export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>}
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never}
export type Incremental<T> =
    T | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: {input: string; output: string}
    String: {input: string; output: string}
    Boolean: {input: boolean; output: boolean}
    Int: {input: number; output: number}
    Float: {input: number; output: number}
    Date: {input: any; output: any}
    JSON: {input: any; output: any}
    PrismicStructuredText: {input: any; output: any}
}

export type BooleanQueryOperatorInput = {
    eq: InputMaybe<Scalars['Boolean']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
    ne: InputMaybe<Scalars['Boolean']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>
}

export type DateQueryOperatorInput = {
    eq: InputMaybe<Scalars['Date']['input']>
    gt: InputMaybe<Scalars['Date']['input']>
    gte: InputMaybe<Scalars['Date']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
    lt: InputMaybe<Scalars['Date']['input']>
    lte: InputMaybe<Scalars['Date']['input']>
    ne: InputMaybe<Scalars['Date']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>
}

export type Directory = Node & {
    absolutePath: Scalars['String']['output']
    accessTime: Scalars['Date']['output']
    atime: Scalars['Date']['output']
    atimeMs: Scalars['Float']['output']
    base: Scalars['String']['output']
    birthTime: Scalars['Date']['output']
    /** @deprecated Use `birthTime` instead */
    birthtime: Maybe<Scalars['Date']['output']>
    /** @deprecated Use `birthTime` instead */
    birthtimeMs: Maybe<Scalars['Float']['output']>
    changeTime: Scalars['Date']['output']
    children: Array<Node>
    ctime: Scalars['Date']['output']
    ctimeMs: Scalars['Float']['output']
    dev: Scalars['Int']['output']
    dir: Scalars['String']['output']
    ext: Scalars['String']['output']
    extension: Scalars['String']['output']
    gid: Scalars['Int']['output']
    id: Scalars['ID']['output']
    ino: Scalars['Float']['output']
    internal: Internal
    mode: Scalars['Int']['output']
    modifiedTime: Scalars['Date']['output']
    mtime: Scalars['Date']['output']
    mtimeMs: Scalars['Float']['output']
    name: Scalars['String']['output']
    nlink: Scalars['Int']['output']
    parent: Maybe<Node>
    prettySize: Scalars['String']['output']
    rdev: Scalars['Int']['output']
    relativeDirectory: Scalars['String']['output']
    relativePath: Scalars['String']['output']
    root: Scalars['String']['output']
    size: Scalars['Int']['output']
    sourceInstanceName: Scalars['String']['output']
    uid: Scalars['Int']['output']
}

export type DirectoryAccessTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryAtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryBirthTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryChangeTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryCtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryModifiedTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryMtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type DirectoryConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<DirectoryEdge>
    group: Array<DirectoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<Directory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type DirectoryConnectionDistinctArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryConnectionGroupArgs = {
    field: DirectoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type DirectoryConnectionMaxArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryConnectionMinArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryConnectionSumArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryEdge = {
    next: Maybe<Directory>
    node: Directory
    previous: Maybe<Directory>
}

export type DirectoryFieldSelector = {
    absolutePath: InputMaybe<FieldSelectorEnum>
    accessTime: InputMaybe<FieldSelectorEnum>
    atime: InputMaybe<FieldSelectorEnum>
    atimeMs: InputMaybe<FieldSelectorEnum>
    base: InputMaybe<FieldSelectorEnum>
    birthTime: InputMaybe<FieldSelectorEnum>
    birthtime: InputMaybe<FieldSelectorEnum>
    birthtimeMs: InputMaybe<FieldSelectorEnum>
    changeTime: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    ctime: InputMaybe<FieldSelectorEnum>
    ctimeMs: InputMaybe<FieldSelectorEnum>
    dev: InputMaybe<FieldSelectorEnum>
    dir: InputMaybe<FieldSelectorEnum>
    ext: InputMaybe<FieldSelectorEnum>
    extension: InputMaybe<FieldSelectorEnum>
    gid: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    ino: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    mode: InputMaybe<FieldSelectorEnum>
    modifiedTime: InputMaybe<FieldSelectorEnum>
    mtime: InputMaybe<FieldSelectorEnum>
    mtimeMs: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    nlink: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prettySize: InputMaybe<FieldSelectorEnum>
    rdev: InputMaybe<FieldSelectorEnum>
    relativeDirectory: InputMaybe<FieldSelectorEnum>
    relativePath: InputMaybe<FieldSelectorEnum>
    root: InputMaybe<FieldSelectorEnum>
    size: InputMaybe<FieldSelectorEnum>
    sourceInstanceName: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
}

export type DirectoryFilterInput = {
    absolutePath: InputMaybe<StringQueryOperatorInput>
    accessTime: InputMaybe<DateQueryOperatorInput>
    atime: InputMaybe<DateQueryOperatorInput>
    atimeMs: InputMaybe<FloatQueryOperatorInput>
    base: InputMaybe<StringQueryOperatorInput>
    birthTime: InputMaybe<DateQueryOperatorInput>
    birthtime: InputMaybe<DateQueryOperatorInput>
    birthtimeMs: InputMaybe<FloatQueryOperatorInput>
    changeTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    ctime: InputMaybe<DateQueryOperatorInput>
    ctimeMs: InputMaybe<FloatQueryOperatorInput>
    dev: InputMaybe<IntQueryOperatorInput>
    dir: InputMaybe<StringQueryOperatorInput>
    ext: InputMaybe<StringQueryOperatorInput>
    extension: InputMaybe<StringQueryOperatorInput>
    gid: InputMaybe<IntQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    ino: InputMaybe<FloatQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    mode: InputMaybe<IntQueryOperatorInput>
    modifiedTime: InputMaybe<DateQueryOperatorInput>
    mtime: InputMaybe<DateQueryOperatorInput>
    mtimeMs: InputMaybe<FloatQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    nlink: InputMaybe<IntQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prettySize: InputMaybe<StringQueryOperatorInput>
    rdev: InputMaybe<IntQueryOperatorInput>
    relativeDirectory: InputMaybe<StringQueryOperatorInput>
    relativePath: InputMaybe<StringQueryOperatorInput>
    root: InputMaybe<StringQueryOperatorInput>
    size: InputMaybe<IntQueryOperatorInput>
    sourceInstanceName: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<IntQueryOperatorInput>
}

export type DirectoryGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<DirectoryEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<DirectoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<Directory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type DirectoryGroupConnectionDistinctArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryGroupConnectionGroupArgs = {
    field: DirectoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type DirectoryGroupConnectionMaxArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryGroupConnectionMinArgs = {
    field: DirectoryFieldSelector
}

export type DirectoryGroupConnectionSumArgs = {
    field: DirectoryFieldSelector
}

export type DirectorySortInput = {
    absolutePath: InputMaybe<SortOrderEnum>
    accessTime: InputMaybe<SortOrderEnum>
    atime: InputMaybe<SortOrderEnum>
    atimeMs: InputMaybe<SortOrderEnum>
    base: InputMaybe<SortOrderEnum>
    birthTime: InputMaybe<SortOrderEnum>
    birthtime: InputMaybe<SortOrderEnum>
    birthtimeMs: InputMaybe<SortOrderEnum>
    changeTime: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    ctime: InputMaybe<SortOrderEnum>
    ctimeMs: InputMaybe<SortOrderEnum>
    dev: InputMaybe<SortOrderEnum>
    dir: InputMaybe<SortOrderEnum>
    ext: InputMaybe<SortOrderEnum>
    extension: InputMaybe<SortOrderEnum>
    gid: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    ino: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    mode: InputMaybe<SortOrderEnum>
    modifiedTime: InputMaybe<SortOrderEnum>
    mtime: InputMaybe<SortOrderEnum>
    mtimeMs: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    nlink: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prettySize: InputMaybe<SortOrderEnum>
    rdev: InputMaybe<SortOrderEnum>
    relativeDirectory: InputMaybe<SortOrderEnum>
    relativePath: InputMaybe<SortOrderEnum>
    root: InputMaybe<SortOrderEnum>
    size: InputMaybe<SortOrderEnum>
    sourceInstanceName: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
}

export enum FieldSelectorEnum {
    SELECT = 'SELECT',
}

export type File = Node & {
    absolutePath: Scalars['String']['output']
    accessTime: Scalars['Date']['output']
    atime: Scalars['Date']['output']
    atimeMs: Scalars['Float']['output']
    base: Scalars['String']['output']
    birthTime: Scalars['Date']['output']
    /** @deprecated Use `birthTime` instead */
    birthtime: Maybe<Scalars['Date']['output']>
    /** @deprecated Use `birthTime` instead */
    birthtimeMs: Maybe<Scalars['Float']['output']>
    changeTime: Scalars['Date']['output']
    children: Array<Node>
    ctime: Scalars['Date']['output']
    ctimeMs: Scalars['Float']['output']
    dev: Scalars['Int']['output']
    dir: Scalars['String']['output']
    ext: Scalars['String']['output']
    extension: Scalars['String']['output']
    gid: Scalars['Int']['output']
    id: Scalars['ID']['output']
    ino: Scalars['Float']['output']
    internal: Internal
    mode: Scalars['Int']['output']
    modifiedTime: Scalars['Date']['output']
    mtime: Scalars['Date']['output']
    mtimeMs: Scalars['Float']['output']
    name: Scalars['String']['output']
    nlink: Scalars['Int']['output']
    parent: Maybe<Node>
    prettySize: Scalars['String']['output']
    rdev: Scalars['Int']['output']
    relativeDirectory: Scalars['String']['output']
    relativePath: Scalars['String']['output']
    root: Scalars['String']['output']
    size: Scalars['Int']['output']
    sourceInstanceName: Scalars['String']['output']
    uid: Scalars['Int']['output']
}

export type FileAccessTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileAtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileBirthTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileChangeTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileCtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileModifiedTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileMtimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type FileConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<FileEdge>
    group: Array<FileGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<File>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type FileConnectionDistinctArgs = {
    field: FileFieldSelector
}

export type FileConnectionGroupArgs = {
    field: FileFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type FileConnectionMaxArgs = {
    field: FileFieldSelector
}

export type FileConnectionMinArgs = {
    field: FileFieldSelector
}

export type FileConnectionSumArgs = {
    field: FileFieldSelector
}

export type FileEdge = {
    next: Maybe<File>
    node: File
    previous: Maybe<File>
}

export type FileFieldSelector = {
    absolutePath: InputMaybe<FieldSelectorEnum>
    accessTime: InputMaybe<FieldSelectorEnum>
    atime: InputMaybe<FieldSelectorEnum>
    atimeMs: InputMaybe<FieldSelectorEnum>
    base: InputMaybe<FieldSelectorEnum>
    birthTime: InputMaybe<FieldSelectorEnum>
    birthtime: InputMaybe<FieldSelectorEnum>
    birthtimeMs: InputMaybe<FieldSelectorEnum>
    changeTime: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    ctime: InputMaybe<FieldSelectorEnum>
    ctimeMs: InputMaybe<FieldSelectorEnum>
    dev: InputMaybe<FieldSelectorEnum>
    dir: InputMaybe<FieldSelectorEnum>
    ext: InputMaybe<FieldSelectorEnum>
    extension: InputMaybe<FieldSelectorEnum>
    gid: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    ino: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    mode: InputMaybe<FieldSelectorEnum>
    modifiedTime: InputMaybe<FieldSelectorEnum>
    mtime: InputMaybe<FieldSelectorEnum>
    mtimeMs: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    nlink: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prettySize: InputMaybe<FieldSelectorEnum>
    rdev: InputMaybe<FieldSelectorEnum>
    relativeDirectory: InputMaybe<FieldSelectorEnum>
    relativePath: InputMaybe<FieldSelectorEnum>
    root: InputMaybe<FieldSelectorEnum>
    size: InputMaybe<FieldSelectorEnum>
    sourceInstanceName: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
}

export type FileFilterInput = {
    absolutePath: InputMaybe<StringQueryOperatorInput>
    accessTime: InputMaybe<DateQueryOperatorInput>
    atime: InputMaybe<DateQueryOperatorInput>
    atimeMs: InputMaybe<FloatQueryOperatorInput>
    base: InputMaybe<StringQueryOperatorInput>
    birthTime: InputMaybe<DateQueryOperatorInput>
    birthtime: InputMaybe<DateQueryOperatorInput>
    birthtimeMs: InputMaybe<FloatQueryOperatorInput>
    changeTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    ctime: InputMaybe<DateQueryOperatorInput>
    ctimeMs: InputMaybe<FloatQueryOperatorInput>
    dev: InputMaybe<IntQueryOperatorInput>
    dir: InputMaybe<StringQueryOperatorInput>
    ext: InputMaybe<StringQueryOperatorInput>
    extension: InputMaybe<StringQueryOperatorInput>
    gid: InputMaybe<IntQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    ino: InputMaybe<FloatQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    mode: InputMaybe<IntQueryOperatorInput>
    modifiedTime: InputMaybe<DateQueryOperatorInput>
    mtime: InputMaybe<DateQueryOperatorInput>
    mtimeMs: InputMaybe<FloatQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    nlink: InputMaybe<IntQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prettySize: InputMaybe<StringQueryOperatorInput>
    rdev: InputMaybe<IntQueryOperatorInput>
    relativeDirectory: InputMaybe<StringQueryOperatorInput>
    relativePath: InputMaybe<StringQueryOperatorInput>
    root: InputMaybe<StringQueryOperatorInput>
    size: InputMaybe<IntQueryOperatorInput>
    sourceInstanceName: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<IntQueryOperatorInput>
}

export type FileGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<FileEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<FileGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<File>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type FileGroupConnectionDistinctArgs = {
    field: FileFieldSelector
}

export type FileGroupConnectionGroupArgs = {
    field: FileFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type FileGroupConnectionMaxArgs = {
    field: FileFieldSelector
}

export type FileGroupConnectionMinArgs = {
    field: FileFieldSelector
}

export type FileGroupConnectionSumArgs = {
    field: FileFieldSelector
}

export type FileSortInput = {
    absolutePath: InputMaybe<SortOrderEnum>
    accessTime: InputMaybe<SortOrderEnum>
    atime: InputMaybe<SortOrderEnum>
    atimeMs: InputMaybe<SortOrderEnum>
    base: InputMaybe<SortOrderEnum>
    birthTime: InputMaybe<SortOrderEnum>
    birthtime: InputMaybe<SortOrderEnum>
    birthtimeMs: InputMaybe<SortOrderEnum>
    changeTime: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    ctime: InputMaybe<SortOrderEnum>
    ctimeMs: InputMaybe<SortOrderEnum>
    dev: InputMaybe<SortOrderEnum>
    dir: InputMaybe<SortOrderEnum>
    ext: InputMaybe<SortOrderEnum>
    extension: InputMaybe<SortOrderEnum>
    gid: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    ino: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    mode: InputMaybe<SortOrderEnum>
    modifiedTime: InputMaybe<SortOrderEnum>
    mtime: InputMaybe<SortOrderEnum>
    mtimeMs: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    nlink: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prettySize: InputMaybe<SortOrderEnum>
    rdev: InputMaybe<SortOrderEnum>
    relativeDirectory: InputMaybe<SortOrderEnum>
    relativePath: InputMaybe<SortOrderEnum>
    root: InputMaybe<SortOrderEnum>
    size: InputMaybe<SortOrderEnum>
    sourceInstanceName: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
}

export type FloatQueryOperatorInput = {
    eq: InputMaybe<Scalars['Float']['input']>
    gt: InputMaybe<Scalars['Float']['input']>
    gte: InputMaybe<Scalars['Float']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    lt: InputMaybe<Scalars['Float']['input']>
    lte: InputMaybe<Scalars['Float']['input']>
    ne: InputMaybe<Scalars['Float']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
}

export enum GatsbyImageFormat {
    AUTO = 'AUTO',
    AVIF = 'AVIF',
    JPG = 'JPG',
    NO_CHANGE = 'NO_CHANGE',
    PNG = 'PNG',
    WEBP = 'WEBP',
}

export enum GatsbyImageLayout {
    CONSTRAINED = 'CONSTRAINED',
    FIXED = 'FIXED',
    FULL_WIDTH = 'FULL_WIDTH',
}

export enum GatsbyImagePlaceholder {
    BLURRED = 'BLURRED',
    DOMINANT_COLOR = 'DOMINANT_COLOR',
    NONE = 'NONE',
    TRACED_SVG = 'TRACED_SVG',
}

export type IdQueryOperatorInput = {
    eq: InputMaybe<Scalars['ID']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
    ne: InputMaybe<Scalars['ID']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>
}

export type ImgixFixed = {
    base64: Scalars['String']['output']
    height: Scalars['Int']['output']
    sizes: Scalars['String']['output']
    src: Scalars['String']['output']
    srcSet: Scalars['String']['output']
    srcSetWebp: Scalars['String']['output']
    srcWebp: Scalars['String']['output']
    width: Scalars['Int']['output']
}

export type ImgixFixedFieldSelector = {
    base64: InputMaybe<FieldSelectorEnum>
    height: InputMaybe<FieldSelectorEnum>
    sizes: InputMaybe<FieldSelectorEnum>
    src: InputMaybe<FieldSelectorEnum>
    srcSet: InputMaybe<FieldSelectorEnum>
    srcSetWebp: InputMaybe<FieldSelectorEnum>
    srcWebp: InputMaybe<FieldSelectorEnum>
    width: InputMaybe<FieldSelectorEnum>
}

export type ImgixFixedFilterInput = {
    base64: InputMaybe<StringQueryOperatorInput>
    height: InputMaybe<IntQueryOperatorInput>
    sizes: InputMaybe<StringQueryOperatorInput>
    src: InputMaybe<StringQueryOperatorInput>
    srcSet: InputMaybe<StringQueryOperatorInput>
    srcSetWebp: InputMaybe<StringQueryOperatorInput>
    srcWebp: InputMaybe<StringQueryOperatorInput>
    width: InputMaybe<IntQueryOperatorInput>
}

export type ImgixFixedSortInput = {
    base64: InputMaybe<SortOrderEnum>
    height: InputMaybe<SortOrderEnum>
    sizes: InputMaybe<SortOrderEnum>
    src: InputMaybe<SortOrderEnum>
    srcSet: InputMaybe<SortOrderEnum>
    srcSetWebp: InputMaybe<SortOrderEnum>
    srcWebp: InputMaybe<SortOrderEnum>
    width: InputMaybe<SortOrderEnum>
}

export type ImgixFluid = {
    aspectRatio: Scalars['Float']['output']
    base64: Scalars['String']['output']
    sizes: Scalars['String']['output']
    src: Scalars['String']['output']
    srcSet: Scalars['String']['output']
    srcSetWebp: Scalars['String']['output']
    srcWebp: Scalars['String']['output']
}

export type ImgixFluidFieldSelector = {
    aspectRatio: InputMaybe<FieldSelectorEnum>
    base64: InputMaybe<FieldSelectorEnum>
    sizes: InputMaybe<FieldSelectorEnum>
    src: InputMaybe<FieldSelectorEnum>
    srcSet: InputMaybe<FieldSelectorEnum>
    srcSetWebp: InputMaybe<FieldSelectorEnum>
    srcWebp: InputMaybe<FieldSelectorEnum>
}

export type ImgixFluidFilterInput = {
    aspectRatio: InputMaybe<FloatQueryOperatorInput>
    base64: InputMaybe<StringQueryOperatorInput>
    sizes: InputMaybe<StringQueryOperatorInput>
    src: InputMaybe<StringQueryOperatorInput>
    srcSet: InputMaybe<StringQueryOperatorInput>
    srcSetWebp: InputMaybe<StringQueryOperatorInput>
    srcWebp: InputMaybe<StringQueryOperatorInput>
}

export type ImgixFluidSortInput = {
    aspectRatio: InputMaybe<SortOrderEnum>
    base64: InputMaybe<SortOrderEnum>
    sizes: InputMaybe<SortOrderEnum>
    src: InputMaybe<SortOrderEnum>
    srcSet: InputMaybe<SortOrderEnum>
    srcSetWebp: InputMaybe<SortOrderEnum>
    srcWebp: InputMaybe<SortOrderEnum>
}

export type ImgixParamsInput = {
    /** Alias for `pdfAnnotation`. */
    annotation: InputMaybe<Scalars['Boolean']['input']>
    /** Specifies an aspect ratio to maintain when resizing and cropping the image. [See docs](https://docs.imgix.com/apis/url/size/ar). */
    ar: InputMaybe<Scalars['String']['input']>
    /** Applies automatic enhancements to images. [See docs](https://docs.imgix.com/apis/url/auto). */
    auto: InputMaybe<Scalars['String']['input']>
    /** Alias for `blend`. */
    b: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendAlign`. */
    ba: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendAlpha`. */
    balph: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendCrop`. */
    bc: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendFit`. */
    bf: InputMaybe<Scalars['String']['input']>
    /** Colors the background of padded and partially-transparent images. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/bg). */
    bg: InputMaybe<Scalars['String']['input']>
    /** Removes background from image. Default: `false`. [See docs](https://docs.imgix.com/apis/rendering/background-removal/bg-remove). */
    bgRemove: InputMaybe<Scalars['Boolean']['input']>
    /** Overrides default fallback behavior for bg-remove failures. Default: `true`. [See docs](https://docs.imgix.com/apis/rendering/background-removal/bg-remove). */
    bgRemoveFallback: InputMaybe<Scalars['Boolean']['input']>
    /** Alias for `blendH`. */
    bh: InputMaybe<Scalars['Float']['input']>
    /** Specifies the location of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend). */
    blend: InputMaybe<Scalars['String']['input']>
    /** Changes the blend alignment relative to the parent image. [See docs](https://docs.imgix.com/apis/url/blending/blend-align). */
    blendAlign: InputMaybe<Scalars['String']['input']>
    /** Changes the alpha of the blend image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/blending/blend-alpha). */
    blendAlpha: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendColor`. */
    blendClr: InputMaybe<Scalars['String']['input']>
    /** Specifies a color to use when applying the blend. [See docs](https://docs.imgix.com/apis/url/blending/blend-color). */
    blendColor: InputMaybe<Scalars['String']['input']>
    /** Specifies the type of crop for blend images. [See docs](https://docs.imgix.com/apis/url/blending/blend-crop). */
    blendCrop: InputMaybe<Scalars['String']['input']>
    /** Specifies the fit mode for blend images. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/blending/blend-fit). */
    blendFit: InputMaybe<Scalars['String']['input']>
    /** Adjusts the height of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-h). */
    blendH: InputMaybe<Scalars['Float']['input']>
    /** Sets the blend mode for a blend image. Default: `overlay`. [See docs](https://docs.imgix.com/apis/url/blending/blend-mode). */
    blendMode: InputMaybe<Scalars['String']['input']>
    /** Applies padding to the blend image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-pad). */
    blendPad: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the size of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-size). */
    blendSize: InputMaybe<Scalars['String']['input']>
    /** Adjusts the width of the blend image. [See docs](https://docs.imgix.com/apis/url/blending/blend-w). */
    blendW: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the x-offset of the blend image relative to its parent. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-x). */
    blendX: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the y-offset of the blend image relative to its parent. Default: `0`. [See docs](https://docs.imgix.com/apis/url/blending/blend-y). */
    blendY: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendAlign`. */
    blendalign: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendAlpha`. */
    blendalpha: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendColor`. */
    blendclr: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendColor`. */
    blendcolor: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendCrop`. */
    blendcrop: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendFit`. */
    blendfit: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendH`. */
    blendh: InputMaybe<Scalars['Float']['input']>
    /** Alias for `blendMode`. */
    blendmode: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendPad`. */
    blendpad: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendSize`. */
    blendsize: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendW`. */
    blendw: InputMaybe<Scalars['Float']['input']>
    /** Alias for `blendX`. */
    blendx: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendY`. */
    blendy: InputMaybe<Scalars['Int']['input']>
    /** Applies a gaussian blur to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/blur). */
    blur: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendMode`. */
    bm: InputMaybe<Scalars['String']['input']>
    /** Applies a border to an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border). */
    border: InputMaybe<Scalars['String']['input']>
    /** Sets bottom border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-bottom). */
    borderBottom: InputMaybe<Scalars['Int']['input']>
    /** Sets left border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-left). */
    borderLeft: InputMaybe<Scalars['Int']['input']>
    /** Sets the outer radius of the image's border in pixels. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-radius). */
    borderRadius: InputMaybe<Scalars['String']['input']>
    /** Sets the inner radius of the image's border in pixels. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-radius-inner). */
    borderRadiusInner: InputMaybe<Scalars['String']['input']>
    /** Sets right border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-right). */
    borderRight: InputMaybe<Scalars['Int']['input']>
    /** Sets top border of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/border-top). */
    borderTop: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendPad`. */
    bp: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the brightness of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/bri). */
    bri: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendSize`. */
    bs: InputMaybe<Scalars['String']['input']>
    /** Alias for `blendW`. */
    bw: InputMaybe<Scalars['Float']['input']>
    /** Alias for `blendX`. */
    bx: InputMaybe<Scalars['Int']['input']>
    /** Alias for `blendY`. */
    by: InputMaybe<Scalars['Int']['input']>
    /** Sets one or more Client-Hints headers. [See docs](https://docs.imgix.com/apis/url/format/ch). */
    ch: InputMaybe<Scalars['String']['input']>
    /** Specifies the output chroma subsampling rate. Default: `420`. [See docs](https://docs.imgix.com/apis/url/format/chromasub). */
    chromasub: InputMaybe<Scalars['Int']['input']>
    /** Limits the number of unique colors in an image. [See docs](https://docs.imgix.com/apis/url/format/colorquant). */
    colorquant: InputMaybe<Scalars['Int']['input']>
    /** Specifies how many colors to include in a palette-extraction response. Default: `6`. [See docs](https://docs.imgix.com/apis/url/color-palette/colors). */
    colors: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the contrast of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/con). */
    con: InputMaybe<Scalars['Int']['input']>
    /** Specifies the radius value for a rounded corner mask. [See docs](https://docs.imgix.com/apis/url/mask/corner-radius). */
    cornerRadius: InputMaybe<Scalars['String']['input']>
    /** Specifies how to crop an image. [See docs](https://docs.imgix.com/apis/url/size/crop). */
    crop: InputMaybe<Scalars['String']['input']>
    /** Specifies the color space of the output image. [See docs](https://docs.imgix.com/apis/url/format/cs). */
    cs: InputMaybe<Scalars['String']['input']>
    /** Forces a URL to use send-file in its response. [See docs](https://docs.imgix.com/apis/url/format/dl). */
    dl: InputMaybe<Scalars['String']['input']>
    /** Sets the DPI value in the EXIF header. [See docs](https://docs.imgix.com/apis/url/format/dpi). */
    dpi: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the device-pixel ratio of the output image. Default: `1`. [See docs](https://docs.imgix.com/apis/url/dpr). */
    dpr: InputMaybe<Scalars['Float']['input']>
    /** Applies a duotone effect to the source image. [See docs](https://docs.imgix.com/apis/url/stylize/duotone). */
    duotone: InputMaybe<Scalars['String']['input']>
    /** Changes the alpha of the duotone effect atop the source image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/stylize/duotone-alpha). */
    duotoneAlpha: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the exposure of the output image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/exp). */
    exp: InputMaybe<Scalars['Int']['input']>
    /** A Unix timestamp specifying a UTC time. Requests made to this URL after that time will output a 404 status code. [See docs](https://docs.imgix.com/apis/url/expires). */
    expires: InputMaybe<Scalars['String']['input']>
    /** Alias for `fit`. */
    f: InputMaybe<Scalars['String']['input']>
    /** Selects a face to crop to. [See docs](https://docs.imgix.com/apis/url/face-detection/faceindex). */
    faceindex: InputMaybe<Scalars['Int']['input']>
    /** Adjusts padding around a selected face. Default: `1`. [See docs](https://docs.imgix.com/apis/url/face-detection/facepad). */
    facepad: InputMaybe<Scalars['Float']['input']>
    /** Specifies that face data should be included in output when combined with `fm=json`. [See docs](https://docs.imgix.com/apis/url/face-detection/faces). */
    faces: InputMaybe<Scalars['Int']['input']>
    /** Determines how to fill in additional space created by the fit setting. [See docs](https://docs.imgix.com/apis/url/fill/fill). */
    fill: InputMaybe<Scalars['String']['input']>
    /** Sets the fill color for images with additional space created by the fit setting. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/fill/fill-color). */
    fillColor: InputMaybe<Scalars['String']['input']>
    /** Alias for `fillColor`. */
    fillcolor: InputMaybe<Scalars['String']['input']>
    /** Specifies how to map the source image to the output image dimensions. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/size/fit). */
    fit: InputMaybe<Scalars['String']['input']>
    /** Flips an image on a specified axis. [See docs](https://docs.imgix.com/apis/url/rotation/flip). */
    flip: InputMaybe<Scalars['String']['input']>
    /** Changes the format of the output image. [See docs](https://docs.imgix.com/apis/url/format/fm). */
    fm: InputMaybe<Scalars['String']['input']>
    /** Displays crosshairs identifying the location of the set focal point. Default: `false`. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-debug). */
    fpDebug: InputMaybe<Scalars['Boolean']['input']>
    /** Sets the relative horizontal value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-x). */
    fpX: InputMaybe<Scalars['Float']['input']>
    /** Sets the relative vertical value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-y). */
    fpY: InputMaybe<Scalars['Float']['input']>
    /** Sets the relative zoom value for the focal point of an image. [See docs](https://docs.imgix.com/apis/url/focalpoint-crop/fp-z). */
    fpZ: InputMaybe<Scalars['Float']['input']>
    /** Specifies the framerate of the generated image. */
    fps: InputMaybe<Scalars['Int']['input']>
    /** Specifies the frame of an animated image to use. */
    frame: InputMaybe<Scalars['String']['input']>
    /** Adjusts the gamma of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/gam). */
    gam: InputMaybe<Scalars['Int']['input']>
    /** animated gif quality. */
    gifQ: InputMaybe<Scalars['Int']['input']>
    /** Alias for `gifQ`. */
    gifq: InputMaybe<Scalars['Int']['input']>
    /** Sets grid colors for the transparency checkerboard grid. */
    gridColors: InputMaybe<Scalars['String']['input']>
    /** Sets grid size for the transparency checkerboard grid. */
    gridSize: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the height of the output image. [See docs](https://docs.imgix.com/apis/url/size/h). */
    h: InputMaybe<Scalars['Float']['input']>
    /** Alias for `h`. */
    height: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the highlights of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/high). */
    high: InputMaybe<Scalars['Int']['input']>
    /** Applies a half-tone effect to the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/htn). */
    htn: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the hue of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/hue). */
    hue: InputMaybe<Scalars['Int']['input']>
    /** Displays every Nth frame starting with the first frame. */
    interval: InputMaybe<Scalars['Int']['input']>
    /** Alias for `invert`. */
    inv: InputMaybe<Scalars['Boolean']['input']>
    /** Inverts the colors on the source image. Default: `false`. [See docs](https://docs.imgix.com/apis/url/adjustment/invert). */
    invert: InputMaybe<Scalars['Boolean']['input']>
    /** Determine if IPTC data should be passed for JPEG images. */
    iptc: InputMaybe<Scalars['String']['input']>
    /** Specifies the number of times an animated image should repeat. A value of 0 means infinite looping. Default: `0`. */
    loop: InputMaybe<Scalars['Int']['input']>
    /** Specifies that the output image should be a lossless variant. Default: `false`. [See docs](https://docs.imgix.com/apis/url/format/lossless). */
    lossless: InputMaybe<Scalars['Boolean']['input']>
    /** Alias for `mark`. */
    m: InputMaybe<Scalars['String']['input']>
    /** Alias for `markAlign`. */
    ma: InputMaybe<Scalars['String']['input']>
    /** Alias for `markAlpha`. */
    malph: InputMaybe<Scalars['Int']['input']>
    /** Specifies the location of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark). */
    mark: InputMaybe<Scalars['String']['input']>
    /** Changes the watermark alignment relative to the parent image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-align). */
    markAlign: InputMaybe<Scalars['String']['input']>
    /** Changes the alpha of the watermark image. Default: `100`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-alpha). */
    markAlpha: InputMaybe<Scalars['Int']['input']>
    /** Changes base URL of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-base). */
    markBase: InputMaybe<Scalars['String']['input']>
    /** Specifies the fit mode for watermark images. Default: `clip`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-fit). */
    markFit: InputMaybe<Scalars['String']['input']>
    /** Adjusts the height of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-h). */
    markH: InputMaybe<Scalars['Float']['input']>
    /** Applies padding to the watermark image. Default: `5`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-pad). */
    markPad: InputMaybe<Scalars['Int']['input']>
    /** Rotates a watermark or tiled watermarks by a specified number of degrees. Default: `0`. [See docs](https://docs.imgix.com/apis/url/watermark/mark-rot). */
    markRot: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the scale of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-scale). */
    markScale: InputMaybe<Scalars['Int']['input']>
    /** Adds tiled watermark. [See docs](https://docs.imgix.com/apis/url/watermark/mark-tile). */
    markTile: InputMaybe<Scalars['String']['input']>
    /** Adjusts the width of the watermark image. [See docs](https://docs.imgix.com/apis/url/watermark/mark-w). */
    markW: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the x-offset of the watermark image relative to its parent. [See docs](https://docs.imgix.com/apis/url/watermark/mark-x). */
    markX: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the y-offset of the watermark image relative to its parent. [See docs](https://docs.imgix.com/apis/url/watermark/mark-y). */
    markY: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markAlign`. */
    markalign: InputMaybe<Scalars['String']['input']>
    /** Alias for `markAlpha`. */
    markalpha: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markBase`. */
    markbase: InputMaybe<Scalars['String']['input']>
    /** Alias for `markFit`. */
    markfit: InputMaybe<Scalars['String']['input']>
    /** Alias for `markH`. */
    markh: InputMaybe<Scalars['Float']['input']>
    /** Alias for `markPad`. */
    markpad: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markScale`. */
    markscale: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markTile`. */
    marktile: InputMaybe<Scalars['String']['input']>
    /** Alias for `markW`. */
    markw: InputMaybe<Scalars['Float']['input']>
    /** Alias for `markX`. */
    markx: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markY`. */
    marky: InputMaybe<Scalars['Int']['input']>
    /** Defines the type of mask and specifies the URL if that type is selected. [See docs](https://docs.imgix.com/apis/url/mask). */
    mask: InputMaybe<Scalars['String']['input']>
    /** Colors the background of the transparent mask area of images. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/mask/mask-bg). */
    maskBg: InputMaybe<Scalars['String']['input']>
    /** Alias for `maskBg`. */
    maskbg: InputMaybe<Scalars['String']['input']>
    /** Specifies the maximum height of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/max-height). */
    maxH: InputMaybe<Scalars['Int']['input']>
    /** Alias for `maxH`. */
    maxHeight: InputMaybe<Scalars['Int']['input']>
    /** Specifies the maximum width of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/max-width). */
    maxW: InputMaybe<Scalars['Int']['input']>
    /** Alias for `maxW`. */
    maxWidth: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markBase`. */
    mb: InputMaybe<Scalars['String']['input']>
    /** Alias for `markFit`. */
    mf: InputMaybe<Scalars['String']['input']>
    /** Alias for `markH`. */
    mh: InputMaybe<Scalars['Float']['input']>
    /** Specifies the minimum height of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/min-height). */
    minH: InputMaybe<Scalars['Int']['input']>
    /** Alias for `minH`. */
    minHeight: InputMaybe<Scalars['Int']['input']>
    /** Specifies the minimum width of the output image in pixels. [See docs](https://docs.imgix.com/apis/url/size/min-width). */
    minW: InputMaybe<Scalars['Int']['input']>
    /** Alias for `minW`. */
    minWidth: InputMaybe<Scalars['Int']['input']>
    /** Alias for `monochrome`. */
    mono: InputMaybe<Scalars['String']['input']>
    /** Applies a monochrome effect to the source image. [See docs](https://docs.imgix.com/apis/url/stylize/monochrome). */
    monochrome: InputMaybe<Scalars['String']['input']>
    /** Alias for `markPad`. */
    mp: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markScale`. */
    ms: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markTile`. */
    mtile: InputMaybe<Scalars['String']['input']>
    /** Alias for `markW`. */
    mw: InputMaybe<Scalars['Float']['input']>
    /** Alias for `markX`. */
    mx: InputMaybe<Scalars['Int']['input']>
    /** Alias for `markY`. */
    my: InputMaybe<Scalars['Int']['input']>
    /** Reduces the noise in an image. Default: `20`. [See docs](https://docs.imgix.com/apis/url/noise-reduction/nr). */
    nr: InputMaybe<Scalars['Int']['input']>
    /** Provides a threshold by which to sharpen an image. Default: `20`. [See docs](https://docs.imgix.com/apis/url/noise-reduction/nrs). */
    nrs: InputMaybe<Scalars['Int']['input']>
    /** Alias for `orient`. */
    or: InputMaybe<Scalars['Int']['input']>
    /** Changes the image orientation. [See docs](https://docs.imgix.com/apis/url/rotation/orient). */
    orient: InputMaybe<Scalars['Int']['input']>
    /** Pads an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad). */
    pad: InputMaybe<Scalars['Int']['input']>
    /** Sets bottom padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-bottom). */
    padBottom: InputMaybe<Scalars['Int']['input']>
    /** Sets left padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-left). */
    padLeft: InputMaybe<Scalars['Int']['input']>
    /** Sets right padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-right). */
    padRight: InputMaybe<Scalars['Int']['input']>
    /** Sets top padding of an image. [See docs](https://docs.imgix.com/apis/url/border-and-padding/pad-top). */
    padTop: InputMaybe<Scalars['Int']['input']>
    /** Selects a page from a PDF for display. Default: `1`. [See docs](https://docs.imgix.com/apis/url/pdf/page). */
    page: InputMaybe<Scalars['Int']['input']>
    /** Specifies an output format for palette-extraction. [See docs](https://docs.imgix.com/apis/url/color-palette/palette). */
    palette: InputMaybe<Scalars['String']['input']>
    /** Enables or disables PDF annotation. Default: `true`. [See docs](https://docs.imgix.com/apis/url/pdf/pdf-annotation). */
    pdfAnnotation: InputMaybe<Scalars['Boolean']['input']>
    /** Specifies a CSS prefix for all classes in palette-extraction. Default: `image`. [See docs](https://docs.imgix.com/apis/url/color-palette/prefix). */
    prefix: InputMaybe<Scalars['String']['input']>
    /** Applies a pixelation effect to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/px). */
    px: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the quality of an output image. Default: `75`. [See docs](https://docs.imgix.com/apis/url/format/q). */
    q: InputMaybe<Scalars['Int']['input']>
    /** Crops an image to a specified rectangle. [See docs](https://docs.imgix.com/apis/url/size/rect). */
    rect: InputMaybe<Scalars['String']['input']>
    /** Reverses the frame order on the source animation. Default: `false`. */
    reverse: InputMaybe<Scalars['Boolean']['input']>
    /** Rotates an image by a specified number of degrees. Default: `0`. [See docs](https://docs.imgix.com/apis/url/rotation/rot). */
    rot: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the saturation of an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/sat). */
    sat: InputMaybe<Scalars['Int']['input']>
    /** Applies a sepia effect to an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/stylize/sepia). */
    sepia: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the highlights of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/shad). */
    shad: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the sharpness of the source image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/sharp). */
    sharp: InputMaybe<Scalars['Float']['input']>
    /** Skips every Nth frame starting with the first frame. */
    skip: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txt`. */
    t: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtAlign`. */
    ta: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtColor`. */
    tc: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtClip`. */
    tcl: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtFont`. */
    tf: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtLine`. */
    tl: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtPad`. */
    tp: InputMaybe<Scalars['Int']['input']>
    /** Adds checkerboard behind images which support transparency. [See docs](https://docs.imgix.com/apis/url/fill/transparency). */
    transparency: InputMaybe<Scalars['String']['input']>
    /** Trims the source image. [See docs](https://docs.imgix.com/apis/url/trim/trim). */
    trim: InputMaybe<Scalars['String']['input']>
    /** Specifies a trim color on a trim operation. [See docs](https://docs.imgix.com/apis/url/trim/trim-color). */
    trimColor: InputMaybe<Scalars['String']['input']>
    /** Specifies the mean difference on a trim operation. Default: `11`. [See docs](https://docs.imgix.com/apis/url/trim/trim-md). */
    trimMd: InputMaybe<Scalars['Float']['input']>
    /** Pads the area of the source image before trimming. Default: `0`. [See docs](https://docs.imgix.com/apis/url/trim/trim-pad). */
    trimPad: InputMaybe<Scalars['Int']['input']>
    /** Specifies the standard deviation on a trim operation. Default: `10`. [See docs](https://docs.imgix.com/apis/url/trim/trim-sd). */
    trimSd: InputMaybe<Scalars['Float']['input']>
    /** Specifies the tolerance on a trim operation. Default: `0`. [See docs](https://docs.imgix.com/apis/url/trim/trim-tol). */
    trimTol: InputMaybe<Scalars['Float']['input']>
    /** Alias for `trimColor`. */
    trimcolor: InputMaybe<Scalars['String']['input']>
    /** Alias for `trimMd`. */
    trimmd: InputMaybe<Scalars['Float']['input']>
    /** Alias for `trimPad`. */
    trimpad: InputMaybe<Scalars['Int']['input']>
    /** Alias for `trimSd`. */
    trimsd: InputMaybe<Scalars['Float']['input']>
    /** Alias for `trimTol`. */
    trimtol: InputMaybe<Scalars['Float']['input']>
    /** Alias for `txtShad`. */
    tsh: InputMaybe<Scalars['Float']['input']>
    /** Alias for `txtSize`. */
    tsz: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtTrack`. */
    tt: InputMaybe<Scalars['Int']['input']>
    /** Sets the text string to render. [See docs](https://docs.imgix.com/apis/url/text/txt). */
    txt: InputMaybe<Scalars['String']['input']>
    /** Sets the vertical and horizontal alignment of rendered text relative to the base image. [See docs](https://docs.imgix.com/apis/url/text/txt-align). */
    txtAlign: InputMaybe<Scalars['String']['input']>
    /** Sets the clipping properties of rendered text. Default: `end`. [See docs](https://docs.imgix.com/apis/url/text/txt-clip). */
    txtClip: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtColor`. */
    txtClr: InputMaybe<Scalars['String']['input']>
    /** Specifies the color of rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-color). */
    txtColor: InputMaybe<Scalars['String']['input']>
    /** Specifies the fit approach for rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-fit). */
    txtFit: InputMaybe<Scalars['String']['input']>
    /** Selects a font for rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-font). */
    txtFont: InputMaybe<Scalars['String']['input']>
    /** Sets the leading (line spacing) for rendered text. Only works on the multi-line text endpoint. Default: `0`. [See docs](https://docs.imgix.com/apis/url/typesetting/txt-lead). */
    txtLead: InputMaybe<Scalars['Int']['input']>
    /** Controls the level of ligature substitution. [See docs](https://docs.imgix.com/apis/url/text/txt-lig). */
    txtLig: InputMaybe<Scalars['Int']['input']>
    /** Outlines the rendered text with a specified color. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-line). */
    txtLine: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtLineColor`. */
    txtLineClr: InputMaybe<Scalars['String']['input']>
    /** Specifies a text outline color. Default: `fff`. [See docs](https://docs.imgix.com/apis/url/text/txt-line-color). */
    txtLineColor: InputMaybe<Scalars['String']['input']>
    /** Specifies the padding (in device-independent pixels) between a textbox and the edges of the base image. [See docs](https://docs.imgix.com/apis/url/text/txt-pad). */
    txtPad: InputMaybe<Scalars['Int']['input']>
    /** Applies a shadow to rendered text. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-shad). */
    txtShad: InputMaybe<Scalars['Float']['input']>
    /** Sets the font size of rendered text. Default: `12`. [See docs](https://docs.imgix.com/apis/url/text/txt-size). */
    txtSize: InputMaybe<Scalars['Int']['input']>
    /** Sets the tracking (letter spacing) for rendered text. Only works on the multi-line text endpoint. Default: `0`. [See docs](https://docs.imgix.com/apis/url/typesetting/txt-track). */
    txtTrack: InputMaybe<Scalars['Int']['input']>
    /** Sets the width of rendered text. [See docs](https://docs.imgix.com/apis/url/text/txt-width). */
    txtWidth: InputMaybe<Scalars['Int']['input']>
    /** Sets the horizontal (x) position of the text in pixels relative to the left edge of the base image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-x). */
    txtX: InputMaybe<Scalars['Int']['input']>
    /** Sets the vertical (y) position of the text in pixels relative to the top edge of the base image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/text/txt-y). */
    txtY: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtAlign`. */
    txtalign: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtClip`. */
    txtclip: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtColor`. */
    txtclr: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtColor`. */
    txtcolor: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtFit`. */
    txtfit: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtFont`. */
    txtfont: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtLead`. */
    txtlead: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtLig`. */
    txtlig: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtLine`. */
    txtline: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtLineColor`. */
    txtlineclr: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtLineColor`. */
    txtlinecolor: InputMaybe<Scalars['String']['input']>
    /** Alias for `txtPad`. */
    txtpad: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtShad`. */
    txtshad: InputMaybe<Scalars['Float']['input']>
    /** Alias for `txtSize`. */
    txtsize: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtTrack`. */
    txttrack: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtWidth`. */
    txtwidth: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtX`. */
    txtx: InputMaybe<Scalars['Int']['input']>
    /** Alias for `txtY`. */
    txty: InputMaybe<Scalars['Int']['input']>
    /** Uses generative AI fill to upscale low resolution images. Default: `false`. [See docs](https://docs.imgix.com/apis/rendering/super-resolution/upscale). */
    upscale: InputMaybe<Scalars['Boolean']['input']>
    /** Overrides default fallback behavior for super resolution failures. Default: `true`. [See docs](https://docs.imgix.com/apis/rendering/super-resolution/upscale-fallback). */
    upscaleFallback: InputMaybe<Scalars['Boolean']['input']>
    /** Sharpens the source image using an unsharp mask. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/usm). */
    usm: InputMaybe<Scalars['Int']['input']>
    /** Specifies the radius for an unsharp mask operation. Default: `2.5`. [See docs](https://docs.imgix.com/apis/url/adjustment/usmrad). */
    usmrad: InputMaybe<Scalars['Float']['input']>
    /** Adjusts the vibrance of an image. Default: `0`. [See docs](https://docs.imgix.com/apis/url/adjustment/vib). */
    vib: InputMaybe<Scalars['Int']['input']>
    /** Adjusts the width of the output image. [See docs](https://docs.imgix.com/apis/url/size/w). */
    w: InputMaybe<Scalars['Float']['input']>
    /** Alias for `w`. */
    width: InputMaybe<Scalars['Float']['input']>
}

export enum ImgixPlaceholder {
    BLURRED = 'BLURRED',
    DOMINANT_COLOR = 'DOMINANT_COLOR',
    NONE = 'NONE',
}

export type IntQueryOperatorInput = {
    eq: InputMaybe<Scalars['Int']['input']>
    gt: InputMaybe<Scalars['Int']['input']>
    gte: InputMaybe<Scalars['Int']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    lt: InputMaybe<Scalars['Int']['input']>
    lte: InputMaybe<Scalars['Int']['input']>
    ne: InputMaybe<Scalars['Int']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type Internal = {
    content: Maybe<Scalars['String']['output']>
    contentDigest: Scalars['String']['output']
    contentFilePath: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    fieldOwners: Maybe<Array<Maybe<Scalars['String']['output']>>>
    ignoreType: Maybe<Scalars['Boolean']['output']>
    mediaType: Maybe<Scalars['String']['output']>
    owner: Scalars['String']['output']
    type: Scalars['String']['output']
}

export type InternalFieldSelector = {
    content: InputMaybe<FieldSelectorEnum>
    contentDigest: InputMaybe<FieldSelectorEnum>
    contentFilePath: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    fieldOwners: InputMaybe<FieldSelectorEnum>
    ignoreType: InputMaybe<FieldSelectorEnum>
    mediaType: InputMaybe<FieldSelectorEnum>
    owner: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
}

export type InternalFilterInput = {
    content: InputMaybe<StringQueryOperatorInput>
    contentDigest: InputMaybe<StringQueryOperatorInput>
    contentFilePath: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    fieldOwners: InputMaybe<StringQueryOperatorInput>
    ignoreType: InputMaybe<BooleanQueryOperatorInput>
    mediaType: InputMaybe<StringQueryOperatorInput>
    owner: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type InternalSortInput = {
    content: InputMaybe<SortOrderEnum>
    contentDigest: InputMaybe<SortOrderEnum>
    contentFilePath: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    fieldOwners: InputMaybe<SortOrderEnum>
    ignoreType: InputMaybe<SortOrderEnum>
    mediaType: InputMaybe<SortOrderEnum>
    owner: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
}

export type JsonQueryOperatorInput = {
    eq: InputMaybe<Scalars['JSON']['input']>
    glob: InputMaybe<Scalars['JSON']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
    ne: InputMaybe<Scalars['JSON']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>
    regex: InputMaybe<Scalars['JSON']['input']>
}

/** Node Interface */
export type Node = {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type NodeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type NodeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type NodeFilterListInput = {
    elemMatch: InputMaybe<NodeFilterInput>
}

export type NodeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PageInfo = {
    currentPage: Scalars['Int']['output']
    hasNextPage: Scalars['Boolean']['output']
    hasPreviousPage: Scalars['Boolean']['output']
    itemCount: Scalars['Int']['output']
    pageCount: Scalars['Int']['output']
    perPage: Maybe<Scalars['Int']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicAboutUsPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicAboutUsPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicAboutUsPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicAboutUsPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicAboutUsPageEdge>
    group: Array<PrismicAboutUsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicAboutUsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicAboutUsPageConnectionDistinctArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageConnectionGroupArgs = {
    field: PrismicAboutUsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageConnectionMaxArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageConnectionMinArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageConnectionSumArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageDataFeatureBlocks1 = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicAboutUsPageDataFeatureBlocks1ImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataFeatureBlocks1FieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks1FilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataFeatureBlocks1FilterListInput = {
    elemMatch: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1FilterInput>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks1SortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1ImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks2 = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicAboutUsPageDataFeatureBlocks2ImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataFeatureBlocks2FieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks2FilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataFeatureBlocks2FilterListInput = {
    elemMatch: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2FilterInput>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataFeatureBlocks2SortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2ImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicAboutUsPageDataHeroImageImageType>
    image_2: Maybe<PrismicAboutUsPageDataHeroImage2ImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicAboutUsPageDataHeroImageImageTypeFieldSelector>
    image_2: InputMaybe<PrismicAboutUsPageDataHeroImage2ImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicAboutUsPageDataHeroImageImageTypeFilterInput>
    image_2: InputMaybe<PrismicAboutUsPageDataHeroImage2ImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicAboutUsPageDataHeroFilterInput>
}

export type PrismicAboutUsPageDataHeroImage2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataHeroImage2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicAboutUsPageDataHeroImageImageTypeSortInput>
    image_2: InputMaybe<PrismicAboutUsPageDataHeroImage2ImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataInlineVideo = {
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicAboutUsPageDataInlineVideoVideoThumbnailImageType>
}

export type PrismicAboutUsPageDataInlineVideoFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
    video_thumbnail: InputMaybe<PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFieldSelector>
}

export type PrismicAboutUsPageDataInlineVideoFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
    video_thumbnail: InputMaybe<PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFilterInput>
}

export type PrismicAboutUsPageDataInlineVideoFilterListInput = {
    elemMatch: InputMaybe<PrismicAboutUsPageDataInlineVideoFilterInput>
}

export type PrismicAboutUsPageDataInlineVideoSortInput = {
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
    video_thumbnail: InputMaybe<PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeSortInput>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataInlineVideoVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAboutUsPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks_1: Maybe<Array<Maybe<PrismicAboutUsPageDataFeatureBlocks1>>>
    feature_blocks_2: Maybe<Array<Maybe<PrismicAboutUsPageDataFeatureBlocks2>>>
    hero: Maybe<Array<Maybe<PrismicAboutUsPageDataHero>>>
    inline_video: Maybe<Array<Maybe<PrismicAboutUsPageDataInlineVideo>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicAboutUsPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
}

export type PrismicAboutUsPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks_1: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1FieldSelector>
    feature_blocks_2: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2FieldSelector>
    hero: InputMaybe<PrismicAboutUsPageDataHeroFieldSelector>
    inline_video: InputMaybe<PrismicAboutUsPageDataInlineVideoFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicAboutUsPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicAboutUsPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks_1: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1FilterListInput>
    feature_blocks_2: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2FilterListInput>
    hero: InputMaybe<PrismicAboutUsPageDataHeroFilterListInput>
    inline_video: InputMaybe<PrismicAboutUsPageDataInlineVideoFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicAboutUsPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicAboutUsPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks_1: InputMaybe<PrismicAboutUsPageDataFeatureBlocks1SortInput>
    feature_blocks_2: InputMaybe<PrismicAboutUsPageDataFeatureBlocks2SortInput>
    hero: InputMaybe<PrismicAboutUsPageDataHeroSortInput>
    inline_video: InputMaybe<PrismicAboutUsPageDataInlineVideoSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicAboutUsPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicAboutUsPageEdge = {
    next: Maybe<PrismicAboutUsPage>
    node: PrismicAboutUsPage
    previous: Maybe<PrismicAboutUsPage>
}

export type PrismicAboutUsPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicAboutUsPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAboutUsPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicAboutUsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAboutUsPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicAboutUsPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicAboutUsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicAboutUsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicAboutUsPageGroupConnectionDistinctArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageGroupConnectionGroupArgs = {
    field: PrismicAboutUsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAboutUsPageGroupConnectionMaxArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageGroupConnectionMinArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageGroupConnectionSumArgs = {
    field: PrismicAboutUsPageFieldSelector
}

export type PrismicAboutUsPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicAboutUsPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAdditionalUsersTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicAdditionalUsersTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicAdditionalUsersTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicAdditionalUsersTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicAdditionalUsersTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicAdditionalUsersTableEdge>
    group: Array<PrismicAdditionalUsersTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicAdditionalUsersTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicAdditionalUsersTableConnectionDistinctArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableConnectionGroupArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAdditionalUsersTableConnectionMaxArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableConnectionMinArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableConnectionSumArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableDataRows = {
    advanced_price: Maybe<Scalars['String']['output']>
    essential_price: Maybe<Scalars['String']['output']>
    users_range: Maybe<Scalars['String']['output']>
}

export type PrismicAdditionalUsersTableDataRowsFieldSelector = {
    advanced_price: InputMaybe<FieldSelectorEnum>
    essential_price: InputMaybe<FieldSelectorEnum>
    users_range: InputMaybe<FieldSelectorEnum>
}

export type PrismicAdditionalUsersTableDataRowsFilterInput = {
    advanced_price: InputMaybe<StringQueryOperatorInput>
    essential_price: InputMaybe<StringQueryOperatorInput>
    users_range: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAdditionalUsersTableDataRowsFilterListInput = {
    elemMatch: InputMaybe<PrismicAdditionalUsersTableDataRowsFilterInput>
}

export type PrismicAdditionalUsersTableDataRowsSortInput = {
    advanced_price: InputMaybe<SortOrderEnum>
    essential_price: InputMaybe<SortOrderEnum>
    users_range: InputMaybe<SortOrderEnum>
}

export type PrismicAdditionalUsersTableDataType = {
    advanced_price_heading: Maybe<Scalars['String']['output']>
    essential_price_heading: Maybe<Scalars['String']['output']>
    rows: Maybe<Array<Maybe<PrismicAdditionalUsersTableDataRows>>>
    users_range_heading: Maybe<Scalars['String']['output']>
}

export type PrismicAdditionalUsersTableDataTypeFieldSelector = {
    advanced_price_heading: InputMaybe<FieldSelectorEnum>
    essential_price_heading: InputMaybe<FieldSelectorEnum>
    rows: InputMaybe<PrismicAdditionalUsersTableDataRowsFieldSelector>
    users_range_heading: InputMaybe<FieldSelectorEnum>
}

export type PrismicAdditionalUsersTableDataTypeFilterInput = {
    advanced_price_heading: InputMaybe<StringQueryOperatorInput>
    essential_price_heading: InputMaybe<StringQueryOperatorInput>
    rows: InputMaybe<PrismicAdditionalUsersTableDataRowsFilterListInput>
    users_range_heading: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAdditionalUsersTableDataTypeSortInput = {
    advanced_price_heading: InputMaybe<SortOrderEnum>
    essential_price_heading: InputMaybe<SortOrderEnum>
    rows: InputMaybe<PrismicAdditionalUsersTableDataRowsSortInput>
    users_range_heading: InputMaybe<SortOrderEnum>
}

export type PrismicAdditionalUsersTableEdge = {
    next: Maybe<PrismicAdditionalUsersTable>
    node: PrismicAdditionalUsersTable
    previous: Maybe<PrismicAdditionalUsersTable>
}

export type PrismicAdditionalUsersTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicAdditionalUsersTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicAdditionalUsersTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicAdditionalUsersTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAdditionalUsersTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicAdditionalUsersTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicAdditionalUsersTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicAdditionalUsersTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicAdditionalUsersTableGroupConnectionDistinctArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableGroupConnectionGroupArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicAdditionalUsersTableGroupConnectionMaxArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableGroupConnectionMinArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableGroupConnectionSumArgs = {
    field: PrismicAdditionalUsersTableFieldSelector
}

export type PrismicAdditionalUsersTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicAdditionalUsersTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicAllDocumentTypes =
    | PrismicAboutUsPage
    | PrismicAdditionalUsersTable
    | PrismicApplePayPage
    | PrismicBigform
    | PrismicBigformPage
    | PrismicBillsCalculator
    | PrismicBillsStatus
    | PrismicBillsTracker
    | PrismicCalendlyPage
    | PrismicCardCreationFunnel
    | PrismicCareersPage
    | PrismicCarousel
    | PrismicCashbackCalculator
    | PrismicComaprisonTable
    | PrismicComparisonTable
    | PrismicCookieBanner
    | PrismicCookieCategory
    | PrismicCookieManager
    | PrismicCookieSegment
    | PrismicCookieSettingsPage
    | PrismicCopyExperiment
    | PrismicCustomerCase
    | PrismicCustomerLogos
    | PrismicCustomerStoriesSection
    | PrismicCustomersLogosSection
    | PrismicCustomersPage
    | PrismicDemoPage
    | PrismicDisallowedEmails
    | PrismicEbook
    | PrismicEbookDetails
    | PrismicEbookMarketingDownload
    | PrismicEbookMarketingPage
    | PrismicEbooksIndex
    | PrismicEvent
    | PrismicEventBigformPage
    | PrismicEventForm
    | PrismicExpensePolicyBuilder
    | PrismicExpenseReportGenerator
    | PrismicExperimentalLandingPage
    | PrismicExploreProduct
    | PrismicFaqPage
    | PrismicFeatureBlock
    | PrismicFeatureBlockGroup
    | PrismicFeatureIconCard
    | PrismicFeatureIconCards
    | PrismicFetchPage
    | PrismicFincirclePage
    | PrismicFlexBenefitsPage
    | PrismicFooter
    | PrismicFooterSignup
    | PrismicFormConsent
    | PrismicGettingStartedExperience
    | PrismicGlobalStrings
    | PrismicHeader
    | PrismicHeaderDropdown
    | PrismicHeaderDropdownColumn
    | PrismicHeaderDropdownCta
    | PrismicHeaderV2
    | PrismicHeaderV2Dropdown
    | PrismicHeroTab
    | PrismicHomepageV4
    | PrismicHowItWorksPage
    | PrismicHubspotGlobalForm
    | PrismicHubspotReferralForm
    | PrismicIntegration
    | PrismicIntegrationPage
    | PrismicIntegrationsFeatureBlock
    | PrismicIntegrationsIndexPage
    | PrismicInvoice
    | PrismicInvoiceGenerator
    | PrismicInvoiceTemplateForm
    | PrismicInvoicesApprovals
    | PrismicJobListing
    | PrismicJobPage
    | PrismicLearnMoreCard
    | PrismicLegalDocument
    | PrismicLegalDocuments
    | PrismicLegalDocumentsDirectory
    | PrismicLegalPage
    | PrismicLegalPageCookiePolicy
    | PrismicLegalPageDsr
    | PrismicLegalPageGdpr
    | PrismicLegalPageThirdPartyLicences
    | PrismicLinkTest
    | PrismicMeetingBookerPage
    | PrismicNotFoundPage
    | PrismicNotificationBanner
    | PrismicOnDemandResourceCategory
    | PrismicOnDemandResourceForm
    | PrismicOnDemandResourcePage
    | PrismicOnDemandWebinarDetailPage
    | PrismicOnDemandWebinarForm
    | PrismicPartner
    | PrismicPartnerBigform
    | PrismicPartnerBigformPage
    | PrismicPartnerPage
    | PrismicPartnerSignupBanner
    | PrismicPartnersProgrammeTable
    | PrismicPartnershipCase
    | PrismicPartnershipTier
    | PrismicPartnershipTiers
    | PrismicPerk
    | PrismicPerksInternalPage
    | PrismicPleoEvent
    | PrismicPleoPartnerTier
    | PrismicPocketPage
    | PrismicPodcastFormPage
    | PrismicPreLaunchFormPage
    | PrismicPricingComparisonTable
    | PrismicPricingPage
    | PrismicPricingPageV2
    | PrismicPricingPlanPicker
    | PrismicPricingTable
    | PrismicPricingTableV2
    | PrismicPricingTier
    | PrismicPricingTiers
    | PrismicPricingTiersV2
    | PrismicPricingV2
    | PrismicPricingV3ComparisonTable
    | PrismicPricingV3Page
    | PrismicPricingV3PricingTier
    | PrismicPricingV3PricingTierFeatureList
    | PrismicPricingV3TierPricingModel
    | PrismicProofPointBadges
    | PrismicProofPointBadgesRepeatable
    | PrismicRating
    | PrismicRatingsGroup
    | PrismicResourceDetailPage
    | PrismicRoiCalculator
    | PrismicRoicPreview
    | PrismicRytisEbookDetails
    | PrismicSecondaryHomepage
    | PrismicSecondaryLegalDocuments
    | PrismicSecondaryLegalPage
    | PrismicSecondaryNotFoundPage
    | PrismicSecondaryPricingPage
    | PrismicSecondaryPricingTier
    | PrismicSecondaryPricingTiers
    | PrismicSeo
    | PrismicSignUpModal
    | PrismicSignupBanner
    | PrismicSignupFunnelExperiment
    | PrismicSignupModal
    | PrismicSignupPage
    | PrismicSignupReason
    | PrismicSignupWizard
    | PrismicSignupmodal
    | PrismicSkillEvaluationTool
    | PrismicSlicePage
    | PrismicSocialProofIndicator
    | PrismicSocialProofLogosExtendedSection
    | PrismicSocialProofLogosSection
    | PrismicSocialProofRatingsSection
    | PrismicStarterBigformPage
    | PrismicStatisticsSection
    | PrismicSubscriptionsPage
    | PrismicSyncedIntegration
    | PrismicSyncedIntegrationsCategories
    | PrismicTemplateCustomerCase
    | PrismicTemplatePartner
    | PrismicTestAaa
    | PrismicTestimonial
    | PrismicThirdPartyLicencesSection
    | PrismicTypeformSurveys
    | PrismicUnifiedSignupModal
    | PrismicVatCalculator
    | PrismicWebinarCategory
    | PrismicWhyPleoPage
    | PrismicWistaChannelPage

export type PrismicAlternateLanguageType = {
    document: Maybe<PrismicAllDocumentTypes>
    id: Maybe<Scalars['ID']['output']>
    lang: Maybe<Scalars['String']['output']>
    raw: Maybe<Scalars['JSON']['output']>
    type: Maybe<Scalars['String']['output']>
    uid: Maybe<Scalars['String']['output']>
}

export type PrismicAlternateLanguageTypeFieldSelector = {
    id: InputMaybe<FieldSelectorEnum>
    lang: InputMaybe<FieldSelectorEnum>
    raw: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
}

export type PrismicAlternateLanguageTypeFilterInput = {
    id: InputMaybe<IdQueryOperatorInput>
    lang: InputMaybe<StringQueryOperatorInput>
    raw: InputMaybe<JsonQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
}

export type PrismicAlternateLanguageTypeFilterListInput = {
    elemMatch: InputMaybe<PrismicAlternateLanguageTypeFilterInput>
}

export type PrismicAlternateLanguageTypeSortInput = {
    id: InputMaybe<SortOrderEnum>
    lang: InputMaybe<SortOrderEnum>
    raw: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicApplePayPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicApplePayPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicApplePayPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicApplePayPageEdge>
    group: Array<PrismicApplePayPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicApplePayPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicApplePayPageConnectionDistinctArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageConnectionGroupArgs = {
    field: PrismicApplePayPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageConnectionMaxArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageConnectionMinArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageConnectionSumArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageDataAddCardSteps = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicApplePayPageDataAddCardStepsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataAddCardStepsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicApplePayPageDataAddCardStepsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataAddCardStepsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicApplePayPageDataAddCardStepsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataAddCardStepsFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataAddCardStepsFilterInput>
}

export type PrismicApplePayPageDataAddCardStepsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataAddCardStepsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataAddCardStepsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicApplePayPageDataAddCardStepsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataCheckOut = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicApplePayPageDataCheckOutImageImageType>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicApplePayPageDataCheckOutFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicApplePayPageDataCheckOutImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicApplePayPageDataCheckOutFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicApplePayPageDataCheckOutImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicApplePayPageDataCheckOutFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataCheckOutFilterInput>
}

export type PrismicApplePayPageDataCheckOutImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataCheckOutImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataCheckOutSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicApplePayPageDataCheckOutImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicApplePayPageDataFastPayments = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicApplePayPageDataFastPaymentsImageImageType>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicApplePayPageDataFastPaymentsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicApplePayPageDataFastPaymentsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicApplePayPageDataFastPaymentsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicApplePayPageDataFastPaymentsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicApplePayPageDataFastPaymentsFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataFastPaymentsFilterInput>
}

export type PrismicApplePayPageDataFastPaymentsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataFastPaymentsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataFastPaymentsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicApplePayPageDataFastPaymentsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicApplePayPageDataFetch = {
    body: Maybe<PrismicStructuredTextType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicApplePayPageDataFetchImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataFetchFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicApplePayPageDataFetchImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataFetchFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicApplePayPageDataFetchImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataFetchFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataFetchFilterInput>
}

export type PrismicApplePayPageDataFetchImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataFetchImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataFetchImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataFetchImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataFetchImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataFetchImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataFetchImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataFetchImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataFetchSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicApplePayPageDataFetchImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataHeroBadgeImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataHeroBadgeImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataPerks = {
    body: Maybe<PrismicStructuredTextType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicApplePayPageDataPerksImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataPerksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicApplePayPageDataPerksImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataPerksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicApplePayPageDataPerksImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataPerksFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataPerksFilterInput>
}

export type PrismicApplePayPageDataPerksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataPerksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataPerksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataPerksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataPerksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataPerksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataPerksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataPerksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataPerksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicApplePayPageDataPerksImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataQuestionsAnswersFilterInput>
}

export type PrismicApplePayPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataSafePayments = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicApplePayPageDataSafePaymentsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataSafePaymentsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicApplePayPageDataSafePaymentsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataSafePaymentsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicApplePayPageDataSafePaymentsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataSafePaymentsFilterListInput = {
    elemMatch: InputMaybe<PrismicApplePayPageDataSafePaymentsFilterInput>
}

export type PrismicApplePayPageDataSafePaymentsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataSafePaymentsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataSafePaymentsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicApplePayPageDataSafePaymentsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageDataType = {
    add_card_cta_text: Maybe<Scalars['String']['output']>
    add_card_steps: Maybe<Array<Maybe<PrismicApplePayPageDataAddCardSteps>>>
    add_card_subtitle: Maybe<Scalars['String']['output']>
    add_card_title: Maybe<Scalars['String']['output']>
    benefits_title: Maybe<Scalars['String']['output']>
    check_out: Maybe<Array<Maybe<PrismicApplePayPageDataCheckOut>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    fast_payments: Maybe<Array<Maybe<PrismicApplePayPageDataFastPayments>>>
    fetch: Maybe<Array<Maybe<PrismicApplePayPageDataFetch>>>
    hero_badge: Maybe<PrismicApplePayPageDataHeroBadgeImageType>
    hero_image: Maybe<PrismicApplePayPageDataHeroImageImageType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicApplePayPageDataOpenGraphImageImageType>
    page_type: Maybe<Scalars['String']['output']>
    perks: Maybe<Array<Maybe<PrismicApplePayPageDataPerks>>>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicApplePayPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    safe_payments: Maybe<Array<Maybe<PrismicApplePayPageDataSafePayments>>>
    signup_banner: Maybe<PrismicLinkType>
    subtitle: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicApplePayPageDataTypeFieldSelector = {
    add_card_cta_text: InputMaybe<FieldSelectorEnum>
    add_card_steps: InputMaybe<PrismicApplePayPageDataAddCardStepsFieldSelector>
    add_card_subtitle: InputMaybe<FieldSelectorEnum>
    add_card_title: InputMaybe<FieldSelectorEnum>
    benefits_title: InputMaybe<FieldSelectorEnum>
    check_out: InputMaybe<PrismicApplePayPageDataCheckOutFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    fast_payments: InputMaybe<PrismicApplePayPageDataFastPaymentsFieldSelector>
    fetch: InputMaybe<PrismicApplePayPageDataFetchFieldSelector>
    hero_badge: InputMaybe<PrismicApplePayPageDataHeroBadgeImageTypeFieldSelector>
    hero_image: InputMaybe<PrismicApplePayPageDataHeroImageImageTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicApplePayPageDataOpenGraphImageImageTypeFieldSelector>
    page_type: InputMaybe<FieldSelectorEnum>
    perks: InputMaybe<PrismicApplePayPageDataPerksFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicApplePayPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    safe_payments: InputMaybe<PrismicApplePayPageDataSafePaymentsFieldSelector>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    subtitle: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageDataTypeFilterInput = {
    add_card_cta_text: InputMaybe<StringQueryOperatorInput>
    add_card_steps: InputMaybe<PrismicApplePayPageDataAddCardStepsFilterListInput>
    add_card_subtitle: InputMaybe<StringQueryOperatorInput>
    add_card_title: InputMaybe<StringQueryOperatorInput>
    benefits_title: InputMaybe<StringQueryOperatorInput>
    check_out: InputMaybe<PrismicApplePayPageDataCheckOutFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    fast_payments: InputMaybe<PrismicApplePayPageDataFastPaymentsFilterListInput>
    fetch: InputMaybe<PrismicApplePayPageDataFetchFilterListInput>
    hero_badge: InputMaybe<PrismicApplePayPageDataHeroBadgeImageTypeFilterInput>
    hero_image: InputMaybe<PrismicApplePayPageDataHeroImageImageTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicApplePayPageDataOpenGraphImageImageTypeFilterInput>
    page_type: InputMaybe<StringQueryOperatorInput>
    perks: InputMaybe<PrismicApplePayPageDataPerksFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicApplePayPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    safe_payments: InputMaybe<PrismicApplePayPageDataSafePaymentsFilterListInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    subtitle: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageDataTypeSortInput = {
    add_card_cta_text: InputMaybe<SortOrderEnum>
    add_card_steps: InputMaybe<PrismicApplePayPageDataAddCardStepsSortInput>
    add_card_subtitle: InputMaybe<SortOrderEnum>
    add_card_title: InputMaybe<SortOrderEnum>
    benefits_title: InputMaybe<SortOrderEnum>
    check_out: InputMaybe<PrismicApplePayPageDataCheckOutSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    fast_payments: InputMaybe<PrismicApplePayPageDataFastPaymentsSortInput>
    fetch: InputMaybe<PrismicApplePayPageDataFetchSortInput>
    hero_badge: InputMaybe<PrismicApplePayPageDataHeroBadgeImageTypeSortInput>
    hero_image: InputMaybe<PrismicApplePayPageDataHeroImageImageTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicApplePayPageDataOpenGraphImageImageTypeSortInput>
    page_type: InputMaybe<SortOrderEnum>
    perks: InputMaybe<PrismicApplePayPageDataPerksSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicApplePayPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    safe_payments: InputMaybe<PrismicApplePayPageDataSafePaymentsSortInput>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    subtitle: InputMaybe<PrismicStructuredTextTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicApplePayPageEdge = {
    next: Maybe<PrismicApplePayPage>
    node: PrismicApplePayPage
    previous: Maybe<PrismicApplePayPage>
}

export type PrismicApplePayPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicApplePayPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicApplePayPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicApplePayPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicApplePayPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicApplePayPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicApplePayPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicApplePayPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicApplePayPageGroupConnectionDistinctArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageGroupConnectionGroupArgs = {
    field: PrismicApplePayPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicApplePayPageGroupConnectionMaxArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageGroupConnectionMinArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageGroupConnectionSumArgs = {
    field: PrismicApplePayPageFieldSelector
}

export type PrismicApplePayPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicApplePayPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBigform = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicBigformDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBigformFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBigformLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBigformConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformEdge>
    group: Array<PrismicBigformGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigform>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformConnectionDistinctArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformConnectionGroupArgs = {
    field: PrismicBigformFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformConnectionMaxArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformConnectionMinArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformConnectionSumArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformDataSandboxHubspotFormIntegrationTypeEdge>
    group: Array<PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigformDataSandboxHubspotFormIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnectionDistinctArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnectionGroupArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnectionMaxArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnectionMinArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeConnectionSumArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeEdge = {
    next: Maybe<PrismicBigformDataSandboxHubspotFormIntegrationType>
    node: PrismicBigformDataSandboxHubspotFormIntegrationType
    previous: Maybe<PrismicBigformDataSandboxHubspotFormIntegrationType>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformDataSandboxHubspotFormIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigformDataSandboxHubspotFormIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector
}

export type PrismicBigformDataSandboxHubspotFormIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicBigformDataType = {
    company_size_error: Maybe<Scalars['String']['output']>
    company_size_label: Maybe<Scalars['String']['output']>
    company_size_placeholder: Maybe<Scalars['String']['output']>
    consent_label: Maybe<PrismicStructuredTextType>
    country_error: Maybe<Scalars['String']['output']>
    country_label: Maybe<Scalars['String']['output']>
    country_placeholder: Maybe<Scalars['String']['output']>
    demo_submit_text: Maybe<Scalars['String']['output']>
    discovered_via_label: Maybe<Scalars['String']['output']>
    discovered_via_placeholder: Maybe<Scalars['String']['output']>
    email_error: Maybe<Scalars['String']['output']>
    email_label: Maybe<Scalars['String']['output']>
    employee: Maybe<Scalars['String']['output']>
    employees: Maybe<Scalars['String']['output']>
    first_name_error: Maybe<Scalars['String']['output']>
    first_name_label: Maybe<Scalars['String']['output']>
    google_search: Maybe<Scalars['String']['output']>
    has_consented_error: Maybe<Scalars['String']['output']>
    last_name_error: Maybe<Scalars['String']['output']>
    last_name_label: Maybe<Scalars['String']['output']>
    other: Maybe<Scalars['String']['output']>
    outdoor_advertising: Maybe<Scalars['String']['output']>
    peer_recommendation: Maybe<Scalars['String']['output']>
    phone_number_error: Maybe<Scalars['String']['output']>
    phone_number_label: Maybe<Scalars['String']['output']>
    press: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    recaptcha_message: Maybe<PrismicStructuredTextType>
    sandbox_hubspot_form: Maybe<PrismicBigformDataSandboxHubspotFormIntegrationType>
    social_media: Maybe<Scalars['String']['output']>
    sole_trader: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    trust_pilot: Maybe<Scalars['String']['output']>
    tv: Maybe<Scalars['String']['output']>
    youtube: Maybe<Scalars['String']['output']>
}

export type PrismicBigformDataTypeFieldSelector = {
    company_size_error: InputMaybe<FieldSelectorEnum>
    company_size_label: InputMaybe<FieldSelectorEnum>
    company_size_placeholder: InputMaybe<FieldSelectorEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    country_error: InputMaybe<FieldSelectorEnum>
    country_label: InputMaybe<FieldSelectorEnum>
    country_placeholder: InputMaybe<FieldSelectorEnum>
    demo_submit_text: InputMaybe<FieldSelectorEnum>
    discovered_via_label: InputMaybe<FieldSelectorEnum>
    discovered_via_placeholder: InputMaybe<FieldSelectorEnum>
    email_error: InputMaybe<FieldSelectorEnum>
    email_label: InputMaybe<FieldSelectorEnum>
    employee: InputMaybe<FieldSelectorEnum>
    employees: InputMaybe<FieldSelectorEnum>
    first_name_error: InputMaybe<FieldSelectorEnum>
    first_name_label: InputMaybe<FieldSelectorEnum>
    google_search: InputMaybe<FieldSelectorEnum>
    has_consented_error: InputMaybe<FieldSelectorEnum>
    last_name_error: InputMaybe<FieldSelectorEnum>
    last_name_label: InputMaybe<FieldSelectorEnum>
    other: InputMaybe<FieldSelectorEnum>
    outdoor_advertising: InputMaybe<FieldSelectorEnum>
    peer_recommendation: InputMaybe<FieldSelectorEnum>
    phone_number_error: InputMaybe<FieldSelectorEnum>
    phone_number_label: InputMaybe<FieldSelectorEnum>
    press: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    sandbox_hubspot_form: InputMaybe<PrismicBigformDataSandboxHubspotFormIntegrationTypeFieldSelector>
    social_media: InputMaybe<FieldSelectorEnum>
    sole_trader: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    trust_pilot: InputMaybe<FieldSelectorEnum>
    tv: InputMaybe<FieldSelectorEnum>
    youtube: InputMaybe<FieldSelectorEnum>
}

export type PrismicBigformDataTypeFilterInput = {
    company_size_error: InputMaybe<StringQueryOperatorInput>
    company_size_label: InputMaybe<StringQueryOperatorInput>
    company_size_placeholder: InputMaybe<StringQueryOperatorInput>
    consent_label: InputMaybe<PrismicStructuredTextTypeFilterInput>
    country_error: InputMaybe<StringQueryOperatorInput>
    country_label: InputMaybe<StringQueryOperatorInput>
    country_placeholder: InputMaybe<StringQueryOperatorInput>
    demo_submit_text: InputMaybe<StringQueryOperatorInput>
    discovered_via_label: InputMaybe<StringQueryOperatorInput>
    discovered_via_placeholder: InputMaybe<StringQueryOperatorInput>
    email_error: InputMaybe<StringQueryOperatorInput>
    email_label: InputMaybe<StringQueryOperatorInput>
    employee: InputMaybe<StringQueryOperatorInput>
    employees: InputMaybe<StringQueryOperatorInput>
    first_name_error: InputMaybe<StringQueryOperatorInput>
    first_name_label: InputMaybe<StringQueryOperatorInput>
    google_search: InputMaybe<StringQueryOperatorInput>
    has_consented_error: InputMaybe<StringQueryOperatorInput>
    last_name_error: InputMaybe<StringQueryOperatorInput>
    last_name_label: InputMaybe<StringQueryOperatorInput>
    other: InputMaybe<StringQueryOperatorInput>
    outdoor_advertising: InputMaybe<StringQueryOperatorInput>
    peer_recommendation: InputMaybe<StringQueryOperatorInput>
    phone_number_error: InputMaybe<StringQueryOperatorInput>
    phone_number_label: InputMaybe<StringQueryOperatorInput>
    press: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    sandbox_hubspot_form: InputMaybe<PrismicBigformDataSandboxHubspotFormIntegrationTypeFilterInput>
    social_media: InputMaybe<StringQueryOperatorInput>
    sole_trader: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    trust_pilot: InputMaybe<StringQueryOperatorInput>
    tv: InputMaybe<StringQueryOperatorInput>
    youtube: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBigformDataTypeSortInput = {
    company_size_error: InputMaybe<SortOrderEnum>
    company_size_label: InputMaybe<SortOrderEnum>
    company_size_placeholder: InputMaybe<SortOrderEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeSortInput>
    country_error: InputMaybe<SortOrderEnum>
    country_label: InputMaybe<SortOrderEnum>
    country_placeholder: InputMaybe<SortOrderEnum>
    demo_submit_text: InputMaybe<SortOrderEnum>
    discovered_via_label: InputMaybe<SortOrderEnum>
    discovered_via_placeholder: InputMaybe<SortOrderEnum>
    email_error: InputMaybe<SortOrderEnum>
    email_label: InputMaybe<SortOrderEnum>
    employee: InputMaybe<SortOrderEnum>
    employees: InputMaybe<SortOrderEnum>
    first_name_error: InputMaybe<SortOrderEnum>
    first_name_label: InputMaybe<SortOrderEnum>
    google_search: InputMaybe<SortOrderEnum>
    has_consented_error: InputMaybe<SortOrderEnum>
    last_name_error: InputMaybe<SortOrderEnum>
    last_name_label: InputMaybe<SortOrderEnum>
    other: InputMaybe<SortOrderEnum>
    outdoor_advertising: InputMaybe<SortOrderEnum>
    peer_recommendation: InputMaybe<SortOrderEnum>
    phone_number_error: InputMaybe<SortOrderEnum>
    phone_number_label: InputMaybe<SortOrderEnum>
    press: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    sandbox_hubspot_form: InputMaybe<PrismicBigformDataSandboxHubspotFormIntegrationTypeSortInput>
    social_media: InputMaybe<SortOrderEnum>
    sole_trader: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    trust_pilot: InputMaybe<SortOrderEnum>
    tv: InputMaybe<SortOrderEnum>
    youtube: InputMaybe<SortOrderEnum>
}

export type PrismicBigformEdge = {
    next: Maybe<PrismicBigform>
    node: PrismicBigform
    previous: Maybe<PrismicBigform>
}

export type PrismicBigformFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicBigformDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBigformFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBigformDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBigformGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBigformGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigform>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformGroupConnectionDistinctArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformGroupConnectionGroupArgs = {
    field: PrismicBigformFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformGroupConnectionMaxArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformGroupConnectionMinArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformGroupConnectionSumArgs = {
    field: PrismicBigformFieldSelector
}

export type PrismicBigformPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicBigformPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBigformPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBigformPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBigformPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformPageEdge>
    group: Array<PrismicBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformPageConnectionDistinctArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageConnectionGroupArgs = {
    field: PrismicBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformPageConnectionMaxArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageConnectionMinArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageConnectionSumArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBigformPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBigformPageDataType = {
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicBigformPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    social_proof_logos_section: Maybe<PrismicLinkType>
}

export type PrismicBigformPageDataTypeFieldSelector = {
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicBigformPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicBigformPageDataTypeFilterInput = {
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicBigformPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicBigformPageDataTypeSortInput = {
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicBigformPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicBigformPageEdge = {
    next: Maybe<PrismicBigformPage>
    node: PrismicBigformPage
    previous: Maybe<PrismicBigformPage>
}

export type PrismicBigformPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicBigformPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBigformPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBigformPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBigformPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBigformPageGroupConnectionDistinctArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageGroupConnectionGroupArgs = {
    field: PrismicBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBigformPageGroupConnectionMaxArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageGroupConnectionMinArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageGroupConnectionSumArgs = {
    field: PrismicBigformPageFieldSelector
}

export type PrismicBigformPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicBigformPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBigformSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicBigformDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicBillsCalculatorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsCalculatorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsCalculatorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsCalculatorEdge>
    group: Array<PrismicBillsCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsCalculatorConnectionDistinctArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorConnectionGroupArgs = {
    field: PrismicBillsCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorConnectionMaxArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorConnectionMinArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorConnectionSumArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorDataAverageTimeToProcess = {
    icon1: Maybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageType>
    icon2: Maybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageType>
    icon3: Maybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessFieldSelector = {
    icon1: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessFilterInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessFilterInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataAverageTimeToProcessSortInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumInvoices = {
    icon1: Maybe<PrismicBillsCalculatorDataNumInvoicesIcon1ImageType>
    icon2: Maybe<PrismicBillsCalculatorDataNumInvoicesIcon2ImageType>
    icon3: Maybe<PrismicBillsCalculatorDataNumInvoicesIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumInvoicesFieldSelector = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesFilterInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumInvoicesFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsCalculatorDataNumInvoicesFilterInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumInvoicesSortInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumInvoicesIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolved = {
    icon1: Maybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageType>
    icon2: Maybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageType>
    icon3: Maybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedFieldSelector = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedFilterInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedFilterInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataNumOfPeopleInvolvedSortInput = {
    icon1: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataResults = {
    invoices_take: Maybe<Scalars['String']['output']>
    results_title: Maybe<Scalars['String']['output']>
    time_saved: Maybe<Scalars['String']['output']>
    with_pleo_bills: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataResultsFieldSelector = {
    invoices_take: InputMaybe<FieldSelectorEnum>
    results_title: InputMaybe<FieldSelectorEnum>
    time_saved: InputMaybe<FieldSelectorEnum>
    with_pleo_bills: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataResultsFilterInput = {
    invoices_take: InputMaybe<StringQueryOperatorInput>
    results_title: InputMaybe<StringQueryOperatorInput>
    time_saved: InputMaybe<StringQueryOperatorInput>
    with_pleo_bills: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataResultsFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsCalculatorDataResultsFilterInput>
}

export type PrismicBillsCalculatorDataResultsSortInput = {
    invoices_take: InputMaybe<SortOrderEnum>
    results_title: InputMaybe<SortOrderEnum>
    time_saved: InputMaybe<SortOrderEnum>
    with_pleo_bills: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorDataType = {
    average_time_to_process: Maybe<Array<Maybe<PrismicBillsCalculatorDataAverageTimeToProcess>>>
    button_cta_text: Maybe<Scalars['String']['output']>
    how_we_calculate: Maybe<Scalars['String']['output']>
    how_we_calculate_answer: Maybe<Scalars['String']['output']>
    num_invoices: Maybe<Array<Maybe<PrismicBillsCalculatorDataNumInvoices>>>
    num_of_people_involved: Maybe<Array<Maybe<PrismicBillsCalculatorDataNumOfPeopleInvolved>>>
    prismic_title: Maybe<Scalars['String']['output']>
    results: Maybe<Array<Maybe<PrismicBillsCalculatorDataResults>>>
    section_description: Maybe<Scalars['String']['output']>
    section_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsCalculatorDataTypeFieldSelector = {
    average_time_to_process: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessFieldSelector>
    button_cta_text: InputMaybe<FieldSelectorEnum>
    how_we_calculate: InputMaybe<FieldSelectorEnum>
    how_we_calculate_answer: InputMaybe<FieldSelectorEnum>
    num_invoices: InputMaybe<PrismicBillsCalculatorDataNumInvoicesFieldSelector>
    num_of_people_involved: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    results: InputMaybe<PrismicBillsCalculatorDataResultsFieldSelector>
    section_description: InputMaybe<FieldSelectorEnum>
    section_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorDataTypeFilterInput = {
    average_time_to_process: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessFilterListInput>
    button_cta_text: InputMaybe<StringQueryOperatorInput>
    how_we_calculate: InputMaybe<StringQueryOperatorInput>
    how_we_calculate_answer: InputMaybe<StringQueryOperatorInput>
    num_invoices: InputMaybe<PrismicBillsCalculatorDataNumInvoicesFilterListInput>
    num_of_people_involved: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    results: InputMaybe<PrismicBillsCalculatorDataResultsFilterListInput>
    section_description: InputMaybe<StringQueryOperatorInput>
    section_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorDataTypeSortInput = {
    average_time_to_process: InputMaybe<PrismicBillsCalculatorDataAverageTimeToProcessSortInput>
    button_cta_text: InputMaybe<SortOrderEnum>
    how_we_calculate: InputMaybe<SortOrderEnum>
    how_we_calculate_answer: InputMaybe<SortOrderEnum>
    num_invoices: InputMaybe<PrismicBillsCalculatorDataNumInvoicesSortInput>
    num_of_people_involved: InputMaybe<PrismicBillsCalculatorDataNumOfPeopleInvolvedSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    results: InputMaybe<PrismicBillsCalculatorDataResultsSortInput>
    section_description: InputMaybe<SortOrderEnum>
    section_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsCalculatorEdge = {
    next: Maybe<PrismicBillsCalculator>
    node: PrismicBillsCalculator
    previous: Maybe<PrismicBillsCalculator>
}

export type PrismicBillsCalculatorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicBillsCalculatorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsCalculatorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsCalculatorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsCalculatorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBillsCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsCalculatorGroupConnectionDistinctArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorGroupConnectionGroupArgs = {
    field: PrismicBillsCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsCalculatorGroupConnectionMaxArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorGroupConnectionMinArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorGroupConnectionSumArgs = {
    field: PrismicBillsCalculatorFieldSelector
}

export type PrismicBillsCalculatorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicBillsCalculatorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatus = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicBillsStatusDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsStatusLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsStatusConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsStatusEdge>
    group: Array<PrismicBillsStatusGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsStatus>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsStatusConnectionDistinctArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusConnectionGroupArgs = {
    field: PrismicBillsStatusFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusConnectionMaxArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusConnectionMinArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusConnectionSumArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusDataErrorContent = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    error_title: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicBillsStatusDataErrorContentImageImageType>
}

export type PrismicBillsStatusDataErrorContentFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    error_title: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicBillsStatusDataErrorContentImageImageTypeFieldSelector>
}

export type PrismicBillsStatusDataErrorContentFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    error_title: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicBillsStatusDataErrorContentImageImageTypeFilterInput>
}

export type PrismicBillsStatusDataErrorContentFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataErrorContentFilterInput>
}

export type PrismicBillsStatusDataErrorContentImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataErrorContentImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataErrorContentSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    error_title: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicBillsStatusDataErrorContentImageImageTypeSortInput>
}

export type PrismicBillsStatusDataMarketingCard = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataMarketingCardFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataMarketingCardFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataMarketingCardFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataMarketingCardFilterInput>
}

export type PrismicBillsStatusDataMarketingCardSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataQuestions = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataQuestionsFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataQuestionsFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataQuestionsFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataQuestionsFilterInput>
}

export type PrismicBillsStatusDataQuestionsSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusPaid = {
    image: Maybe<PrismicBillsStatusDataStatusPaidImageImageType>
    status_paid_subtitle: Maybe<Scalars['String']['output']>
    status_paid_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusPaidFieldSelector = {
    image: InputMaybe<PrismicBillsStatusDataStatusPaidImageImageTypeFieldSelector>
    status_paid_subtitle: InputMaybe<FieldSelectorEnum>
    status_paid_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusPaidFilterInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusPaidImageImageTypeFilterInput>
    status_paid_subtitle: InputMaybe<StringQueryOperatorInput>
    status_paid_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusPaidFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataStatusPaidFilterInput>
}

export type PrismicBillsStatusDataStatusPaidImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusPaidImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusPaidSortInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusPaidImageImageTypeSortInput>
    status_paid_subtitle: InputMaybe<SortOrderEnum>
    status_paid_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusProcessing = {
    image: Maybe<PrismicBillsStatusDataStatusProcessingImageImageType>
    status_processing_subtitle: Maybe<Scalars['String']['output']>
    status_processing_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusProcessingFieldSelector = {
    image: InputMaybe<PrismicBillsStatusDataStatusProcessingImageImageTypeFieldSelector>
    status_processing_subtitle: InputMaybe<FieldSelectorEnum>
    status_processing_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusProcessingFilterInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusProcessingImageImageTypeFilterInput>
    status_processing_subtitle: InputMaybe<StringQueryOperatorInput>
    status_processing_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusProcessingFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataStatusProcessingFilterInput>
}

export type PrismicBillsStatusDataStatusProcessingImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusProcessingImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusProcessingSortInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusProcessingImageImageTypeSortInput>
    status_processing_subtitle: InputMaybe<SortOrderEnum>
    status_processing_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusReceived = {
    image: Maybe<PrismicBillsStatusDataStatusReceivedImageImageType>
    status_received_subtitle: Maybe<Scalars['String']['output']>
    status_received_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusReceivedFieldSelector = {
    image: InputMaybe<PrismicBillsStatusDataStatusReceivedImageImageTypeFieldSelector>
    status_received_subtitle: InputMaybe<FieldSelectorEnum>
    status_received_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusReceivedFilterInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusReceivedImageImageTypeFilterInput>
    status_received_subtitle: InputMaybe<StringQueryOperatorInput>
    status_received_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusReceivedFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsStatusDataStatusReceivedFilterInput>
}

export type PrismicBillsStatusDataStatusReceivedImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataStatusReceivedImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataStatusReceivedSortInput = {
    image: InputMaybe<PrismicBillsStatusDataStatusReceivedImageImageTypeSortInput>
    status_received_subtitle: InputMaybe<SortOrderEnum>
    status_received_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusDataType = {
    accept_terms_error: Maybe<Scalars['String']['output']>
    allow_indexing: Maybe<Scalars['Boolean']['output']>
    company: Maybe<Scalars['String']['output']>
    customer_logos: Maybe<PrismicLinkType>
    customer_logos_title: Maybe<Scalars['String']['output']>
    error_content: Maybe<Array<Maybe<PrismicBillsStatusDataErrorContent>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    header_cta: Maybe<Scalars['String']['output']>
    header_cta_link: Maybe<PrismicLinkType>
    header_link: Maybe<PrismicStructuredTextType>
    input_aria_label: Maybe<Scalars['String']['output']>
    input_label: Maybe<Scalars['String']['output']>
    invoice_date: Maybe<Scalars['String']['output']>
    invoice_id: Maybe<Scalars['String']['output']>
    last_edited: Maybe<Scalars['String']['output']>
    marketing_card: Maybe<Array<Maybe<PrismicBillsStatusDataMarketingCard>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicBillsStatusDataOpenGraphImageImageType>
    questions: Maybe<Array<Maybe<PrismicBillsStatusDataQuestions>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_box_placeholder: Maybe<Scalars['String']['output']>
    signup_box_title: Maybe<Scalars['String']['output']>
    signup_success_message: Maybe<PrismicStructuredTextType>
    status_paid: Maybe<Array<Maybe<PrismicBillsStatusDataStatusPaid>>>
    status_processing: Maybe<Array<Maybe<PrismicBillsStatusDataStatusProcessing>>>
    status_received: Maybe<Array<Maybe<PrismicBillsStatusDataStatusReceived>>>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    total_amount: Maybe<Scalars['String']['output']>
}

export type PrismicBillsStatusDataTypeFieldSelector = {
    accept_terms_error: InputMaybe<FieldSelectorEnum>
    allow_indexing: InputMaybe<FieldSelectorEnum>
    company: InputMaybe<FieldSelectorEnum>
    customer_logos: InputMaybe<PrismicLinkTypeFieldSelector>
    customer_logos_title: InputMaybe<FieldSelectorEnum>
    error_content: InputMaybe<PrismicBillsStatusDataErrorContentFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    header_cta: InputMaybe<FieldSelectorEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    header_link: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    input_aria_label: InputMaybe<FieldSelectorEnum>
    input_label: InputMaybe<FieldSelectorEnum>
    invoice_date: InputMaybe<FieldSelectorEnum>
    invoice_id: InputMaybe<FieldSelectorEnum>
    last_edited: InputMaybe<FieldSelectorEnum>
    marketing_card: InputMaybe<PrismicBillsStatusDataMarketingCardFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicBillsStatusDataOpenGraphImageImageTypeFieldSelector>
    questions: InputMaybe<PrismicBillsStatusDataQuestionsFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_box_placeholder: InputMaybe<FieldSelectorEnum>
    signup_box_title: InputMaybe<FieldSelectorEnum>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    status_paid: InputMaybe<PrismicBillsStatusDataStatusPaidFieldSelector>
    status_processing: InputMaybe<PrismicBillsStatusDataStatusProcessingFieldSelector>
    status_received: InputMaybe<PrismicBillsStatusDataStatusReceivedFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    total_amount: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusDataTypeFilterInput = {
    accept_terms_error: InputMaybe<StringQueryOperatorInput>
    allow_indexing: InputMaybe<BooleanQueryOperatorInput>
    company: InputMaybe<StringQueryOperatorInput>
    customer_logos: InputMaybe<PrismicLinkTypeFilterInput>
    customer_logos_title: InputMaybe<StringQueryOperatorInput>
    error_content: InputMaybe<PrismicBillsStatusDataErrorContentFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    header_cta: InputMaybe<StringQueryOperatorInput>
    header_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    header_link: InputMaybe<PrismicStructuredTextTypeFilterInput>
    input_aria_label: InputMaybe<StringQueryOperatorInput>
    input_label: InputMaybe<StringQueryOperatorInput>
    invoice_date: InputMaybe<StringQueryOperatorInput>
    invoice_id: InputMaybe<StringQueryOperatorInput>
    last_edited: InputMaybe<StringQueryOperatorInput>
    marketing_card: InputMaybe<PrismicBillsStatusDataMarketingCardFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicBillsStatusDataOpenGraphImageImageTypeFilterInput>
    questions: InputMaybe<PrismicBillsStatusDataQuestionsFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_box_placeholder: InputMaybe<StringQueryOperatorInput>
    signup_box_title: InputMaybe<StringQueryOperatorInput>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    status_paid: InputMaybe<PrismicBillsStatusDataStatusPaidFilterListInput>
    status_processing: InputMaybe<PrismicBillsStatusDataStatusProcessingFilterListInput>
    status_received: InputMaybe<PrismicBillsStatusDataStatusReceivedFilterListInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    total_amount: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusDataTypeSortInput = {
    accept_terms_error: InputMaybe<SortOrderEnum>
    allow_indexing: InputMaybe<SortOrderEnum>
    company: InputMaybe<SortOrderEnum>
    customer_logos: InputMaybe<PrismicLinkTypeSortInput>
    customer_logos_title: InputMaybe<SortOrderEnum>
    error_content: InputMaybe<PrismicBillsStatusDataErrorContentSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    header_cta: InputMaybe<SortOrderEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    header_link: InputMaybe<PrismicStructuredTextTypeSortInput>
    input_aria_label: InputMaybe<SortOrderEnum>
    input_label: InputMaybe<SortOrderEnum>
    invoice_date: InputMaybe<SortOrderEnum>
    invoice_id: InputMaybe<SortOrderEnum>
    last_edited: InputMaybe<SortOrderEnum>
    marketing_card: InputMaybe<PrismicBillsStatusDataMarketingCardSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicBillsStatusDataOpenGraphImageImageTypeSortInput>
    questions: InputMaybe<PrismicBillsStatusDataQuestionsSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_box_placeholder: InputMaybe<SortOrderEnum>
    signup_box_title: InputMaybe<SortOrderEnum>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    status_paid: InputMaybe<PrismicBillsStatusDataStatusPaidSortInput>
    status_processing: InputMaybe<PrismicBillsStatusDataStatusProcessingSortInput>
    status_received: InputMaybe<PrismicBillsStatusDataStatusReceivedSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    total_amount: InputMaybe<SortOrderEnum>
}

export type PrismicBillsStatusEdge = {
    next: Maybe<PrismicBillsStatus>
    node: PrismicBillsStatus
    previous: Maybe<PrismicBillsStatus>
}

export type PrismicBillsStatusFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicBillsStatusDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsStatusFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsStatusDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsStatusGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsStatusEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBillsStatusGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsStatus>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsStatusGroupConnectionDistinctArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusGroupConnectionGroupArgs = {
    field: PrismicBillsStatusFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsStatusGroupConnectionMaxArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusGroupConnectionMinArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusGroupConnectionSumArgs = {
    field: PrismicBillsStatusFieldSelector
}

export type PrismicBillsStatusSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicBillsStatusDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTracker = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicBillsTrackerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsTrackerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicBillsTrackerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsTrackerEdge>
    group: Array<PrismicBillsTrackerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsTracker>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsTrackerConnectionDistinctArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerConnectionGroupArgs = {
    field: PrismicBillsTrackerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerConnectionMaxArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerConnectionMinArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerConnectionSumArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerDataErrorContent = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    error_title: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicBillsTrackerDataErrorContentImageImageType>
}

export type PrismicBillsTrackerDataErrorContentFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    error_title: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicBillsTrackerDataErrorContentImageImageTypeFieldSelector>
}

export type PrismicBillsTrackerDataErrorContentFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    error_title: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicBillsTrackerDataErrorContentImageImageTypeFilterInput>
}

export type PrismicBillsTrackerDataErrorContentFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataErrorContentFilterInput>
}

export type PrismicBillsTrackerDataErrorContentImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataErrorContentImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataErrorContentSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    error_title: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicBillsTrackerDataErrorContentImageImageTypeSortInput>
}

export type PrismicBillsTrackerDataMarketingCard = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataMarketingCardFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataMarketingCardFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataMarketingCardFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataMarketingCardFilterInput>
}

export type PrismicBillsTrackerDataMarketingCardSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataQuestions = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataQuestionsFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataQuestionsFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataQuestionsFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataQuestionsFilterInput>
}

export type PrismicBillsTrackerDataQuestionsSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusPaid = {
    image: Maybe<PrismicBillsTrackerDataStatusPaidImageImageType>
    status_paid_subtitle: Maybe<Scalars['String']['output']>
    status_paid_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusPaidFieldSelector = {
    image: InputMaybe<PrismicBillsTrackerDataStatusPaidImageImageTypeFieldSelector>
    status_paid_subtitle: InputMaybe<FieldSelectorEnum>
    status_paid_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusPaidFilterInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusPaidImageImageTypeFilterInput>
    status_paid_subtitle: InputMaybe<StringQueryOperatorInput>
    status_paid_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusPaidFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataStatusPaidFilterInput>
}

export type PrismicBillsTrackerDataStatusPaidImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusPaidImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusPaidSortInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusPaidImageImageTypeSortInput>
    status_paid_subtitle: InputMaybe<SortOrderEnum>
    status_paid_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusProcessing = {
    image: Maybe<PrismicBillsTrackerDataStatusProcessingImageImageType>
    status_processing_subtitle: Maybe<Scalars['String']['output']>
    status_processing_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusProcessingFieldSelector = {
    image: InputMaybe<PrismicBillsTrackerDataStatusProcessingImageImageTypeFieldSelector>
    status_processing_subtitle: InputMaybe<FieldSelectorEnum>
    status_processing_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusProcessingFilterInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusProcessingImageImageTypeFilterInput>
    status_processing_subtitle: InputMaybe<StringQueryOperatorInput>
    status_processing_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusProcessingFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataStatusProcessingFilterInput>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusProcessingImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusProcessingSortInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusProcessingImageImageTypeSortInput>
    status_processing_subtitle: InputMaybe<SortOrderEnum>
    status_processing_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusReceived = {
    image: Maybe<PrismicBillsTrackerDataStatusReceivedImageImageType>
    status_received_subtitle: Maybe<Scalars['String']['output']>
    status_received_title: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusReceivedFieldSelector = {
    image: InputMaybe<PrismicBillsTrackerDataStatusReceivedImageImageTypeFieldSelector>
    status_received_subtitle: InputMaybe<FieldSelectorEnum>
    status_received_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusReceivedFilterInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusReceivedImageImageTypeFilterInput>
    status_received_subtitle: InputMaybe<StringQueryOperatorInput>
    status_received_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusReceivedFilterListInput = {
    elemMatch: InputMaybe<PrismicBillsTrackerDataStatusReceivedFilterInput>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataStatusReceivedImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataStatusReceivedSortInput = {
    image: InputMaybe<PrismicBillsTrackerDataStatusReceivedImageImageTypeSortInput>
    status_received_subtitle: InputMaybe<SortOrderEnum>
    status_received_title: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerDataType = {
    accept_terms_error: Maybe<Scalars['String']['output']>
    allow_indexing: Maybe<Scalars['Boolean']['output']>
    company: Maybe<Scalars['String']['output']>
    customer_logos: Maybe<PrismicLinkType>
    customer_logos_title: Maybe<Scalars['String']['output']>
    error_content: Maybe<Array<Maybe<PrismicBillsTrackerDataErrorContent>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    header_cta: Maybe<Scalars['String']['output']>
    header_cta_link: Maybe<PrismicLinkType>
    header_link: Maybe<PrismicStructuredTextType>
    input_aria_label: Maybe<Scalars['String']['output']>
    input_label: Maybe<Scalars['String']['output']>
    invoice_date: Maybe<Scalars['String']['output']>
    invoice_id: Maybe<Scalars['String']['output']>
    last_edited: Maybe<Scalars['String']['output']>
    marketing_card: Maybe<Array<Maybe<PrismicBillsTrackerDataMarketingCard>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicBillsTrackerDataOpenGraphImageImageType>
    questions: Maybe<Array<Maybe<PrismicBillsTrackerDataQuestions>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_box_placeholder: Maybe<Scalars['String']['output']>
    signup_box_title: Maybe<Scalars['String']['output']>
    signup_success_message: Maybe<PrismicStructuredTextType>
    status_paid: Maybe<Array<Maybe<PrismicBillsTrackerDataStatusPaid>>>
    status_processing: Maybe<Array<Maybe<PrismicBillsTrackerDataStatusProcessing>>>
    status_received: Maybe<Array<Maybe<PrismicBillsTrackerDataStatusReceived>>>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    total_amount: Maybe<Scalars['String']['output']>
}

export type PrismicBillsTrackerDataTypeFieldSelector = {
    accept_terms_error: InputMaybe<FieldSelectorEnum>
    allow_indexing: InputMaybe<FieldSelectorEnum>
    company: InputMaybe<FieldSelectorEnum>
    customer_logos: InputMaybe<PrismicLinkTypeFieldSelector>
    customer_logos_title: InputMaybe<FieldSelectorEnum>
    error_content: InputMaybe<PrismicBillsTrackerDataErrorContentFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    header_cta: InputMaybe<FieldSelectorEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    header_link: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    input_aria_label: InputMaybe<FieldSelectorEnum>
    input_label: InputMaybe<FieldSelectorEnum>
    invoice_date: InputMaybe<FieldSelectorEnum>
    invoice_id: InputMaybe<FieldSelectorEnum>
    last_edited: InputMaybe<FieldSelectorEnum>
    marketing_card: InputMaybe<PrismicBillsTrackerDataMarketingCardFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicBillsTrackerDataOpenGraphImageImageTypeFieldSelector>
    questions: InputMaybe<PrismicBillsTrackerDataQuestionsFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_box_placeholder: InputMaybe<FieldSelectorEnum>
    signup_box_title: InputMaybe<FieldSelectorEnum>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    status_paid: InputMaybe<PrismicBillsTrackerDataStatusPaidFieldSelector>
    status_processing: InputMaybe<PrismicBillsTrackerDataStatusProcessingFieldSelector>
    status_received: InputMaybe<PrismicBillsTrackerDataStatusReceivedFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    total_amount: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerDataTypeFilterInput = {
    accept_terms_error: InputMaybe<StringQueryOperatorInput>
    allow_indexing: InputMaybe<BooleanQueryOperatorInput>
    company: InputMaybe<StringQueryOperatorInput>
    customer_logos: InputMaybe<PrismicLinkTypeFilterInput>
    customer_logos_title: InputMaybe<StringQueryOperatorInput>
    error_content: InputMaybe<PrismicBillsTrackerDataErrorContentFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    header_cta: InputMaybe<StringQueryOperatorInput>
    header_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    header_link: InputMaybe<PrismicStructuredTextTypeFilterInput>
    input_aria_label: InputMaybe<StringQueryOperatorInput>
    input_label: InputMaybe<StringQueryOperatorInput>
    invoice_date: InputMaybe<StringQueryOperatorInput>
    invoice_id: InputMaybe<StringQueryOperatorInput>
    last_edited: InputMaybe<StringQueryOperatorInput>
    marketing_card: InputMaybe<PrismicBillsTrackerDataMarketingCardFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicBillsTrackerDataOpenGraphImageImageTypeFilterInput>
    questions: InputMaybe<PrismicBillsTrackerDataQuestionsFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_box_placeholder: InputMaybe<StringQueryOperatorInput>
    signup_box_title: InputMaybe<StringQueryOperatorInput>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    status_paid: InputMaybe<PrismicBillsTrackerDataStatusPaidFilterListInput>
    status_processing: InputMaybe<PrismicBillsTrackerDataStatusProcessingFilterListInput>
    status_received: InputMaybe<PrismicBillsTrackerDataStatusReceivedFilterListInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    total_amount: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerDataTypeSortInput = {
    accept_terms_error: InputMaybe<SortOrderEnum>
    allow_indexing: InputMaybe<SortOrderEnum>
    company: InputMaybe<SortOrderEnum>
    customer_logos: InputMaybe<PrismicLinkTypeSortInput>
    customer_logos_title: InputMaybe<SortOrderEnum>
    error_content: InputMaybe<PrismicBillsTrackerDataErrorContentSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    header_cta: InputMaybe<SortOrderEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    header_link: InputMaybe<PrismicStructuredTextTypeSortInput>
    input_aria_label: InputMaybe<SortOrderEnum>
    input_label: InputMaybe<SortOrderEnum>
    invoice_date: InputMaybe<SortOrderEnum>
    invoice_id: InputMaybe<SortOrderEnum>
    last_edited: InputMaybe<SortOrderEnum>
    marketing_card: InputMaybe<PrismicBillsTrackerDataMarketingCardSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicBillsTrackerDataOpenGraphImageImageTypeSortInput>
    questions: InputMaybe<PrismicBillsTrackerDataQuestionsSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_box_placeholder: InputMaybe<SortOrderEnum>
    signup_box_title: InputMaybe<SortOrderEnum>
    signup_success_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    status_paid: InputMaybe<PrismicBillsTrackerDataStatusPaidSortInput>
    status_processing: InputMaybe<PrismicBillsTrackerDataStatusProcessingSortInput>
    status_received: InputMaybe<PrismicBillsTrackerDataStatusReceivedSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    total_amount: InputMaybe<SortOrderEnum>
}

export type PrismicBillsTrackerEdge = {
    next: Maybe<PrismicBillsTracker>
    node: PrismicBillsTracker
    previous: Maybe<PrismicBillsTracker>
}

export type PrismicBillsTrackerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicBillsTrackerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicBillsTrackerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsTrackerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicBillsTrackerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicBillsTrackerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicBillsTrackerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicBillsTracker>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicBillsTrackerGroupConnectionDistinctArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerGroupConnectionGroupArgs = {
    field: PrismicBillsTrackerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicBillsTrackerGroupConnectionMaxArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerGroupConnectionMinArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerGroupConnectionSumArgs = {
    field: PrismicBillsTrackerFieldSelector
}

export type PrismicBillsTrackerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicBillsTrackerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCalendlyPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCalendlyPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCalendlyPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCalendlyPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCalendlyPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCalendlyPageEdge>
    group: Array<PrismicCalendlyPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCalendlyPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCalendlyPageConnectionDistinctArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageConnectionGroupArgs = {
    field: PrismicCalendlyPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCalendlyPageConnectionMaxArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageConnectionMinArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageConnectionSumArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCalendlyPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCalendlyPageDataRedirectLinks = {
    company_size_1: Maybe<PrismicLinkType>
    company_size_2: Maybe<PrismicLinkType>
    company_size_5: Maybe<PrismicLinkType>
    company_size_10: Maybe<PrismicLinkType>
    company_size_50: Maybe<PrismicLinkType>
    company_size_100: Maybe<PrismicLinkType>
    company_size_250: Maybe<PrismicLinkType>
    company_size_500: Maybe<PrismicLinkType>
    sole_trader: Maybe<PrismicLinkType>
}

export type PrismicCalendlyPageDataRedirectLinksFieldSelector = {
    company_size_1: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_2: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_5: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_10: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_50: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_100: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_250: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_500: InputMaybe<PrismicLinkTypeFieldSelector>
    sole_trader: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicCalendlyPageDataRedirectLinksFilterInput = {
    company_size_1: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_2: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_5: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_10: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_50: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_100: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_250: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_500: InputMaybe<PrismicLinkTypeFilterInput>
    sole_trader: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicCalendlyPageDataRedirectLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicCalendlyPageDataRedirectLinksFilterInput>
}

export type PrismicCalendlyPageDataRedirectLinksSortInput = {
    company_size_1: InputMaybe<PrismicLinkTypeSortInput>
    company_size_2: InputMaybe<PrismicLinkTypeSortInput>
    company_size_5: InputMaybe<PrismicLinkTypeSortInput>
    company_size_10: InputMaybe<PrismicLinkTypeSortInput>
    company_size_50: InputMaybe<PrismicLinkTypeSortInput>
    company_size_100: InputMaybe<PrismicLinkTypeSortInput>
    company_size_250: InputMaybe<PrismicLinkTypeSortInput>
    company_size_500: InputMaybe<PrismicLinkTypeSortInput>
    sole_trader: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicCalendlyPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicCalendlyPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    redirect_links: Maybe<Array<Maybe<PrismicCalendlyPageDataRedirectLinks>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCalendlyPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicCalendlyPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    redirect_links: InputMaybe<PrismicCalendlyPageDataRedirectLinksFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCalendlyPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicCalendlyPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    redirect_links: InputMaybe<PrismicCalendlyPageDataRedirectLinksFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCalendlyPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicCalendlyPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    redirect_links: InputMaybe<PrismicCalendlyPageDataRedirectLinksSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCalendlyPageEdge = {
    next: Maybe<PrismicCalendlyPage>
    node: PrismicCalendlyPage
    previous: Maybe<PrismicCalendlyPage>
}

export type PrismicCalendlyPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCalendlyPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCalendlyPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCalendlyPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCalendlyPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCalendlyPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCalendlyPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCalendlyPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCalendlyPageGroupConnectionDistinctArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageGroupConnectionGroupArgs = {
    field: PrismicCalendlyPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCalendlyPageGroupConnectionMaxArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageGroupConnectionMinArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageGroupConnectionSumArgs = {
    field: PrismicCalendlyPageFieldSelector
}

export type PrismicCalendlyPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCalendlyPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCardCreationFunnel = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCardCreationFunnelDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCardCreationFunnelFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCardCreationFunnelLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCardCreationFunnelConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCardCreationFunnelEdge>
    group: Array<PrismicCardCreationFunnelGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCardCreationFunnel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCardCreationFunnelConnectionDistinctArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelConnectionGroupArgs = {
    field: PrismicCardCreationFunnelFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCardCreationFunnelConnectionMaxArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelConnectionMinArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelConnectionSumArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelDataCardImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCardCreationFunnelDataCardImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCardCreationFunnelDataCardImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCardCreationFunnelDataCardImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCardCreationFunnelDataCardImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCardCreationFunnelDataCardImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCardCreationFunnelDataCardImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCardCreationFunnelDataCardImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCardCreationFunnelDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCardCreationFunnelDataType = {
    card: Maybe<PrismicCardCreationFunnelDataCardImageType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicCardCreationFunnelDataOpenGraphImageImageType>
    title: Maybe<Scalars['String']['output']>
    wizard: Maybe<Array<Maybe<PrismicCardCreationFunnelDataWizard>>>
}

export type PrismicCardCreationFunnelDataTypeFieldSelector = {
    card: InputMaybe<PrismicCardCreationFunnelDataCardImageTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicCardCreationFunnelDataOpenGraphImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    wizard: InputMaybe<PrismicCardCreationFunnelDataWizardFieldSelector>
}

export type PrismicCardCreationFunnelDataTypeFilterInput = {
    card: InputMaybe<PrismicCardCreationFunnelDataCardImageTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicCardCreationFunnelDataOpenGraphImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    wizard: InputMaybe<PrismicCardCreationFunnelDataWizardFilterListInput>
}

export type PrismicCardCreationFunnelDataTypeSortInput = {
    card: InputMaybe<PrismicCardCreationFunnelDataCardImageTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicCardCreationFunnelDataOpenGraphImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    wizard: InputMaybe<PrismicCardCreationFunnelDataWizardSortInput>
}

export type PrismicCardCreationFunnelDataWizard = {
    back: Maybe<Scalars['String']['output']>
    company_email: Maybe<Scalars['String']['output']>
    company_name: Maybe<Scalars['String']['output']>
    company_name_error: Maybe<Scalars['String']['output']>
    company_size: Maybe<Scalars['String']['output']>
    employee: Maybe<Scalars['String']['output']>
    employees: Maybe<Scalars['String']['output']>
    enter_company_name: Maybe<Scalars['String']['output']>
    enter_your_full_name: Maybe<Scalars['String']['output']>
    error_company_size: Maybe<Scalars['String']['output']>
    error_name: Maybe<Scalars['String']['output']>
    full_name: Maybe<Scalars['String']['output']>
    get_started: Maybe<Scalars['String']['output']>
    must_be_company_email: Maybe<Scalars['String']['output']>
    next: Maybe<Scalars['String']['output']>
    of: Maybe<Scalars['String']['output']>
    select: Maybe<Scalars['String']['output']>
    sole_trader: Maybe<Scalars['String']['output']>
    step: Maybe<Scalars['String']['output']>
    terms: Maybe<PrismicStructuredTextType>
    what_your_company_name: Maybe<Scalars['String']['output']>
    whats_your_company_size: Maybe<Scalars['String']['output']>
    whats_your_email: Maybe<Scalars['String']['output']>
    whats_your_name: Maybe<Scalars['String']['output']>
}

export type PrismicCardCreationFunnelDataWizardFieldSelector = {
    back: InputMaybe<FieldSelectorEnum>
    company_email: InputMaybe<FieldSelectorEnum>
    company_name: InputMaybe<FieldSelectorEnum>
    company_name_error: InputMaybe<FieldSelectorEnum>
    company_size: InputMaybe<FieldSelectorEnum>
    employee: InputMaybe<FieldSelectorEnum>
    employees: InputMaybe<FieldSelectorEnum>
    enter_company_name: InputMaybe<FieldSelectorEnum>
    enter_your_full_name: InputMaybe<FieldSelectorEnum>
    error_company_size: InputMaybe<FieldSelectorEnum>
    error_name: InputMaybe<FieldSelectorEnum>
    full_name: InputMaybe<FieldSelectorEnum>
    get_started: InputMaybe<FieldSelectorEnum>
    must_be_company_email: InputMaybe<FieldSelectorEnum>
    next: InputMaybe<FieldSelectorEnum>
    of: InputMaybe<FieldSelectorEnum>
    select: InputMaybe<FieldSelectorEnum>
    sole_trader: InputMaybe<FieldSelectorEnum>
    step: InputMaybe<FieldSelectorEnum>
    terms: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    what_your_company_name: InputMaybe<FieldSelectorEnum>
    whats_your_company_size: InputMaybe<FieldSelectorEnum>
    whats_your_email: InputMaybe<FieldSelectorEnum>
    whats_your_name: InputMaybe<FieldSelectorEnum>
}

export type PrismicCardCreationFunnelDataWizardFilterInput = {
    back: InputMaybe<StringQueryOperatorInput>
    company_email: InputMaybe<StringQueryOperatorInput>
    company_name: InputMaybe<StringQueryOperatorInput>
    company_name_error: InputMaybe<StringQueryOperatorInput>
    company_size: InputMaybe<StringQueryOperatorInput>
    employee: InputMaybe<StringQueryOperatorInput>
    employees: InputMaybe<StringQueryOperatorInput>
    enter_company_name: InputMaybe<StringQueryOperatorInput>
    enter_your_full_name: InputMaybe<StringQueryOperatorInput>
    error_company_size: InputMaybe<StringQueryOperatorInput>
    error_name: InputMaybe<StringQueryOperatorInput>
    full_name: InputMaybe<StringQueryOperatorInput>
    get_started: InputMaybe<StringQueryOperatorInput>
    must_be_company_email: InputMaybe<StringQueryOperatorInput>
    next: InputMaybe<StringQueryOperatorInput>
    of: InputMaybe<StringQueryOperatorInput>
    select: InputMaybe<StringQueryOperatorInput>
    sole_trader: InputMaybe<StringQueryOperatorInput>
    step: InputMaybe<StringQueryOperatorInput>
    terms: InputMaybe<PrismicStructuredTextTypeFilterInput>
    what_your_company_name: InputMaybe<StringQueryOperatorInput>
    whats_your_company_size: InputMaybe<StringQueryOperatorInput>
    whats_your_email: InputMaybe<StringQueryOperatorInput>
    whats_your_name: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCardCreationFunnelDataWizardFilterListInput = {
    elemMatch: InputMaybe<PrismicCardCreationFunnelDataWizardFilterInput>
}

export type PrismicCardCreationFunnelDataWizardSortInput = {
    back: InputMaybe<SortOrderEnum>
    company_email: InputMaybe<SortOrderEnum>
    company_name: InputMaybe<SortOrderEnum>
    company_name_error: InputMaybe<SortOrderEnum>
    company_size: InputMaybe<SortOrderEnum>
    employee: InputMaybe<SortOrderEnum>
    employees: InputMaybe<SortOrderEnum>
    enter_company_name: InputMaybe<SortOrderEnum>
    enter_your_full_name: InputMaybe<SortOrderEnum>
    error_company_size: InputMaybe<SortOrderEnum>
    error_name: InputMaybe<SortOrderEnum>
    full_name: InputMaybe<SortOrderEnum>
    get_started: InputMaybe<SortOrderEnum>
    must_be_company_email: InputMaybe<SortOrderEnum>
    next: InputMaybe<SortOrderEnum>
    of: InputMaybe<SortOrderEnum>
    select: InputMaybe<SortOrderEnum>
    sole_trader: InputMaybe<SortOrderEnum>
    step: InputMaybe<SortOrderEnum>
    terms: InputMaybe<PrismicStructuredTextTypeSortInput>
    what_your_company_name: InputMaybe<SortOrderEnum>
    whats_your_company_size: InputMaybe<SortOrderEnum>
    whats_your_email: InputMaybe<SortOrderEnum>
    whats_your_name: InputMaybe<SortOrderEnum>
}

export type PrismicCardCreationFunnelEdge = {
    next: Maybe<PrismicCardCreationFunnel>
    node: PrismicCardCreationFunnel
    previous: Maybe<PrismicCardCreationFunnel>
}

export type PrismicCardCreationFunnelFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCardCreationFunnelDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCardCreationFunnelFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCardCreationFunnelDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCardCreationFunnelGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCardCreationFunnelEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCardCreationFunnelGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCardCreationFunnel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCardCreationFunnelGroupConnectionDistinctArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelGroupConnectionGroupArgs = {
    field: PrismicCardCreationFunnelFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCardCreationFunnelGroupConnectionMaxArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelGroupConnectionMinArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelGroupConnectionSumArgs = {
    field: PrismicCardCreationFunnelFieldSelector
}

export type PrismicCardCreationFunnelSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCardCreationFunnelDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCareersPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCareersPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCareersPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCareersPageEdge>
    group: Array<PrismicCareersPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCareersPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCareersPageConnectionDistinctArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageConnectionGroupArgs = {
    field: PrismicCareersPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageConnectionMaxArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageConnectionMinArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageConnectionSumArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageDataFlexBenefits = {
    body: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicCareersPageDataFlexBenefitsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataFlexBenefitsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_label: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    image: InputMaybe<PrismicCareersPageDataFlexBenefitsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataFlexBenefitsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_label: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    image: InputMaybe<PrismicCareersPageDataFlexBenefitsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataFlexBenefitsFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataFlexBenefitsFilterInput>
}

export type PrismicCareersPageDataFlexBenefitsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataFlexBenefitsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataFlexBenefitsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_label: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    image: InputMaybe<PrismicCareersPageDataFlexBenefitsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataFundamentals = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicCareersPageDataFundamentalsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataFundamentalsFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicCareersPageDataFundamentalsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataFundamentalsFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicCareersPageDataFundamentalsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataFundamentalsFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataFundamentalsFilterInput>
}

export type PrismicCareersPageDataFundamentalsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataFundamentalsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataFundamentalsSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicCareersPageDataFundamentalsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicCareersPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicCareersPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicCareersPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataHeroFilterInput>
}

export type PrismicCareersPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicCareersPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataListings = {
    all_listings_cta_link: Maybe<PrismicLinkType>
    all_listings_cta_text: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    sub_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataListingsFieldSelector = {
    all_listings_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    all_listings_cta_text: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    sub_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataListingsFilterInput = {
    all_listings_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    all_listings_cta_text: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    sub_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataListingsFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataListingsFilterInput>
}

export type PrismicCareersPageDataListingsSortInput = {
    all_listings_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    all_listings_cta_text: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    sub_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataLocation = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicCareersPageDataLocationImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataLocationFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicCareersPageDataLocationImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataLocationFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicCareersPageDataLocationImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataLocationFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataLocationFilterInput>
}

export type PrismicCareersPageDataLocationImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataLocationImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataLocationImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataLocationImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataLocationImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataLocationImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataLocationImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataLocationImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataLocationSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicCareersPageDataLocationImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataMeetTheTeam = {
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicCareersPageDataMeetTheTeamVideoThumbnailImageType>
}

export type PrismicCareersPageDataMeetTheTeamFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
    video_thumbnail: InputMaybe<PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFieldSelector>
}

export type PrismicCareersPageDataMeetTheTeamFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
    video_thumbnail: InputMaybe<PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFilterInput>
}

export type PrismicCareersPageDataMeetTheTeamFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataMeetTheTeamFilterInput>
}

export type PrismicCareersPageDataMeetTheTeamSortInput = {
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
    video_thumbnail: InputMaybe<PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeSortInput>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataMeetTheTeamVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageDataQuotes = {
    quote: Maybe<PrismicLinkType>
}

export type PrismicCareersPageDataQuotesFieldSelector = {
    quote: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicCareersPageDataQuotesFilterInput = {
    quote: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicCareersPageDataQuotesFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataQuotesFilterInput>
}

export type PrismicCareersPageDataQuotesSortInput = {
    quote: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicCareersPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    flex_benefits: Maybe<Array<Maybe<PrismicCareersPageDataFlexBenefits>>>
    fundamentals: Maybe<Array<Maybe<PrismicCareersPageDataFundamentals>>>
    fundamentals_title: Maybe<Scalars['String']['output']>
    hero: Maybe<Array<Maybe<PrismicCareersPageDataHero>>>
    listings: Maybe<Array<Maybe<PrismicCareersPageDataListings>>>
    location: Maybe<Array<Maybe<PrismicCareersPageDataLocation>>>
    location_title: Maybe<Scalars['String']['output']>
    meet_the_team: Maybe<Array<Maybe<PrismicCareersPageDataMeetTheTeam>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicCareersPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    quotes: Maybe<Array<Maybe<PrismicCareersPageDataQuotes>>>
    wish_you_were_here: Maybe<Array<Maybe<PrismicCareersPageDataWishYouWereHere>>>
}

export type PrismicCareersPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    flex_benefits: InputMaybe<PrismicCareersPageDataFlexBenefitsFieldSelector>
    fundamentals: InputMaybe<PrismicCareersPageDataFundamentalsFieldSelector>
    fundamentals_title: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicCareersPageDataHeroFieldSelector>
    listings: InputMaybe<PrismicCareersPageDataListingsFieldSelector>
    location: InputMaybe<PrismicCareersPageDataLocationFieldSelector>
    location_title: InputMaybe<FieldSelectorEnum>
    meet_the_team: InputMaybe<PrismicCareersPageDataMeetTheTeamFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicCareersPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    quotes: InputMaybe<PrismicCareersPageDataQuotesFieldSelector>
    wish_you_were_here: InputMaybe<PrismicCareersPageDataWishYouWereHereFieldSelector>
}

export type PrismicCareersPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    flex_benefits: InputMaybe<PrismicCareersPageDataFlexBenefitsFilterListInput>
    fundamentals: InputMaybe<PrismicCareersPageDataFundamentalsFilterListInput>
    fundamentals_title: InputMaybe<StringQueryOperatorInput>
    hero: InputMaybe<PrismicCareersPageDataHeroFilterListInput>
    listings: InputMaybe<PrismicCareersPageDataListingsFilterListInput>
    location: InputMaybe<PrismicCareersPageDataLocationFilterListInput>
    location_title: InputMaybe<StringQueryOperatorInput>
    meet_the_team: InputMaybe<PrismicCareersPageDataMeetTheTeamFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicCareersPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    quotes: InputMaybe<PrismicCareersPageDataQuotesFilterListInput>
    wish_you_were_here: InputMaybe<PrismicCareersPageDataWishYouWereHereFilterListInput>
}

export type PrismicCareersPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    flex_benefits: InputMaybe<PrismicCareersPageDataFlexBenefitsSortInput>
    fundamentals: InputMaybe<PrismicCareersPageDataFundamentalsSortInput>
    fundamentals_title: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicCareersPageDataHeroSortInput>
    listings: InputMaybe<PrismicCareersPageDataListingsSortInput>
    location: InputMaybe<PrismicCareersPageDataLocationSortInput>
    location_title: InputMaybe<SortOrderEnum>
    meet_the_team: InputMaybe<PrismicCareersPageDataMeetTheTeamSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicCareersPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    quotes: InputMaybe<PrismicCareersPageDataQuotesSortInput>
    wish_you_were_here: InputMaybe<PrismicCareersPageDataWishYouWereHereSortInput>
}

export type PrismicCareersPageDataWishYouWereHere = {
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicCareersPageDataWishYouWereHereVideoThumbnailImageType>
}

export type PrismicCareersPageDataWishYouWereHereFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
    video_thumbnail: InputMaybe<PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFieldSelector>
}

export type PrismicCareersPageDataWishYouWereHereFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
    video_thumbnail: InputMaybe<PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFilterInput>
}

export type PrismicCareersPageDataWishYouWereHereFilterListInput = {
    elemMatch: InputMaybe<PrismicCareersPageDataWishYouWereHereFilterInput>
}

export type PrismicCareersPageDataWishYouWereHereSortInput = {
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
    video_thumbnail: InputMaybe<PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeSortInput>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageDataWishYouWereHereVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCareersPageEdge = {
    next: Maybe<PrismicCareersPage>
    node: PrismicCareersPage
    previous: Maybe<PrismicCareersPage>
}

export type PrismicCareersPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCareersPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCareersPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCareersPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCareersPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCareersPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCareersPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCareersPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCareersPageGroupConnectionDistinctArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageGroupConnectionGroupArgs = {
    field: PrismicCareersPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCareersPageGroupConnectionMaxArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageGroupConnectionMinArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageGroupConnectionSumArgs = {
    field: PrismicCareersPageFieldSelector
}

export type PrismicCareersPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCareersPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCarousel = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCarouselDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCarouselFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCarouselLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCarouselConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCarouselEdge>
    group: Array<PrismicCarouselGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCarousel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCarouselConnectionDistinctArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselConnectionGroupArgs = {
    field: PrismicCarouselFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCarouselConnectionMaxArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselConnectionMinArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselConnectionSumArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselDataItems = {
    heading: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicCarouselDataItemsImageImageType>
    link: Maybe<PrismicLinkType>
}

export type PrismicCarouselDataItemsFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicCarouselDataItemsImageImageTypeFieldSelector>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicCarouselDataItemsFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicCarouselDataItemsImageImageTypeFilterInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicCarouselDataItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicCarouselDataItemsFilterInput>
}

export type PrismicCarouselDataItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCarouselDataItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCarouselDataItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCarouselDataItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCarouselDataItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCarouselDataItemsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCarouselDataItemsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCarouselDataItemsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCarouselDataItemsSortInput = {
    heading: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicCarouselDataItemsImageImageTypeSortInput>
    link: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicCarouselDataType = {
    exclude_production: Maybe<Scalars['Boolean']['output']>
    items: Maybe<Array<Maybe<PrismicCarouselDataItems>>>
}

export type PrismicCarouselDataTypeFieldSelector = {
    exclude_production: InputMaybe<FieldSelectorEnum>
    items: InputMaybe<PrismicCarouselDataItemsFieldSelector>
}

export type PrismicCarouselDataTypeFilterInput = {
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    items: InputMaybe<PrismicCarouselDataItemsFilterListInput>
}

export type PrismicCarouselDataTypeSortInput = {
    exclude_production: InputMaybe<SortOrderEnum>
    items: InputMaybe<PrismicCarouselDataItemsSortInput>
}

export type PrismicCarouselEdge = {
    next: Maybe<PrismicCarousel>
    node: PrismicCarousel
    previous: Maybe<PrismicCarousel>
}

export type PrismicCarouselFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCarouselDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCarouselFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCarouselDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCarouselGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCarouselEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCarouselGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCarousel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCarouselGroupConnectionDistinctArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselGroupConnectionGroupArgs = {
    field: PrismicCarouselFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCarouselGroupConnectionMaxArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselGroupConnectionMinArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselGroupConnectionSumArgs = {
    field: PrismicCarouselFieldSelector
}

export type PrismicCarouselSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCarouselDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCashbackCalculatorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCashbackCalculatorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCashbackCalculatorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCashbackCalculatorEdge>
    group: Array<PrismicCashbackCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCashbackCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCashbackCalculatorConnectionDistinctArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorConnectionGroupArgs = {
    field: PrismicCashbackCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorConnectionMaxArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorConnectionMinArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorConnectionSumArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorDataMonthlySpend = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicCashbackCalculatorDataMonthlySpendHighIconImageType>
    low_icon: Maybe<PrismicCashbackCalculatorDataMonthlySpendLowIconImageType>
    medium_icon: Maybe<PrismicCashbackCalculatorDataMonthlySpendMediumIconImageType>
    subheading: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataMonthlySpendFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFieldSelector>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFieldSelector>
    subheading: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFilterInput>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFilterInput>
    subheading: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendFilterListInput = {
    elemMatch: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendFilterInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataMonthlySpendSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendHighIconImageTypeSortInput>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendMediumIconImageTypeSortInput>
    subheading: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployees = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageType>
    low_icon: Maybe<PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageType>
    medium_icon: Maybe<PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageType>
    subheading: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFieldSelector>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFieldSelector>
    subheading: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFilterInput>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFilterInput>
    subheading: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesFilterListInput = {
    elemMatch: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesFilterInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataNumOfEmployeesSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesHighIconImageTypeSortInput>
    low_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesMediumIconImageTypeSortInput>
    subheading: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorDataType = {
    cta_text: Maybe<Scalars['String']['output']>
    monthly_spend: Maybe<Array<Maybe<PrismicCashbackCalculatorDataMonthlySpend>>>
    num_of_employees: Maybe<Array<Maybe<PrismicCashbackCalculatorDataNumOfEmployees>>>
    results_line_cashback: Maybe<Scalars['String']['output']>
    results_subheading: Maybe<Scalars['String']['output']>
    results_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCashbackCalculatorDataTypeFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    monthly_spend: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendFieldSelector>
    num_of_employees: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesFieldSelector>
    results_line_cashback: InputMaybe<FieldSelectorEnum>
    results_subheading: InputMaybe<FieldSelectorEnum>
    results_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorDataTypeFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    monthly_spend: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendFilterListInput>
    num_of_employees: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesFilterListInput>
    results_line_cashback: InputMaybe<StringQueryOperatorInput>
    results_subheading: InputMaybe<StringQueryOperatorInput>
    results_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorDataTypeSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    monthly_spend: InputMaybe<PrismicCashbackCalculatorDataMonthlySpendSortInput>
    num_of_employees: InputMaybe<PrismicCashbackCalculatorDataNumOfEmployeesSortInput>
    results_line_cashback: InputMaybe<SortOrderEnum>
    results_subheading: InputMaybe<SortOrderEnum>
    results_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCashbackCalculatorEdge = {
    next: Maybe<PrismicCashbackCalculator>
    node: PrismicCashbackCalculator
    previous: Maybe<PrismicCashbackCalculator>
}

export type PrismicCashbackCalculatorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCashbackCalculatorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCashbackCalculatorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCashbackCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCashbackCalculatorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCashbackCalculatorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCashbackCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCashbackCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCashbackCalculatorGroupConnectionDistinctArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorGroupConnectionGroupArgs = {
    field: PrismicCashbackCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCashbackCalculatorGroupConnectionMaxArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorGroupConnectionMinArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorGroupConnectionSumArgs = {
    field: PrismicCashbackCalculatorFieldSelector
}

export type PrismicCashbackCalculatorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCashbackCalculatorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicComaprisonTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicComaprisonTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicComaprisonTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicComaprisonTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicComaprisonTableEdge>
    group: Array<PrismicComaprisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicComaprisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicComaprisonTableConnectionDistinctArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableConnectionGroupArgs = {
    field: PrismicComaprisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicComaprisonTableConnectionMaxArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableConnectionMinArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableConnectionSumArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableEdge = {
    next: Maybe<PrismicComaprisonTable>
    node: PrismicComaprisonTable
    previous: Maybe<PrismicComaprisonTable>
}

export type PrismicComaprisonTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicComaprisonTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicComaprisonTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicComaprisonTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicComaprisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicComaprisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicComaprisonTableGroupConnectionDistinctArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableGroupConnectionGroupArgs = {
    field: PrismicComaprisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicComaprisonTableGroupConnectionMaxArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableGroupConnectionMinArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableGroupConnectionSumArgs = {
    field: PrismicComaprisonTableFieldSelector
}

export type PrismicComaprisonTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicComparisonTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicComparisonTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicComparisonTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicComparisonTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicComparisonTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicComparisonTableEdge>
    group: Array<PrismicComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicComparisonTableConnectionDistinctArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableConnectionGroupArgs = {
    field: PrismicComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicComparisonTableConnectionMaxArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableConnectionMinArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableConnectionSumArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableDataRows = {
    corporate_cards: Maybe<Scalars['Boolean']['output']>
    corporate_cards_expense_software: Maybe<Scalars['Boolean']['output']>
    expense_software: Maybe<Scalars['Boolean']['output']>
    feature: Maybe<Scalars['String']['output']>
    feature_subtext: Maybe<Scalars['String']['output']>
    pleo: Maybe<Scalars['Boolean']['output']>
}

export type PrismicComparisonTableDataRowsFieldSelector = {
    corporate_cards: InputMaybe<FieldSelectorEnum>
    corporate_cards_expense_software: InputMaybe<FieldSelectorEnum>
    expense_software: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    feature_subtext: InputMaybe<FieldSelectorEnum>
    pleo: InputMaybe<FieldSelectorEnum>
}

export type PrismicComparisonTableDataRowsFilterInput = {
    corporate_cards: InputMaybe<BooleanQueryOperatorInput>
    corporate_cards_expense_software: InputMaybe<BooleanQueryOperatorInput>
    expense_software: InputMaybe<BooleanQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    feature_subtext: InputMaybe<StringQueryOperatorInput>
    pleo: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicComparisonTableDataRowsFilterListInput = {
    elemMatch: InputMaybe<PrismicComparisonTableDataRowsFilterInput>
}

export type PrismicComparisonTableDataRowsSortInput = {
    corporate_cards: InputMaybe<SortOrderEnum>
    corporate_cards_expense_software: InputMaybe<SortOrderEnum>
    expense_software: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    feature_subtext: InputMaybe<SortOrderEnum>
    pleo: InputMaybe<SortOrderEnum>
}

export type PrismicComparisonTableDataType = {
    category: Maybe<Scalars['String']['output']>
    corporate_cards_expense_software_heading: Maybe<Scalars['String']['output']>
    corporate_cards_heading: Maybe<Scalars['String']['output']>
    expense_software_heading: Maybe<Scalars['String']['output']>
    no_value: Maybe<Scalars['String']['output']>
    pleo_heading: Maybe<Scalars['String']['output']>
    rows: Maybe<Array<Maybe<PrismicComparisonTableDataRows>>>
    title: Maybe<Scalars['String']['output']>
    yes_value: Maybe<Scalars['String']['output']>
}

export type PrismicComparisonTableDataTypeFieldSelector = {
    category: InputMaybe<FieldSelectorEnum>
    corporate_cards_expense_software_heading: InputMaybe<FieldSelectorEnum>
    corporate_cards_heading: InputMaybe<FieldSelectorEnum>
    expense_software_heading: InputMaybe<FieldSelectorEnum>
    no_value: InputMaybe<FieldSelectorEnum>
    pleo_heading: InputMaybe<FieldSelectorEnum>
    rows: InputMaybe<PrismicComparisonTableDataRowsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    yes_value: InputMaybe<FieldSelectorEnum>
}

export type PrismicComparisonTableDataTypeFilterInput = {
    category: InputMaybe<StringQueryOperatorInput>
    corporate_cards_expense_software_heading: InputMaybe<StringQueryOperatorInput>
    corporate_cards_heading: InputMaybe<StringQueryOperatorInput>
    expense_software_heading: InputMaybe<StringQueryOperatorInput>
    no_value: InputMaybe<StringQueryOperatorInput>
    pleo_heading: InputMaybe<StringQueryOperatorInput>
    rows: InputMaybe<PrismicComparisonTableDataRowsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
    yes_value: InputMaybe<StringQueryOperatorInput>
}

export type PrismicComparisonTableDataTypeSortInput = {
    category: InputMaybe<SortOrderEnum>
    corporate_cards_expense_software_heading: InputMaybe<SortOrderEnum>
    corporate_cards_heading: InputMaybe<SortOrderEnum>
    expense_software_heading: InputMaybe<SortOrderEnum>
    no_value: InputMaybe<SortOrderEnum>
    pleo_heading: InputMaybe<SortOrderEnum>
    rows: InputMaybe<PrismicComparisonTableDataRowsSortInput>
    title: InputMaybe<SortOrderEnum>
    yes_value: InputMaybe<SortOrderEnum>
}

export type PrismicComparisonTableEdge = {
    next: Maybe<PrismicComparisonTable>
    node: PrismicComparisonTable
    previous: Maybe<PrismicComparisonTable>
}

export type PrismicComparisonTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicComparisonTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicComparisonTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicComparisonTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicComparisonTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicComparisonTableGroupConnectionDistinctArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableGroupConnectionGroupArgs = {
    field: PrismicComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicComparisonTableGroupConnectionMaxArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableGroupConnectionMinArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableGroupConnectionSumArgs = {
    field: PrismicComparisonTableFieldSelector
}

export type PrismicComparisonTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicComparisonTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieBanner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCookieBannerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieBannerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieBannerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieBannerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieBannerEdge>
    group: Array<PrismicCookieBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieBannerConnectionDistinctArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerConnectionGroupArgs = {
    field: PrismicCookieBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieBannerConnectionMaxArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerConnectionMinArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerConnectionSumArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerDataModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieBannerDataModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieBannerDataModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCookieBannerDataModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCookieBannerDataModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCookieBannerDataModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieBannerDataModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieBannerDataModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieBannerDataType = {
    ads_disclaimer: Maybe<PrismicStructuredTextType>
    always_on_label: Maybe<Scalars['String']['output']>
    banner_body: Maybe<PrismicStructuredTextType>
    banner_button_accept: Maybe<PrismicStructuredTextType>
    body: Maybe<PrismicStructuredTextType>
    dismiss_text: Maybe<Scalars['String']['output']>
    manage_cookies_modal_link: Maybe<PrismicStructuredTextType>
    modal_cancel_button: Maybe<Scalars['String']['output']>
    modal_image: Maybe<PrismicCookieBannerDataModalImageImageType>
    modal_save_changes_button: Maybe<Scalars['String']['output']>
    modal_title: Maybe<PrismicStructuredTextType>
    necessary_cookies_disclaimer: Maybe<PrismicStructuredTextType>
    necessary_cookies_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    tracking_categories: Maybe<Scalars['String']['output']>
}

export type PrismicCookieBannerDataTypeFieldSelector = {
    ads_disclaimer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    always_on_label: InputMaybe<FieldSelectorEnum>
    banner_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    banner_button_accept: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    dismiss_text: InputMaybe<FieldSelectorEnum>
    manage_cookies_modal_link: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    modal_cancel_button: InputMaybe<FieldSelectorEnum>
    modal_image: InputMaybe<PrismicCookieBannerDataModalImageImageTypeFieldSelector>
    modal_save_changes_button: InputMaybe<FieldSelectorEnum>
    modal_title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    necessary_cookies_disclaimer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    necessary_cookies_label: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    tracking_categories: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieBannerDataTypeFilterInput = {
    ads_disclaimer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    always_on_label: InputMaybe<StringQueryOperatorInput>
    banner_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    banner_button_accept: InputMaybe<PrismicStructuredTextTypeFilterInput>
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    dismiss_text: InputMaybe<StringQueryOperatorInput>
    manage_cookies_modal_link: InputMaybe<PrismicStructuredTextTypeFilterInput>
    modal_cancel_button: InputMaybe<StringQueryOperatorInput>
    modal_image: InputMaybe<PrismicCookieBannerDataModalImageImageTypeFilterInput>
    modal_save_changes_button: InputMaybe<StringQueryOperatorInput>
    modal_title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    necessary_cookies_disclaimer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    necessary_cookies_label: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    tracking_categories: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieBannerDataTypeSortInput = {
    ads_disclaimer: InputMaybe<PrismicStructuredTextTypeSortInput>
    always_on_label: InputMaybe<SortOrderEnum>
    banner_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    banner_button_accept: InputMaybe<PrismicStructuredTextTypeSortInput>
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    dismiss_text: InputMaybe<SortOrderEnum>
    manage_cookies_modal_link: InputMaybe<PrismicStructuredTextTypeSortInput>
    modal_cancel_button: InputMaybe<SortOrderEnum>
    modal_image: InputMaybe<PrismicCookieBannerDataModalImageImageTypeSortInput>
    modal_save_changes_button: InputMaybe<SortOrderEnum>
    modal_title: InputMaybe<PrismicStructuredTextTypeSortInput>
    necessary_cookies_disclaimer: InputMaybe<PrismicStructuredTextTypeSortInput>
    necessary_cookies_label: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    tracking_categories: InputMaybe<SortOrderEnum>
}

export type PrismicCookieBannerEdge = {
    next: Maybe<PrismicCookieBanner>
    node: PrismicCookieBanner
    previous: Maybe<PrismicCookieBanner>
}

export type PrismicCookieBannerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCookieBannerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieBannerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieBannerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieBannerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCookieBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieBannerGroupConnectionDistinctArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerGroupConnectionGroupArgs = {
    field: PrismicCookieBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieBannerGroupConnectionMaxArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerGroupConnectionMinArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerGroupConnectionSumArgs = {
    field: PrismicCookieBannerFieldSelector
}

export type PrismicCookieBannerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCookieBannerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieCategory = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCookieCategoryDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieCategoryFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieCategoryLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieCategoryConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieCategoryEdge>
    group: Array<PrismicCookieCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieCategoryConnectionDistinctArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryConnectionGroupArgs = {
    field: PrismicCookieCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieCategoryConnectionMaxArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryConnectionMinArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryConnectionSumArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryDataCookies = {
    cookie_id: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    is_segment_cookie: Maybe<Scalars['Boolean']['output']>
    name: Maybe<Scalars['String']['output']>
    origin: Maybe<Scalars['String']['output']>
    purpose: Maybe<Scalars['String']['output']>
    segment_destination_id: Maybe<Scalars['String']['output']>
}

export type PrismicCookieCategoryDataCookiesFieldSelector = {
    cookie_id: InputMaybe<FieldSelectorEnum>
    duration: InputMaybe<FieldSelectorEnum>
    is_segment_cookie: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    origin: InputMaybe<FieldSelectorEnum>
    purpose: InputMaybe<FieldSelectorEnum>
    segment_destination_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieCategoryDataCookiesFilterInput = {
    cookie_id: InputMaybe<StringQueryOperatorInput>
    duration: InputMaybe<StringQueryOperatorInput>
    is_segment_cookie: InputMaybe<BooleanQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    origin: InputMaybe<StringQueryOperatorInput>
    purpose: InputMaybe<StringQueryOperatorInput>
    segment_destination_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieCategoryDataCookiesFilterListInput = {
    elemMatch: InputMaybe<PrismicCookieCategoryDataCookiesFilterInput>
}

export type PrismicCookieCategoryDataCookiesSortInput = {
    cookie_id: InputMaybe<SortOrderEnum>
    duration: InputMaybe<SortOrderEnum>
    is_segment_cookie: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    origin: InputMaybe<SortOrderEnum>
    purpose: InputMaybe<SortOrderEnum>
    segment_destination_id: InputMaybe<SortOrderEnum>
}

export type PrismicCookieCategoryDataType = {
    banner_title: Maybe<Scalars['String']['output']>
    cookies: Maybe<Array<Maybe<PrismicCookieCategoryDataCookies>>>
    description: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    toggle_text: Maybe<Scalars['String']['output']>
}

export type PrismicCookieCategoryDataTypeFieldSelector = {
    banner_title: InputMaybe<FieldSelectorEnum>
    cookies: InputMaybe<PrismicCookieCategoryDataCookiesFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    toggle_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieCategoryDataTypeFilterInput = {
    banner_title: InputMaybe<StringQueryOperatorInput>
    cookies: InputMaybe<PrismicCookieCategoryDataCookiesFilterListInput>
    description: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    toggle_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieCategoryDataTypeSortInput = {
    banner_title: InputMaybe<SortOrderEnum>
    cookies: InputMaybe<PrismicCookieCategoryDataCookiesSortInput>
    description: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    toggle_text: InputMaybe<SortOrderEnum>
}

export type PrismicCookieCategoryEdge = {
    next: Maybe<PrismicCookieCategory>
    node: PrismicCookieCategory
    previous: Maybe<PrismicCookieCategory>
}

export type PrismicCookieCategoryFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCookieCategoryDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieCategoryFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieCategoryGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieCategoryEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCookieCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieCategoryGroupConnectionDistinctArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryGroupConnectionGroupArgs = {
    field: PrismicCookieCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieCategoryGroupConnectionMaxArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryGroupConnectionMinArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategoryGroupConnectionSumArgs = {
    field: PrismicCookieCategoryFieldSelector
}

export type PrismicCookieCategorySortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCookieCategoryDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieManager = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCookieManagerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieManagerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieManagerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieManagerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieManagerEdge>
    group: Array<PrismicCookieManagerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieManager>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieManagerConnectionDistinctArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerConnectionGroupArgs = {
    field: PrismicCookieManagerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieManagerConnectionMaxArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerConnectionMinArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerConnectionSumArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerDataCookieCategories = {
    functional_cookies: Maybe<PrismicLinkType>
    marketing_cookies: Maybe<PrismicLinkType>
    necessary_cookies: Maybe<PrismicLinkType>
    performance_cookies: Maybe<PrismicLinkType>
}

export type PrismicCookieManagerDataCookieCategoriesFieldSelector = {
    functional_cookies: InputMaybe<PrismicLinkTypeFieldSelector>
    marketing_cookies: InputMaybe<PrismicLinkTypeFieldSelector>
    necessary_cookies: InputMaybe<PrismicLinkTypeFieldSelector>
    performance_cookies: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicCookieManagerDataCookieCategoriesFilterInput = {
    functional_cookies: InputMaybe<PrismicLinkTypeFilterInput>
    marketing_cookies: InputMaybe<PrismicLinkTypeFilterInput>
    necessary_cookies: InputMaybe<PrismicLinkTypeFilterInput>
    performance_cookies: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicCookieManagerDataCookieCategoriesFilterListInput = {
    elemMatch: InputMaybe<PrismicCookieManagerDataCookieCategoriesFilterInput>
}

export type PrismicCookieManagerDataCookieCategoriesSortInput = {
    functional_cookies: InputMaybe<PrismicLinkTypeSortInput>
    marketing_cookies: InputMaybe<PrismicLinkTypeSortInput>
    necessary_cookies: InputMaybe<PrismicLinkTypeSortInput>
    performance_cookies: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicCookieManagerDataType = {
    accept_all_cookies_success_message: Maybe<Scalars['String']['output']>
    accept_cookies_text: Maybe<Scalars['String']['output']>
    cookie_categories: Maybe<Array<Maybe<PrismicCookieManagerDataCookieCategories>>>
    cookie_duration_heading: Maybe<Scalars['String']['output']>
    cookie_name_heading: Maybe<Scalars['String']['output']>
    cookie_origin_heading: Maybe<Scalars['String']['output']>
    cookie_purpose_heading: Maybe<Scalars['String']['output']>
    customise_cookies_success_message: Maybe<Scalars['String']['output']>
    customise_text: Maybe<Scalars['String']['output']>
    decline_all_cookies_success_message: Maybe<Scalars['String']['output']>
    decline_cookies_text: Maybe<Scalars['String']['output']>
    description: Maybe<PrismicStructuredTextType>
    hide_cookies_text: Maybe<Scalars['String']['output']>
    save_preferences_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    view_cookies_text: Maybe<Scalars['String']['output']>
}

export type PrismicCookieManagerDataTypeFieldSelector = {
    accept_all_cookies_success_message: InputMaybe<FieldSelectorEnum>
    accept_cookies_text: InputMaybe<FieldSelectorEnum>
    cookie_categories: InputMaybe<PrismicCookieManagerDataCookieCategoriesFieldSelector>
    cookie_duration_heading: InputMaybe<FieldSelectorEnum>
    cookie_name_heading: InputMaybe<FieldSelectorEnum>
    cookie_origin_heading: InputMaybe<FieldSelectorEnum>
    cookie_purpose_heading: InputMaybe<FieldSelectorEnum>
    customise_cookies_success_message: InputMaybe<FieldSelectorEnum>
    customise_text: InputMaybe<FieldSelectorEnum>
    decline_all_cookies_success_message: InputMaybe<FieldSelectorEnum>
    decline_cookies_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    hide_cookies_text: InputMaybe<FieldSelectorEnum>
    save_preferences_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    view_cookies_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieManagerDataTypeFilterInput = {
    accept_all_cookies_success_message: InputMaybe<StringQueryOperatorInput>
    accept_cookies_text: InputMaybe<StringQueryOperatorInput>
    cookie_categories: InputMaybe<PrismicCookieManagerDataCookieCategoriesFilterListInput>
    cookie_duration_heading: InputMaybe<StringQueryOperatorInput>
    cookie_name_heading: InputMaybe<StringQueryOperatorInput>
    cookie_origin_heading: InputMaybe<StringQueryOperatorInput>
    cookie_purpose_heading: InputMaybe<StringQueryOperatorInput>
    customise_cookies_success_message: InputMaybe<StringQueryOperatorInput>
    customise_text: InputMaybe<StringQueryOperatorInput>
    decline_all_cookies_success_message: InputMaybe<StringQueryOperatorInput>
    decline_cookies_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    hide_cookies_text: InputMaybe<StringQueryOperatorInput>
    save_preferences_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    view_cookies_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieManagerDataTypeSortInput = {
    accept_all_cookies_success_message: InputMaybe<SortOrderEnum>
    accept_cookies_text: InputMaybe<SortOrderEnum>
    cookie_categories: InputMaybe<PrismicCookieManagerDataCookieCategoriesSortInput>
    cookie_duration_heading: InputMaybe<SortOrderEnum>
    cookie_name_heading: InputMaybe<SortOrderEnum>
    cookie_origin_heading: InputMaybe<SortOrderEnum>
    cookie_purpose_heading: InputMaybe<SortOrderEnum>
    customise_cookies_success_message: InputMaybe<SortOrderEnum>
    customise_text: InputMaybe<SortOrderEnum>
    decline_all_cookies_success_message: InputMaybe<SortOrderEnum>
    decline_cookies_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    hide_cookies_text: InputMaybe<SortOrderEnum>
    save_preferences_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    view_cookies_text: InputMaybe<SortOrderEnum>
}

export type PrismicCookieManagerEdge = {
    next: Maybe<PrismicCookieManager>
    node: PrismicCookieManager
    previous: Maybe<PrismicCookieManager>
}

export type PrismicCookieManagerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCookieManagerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieManagerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieManagerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieManagerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieManagerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCookieManagerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieManager>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieManagerGroupConnectionDistinctArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerGroupConnectionGroupArgs = {
    field: PrismicCookieManagerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieManagerGroupConnectionMaxArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerGroupConnectionMinArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerGroupConnectionSumArgs = {
    field: PrismicCookieManagerFieldSelector
}

export type PrismicCookieManagerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCookieManagerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSegment = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCookieSegmentDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSegmentFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieSegmentLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieSegmentConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieSegmentEdge>
    group: Array<PrismicCookieSegmentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieSegment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieSegmentConnectionDistinctArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentConnectionGroupArgs = {
    field: PrismicCookieSegmentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSegmentConnectionMaxArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentConnectionMinArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentConnectionSumArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentDataCookies = {
    duration: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    origin: Maybe<Scalars['String']['output']>
    purpose: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSegmentDataCookiesFieldSelector = {
    duration: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    origin: InputMaybe<FieldSelectorEnum>
    purpose: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSegmentDataCookiesFilterInput = {
    duration: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    origin: InputMaybe<StringQueryOperatorInput>
    purpose: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSegmentDataCookiesFilterListInput = {
    elemMatch: InputMaybe<PrismicCookieSegmentDataCookiesFilterInput>
}

export type PrismicCookieSegmentDataCookiesSortInput = {
    duration: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    origin: InputMaybe<SortOrderEnum>
    purpose: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSegmentDataType = {
    cookies: Maybe<Array<Maybe<PrismicCookieSegmentDataCookies>>>
    description: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    toggle_text: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSegmentDataTypeFieldSelector = {
    cookies: InputMaybe<PrismicCookieSegmentDataCookiesFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    toggle_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSegmentDataTypeFilterInput = {
    cookies: InputMaybe<PrismicCookieSegmentDataCookiesFilterListInput>
    description: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    toggle_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSegmentDataTypeSortInput = {
    cookies: InputMaybe<PrismicCookieSegmentDataCookiesSortInput>
    description: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    toggle_text: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSegmentEdge = {
    next: Maybe<PrismicCookieSegment>
    node: PrismicCookieSegment
    previous: Maybe<PrismicCookieSegment>
}

export type PrismicCookieSegmentFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCookieSegmentDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSegmentFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieSegmentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSegmentGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieSegmentEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCookieSegmentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieSegment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieSegmentGroupConnectionDistinctArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentGroupConnectionGroupArgs = {
    field: PrismicCookieSegmentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSegmentGroupConnectionMaxArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentGroupConnectionMinArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentGroupConnectionSumArgs = {
    field: PrismicCookieSegmentFieldSelector
}

export type PrismicCookieSegmentSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCookieSegmentDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSettingsPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCookieSettingsPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSettingsPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieSettingsPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCookieSettingsPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieSettingsPageEdge>
    group: Array<PrismicCookieSettingsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieSettingsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieSettingsPageConnectionDistinctArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageConnectionGroupArgs = {
    field: PrismicCookieSettingsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSettingsPageConnectionMaxArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageConnectionMinArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageConnectionSumArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageDataHero = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicCookieSettingsPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSettingsPageDataHeroFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicCookieSettingsPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSettingsPageDataHeroFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicCookieSettingsPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSettingsPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicCookieSettingsPageDataHeroFilterInput>
}

export type PrismicCookieSettingsPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSettingsPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSettingsPageDataHeroSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicCookieSettingsPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSettingsPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCookieSettingsPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero: Maybe<Array<Maybe<PrismicCookieSettingsPageDataHero>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicCookieSettingsPageDataOpenGraphImageImageType>
}

export type PrismicCookieSettingsPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicCookieSettingsPageDataHeroFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicCookieSettingsPageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicCookieSettingsPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero: InputMaybe<PrismicCookieSettingsPageDataHeroFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicCookieSettingsPageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicCookieSettingsPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicCookieSettingsPageDataHeroSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicCookieSettingsPageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicCookieSettingsPageEdge = {
    next: Maybe<PrismicCookieSettingsPage>
    node: PrismicCookieSettingsPage
    previous: Maybe<PrismicCookieSettingsPage>
}

export type PrismicCookieSettingsPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCookieSettingsPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCookieSettingsPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieSettingsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCookieSettingsPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCookieSettingsPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCookieSettingsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCookieSettingsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCookieSettingsPageGroupConnectionDistinctArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageGroupConnectionGroupArgs = {
    field: PrismicCookieSettingsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCookieSettingsPageGroupConnectionMaxArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageGroupConnectionMinArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageGroupConnectionSumArgs = {
    field: PrismicCookieSettingsPageFieldSelector
}

export type PrismicCookieSettingsPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCookieSettingsPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCopyExperiment = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCopyExperimentDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCopyExperimentFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCopyExperimentLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCopyExperimentConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCopyExperimentEdge>
    group: Array<PrismicCopyExperimentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCopyExperiment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCopyExperimentConnectionDistinctArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentConnectionGroupArgs = {
    field: PrismicCopyExperimentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCopyExperimentConnectionMaxArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentConnectionMinArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentConnectionSumArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentDataBodySlicesType = PrismicCopyExperimentDataBodyVariant

export type PrismicCopyExperimentDataBodyVariant = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicCopyExperimentDataBodyVariantPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicCopyExperimentDataBodyVariantPrimary = {
    id: Maybe<Scalars['String']['output']>
    rich_text: Maybe<PrismicStructuredTextType>
    text: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicCopyExperimentDataType = {
    body: Array<PrismicCopyExperimentDataBodySlicesType>
}

export type PrismicCopyExperimentEdge = {
    next: Maybe<PrismicCopyExperiment>
    node: PrismicCopyExperiment
    previous: Maybe<PrismicCopyExperiment>
}

export type PrismicCopyExperimentFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCopyExperimentFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCopyExperimentGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCopyExperimentEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCopyExperimentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCopyExperiment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCopyExperimentGroupConnectionDistinctArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentGroupConnectionGroupArgs = {
    field: PrismicCopyExperimentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCopyExperimentGroupConnectionMaxArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentGroupConnectionMinArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentGroupConnectionSumArgs = {
    field: PrismicCopyExperimentFieldSelector
}

export type PrismicCopyExperimentSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCase = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCustomerCaseDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerCaseLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerCaseConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerCaseEdge>
    group: Array<PrismicCustomerCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerCaseConnectionDistinctArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseConnectionGroupArgs = {
    field: PrismicCustomerCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseConnectionMaxArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseConnectionMinArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseConnectionSumArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseDataChallengeList = {
    challenge_list_item_body: Maybe<PrismicStructuredTextType>
    challenge_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataChallengeListFieldSelector = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    challenge_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataChallengeListFilterInput = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    challenge_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataChallengeListFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataChallengeListFilterInput>
}

export type PrismicCustomerCaseDataChallengeListSortInput = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    challenge_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataCustomerCard = {
    employees: Maybe<Scalars['String']['output']>
    industry: Maybe<Scalars['String']['output']>
    location: Maybe<Scalars['String']['output']>
    logo: Maybe<PrismicCustomerCaseDataCustomerCardLogoImageType>
    quote: Maybe<Scalars['String']['output']>
    quote_author: Maybe<Scalars['String']['output']>
    quote_author_image: Maybe<PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageType>
}

export type PrismicCustomerCaseDataCustomerCardFieldSelector = {
    employees: InputMaybe<FieldSelectorEnum>
    industry: InputMaybe<FieldSelectorEnum>
    location: InputMaybe<FieldSelectorEnum>
    logo: InputMaybe<PrismicCustomerCaseDataCustomerCardLogoImageTypeFieldSelector>
    quote: InputMaybe<FieldSelectorEnum>
    quote_author: InputMaybe<FieldSelectorEnum>
    quote_author_image: InputMaybe<PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFieldSelector>
}

export type PrismicCustomerCaseDataCustomerCardFilterInput = {
    employees: InputMaybe<StringQueryOperatorInput>
    industry: InputMaybe<StringQueryOperatorInput>
    location: InputMaybe<StringQueryOperatorInput>
    logo: InputMaybe<PrismicCustomerCaseDataCustomerCardLogoImageTypeFilterInput>
    quote: InputMaybe<StringQueryOperatorInput>
    quote_author: InputMaybe<StringQueryOperatorInput>
    quote_author_image: InputMaybe<PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFilterInput>
}

export type PrismicCustomerCaseDataCustomerCardFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataCustomerCardFilterInput>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataCustomerCardLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataCustomerCardSortInput = {
    employees: InputMaybe<SortOrderEnum>
    industry: InputMaybe<SortOrderEnum>
    location: InputMaybe<SortOrderEnum>
    logo: InputMaybe<PrismicCustomerCaseDataCustomerCardLogoImageTypeSortInput>
    quote: InputMaybe<SortOrderEnum>
    quote_author: InputMaybe<SortOrderEnum>
    quote_author_image: InputMaybe<PrismicCustomerCaseDataCustomerCardQuoteAuthorImageImageTypeSortInput>
}

export type PrismicCustomerCaseDataHeroSection = {
    image: Maybe<PrismicCustomerCaseDataHeroSectionImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataHeroSectionFieldSelector = {
    image: InputMaybe<PrismicCustomerCaseDataHeroSectionImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    wistia_video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataHeroSectionFilterInput = {
    image: InputMaybe<PrismicCustomerCaseDataHeroSectionImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    wistia_video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataHeroSectionFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataHeroSectionFilterInput>
}

export type PrismicCustomerCaseDataHeroSectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataHeroSectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataHeroSectionSortInput = {
    image: InputMaybe<PrismicCustomerCaseDataHeroSectionImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    wistia_video_id: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataMediaItemGrid = {
    body: Maybe<PrismicStructuredTextType>
    icon: Maybe<PrismicCustomerCaseDataMediaItemGridIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataMediaItemGridFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    icon: InputMaybe<PrismicCustomerCaseDataMediaItemGridIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataMediaItemGridFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    icon: InputMaybe<PrismicCustomerCaseDataMediaItemGridIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataMediaItemGridFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataMediaItemGridFilterInput>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataMediaItemGridIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataMediaItemGridSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    icon: InputMaybe<PrismicCustomerCaseDataMediaItemGridIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataRelatedCustomerCases = {
    body: Maybe<Scalars['String']['output']>
    case_title: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicCustomerCaseDataRelatedCustomerCasesImageImageType>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    case_title: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    image: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFieldSelector>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    case_title: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    image: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFilterInput>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesFilterInput>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataRelatedCustomerCasesSortInput = {
    body: InputMaybe<SortOrderEnum>
    case_title: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    image: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesImageImageTypeSortInput>
}

export type PrismicCustomerCaseDataResultList = {
    result_list_item_body: Maybe<PrismicStructuredTextType>
    result_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataResultListFieldSelector = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    result_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataResultListFilterInput = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    result_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataResultListFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataResultListFilterInput>
}

export type PrismicCustomerCaseDataResultListSortInput = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    result_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataSolutionList = {
    solution_list_item_body: Maybe<PrismicStructuredTextType>
    solution_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataSolutionListFieldSelector = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    solution_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataSolutionListFilterInput = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    solution_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataSolutionListFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerCaseDataSolutionListFilterInput>
}

export type PrismicCustomerCaseDataSolutionListSortInput = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    solution_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseDataType = {
    challenge_lead_text: Maybe<PrismicStructuredTextType>
    challenge_list: Maybe<Array<Maybe<PrismicCustomerCaseDataChallengeList>>>
    challenge_title: Maybe<Scalars['String']['output']>
    customer_card: Maybe<Array<Maybe<PrismicCustomerCaseDataCustomerCard>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero_section: Maybe<Array<Maybe<PrismicCustomerCaseDataHeroSection>>>
    media_item_grid: Maybe<Array<Maybe<PrismicCustomerCaseDataMediaItemGrid>>>
    media_item_grid_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    related_customer_cases: Maybe<Array<Maybe<PrismicCustomerCaseDataRelatedCustomerCases>>>
    related_customer_cases_cta_text: Maybe<Scalars['String']['output']>
    related_customer_cases_title: Maybe<Scalars['String']['output']>
    result_lead_text: Maybe<PrismicStructuredTextType>
    result_list: Maybe<Array<Maybe<PrismicCustomerCaseDataResultList>>>
    result_title: Maybe<Scalars['String']['output']>
    solution_lead_text: Maybe<PrismicStructuredTextType>
    solution_list: Maybe<Array<Maybe<PrismicCustomerCaseDataSolutionList>>>
    solution_title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerCaseDataTypeFieldSelector = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    challenge_list: InputMaybe<PrismicCustomerCaseDataChallengeListFieldSelector>
    challenge_title: InputMaybe<FieldSelectorEnum>
    customer_card: InputMaybe<PrismicCustomerCaseDataCustomerCardFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero_section: InputMaybe<PrismicCustomerCaseDataHeroSectionFieldSelector>
    media_item_grid: InputMaybe<PrismicCustomerCaseDataMediaItemGridFieldSelector>
    media_item_grid_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    related_customer_cases: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesFieldSelector>
    related_customer_cases_cta_text: InputMaybe<FieldSelectorEnum>
    related_customer_cases_title: InputMaybe<FieldSelectorEnum>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    result_list: InputMaybe<PrismicCustomerCaseDataResultListFieldSelector>
    result_title: InputMaybe<FieldSelectorEnum>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    solution_list: InputMaybe<PrismicCustomerCaseDataSolutionListFieldSelector>
    solution_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseDataTypeFilterInput = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    challenge_list: InputMaybe<PrismicCustomerCaseDataChallengeListFilterListInput>
    challenge_title: InputMaybe<StringQueryOperatorInput>
    customer_card: InputMaybe<PrismicCustomerCaseDataCustomerCardFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero_section: InputMaybe<PrismicCustomerCaseDataHeroSectionFilterListInput>
    media_item_grid: InputMaybe<PrismicCustomerCaseDataMediaItemGridFilterListInput>
    media_item_grid_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    related_customer_cases: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesFilterListInput>
    related_customer_cases_cta_text: InputMaybe<StringQueryOperatorInput>
    related_customer_cases_title: InputMaybe<StringQueryOperatorInput>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    result_list: InputMaybe<PrismicCustomerCaseDataResultListFilterListInput>
    result_title: InputMaybe<StringQueryOperatorInput>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    solution_list: InputMaybe<PrismicCustomerCaseDataSolutionListFilterListInput>
    solution_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseDataTypeSortInput = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    challenge_list: InputMaybe<PrismicCustomerCaseDataChallengeListSortInput>
    challenge_title: InputMaybe<SortOrderEnum>
    customer_card: InputMaybe<PrismicCustomerCaseDataCustomerCardSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero_section: InputMaybe<PrismicCustomerCaseDataHeroSectionSortInput>
    media_item_grid: InputMaybe<PrismicCustomerCaseDataMediaItemGridSortInput>
    media_item_grid_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    related_customer_cases: InputMaybe<PrismicCustomerCaseDataRelatedCustomerCasesSortInput>
    related_customer_cases_cta_text: InputMaybe<SortOrderEnum>
    related_customer_cases_title: InputMaybe<SortOrderEnum>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    result_list: InputMaybe<PrismicCustomerCaseDataResultListSortInput>
    result_title: InputMaybe<SortOrderEnum>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    solution_list: InputMaybe<PrismicCustomerCaseDataSolutionListSortInput>
    solution_title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerCaseEdge = {
    next: Maybe<PrismicCustomerCase>
    node: PrismicCustomerCase
    previous: Maybe<PrismicCustomerCase>
}

export type PrismicCustomerCaseFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCustomerCaseDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerCaseFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerCaseGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerCaseEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCustomerCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerCaseGroupConnectionDistinctArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseGroupConnectionGroupArgs = {
    field: PrismicCustomerCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerCaseGroupConnectionMaxArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseGroupConnectionMinArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseGroupConnectionSumArgs = {
    field: PrismicCustomerCaseFieldSelector
}

export type PrismicCustomerCaseSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCustomerCaseDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerLogos = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCustomerLogosDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerLogosFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerLogosLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerLogosConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerLogosEdge>
    group: Array<PrismicCustomerLogosGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerLogos>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerLogosConnectionDistinctArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosConnectionGroupArgs = {
    field: PrismicCustomerLogosFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerLogosConnectionMaxArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosConnectionMinArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosConnectionSumArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosDataLogos = {
    logo: Maybe<PrismicCustomerLogosDataLogosLogoImageType>
}

export type PrismicCustomerLogosDataLogosFieldSelector = {
    logo: InputMaybe<PrismicCustomerLogosDataLogosLogoImageTypeFieldSelector>
}

export type PrismicCustomerLogosDataLogosFilterInput = {
    logo: InputMaybe<PrismicCustomerLogosDataLogosLogoImageTypeFilterInput>
}

export type PrismicCustomerLogosDataLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerLogosDataLogosFilterInput>
}

export type PrismicCustomerLogosDataLogosLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerLogosDataLogosLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerLogosDataLogosSortInput = {
    logo: InputMaybe<PrismicCustomerLogosDataLogosLogoImageTypeSortInput>
}

export type PrismicCustomerLogosDataType = {
    logos: Maybe<Array<Maybe<PrismicCustomerLogosDataLogos>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerLogosDataTypeFieldSelector = {
    logos: InputMaybe<PrismicCustomerLogosDataLogosFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerLogosDataTypeFilterInput = {
    logos: InputMaybe<PrismicCustomerLogosDataLogosFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerLogosDataTypeSortInput = {
    logos: InputMaybe<PrismicCustomerLogosDataLogosSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerLogosEdge = {
    next: Maybe<PrismicCustomerLogos>
    node: PrismicCustomerLogos
    previous: Maybe<PrismicCustomerLogos>
}

export type PrismicCustomerLogosFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCustomerLogosDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerLogosFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerLogosDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerLogosGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerLogosEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCustomerLogosGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerLogos>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerLogosGroupConnectionDistinctArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosGroupConnectionGroupArgs = {
    field: PrismicCustomerLogosFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerLogosGroupConnectionMaxArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosGroupConnectionMinArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosGroupConnectionSumArgs = {
    field: PrismicCustomerLogosFieldSelector
}

export type PrismicCustomerLogosSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCustomerLogosDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerStoriesSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCustomerStoriesSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerStoriesSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerStoriesSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomerStoriesSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerStoriesSectionEdge>
    group: Array<PrismicCustomerStoriesSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerStoriesSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerStoriesSectionConnectionDistinctArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionConnectionGroupArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerStoriesSectionConnectionMaxArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionConnectionMinArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionConnectionSumArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionDataCustomerCases = {
    body: Maybe<Scalars['String']['output']>
    case_title: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicCustomerStoriesSectionDataCustomerCasesImageImageType>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    case_title: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    image: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFieldSelector>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    case_title: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    image: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFilterInput>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesFilterInput>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerStoriesSectionDataCustomerCasesSortInput = {
    body: InputMaybe<SortOrderEnum>
    case_title: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    image: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesImageImageTypeSortInput>
}

export type PrismicCustomerStoriesSectionDataType = {
    cta_text: Maybe<Scalars['String']['output']>
    customer_cases: Maybe<Array<Maybe<PrismicCustomerStoriesSectionDataCustomerCases>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomerStoriesSectionDataTypeFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    customer_cases: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerStoriesSectionDataTypeFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    customer_cases: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerStoriesSectionDataTypeSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    customer_cases: InputMaybe<PrismicCustomerStoriesSectionDataCustomerCasesSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomerStoriesSectionEdge = {
    next: Maybe<PrismicCustomerStoriesSection>
    node: PrismicCustomerStoriesSection
    previous: Maybe<PrismicCustomerStoriesSection>
}

export type PrismicCustomerStoriesSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCustomerStoriesSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomerStoriesSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerStoriesSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomerStoriesSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomerStoriesSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCustomerStoriesSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomerStoriesSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomerStoriesSectionGroupConnectionDistinctArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionGroupConnectionGroupArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomerStoriesSectionGroupConnectionMaxArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionGroupConnectionMinArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionGroupConnectionSumArgs = {
    field: PrismicCustomerStoriesSectionFieldSelector
}

export type PrismicCustomerStoriesSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCustomerStoriesSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersLogosSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCustomersLogosSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersLogosSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomersLogosSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomersLogosSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomersLogosSectionEdge>
    group: Array<PrismicCustomersLogosSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomersLogosSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomersLogosSectionConnectionDistinctArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionConnectionGroupArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersLogosSectionConnectionMaxArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionConnectionMinArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionConnectionSumArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionDataLogos = {
    logo: Maybe<PrismicCustomersLogosSectionDataLogosLogoImageType>
}

export type PrismicCustomersLogosSectionDataLogosFieldSelector = {
    logo: InputMaybe<PrismicCustomersLogosSectionDataLogosLogoImageTypeFieldSelector>
}

export type PrismicCustomersLogosSectionDataLogosFilterInput = {
    logo: InputMaybe<PrismicCustomersLogosSectionDataLogosLogoImageTypeFilterInput>
}

export type PrismicCustomersLogosSectionDataLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersLogosSectionDataLogosFilterInput>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersLogosSectionDataLogosLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersLogosSectionDataLogosSortInput = {
    logo: InputMaybe<PrismicCustomersLogosSectionDataLogosLogoImageTypeSortInput>
}

export type PrismicCustomersLogosSectionDataType = {
    logos: Maybe<Array<Maybe<PrismicCustomersLogosSectionDataLogos>>>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicCustomersLogosSectionDataTypeFieldSelector = {
    logos: InputMaybe<PrismicCustomersLogosSectionDataLogosFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
}

export type PrismicCustomersLogosSectionDataTypeFilterInput = {
    logos: InputMaybe<PrismicCustomersLogosSectionDataLogosFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
}

export type PrismicCustomersLogosSectionDataTypeSortInput = {
    logos: InputMaybe<PrismicCustomersLogosSectionDataLogosSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
}

export type PrismicCustomersLogosSectionEdge = {
    next: Maybe<PrismicCustomersLogosSection>
    node: PrismicCustomersLogosSection
    previous: Maybe<PrismicCustomersLogosSection>
}

export type PrismicCustomersLogosSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCustomersLogosSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersLogosSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomersLogosSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersLogosSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomersLogosSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCustomersLogosSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomersLogosSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomersLogosSectionGroupConnectionDistinctArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionGroupConnectionGroupArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersLogosSectionGroupConnectionMaxArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionGroupConnectionMinArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionGroupConnectionSumArgs = {
    field: PrismicCustomersLogosSectionFieldSelector
}

export type PrismicCustomersLogosSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCustomersLogosSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicCustomersPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomersPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicCustomersPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomersPageEdge>
    group: Array<PrismicCustomersPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomersPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomersPageConnectionDistinctArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageConnectionGroupArgs = {
    field: PrismicCustomersPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageConnectionMaxArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageConnectionMinArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageConnectionSumArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageDataCustomerCards = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    design: Maybe<Scalars['Boolean']['output']>
    financial_services: Maybe<Scalars['Boolean']['output']>
    food_and_drink: Maybe<Scalars['Boolean']['output']>
    image: Maybe<PrismicCustomersPageDataCustomerCardsImageImageType>
    logistics: Maybe<Scalars['Boolean']['output']>
    marketing: Maybe<Scalars['Boolean']['output']>
    media: Maybe<Scalars['Boolean']['output']>
    property: Maybe<Scalars['Boolean']['output']>
    sports_and_events: Maybe<Scalars['Boolean']['output']>
    technology: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
    travel: Maybe<Scalars['Boolean']['output']>
}

export type PrismicCustomersPageDataCustomerCardsFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    design: InputMaybe<FieldSelectorEnum>
    financial_services: InputMaybe<FieldSelectorEnum>
    food_and_drink: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicCustomersPageDataCustomerCardsImageImageTypeFieldSelector>
    logistics: InputMaybe<FieldSelectorEnum>
    marketing: InputMaybe<FieldSelectorEnum>
    media: InputMaybe<FieldSelectorEnum>
    property: InputMaybe<FieldSelectorEnum>
    sports_and_events: InputMaybe<FieldSelectorEnum>
    technology: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    travel: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataCustomerCardsFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    design: InputMaybe<BooleanQueryOperatorInput>
    financial_services: InputMaybe<BooleanQueryOperatorInput>
    food_and_drink: InputMaybe<BooleanQueryOperatorInput>
    image: InputMaybe<PrismicCustomersPageDataCustomerCardsImageImageTypeFilterInput>
    logistics: InputMaybe<BooleanQueryOperatorInput>
    marketing: InputMaybe<BooleanQueryOperatorInput>
    media: InputMaybe<BooleanQueryOperatorInput>
    property: InputMaybe<BooleanQueryOperatorInput>
    sports_and_events: InputMaybe<BooleanQueryOperatorInput>
    technology: InputMaybe<BooleanQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    travel: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicCustomersPageDataCustomerCardsFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersPageDataCustomerCardsFilterInput>
}

export type PrismicCustomersPageDataCustomerCardsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataCustomerCardsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataCustomerCardsSortInput = {
    body: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    design: InputMaybe<SortOrderEnum>
    financial_services: InputMaybe<SortOrderEnum>
    food_and_drink: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicCustomersPageDataCustomerCardsImageImageTypeSortInput>
    logistics: InputMaybe<SortOrderEnum>
    marketing: InputMaybe<SortOrderEnum>
    media: InputMaybe<SortOrderEnum>
    property: InputMaybe<SortOrderEnum>
    sports_and_events: InputMaybe<SortOrderEnum>
    technology: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    travel: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicCustomersPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicCustomersPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicCustomersPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersPageDataHeroFilterInput>
}

export type PrismicCustomersPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomersPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomersPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomersPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicCustomersPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataIndustries = {
    all: Maybe<Scalars['String']['output']>
    design: Maybe<Scalars['String']['output']>
    financial_services: Maybe<Scalars['String']['output']>
    food_and_drink: Maybe<Scalars['String']['output']>
    logistics: Maybe<Scalars['String']['output']>
    marketing: Maybe<Scalars['String']['output']>
    media: Maybe<Scalars['String']['output']>
    property: Maybe<Scalars['String']['output']>
    sports_and_events: Maybe<Scalars['String']['output']>
    technology: Maybe<Scalars['String']['output']>
    travel: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataIndustriesFieldSelector = {
    all: InputMaybe<FieldSelectorEnum>
    design: InputMaybe<FieldSelectorEnum>
    financial_services: InputMaybe<FieldSelectorEnum>
    food_and_drink: InputMaybe<FieldSelectorEnum>
    logistics: InputMaybe<FieldSelectorEnum>
    marketing: InputMaybe<FieldSelectorEnum>
    media: InputMaybe<FieldSelectorEnum>
    property: InputMaybe<FieldSelectorEnum>
    sports_and_events: InputMaybe<FieldSelectorEnum>
    technology: InputMaybe<FieldSelectorEnum>
    travel: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataIndustriesFilterInput = {
    all: InputMaybe<StringQueryOperatorInput>
    design: InputMaybe<StringQueryOperatorInput>
    financial_services: InputMaybe<StringQueryOperatorInput>
    food_and_drink: InputMaybe<StringQueryOperatorInput>
    logistics: InputMaybe<StringQueryOperatorInput>
    marketing: InputMaybe<StringQueryOperatorInput>
    media: InputMaybe<StringQueryOperatorInput>
    property: InputMaybe<StringQueryOperatorInput>
    sports_and_events: InputMaybe<StringQueryOperatorInput>
    technology: InputMaybe<StringQueryOperatorInput>
    travel: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataIndustriesFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersPageDataIndustriesFilterInput>
}

export type PrismicCustomersPageDataIndustriesSortInput = {
    all: InputMaybe<SortOrderEnum>
    design: InputMaybe<SortOrderEnum>
    financial_services: InputMaybe<SortOrderEnum>
    food_and_drink: InputMaybe<SortOrderEnum>
    logistics: InputMaybe<SortOrderEnum>
    marketing: InputMaybe<SortOrderEnum>
    media: InputMaybe<SortOrderEnum>
    property: InputMaybe<SortOrderEnum>
    sports_and_events: InputMaybe<SortOrderEnum>
    technology: InputMaybe<SortOrderEnum>
    travel: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataTestimonials = {
    testimonial: Maybe<PrismicLinkType>
}

export type PrismicCustomersPageDataTestimonialsFieldSelector = {
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicCustomersPageDataTestimonialsFilterInput = {
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicCustomersPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersPageDataTestimonialsFilterInput>
}

export type PrismicCustomersPageDataTestimonialsSortInput = {
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicCustomersPageDataType = {
    customer_card_cta_text: Maybe<Scalars['String']['output']>
    customer_cards: Maybe<Array<Maybe<PrismicCustomersPageDataCustomerCards>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero: Maybe<Array<Maybe<PrismicCustomersPageDataHero>>>
    industries: Maybe<Array<Maybe<PrismicCustomersPageDataIndustries>>>
    industry_select_text: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicCustomersPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    show_more_customers_text: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    testimonials: Maybe<Array<Maybe<PrismicCustomersPageDataTestimonials>>>
    why_pleo: Maybe<Array<Maybe<PrismicCustomersPageDataWhyPleo>>>
}

export type PrismicCustomersPageDataTypeFieldSelector = {
    customer_card_cta_text: InputMaybe<FieldSelectorEnum>
    customer_cards: InputMaybe<PrismicCustomersPageDataCustomerCardsFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicCustomersPageDataHeroFieldSelector>
    industries: InputMaybe<PrismicCustomersPageDataIndustriesFieldSelector>
    industry_select_text: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicCustomersPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    show_more_customers_text: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    testimonials: InputMaybe<PrismicCustomersPageDataTestimonialsFieldSelector>
    why_pleo: InputMaybe<PrismicCustomersPageDataWhyPleoFieldSelector>
}

export type PrismicCustomersPageDataTypeFilterInput = {
    customer_card_cta_text: InputMaybe<StringQueryOperatorInput>
    customer_cards: InputMaybe<PrismicCustomersPageDataCustomerCardsFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero: InputMaybe<PrismicCustomersPageDataHeroFilterListInput>
    industries: InputMaybe<PrismicCustomersPageDataIndustriesFilterListInput>
    industry_select_text: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicCustomersPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    show_more_customers_text: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    testimonials: InputMaybe<PrismicCustomersPageDataTestimonialsFilterListInput>
    why_pleo: InputMaybe<PrismicCustomersPageDataWhyPleoFilterListInput>
}

export type PrismicCustomersPageDataTypeSortInput = {
    customer_card_cta_text: InputMaybe<SortOrderEnum>
    customer_cards: InputMaybe<PrismicCustomersPageDataCustomerCardsSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicCustomersPageDataHeroSortInput>
    industries: InputMaybe<PrismicCustomersPageDataIndustriesSortInput>
    industry_select_text: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicCustomersPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    show_more_customers_text: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    testimonials: InputMaybe<PrismicCustomersPageDataTestimonialsSortInput>
    why_pleo: InputMaybe<PrismicCustomersPageDataWhyPleoSortInput>
}

export type PrismicCustomersPageDataWhyPleo = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicCustomersPageDataWhyPleoImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataWhyPleoFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicCustomersPageDataWhyPleoImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataWhyPleoFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicCustomersPageDataWhyPleoImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataWhyPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicCustomersPageDataWhyPleoFilterInput>
}

export type PrismicCustomersPageDataWhyPleoImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageDataWhyPleoImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageDataWhyPleoSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicCustomersPageDataWhyPleoImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicCustomersPageEdge = {
    next: Maybe<PrismicCustomersPage>
    node: PrismicCustomersPage
    previous: Maybe<PrismicCustomersPage>
}

export type PrismicCustomersPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicCustomersPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicCustomersPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomersPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicCustomersPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicCustomersPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicCustomersPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicCustomersPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicCustomersPageGroupConnectionDistinctArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageGroupConnectionGroupArgs = {
    field: PrismicCustomersPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicCustomersPageGroupConnectionMaxArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageGroupConnectionMinArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageGroupConnectionSumArgs = {
    field: PrismicCustomersPageFieldSelector
}

export type PrismicCustomersPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicCustomersPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicDemoPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicDemoPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicDemoPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageEdge>
    group: Array<PrismicDemoPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageConnectionDistinctArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageConnectionGroupArgs = {
    field: PrismicDemoPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageConnectionMaxArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageConnectionMinArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageConnectionSumArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageDataBulletPoints = {
    icon: Maybe<PrismicDemoPageDataBulletPointsIconImageType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataBulletPointsFieldSelector = {
    icon: InputMaybe<PrismicDemoPageDataBulletPointsIconImageTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataBulletPointsFilterInput = {
    icon: InputMaybe<PrismicDemoPageDataBulletPointsIconImageTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataBulletPointsFilterListInput = {
    elemMatch: InputMaybe<PrismicDemoPageDataBulletPointsFilterInput>
}

export type PrismicDemoPageDataBulletPointsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataBulletPointsIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataBulletPointsSortInput = {
    icon: InputMaybe<PrismicDemoPageDataBulletPointsIconImageTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicDemoPageDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicDemoPageDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPageDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicDemoPageDataFormProductionIntegrationType>
    node: PrismicDemoPageDataFormProductionIntegrationType
    previous: Maybe<PrismicDemoPageDataFormProductionIntegrationType>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicDemoPageDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPageDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicDemoPageDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicDemoPageDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPageDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput = {
    id: InputMaybe<SortOrderEnum>
    required: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicDemoPageDataFormStagingIntegrationType>
    node: PrismicDemoPageDataFormStagingIntegrationType
    previous: Maybe<PrismicDemoPageDataFormStagingIntegrationType>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicDemoPageDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPageDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicDemoPageDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataImperativeConsentsProduction = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicDemoPageDataImperativeConsentsProductionFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicDemoPageDataImperativeConsentsProductionFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicDemoPageDataImperativeConsentsProductionFilterListInput = {
    elemMatch: InputMaybe<PrismicDemoPageDataImperativeConsentsProductionFilterInput>
}

export type PrismicDemoPageDataImperativeConsentsProductionSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicDemoPageDataImperativeConsentsStaging = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicDemoPageDataImperativeConsentsStagingFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicDemoPageDataImperativeConsentsStagingFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicDemoPageDataImperativeConsentsStagingFilterListInput = {
    elemMatch: InputMaybe<PrismicDemoPageDataImperativeConsentsStagingFilterInput>
}

export type PrismicDemoPageDataImperativeConsentsStagingSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicDemoPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageDataType = {
    bullet_points: Maybe<Array<Maybe<PrismicDemoPageDataBulletPoints>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicDemoPageDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicDemoPageDataFormStagingIntegrationType>
    form_submit_text: Maybe<Scalars['String']['output']>
    form_title: Maybe<Scalars['String']['output']>
    imperative_consents_production: Maybe<
        Array<Maybe<PrismicDemoPageDataImperativeConsentsProduction>>
    >
    imperative_consents_staging: Maybe<Array<Maybe<PrismicDemoPageDataImperativeConsentsStaging>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicDemoPageDataOpenGraphImageImageType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicDemoPageDataTypeFieldSelector = {
    bullet_points: InputMaybe<PrismicDemoPageDataBulletPointsFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeFieldSelector>
    form_submit_text: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    imperative_consents_production: InputMaybe<PrismicDemoPageDataImperativeConsentsProductionFieldSelector>
    imperative_consents_staging: InputMaybe<PrismicDemoPageDataImperativeConsentsStagingFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicDemoPageDataOpenGraphImageImageTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageDataTypeFilterInput = {
    bullet_points: InputMaybe<PrismicDemoPageDataBulletPointsFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeFilterInput>
    form_submit_text: InputMaybe<StringQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    imperative_consents_production: InputMaybe<PrismicDemoPageDataImperativeConsentsProductionFilterListInput>
    imperative_consents_staging: InputMaybe<PrismicDemoPageDataImperativeConsentsStagingFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicDemoPageDataOpenGraphImageImageTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageDataTypeSortInput = {
    bullet_points: InputMaybe<PrismicDemoPageDataBulletPointsSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeSortInput>
    form_submit_text: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    imperative_consents_production: InputMaybe<PrismicDemoPageDataImperativeConsentsProductionSortInput>
    imperative_consents_staging: InputMaybe<PrismicDemoPageDataImperativeConsentsStagingSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicDemoPageDataOpenGraphImageImageTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicDemoPageEdge = {
    next: Maybe<PrismicDemoPage>
    node: PrismicDemoPage
    previous: Maybe<PrismicDemoPage>
}

export type PrismicDemoPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicDemoPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicDemoPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicDemoPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDemoPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDemoPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicDemoPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDemoPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDemoPageGroupConnectionDistinctArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageGroupConnectionGroupArgs = {
    field: PrismicDemoPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDemoPageGroupConnectionMaxArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageGroupConnectionMinArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageGroupConnectionSumArgs = {
    field: PrismicDemoPageFieldSelector
}

export type PrismicDemoPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicDemoPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicDisallowedEmails = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicDisallowedEmailsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicDisallowedEmailsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicDisallowedEmailsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicDisallowedEmailsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDisallowedEmailsEdge>
    group: Array<PrismicDisallowedEmailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDisallowedEmails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDisallowedEmailsConnectionDistinctArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsConnectionGroupArgs = {
    field: PrismicDisallowedEmailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDisallowedEmailsConnectionMaxArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsConnectionMinArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsConnectionSumArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsDataEmails = {
    email: Maybe<Scalars['String']['output']>
}

export type PrismicDisallowedEmailsDataEmailsFieldSelector = {
    email: InputMaybe<FieldSelectorEnum>
}

export type PrismicDisallowedEmailsDataEmailsFilterInput = {
    email: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDisallowedEmailsDataEmailsFilterListInput = {
    elemMatch: InputMaybe<PrismicDisallowedEmailsDataEmailsFilterInput>
}

export type PrismicDisallowedEmailsDataEmailsSortInput = {
    email: InputMaybe<SortOrderEnum>
}

export type PrismicDisallowedEmailsDataType = {
    emails: Maybe<Array<Maybe<PrismicDisallowedEmailsDataEmails>>>
}

export type PrismicDisallowedEmailsDataTypeFieldSelector = {
    emails: InputMaybe<PrismicDisallowedEmailsDataEmailsFieldSelector>
}

export type PrismicDisallowedEmailsDataTypeFilterInput = {
    emails: InputMaybe<PrismicDisallowedEmailsDataEmailsFilterListInput>
}

export type PrismicDisallowedEmailsDataTypeSortInput = {
    emails: InputMaybe<PrismicDisallowedEmailsDataEmailsSortInput>
}

export type PrismicDisallowedEmailsEdge = {
    next: Maybe<PrismicDisallowedEmails>
    node: PrismicDisallowedEmails
    previous: Maybe<PrismicDisallowedEmails>
}

export type PrismicDisallowedEmailsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicDisallowedEmailsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicDisallowedEmailsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicDisallowedEmailsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicDisallowedEmailsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicDisallowedEmailsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicDisallowedEmailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicDisallowedEmails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicDisallowedEmailsGroupConnectionDistinctArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsGroupConnectionGroupArgs = {
    field: PrismicDisallowedEmailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicDisallowedEmailsGroupConnectionMaxArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsGroupConnectionMinArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsGroupConnectionSumArgs = {
    field: PrismicDisallowedEmailsFieldSelector
}

export type PrismicDisallowedEmailsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicDisallowedEmailsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbook = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEbookDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookEdge>
    group: Array<PrismicEbookGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbook>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookConnectionDistinctArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookConnectionGroupArgs = {
    field: PrismicEbookFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookConnectionMaxArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookConnectionMinArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookConnectionSumArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookDataCoverImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataCoverImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataCoverImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookDataCoverImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookDataCoverImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookDataCoverImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataCoverImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataCoverImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicEbookDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicEbookDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput = {
    id: InputMaybe<SortOrderEnum>
    required: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicEbookDataFormProductionIntegrationType>
    node: PrismicEbookDataFormProductionIntegrationType
    previous: Maybe<PrismicEbookDataFormProductionIntegrationType>
}

export type PrismicEbookDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicEbookDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicEbookDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicEbookDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector = {
    id: InputMaybe<FieldSelectorEnum>
    required: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput = {
    id: InputMaybe<IntQueryOperatorInput>
    required: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput = {
    id: InputMaybe<SortOrderEnum>
    required: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicEbookDataFormStagingIntegrationType>
    node: PrismicEbookDataFormStagingIntegrationType
    previous: Maybe<PrismicEbookDataFormStagingIntegrationType>
}

export type PrismicEbookDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicEbookDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicEbookDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataImperativeConsentsProduction = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicEbookDataImperativeConsentsProductionFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicEbookDataImperativeConsentsProductionFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicEbookDataImperativeConsentsProductionFilterListInput = {
    elemMatch: InputMaybe<PrismicEbookDataImperativeConsentsProductionFilterInput>
}

export type PrismicEbookDataImperativeConsentsProductionSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicEbookDataImperativeConsentsStaging = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicEbookDataImperativeConsentsStagingFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicEbookDataImperativeConsentsStagingFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicEbookDataImperativeConsentsStagingFilterListInput = {
    elemMatch: InputMaybe<PrismicEbookDataImperativeConsentsStagingFilterInput>
}

export type PrismicEbookDataImperativeConsentsStagingSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicEbookDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataType = {
    campaign: Maybe<Scalars['String']['output']>
    cover_image: Maybe<PrismicEbookDataCoverImageImageType>
    description: Maybe<Scalars['String']['output']>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    file: Maybe<PrismicLinkType>
    form_pre_title: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicEbookDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicEbookDataFormStagingIntegrationType>
    form_submit_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicEbookDataImageImageType>
    imperative_consents_production: Maybe<
        Array<Maybe<PrismicEbookDataImperativeConsentsProduction>>
    >
    imperative_consents_staging: Maybe<Array<Maybe<PrismicEbookDataImperativeConsentsStaging>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicEbookDataOpenGraphImageImageType>
    predefined_details: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    what_s_inside_image: Maybe<PrismicEbookDataWhatSInsideImageImageType>
    what_s_inside_points: Maybe<Array<Maybe<PrismicEbookDataWhatSInsidePoints>>>
}

export type PrismicEbookDataTypeFieldSelector = {
    campaign: InputMaybe<FieldSelectorEnum>
    cover_image: InputMaybe<PrismicEbookDataCoverImageImageTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    file: InputMaybe<PrismicLinkTypeFieldSelector>
    form_pre_title: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeFieldSelector>
    form_submit_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicEbookDataImageImageTypeFieldSelector>
    imperative_consents_production: InputMaybe<PrismicEbookDataImperativeConsentsProductionFieldSelector>
    imperative_consents_staging: InputMaybe<PrismicEbookDataImperativeConsentsStagingFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicEbookDataOpenGraphImageImageTypeFieldSelector>
    predefined_details: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    what_s_inside_image: InputMaybe<PrismicEbookDataWhatSInsideImageImageTypeFieldSelector>
    what_s_inside_points: InputMaybe<PrismicEbookDataWhatSInsidePointsFieldSelector>
}

export type PrismicEbookDataTypeFilterInput = {
    campaign: InputMaybe<StringQueryOperatorInput>
    cover_image: InputMaybe<PrismicEbookDataCoverImageImageTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    file: InputMaybe<PrismicLinkTypeFilterInput>
    form_pre_title: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeFilterInput>
    form_submit_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicEbookDataImageImageTypeFilterInput>
    imperative_consents_production: InputMaybe<PrismicEbookDataImperativeConsentsProductionFilterListInput>
    imperative_consents_staging: InputMaybe<PrismicEbookDataImperativeConsentsStagingFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicEbookDataOpenGraphImageImageTypeFilterInput>
    predefined_details: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    what_s_inside_image: InputMaybe<PrismicEbookDataWhatSInsideImageImageTypeFilterInput>
    what_s_inside_points: InputMaybe<PrismicEbookDataWhatSInsidePointsFilterListInput>
}

export type PrismicEbookDataTypeSortInput = {
    campaign: InputMaybe<SortOrderEnum>
    cover_image: InputMaybe<PrismicEbookDataCoverImageImageTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    file: InputMaybe<PrismicLinkTypeSortInput>
    form_pre_title: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeSortInput>
    form_submit_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicEbookDataImageImageTypeSortInput>
    imperative_consents_production: InputMaybe<PrismicEbookDataImperativeConsentsProductionSortInput>
    imperative_consents_staging: InputMaybe<PrismicEbookDataImperativeConsentsStagingSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicEbookDataOpenGraphImageImageTypeSortInput>
    predefined_details: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    what_s_inside_image: InputMaybe<PrismicEbookDataWhatSInsideImageImageTypeSortInput>
    what_s_inside_points: InputMaybe<PrismicEbookDataWhatSInsidePointsSortInput>
}

export type PrismicEbookDataWhatSInsideImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataWhatSInsideImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDataWhatSInsideImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookDataWhatSInsideImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookDataWhatSInsideImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookDataWhatSInsideImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataWhatSInsideImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataWhatSInsideImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDataWhatSInsidePoints = {
    point: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDataWhatSInsidePointsFieldSelector = {
    point: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDataWhatSInsidePointsFilterInput = {
    point: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDataWhatSInsidePointsFilterListInput = {
    elemMatch: InputMaybe<PrismicEbookDataWhatSInsidePointsFilterInput>
}

export type PrismicEbookDataWhatSInsidePointsSortInput = {
    point: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDetails = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEbookDetailsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDetailsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookDetailsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookDetailsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDetailsEdge>
    group: Array<PrismicEbookDetailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDetails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDetailsConnectionDistinctArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsConnectionGroupArgs = {
    field: PrismicEbookDetailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDetailsConnectionMaxArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsConnectionMinArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsConnectionSumArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsDataThankYouImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDetailsDataThankYouImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDetailsDataType = {
    form_error_text: Maybe<Scalars['String']['output']>
    form_pre_title: Maybe<Scalars['String']['output']>
    form_submit_text: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    thank_you_download_button_label: Maybe<Scalars['String']['output']>
    thank_you_heading: Maybe<Scalars['String']['output']>
    thank_you_image: Maybe<PrismicEbookDetailsDataThankYouImageImageType>
    thank_you_return_button_label: Maybe<Scalars['String']['output']>
    thank_you_signup_text: Maybe<PrismicStructuredTextType>
    thank_you_text: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
    what_s_inside_text: Maybe<Scalars['String']['output']>
}

export type PrismicEbookDetailsDataTypeFieldSelector = {
    form_error_text: InputMaybe<FieldSelectorEnum>
    form_pre_title: InputMaybe<FieldSelectorEnum>
    form_submit_text: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    thank_you_download_button_label: InputMaybe<FieldSelectorEnum>
    thank_you_heading: InputMaybe<FieldSelectorEnum>
    thank_you_image: InputMaybe<PrismicEbookDetailsDataThankYouImageImageTypeFieldSelector>
    thank_you_return_button_label: InputMaybe<FieldSelectorEnum>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    what_s_inside_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDetailsDataTypeFilterInput = {
    form_error_text: InputMaybe<StringQueryOperatorInput>
    form_pre_title: InputMaybe<StringQueryOperatorInput>
    form_submit_text: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    thank_you_download_button_label: InputMaybe<StringQueryOperatorInput>
    thank_you_heading: InputMaybe<StringQueryOperatorInput>
    thank_you_image: InputMaybe<PrismicEbookDetailsDataThankYouImageImageTypeFilterInput>
    thank_you_return_button_label: InputMaybe<StringQueryOperatorInput>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    what_s_inside_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDetailsDataTypeSortInput = {
    form_error_text: InputMaybe<SortOrderEnum>
    form_pre_title: InputMaybe<SortOrderEnum>
    form_submit_text: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    thank_you_download_button_label: InputMaybe<SortOrderEnum>
    thank_you_heading: InputMaybe<SortOrderEnum>
    thank_you_image: InputMaybe<PrismicEbookDetailsDataThankYouImageImageTypeSortInput>
    thank_you_return_button_label: InputMaybe<SortOrderEnum>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    what_s_inside_text: InputMaybe<SortOrderEnum>
}

export type PrismicEbookDetailsEdge = {
    next: Maybe<PrismicEbookDetails>
    node: PrismicEbookDetails
    previous: Maybe<PrismicEbookDetails>
}

export type PrismicEbookDetailsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEbookDetailsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookDetailsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookDetailsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookDetailsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookDetailsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookDetailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookDetails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookDetailsGroupConnectionDistinctArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsGroupConnectionGroupArgs = {
    field: PrismicEbookDetailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookDetailsGroupConnectionMaxArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsGroupConnectionMinArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsGroupConnectionSumArgs = {
    field: PrismicEbookDetailsFieldSelector
}

export type PrismicEbookDetailsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEbookDetailsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookEdge = {
    next: Maybe<PrismicEbook>
    node: PrismicEbook
    previous: Maybe<PrismicEbook>
}

export type PrismicEbookFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEbookDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbook>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookGroupConnectionDistinctArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookGroupConnectionGroupArgs = {
    field: PrismicEbookFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookGroupConnectionMaxArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookGroupConnectionMinArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookGroupConnectionSumArgs = {
    field: PrismicEbookFieldSelector
}

export type PrismicEbookMarketingDownload = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEbookMarketingDownloadDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingDownloadFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookMarketingDownloadLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookMarketingDownloadConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookMarketingDownloadEdge>
    group: Array<PrismicEbookMarketingDownloadGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookMarketingDownload>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookMarketingDownloadConnectionDistinctArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadConnectionGroupArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingDownloadConnectionMaxArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadConnectionMinArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadConnectionSumArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadDataCoverImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingDownloadDataCoverImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookMarketingDownloadDataType = {
    campaign: Maybe<Scalars['String']['output']>
    cover_image: Maybe<PrismicEbookMarketingDownloadDataCoverImageImageType>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    file: Maybe<PrismicLinkType>
    hubspot_form_id: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicEbookMarketingDownloadDataOpenGraphImageImageType>
    title: Maybe<Scalars['String']['output']>
    what_s_inside_points: Maybe<Array<Maybe<PrismicEbookMarketingDownloadDataWhatSInsidePoints>>>
}

export type PrismicEbookMarketingDownloadDataTypeFieldSelector = {
    campaign: InputMaybe<FieldSelectorEnum>
    cover_image: InputMaybe<PrismicEbookMarketingDownloadDataCoverImageImageTypeFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    file: InputMaybe<PrismicLinkTypeFieldSelector>
    hubspot_form_id: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    what_s_inside_points: InputMaybe<PrismicEbookMarketingDownloadDataWhatSInsidePointsFieldSelector>
}

export type PrismicEbookMarketingDownloadDataTypeFilterInput = {
    campaign: InputMaybe<StringQueryOperatorInput>
    cover_image: InputMaybe<PrismicEbookMarketingDownloadDataCoverImageImageTypeFilterInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    file: InputMaybe<PrismicLinkTypeFilterInput>
    hubspot_form_id: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    what_s_inside_points: InputMaybe<PrismicEbookMarketingDownloadDataWhatSInsidePointsFilterListInput>
}

export type PrismicEbookMarketingDownloadDataTypeSortInput = {
    campaign: InputMaybe<SortOrderEnum>
    cover_image: InputMaybe<PrismicEbookMarketingDownloadDataCoverImageImageTypeSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    file: InputMaybe<PrismicLinkTypeSortInput>
    hubspot_form_id: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicEbookMarketingDownloadDataOpenGraphImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    what_s_inside_points: InputMaybe<PrismicEbookMarketingDownloadDataWhatSInsidePointsSortInput>
}

export type PrismicEbookMarketingDownloadDataWhatSInsidePoints = {
    point: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingDownloadDataWhatSInsidePointsFieldSelector = {
    point: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingDownloadDataWhatSInsidePointsFilterInput = {
    point: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingDownloadDataWhatSInsidePointsFilterListInput = {
    elemMatch: InputMaybe<PrismicEbookMarketingDownloadDataWhatSInsidePointsFilterInput>
}

export type PrismicEbookMarketingDownloadDataWhatSInsidePointsSortInput = {
    point: InputMaybe<SortOrderEnum>
}

export type PrismicEbookMarketingDownloadEdge = {
    next: Maybe<PrismicEbookMarketingDownload>
    node: PrismicEbookMarketingDownload
    previous: Maybe<PrismicEbookMarketingDownload>
}

export type PrismicEbookMarketingDownloadFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEbookMarketingDownloadDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingDownloadFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookMarketingDownloadDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingDownloadGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookMarketingDownloadEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookMarketingDownloadGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookMarketingDownload>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookMarketingDownloadGroupConnectionDistinctArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadGroupConnectionGroupArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingDownloadGroupConnectionMaxArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadGroupConnectionMinArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadGroupConnectionSumArgs = {
    field: PrismicEbookMarketingDownloadFieldSelector
}

export type PrismicEbookMarketingDownloadSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEbookMarketingDownloadDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookMarketingPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEbookMarketingPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookMarketingPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbookMarketingPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookMarketingPageEdge>
    group: Array<PrismicEbookMarketingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookMarketingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookMarketingPageConnectionDistinctArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageConnectionGroupArgs = {
    field: PrismicEbookMarketingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingPageConnectionMaxArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageConnectionMinArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageConnectionSumArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageDataType = {
    form_error_text: Maybe<Scalars['String']['output']>
    form_pre_title: Maybe<Scalars['String']['output']>
    form_submit_text: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    thank_you_download_button_label: Maybe<Scalars['String']['output']>
    thank_you_heading: Maybe<Scalars['String']['output']>
    thank_you_return_button_label: Maybe<Scalars['String']['output']>
    thank_you_signup_text: Maybe<PrismicStructuredTextType>
    thank_you_text: Maybe<PrismicStructuredTextType>
    what_s_inside_text: Maybe<Scalars['String']['output']>
}

export type PrismicEbookMarketingPageDataTypeFieldSelector = {
    form_error_text: InputMaybe<FieldSelectorEnum>
    form_pre_title: InputMaybe<FieldSelectorEnum>
    form_submit_text: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    thank_you_download_button_label: InputMaybe<FieldSelectorEnum>
    thank_you_heading: InputMaybe<FieldSelectorEnum>
    thank_you_return_button_label: InputMaybe<FieldSelectorEnum>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    what_s_inside_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingPageDataTypeFilterInput = {
    form_error_text: InputMaybe<StringQueryOperatorInput>
    form_pre_title: InputMaybe<StringQueryOperatorInput>
    form_submit_text: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    thank_you_download_button_label: InputMaybe<StringQueryOperatorInput>
    thank_you_heading: InputMaybe<StringQueryOperatorInput>
    thank_you_return_button_label: InputMaybe<StringQueryOperatorInput>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    what_s_inside_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingPageDataTypeSortInput = {
    form_error_text: InputMaybe<SortOrderEnum>
    form_pre_title: InputMaybe<SortOrderEnum>
    form_submit_text: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    thank_you_download_button_label: InputMaybe<SortOrderEnum>
    thank_you_heading: InputMaybe<SortOrderEnum>
    thank_you_return_button_label: InputMaybe<SortOrderEnum>
    thank_you_signup_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    thank_you_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    what_s_inside_text: InputMaybe<SortOrderEnum>
}

export type PrismicEbookMarketingPageEdge = {
    next: Maybe<PrismicEbookMarketingPage>
    node: PrismicEbookMarketingPage
    previous: Maybe<PrismicEbookMarketingPage>
}

export type PrismicEbookMarketingPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEbookMarketingPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbookMarketingPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookMarketingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbookMarketingPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbookMarketingPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbookMarketingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbookMarketingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbookMarketingPageGroupConnectionDistinctArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageGroupConnectionGroupArgs = {
    field: PrismicEbookMarketingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbookMarketingPageGroupConnectionMaxArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageGroupConnectionMinArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageGroupConnectionSumArgs = {
    field: PrismicEbookMarketingPageFieldSelector
}

export type PrismicEbookMarketingPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEbookMarketingPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbookSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEbookDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbooksIndex = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEbooksIndexDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbooksIndexFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbooksIndexLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEbooksIndexConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbooksIndexEdge>
    group: Array<PrismicEbooksIndexGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbooksIndex>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbooksIndexConnectionDistinctArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexConnectionGroupArgs = {
    field: PrismicEbooksIndexFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbooksIndexConnectionMaxArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexConnectionMinArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexConnectionSumArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexDataEbooks = {
    ebook: Maybe<PrismicLinkType>
}

export type PrismicEbooksIndexDataEbooksFieldSelector = {
    ebook: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicEbooksIndexDataEbooksFilterInput = {
    ebook: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicEbooksIndexDataEbooksFilterListInput = {
    elemMatch: InputMaybe<PrismicEbooksIndexDataEbooksFilterInput>
}

export type PrismicEbooksIndexDataEbooksSortInput = {
    ebook: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicEbooksIndexDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbooksIndexDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEbooksIndexDataType = {
    ebook_link_text: Maybe<Scalars['String']['output']>
    ebooks: Maybe<Array<Maybe<PrismicEbooksIndexDataEbooks>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicEbooksIndexDataOpenGraphImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicEbooksIndexDataTypeFieldSelector = {
    ebook_link_text: InputMaybe<FieldSelectorEnum>
    ebooks: InputMaybe<PrismicEbooksIndexDataEbooksFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicEbooksIndexDataOpenGraphImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbooksIndexDataTypeFilterInput = {
    ebook_link_text: InputMaybe<StringQueryOperatorInput>
    ebooks: InputMaybe<PrismicEbooksIndexDataEbooksFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicEbooksIndexDataOpenGraphImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbooksIndexDataTypeSortInput = {
    ebook_link_text: InputMaybe<SortOrderEnum>
    ebooks: InputMaybe<PrismicEbooksIndexDataEbooksSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicEbooksIndexDataOpenGraphImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicEbooksIndexEdge = {
    next: Maybe<PrismicEbooksIndex>
    node: PrismicEbooksIndex
    previous: Maybe<PrismicEbooksIndex>
}

export type PrismicEbooksIndexFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEbooksIndexDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEbooksIndexFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbooksIndexDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEbooksIndexGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEbooksIndexEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEbooksIndexGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEbooksIndex>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEbooksIndexGroupConnectionDistinctArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexGroupConnectionGroupArgs = {
    field: PrismicEbooksIndexFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEbooksIndexGroupConnectionMaxArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexGroupConnectionMinArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexGroupConnectionSumArgs = {
    field: PrismicEbooksIndexFieldSelector
}

export type PrismicEbooksIndexSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEbooksIndexDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEmbedType = Node & {
    aspectRatio: Maybe<Scalars['String']['output']>
    children: Array<Node>
    height: Maybe<Scalars['String']['output']>
    html: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    width: Maybe<Scalars['String']['output']>
}

export type PrismicEmbedTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEmbedTypeEdge>
    group: Array<PrismicEmbedTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEmbedType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEmbedTypeConnectionDistinctArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeConnectionGroupArgs = {
    field: PrismicEmbedTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEmbedTypeConnectionMaxArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeConnectionMinArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeConnectionSumArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeEdge = {
    next: Maybe<PrismicEmbedType>
    node: PrismicEmbedType
    previous: Maybe<PrismicEmbedType>
}

export type PrismicEmbedTypeFieldSelector = {
    aspectRatio: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    height: InputMaybe<FieldSelectorEnum>
    html: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    width: InputMaybe<FieldSelectorEnum>
}

export type PrismicEmbedTypeFilterInput = {
    aspectRatio: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    height: InputMaybe<StringQueryOperatorInput>
    html: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    width: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEmbedTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEmbedTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEmbedTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEmbedType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEmbedTypeGroupConnectionDistinctArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeGroupConnectionGroupArgs = {
    field: PrismicEmbedTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEmbedTypeGroupConnectionMaxArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeGroupConnectionMinArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeGroupConnectionSumArgs = {
    field: PrismicEmbedTypeFieldSelector
}

export type PrismicEmbedTypeSortInput = {
    aspectRatio: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    height: InputMaybe<SortOrderEnum>
    html: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    width: InputMaybe<SortOrderEnum>
}

export type PrismicEvent = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEventDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEventFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventBigformPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEventBigformPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEventBigformPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventBigformPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventBigformPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventBigformPageEdge>
    group: Array<PrismicEventBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEventBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventBigformPageConnectionDistinctArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageConnectionGroupArgs = {
    field: PrismicEventBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventBigformPageConnectionMaxArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageConnectionMinArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageConnectionSumArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEventBigformPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEventBigformPageDataType = {
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicEventBigformPageDataOpenGraphImageImageType>
}

export type PrismicEventBigformPageDataTypeFieldSelector = {
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicEventBigformPageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicEventBigformPageDataTypeFilterInput = {
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicEventBigformPageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicEventBigformPageDataTypeSortInput = {
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicEventBigformPageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicEventBigformPageEdge = {
    next: Maybe<PrismicEventBigformPage>
    node: PrismicEventBigformPage
    previous: Maybe<PrismicEventBigformPage>
}

export type PrismicEventBigformPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEventBigformPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEventBigformPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEventBigformPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventBigformPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEventBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEventBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventBigformPageGroupConnectionDistinctArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageGroupConnectionGroupArgs = {
    field: PrismicEventBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventBigformPageGroupConnectionMaxArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageGroupConnectionMinArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageGroupConnectionSumArgs = {
    field: PrismicEventBigformPageFieldSelector
}

export type PrismicEventBigformPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEventBigformPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEventConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventEdge>
    group: Array<PrismicEventGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEvent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventConnectionDistinctArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventConnectionGroupArgs = {
    field: PrismicEventFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventConnectionMaxArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventConnectionMinArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventConnectionSumArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventDataType = {
    date: Maybe<Scalars['Date']['output']>
    link: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicEventDataTypeDateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventDataTypeFieldSelector = {
    date: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicEventDataTypeFilterInput = {
    date: InputMaybe<DateQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEventDataTypeSortInput = {
    date: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicEventEdge = {
    next: Maybe<PrismicEvent>
    node: PrismicEvent
    previous: Maybe<PrismicEvent>
}

export type PrismicEventFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEventDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEventFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEventForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicEventFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicEventFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicEventFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventFormEdge>
    group: Array<PrismicEventFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEventForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventFormConnectionDistinctArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormConnectionGroupArgs = {
    field: PrismicEventFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventFormConnectionMaxArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormConnectionMinArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormConnectionSumArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormDataType = {
    aria_label: Maybe<Scalars['String']['output']>
    bigform_terms_copy: Maybe<PrismicStructuredTextType>
    consent_error_text: Maybe<Scalars['String']['output']>
    consent_text: Maybe<PrismicStructuredTextType>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    success_page: Maybe<PrismicLinkType>
}

export type PrismicEventFormDataTypeFieldSelector = {
    aria_label: InputMaybe<FieldSelectorEnum>
    bigform_terms_copy: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    consent_error_text: InputMaybe<FieldSelectorEnum>
    consent_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    success_page: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicEventFormDataTypeFilterInput = {
    aria_label: InputMaybe<StringQueryOperatorInput>
    bigform_terms_copy: InputMaybe<PrismicStructuredTextTypeFilterInput>
    consent_error_text: InputMaybe<StringQueryOperatorInput>
    consent_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    success_page: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicEventFormDataTypeSortInput = {
    aria_label: InputMaybe<SortOrderEnum>
    bigform_terms_copy: InputMaybe<PrismicStructuredTextTypeSortInput>
    consent_error_text: InputMaybe<SortOrderEnum>
    consent_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    success_page: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicEventFormEdge = {
    next: Maybe<PrismicEventForm>
    node: PrismicEventForm
    previous: Maybe<PrismicEventForm>
}

export type PrismicEventFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicEventFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicEventFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicEventFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEventFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEventForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventFormGroupConnectionDistinctArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormGroupConnectionGroupArgs = {
    field: PrismicEventFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventFormGroupConnectionMaxArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormGroupConnectionMinArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormGroupConnectionSumArgs = {
    field: PrismicEventFormFieldSelector
}

export type PrismicEventFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEventFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicEventGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicEventEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicEventGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicEvent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicEventGroupConnectionDistinctArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventGroupConnectionGroupArgs = {
    field: PrismicEventFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicEventGroupConnectionMaxArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventGroupConnectionMinArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventGroupConnectionSumArgs = {
    field: PrismicEventFieldSelector
}

export type PrismicEventSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicEventDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilder = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicExpensePolicyBuilderDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExpensePolicyBuilderLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExpensePolicyBuilderConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderEdge>
    group: Array<PrismicExpensePolicyBuilderGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilder>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderConnectionDistinctArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderDataAccommodation = {
    budget_per_night: Maybe<Scalars['String']['output']>
    budget_per_night_placeholder: Maybe<Scalars['String']['output']>
    covered_by_per_diem: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    how_to_book_trips: Maybe<Scalars['String']['output']>
    how_to_book_trips_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataAccommodationFieldSelector = {
    budget_per_night: InputMaybe<FieldSelectorEnum>
    budget_per_night_placeholder: InputMaybe<FieldSelectorEnum>
    covered_by_per_diem: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    how_to_book_trips: InputMaybe<FieldSelectorEnum>
    how_to_book_trips_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataAccommodationFilterInput = {
    budget_per_night: InputMaybe<StringQueryOperatorInput>
    budget_per_night_placeholder: InputMaybe<StringQueryOperatorInput>
    covered_by_per_diem: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    how_to_book_trips: InputMaybe<StringQueryOperatorInput>
    how_to_book_trips_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataAccommodationFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataAccommodationFilterInput>
}

export type PrismicExpensePolicyBuilderDataAccommodationSortInput = {
    budget_per_night: InputMaybe<SortOrderEnum>
    budget_per_night_placeholder: InputMaybe<SortOrderEnum>
    covered_by_per_diem: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    how_to_book_trips: InputMaybe<SortOrderEnum>
    how_to_book_trips_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataAllDone = {
    copied_text: Maybe<Scalars['String']['output']>
    download_pdf: Maybe<Scalars['String']['output']>
    download_pdf_cta_text: Maybe<Scalars['String']['output']>
    email: Maybe<Scalars['String']['output']>
    email_placeholder: Maybe<Scalars['String']['output']>
    privacy_policy: Maybe<PrismicStructuredTextType>
    sharable_link_cta_text: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataAllDoneFieldSelector = {
    copied_text: InputMaybe<FieldSelectorEnum>
    download_pdf: InputMaybe<FieldSelectorEnum>
    download_pdf_cta_text: InputMaybe<FieldSelectorEnum>
    email: InputMaybe<FieldSelectorEnum>
    email_placeholder: InputMaybe<FieldSelectorEnum>
    privacy_policy: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    sharable_link_cta_text: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataAllDoneFilterInput = {
    copied_text: InputMaybe<StringQueryOperatorInput>
    download_pdf: InputMaybe<StringQueryOperatorInput>
    download_pdf_cta_text: InputMaybe<StringQueryOperatorInput>
    email: InputMaybe<StringQueryOperatorInput>
    email_placeholder: InputMaybe<StringQueryOperatorInput>
    privacy_policy: InputMaybe<PrismicStructuredTextTypeFilterInput>
    sharable_link_cta_text: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataAllDoneFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataAllDoneFilterInput>
}

export type PrismicExpensePolicyBuilderDataAllDoneSortInput = {
    copied_text: InputMaybe<SortOrderEnum>
    download_pdf: InputMaybe<SortOrderEnum>
    download_pdf_cta_text: InputMaybe<SortOrderEnum>
    email: InputMaybe<SortOrderEnum>
    email_placeholder: InputMaybe<SortOrderEnum>
    privacy_policy: InputMaybe<PrismicStructuredTextTypeSortInput>
    sharable_link_cta_text: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataConferences = {
    conference_amount: Maybe<Scalars['String']['output']>
    conference_amount_placeholder: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataConferencesFieldSelector = {
    conference_amount: InputMaybe<FieldSelectorEnum>
    conference_amount_placeholder: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataConferencesFilterInput = {
    conference_amount: InputMaybe<StringQueryOperatorInput>
    conference_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataConferencesFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataConferencesFilterInput>
}

export type PrismicExpensePolicyBuilderDataConferencesSortInput = {
    conference_amount: InputMaybe<SortOrderEnum>
    conference_amount_placeholder: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataDetails = {
    contact: Maybe<Scalars['String']['output']>
    contact_email: Maybe<Scalars['String']['output']>
    contact_name: Maybe<Scalars['String']['output']>
    detail_days: Maybe<Scalars['String']['output']>
    detail_days_placeholder: Maybe<Scalars['String']['output']>
    details_reimbursement: Maybe<Scalars['String']['output']>
    details_reimbursement_placeholder: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataDetailsFieldSelector = {
    contact: InputMaybe<FieldSelectorEnum>
    contact_email: InputMaybe<FieldSelectorEnum>
    contact_name: InputMaybe<FieldSelectorEnum>
    detail_days: InputMaybe<FieldSelectorEnum>
    detail_days_placeholder: InputMaybe<FieldSelectorEnum>
    details_reimbursement: InputMaybe<FieldSelectorEnum>
    details_reimbursement_placeholder: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataDetailsFilterInput = {
    contact: InputMaybe<StringQueryOperatorInput>
    contact_email: InputMaybe<StringQueryOperatorInput>
    contact_name: InputMaybe<StringQueryOperatorInput>
    detail_days: InputMaybe<StringQueryOperatorInput>
    detail_days_placeholder: InputMaybe<StringQueryOperatorInput>
    details_reimbursement: InputMaybe<StringQueryOperatorInput>
    details_reimbursement_placeholder: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataDetailsFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataDetailsFilterInput>
}

export type PrismicExpensePolicyBuilderDataDetailsSortInput = {
    contact: InputMaybe<SortOrderEnum>
    contact_email: InputMaybe<SortOrderEnum>
    contact_name: InputMaybe<SortOrderEnum>
    detail_days: InputMaybe<SortOrderEnum>
    detail_days_placeholder: InputMaybe<SortOrderEnum>
    details_reimbursement: InputMaybe<SortOrderEnum>
    details_reimbursement_placeholder: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataFood = {
    breakfast: Maybe<Scalars['String']['output']>
    breakfast_placeholder: Maybe<Scalars['String']['output']>
    covered_by_per_diem: Maybe<Scalars['String']['output']>
    dinner: Maybe<Scalars['String']['output']>
    dinner_placeholder: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    lunch: Maybe<Scalars['String']['output']>
    lunch_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataFoodFieldSelector = {
    breakfast: InputMaybe<FieldSelectorEnum>
    breakfast_placeholder: InputMaybe<FieldSelectorEnum>
    covered_by_per_diem: InputMaybe<FieldSelectorEnum>
    dinner: InputMaybe<FieldSelectorEnum>
    dinner_placeholder: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    lunch: InputMaybe<FieldSelectorEnum>
    lunch_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataFoodFilterInput = {
    breakfast: InputMaybe<StringQueryOperatorInput>
    breakfast_placeholder: InputMaybe<StringQueryOperatorInput>
    covered_by_per_diem: InputMaybe<StringQueryOperatorInput>
    dinner: InputMaybe<StringQueryOperatorInput>
    dinner_placeholder: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    lunch: InputMaybe<StringQueryOperatorInput>
    lunch_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataFoodFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataFoodFilterInput>
}

export type PrismicExpensePolicyBuilderDataFoodSortInput = {
    breakfast: InputMaybe<SortOrderEnum>
    breakfast_placeholder: InputMaybe<SortOrderEnum>
    covered_by_per_diem: InputMaybe<SortOrderEnum>
    dinner: InputMaybe<SortOrderEnum>
    dinner_placeholder: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    lunch: InputMaybe<SortOrderEnum>
    lunch_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
    node: PrismicExpensePolicyBuilderDataFormProductionIntegrationType
    previous: Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
    node: PrismicExpensePolicyBuilderDataFormStagingIntegrationType
    previous: Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataGifts = {
    client_amount: Maybe<Scalars['String']['output']>
    client_amount_placeholder: Maybe<Scalars['String']['output']>
    employee_amount: Maybe<Scalars['String']['output']>
    employee_amount_placeholder: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataGiftsFieldSelector = {
    client_amount: InputMaybe<FieldSelectorEnum>
    client_amount_placeholder: InputMaybe<FieldSelectorEnum>
    employee_amount: InputMaybe<FieldSelectorEnum>
    employee_amount_placeholder: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataGiftsFilterInput = {
    client_amount: InputMaybe<StringQueryOperatorInput>
    client_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    employee_amount: InputMaybe<StringQueryOperatorInput>
    employee_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataGiftsFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataGiftsFilterInput>
}

export type PrismicExpensePolicyBuilderDataGiftsSortInput = {
    client_amount: InputMaybe<SortOrderEnum>
    client_amount_placeholder: InputMaybe<SortOrderEnum>
    employee_amount: InputMaybe<SortOrderEnum>
    employee_amount_placeholder: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicExpensePolicyBuilderDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExpensePolicyBuilderDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExpensePolicyBuilderDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataImperativeConsentsFilterInput>
}

export type PrismicExpensePolicyBuilderDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreview = {
    accommodation_heading: Maybe<Scalars['String']['output']>
    accommodation_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageType>
    air_travel_budget: Maybe<Scalars['String']['output']>
    breakfast: Maybe<Scalars['String']['output']>
    budget_per_night: Maybe<Scalars['String']['output']>
    budget_per_night_per_diem: Maybe<Scalars['String']['output']>
    city_transport_budget: Maybe<Scalars['String']['output']>
    client_amount: Maybe<Scalars['String']['output']>
    conference_amount: Maybe<Scalars['String']['output']>
    conferences_heading: Maybe<Scalars['String']['output']>
    conferences_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewConferencesIconImageType>
    contact: Maybe<Scalars['String']['output']>
    detail_days: Maybe<Scalars['String']['output']>
    detail_reimbursements: Maybe<Scalars['String']['output']>
    details_heading: Maybe<Scalars['String']['output']>
    dinner: Maybe<Scalars['String']['output']>
    employee_amount: Maybe<Scalars['String']['output']>
    food_budget: Maybe<Scalars['String']['output']>
    food_covered_by_per_diem: Maybe<Scalars['String']['output']>
    food_heading: Maybe<Scalars['String']['output']>
    food_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewFoodIconImageType>
    food_subtitle: Maybe<Scalars['String']['output']>
    gifts_heading: Maybe<Scalars['String']['output']>
    gifts_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewGiftsIconImageType>
    hardware_amount: Maybe<Scalars['String']['output']>
    how_to_book_trips: Maybe<Scalars['String']['output']>
    lunch: Maybe<Scalars['String']['output']>
    mileage_budget: Maybe<Scalars['String']['output']>
    remote_heading: Maybe<Scalars['String']['output']>
    remote_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewRemoteIconImageType>
    software_amount: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    transport_heading: Maybe<Scalars['String']['output']>
    transport_icon: Maybe<PrismicExpensePolicyBuilderDataPreviewTransportIconImageType>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewFieldSelector = {
    accommodation_heading: InputMaybe<FieldSelectorEnum>
    accommodation_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFieldSelector>
    air_travel_budget: InputMaybe<FieldSelectorEnum>
    breakfast: InputMaybe<FieldSelectorEnum>
    budget_per_night: InputMaybe<FieldSelectorEnum>
    budget_per_night_per_diem: InputMaybe<FieldSelectorEnum>
    city_transport_budget: InputMaybe<FieldSelectorEnum>
    client_amount: InputMaybe<FieldSelectorEnum>
    conference_amount: InputMaybe<FieldSelectorEnum>
    conferences_heading: InputMaybe<FieldSelectorEnum>
    conferences_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFieldSelector>
    contact: InputMaybe<FieldSelectorEnum>
    detail_days: InputMaybe<FieldSelectorEnum>
    detail_reimbursements: InputMaybe<FieldSelectorEnum>
    details_heading: InputMaybe<FieldSelectorEnum>
    dinner: InputMaybe<FieldSelectorEnum>
    employee_amount: InputMaybe<FieldSelectorEnum>
    food_budget: InputMaybe<FieldSelectorEnum>
    food_covered_by_per_diem: InputMaybe<FieldSelectorEnum>
    food_heading: InputMaybe<FieldSelectorEnum>
    food_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFieldSelector>
    food_subtitle: InputMaybe<FieldSelectorEnum>
    gifts_heading: InputMaybe<FieldSelectorEnum>
    gifts_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFieldSelector>
    hardware_amount: InputMaybe<FieldSelectorEnum>
    how_to_book_trips: InputMaybe<FieldSelectorEnum>
    lunch: InputMaybe<FieldSelectorEnum>
    mileage_budget: InputMaybe<FieldSelectorEnum>
    remote_heading: InputMaybe<FieldSelectorEnum>
    remote_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFieldSelector>
    software_amount: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    transport_heading: InputMaybe<FieldSelectorEnum>
    transport_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFieldSelector>
}

export type PrismicExpensePolicyBuilderDataPreviewFilterInput = {
    accommodation_heading: InputMaybe<StringQueryOperatorInput>
    accommodation_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeFilterInput>
    air_travel_budget: InputMaybe<StringQueryOperatorInput>
    breakfast: InputMaybe<StringQueryOperatorInput>
    budget_per_night: InputMaybe<StringQueryOperatorInput>
    budget_per_night_per_diem: InputMaybe<StringQueryOperatorInput>
    city_transport_budget: InputMaybe<StringQueryOperatorInput>
    client_amount: InputMaybe<StringQueryOperatorInput>
    conference_amount: InputMaybe<StringQueryOperatorInput>
    conferences_heading: InputMaybe<StringQueryOperatorInput>
    conferences_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeFilterInput>
    contact: InputMaybe<StringQueryOperatorInput>
    detail_days: InputMaybe<StringQueryOperatorInput>
    detail_reimbursements: InputMaybe<StringQueryOperatorInput>
    details_heading: InputMaybe<StringQueryOperatorInput>
    dinner: InputMaybe<StringQueryOperatorInput>
    employee_amount: InputMaybe<StringQueryOperatorInput>
    food_budget: InputMaybe<StringQueryOperatorInput>
    food_covered_by_per_diem: InputMaybe<StringQueryOperatorInput>
    food_heading: InputMaybe<StringQueryOperatorInput>
    food_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFilterInput>
    food_subtitle: InputMaybe<StringQueryOperatorInput>
    gifts_heading: InputMaybe<StringQueryOperatorInput>
    gifts_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFilterInput>
    hardware_amount: InputMaybe<StringQueryOperatorInput>
    how_to_book_trips: InputMaybe<StringQueryOperatorInput>
    lunch: InputMaybe<StringQueryOperatorInput>
    mileage_budget: InputMaybe<StringQueryOperatorInput>
    remote_heading: InputMaybe<StringQueryOperatorInput>
    remote_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFilterInput>
    software_amount: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    transport_heading: InputMaybe<StringQueryOperatorInput>
    transport_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFilterInput>
}

export type PrismicExpensePolicyBuilderDataPreviewFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFilterInput>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewSortInput = {
    accommodation_heading: InputMaybe<SortOrderEnum>
    accommodation_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewAccommodationIconImageTypeSortInput>
    air_travel_budget: InputMaybe<SortOrderEnum>
    breakfast: InputMaybe<SortOrderEnum>
    budget_per_night: InputMaybe<SortOrderEnum>
    budget_per_night_per_diem: InputMaybe<SortOrderEnum>
    city_transport_budget: InputMaybe<SortOrderEnum>
    client_amount: InputMaybe<SortOrderEnum>
    conference_amount: InputMaybe<SortOrderEnum>
    conferences_heading: InputMaybe<SortOrderEnum>
    conferences_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewConferencesIconImageTypeSortInput>
    contact: InputMaybe<SortOrderEnum>
    detail_days: InputMaybe<SortOrderEnum>
    detail_reimbursements: InputMaybe<SortOrderEnum>
    details_heading: InputMaybe<SortOrderEnum>
    dinner: InputMaybe<SortOrderEnum>
    employee_amount: InputMaybe<SortOrderEnum>
    food_budget: InputMaybe<SortOrderEnum>
    food_covered_by_per_diem: InputMaybe<SortOrderEnum>
    food_heading: InputMaybe<SortOrderEnum>
    food_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFoodIconImageTypeSortInput>
    food_subtitle: InputMaybe<SortOrderEnum>
    gifts_heading: InputMaybe<SortOrderEnum>
    gifts_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewGiftsIconImageTypeSortInput>
    hardware_amount: InputMaybe<SortOrderEnum>
    how_to_book_trips: InputMaybe<SortOrderEnum>
    lunch: InputMaybe<SortOrderEnum>
    mileage_budget: InputMaybe<SortOrderEnum>
    remote_heading: InputMaybe<SortOrderEnum>
    remote_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewRemoteIconImageTypeSortInput>
    software_amount: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    transport_heading: InputMaybe<SortOrderEnum>
    transport_icon: InputMaybe<PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeSortInput>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataPreviewTransportIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataRemote = {
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    hardware_amount: Maybe<Scalars['String']['output']>
    hardware_amount_placeholder: Maybe<Scalars['String']['output']>
    software_amount: Maybe<Scalars['String']['output']>
    software_amount_placeholder: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataRemoteFieldSelector = {
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    hardware_amount: InputMaybe<FieldSelectorEnum>
    hardware_amount_placeholder: InputMaybe<FieldSelectorEnum>
    software_amount: InputMaybe<FieldSelectorEnum>
    software_amount_placeholder: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataRemoteFilterInput = {
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    hardware_amount: InputMaybe<StringQueryOperatorInput>
    hardware_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    software_amount: InputMaybe<StringQueryOperatorInput>
    software_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataRemoteFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataRemoteFilterInput>
}

export type PrismicExpensePolicyBuilderDataRemoteSortInput = {
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    hardware_amount: InputMaybe<SortOrderEnum>
    hardware_amount_placeholder: InputMaybe<SortOrderEnum>
    software_amount: InputMaybe<SortOrderEnum>
    software_amount_placeholder: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataSidebar = {
    next: Maybe<Scalars['String']['output']>
    of: Maybe<Scalars['String']['output']>
    preview: Maybe<Scalars['String']['output']>
    skip: Maybe<Scalars['String']['output']>
    step: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataSidebarFieldSelector = {
    next: InputMaybe<FieldSelectorEnum>
    of: InputMaybe<FieldSelectorEnum>
    preview: InputMaybe<FieldSelectorEnum>
    skip: InputMaybe<FieldSelectorEnum>
    step: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataSidebarFilterInput = {
    next: InputMaybe<StringQueryOperatorInput>
    of: InputMaybe<StringQueryOperatorInput>
    preview: InputMaybe<StringQueryOperatorInput>
    skip: InputMaybe<StringQueryOperatorInput>
    step: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataSidebarFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataSidebarFilterInput>
}

export type PrismicExpensePolicyBuilderDataSidebarSortInput = {
    next: InputMaybe<SortOrderEnum>
    of: InputMaybe<SortOrderEnum>
    preview: InputMaybe<SortOrderEnum>
    skip: InputMaybe<SortOrderEnum>
    step: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataTransport = {
    air_travel_policy: Maybe<Scalars['String']['output']>
    air_travel_policy_placeholder: Maybe<Scalars['String']['output']>
    city_travel_policy: Maybe<Scalars['String']['output']>
    city_travel_policy_placeholder: Maybe<Scalars['String']['output']>
    extra: Maybe<Scalars['String']['output']>
    extra_placeholder: Maybe<Scalars['String']['output']>
    mileage_amount: Maybe<Scalars['String']['output']>
    mileage_amount_placeholder: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataTransportFieldSelector = {
    air_travel_policy: InputMaybe<FieldSelectorEnum>
    air_travel_policy_placeholder: InputMaybe<FieldSelectorEnum>
    city_travel_policy: InputMaybe<FieldSelectorEnum>
    city_travel_policy_placeholder: InputMaybe<FieldSelectorEnum>
    extra: InputMaybe<FieldSelectorEnum>
    extra_placeholder: InputMaybe<FieldSelectorEnum>
    mileage_amount: InputMaybe<FieldSelectorEnum>
    mileage_amount_placeholder: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataTransportFilterInput = {
    air_travel_policy: InputMaybe<StringQueryOperatorInput>
    air_travel_policy_placeholder: InputMaybe<StringQueryOperatorInput>
    city_travel_policy: InputMaybe<StringQueryOperatorInput>
    city_travel_policy_placeholder: InputMaybe<StringQueryOperatorInput>
    extra: InputMaybe<StringQueryOperatorInput>
    extra_placeholder: InputMaybe<StringQueryOperatorInput>
    mileage_amount: InputMaybe<StringQueryOperatorInput>
    mileage_amount_placeholder: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataTransportFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataTransportFilterInput>
}

export type PrismicExpensePolicyBuilderDataTransportSortInput = {
    air_travel_policy: InputMaybe<SortOrderEnum>
    air_travel_policy_placeholder: InputMaybe<SortOrderEnum>
    city_travel_policy: InputMaybe<SortOrderEnum>
    city_travel_policy_placeholder: InputMaybe<SortOrderEnum>
    extra: InputMaybe<SortOrderEnum>
    extra_placeholder: InputMaybe<SortOrderEnum>
    mileage_amount: InputMaybe<SortOrderEnum>
    mileage_amount_placeholder: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataType = {
    accommodation: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataAccommodation>>>
    all_done: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataAllDone>>>
    conferences: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataConferences>>>
    details: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataDetails>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    food: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataFood>>>
    form_production: Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
    gifts: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataGifts>>>
    imperative_consents: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataImperativeConsents>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicExpensePolicyBuilderDataOpenGraphImageImageType>
    preview: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataPreview>>>
    prismic_title: Maybe<Scalars['String']['output']>
    remote: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataRemote>>>
    sidebar: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataSidebar>>>
    transport: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataTransport>>>
    welcome: Maybe<Array<Maybe<PrismicExpensePolicyBuilderDataWelcome>>>
}

export type PrismicExpensePolicyBuilderDataTypeFieldSelector = {
    accommodation: InputMaybe<PrismicExpensePolicyBuilderDataAccommodationFieldSelector>
    all_done: InputMaybe<PrismicExpensePolicyBuilderDataAllDoneFieldSelector>
    conferences: InputMaybe<PrismicExpensePolicyBuilderDataConferencesFieldSelector>
    details: InputMaybe<PrismicExpensePolicyBuilderDataDetailsFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    food: InputMaybe<PrismicExpensePolicyBuilderDataFoodFieldSelector>
    form_production: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFieldSelector>
    gifts: InputMaybe<PrismicExpensePolicyBuilderDataGiftsFieldSelector>
    imperative_consents: InputMaybe<PrismicExpensePolicyBuilderDataImperativeConsentsFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFieldSelector>
    preview: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    remote: InputMaybe<PrismicExpensePolicyBuilderDataRemoteFieldSelector>
    sidebar: InputMaybe<PrismicExpensePolicyBuilderDataSidebarFieldSelector>
    transport: InputMaybe<PrismicExpensePolicyBuilderDataTransportFieldSelector>
    welcome: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeFieldSelector>
}

export type PrismicExpensePolicyBuilderDataTypeFilterInput = {
    accommodation: InputMaybe<PrismicExpensePolicyBuilderDataAccommodationFilterListInput>
    all_done: InputMaybe<PrismicExpensePolicyBuilderDataAllDoneFilterListInput>
    conferences: InputMaybe<PrismicExpensePolicyBuilderDataConferencesFilterListInput>
    details: InputMaybe<PrismicExpensePolicyBuilderDataDetailsFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    food: InputMaybe<PrismicExpensePolicyBuilderDataFoodFilterListInput>
    form_production: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFilterInput>
    gifts: InputMaybe<PrismicExpensePolicyBuilderDataGiftsFilterListInput>
    imperative_consents: InputMaybe<PrismicExpensePolicyBuilderDataImperativeConsentsFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeFilterInput>
    preview: InputMaybe<PrismicExpensePolicyBuilderDataPreviewFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    remote: InputMaybe<PrismicExpensePolicyBuilderDataRemoteFilterListInput>
    sidebar: InputMaybe<PrismicExpensePolicyBuilderDataSidebarFilterListInput>
    transport: InputMaybe<PrismicExpensePolicyBuilderDataTransportFilterListInput>
    welcome: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeFilterListInput>
}

export type PrismicExpensePolicyBuilderDataTypeSortInput = {
    accommodation: InputMaybe<PrismicExpensePolicyBuilderDataAccommodationSortInput>
    all_done: InputMaybe<PrismicExpensePolicyBuilderDataAllDoneSortInput>
    conferences: InputMaybe<PrismicExpensePolicyBuilderDataConferencesSortInput>
    details: InputMaybe<PrismicExpensePolicyBuilderDataDetailsSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    food: InputMaybe<PrismicExpensePolicyBuilderDataFoodSortInput>
    form_production: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeSortInput>
    gifts: InputMaybe<PrismicExpensePolicyBuilderDataGiftsSortInput>
    imperative_consents: InputMaybe<PrismicExpensePolicyBuilderDataImperativeConsentsSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicExpensePolicyBuilderDataOpenGraphImageImageTypeSortInput>
    preview: InputMaybe<PrismicExpensePolicyBuilderDataPreviewSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    remote: InputMaybe<PrismicExpensePolicyBuilderDataRemoteSortInput>
    sidebar: InputMaybe<PrismicExpensePolicyBuilderDataSidebarSortInput>
    transport: InputMaybe<PrismicExpensePolicyBuilderDataTransportSortInput>
    welcome: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeSortInput>
}

export type PrismicExpensePolicyBuilderDataWelcome = {
    body: Maybe<Scalars['String']['output']>
    company_name: Maybe<Scalars['String']['output']>
    company_name_placeholder: Maybe<Scalars['String']['output']>
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicExpensePolicyBuilderDataWelcomeImageImageType>
    start_button_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataWelcomeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    company_name: InputMaybe<FieldSelectorEnum>
    company_name_placeholder: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFieldSelector>
    start_button_label: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataWelcomeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    company_name: InputMaybe<StringQueryOperatorInput>
    company_name_placeholder: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFilterInput>
    start_button_label: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataWelcomeFilterListInput = {
    elemMatch: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeFilterInput>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderDataWelcomeImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderDataWelcomeSortInput = {
    body: InputMaybe<SortOrderEnum>
    company_name: InputMaybe<SortOrderEnum>
    company_name_placeholder: InputMaybe<SortOrderEnum>
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicExpensePolicyBuilderDataWelcomeImageImageTypeSortInput>
    start_button_label: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExpensePolicyBuilderEdge = {
    next: Maybe<PrismicExpensePolicyBuilder>
    node: PrismicExpensePolicyBuilder
    previous: Maybe<PrismicExpensePolicyBuilder>
}

export type PrismicExpensePolicyBuilderFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicExpensePolicyBuilderDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpensePolicyBuilderFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExpensePolicyBuilderDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpensePolicyBuilderGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpensePolicyBuilderEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExpensePolicyBuilderGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpensePolicyBuilder>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpensePolicyBuilderGroupConnectionDistinctArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderGroupConnectionGroupArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpensePolicyBuilderGroupConnectionMaxArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderGroupConnectionMinArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderGroupConnectionSumArgs = {
    field: PrismicExpensePolicyBuilderFieldSelector
}

export type PrismicExpensePolicyBuilderSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicExpensePolicyBuilderDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGenerator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicExpenseReportGeneratorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExpenseReportGeneratorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExpenseReportGeneratorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpenseReportGeneratorEdge>
    group: Array<PrismicExpenseReportGeneratorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpenseReportGenerator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpenseReportGeneratorConnectionDistinctArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorConnectionGroupArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorConnectionMaxArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorConnectionMinArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorConnectionSumArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorDataAlmostThere = {
    almost_there_title: Maybe<Scalars['String']['output']>
    body: Maybe<PrismicStructuredTextType>
    disclaimer: Maybe<PrismicStructuredTextType>
    download_button_text: Maybe<Scalars['String']['output']>
    email_subject: Maybe<Scalars['String']['output']>
    generate_report_button_text: Maybe<Scalars['String']['output']>
    logo_placeholder: Maybe<PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageType>
    receive_report_button_text: Maybe<Scalars['String']['output']>
    report_number: Maybe<Scalars['String']['output']>
    share_button_text: Maybe<Scalars['String']['output']>
    share_button_text_fallback: Maybe<Scalars['String']['output']>
    share_text: Maybe<Scalars['String']['output']>
    share_title: Maybe<Scalars['String']['output']>
    share_to_email_body: Maybe<Scalars['String']['output']>
    share_to_email_subject: Maybe<Scalars['String']['output']>
    share_url: Maybe<Scalars['String']['output']>
    your_company_name: Maybe<Scalars['String']['output']>
    your_first_and_last_name: Maybe<Scalars['String']['output']>
    your_name: Maybe<Scalars['String']['output']>
    your_report_number: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataAlmostThereFieldSelector = {
    almost_there_title: InputMaybe<FieldSelectorEnum>
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    disclaimer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    download_button_text: InputMaybe<FieldSelectorEnum>
    email_subject: InputMaybe<FieldSelectorEnum>
    generate_report_button_text: InputMaybe<FieldSelectorEnum>
    logo_placeholder: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFieldSelector>
    receive_report_button_text: InputMaybe<FieldSelectorEnum>
    report_number: InputMaybe<FieldSelectorEnum>
    share_button_text: InputMaybe<FieldSelectorEnum>
    share_button_text_fallback: InputMaybe<FieldSelectorEnum>
    share_text: InputMaybe<FieldSelectorEnum>
    share_title: InputMaybe<FieldSelectorEnum>
    share_to_email_body: InputMaybe<FieldSelectorEnum>
    share_to_email_subject: InputMaybe<FieldSelectorEnum>
    share_url: InputMaybe<FieldSelectorEnum>
    your_company_name: InputMaybe<FieldSelectorEnum>
    your_first_and_last_name: InputMaybe<FieldSelectorEnum>
    your_name: InputMaybe<FieldSelectorEnum>
    your_report_number: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataAlmostThereFilterInput = {
    almost_there_title: InputMaybe<StringQueryOperatorInput>
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    disclaimer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    download_button_text: InputMaybe<StringQueryOperatorInput>
    email_subject: InputMaybe<StringQueryOperatorInput>
    generate_report_button_text: InputMaybe<StringQueryOperatorInput>
    logo_placeholder: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFilterInput>
    receive_report_button_text: InputMaybe<StringQueryOperatorInput>
    report_number: InputMaybe<StringQueryOperatorInput>
    share_button_text: InputMaybe<StringQueryOperatorInput>
    share_button_text_fallback: InputMaybe<StringQueryOperatorInput>
    share_text: InputMaybe<StringQueryOperatorInput>
    share_title: InputMaybe<StringQueryOperatorInput>
    share_to_email_body: InputMaybe<StringQueryOperatorInput>
    share_to_email_subject: InputMaybe<StringQueryOperatorInput>
    share_url: InputMaybe<StringQueryOperatorInput>
    your_company_name: InputMaybe<StringQueryOperatorInput>
    your_first_and_last_name: InputMaybe<StringQueryOperatorInput>
    your_name: InputMaybe<StringQueryOperatorInput>
    your_report_number: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataAlmostThereFilterListInput = {
    elemMatch: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereFilterInput>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataAlmostThereSortInput = {
    almost_there_title: InputMaybe<SortOrderEnum>
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    disclaimer: InputMaybe<PrismicStructuredTextTypeSortInput>
    download_button_text: InputMaybe<SortOrderEnum>
    email_subject: InputMaybe<SortOrderEnum>
    generate_report_button_text: InputMaybe<SortOrderEnum>
    logo_placeholder: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereLogoPlaceholderImageTypeSortInput>
    receive_report_button_text: InputMaybe<SortOrderEnum>
    report_number: InputMaybe<SortOrderEnum>
    share_button_text: InputMaybe<SortOrderEnum>
    share_button_text_fallback: InputMaybe<SortOrderEnum>
    share_text: InputMaybe<SortOrderEnum>
    share_title: InputMaybe<SortOrderEnum>
    share_to_email_body: InputMaybe<SortOrderEnum>
    share_to_email_subject: InputMaybe<SortOrderEnum>
    share_url: InputMaybe<SortOrderEnum>
    your_company_name: InputMaybe<SortOrderEnum>
    your_first_and_last_name: InputMaybe<SortOrderEnum>
    your_name: InputMaybe<SortOrderEnum>
    your_report_number: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataEmailContent = {
    email_body: Maybe<Scalars['String']['output']>
    email_subject: Maybe<Scalars['String']['output']>
    explore_pleo_button_link: Maybe<PrismicLinkType>
    explore_pleo_button_text: Maybe<Scalars['String']['output']>
    hello_there: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataEmailContentFieldSelector = {
    email_body: InputMaybe<FieldSelectorEnum>
    email_subject: InputMaybe<FieldSelectorEnum>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeFieldSelector>
    explore_pleo_button_text: InputMaybe<FieldSelectorEnum>
    hello_there: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataEmailContentFilterInput = {
    email_body: InputMaybe<StringQueryOperatorInput>
    email_subject: InputMaybe<StringQueryOperatorInput>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeFilterInput>
    explore_pleo_button_text: InputMaybe<StringQueryOperatorInput>
    hello_there: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataEmailContentFilterListInput = {
    elemMatch: InputMaybe<PrismicExpenseReportGeneratorDataEmailContentFilterInput>
}

export type PrismicExpenseReportGeneratorDataEmailContentSortInput = {
    email_body: InputMaybe<SortOrderEnum>
    email_subject: InputMaybe<SortOrderEnum>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeSortInput>
    explore_pleo_button_text: InputMaybe<SortOrderEnum>
    hello_there: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataLoadingFacts = {
    fact: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataLoadingFactsFieldSelector = {
    fact: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataLoadingFactsFilterInput = {
    fact: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataLoadingFactsFilterListInput = {
    elemMatch: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFactsFilterInput>
}

export type PrismicExpenseReportGeneratorDataLoadingFactsSortInput = {
    fact: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataSuccessScreen = {
    button_link: Maybe<PrismicLinkType>
    button_text: Maybe<Scalars['String']['output']>
    create_another_report: Maybe<Scalars['String']['output']>
    download_report_button_text: Maybe<Scalars['String']['output']>
    explore_pleo_button_link: Maybe<PrismicLinkType>
    explore_pleo_button_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicExpenseReportGeneratorDataSuccessScreenImageImageType>
    success_body: Maybe<Scalars['String']['output']>
    success_title: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenFieldSelector = {
    button_link: InputMaybe<PrismicLinkTypeFieldSelector>
    button_text: InputMaybe<FieldSelectorEnum>
    create_another_report: InputMaybe<FieldSelectorEnum>
    download_report_button_text: InputMaybe<FieldSelectorEnum>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeFieldSelector>
    explore_pleo_button_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFieldSelector>
    success_body: InputMaybe<FieldSelectorEnum>
    success_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenFilterInput = {
    button_link: InputMaybe<PrismicLinkTypeFilterInput>
    button_text: InputMaybe<StringQueryOperatorInput>
    create_another_report: InputMaybe<StringQueryOperatorInput>
    download_report_button_text: InputMaybe<StringQueryOperatorInput>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeFilterInput>
    explore_pleo_button_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFilterInput>
    success_body: InputMaybe<StringQueryOperatorInput>
    success_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenFilterListInput = {
    elemMatch: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenFilterInput>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataSuccessScreenSortInput = {
    button_link: InputMaybe<PrismicLinkTypeSortInput>
    button_text: InputMaybe<SortOrderEnum>
    create_another_report: InputMaybe<SortOrderEnum>
    download_report_button_text: InputMaybe<SortOrderEnum>
    explore_pleo_button_link: InputMaybe<PrismicLinkTypeSortInput>
    explore_pleo_button_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenImageImageTypeSortInput>
    success_body: InputMaybe<SortOrderEnum>
    success_title: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorDataType = {
    add_expense: Maybe<Scalars['String']['output']>
    allow_indexing: Maybe<Scalars['Boolean']['output']>
    almost_there: Maybe<Array<Maybe<PrismicExpenseReportGeneratorDataAlmostThere>>>
    amount: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    date: Maybe<Scalars['String']['output']>
    delete_expense: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    did_you_know: Maybe<Scalars['String']['output']>
    email_content: Maybe<Array<Maybe<PrismicExpenseReportGeneratorDataEmailContent>>>
    employee: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    expense: Maybe<Scalars['String']['output']>
    expense_report: Maybe<Scalars['String']['output']>
    expenses_dashboard: Maybe<Scalars['String']['output']>
    generate_expense_report: Maybe<Scalars['String']['output']>
    header_cta: Maybe<Scalars['String']['output']>
    header_cta_link: Maybe<PrismicLinkType>
    header_link: Maybe<PrismicStructuredTextType>
    loading_facts: Maybe<Array<Maybe<PrismicExpenseReportGeneratorDataLoadingFacts>>>
    loading_fallback_image: Maybe<PrismicExpenseReportGeneratorDataLoadingFallbackImageImageType>
    loading_video: Maybe<PrismicLinkType>
    made_by_pleo: Maybe<PrismicStructuredTextType>
    merchant: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicExpenseReportGeneratorDataOpenGraphImageImageType>
    preview: Maybe<Scalars['String']['output']>
    preview_disclaimer: Maybe<Scalars['String']['output']>
    preview_footer: Maybe<PrismicStructuredTextType>
    project: Maybe<Scalars['String']['output']>
    report_generating: Maybe<Scalars['String']['output']>
    report_number: Maybe<Scalars['String']['output']>
    submitted_by: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    success_screen: Maybe<Array<Maybe<PrismicExpenseReportGeneratorDataSuccessScreen>>>
    title: Maybe<Scalars['String']['output']>
    total: Maybe<Scalars['String']['output']>
}

export type PrismicExpenseReportGeneratorDataTypeFieldSelector = {
    add_expense: InputMaybe<FieldSelectorEnum>
    allow_indexing: InputMaybe<FieldSelectorEnum>
    almost_there: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereFieldSelector>
    amount: InputMaybe<FieldSelectorEnum>
    category: InputMaybe<FieldSelectorEnum>
    date: InputMaybe<FieldSelectorEnum>
    delete_expense: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    did_you_know: InputMaybe<FieldSelectorEnum>
    email_content: InputMaybe<PrismicExpenseReportGeneratorDataEmailContentFieldSelector>
    employee: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    expense: InputMaybe<FieldSelectorEnum>
    expense_report: InputMaybe<FieldSelectorEnum>
    expenses_dashboard: InputMaybe<FieldSelectorEnum>
    generate_expense_report: InputMaybe<FieldSelectorEnum>
    header_cta: InputMaybe<FieldSelectorEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    header_link: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    loading_facts: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFactsFieldSelector>
    loading_fallback_image: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFieldSelector>
    loading_video: InputMaybe<PrismicLinkTypeFieldSelector>
    made_by_pleo: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    merchant: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFieldSelector>
    preview: InputMaybe<FieldSelectorEnum>
    preview_disclaimer: InputMaybe<FieldSelectorEnum>
    preview_footer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    project: InputMaybe<FieldSelectorEnum>
    report_generating: InputMaybe<FieldSelectorEnum>
    report_number: InputMaybe<FieldSelectorEnum>
    submitted_by: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    success_screen: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    total: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorDataTypeFilterInput = {
    add_expense: InputMaybe<StringQueryOperatorInput>
    allow_indexing: InputMaybe<BooleanQueryOperatorInput>
    almost_there: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereFilterListInput>
    amount: InputMaybe<StringQueryOperatorInput>
    category: InputMaybe<StringQueryOperatorInput>
    date: InputMaybe<StringQueryOperatorInput>
    delete_expense: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    did_you_know: InputMaybe<StringQueryOperatorInput>
    email_content: InputMaybe<PrismicExpenseReportGeneratorDataEmailContentFilterListInput>
    employee: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    expense: InputMaybe<StringQueryOperatorInput>
    expense_report: InputMaybe<StringQueryOperatorInput>
    expenses_dashboard: InputMaybe<StringQueryOperatorInput>
    generate_expense_report: InputMaybe<StringQueryOperatorInput>
    header_cta: InputMaybe<StringQueryOperatorInput>
    header_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    header_link: InputMaybe<PrismicStructuredTextTypeFilterInput>
    loading_facts: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFactsFilterListInput>
    loading_fallback_image: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeFilterInput>
    loading_video: InputMaybe<PrismicLinkTypeFilterInput>
    made_by_pleo: InputMaybe<PrismicStructuredTextTypeFilterInput>
    merchant: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeFilterInput>
    preview: InputMaybe<StringQueryOperatorInput>
    preview_disclaimer: InputMaybe<StringQueryOperatorInput>
    preview_footer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    project: InputMaybe<StringQueryOperatorInput>
    report_generating: InputMaybe<StringQueryOperatorInput>
    report_number: InputMaybe<StringQueryOperatorInput>
    submitted_by: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    success_screen: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
    total: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorDataTypeSortInput = {
    add_expense: InputMaybe<SortOrderEnum>
    allow_indexing: InputMaybe<SortOrderEnum>
    almost_there: InputMaybe<PrismicExpenseReportGeneratorDataAlmostThereSortInput>
    amount: InputMaybe<SortOrderEnum>
    category: InputMaybe<SortOrderEnum>
    date: InputMaybe<SortOrderEnum>
    delete_expense: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    did_you_know: InputMaybe<SortOrderEnum>
    email_content: InputMaybe<PrismicExpenseReportGeneratorDataEmailContentSortInput>
    employee: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    expense: InputMaybe<SortOrderEnum>
    expense_report: InputMaybe<SortOrderEnum>
    expenses_dashboard: InputMaybe<SortOrderEnum>
    generate_expense_report: InputMaybe<SortOrderEnum>
    header_cta: InputMaybe<SortOrderEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    header_link: InputMaybe<PrismicStructuredTextTypeSortInput>
    loading_facts: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFactsSortInput>
    loading_fallback_image: InputMaybe<PrismicExpenseReportGeneratorDataLoadingFallbackImageImageTypeSortInput>
    loading_video: InputMaybe<PrismicLinkTypeSortInput>
    made_by_pleo: InputMaybe<PrismicStructuredTextTypeSortInput>
    merchant: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicExpenseReportGeneratorDataOpenGraphImageImageTypeSortInput>
    preview: InputMaybe<SortOrderEnum>
    preview_disclaimer: InputMaybe<SortOrderEnum>
    preview_footer: InputMaybe<PrismicStructuredTextTypeSortInput>
    project: InputMaybe<SortOrderEnum>
    report_generating: InputMaybe<SortOrderEnum>
    report_number: InputMaybe<SortOrderEnum>
    submitted_by: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    success_screen: InputMaybe<PrismicExpenseReportGeneratorDataSuccessScreenSortInput>
    title: InputMaybe<SortOrderEnum>
    total: InputMaybe<SortOrderEnum>
}

export type PrismicExpenseReportGeneratorEdge = {
    next: Maybe<PrismicExpenseReportGenerator>
    node: PrismicExpenseReportGenerator
    previous: Maybe<PrismicExpenseReportGenerator>
}

export type PrismicExpenseReportGeneratorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicExpenseReportGeneratorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExpenseReportGeneratorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExpenseReportGeneratorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExpenseReportGeneratorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExpenseReportGeneratorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExpenseReportGeneratorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExpenseReportGenerator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExpenseReportGeneratorGroupConnectionDistinctArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorGroupConnectionGroupArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExpenseReportGeneratorGroupConnectionMaxArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorGroupConnectionMinArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorGroupConnectionSumArgs = {
    field: PrismicExpenseReportGeneratorFieldSelector
}

export type PrismicExpenseReportGeneratorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicExpenseReportGeneratorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExperimentalLandingPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicExperimentalLandingPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExperimentalLandingPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExperimentalLandingPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExperimentalLandingPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExperimentalLandingPageEdge>
    group: Array<PrismicExperimentalLandingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExperimentalLandingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExperimentalLandingPageConnectionDistinctArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageConnectionGroupArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExperimentalLandingPageConnectionMaxArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageConnectionMinArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageConnectionSumArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicExperimentalLandingPageDataFeatureBlocksImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksFilterInput>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExperimentalLandingPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExperimentalLandingPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicExperimentalLandingPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExperimentalLandingPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicExperimentalLandingPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExperimentalLandingPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicExperimentalLandingPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExperimentalLandingPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicExperimentalLandingPageDataHeroFilterInput>
}

export type PrismicExperimentalLandingPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExperimentalLandingPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExperimentalLandingPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicExperimentalLandingPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExperimentalLandingPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExperimentalLandingPageDataTestimonials = {
    testimonial: Maybe<PrismicLinkType>
}

export type PrismicExperimentalLandingPageDataTestimonialsFieldSelector = {
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExperimentalLandingPageDataTestimonialsFilterInput = {
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExperimentalLandingPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicExperimentalLandingPageDataTestimonialsFilterInput>
}

export type PrismicExperimentalLandingPageDataTestimonialsSortInput = {
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExperimentalLandingPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks: Maybe<Array<Maybe<PrismicExperimentalLandingPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicExperimentalLandingPageDataHero>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicExperimentalLandingPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    testimonials: Maybe<Array<Maybe<PrismicExperimentalLandingPageDataTestimonials>>>
}

export type PrismicExperimentalLandingPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicExperimentalLandingPageDataHeroFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    testimonials: InputMaybe<PrismicExperimentalLandingPageDataTestimonialsFieldSelector>
}

export type PrismicExperimentalLandingPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicExperimentalLandingPageDataHeroFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicExperimentalLandingPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    testimonials: InputMaybe<PrismicExperimentalLandingPageDataTestimonialsFilterListInput>
}

export type PrismicExperimentalLandingPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks: InputMaybe<PrismicExperimentalLandingPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicExperimentalLandingPageDataHeroSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicExperimentalLandingPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    testimonials: InputMaybe<PrismicExperimentalLandingPageDataTestimonialsSortInput>
}

export type PrismicExperimentalLandingPageEdge = {
    next: Maybe<PrismicExperimentalLandingPage>
    node: PrismicExperimentalLandingPage
    previous: Maybe<PrismicExperimentalLandingPage>
}

export type PrismicExperimentalLandingPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicExperimentalLandingPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExperimentalLandingPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExperimentalLandingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExperimentalLandingPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExperimentalLandingPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExperimentalLandingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExperimentalLandingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExperimentalLandingPageGroupConnectionDistinctArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageGroupConnectionGroupArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExperimentalLandingPageGroupConnectionMaxArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageGroupConnectionMinArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageGroupConnectionSumArgs = {
    field: PrismicExperimentalLandingPageFieldSelector
}

export type PrismicExperimentalLandingPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicExperimentalLandingPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProduct = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicExploreProductDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExploreProductLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicExploreProductConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductEdge>
    group: Array<PrismicExploreProductGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProduct>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductConnectionDistinctArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductConnectionGroupArgs = {
    field: PrismicExploreProductFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductConnectionMaxArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductConnectionMinArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductConnectionSumArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicExploreProductDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicExploreProductDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProductDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicExploreProductDataFormProductionIntegrationType>
    node: PrismicExploreProductDataFormProductionIntegrationType
    previous: Maybe<PrismicExploreProductDataFormProductionIntegrationType>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExploreProductDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProductDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicExploreProductDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicExploreProductDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProductDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicExploreProductDataFormStagingIntegrationType>
    node: PrismicExploreProductDataFormStagingIntegrationType
    previous: Maybe<PrismicExploreProductDataFormStagingIntegrationType>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExploreProductDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProductDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicExploreProductDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicExploreProductDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExploreProductDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExploreProductDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicExploreProductDataImperativeConsentsFilterInput>
}

export type PrismicExploreProductDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExploreProductDataItems = {
    demo_placeholder_image: Maybe<PrismicExploreProductDataItemsDemoPlaceholderImageImageType>
    description: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    navattic_url_production: Maybe<PrismicLinkType>
    navattic_url_staging: Maybe<PrismicLinkType>
    navigation_icon: Maybe<PrismicExploreProductDataItemsNavigationIconImageType>
    navigation_label: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_placeholder_image: Maybe<PrismicExploreProductDataItemsVideoPlaceholderImageImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataItemsFieldSelector = {
    demo_placeholder_image: InputMaybe<PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    navattic_url_production: InputMaybe<PrismicLinkTypeFieldSelector>
    navattic_url_staging: InputMaybe<PrismicLinkTypeFieldSelector>
    navigation_icon: InputMaybe<PrismicExploreProductDataItemsNavigationIconImageTypeFieldSelector>
    navigation_label: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_placeholder_image: InputMaybe<PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExploreProductDataItemsFilterInput = {
    demo_placeholder_image: InputMaybe<PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    navattic_url_production: InputMaybe<PrismicLinkTypeFilterInput>
    navattic_url_staging: InputMaybe<PrismicLinkTypeFilterInput>
    navigation_icon: InputMaybe<PrismicExploreProductDataItemsNavigationIconImageTypeFilterInput>
    navigation_label: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_placeholder_image: InputMaybe<PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExploreProductDataItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicExploreProductDataItemsFilterInput>
}

export type PrismicExploreProductDataItemsNavigationIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataItemsNavigationIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataItemsSortInput = {
    demo_placeholder_image: InputMaybe<PrismicExploreProductDataItemsDemoPlaceholderImageImageTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    navattic_url_production: InputMaybe<PrismicLinkTypeSortInput>
    navattic_url_staging: InputMaybe<PrismicLinkTypeSortInput>
    navigation_icon: InputMaybe<PrismicExploreProductDataItemsNavigationIconImageTypeSortInput>
    navigation_label: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_placeholder_image: InputMaybe<PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataItemsVideoPlaceholderImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataLastStepImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataLastStepImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataLastStepImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataLastStepImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataLastStepImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataLastStepImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataLastStepImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataLastStepImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataMainPlaceholderImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataMainPlaceholderImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataMobileFirstStepImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataMobileFirstStepImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataMobileModal = {
    button_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicExploreProductDataMobileModalImageImageType>
    link_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataMobileModalFieldSelector = {
    button_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicExploreProductDataMobileModalImageImageTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataMobileModalFilterInput = {
    button_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicExploreProductDataMobileModalImageImageTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataMobileModalFilterListInput = {
    elemMatch: InputMaybe<PrismicExploreProductDataMobileModalFilterInput>
}

export type PrismicExploreProductDataMobileModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataMobileModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataMobileModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataMobileModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataMobileModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataMobileModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataMobileModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataMobileModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataMobileModalSortInput = {
    button_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicExploreProductDataMobileModalImageImageTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataModal = {
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicExploreProductDataModalImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataModalFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicExploreProductDataModalImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataModalFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicExploreProductDataModalImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataModalFilterListInput = {
    elemMatch: InputMaybe<PrismicExploreProductDataModalFilterInput>
}

export type PrismicExploreProductDataModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataModalSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicExploreProductDataModalImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataSidePlaceholderImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataSidePlaceholderImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataSocialProof = {
    platform: Maybe<PrismicLinkType>
}

export type PrismicExploreProductDataSocialProofFieldSelector = {
    platform: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicExploreProductDataSocialProofFilterInput = {
    platform: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicExploreProductDataSocialProofFilterListInput = {
    elemMatch: InputMaybe<PrismicExploreProductDataSocialProofFilterInput>
}

export type PrismicExploreProductDataSocialProofSortInput = {
    platform: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicExploreProductDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicExploreProductDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicExploreProductDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicExploreProductDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductDataType = {
    copy_and_share_text: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicExploreProductDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicExploreProductDataFormStagingIntegrationType>
    imperative_consents: Maybe<Array<Maybe<PrismicExploreProductDataImperativeConsents>>>
    interactive_demo_frame_title: Maybe<Scalars['String']['output']>
    items: Maybe<Array<Maybe<PrismicExploreProductDataItems>>>
    last_step_image: Maybe<PrismicExploreProductDataLastStepImageImageType>
    last_step_title: Maybe<Scalars['String']['output']>
    main_placeholder_image: Maybe<PrismicExploreProductDataMainPlaceholderImageImageType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    mobile_first_step_button_text: Maybe<Scalars['String']['output']>
    mobile_first_step_image: Maybe<PrismicExploreProductDataMobileFirstStepImageImageType>
    mobile_first_step_swipe_text: Maybe<Scalars['String']['output']>
    mobile_first_step_title: Maybe<Scalars['String']['output']>
    mobile_modal: Maybe<Array<Maybe<PrismicExploreProductDataMobileModal>>>
    modal: Maybe<Array<Maybe<PrismicExploreProductDataModal>>>
    navattic_link: Maybe<PrismicLinkType>
    navattic_link_staging: Maybe<PrismicLinkType>
    open_graph_image: Maybe<PrismicExploreProductDataOpenGraphImageImageType>
    redirect_to_app_text: Maybe<Scalars['String']['output']>
    share_this_demo_text: Maybe<Scalars['String']['output']>
    side_placeholder_image: Maybe<PrismicExploreProductDataSidePlaceholderImageImageType>
    social_proof: Maybe<Array<Maybe<PrismicExploreProductDataSocialProof>>>
    start_the_demo_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_image: Maybe<PrismicExploreProductDataTitleImageImageType>
    version: Maybe<Scalars['String']['output']>
}

export type PrismicExploreProductDataTypeFieldSelector = {
    copy_and_share_text: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicExploreProductDataImperativeConsentsFieldSelector>
    interactive_demo_frame_title: InputMaybe<FieldSelectorEnum>
    items: InputMaybe<PrismicExploreProductDataItemsFieldSelector>
    last_step_image: InputMaybe<PrismicExploreProductDataLastStepImageImageTypeFieldSelector>
    last_step_title: InputMaybe<FieldSelectorEnum>
    main_placeholder_image: InputMaybe<PrismicExploreProductDataMainPlaceholderImageImageTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    mobile_first_step_button_text: InputMaybe<FieldSelectorEnum>
    mobile_first_step_image: InputMaybe<PrismicExploreProductDataMobileFirstStepImageImageTypeFieldSelector>
    mobile_first_step_swipe_text: InputMaybe<FieldSelectorEnum>
    mobile_first_step_title: InputMaybe<FieldSelectorEnum>
    mobile_modal: InputMaybe<PrismicExploreProductDataMobileModalFieldSelector>
    modal: InputMaybe<PrismicExploreProductDataModalFieldSelector>
    navattic_link: InputMaybe<PrismicLinkTypeFieldSelector>
    navattic_link_staging: InputMaybe<PrismicLinkTypeFieldSelector>
    open_graph_image: InputMaybe<PrismicExploreProductDataOpenGraphImageImageTypeFieldSelector>
    redirect_to_app_text: InputMaybe<FieldSelectorEnum>
    share_this_demo_text: InputMaybe<FieldSelectorEnum>
    side_placeholder_image: InputMaybe<PrismicExploreProductDataSidePlaceholderImageImageTypeFieldSelector>
    social_proof: InputMaybe<PrismicExploreProductDataSocialProofFieldSelector>
    start_the_demo_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    title_image: InputMaybe<PrismicExploreProductDataTitleImageImageTypeFieldSelector>
    version: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductDataTypeFilterInput = {
    copy_and_share_text: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeFilterInput>
    imperative_consents: InputMaybe<PrismicExploreProductDataImperativeConsentsFilterListInput>
    interactive_demo_frame_title: InputMaybe<StringQueryOperatorInput>
    items: InputMaybe<PrismicExploreProductDataItemsFilterListInput>
    last_step_image: InputMaybe<PrismicExploreProductDataLastStepImageImageTypeFilterInput>
    last_step_title: InputMaybe<StringQueryOperatorInput>
    main_placeholder_image: InputMaybe<PrismicExploreProductDataMainPlaceholderImageImageTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    mobile_first_step_button_text: InputMaybe<StringQueryOperatorInput>
    mobile_first_step_image: InputMaybe<PrismicExploreProductDataMobileFirstStepImageImageTypeFilterInput>
    mobile_first_step_swipe_text: InputMaybe<StringQueryOperatorInput>
    mobile_first_step_title: InputMaybe<StringQueryOperatorInput>
    mobile_modal: InputMaybe<PrismicExploreProductDataMobileModalFilterListInput>
    modal: InputMaybe<PrismicExploreProductDataModalFilterListInput>
    navattic_link: InputMaybe<PrismicLinkTypeFilterInput>
    navattic_link_staging: InputMaybe<PrismicLinkTypeFilterInput>
    open_graph_image: InputMaybe<PrismicExploreProductDataOpenGraphImageImageTypeFilterInput>
    redirect_to_app_text: InputMaybe<StringQueryOperatorInput>
    share_this_demo_text: InputMaybe<StringQueryOperatorInput>
    side_placeholder_image: InputMaybe<PrismicExploreProductDataSidePlaceholderImageImageTypeFilterInput>
    social_proof: InputMaybe<PrismicExploreProductDataSocialProofFilterListInput>
    start_the_demo_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    title_image: InputMaybe<PrismicExploreProductDataTitleImageImageTypeFilterInput>
    version: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductDataTypeSortInput = {
    copy_and_share_text: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeSortInput>
    imperative_consents: InputMaybe<PrismicExploreProductDataImperativeConsentsSortInput>
    interactive_demo_frame_title: InputMaybe<SortOrderEnum>
    items: InputMaybe<PrismicExploreProductDataItemsSortInput>
    last_step_image: InputMaybe<PrismicExploreProductDataLastStepImageImageTypeSortInput>
    last_step_title: InputMaybe<SortOrderEnum>
    main_placeholder_image: InputMaybe<PrismicExploreProductDataMainPlaceholderImageImageTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    mobile_first_step_button_text: InputMaybe<SortOrderEnum>
    mobile_first_step_image: InputMaybe<PrismicExploreProductDataMobileFirstStepImageImageTypeSortInput>
    mobile_first_step_swipe_text: InputMaybe<SortOrderEnum>
    mobile_first_step_title: InputMaybe<SortOrderEnum>
    mobile_modal: InputMaybe<PrismicExploreProductDataMobileModalSortInput>
    modal: InputMaybe<PrismicExploreProductDataModalSortInput>
    navattic_link: InputMaybe<PrismicLinkTypeSortInput>
    navattic_link_staging: InputMaybe<PrismicLinkTypeSortInput>
    open_graph_image: InputMaybe<PrismicExploreProductDataOpenGraphImageImageTypeSortInput>
    redirect_to_app_text: InputMaybe<SortOrderEnum>
    share_this_demo_text: InputMaybe<SortOrderEnum>
    side_placeholder_image: InputMaybe<PrismicExploreProductDataSidePlaceholderImageImageTypeSortInput>
    social_proof: InputMaybe<PrismicExploreProductDataSocialProofSortInput>
    start_the_demo_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    title_image: InputMaybe<PrismicExploreProductDataTitleImageImageTypeSortInput>
    version: InputMaybe<SortOrderEnum>
}

export type PrismicExploreProductEdge = {
    next: Maybe<PrismicExploreProduct>
    node: PrismicExploreProduct
    previous: Maybe<PrismicExploreProduct>
}

export type PrismicExploreProductFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicExploreProductDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicExploreProductFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExploreProductDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicExploreProductGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicExploreProductEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicExploreProductGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicExploreProduct>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicExploreProductGroupConnectionDistinctArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductGroupConnectionGroupArgs = {
    field: PrismicExploreProductFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicExploreProductGroupConnectionMaxArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductGroupConnectionMinArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductGroupConnectionSumArgs = {
    field: PrismicExploreProductFieldSelector
}

export type PrismicExploreProductSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicExploreProductDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFaqPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFaqPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFaqPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFaqPageEdge>
    group: Array<PrismicFaqPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFaqPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFaqPageConnectionDistinctArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageConnectionGroupArgs = {
    field: PrismicFaqPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFaqPageConnectionMaxArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageConnectionMinArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageConnectionSumArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageDataFaqBasic = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataFaqBasicFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataFaqBasicFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataFaqBasicFilterListInput = {
    elemMatch: InputMaybe<PrismicFaqPageDataFaqBasicFilterInput>
}

export type PrismicFaqPageDataFaqBasicSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageDataFaqFeature = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataFaqFeatureFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataFaqFeatureFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataFaqFeatureFilterListInput = {
    elemMatch: InputMaybe<PrismicFaqPageDataFaqFeatureFilterInput>
}

export type PrismicFaqPageDataFaqFeatureSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageDataFaqSecurity = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataFaqSecurityFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataFaqSecurityFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataFaqSecurityFilterListInput = {
    elemMatch: InputMaybe<PrismicFaqPageDataFaqSecurityFilterInput>
}

export type PrismicFaqPageDataFaqSecuritySortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageDataFaqUse = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataFaqUseFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataFaqUseFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataFaqUseFilterListInput = {
    elemMatch: InputMaybe<PrismicFaqPageDataFaqUseFilterInput>
}

export type PrismicFaqPageDataFaqUseSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageDataTestimonials = {
    testimonial: Maybe<PrismicLinkType>
}

export type PrismicFaqPageDataTestimonialsFieldSelector = {
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicFaqPageDataTestimonialsFilterInput = {
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicFaqPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicFaqPageDataTestimonialsFilterInput>
}

export type PrismicFaqPageDataTestimonialsSortInput = {
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicFaqPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    faq_basic: Maybe<Array<Maybe<PrismicFaqPageDataFaqBasic>>>
    faq_basic_button_label: Maybe<Scalars['String']['output']>
    faq_basic_title: Maybe<Scalars['String']['output']>
    faq_feature: Maybe<Array<Maybe<PrismicFaqPageDataFaqFeature>>>
    faq_feature_button_label: Maybe<Scalars['String']['output']>
    faq_feature_title: Maybe<Scalars['String']['output']>
    faq_security: Maybe<Array<Maybe<PrismicFaqPageDataFaqSecurity>>>
    faq_security_button_label: Maybe<Scalars['String']['output']>
    faq_security_title: Maybe<Scalars['String']['output']>
    faq_use: Maybe<Array<Maybe<PrismicFaqPageDataFaqUse>>>
    faq_use_button_label: Maybe<Scalars['String']['output']>
    faq_use_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicFaqPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    subtitle: Maybe<Scalars['String']['output']>
    testimonials: Maybe<Array<Maybe<PrismicFaqPageDataTestimonials>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFaqPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    faq_basic: InputMaybe<PrismicFaqPageDataFaqBasicFieldSelector>
    faq_basic_button_label: InputMaybe<FieldSelectorEnum>
    faq_basic_title: InputMaybe<FieldSelectorEnum>
    faq_feature: InputMaybe<PrismicFaqPageDataFaqFeatureFieldSelector>
    faq_feature_button_label: InputMaybe<FieldSelectorEnum>
    faq_feature_title: InputMaybe<FieldSelectorEnum>
    faq_security: InputMaybe<PrismicFaqPageDataFaqSecurityFieldSelector>
    faq_security_button_label: InputMaybe<FieldSelectorEnum>
    faq_security_title: InputMaybe<FieldSelectorEnum>
    faq_use: InputMaybe<PrismicFaqPageDataFaqUseFieldSelector>
    faq_use_button_label: InputMaybe<FieldSelectorEnum>
    faq_use_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicFaqPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    testimonials: InputMaybe<PrismicFaqPageDataTestimonialsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    faq_basic: InputMaybe<PrismicFaqPageDataFaqBasicFilterListInput>
    faq_basic_button_label: InputMaybe<StringQueryOperatorInput>
    faq_basic_title: InputMaybe<StringQueryOperatorInput>
    faq_feature: InputMaybe<PrismicFaqPageDataFaqFeatureFilterListInput>
    faq_feature_button_label: InputMaybe<StringQueryOperatorInput>
    faq_feature_title: InputMaybe<StringQueryOperatorInput>
    faq_security: InputMaybe<PrismicFaqPageDataFaqSecurityFilterListInput>
    faq_security_button_label: InputMaybe<StringQueryOperatorInput>
    faq_security_title: InputMaybe<StringQueryOperatorInput>
    faq_use: InputMaybe<PrismicFaqPageDataFaqUseFilterListInput>
    faq_use_button_label: InputMaybe<StringQueryOperatorInput>
    faq_use_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicFaqPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    testimonials: InputMaybe<PrismicFaqPageDataTestimonialsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    faq_basic: InputMaybe<PrismicFaqPageDataFaqBasicSortInput>
    faq_basic_button_label: InputMaybe<SortOrderEnum>
    faq_basic_title: InputMaybe<SortOrderEnum>
    faq_feature: InputMaybe<PrismicFaqPageDataFaqFeatureSortInput>
    faq_feature_button_label: InputMaybe<SortOrderEnum>
    faq_feature_title: InputMaybe<SortOrderEnum>
    faq_security: InputMaybe<PrismicFaqPageDataFaqSecuritySortInput>
    faq_security_button_label: InputMaybe<SortOrderEnum>
    faq_security_title: InputMaybe<SortOrderEnum>
    faq_use: InputMaybe<PrismicFaqPageDataFaqUseSortInput>
    faq_use_button_label: InputMaybe<SortOrderEnum>
    faq_use_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicFaqPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    testimonials: InputMaybe<PrismicFaqPageDataTestimonialsSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFaqPageEdge = {
    next: Maybe<PrismicFaqPage>
    node: PrismicFaqPage
    previous: Maybe<PrismicFaqPage>
}

export type PrismicFaqPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFaqPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFaqPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFaqPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFaqPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFaqPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFaqPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFaqPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFaqPageGroupConnectionDistinctArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageGroupConnectionGroupArgs = {
    field: PrismicFaqPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFaqPageGroupConnectionMaxArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageGroupConnectionMinArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageGroupConnectionSumArgs = {
    field: PrismicFaqPageFieldSelector
}

export type PrismicFaqPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFaqPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureBlock = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFeatureBlockDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureBlockFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureBlockLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureBlockConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureBlockEdge>
    group: Array<PrismicFeatureBlockGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureBlock>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureBlockConnectionDistinctArgs = {
    field: PrismicFeatureBlockFieldSelector
}

export type PrismicFeatureBlockConnectionGroupArgs = {
    field: PrismicFeatureBlockFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureBlockConnectionMaxArgs = {
    field: PrismicFeatureBlockFieldSelector
}

export type PrismicFeatureBlockConnectionMinArgs = {
    field: PrismicFeatureBlockFieldSelector
}

export type PrismicFeatureBlockConnectionSumArgs = {
    field: PrismicFeatureBlockFieldSelector
}

export type PrismicFeatureBlockDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureBlockDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureBlockDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFeatureBlockDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFeatureBlockDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFeatureBlockDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureBlockDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureBlockDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureBlockDataType = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFeatureBlockDataImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureBlockDataTypeFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFeatureBlockDataImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureBlockDataTypeFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFeatureBlockDataImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureBlockDataTypeSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFeatureBlockDataImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureBlockEdge = {
    next: Maybe<PrismicFeatureBlock>
    node: PrismicFeatureBlock
    previous: Maybe<PrismicFeatureBlock>
}

export type PrismicFeatureBlockFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFeatureBlockDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureBlockFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureBlockDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureBlockGroup = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFeatureBlockGroupDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureBlockGroupFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureBlockGroupLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureBlockGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureBlockGroupEdge>
    group: Array<PrismicFeatureBlockGroupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureBlockGroup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureBlockGroupConnectionDistinctArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupConnectionGroupArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureBlockGroupConnectionMaxArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupConnectionMinArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupConnectionSumArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupDataFeatureBlocks = {
    feature_block: Maybe<PrismicLinkType>
}

export type PrismicFeatureBlockGroupDataFeatureBlocksFieldSelector = {
    feature_block: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicFeatureBlockGroupDataFeatureBlocksFilterInput = {
    feature_block: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicFeatureBlockGroupDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicFeatureBlockGroupDataFeatureBlocksFilterInput>
}

export type PrismicFeatureBlockGroupDataFeatureBlocksSortInput = {
    feature_block: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicFeatureBlockGroupDataType = {
    feature_blocks: Maybe<Array<Maybe<PrismicFeatureBlockGroupDataFeatureBlocks>>>
}

export type PrismicFeatureBlockGroupDataTypeFieldSelector = {
    feature_blocks: InputMaybe<PrismicFeatureBlockGroupDataFeatureBlocksFieldSelector>
}

export type PrismicFeatureBlockGroupDataTypeFilterInput = {
    feature_blocks: InputMaybe<PrismicFeatureBlockGroupDataFeatureBlocksFilterListInput>
}

export type PrismicFeatureBlockGroupDataTypeSortInput = {
    feature_blocks: InputMaybe<PrismicFeatureBlockGroupDataFeatureBlocksSortInput>
}

export type PrismicFeatureBlockGroupEdge = {
    next: Maybe<PrismicFeatureBlockGroup>
    node: PrismicFeatureBlockGroup
    previous: Maybe<PrismicFeatureBlockGroup>
}

export type PrismicFeatureBlockGroupFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFeatureBlockGroupDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureBlockGroupFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureBlockGroupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureBlockGroupGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureBlockGroupEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFeatureBlockGroupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureBlockGroup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureBlockGroupGroupConnectionDistinctArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupGroupConnectionGroupArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureBlockGroupGroupConnectionMaxArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupGroupConnectionMinArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupGroupConnectionSumArgs = {
    field: PrismicFeatureBlockGroupFieldSelector
}

export type PrismicFeatureBlockGroupSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFeatureBlockGroupDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureBlockSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFeatureBlockDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureIconCard = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFeatureIconCardDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureIconCardFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureIconCardLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureIconCardConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureIconCardEdge>
    group: Array<PrismicFeatureIconCardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureIconCard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureIconCardConnectionDistinctArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardConnectionGroupArgs = {
    field: PrismicFeatureIconCardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureIconCardConnectionMaxArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardConnectionMinArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardConnectionSumArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardDataIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureIconCardDataIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureIconCardDataIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFeatureIconCardDataIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFeatureIconCardDataIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFeatureIconCardDataIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureIconCardDataIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureIconCardDataIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureIconCardDataType = {
    body: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicFeatureIconCardDataIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureIconCardDataTypeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicFeatureIconCardDataIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureIconCardDataTypeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicFeatureIconCardDataIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureIconCardDataTypeSortInput = {
    body: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicFeatureIconCardDataIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureIconCardEdge = {
    next: Maybe<PrismicFeatureIconCard>
    node: PrismicFeatureIconCard
    previous: Maybe<PrismicFeatureIconCard>
}

export type PrismicFeatureIconCardFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFeatureIconCardDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureIconCardFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureIconCardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureIconCardGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureIconCardEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFeatureIconCardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureIconCard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureIconCardGroupConnectionDistinctArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardGroupConnectionGroupArgs = {
    field: PrismicFeatureIconCardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureIconCardGroupConnectionMaxArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardGroupConnectionMinArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardGroupConnectionSumArgs = {
    field: PrismicFeatureIconCardFieldSelector
}

export type PrismicFeatureIconCardSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFeatureIconCardDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureIconCards = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFeatureIconCardsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureIconCardsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureIconCardsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFeatureIconCardsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureIconCardsEdge>
    group: Array<PrismicFeatureIconCardsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureIconCards>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureIconCardsConnectionDistinctArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsConnectionGroupArgs = {
    field: PrismicFeatureIconCardsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureIconCardsConnectionMaxArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsConnectionMinArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsConnectionSumArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsDataFeatures = {
    feature: Maybe<PrismicLinkType>
}

export type PrismicFeatureIconCardsDataFeaturesFieldSelector = {
    feature: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicFeatureIconCardsDataFeaturesFilterInput = {
    feature: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicFeatureIconCardsDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicFeatureIconCardsDataFeaturesFilterInput>
}

export type PrismicFeatureIconCardsDataFeaturesSortInput = {
    feature: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicFeatureIconCardsDataType = {
    features: Maybe<Array<Maybe<PrismicFeatureIconCardsDataFeatures>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFeatureIconCardsDataTypeFieldSelector = {
    features: InputMaybe<PrismicFeatureIconCardsDataFeaturesFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureIconCardsDataTypeFilterInput = {
    features: InputMaybe<PrismicFeatureIconCardsDataFeaturesFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureIconCardsDataTypeSortInput = {
    features: InputMaybe<PrismicFeatureIconCardsDataFeaturesSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFeatureIconCardsEdge = {
    next: Maybe<PrismicFeatureIconCards>
    node: PrismicFeatureIconCards
    previous: Maybe<PrismicFeatureIconCards>
}

export type PrismicFeatureIconCardsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFeatureIconCardsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFeatureIconCardsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureIconCardsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFeatureIconCardsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFeatureIconCardsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFeatureIconCardsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFeatureIconCards>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFeatureIconCardsGroupConnectionDistinctArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsGroupConnectionGroupArgs = {
    field: PrismicFeatureIconCardsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFeatureIconCardsGroupConnectionMaxArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsGroupConnectionMinArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsGroupConnectionSumArgs = {
    field: PrismicFeatureIconCardsFieldSelector
}

export type PrismicFeatureIconCardsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFeatureIconCardsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFetchPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFetchPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFetchPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFetchPageEdge>
    group: Array<PrismicFetchPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFetchPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFetchPageConnectionDistinctArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageConnectionGroupArgs = {
    field: PrismicFetchPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFetchPageConnectionMaxArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageConnectionMinArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageConnectionSumArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageDataFeatures = {
    body: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataFeaturesFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataFeaturesFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicFetchPageDataFeaturesFilterInput>
}

export type PrismicFetchPageDataFeaturesSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFetchPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFetchPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFetchPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFetchPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataHowToSteps = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataHowToStepsFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataHowToStepsFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataHowToStepsFilterListInput = {
    elemMatch: InputMaybe<PrismicFetchPageDataHowToStepsFilterInput>
}

export type PrismicFetchPageDataHowToStepsSortInput = {
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataQuestions = {
    body: Maybe<PrismicStructuredTextType>
    body_2: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFetchPageDataQuestionsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataQuestionsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    body_2: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFetchPageDataQuestionsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataQuestionsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    body_2: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFetchPageDataQuestionsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataQuestionsFilterListInput = {
    elemMatch: InputMaybe<PrismicFetchPageDataQuestionsFilterInput>
}

export type PrismicFetchPageDataQuestionsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataQuestionsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFetchPageDataQuestionsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFetchPageDataQuestionsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFetchPageDataQuestionsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFetchPageDataQuestionsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataQuestionsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataQuestionsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataQuestionsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    body_2: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFetchPageDataQuestionsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataTestimonials = {
    attribution: Maybe<PrismicStructuredTextType>
    quote: Maybe<Scalars['String']['output']>
    stars: Maybe<Scalars['Float']['output']>
}

export type PrismicFetchPageDataTestimonialsFieldSelector = {
    attribution: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    quote: InputMaybe<FieldSelectorEnum>
    stars: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataTestimonialsFilterInput = {
    attribution: InputMaybe<PrismicStructuredTextTypeFilterInput>
    quote: InputMaybe<StringQueryOperatorInput>
    stars: InputMaybe<FloatQueryOperatorInput>
}

export type PrismicFetchPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicFetchPageDataTestimonialsFilterInput>
}

export type PrismicFetchPageDataTestimonialsSortInput = {
    attribution: InputMaybe<PrismicStructuredTextTypeSortInput>
    quote: InputMaybe<SortOrderEnum>
    stars: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    features: Maybe<Array<Maybe<PrismicFetchPageDataFeatures>>>
    features_title: Maybe<Scalars['String']['output']>
    hero_image: Maybe<PrismicFetchPageDataHeroImageImageType>
    how_to_steps: Maybe<Array<Maybe<PrismicFetchPageDataHowToSteps>>>
    how_to_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicFetchPageDataOpenGraphImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    questions: Maybe<Array<Maybe<PrismicFetchPageDataQuestions>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    testimonials: Maybe<Array<Maybe<PrismicFetchPageDataTestimonials>>>
    testimonials_title: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicFetchPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<PrismicFetchPageDataFeaturesFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    hero_image: InputMaybe<PrismicFetchPageDataHeroImageImageTypeFieldSelector>
    how_to_steps: InputMaybe<PrismicFetchPageDataHowToStepsFieldSelector>
    how_to_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicFetchPageDataOpenGraphImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    questions: InputMaybe<PrismicFetchPageDataQuestionsFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    testimonials: InputMaybe<PrismicFetchPageDataTestimonialsFieldSelector>
    testimonials_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    features: InputMaybe<PrismicFetchPageDataFeaturesFilterListInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    hero_image: InputMaybe<PrismicFetchPageDataHeroImageImageTypeFilterInput>
    how_to_steps: InputMaybe<PrismicFetchPageDataHowToStepsFilterListInput>
    how_to_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicFetchPageDataOpenGraphImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    questions: InputMaybe<PrismicFetchPageDataQuestionsFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    testimonials: InputMaybe<PrismicFetchPageDataTestimonialsFilterListInput>
    testimonials_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    features: InputMaybe<PrismicFetchPageDataFeaturesSortInput>
    features_title: InputMaybe<SortOrderEnum>
    hero_image: InputMaybe<PrismicFetchPageDataHeroImageImageTypeSortInput>
    how_to_steps: InputMaybe<PrismicFetchPageDataHowToStepsSortInput>
    how_to_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicFetchPageDataOpenGraphImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    questions: InputMaybe<PrismicFetchPageDataQuestionsSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    testimonials: InputMaybe<PrismicFetchPageDataTestimonialsSortInput>
    testimonials_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
    video_id: InputMaybe<SortOrderEnum>
}

export type PrismicFetchPageEdge = {
    next: Maybe<PrismicFetchPage>
    node: PrismicFetchPage
    previous: Maybe<PrismicFetchPage>
}

export type PrismicFetchPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFetchPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFetchPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFetchPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFetchPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFetchPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFetchPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFetchPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFetchPageGroupConnectionDistinctArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageGroupConnectionGroupArgs = {
    field: PrismicFetchPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFetchPageGroupConnectionMaxArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageGroupConnectionMinArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageGroupConnectionSumArgs = {
    field: PrismicFetchPageFieldSelector
}

export type PrismicFetchPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFetchPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFincirclePage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFincirclePageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFincirclePageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFincirclePageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFincirclePageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFincirclePageEdge>
    group: Array<PrismicFincirclePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFincirclePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFincirclePageConnectionDistinctArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageConnectionGroupArgs = {
    field: PrismicFincirclePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFincirclePageConnectionMaxArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageConnectionMinArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageConnectionSumArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    consent_error_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicFincirclePageDataHeroImageImageType>
    signup_banner: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFincirclePageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    consent_error_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicFincirclePageDataHeroImageImageTypeFieldSelector>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFincirclePageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    consent_error_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicFincirclePageDataHeroImageImageTypeFilterInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFincirclePageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicFincirclePageDataHeroFilterInput>
}

export type PrismicFincirclePageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFincirclePageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFincirclePageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFincirclePageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFincirclePageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFincirclePageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFincirclePageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFincirclePageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFincirclePageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    consent_error_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicFincirclePageDataHeroImageImageTypeSortInput>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFincirclePageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFincirclePageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFincirclePageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero: Maybe<Array<Maybe<PrismicFincirclePageDataHero>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicFincirclePageDataOpenGraphImageImageType>
}

export type PrismicFincirclePageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicFincirclePageDataHeroFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicFincirclePageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicFincirclePageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero: InputMaybe<PrismicFincirclePageDataHeroFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicFincirclePageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicFincirclePageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicFincirclePageDataHeroSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicFincirclePageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicFincirclePageEdge = {
    next: Maybe<PrismicFincirclePage>
    node: PrismicFincirclePage
    previous: Maybe<PrismicFincirclePage>
}

export type PrismicFincirclePageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFincirclePageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFincirclePageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFincirclePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFincirclePageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFincirclePageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFincirclePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFincirclePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFincirclePageGroupConnectionDistinctArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageGroupConnectionGroupArgs = {
    field: PrismicFincirclePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFincirclePageGroupConnectionMaxArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageGroupConnectionMinArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageGroupConnectionSumArgs = {
    field: PrismicFincirclePageFieldSelector
}

export type PrismicFincirclePageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFincirclePageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFlexBenefitsPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFlexBenefitsPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFlexBenefitsPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFlexBenefitsPageEdge>
    group: Array<PrismicFlexBenefitsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFlexBenefitsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFlexBenefitsPageConnectionDistinctArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageConnectionGroupArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageConnectionMaxArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageConnectionMinArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageConnectionSumArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefits = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataBaseBenefitsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsFilterInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermany = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyFilterInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemote = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFilterInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsGermanySortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemote = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteFilterInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsRemoteSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataBaseBenefitsSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataCharityAndDonationsSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHealthAndWellbeingSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataHero = {
    content: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHeroFieldSelector = {
    content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHeroFilterInput = {
    content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataHeroFilterInput>
}

export type PrismicFlexBenefitsPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHeroSortInput = {
    content: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataHomeOfficeSetupSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataJobGrid = {
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    open_roles: Maybe<PrismicLinkType>
    see_more: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataJobGridFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    open_roles: InputMaybe<PrismicLinkTypeFieldSelector>
    see_more: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataJobGridFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    open_roles: InputMaybe<PrismicLinkTypeFilterInput>
    see_more: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataJobGridFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataJobGridFilterInput>
}

export type PrismicFlexBenefitsPageDataJobGridSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    open_roles: InputMaybe<PrismicLinkTypeSortInput>
    see_more: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLeaveDaysSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFilterInput>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeFilterInput =
    {
        alt: InputMaybe<StringQueryOperatorInput>
        copyright: InputMaybe<StringQueryOperatorInput>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
        fixed: InputMaybe<ImgixFixedFilterInput>
        fluid: InputMaybe<ImgixFluidFilterInput>
        gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
        localFile: InputMaybe<FileFilterInput>
        url: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeSortInput =
    {
        alt: InputMaybe<SortOrderEnum>
        copyright: InputMaybe<SortOrderEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
        fixed: InputMaybe<ImgixFixedSortInput>
        fluid: InputMaybe<ImgixFluidSortInput>
        gatsbyImageData: InputMaybe<SortOrderEnum>
        localFile: InputMaybe<FileSortInput>
        url: InputMaybe<SortOrderEnum>
    }

export type PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageDataLocationNames = {
    denmark: Maybe<Scalars['String']['output']>
    germany: Maybe<Scalars['String']['output']>
    portugal: Maybe<Scalars['String']['output']>
    quebec: Maybe<Scalars['String']['output']>
    remote: Maybe<Scalars['String']['output']>
    spain: Maybe<Scalars['String']['output']>
    sweden: Maybe<Scalars['String']['output']>
    uk: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLocationNamesFieldSelector = {
    denmark: InputMaybe<FieldSelectorEnum>
    germany: InputMaybe<FieldSelectorEnum>
    portugal: InputMaybe<FieldSelectorEnum>
    quebec: InputMaybe<FieldSelectorEnum>
    remote: InputMaybe<FieldSelectorEnum>
    spain: InputMaybe<FieldSelectorEnum>
    sweden: InputMaybe<FieldSelectorEnum>
    uk: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLocationNamesFilterInput = {
    denmark: InputMaybe<StringQueryOperatorInput>
    germany: InputMaybe<StringQueryOperatorInput>
    portugal: InputMaybe<StringQueryOperatorInput>
    quebec: InputMaybe<StringQueryOperatorInput>
    remote: InputMaybe<StringQueryOperatorInput>
    spain: InputMaybe<StringQueryOperatorInput>
    sweden: InputMaybe<StringQueryOperatorInput>
    uk: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLocationNamesFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataLocationNamesFilterInput>
}

export type PrismicFlexBenefitsPageDataLocationNamesSortInput = {
    denmark: InputMaybe<SortOrderEnum>
    germany: InputMaybe<SortOrderEnum>
    portugal: InputMaybe<SortOrderEnum>
    quebec: InputMaybe<SortOrderEnum>
    remote: InputMaybe<SortOrderEnum>
    spain: InputMaybe<SortOrderEnum>
    sweden: InputMaybe<SortOrderEnum>
    uk: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataLocationSelectOptions = {
    denmark: Maybe<Scalars['String']['output']>
    germany: Maybe<Scalars['String']['output']>
    portugal: Maybe<Scalars['String']['output']>
    quebec: Maybe<Scalars['String']['output']>
    remote: Maybe<Scalars['String']['output']>
    spain: Maybe<Scalars['String']['output']>
    sweden: Maybe<Scalars['String']['output']>
    united_kingdom: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataLocationSelectOptionsFieldSelector = {
    denmark: InputMaybe<FieldSelectorEnum>
    germany: InputMaybe<FieldSelectorEnum>
    portugal: InputMaybe<FieldSelectorEnum>
    quebec: InputMaybe<FieldSelectorEnum>
    remote: InputMaybe<FieldSelectorEnum>
    spain: InputMaybe<FieldSelectorEnum>
    sweden: InputMaybe<FieldSelectorEnum>
    united_kingdom: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataLocationSelectOptionsFilterInput = {
    denmark: InputMaybe<StringQueryOperatorInput>
    germany: InputMaybe<StringQueryOperatorInput>
    portugal: InputMaybe<StringQueryOperatorInput>
    quebec: InputMaybe<StringQueryOperatorInput>
    remote: InputMaybe<StringQueryOperatorInput>
    spain: InputMaybe<StringQueryOperatorInput>
    sweden: InputMaybe<StringQueryOperatorInput>
    united_kingdom: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataLocationSelectOptionsFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataLocationSelectOptionsFilterInput>
}

export type PrismicFlexBenefitsPageDataLocationSelectOptionsSortInput = {
    denmark: InputMaybe<SortOrderEnum>
    germany: InputMaybe<SortOrderEnum>
    portugal: InputMaybe<SortOrderEnum>
    quebec: InputMaybe<SortOrderEnum>
    remote: InputMaybe<SortOrderEnum>
    spain: InputMaybe<SortOrderEnum>
    sweden: InputMaybe<SortOrderEnum>
    united_kingdom: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOption = {
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionFilterInput>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataOfficeRadioOptionSortInput = {
    description: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefits = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataParentalBenefitsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsFilterInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpain = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainFilterInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataParentalBenefitsSpainSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOption = {
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionFilterInput>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataRemoteRadioOptionSortInput = {
    description: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataResultsPackageItems = {
    flex_benefits_budget: Maybe<Scalars['String']['output']>
    lunch: Maybe<Scalars['String']['output']>
    private_healthcare: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataResultsPackageItemsFieldSelector = {
    flex_benefits_budget: InputMaybe<FieldSelectorEnum>
    lunch: InputMaybe<FieldSelectorEnum>
    private_healthcare: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataResultsPackageItemsFilterInput = {
    flex_benefits_budget: InputMaybe<StringQueryOperatorInput>
    lunch: InputMaybe<StringQueryOperatorInput>
    private_healthcare: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataResultsPackageItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataResultsPackageItemsFilterInput>
}

export type PrismicFlexBenefitsPageDataResultsPackageItemsSortInput = {
    flex_benefits_budget: InputMaybe<SortOrderEnum>
    lunch: InputMaybe<SortOrderEnum>
    private_healthcare: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataType = {
    arts_culture_and_entertainment_slider: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSlider>>
    >
    base_benefits: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataBaseBenefits>>>
    base_benefits_germany: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataBaseBenefitsGermany>>>
    base_benefits_germany_remote: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemote>>
    >
    base_benefits_remote: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataBaseBenefitsRemote>>>
    base_benefits_section_country_title: Maybe<Scalars['String']['output']>
    base_benefits_section_fully_remote_title: Maybe<Scalars['String']['output']>
    base_benefits_section_partial_remote_title: Maybe<Scalars['String']['output']>
    charity_and_donations_slider: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataCharityAndDonationsSlider>>
    >
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    health_and_wellbeing_slider: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSlider>>
    >
    hero: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataHero>>>
    hide_results_text: Maybe<Scalars['String']['output']>
    home_office_setup_slider: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSlider>>>
    job_grid: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataJobGrid>>>
    learning_and_development_slider: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSlider>>
    >
    leave_days_slider: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataLeaveDaysSlider>>>
    lifestyle_travel_and_transport_slider: Maybe<
        Array<Maybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSlider>>
    >
    location_names: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataLocationNames>>>
    location_select_label: Maybe<Scalars['String']['output']>
    location_select_options: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataLocationSelectOptions>>>
    location_select_placeholder: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    office_radio_group_legend: Maybe<Scalars['String']['output']>
    office_radio_option: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataOfficeRadioOption>>>
    open_graph_image: Maybe<PrismicFlexBenefitsPageDataOpenGraphImageImageType>
    parental_benefits: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataParentalBenefits>>>
    parental_benefits_spain: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataParentalBenefitsSpain>>>
    remote_radio_option: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataRemoteRadioOption>>>
    results_budget_allowance_text: Maybe<Scalars['String']['output']>
    results_note: Maybe<Scalars['String']['output']>
    results_package_items: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataResultsPackageItems>>>
    results_package_title: Maybe<Scalars['String']['output']>
    results_progress_bar_text: Maybe<Scalars['String']['output']>
    results_title: Maybe<Scalars['String']['output']>
    results_total_benefits_title: Maybe<Scalars['String']['output']>
    show_results_text: Maybe<Scalars['String']['output']>
    sliders_subtitle: Maybe<Scalars['String']['output']>
    sliders_title: Maybe<Scalars['String']['output']>
    ways_of_working: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataWaysOfWorking>>>
    ways_of_working_remote: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemote>>>
    your_family_slider: Maybe<Array<Maybe<PrismicFlexBenefitsPageDataYourFamilySlider>>>
}

export type PrismicFlexBenefitsPageDataTypeFieldSelector = {
    arts_culture_and_entertainment_slider: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFieldSelector>
    base_benefits: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsFieldSelector>
    base_benefits_germany: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyFieldSelector>
    base_benefits_germany_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFieldSelector>
    base_benefits_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteFieldSelector>
    base_benefits_section_country_title: InputMaybe<FieldSelectorEnum>
    base_benefits_section_fully_remote_title: InputMaybe<FieldSelectorEnum>
    base_benefits_section_partial_remote_title: InputMaybe<FieldSelectorEnum>
    charity_and_donations_slider: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    health_and_wellbeing_slider: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFieldSelector>
    hero: InputMaybe<PrismicFlexBenefitsPageDataHeroFieldSelector>
    hide_results_text: InputMaybe<FieldSelectorEnum>
    home_office_setup_slider: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFieldSelector>
    job_grid: InputMaybe<PrismicFlexBenefitsPageDataJobGridFieldSelector>
    learning_and_development_slider: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFieldSelector>
    leave_days_slider: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderFieldSelector>
    lifestyle_travel_and_transport_slider: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFieldSelector>
    location_names: InputMaybe<PrismicFlexBenefitsPageDataLocationNamesFieldSelector>
    location_select_label: InputMaybe<FieldSelectorEnum>
    location_select_options: InputMaybe<PrismicFlexBenefitsPageDataLocationSelectOptionsFieldSelector>
    location_select_placeholder: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    office_radio_group_legend: InputMaybe<FieldSelectorEnum>
    office_radio_option: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionFieldSelector>
    open_graph_image: InputMaybe<PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFieldSelector>
    parental_benefits: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsFieldSelector>
    parental_benefits_spain: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainFieldSelector>
    remote_radio_option: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionFieldSelector>
    results_budget_allowance_text: InputMaybe<FieldSelectorEnum>
    results_note: InputMaybe<FieldSelectorEnum>
    results_package_items: InputMaybe<PrismicFlexBenefitsPageDataResultsPackageItemsFieldSelector>
    results_package_title: InputMaybe<FieldSelectorEnum>
    results_progress_bar_text: InputMaybe<FieldSelectorEnum>
    results_title: InputMaybe<FieldSelectorEnum>
    results_total_benefits_title: InputMaybe<FieldSelectorEnum>
    show_results_text: InputMaybe<FieldSelectorEnum>
    sliders_subtitle: InputMaybe<FieldSelectorEnum>
    sliders_title: InputMaybe<FieldSelectorEnum>
    ways_of_working: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingFieldSelector>
    ways_of_working_remote: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFieldSelector>
    your_family_slider: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderFieldSelector>
}

export type PrismicFlexBenefitsPageDataTypeFilterInput = {
    arts_culture_and_entertainment_slider: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderFilterListInput>
    base_benefits: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsFilterListInput>
    base_benefits_germany: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyFilterListInput>
    base_benefits_germany_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteFilterListInput>
    base_benefits_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteFilterListInput>
    base_benefits_section_country_title: InputMaybe<StringQueryOperatorInput>
    base_benefits_section_fully_remote_title: InputMaybe<StringQueryOperatorInput>
    base_benefits_section_partial_remote_title: InputMaybe<StringQueryOperatorInput>
    charity_and_donations_slider: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    health_and_wellbeing_slider: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderFilterListInput>
    hero: InputMaybe<PrismicFlexBenefitsPageDataHeroFilterListInput>
    hide_results_text: InputMaybe<StringQueryOperatorInput>
    home_office_setup_slider: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderFilterListInput>
    job_grid: InputMaybe<PrismicFlexBenefitsPageDataJobGridFilterListInput>
    learning_and_development_slider: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderFilterListInput>
    leave_days_slider: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderFilterListInput>
    lifestyle_travel_and_transport_slider: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderFilterListInput>
    location_names: InputMaybe<PrismicFlexBenefitsPageDataLocationNamesFilterListInput>
    location_select_label: InputMaybe<StringQueryOperatorInput>
    location_select_options: InputMaybe<PrismicFlexBenefitsPageDataLocationSelectOptionsFilterListInput>
    location_select_placeholder: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    office_radio_group_legend: InputMaybe<StringQueryOperatorInput>
    office_radio_option: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionFilterListInput>
    open_graph_image: InputMaybe<PrismicFlexBenefitsPageDataOpenGraphImageImageTypeFilterInput>
    parental_benefits: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsFilterListInput>
    parental_benefits_spain: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainFilterListInput>
    remote_radio_option: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionFilterListInput>
    results_budget_allowance_text: InputMaybe<StringQueryOperatorInput>
    results_note: InputMaybe<StringQueryOperatorInput>
    results_package_items: InputMaybe<PrismicFlexBenefitsPageDataResultsPackageItemsFilterListInput>
    results_package_title: InputMaybe<StringQueryOperatorInput>
    results_progress_bar_text: InputMaybe<StringQueryOperatorInput>
    results_title: InputMaybe<StringQueryOperatorInput>
    results_total_benefits_title: InputMaybe<StringQueryOperatorInput>
    show_results_text: InputMaybe<StringQueryOperatorInput>
    sliders_subtitle: InputMaybe<StringQueryOperatorInput>
    sliders_title: InputMaybe<StringQueryOperatorInput>
    ways_of_working: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingFilterListInput>
    ways_of_working_remote: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFilterListInput>
    your_family_slider: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderFilterListInput>
}

export type PrismicFlexBenefitsPageDataTypeSortInput = {
    arts_culture_and_entertainment_slider: InputMaybe<PrismicFlexBenefitsPageDataArtsCultureAndEntertainmentSliderSortInput>
    base_benefits: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsSortInput>
    base_benefits_germany: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanySortInput>
    base_benefits_germany_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsGermanyRemoteSortInput>
    base_benefits_remote: InputMaybe<PrismicFlexBenefitsPageDataBaseBenefitsRemoteSortInput>
    base_benefits_section_country_title: InputMaybe<SortOrderEnum>
    base_benefits_section_fully_remote_title: InputMaybe<SortOrderEnum>
    base_benefits_section_partial_remote_title: InputMaybe<SortOrderEnum>
    charity_and_donations_slider: InputMaybe<PrismicFlexBenefitsPageDataCharityAndDonationsSliderSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    health_and_wellbeing_slider: InputMaybe<PrismicFlexBenefitsPageDataHealthAndWellbeingSliderSortInput>
    hero: InputMaybe<PrismicFlexBenefitsPageDataHeroSortInput>
    hide_results_text: InputMaybe<SortOrderEnum>
    home_office_setup_slider: InputMaybe<PrismicFlexBenefitsPageDataHomeOfficeSetupSliderSortInput>
    job_grid: InputMaybe<PrismicFlexBenefitsPageDataJobGridSortInput>
    learning_and_development_slider: InputMaybe<PrismicFlexBenefitsPageDataLearningAndDevelopmentSliderSortInput>
    leave_days_slider: InputMaybe<PrismicFlexBenefitsPageDataLeaveDaysSliderSortInput>
    lifestyle_travel_and_transport_slider: InputMaybe<PrismicFlexBenefitsPageDataLifestyleTravelAndTransportSliderSortInput>
    location_names: InputMaybe<PrismicFlexBenefitsPageDataLocationNamesSortInput>
    location_select_label: InputMaybe<SortOrderEnum>
    location_select_options: InputMaybe<PrismicFlexBenefitsPageDataLocationSelectOptionsSortInput>
    location_select_placeholder: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    office_radio_group_legend: InputMaybe<SortOrderEnum>
    office_radio_option: InputMaybe<PrismicFlexBenefitsPageDataOfficeRadioOptionSortInput>
    open_graph_image: InputMaybe<PrismicFlexBenefitsPageDataOpenGraphImageImageTypeSortInput>
    parental_benefits: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSortInput>
    parental_benefits_spain: InputMaybe<PrismicFlexBenefitsPageDataParentalBenefitsSpainSortInput>
    remote_radio_option: InputMaybe<PrismicFlexBenefitsPageDataRemoteRadioOptionSortInput>
    results_budget_allowance_text: InputMaybe<SortOrderEnum>
    results_note: InputMaybe<SortOrderEnum>
    results_package_items: InputMaybe<PrismicFlexBenefitsPageDataResultsPackageItemsSortInput>
    results_package_title: InputMaybe<SortOrderEnum>
    results_progress_bar_text: InputMaybe<SortOrderEnum>
    results_title: InputMaybe<SortOrderEnum>
    results_total_benefits_title: InputMaybe<SortOrderEnum>
    show_results_text: InputMaybe<SortOrderEnum>
    sliders_subtitle: InputMaybe<SortOrderEnum>
    sliders_title: InputMaybe<SortOrderEnum>
    ways_of_working: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingSortInput>
    ways_of_working_remote: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteSortInput>
    your_family_slider: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderSortInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorking = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataWaysOfWorkingImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingFilterInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemote = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteFilterInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingRemoteSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingRemoteImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataWaysOfWorkingSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicFlexBenefitsPageDataWaysOfWorkingImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySlider = {
    heading: Maybe<Scalars['String']['output']>
    high_icon: Maybe<PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageType>
    label: Maybe<Scalars['String']['output']>
    low_icon: Maybe<PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageType>
    medium_icon: Maybe<PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageType>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderFieldSelector = {
    heading: InputMaybe<FieldSelectorEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFieldSelector>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFieldSelector>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderFilterInput = {
    heading: InputMaybe<StringQueryOperatorInput>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFilterInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFilterInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderFilterListInput = {
    elemMatch: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderFilterInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFlexBenefitsPageDataYourFamilySliderSortInput = {
    heading: InputMaybe<SortOrderEnum>
    high_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderHighIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    low_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderLowIconImageTypeSortInput>
    medium_icon: InputMaybe<PrismicFlexBenefitsPageDataYourFamilySliderMediumIconImageTypeSortInput>
}

export type PrismicFlexBenefitsPageEdge = {
    next: Maybe<PrismicFlexBenefitsPage>
    node: PrismicFlexBenefitsPage
    previous: Maybe<PrismicFlexBenefitsPage>
}

export type PrismicFlexBenefitsPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFlexBenefitsPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFlexBenefitsPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFlexBenefitsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFlexBenefitsPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFlexBenefitsPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFlexBenefitsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFlexBenefitsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFlexBenefitsPageGroupConnectionDistinctArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageGroupConnectionGroupArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFlexBenefitsPageGroupConnectionMaxArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageGroupConnectionMinArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageGroupConnectionSumArgs = {
    field: PrismicFlexBenefitsPageFieldSelector
}

export type PrismicFlexBenefitsPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFlexBenefitsPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFooter = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFooterDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFooterFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFooterLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFooterConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFooterEdge>
    group: Array<PrismicFooterGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFooter>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFooterConnectionDistinctArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterConnectionGroupArgs = {
    field: PrismicFooterFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFooterConnectionMaxArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterConnectionMinArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterConnectionSumArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterDataCompanyLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataCompanyLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataCompanyLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataCompanyLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataCompanyLinksFilterInput>
}

export type PrismicFooterDataCompanyLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataLegalLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataLegalLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataLegalLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataLegalLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataLegalLinksFilterInput>
}

export type PrismicFooterDataLegalLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataPartnershipsLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataPartnershipsLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataPartnershipsLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataPartnershipsLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataPartnershipsLinksFilterInput>
}

export type PrismicFooterDataPartnershipsLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataProductLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataProductLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataProductLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataProductLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataProductLinksFilterInput>
}

export type PrismicFooterDataProductLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataResourcesLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataResourcesLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataResourcesLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataResourcesLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataResourcesLinksFilterInput>
}

export type PrismicFooterDataResourcesLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataSolutionsLinks = {
    link: Maybe<PrismicLinkType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataSolutionsLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataSolutionsLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataSolutionsLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterDataSolutionsLinksFilterInput>
}

export type PrismicFooterDataSolutionsLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicFooterDataType = {
    about_us: Maybe<Scalars['String']['output']>
    address: Maybe<PrismicStructuredTextType>
    blog: Maybe<Scalars['String']['output']>
    careers: Maybe<Scalars['String']['output']>
    company_heading: Maybe<Scalars['String']['output']>
    company_links: Maybe<Array<Maybe<PrismicFooterDataCompanyLinks>>>
    contact_us: Maybe<Scalars['String']['output']>
    copyright_text: Maybe<Scalars['String']['output']>
    customers: Maybe<Scalars['String']['output']>
    entity: Maybe<Scalars['String']['output']>
    faq: Maybe<Scalars['String']['output']>
    features: Maybe<Scalars['String']['output']>
    financial_partner_copyright_text: Maybe<Scalars['String']['output']>
    financial_partner_terms_body: Maybe<Scalars['String']['output']>
    financial_partner_terms_text: Maybe<PrismicStructuredTextType>
    help_centre: Maybe<Scalars['String']['output']>
    info_email: Maybe<Scalars['String']['output']>
    integrations: Maybe<Scalars['String']['output']>
    legal: Maybe<Scalars['String']['output']>
    legal_heading: Maybe<Scalars['String']['output']>
    legal_links: Maybe<Array<Maybe<PrismicFooterDataLegalLinks>>>
    partners: Maybe<Scalars['String']['output']>
    partnerships_heading: Maybe<Scalars['String']['output']>
    partnerships_links: Maybe<Array<Maybe<PrismicFooterDataPartnershipsLinks>>>
    press: Maybe<Scalars['String']['output']>
    pricing: Maybe<Scalars['String']['output']>
    product_heading: Maybe<Scalars['String']['output']>
    product_links: Maybe<Array<Maybe<PrismicFooterDataProductLinks>>>
    referrals: Maybe<Scalars['String']['output']>
    resources_heading: Maybe<Scalars['String']['output']>
    resources_links: Maybe<Array<Maybe<PrismicFooterDataResourcesLinks>>>
    sales_email: Maybe<Scalars['String']['output']>
    security: Maybe<Scalars['String']['output']>
    solutions_heading: Maybe<Scalars['String']['output']>
    solutions_links: Maybe<Array<Maybe<PrismicFooterDataSolutionsLinks>>>
    status: Maybe<Scalars['String']['output']>
    support_email: Maybe<Scalars['String']['output']>
    terms_body: Maybe<Scalars['String']['output']>
    why_pleo: Maybe<Scalars['String']['output']>
}

export type PrismicFooterDataTypeFieldSelector = {
    about_us: InputMaybe<FieldSelectorEnum>
    address: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    blog: InputMaybe<FieldSelectorEnum>
    careers: InputMaybe<FieldSelectorEnum>
    company_heading: InputMaybe<FieldSelectorEnum>
    company_links: InputMaybe<PrismicFooterDataCompanyLinksFieldSelector>
    contact_us: InputMaybe<FieldSelectorEnum>
    copyright_text: InputMaybe<FieldSelectorEnum>
    customers: InputMaybe<FieldSelectorEnum>
    entity: InputMaybe<FieldSelectorEnum>
    faq: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<FieldSelectorEnum>
    financial_partner_copyright_text: InputMaybe<FieldSelectorEnum>
    financial_partner_terms_body: InputMaybe<FieldSelectorEnum>
    financial_partner_terms_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    help_centre: InputMaybe<FieldSelectorEnum>
    info_email: InputMaybe<FieldSelectorEnum>
    integrations: InputMaybe<FieldSelectorEnum>
    legal: InputMaybe<FieldSelectorEnum>
    legal_heading: InputMaybe<FieldSelectorEnum>
    legal_links: InputMaybe<PrismicFooterDataLegalLinksFieldSelector>
    partners: InputMaybe<FieldSelectorEnum>
    partnerships_heading: InputMaybe<FieldSelectorEnum>
    partnerships_links: InputMaybe<PrismicFooterDataPartnershipsLinksFieldSelector>
    press: InputMaybe<FieldSelectorEnum>
    pricing: InputMaybe<FieldSelectorEnum>
    product_heading: InputMaybe<FieldSelectorEnum>
    product_links: InputMaybe<PrismicFooterDataProductLinksFieldSelector>
    referrals: InputMaybe<FieldSelectorEnum>
    resources_heading: InputMaybe<FieldSelectorEnum>
    resources_links: InputMaybe<PrismicFooterDataResourcesLinksFieldSelector>
    sales_email: InputMaybe<FieldSelectorEnum>
    security: InputMaybe<FieldSelectorEnum>
    solutions_heading: InputMaybe<FieldSelectorEnum>
    solutions_links: InputMaybe<PrismicFooterDataSolutionsLinksFieldSelector>
    status: InputMaybe<FieldSelectorEnum>
    support_email: InputMaybe<FieldSelectorEnum>
    terms_body: InputMaybe<FieldSelectorEnum>
    why_pleo: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterDataTypeFilterInput = {
    about_us: InputMaybe<StringQueryOperatorInput>
    address: InputMaybe<PrismicStructuredTextTypeFilterInput>
    blog: InputMaybe<StringQueryOperatorInput>
    careers: InputMaybe<StringQueryOperatorInput>
    company_heading: InputMaybe<StringQueryOperatorInput>
    company_links: InputMaybe<PrismicFooterDataCompanyLinksFilterListInput>
    contact_us: InputMaybe<StringQueryOperatorInput>
    copyright_text: InputMaybe<StringQueryOperatorInput>
    customers: InputMaybe<StringQueryOperatorInput>
    entity: InputMaybe<StringQueryOperatorInput>
    faq: InputMaybe<StringQueryOperatorInput>
    features: InputMaybe<StringQueryOperatorInput>
    financial_partner_copyright_text: InputMaybe<StringQueryOperatorInput>
    financial_partner_terms_body: InputMaybe<StringQueryOperatorInput>
    financial_partner_terms_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    help_centre: InputMaybe<StringQueryOperatorInput>
    info_email: InputMaybe<StringQueryOperatorInput>
    integrations: InputMaybe<StringQueryOperatorInput>
    legal: InputMaybe<StringQueryOperatorInput>
    legal_heading: InputMaybe<StringQueryOperatorInput>
    legal_links: InputMaybe<PrismicFooterDataLegalLinksFilterListInput>
    partners: InputMaybe<StringQueryOperatorInput>
    partnerships_heading: InputMaybe<StringQueryOperatorInput>
    partnerships_links: InputMaybe<PrismicFooterDataPartnershipsLinksFilterListInput>
    press: InputMaybe<StringQueryOperatorInput>
    pricing: InputMaybe<StringQueryOperatorInput>
    product_heading: InputMaybe<StringQueryOperatorInput>
    product_links: InputMaybe<PrismicFooterDataProductLinksFilterListInput>
    referrals: InputMaybe<StringQueryOperatorInput>
    resources_heading: InputMaybe<StringQueryOperatorInput>
    resources_links: InputMaybe<PrismicFooterDataResourcesLinksFilterListInput>
    sales_email: InputMaybe<StringQueryOperatorInput>
    security: InputMaybe<StringQueryOperatorInput>
    solutions_heading: InputMaybe<StringQueryOperatorInput>
    solutions_links: InputMaybe<PrismicFooterDataSolutionsLinksFilterListInput>
    status: InputMaybe<StringQueryOperatorInput>
    support_email: InputMaybe<StringQueryOperatorInput>
    terms_body: InputMaybe<StringQueryOperatorInput>
    why_pleo: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterDataTypeSortInput = {
    about_us: InputMaybe<SortOrderEnum>
    address: InputMaybe<PrismicStructuredTextTypeSortInput>
    blog: InputMaybe<SortOrderEnum>
    careers: InputMaybe<SortOrderEnum>
    company_heading: InputMaybe<SortOrderEnum>
    company_links: InputMaybe<PrismicFooterDataCompanyLinksSortInput>
    contact_us: InputMaybe<SortOrderEnum>
    copyright_text: InputMaybe<SortOrderEnum>
    customers: InputMaybe<SortOrderEnum>
    entity: InputMaybe<SortOrderEnum>
    faq: InputMaybe<SortOrderEnum>
    features: InputMaybe<SortOrderEnum>
    financial_partner_copyright_text: InputMaybe<SortOrderEnum>
    financial_partner_terms_body: InputMaybe<SortOrderEnum>
    financial_partner_terms_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    help_centre: InputMaybe<SortOrderEnum>
    info_email: InputMaybe<SortOrderEnum>
    integrations: InputMaybe<SortOrderEnum>
    legal: InputMaybe<SortOrderEnum>
    legal_heading: InputMaybe<SortOrderEnum>
    legal_links: InputMaybe<PrismicFooterDataLegalLinksSortInput>
    partners: InputMaybe<SortOrderEnum>
    partnerships_heading: InputMaybe<SortOrderEnum>
    partnerships_links: InputMaybe<PrismicFooterDataPartnershipsLinksSortInput>
    press: InputMaybe<SortOrderEnum>
    pricing: InputMaybe<SortOrderEnum>
    product_heading: InputMaybe<SortOrderEnum>
    product_links: InputMaybe<PrismicFooterDataProductLinksSortInput>
    referrals: InputMaybe<SortOrderEnum>
    resources_heading: InputMaybe<SortOrderEnum>
    resources_links: InputMaybe<PrismicFooterDataResourcesLinksSortInput>
    sales_email: InputMaybe<SortOrderEnum>
    security: InputMaybe<SortOrderEnum>
    solutions_heading: InputMaybe<SortOrderEnum>
    solutions_links: InputMaybe<PrismicFooterDataSolutionsLinksSortInput>
    status: InputMaybe<SortOrderEnum>
    support_email: InputMaybe<SortOrderEnum>
    terms_body: InputMaybe<SortOrderEnum>
    why_pleo: InputMaybe<SortOrderEnum>
}

export type PrismicFooterEdge = {
    next: Maybe<PrismicFooter>
    node: PrismicFooter
    previous: Maybe<PrismicFooter>
}

export type PrismicFooterFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFooterDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFooterDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFooterEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFooterGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFooter>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFooterGroupConnectionDistinctArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterGroupConnectionGroupArgs = {
    field: PrismicFooterFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFooterGroupConnectionMaxArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterGroupConnectionMinArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterGroupConnectionSumArgs = {
    field: PrismicFooterFieldSelector
}

export type PrismicFooterSignup = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFooterSignupDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFooterSignupFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFooterSignupLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFooterSignupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFooterSignupEdge>
    group: Array<PrismicFooterSignupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFooterSignup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFooterSignupConnectionDistinctArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupConnectionGroupArgs = {
    field: PrismicFooterSignupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFooterSignupConnectionMaxArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupConnectionMinArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupConnectionSumArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupDataPressItems = {
    company_name: Maybe<Scalars['String']['output']>
    logo: Maybe<PrismicFooterSignupDataPressItemsLogoImageType>
}

export type PrismicFooterSignupDataPressItemsFieldSelector = {
    company_name: InputMaybe<FieldSelectorEnum>
    logo: InputMaybe<PrismicFooterSignupDataPressItemsLogoImageTypeFieldSelector>
}

export type PrismicFooterSignupDataPressItemsFilterInput = {
    company_name: InputMaybe<StringQueryOperatorInput>
    logo: InputMaybe<PrismicFooterSignupDataPressItemsLogoImageTypeFilterInput>
}

export type PrismicFooterSignupDataPressItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicFooterSignupDataPressItemsFilterInput>
}

export type PrismicFooterSignupDataPressItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterSignupDataPressItemsLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFooterSignupDataPressItemsSortInput = {
    company_name: InputMaybe<SortOrderEnum>
    logo: InputMaybe<PrismicFooterSignupDataPressItemsLogoImageTypeSortInput>
}

export type PrismicFooterSignupDataType = {
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    featured_text: Maybe<Scalars['String']['output']>
    press_items: Maybe<Array<Maybe<PrismicFooterSignupDataPressItems>>>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicFooterSignupDataTypeFieldSelector = {
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    featured_text: InputMaybe<FieldSelectorEnum>
    press_items: InputMaybe<PrismicFooterSignupDataPressItemsFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterSignupDataTypeFilterInput = {
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    featured_text: InputMaybe<StringQueryOperatorInput>
    press_items: InputMaybe<PrismicFooterSignupDataPressItemsFilterListInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterSignupDataTypeSortInput = {
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    featured_text: InputMaybe<SortOrderEnum>
    press_items: InputMaybe<PrismicFooterSignupDataPressItemsSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicFooterSignupEdge = {
    next: Maybe<PrismicFooterSignup>
    node: PrismicFooterSignup
    previous: Maybe<PrismicFooterSignup>
}

export type PrismicFooterSignupFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFooterSignupDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFooterSignupFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFooterSignupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFooterSignupGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFooterSignupEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFooterSignupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFooterSignup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFooterSignupGroupConnectionDistinctArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupGroupConnectionGroupArgs = {
    field: PrismicFooterSignupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFooterSignupGroupConnectionMaxArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupGroupConnectionMinArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupGroupConnectionSumArgs = {
    field: PrismicFooterSignupFieldSelector
}

export type PrismicFooterSignupSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFooterSignupDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFooterSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFooterDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicFormConsent = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicFormConsentDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicFormConsentFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFormConsentLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicFormConsentConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentEdge>
    group: Array<PrismicFormConsentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentConnectionDistinctArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentConnectionGroupArgs = {
    field: PrismicFormConsentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFormConsentConnectionMaxArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentConnectionMinArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentConnectionSumArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
    subscriptionId: Maybe<Scalars['Int']['output']>
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeEdge>
    group: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeEdge = {
    next: Maybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
    node: PrismicFormConsentDataSubscriptionTypeProductionIntegrationType
    previous: Maybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    subscriptionId: InputMaybe<FieldSelectorEnum>
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    subscriptionId: InputMaybe<IntQueryOperatorInput>
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    subscriptionId: InputMaybe<SortOrderEnum>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
    subscriptionId: Maybe<Scalars['Int']['output']>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeEdge>
    group: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeEdge = {
    next: Maybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
    node: PrismicFormConsentDataSubscriptionTypeStagingIntegrationType
    previous: Maybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    subscriptionId: InputMaybe<FieldSelectorEnum>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    subscriptionId: InputMaybe<IntQueryOperatorInput>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
    }

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector
}

export type PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    subscriptionId: InputMaybe<SortOrderEnum>
}

export type PrismicFormConsentDataType = {
    is_default: Maybe<Scalars['Boolean']['output']>
    subscription_type_production: Maybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
    subscription_type_staging: Maybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
    text: Maybe<PrismicStructuredTextType>
    type: Maybe<Scalars['String']['output']>
}

export type PrismicFormConsentDataTypeFieldSelector = {
    is_default: InputMaybe<FieldSelectorEnum>
    subscription_type_production: InputMaybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFieldSelector>
    subscription_type_staging: InputMaybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFieldSelector>
    text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicFormConsentDataTypeFilterInput = {
    is_default: InputMaybe<BooleanQueryOperatorInput>
    subscription_type_production: InputMaybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFilterInput>
    subscription_type_staging: InputMaybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFilterInput>
    text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFormConsentDataTypeSortInput = {
    is_default: InputMaybe<SortOrderEnum>
    subscription_type_production: InputMaybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeSortInput>
    subscription_type_staging: InputMaybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeSortInput>
    text: InputMaybe<PrismicStructuredTextTypeSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicFormConsentEdge = {
    next: Maybe<PrismicFormConsent>
    node: PrismicFormConsent
    previous: Maybe<PrismicFormConsent>
}

export type PrismicFormConsentFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicFormConsentDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicFormConsentFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFormConsentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicFormConsentGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicFormConsentEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicFormConsentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicFormConsent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicFormConsentGroupConnectionDistinctArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentGroupConnectionGroupArgs = {
    field: PrismicFormConsentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicFormConsentGroupConnectionMaxArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentGroupConnectionMinArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentGroupConnectionSumArgs = {
    field: PrismicFormConsentFieldSelector
}

export type PrismicFormConsentSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicFormConsentDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGeoPointType = {
    latitude: Scalars['Float']['output']
    longitude: Scalars['Float']['output']
}

export type PrismicGettingStartedExperience = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicGettingStartedExperienceDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicGettingStartedExperienceLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicGettingStartedExperienceConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceEdge>
    group: Array<PrismicGettingStartedExperienceGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperience>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceConnectionDistinctArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceConnectionGroupArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceConnectionMaxArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceConnectionMinArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceConnectionSumArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataAccountOption1IconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataAccountOption2IconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataAccountOption3IconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFieldSelector =
    {
        alt: InputMaybe<FieldSelectorEnum>
        copyright: InputMaybe<FieldSelectorEnum>
        dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
        fixed: InputMaybe<ImgixFixedFieldSelector>
        fluid: InputMaybe<ImgixFluidFieldSelector>
        gatsbyImageData: InputMaybe<FieldSelectorEnum>
        localFile: InputMaybe<FileFieldSelector>
        url: InputMaybe<FieldSelectorEnum>
    }

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
    node: PrismicGettingStartedExperienceDataFormProductionIntegrationType
    previous: Maybe<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
    node: PrismicGettingStartedExperienceDataFormStagingIntegrationType
    previous: Maybe<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
    }

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicGettingStartedExperienceDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicGettingStartedExperienceDataImages = {
    image: Maybe<PrismicGettingStartedExperienceDataImagesImageImageType>
}

export type PrismicGettingStartedExperienceDataImagesFieldSelector = {
    image: InputMaybe<PrismicGettingStartedExperienceDataImagesImageImageTypeFieldSelector>
}

export type PrismicGettingStartedExperienceDataImagesFilterInput = {
    image: InputMaybe<PrismicGettingStartedExperienceDataImagesImageImageTypeFilterInput>
}

export type PrismicGettingStartedExperienceDataImagesFilterListInput = {
    elemMatch: InputMaybe<PrismicGettingStartedExperienceDataImagesFilterInput>
}

export type PrismicGettingStartedExperienceDataImagesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataImagesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataImagesSortInput = {
    image: InputMaybe<PrismicGettingStartedExperienceDataImagesImageImageTypeSortInput>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataSuccessImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataType = {
    account_option_1_description: Maybe<Scalars['String']['output']>
    account_option_1_icon: Maybe<PrismicGettingStartedExperienceDataAccountOption1IconImageType>
    account_option_1_label: Maybe<Scalars['String']['output']>
    account_option_2_description: Maybe<Scalars['String']['output']>
    account_option_2_icon: Maybe<PrismicGettingStartedExperienceDataAccountOption2IconImageType>
    account_option_2_label: Maybe<Scalars['String']['output']>
    account_option_3_description: Maybe<Scalars['String']['output']>
    account_option_3_icon: Maybe<PrismicGettingStartedExperienceDataAccountOption3IconImageType>
    account_option_3_label: Maybe<Scalars['String']['output']>
    account_question: Maybe<Scalars['String']['output']>
    back_to_home_page_text: Maybe<Scalars['String']['output']>
    entity_continue_button: Maybe<Scalars['String']['output']>
    entity_description: Maybe<Scalars['String']['output']>
    entity_i_dont_know_option: Maybe<Scalars['String']['output']>
    entity_no_entity_option: Maybe<Scalars['String']['output']>
    entity_select_label: Maybe<Scalars['String']['output']>
    entity_select_placeholder: Maybe<Scalars['String']['output']>
    entity_title: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    existing_client_description: Maybe<Scalars['String']['output']>
    existing_client_help_text: Maybe<PrismicStructuredTextType>
    existing_client_help_title: Maybe<Scalars['String']['output']>
    existing_client_title: Maybe<Scalars['String']['output']>
    existing_client_wistia_id: Maybe<Scalars['String']['output']>
    existing_client_wistia_thumbnail: Maybe<PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageType>
    form_production: Maybe<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
    form_submit_text: Maybe<Scalars['String']['output']>
    images: Maybe<Array<Maybe<PrismicGettingStartedExperienceDataImages>>>
    marquee_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    multi_entity_banner_description: Maybe<PrismicStructuredTextType>
    multi_entity_banner_image: Maybe<PrismicGettingStartedExperienceDataMultiEntityBannerImageImageType>
    multi_entity_banner_title: Maybe<Scalars['String']['output']>
    multi_entity_book_a_demo_button_text: Maybe<Scalars['String']['output']>
    multi_entity_description: Maybe<Scalars['String']['output']>
    multi_entity_get_started_button_text: Maybe<Scalars['String']['output']>
    multi_entity_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicGettingStartedExperienceDataOpenGraphImageImageType>
    success_image: Maybe<PrismicGettingStartedExperienceDataSuccessImageImageType>
    success_message_description: Maybe<Scalars['String']['output']>
    success_message_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    waiting_list_description: Maybe<Scalars['String']['output']>
    waiting_list_title: Maybe<Scalars['String']['output']>
    where_pleo_operates_img: Maybe<PrismicGettingStartedExperienceDataWherePleoOperatesImgImageType>
    where_pleo_operates_label: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataTypeFieldSelector = {
    account_option_1_description: InputMaybe<FieldSelectorEnum>
    account_option_1_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFieldSelector>
    account_option_1_label: InputMaybe<FieldSelectorEnum>
    account_option_2_description: InputMaybe<FieldSelectorEnum>
    account_option_2_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFieldSelector>
    account_option_2_label: InputMaybe<FieldSelectorEnum>
    account_option_3_description: InputMaybe<FieldSelectorEnum>
    account_option_3_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFieldSelector>
    account_option_3_label: InputMaybe<FieldSelectorEnum>
    account_question: InputMaybe<FieldSelectorEnum>
    back_to_home_page_text: InputMaybe<FieldSelectorEnum>
    entity_continue_button: InputMaybe<FieldSelectorEnum>
    entity_description: InputMaybe<FieldSelectorEnum>
    entity_i_dont_know_option: InputMaybe<FieldSelectorEnum>
    entity_no_entity_option: InputMaybe<FieldSelectorEnum>
    entity_select_label: InputMaybe<FieldSelectorEnum>
    entity_select_placeholder: InputMaybe<FieldSelectorEnum>
    entity_title: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    existing_client_description: InputMaybe<FieldSelectorEnum>
    existing_client_help_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    existing_client_help_title: InputMaybe<FieldSelectorEnum>
    existing_client_title: InputMaybe<FieldSelectorEnum>
    existing_client_wistia_id: InputMaybe<FieldSelectorEnum>
    existing_client_wistia_thumbnail: InputMaybe<PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFieldSelector>
    form_production: InputMaybe<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFieldSelector>
    form_submit_text: InputMaybe<FieldSelectorEnum>
    images: InputMaybe<PrismicGettingStartedExperienceDataImagesFieldSelector>
    marquee_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    multi_entity_banner_description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    multi_entity_banner_image: InputMaybe<PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFieldSelector>
    multi_entity_banner_title: InputMaybe<FieldSelectorEnum>
    multi_entity_book_a_demo_button_text: InputMaybe<FieldSelectorEnum>
    multi_entity_description: InputMaybe<FieldSelectorEnum>
    multi_entity_get_started_button_text: InputMaybe<FieldSelectorEnum>
    multi_entity_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFieldSelector>
    success_image: InputMaybe<PrismicGettingStartedExperienceDataSuccessImageImageTypeFieldSelector>
    success_message_description: InputMaybe<FieldSelectorEnum>
    success_message_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    waiting_list_description: InputMaybe<FieldSelectorEnum>
    waiting_list_title: InputMaybe<FieldSelectorEnum>
    where_pleo_operates_img: InputMaybe<PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFieldSelector>
    where_pleo_operates_label: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataTypeFilterInput = {
    account_option_1_description: InputMaybe<StringQueryOperatorInput>
    account_option_1_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption1IconImageTypeFilterInput>
    account_option_1_label: InputMaybe<StringQueryOperatorInput>
    account_option_2_description: InputMaybe<StringQueryOperatorInput>
    account_option_2_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption2IconImageTypeFilterInput>
    account_option_2_label: InputMaybe<StringQueryOperatorInput>
    account_option_3_description: InputMaybe<StringQueryOperatorInput>
    account_option_3_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption3IconImageTypeFilterInput>
    account_option_3_label: InputMaybe<StringQueryOperatorInput>
    account_question: InputMaybe<StringQueryOperatorInput>
    back_to_home_page_text: InputMaybe<StringQueryOperatorInput>
    entity_continue_button: InputMaybe<StringQueryOperatorInput>
    entity_description: InputMaybe<StringQueryOperatorInput>
    entity_i_dont_know_option: InputMaybe<StringQueryOperatorInput>
    entity_no_entity_option: InputMaybe<StringQueryOperatorInput>
    entity_select_label: InputMaybe<StringQueryOperatorInput>
    entity_select_placeholder: InputMaybe<StringQueryOperatorInput>
    entity_title: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    existing_client_description: InputMaybe<StringQueryOperatorInput>
    existing_client_help_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    existing_client_help_title: InputMaybe<StringQueryOperatorInput>
    existing_client_title: InputMaybe<StringQueryOperatorInput>
    existing_client_wistia_id: InputMaybe<StringQueryOperatorInput>
    existing_client_wistia_thumbnail: InputMaybe<PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeFilterInput>
    form_production: InputMaybe<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFilterInput>
    form_submit_text: InputMaybe<StringQueryOperatorInput>
    images: InputMaybe<PrismicGettingStartedExperienceDataImagesFilterListInput>
    marquee_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    multi_entity_banner_description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    multi_entity_banner_image: InputMaybe<PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeFilterInput>
    multi_entity_banner_title: InputMaybe<StringQueryOperatorInput>
    multi_entity_book_a_demo_button_text: InputMaybe<StringQueryOperatorInput>
    multi_entity_description: InputMaybe<StringQueryOperatorInput>
    multi_entity_get_started_button_text: InputMaybe<StringQueryOperatorInput>
    multi_entity_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicGettingStartedExperienceDataOpenGraphImageImageTypeFilterInput>
    success_image: InputMaybe<PrismicGettingStartedExperienceDataSuccessImageImageTypeFilterInput>
    success_message_description: InputMaybe<StringQueryOperatorInput>
    success_message_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    waiting_list_description: InputMaybe<StringQueryOperatorInput>
    waiting_list_title: InputMaybe<StringQueryOperatorInput>
    where_pleo_operates_img: InputMaybe<PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFilterInput>
    where_pleo_operates_label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataTypeSortInput = {
    account_option_1_description: InputMaybe<SortOrderEnum>
    account_option_1_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption1IconImageTypeSortInput>
    account_option_1_label: InputMaybe<SortOrderEnum>
    account_option_2_description: InputMaybe<SortOrderEnum>
    account_option_2_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption2IconImageTypeSortInput>
    account_option_2_label: InputMaybe<SortOrderEnum>
    account_option_3_description: InputMaybe<SortOrderEnum>
    account_option_3_icon: InputMaybe<PrismicGettingStartedExperienceDataAccountOption3IconImageTypeSortInput>
    account_option_3_label: InputMaybe<SortOrderEnum>
    account_question: InputMaybe<SortOrderEnum>
    back_to_home_page_text: InputMaybe<SortOrderEnum>
    entity_continue_button: InputMaybe<SortOrderEnum>
    entity_description: InputMaybe<SortOrderEnum>
    entity_i_dont_know_option: InputMaybe<SortOrderEnum>
    entity_no_entity_option: InputMaybe<SortOrderEnum>
    entity_select_label: InputMaybe<SortOrderEnum>
    entity_select_placeholder: InputMaybe<SortOrderEnum>
    entity_title: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    existing_client_description: InputMaybe<SortOrderEnum>
    existing_client_help_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    existing_client_help_title: InputMaybe<SortOrderEnum>
    existing_client_title: InputMaybe<SortOrderEnum>
    existing_client_wistia_id: InputMaybe<SortOrderEnum>
    existing_client_wistia_thumbnail: InputMaybe<PrismicGettingStartedExperienceDataExistingClientWistiaThumbnailImageTypeSortInput>
    form_production: InputMaybe<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeSortInput>
    form_submit_text: InputMaybe<SortOrderEnum>
    images: InputMaybe<PrismicGettingStartedExperienceDataImagesSortInput>
    marquee_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    multi_entity_banner_description: InputMaybe<PrismicStructuredTextTypeSortInput>
    multi_entity_banner_image: InputMaybe<PrismicGettingStartedExperienceDataMultiEntityBannerImageImageTypeSortInput>
    multi_entity_banner_title: InputMaybe<SortOrderEnum>
    multi_entity_book_a_demo_button_text: InputMaybe<SortOrderEnum>
    multi_entity_description: InputMaybe<SortOrderEnum>
    multi_entity_get_started_button_text: InputMaybe<SortOrderEnum>
    multi_entity_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicGettingStartedExperienceDataOpenGraphImageImageTypeSortInput>
    success_image: InputMaybe<PrismicGettingStartedExperienceDataSuccessImageImageTypeSortInput>
    success_message_description: InputMaybe<SortOrderEnum>
    success_message_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    waiting_list_description: InputMaybe<SortOrderEnum>
    waiting_list_title: InputMaybe<SortOrderEnum>
    where_pleo_operates_img: InputMaybe<PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeSortInput>
    where_pleo_operates_label: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceDataWherePleoOperatesImgImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGettingStartedExperienceEdge = {
    next: Maybe<PrismicGettingStartedExperience>
    node: PrismicGettingStartedExperience
    previous: Maybe<PrismicGettingStartedExperience>
}

export type PrismicGettingStartedExperienceFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicGettingStartedExperienceDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGettingStartedExperienceFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicGettingStartedExperienceDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGettingStartedExperienceGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGettingStartedExperienceEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicGettingStartedExperienceGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGettingStartedExperience>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGettingStartedExperienceGroupConnectionDistinctArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceGroupConnectionGroupArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGettingStartedExperienceGroupConnectionMaxArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceGroupConnectionMinArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceGroupConnectionSumArgs = {
    field: PrismicGettingStartedExperienceFieldSelector
}

export type PrismicGettingStartedExperienceSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicGettingStartedExperienceDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicGlobalStrings = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicGlobalStringsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicGlobalStringsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicGlobalStringsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicGlobalStringsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGlobalStringsEdge>
    group: Array<PrismicGlobalStringsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGlobalStrings>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGlobalStringsConnectionDistinctArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsConnectionGroupArgs = {
    field: PrismicGlobalStringsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGlobalStringsConnectionMaxArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsConnectionMinArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsConnectionSumArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsDataType = {
    accept_terms_and_privacy: Maybe<PrismicStructuredTextType>
    address: Maybe<Scalars['String']['output']>
    admin: Maybe<Scalars['String']['output']>
    all: Maybe<Scalars['String']['output']>
    back: Maybe<Scalars['String']['output']>
    back_to_pleo_io: Maybe<Scalars['String']['output']>
    city: Maybe<Scalars['String']['output']>
    clearbit_credits: Maybe<PrismicStructuredTextType>
    close_button_text: Maybe<Scalars['String']['output']>
    company_logo: Maybe<Scalars['String']['output']>
    company_name: Maybe<Scalars['String']['output']>
    company_size: Maybe<Scalars['String']['output']>
    company_size_error: Maybe<Scalars['String']['output']>
    consent_label: Maybe<PrismicStructuredTextType>
    consents_error: Maybe<Scalars['String']['output']>
    contact_sales: Maybe<Scalars['String']['output']>
    continue: Maybe<Scalars['String']['output']>
    copied_to_clipboard: Maybe<Scalars['String']['output']>
    copy_to_clipboard: Maybe<Scalars['String']['output']>
    country: Maybe<Scalars['String']['output']>
    country_error: Maybe<Scalars['String']['output']>
    country_placeholder: Maybe<Scalars['String']['output']>
    currency: Maybe<Scalars['String']['output']>
    days: Maybe<Scalars['String']['output']>
    demo_submit_text: Maybe<Scalars['String']['output']>
    discovered_via_label: Maybe<Scalars['String']['output']>
    discovered_via_placeholder: Maybe<Scalars['String']['output']>
    due_date: Maybe<Scalars['String']['output']>
    email: Maybe<Scalars['String']['output']>
    employee: Maybe<Scalars['String']['output']>
    employees: Maybe<Scalars['String']['output']>
    feedback: Maybe<Scalars['String']['output']>
    file_type: Maybe<Scalars['String']['output']>
    file_upload_too_large: Maybe<Scalars['String']['output']>
    filter_items: Maybe<Scalars['String']['output']>
    financial_partner_disclaimer: Maybe<Scalars['String']['output']>
    first_name: Maybe<Scalars['String']['output']>
    first_name_error: Maybe<Scalars['String']['output']>
    form_submission_error: Maybe<Scalars['String']['output']>
    form_thank_you_button_label: Maybe<Scalars['String']['output']>
    form_thank_you_content: Maybe<PrismicStructuredTextType>
    form_thank_you_title: Maybe<Scalars['String']['output']>
    free_plan_cost_label: Maybe<Scalars['String']['output']>
    get_started: Maybe<Scalars['String']['output']>
    google_search: Maybe<Scalars['String']['output']>
    has_consented_error: Maybe<Scalars['String']['output']>
    home: Maybe<Scalars['String']['output']>
    hours: Maybe<Scalars['String']['output']>
    industry: Maybe<Scalars['String']['output']>
    interest_message_label: Maybe<Scalars['String']['output']>
    invalid_email_error: Maybe<Scalars['String']['output']>
    invoice_number: Maybe<Scalars['String']['output']>
    issued_on: Maybe<Scalars['String']['output']>
    labels: Maybe<Scalars['String']['output']>
    last_name: Maybe<Scalars['String']['output']>
    last_name_error: Maybe<Scalars['String']['output']>
    latest_articles: Maybe<Scalars['String']['output']>
    learn_more: Maybe<Scalars['String']['output']>
    loading: Maybe<Scalars['String']['output']>
    locale_selector_global_label: Maybe<Scalars['String']['output']>
    location: Maybe<Scalars['String']['output']>
    make_a_submission: Maybe<Scalars['String']['output']>
    marketing_emails_consent_text: Maybe<PrismicStructuredTextType>
    menu: Maybe<Scalars['String']['output']>
    min_read: Maybe<Scalars['String']['output']>
    mins_read: Maybe<Scalars['String']['output']>
    minutes: Maybe<Scalars['String']['output']>
    must_be_company_email: Maybe<Scalars['String']['output']>
    next: Maybe<Scalars['String']['output']>
    non_work_email_error: Maybe<Scalars['String']['output']>
    non_work_email_error_cta_text: Maybe<Scalars['String']['output']>
    notification_banner_message: Maybe<PrismicStructuredTextType>
    notification_banner_message_forward: Maybe<PrismicStructuredTextType>
    notification_banner_message_old: Maybe<PrismicStructuredTextType>
    num_customers: Maybe<Scalars['String']['output']>
    number_of_customers: Maybe<Scalars['String']['output']>
    number_of_customers_error: Maybe<Scalars['String']['output']>
    other: Maybe<Scalars['String']['output']>
    outdoor_advertising: Maybe<Scalars['String']['output']>
    panel: Maybe<Scalars['String']['output']>
    panels: Maybe<Scalars['String']['output']>
    peer_recommendation: Maybe<Scalars['String']['output']>
    phone_number: Maybe<Scalars['String']['output']>
    phone_number_error: Maybe<Scalars['String']['output']>
    play: Maybe<Scalars['String']['output']>
    play_video: Maybe<Scalars['String']['output']>
    please_enter_a_work_email: Maybe<Scalars['String']['output']>
    please_enter_your_work_email: Maybe<Scalars['String']['output']>
    please_select_number_of_employees: Maybe<Scalars['String']['output']>
    postcode: Maybe<Scalars['String']['output']>
    press: Maybe<Scalars['String']['output']>
    preview: Maybe<Scalars['String']['output']>
    previous: Maybe<Scalars['String']['output']>
    privacy_consent_text: Maybe<PrismicStructuredTextType>
    read_more: Maybe<Scalars['String']['output']>
    recaptcha_and_privacy_terms: Maybe<PrismicStructuredTextType>
    recaptcha_message: Maybe<PrismicStructuredTextType>
    related_posts_text: Maybe<Scalars['String']['output']>
    select: Maybe<Scalars['String']['output']>
    send_message: Maybe<Scalars['String']['output']>
    sequence_posts_text: Maybe<Scalars['String']['output']>
    show_me: Maybe<Scalars['String']['output']>
    show_more: Maybe<Scalars['String']['output']>
    sign_up: Maybe<Scalars['String']['output']>
    skip_to_content: Maybe<Scalars['String']['output']>
    slides: Maybe<Scalars['String']['output']>
    social_media: Maybe<Scalars['String']['output']>
    sole_trader: Maybe<Scalars['String']['output']>
    something_went_wrong: Maybe<Scalars['String']['output']>
    state: Maybe<Scalars['String']['output']>
    sticky_cta_button_text: Maybe<Scalars['String']['output']>
    submit: Maybe<Scalars['String']['output']>
    tags: Maybe<Scalars['String']['output']>
    this_field_is_required: Maybe<Scalars['String']['output']>
    trust_pilot: Maybe<Scalars['String']['output']>
    tv: Maybe<Scalars['String']['output']>
    upload_text: Maybe<Scalars['String']['output']>
    visit_website: Maybe<Scalars['String']['output']>
    watch_now: Maybe<Scalars['String']['output']>
    watch_the_video: Maybe<Scalars['String']['output']>
    work_email: Maybe<Scalars['String']['output']>
    your_email_label: Maybe<Scalars['String']['output']>
    your_full_name: Maybe<Scalars['String']['output']>
    your_message: Maybe<Scalars['String']['output']>
    your_work_email: Maybe<Scalars['String']['output']>
    youtube: Maybe<Scalars['String']['output']>
}

export type PrismicGlobalStringsDataTypeFieldSelector = {
    accept_terms_and_privacy: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    address: InputMaybe<FieldSelectorEnum>
    admin: InputMaybe<FieldSelectorEnum>
    all: InputMaybe<FieldSelectorEnum>
    back: InputMaybe<FieldSelectorEnum>
    back_to_pleo_io: InputMaybe<FieldSelectorEnum>
    city: InputMaybe<FieldSelectorEnum>
    clearbit_credits: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    close_button_text: InputMaybe<FieldSelectorEnum>
    company_logo: InputMaybe<FieldSelectorEnum>
    company_name: InputMaybe<FieldSelectorEnum>
    company_size: InputMaybe<FieldSelectorEnum>
    company_size_error: InputMaybe<FieldSelectorEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    consents_error: InputMaybe<FieldSelectorEnum>
    contact_sales: InputMaybe<FieldSelectorEnum>
    continue: InputMaybe<FieldSelectorEnum>
    copied_to_clipboard: InputMaybe<FieldSelectorEnum>
    copy_to_clipboard: InputMaybe<FieldSelectorEnum>
    country: InputMaybe<FieldSelectorEnum>
    country_error: InputMaybe<FieldSelectorEnum>
    country_placeholder: InputMaybe<FieldSelectorEnum>
    currency: InputMaybe<FieldSelectorEnum>
    days: InputMaybe<FieldSelectorEnum>
    demo_submit_text: InputMaybe<FieldSelectorEnum>
    discovered_via_label: InputMaybe<FieldSelectorEnum>
    discovered_via_placeholder: InputMaybe<FieldSelectorEnum>
    due_date: InputMaybe<FieldSelectorEnum>
    email: InputMaybe<FieldSelectorEnum>
    employee: InputMaybe<FieldSelectorEnum>
    employees: InputMaybe<FieldSelectorEnum>
    feedback: InputMaybe<FieldSelectorEnum>
    file_type: InputMaybe<FieldSelectorEnum>
    file_upload_too_large: InputMaybe<FieldSelectorEnum>
    filter_items: InputMaybe<FieldSelectorEnum>
    financial_partner_disclaimer: InputMaybe<FieldSelectorEnum>
    first_name: InputMaybe<FieldSelectorEnum>
    first_name_error: InputMaybe<FieldSelectorEnum>
    form_submission_error: InputMaybe<FieldSelectorEnum>
    form_thank_you_button_label: InputMaybe<FieldSelectorEnum>
    form_thank_you_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    form_thank_you_title: InputMaybe<FieldSelectorEnum>
    free_plan_cost_label: InputMaybe<FieldSelectorEnum>
    get_started: InputMaybe<FieldSelectorEnum>
    google_search: InputMaybe<FieldSelectorEnum>
    has_consented_error: InputMaybe<FieldSelectorEnum>
    home: InputMaybe<FieldSelectorEnum>
    hours: InputMaybe<FieldSelectorEnum>
    industry: InputMaybe<FieldSelectorEnum>
    interest_message_label: InputMaybe<FieldSelectorEnum>
    invalid_email_error: InputMaybe<FieldSelectorEnum>
    invoice_number: InputMaybe<FieldSelectorEnum>
    issued_on: InputMaybe<FieldSelectorEnum>
    labels: InputMaybe<FieldSelectorEnum>
    last_name: InputMaybe<FieldSelectorEnum>
    last_name_error: InputMaybe<FieldSelectorEnum>
    latest_articles: InputMaybe<FieldSelectorEnum>
    learn_more: InputMaybe<FieldSelectorEnum>
    loading: InputMaybe<FieldSelectorEnum>
    locale_selector_global_label: InputMaybe<FieldSelectorEnum>
    location: InputMaybe<FieldSelectorEnum>
    make_a_submission: InputMaybe<FieldSelectorEnum>
    marketing_emails_consent_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    menu: InputMaybe<FieldSelectorEnum>
    min_read: InputMaybe<FieldSelectorEnum>
    mins_read: InputMaybe<FieldSelectorEnum>
    minutes: InputMaybe<FieldSelectorEnum>
    must_be_company_email: InputMaybe<FieldSelectorEnum>
    next: InputMaybe<FieldSelectorEnum>
    non_work_email_error: InputMaybe<FieldSelectorEnum>
    non_work_email_error_cta_text: InputMaybe<FieldSelectorEnum>
    notification_banner_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    notification_banner_message_forward: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    notification_banner_message_old: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    num_customers: InputMaybe<FieldSelectorEnum>
    number_of_customers: InputMaybe<FieldSelectorEnum>
    number_of_customers_error: InputMaybe<FieldSelectorEnum>
    other: InputMaybe<FieldSelectorEnum>
    outdoor_advertising: InputMaybe<FieldSelectorEnum>
    panel: InputMaybe<FieldSelectorEnum>
    panels: InputMaybe<FieldSelectorEnum>
    peer_recommendation: InputMaybe<FieldSelectorEnum>
    phone_number: InputMaybe<FieldSelectorEnum>
    phone_number_error: InputMaybe<FieldSelectorEnum>
    play: InputMaybe<FieldSelectorEnum>
    play_video: InputMaybe<FieldSelectorEnum>
    please_enter_a_work_email: InputMaybe<FieldSelectorEnum>
    please_enter_your_work_email: InputMaybe<FieldSelectorEnum>
    please_select_number_of_employees: InputMaybe<FieldSelectorEnum>
    postcode: InputMaybe<FieldSelectorEnum>
    press: InputMaybe<FieldSelectorEnum>
    preview: InputMaybe<FieldSelectorEnum>
    previous: InputMaybe<FieldSelectorEnum>
    privacy_consent_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    read_more: InputMaybe<FieldSelectorEnum>
    recaptcha_and_privacy_terms: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    related_posts_text: InputMaybe<FieldSelectorEnum>
    select: InputMaybe<FieldSelectorEnum>
    send_message: InputMaybe<FieldSelectorEnum>
    sequence_posts_text: InputMaybe<FieldSelectorEnum>
    show_me: InputMaybe<FieldSelectorEnum>
    show_more: InputMaybe<FieldSelectorEnum>
    sign_up: InputMaybe<FieldSelectorEnum>
    skip_to_content: InputMaybe<FieldSelectorEnum>
    slides: InputMaybe<FieldSelectorEnum>
    social_media: InputMaybe<FieldSelectorEnum>
    sole_trader: InputMaybe<FieldSelectorEnum>
    something_went_wrong: InputMaybe<FieldSelectorEnum>
    state: InputMaybe<FieldSelectorEnum>
    sticky_cta_button_text: InputMaybe<FieldSelectorEnum>
    submit: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    this_field_is_required: InputMaybe<FieldSelectorEnum>
    trust_pilot: InputMaybe<FieldSelectorEnum>
    tv: InputMaybe<FieldSelectorEnum>
    upload_text: InputMaybe<FieldSelectorEnum>
    visit_website: InputMaybe<FieldSelectorEnum>
    watch_now: InputMaybe<FieldSelectorEnum>
    watch_the_video: InputMaybe<FieldSelectorEnum>
    work_email: InputMaybe<FieldSelectorEnum>
    your_email_label: InputMaybe<FieldSelectorEnum>
    your_full_name: InputMaybe<FieldSelectorEnum>
    your_message: InputMaybe<FieldSelectorEnum>
    your_work_email: InputMaybe<FieldSelectorEnum>
    youtube: InputMaybe<FieldSelectorEnum>
}

export type PrismicGlobalStringsDataTypeFilterInput = {
    accept_terms_and_privacy: InputMaybe<PrismicStructuredTextTypeFilterInput>
    address: InputMaybe<StringQueryOperatorInput>
    admin: InputMaybe<StringQueryOperatorInput>
    all: InputMaybe<StringQueryOperatorInput>
    back: InputMaybe<StringQueryOperatorInput>
    back_to_pleo_io: InputMaybe<StringQueryOperatorInput>
    city: InputMaybe<StringQueryOperatorInput>
    clearbit_credits: InputMaybe<PrismicStructuredTextTypeFilterInput>
    close_button_text: InputMaybe<StringQueryOperatorInput>
    company_logo: InputMaybe<StringQueryOperatorInput>
    company_name: InputMaybe<StringQueryOperatorInput>
    company_size: InputMaybe<StringQueryOperatorInput>
    company_size_error: InputMaybe<StringQueryOperatorInput>
    consent_label: InputMaybe<PrismicStructuredTextTypeFilterInput>
    consents_error: InputMaybe<StringQueryOperatorInput>
    contact_sales: InputMaybe<StringQueryOperatorInput>
    continue: InputMaybe<StringQueryOperatorInput>
    copied_to_clipboard: InputMaybe<StringQueryOperatorInput>
    copy_to_clipboard: InputMaybe<StringQueryOperatorInput>
    country: InputMaybe<StringQueryOperatorInput>
    country_error: InputMaybe<StringQueryOperatorInput>
    country_placeholder: InputMaybe<StringQueryOperatorInput>
    currency: InputMaybe<StringQueryOperatorInput>
    days: InputMaybe<StringQueryOperatorInput>
    demo_submit_text: InputMaybe<StringQueryOperatorInput>
    discovered_via_label: InputMaybe<StringQueryOperatorInput>
    discovered_via_placeholder: InputMaybe<StringQueryOperatorInput>
    due_date: InputMaybe<StringQueryOperatorInput>
    email: InputMaybe<StringQueryOperatorInput>
    employee: InputMaybe<StringQueryOperatorInput>
    employees: InputMaybe<StringQueryOperatorInput>
    feedback: InputMaybe<StringQueryOperatorInput>
    file_type: InputMaybe<StringQueryOperatorInput>
    file_upload_too_large: InputMaybe<StringQueryOperatorInput>
    filter_items: InputMaybe<StringQueryOperatorInput>
    financial_partner_disclaimer: InputMaybe<StringQueryOperatorInput>
    first_name: InputMaybe<StringQueryOperatorInput>
    first_name_error: InputMaybe<StringQueryOperatorInput>
    form_submission_error: InputMaybe<StringQueryOperatorInput>
    form_thank_you_button_label: InputMaybe<StringQueryOperatorInput>
    form_thank_you_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    form_thank_you_title: InputMaybe<StringQueryOperatorInput>
    free_plan_cost_label: InputMaybe<StringQueryOperatorInput>
    get_started: InputMaybe<StringQueryOperatorInput>
    google_search: InputMaybe<StringQueryOperatorInput>
    has_consented_error: InputMaybe<StringQueryOperatorInput>
    home: InputMaybe<StringQueryOperatorInput>
    hours: InputMaybe<StringQueryOperatorInput>
    industry: InputMaybe<StringQueryOperatorInput>
    interest_message_label: InputMaybe<StringQueryOperatorInput>
    invalid_email_error: InputMaybe<StringQueryOperatorInput>
    invoice_number: InputMaybe<StringQueryOperatorInput>
    issued_on: InputMaybe<StringQueryOperatorInput>
    labels: InputMaybe<StringQueryOperatorInput>
    last_name: InputMaybe<StringQueryOperatorInput>
    last_name_error: InputMaybe<StringQueryOperatorInput>
    latest_articles: InputMaybe<StringQueryOperatorInput>
    learn_more: InputMaybe<StringQueryOperatorInput>
    loading: InputMaybe<StringQueryOperatorInput>
    locale_selector_global_label: InputMaybe<StringQueryOperatorInput>
    location: InputMaybe<StringQueryOperatorInput>
    make_a_submission: InputMaybe<StringQueryOperatorInput>
    marketing_emails_consent_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    menu: InputMaybe<StringQueryOperatorInput>
    min_read: InputMaybe<StringQueryOperatorInput>
    mins_read: InputMaybe<StringQueryOperatorInput>
    minutes: InputMaybe<StringQueryOperatorInput>
    must_be_company_email: InputMaybe<StringQueryOperatorInput>
    next: InputMaybe<StringQueryOperatorInput>
    non_work_email_error: InputMaybe<StringQueryOperatorInput>
    non_work_email_error_cta_text: InputMaybe<StringQueryOperatorInput>
    notification_banner_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    notification_banner_message_forward: InputMaybe<PrismicStructuredTextTypeFilterInput>
    notification_banner_message_old: InputMaybe<PrismicStructuredTextTypeFilterInput>
    num_customers: InputMaybe<StringQueryOperatorInput>
    number_of_customers: InputMaybe<StringQueryOperatorInput>
    number_of_customers_error: InputMaybe<StringQueryOperatorInput>
    other: InputMaybe<StringQueryOperatorInput>
    outdoor_advertising: InputMaybe<StringQueryOperatorInput>
    panel: InputMaybe<StringQueryOperatorInput>
    panels: InputMaybe<StringQueryOperatorInput>
    peer_recommendation: InputMaybe<StringQueryOperatorInput>
    phone_number: InputMaybe<StringQueryOperatorInput>
    phone_number_error: InputMaybe<StringQueryOperatorInput>
    play: InputMaybe<StringQueryOperatorInput>
    play_video: InputMaybe<StringQueryOperatorInput>
    please_enter_a_work_email: InputMaybe<StringQueryOperatorInput>
    please_enter_your_work_email: InputMaybe<StringQueryOperatorInput>
    please_select_number_of_employees: InputMaybe<StringQueryOperatorInput>
    postcode: InputMaybe<StringQueryOperatorInput>
    press: InputMaybe<StringQueryOperatorInput>
    preview: InputMaybe<StringQueryOperatorInput>
    previous: InputMaybe<StringQueryOperatorInput>
    privacy_consent_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    read_more: InputMaybe<StringQueryOperatorInput>
    recaptcha_and_privacy_terms: InputMaybe<PrismicStructuredTextTypeFilterInput>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    related_posts_text: InputMaybe<StringQueryOperatorInput>
    select: InputMaybe<StringQueryOperatorInput>
    send_message: InputMaybe<StringQueryOperatorInput>
    sequence_posts_text: InputMaybe<StringQueryOperatorInput>
    show_me: InputMaybe<StringQueryOperatorInput>
    show_more: InputMaybe<StringQueryOperatorInput>
    sign_up: InputMaybe<StringQueryOperatorInput>
    skip_to_content: InputMaybe<StringQueryOperatorInput>
    slides: InputMaybe<StringQueryOperatorInput>
    social_media: InputMaybe<StringQueryOperatorInput>
    sole_trader: InputMaybe<StringQueryOperatorInput>
    something_went_wrong: InputMaybe<StringQueryOperatorInput>
    state: InputMaybe<StringQueryOperatorInput>
    sticky_cta_button_text: InputMaybe<StringQueryOperatorInput>
    submit: InputMaybe<StringQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    this_field_is_required: InputMaybe<StringQueryOperatorInput>
    trust_pilot: InputMaybe<StringQueryOperatorInput>
    tv: InputMaybe<StringQueryOperatorInput>
    upload_text: InputMaybe<StringQueryOperatorInput>
    visit_website: InputMaybe<StringQueryOperatorInput>
    watch_now: InputMaybe<StringQueryOperatorInput>
    watch_the_video: InputMaybe<StringQueryOperatorInput>
    work_email: InputMaybe<StringQueryOperatorInput>
    your_email_label: InputMaybe<StringQueryOperatorInput>
    your_full_name: InputMaybe<StringQueryOperatorInput>
    your_message: InputMaybe<StringQueryOperatorInput>
    your_work_email: InputMaybe<StringQueryOperatorInput>
    youtube: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGlobalStringsDataTypeSortInput = {
    accept_terms_and_privacy: InputMaybe<PrismicStructuredTextTypeSortInput>
    address: InputMaybe<SortOrderEnum>
    admin: InputMaybe<SortOrderEnum>
    all: InputMaybe<SortOrderEnum>
    back: InputMaybe<SortOrderEnum>
    back_to_pleo_io: InputMaybe<SortOrderEnum>
    city: InputMaybe<SortOrderEnum>
    clearbit_credits: InputMaybe<PrismicStructuredTextTypeSortInput>
    close_button_text: InputMaybe<SortOrderEnum>
    company_logo: InputMaybe<SortOrderEnum>
    company_name: InputMaybe<SortOrderEnum>
    company_size: InputMaybe<SortOrderEnum>
    company_size_error: InputMaybe<SortOrderEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeSortInput>
    consents_error: InputMaybe<SortOrderEnum>
    contact_sales: InputMaybe<SortOrderEnum>
    continue: InputMaybe<SortOrderEnum>
    copied_to_clipboard: InputMaybe<SortOrderEnum>
    copy_to_clipboard: InputMaybe<SortOrderEnum>
    country: InputMaybe<SortOrderEnum>
    country_error: InputMaybe<SortOrderEnum>
    country_placeholder: InputMaybe<SortOrderEnum>
    currency: InputMaybe<SortOrderEnum>
    days: InputMaybe<SortOrderEnum>
    demo_submit_text: InputMaybe<SortOrderEnum>
    discovered_via_label: InputMaybe<SortOrderEnum>
    discovered_via_placeholder: InputMaybe<SortOrderEnum>
    due_date: InputMaybe<SortOrderEnum>
    email: InputMaybe<SortOrderEnum>
    employee: InputMaybe<SortOrderEnum>
    employees: InputMaybe<SortOrderEnum>
    feedback: InputMaybe<SortOrderEnum>
    file_type: InputMaybe<SortOrderEnum>
    file_upload_too_large: InputMaybe<SortOrderEnum>
    filter_items: InputMaybe<SortOrderEnum>
    financial_partner_disclaimer: InputMaybe<SortOrderEnum>
    first_name: InputMaybe<SortOrderEnum>
    first_name_error: InputMaybe<SortOrderEnum>
    form_submission_error: InputMaybe<SortOrderEnum>
    form_thank_you_button_label: InputMaybe<SortOrderEnum>
    form_thank_you_content: InputMaybe<PrismicStructuredTextTypeSortInput>
    form_thank_you_title: InputMaybe<SortOrderEnum>
    free_plan_cost_label: InputMaybe<SortOrderEnum>
    get_started: InputMaybe<SortOrderEnum>
    google_search: InputMaybe<SortOrderEnum>
    has_consented_error: InputMaybe<SortOrderEnum>
    home: InputMaybe<SortOrderEnum>
    hours: InputMaybe<SortOrderEnum>
    industry: InputMaybe<SortOrderEnum>
    interest_message_label: InputMaybe<SortOrderEnum>
    invalid_email_error: InputMaybe<SortOrderEnum>
    invoice_number: InputMaybe<SortOrderEnum>
    issued_on: InputMaybe<SortOrderEnum>
    labels: InputMaybe<SortOrderEnum>
    last_name: InputMaybe<SortOrderEnum>
    last_name_error: InputMaybe<SortOrderEnum>
    latest_articles: InputMaybe<SortOrderEnum>
    learn_more: InputMaybe<SortOrderEnum>
    loading: InputMaybe<SortOrderEnum>
    locale_selector_global_label: InputMaybe<SortOrderEnum>
    location: InputMaybe<SortOrderEnum>
    make_a_submission: InputMaybe<SortOrderEnum>
    marketing_emails_consent_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    menu: InputMaybe<SortOrderEnum>
    min_read: InputMaybe<SortOrderEnum>
    mins_read: InputMaybe<SortOrderEnum>
    minutes: InputMaybe<SortOrderEnum>
    must_be_company_email: InputMaybe<SortOrderEnum>
    next: InputMaybe<SortOrderEnum>
    non_work_email_error: InputMaybe<SortOrderEnum>
    non_work_email_error_cta_text: InputMaybe<SortOrderEnum>
    notification_banner_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    notification_banner_message_forward: InputMaybe<PrismicStructuredTextTypeSortInput>
    notification_banner_message_old: InputMaybe<PrismicStructuredTextTypeSortInput>
    num_customers: InputMaybe<SortOrderEnum>
    number_of_customers: InputMaybe<SortOrderEnum>
    number_of_customers_error: InputMaybe<SortOrderEnum>
    other: InputMaybe<SortOrderEnum>
    outdoor_advertising: InputMaybe<SortOrderEnum>
    panel: InputMaybe<SortOrderEnum>
    panels: InputMaybe<SortOrderEnum>
    peer_recommendation: InputMaybe<SortOrderEnum>
    phone_number: InputMaybe<SortOrderEnum>
    phone_number_error: InputMaybe<SortOrderEnum>
    play: InputMaybe<SortOrderEnum>
    play_video: InputMaybe<SortOrderEnum>
    please_enter_a_work_email: InputMaybe<SortOrderEnum>
    please_enter_your_work_email: InputMaybe<SortOrderEnum>
    please_select_number_of_employees: InputMaybe<SortOrderEnum>
    postcode: InputMaybe<SortOrderEnum>
    press: InputMaybe<SortOrderEnum>
    preview: InputMaybe<SortOrderEnum>
    previous: InputMaybe<SortOrderEnum>
    privacy_consent_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    read_more: InputMaybe<SortOrderEnum>
    recaptcha_and_privacy_terms: InputMaybe<PrismicStructuredTextTypeSortInput>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    related_posts_text: InputMaybe<SortOrderEnum>
    select: InputMaybe<SortOrderEnum>
    send_message: InputMaybe<SortOrderEnum>
    sequence_posts_text: InputMaybe<SortOrderEnum>
    show_me: InputMaybe<SortOrderEnum>
    show_more: InputMaybe<SortOrderEnum>
    sign_up: InputMaybe<SortOrderEnum>
    skip_to_content: InputMaybe<SortOrderEnum>
    slides: InputMaybe<SortOrderEnum>
    social_media: InputMaybe<SortOrderEnum>
    sole_trader: InputMaybe<SortOrderEnum>
    something_went_wrong: InputMaybe<SortOrderEnum>
    state: InputMaybe<SortOrderEnum>
    sticky_cta_button_text: InputMaybe<SortOrderEnum>
    submit: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    this_field_is_required: InputMaybe<SortOrderEnum>
    trust_pilot: InputMaybe<SortOrderEnum>
    tv: InputMaybe<SortOrderEnum>
    upload_text: InputMaybe<SortOrderEnum>
    visit_website: InputMaybe<SortOrderEnum>
    watch_now: InputMaybe<SortOrderEnum>
    watch_the_video: InputMaybe<SortOrderEnum>
    work_email: InputMaybe<SortOrderEnum>
    your_email_label: InputMaybe<SortOrderEnum>
    your_full_name: InputMaybe<SortOrderEnum>
    your_message: InputMaybe<SortOrderEnum>
    your_work_email: InputMaybe<SortOrderEnum>
    youtube: InputMaybe<SortOrderEnum>
}

export type PrismicGlobalStringsEdge = {
    next: Maybe<PrismicGlobalStrings>
    node: PrismicGlobalStrings
    previous: Maybe<PrismicGlobalStrings>
}

export type PrismicGlobalStringsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicGlobalStringsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicGlobalStringsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicGlobalStringsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicGlobalStringsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicGlobalStringsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicGlobalStringsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicGlobalStrings>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicGlobalStringsGroupConnectionDistinctArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsGroupConnectionGroupArgs = {
    field: PrismicGlobalStringsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicGlobalStringsGroupConnectionMaxArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsGroupConnectionMinArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsGroupConnectionSumArgs = {
    field: PrismicGlobalStringsFieldSelector
}

export type PrismicGlobalStringsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicGlobalStringsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeader = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderEdge>
    group: Array<PrismicHeaderGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeader>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderConnectionDistinctArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderConnectionGroupArgs = {
    field: PrismicHeaderFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderConnectionMaxArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderConnectionMinArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderConnectionSumArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderDataDropdowns = {
    dropdown: Maybe<PrismicLinkType>
    label: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    show_badge: Maybe<Scalars['Boolean']['output']>
}

export type PrismicHeaderDataDropdownsFieldSelector = {
    dropdown: InputMaybe<PrismicLinkTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    show_badge: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDataDropdownsFilterInput = {
    dropdown: InputMaybe<PrismicLinkTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    show_badge: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicHeaderDataDropdownsFilterListInput = {
    elemMatch: InputMaybe<PrismicHeaderDataDropdownsFilterInput>
}

export type PrismicHeaderDataDropdownsSortInput = {
    dropdown: InputMaybe<PrismicLinkTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    show_badge: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDataType = {
    app_link_text: Maybe<Scalars['String']['output']>
    book_a_demo: Maybe<Scalars['String']['output']>
    dropdowns: Maybe<Array<Maybe<PrismicHeaderDataDropdowns>>>
    explore: Maybe<Scalars['String']['output']>
    explore_partner_portal: Maybe<Scalars['String']['output']>
    explore_product: Maybe<Scalars['String']['output']>
    log_in: Maybe<Scalars['String']['output']>
    start_free_trial: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDataTypeFieldSelector = {
    app_link_text: InputMaybe<FieldSelectorEnum>
    book_a_demo: InputMaybe<FieldSelectorEnum>
    dropdowns: InputMaybe<PrismicHeaderDataDropdownsFieldSelector>
    explore: InputMaybe<FieldSelectorEnum>
    explore_partner_portal: InputMaybe<FieldSelectorEnum>
    explore_product: InputMaybe<FieldSelectorEnum>
    log_in: InputMaybe<FieldSelectorEnum>
    start_free_trial: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDataTypeFilterInput = {
    app_link_text: InputMaybe<StringQueryOperatorInput>
    book_a_demo: InputMaybe<StringQueryOperatorInput>
    dropdowns: InputMaybe<PrismicHeaderDataDropdownsFilterListInput>
    explore: InputMaybe<StringQueryOperatorInput>
    explore_partner_portal: InputMaybe<StringQueryOperatorInput>
    explore_product: InputMaybe<StringQueryOperatorInput>
    log_in: InputMaybe<StringQueryOperatorInput>
    start_free_trial: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDataTypeSortInput = {
    app_link_text: InputMaybe<SortOrderEnum>
    book_a_demo: InputMaybe<SortOrderEnum>
    dropdowns: InputMaybe<PrismicHeaderDataDropdownsSortInput>
    explore: InputMaybe<SortOrderEnum>
    explore_partner_portal: InputMaybe<SortOrderEnum>
    explore_product: InputMaybe<SortOrderEnum>
    log_in: InputMaybe<SortOrderEnum>
    start_free_trial: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdown = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderDropdownDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownColumn = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderDropdownColumnDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownColumnFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownColumnLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownColumnConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownColumnEdge>
    group: Array<PrismicHeaderDropdownColumnGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdownColumn>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownColumnConnectionDistinctArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnConnectionGroupArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownColumnConnectionMaxArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnConnectionMinArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnConnectionSumArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnDataIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownColumnDataIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdownColumnDataLinks = {
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownColumnDataLinksFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownColumnDataLinksFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownColumnDataLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicHeaderDropdownColumnDataLinksFilterInput>
}

export type PrismicHeaderDropdownColumnDataLinksSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdownColumnDataType = {
    icon: Maybe<PrismicHeaderDropdownColumnDataIconImageType>
    label: Maybe<Scalars['String']['output']>
    links: Maybe<Array<Maybe<PrismicHeaderDropdownColumnDataLinks>>>
}

export type PrismicHeaderDropdownColumnDataTypeFieldSelector = {
    icon: InputMaybe<PrismicHeaderDropdownColumnDataIconImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
    links: InputMaybe<PrismicHeaderDropdownColumnDataLinksFieldSelector>
}

export type PrismicHeaderDropdownColumnDataTypeFilterInput = {
    icon: InputMaybe<PrismicHeaderDropdownColumnDataIconImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
    links: InputMaybe<PrismicHeaderDropdownColumnDataLinksFilterListInput>
}

export type PrismicHeaderDropdownColumnDataTypeSortInput = {
    icon: InputMaybe<PrismicHeaderDropdownColumnDataIconImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
    links: InputMaybe<PrismicHeaderDropdownColumnDataLinksSortInput>
}

export type PrismicHeaderDropdownColumnEdge = {
    next: Maybe<PrismicHeaderDropdownColumn>
    node: PrismicHeaderDropdownColumn
    previous: Maybe<PrismicHeaderDropdownColumn>
}

export type PrismicHeaderDropdownColumnFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeaderDropdownColumnDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownColumnFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownColumnDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownColumnGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownColumnEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderDropdownColumnGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdownColumn>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownColumnGroupConnectionDistinctArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnGroupConnectionGroupArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownColumnGroupConnectionMaxArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnGroupConnectionMinArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnGroupConnectionSumArgs = {
    field: PrismicHeaderDropdownColumnFieldSelector
}

export type PrismicHeaderDropdownColumnSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeaderDropdownColumnDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdownConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownEdge>
    group: Array<PrismicHeaderDropdownGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdown>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownConnectionDistinctArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownConnectionGroupArgs = {
    field: PrismicHeaderDropdownFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownConnectionMaxArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownConnectionMinArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownConnectionSumArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownCta = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderDropdownCtaDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownCtaFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownCtaLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderDropdownCtaConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownCtaEdge>
    group: Array<PrismicHeaderDropdownCtaGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdownCta>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownCtaConnectionDistinctArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaConnectionGroupArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownCtaConnectionMaxArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaConnectionMinArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaConnectionSumArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownCtaDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdownCtaDataType = {
    background_color: Maybe<Scalars['String']['output']>
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHeaderDropdownCtaDataImageImageType>
}

export type PrismicHeaderDropdownCtaDataTypeFieldSelector = {
    background_color: InputMaybe<FieldSelectorEnum>
    body: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicHeaderDropdownCtaDataImageImageTypeFieldSelector>
}

export type PrismicHeaderDropdownCtaDataTypeFilterInput = {
    background_color: InputMaybe<StringQueryOperatorInput>
    body: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicHeaderDropdownCtaDataImageImageTypeFilterInput>
}

export type PrismicHeaderDropdownCtaDataTypeSortInput = {
    background_color: InputMaybe<SortOrderEnum>
    body: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicHeaderDropdownCtaDataImageImageTypeSortInput>
}

export type PrismicHeaderDropdownCtaEdge = {
    next: Maybe<PrismicHeaderDropdownCta>
    node: PrismicHeaderDropdownCta
    previous: Maybe<PrismicHeaderDropdownCta>
}

export type PrismicHeaderDropdownCtaFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeaderDropdownCtaDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownCtaFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownCtaDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownCtaGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownCtaEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderDropdownCtaGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdownCta>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownCtaGroupConnectionDistinctArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaGroupConnectionGroupArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownCtaGroupConnectionMaxArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaGroupConnectionMinArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaGroupConnectionSumArgs = {
    field: PrismicHeaderDropdownCtaFieldSelector
}

export type PrismicHeaderDropdownCtaSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeaderDropdownCtaDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderDropdownDataColumns = {
    column: Maybe<PrismicLinkType>
}

export type PrismicHeaderDropdownDataColumnsFieldSelector = {
    column: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicHeaderDropdownDataColumnsFilterInput = {
    column: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicHeaderDropdownDataColumnsFilterListInput = {
    elemMatch: InputMaybe<PrismicHeaderDropdownDataColumnsFilterInput>
}

export type PrismicHeaderDropdownDataColumnsSortInput = {
    column: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicHeaderDropdownDataType = {
    columns: Maybe<Array<Maybe<PrismicHeaderDropdownDataColumns>>>
    cta_column: Maybe<PrismicLinkType>
}

export type PrismicHeaderDropdownDataTypeFieldSelector = {
    columns: InputMaybe<PrismicHeaderDropdownDataColumnsFieldSelector>
    cta_column: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicHeaderDropdownDataTypeFilterInput = {
    columns: InputMaybe<PrismicHeaderDropdownDataColumnsFilterListInput>
    cta_column: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicHeaderDropdownDataTypeSortInput = {
    columns: InputMaybe<PrismicHeaderDropdownDataColumnsSortInput>
    cta_column: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicHeaderDropdownEdge = {
    next: Maybe<PrismicHeaderDropdown>
    node: PrismicHeaderDropdown
    previous: Maybe<PrismicHeaderDropdown>
}

export type PrismicHeaderDropdownFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeaderDropdownDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderDropdownFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderDropdownGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderDropdownEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderDropdownGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderDropdown>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderDropdownGroupConnectionDistinctArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownGroupConnectionGroupArgs = {
    field: PrismicHeaderDropdownFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderDropdownGroupConnectionMaxArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownGroupConnectionMinArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownGroupConnectionSumArgs = {
    field: PrismicHeaderDropdownFieldSelector
}

export type PrismicHeaderDropdownSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeaderDropdownDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderEdge = {
    next: Maybe<PrismicHeader>
    node: PrismicHeader
    previous: Maybe<PrismicHeader>
}

export type PrismicHeaderFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeaderDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeader>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderGroupConnectionDistinctArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderGroupConnectionGroupArgs = {
    field: PrismicHeaderFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderGroupConnectionMaxArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderGroupConnectionMinArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderGroupConnectionSumArgs = {
    field: PrismicHeaderFieldSelector
}

export type PrismicHeaderSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeaderDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderV2 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderV2DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderV2First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderV2Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderV2Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderV2Edge>
    group: Array<PrismicHeaderV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderV2ConnectionDistinctArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2ConnectionGroupArgs = {
    field: PrismicHeaderV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderV2ConnectionMaxArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2ConnectionMinArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2ConnectionSumArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2DataItems = {
    dropdown: Maybe<PrismicLinkType>
    hide_on: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
}

export type PrismicHeaderV2DataItemsFieldSelector = {
    dropdown: InputMaybe<PrismicLinkTypeFieldSelector>
    hide_on: InputMaybe<FieldSelectorEnum>
    label: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicHeaderV2DataItemsFilterInput = {
    dropdown: InputMaybe<PrismicLinkTypeFilterInput>
    hide_on: InputMaybe<StringQueryOperatorInput>
    label: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicHeaderV2DataItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicHeaderV2DataItemsFilterInput>
}

export type PrismicHeaderV2DataItemsSortInput = {
    dropdown: InputMaybe<PrismicLinkTypeSortInput>
    hide_on: InputMaybe<SortOrderEnum>
    label: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicHeaderV2DataType = {
    items: Maybe<Array<Maybe<PrismicHeaderV2DataItems>>>
    log_in: Maybe<Scalars['String']['output']>
    no_results_text: Maybe<Scalars['String']['output']>
    secondary_cta_link: Maybe<PrismicLinkType>
    secondary_cta_text: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderV2DataTypeFieldSelector = {
    items: InputMaybe<PrismicHeaderV2DataItemsFieldSelector>
    log_in: InputMaybe<FieldSelectorEnum>
    no_results_text: InputMaybe<FieldSelectorEnum>
    secondary_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    secondary_cta_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderV2DataTypeFilterInput = {
    items: InputMaybe<PrismicHeaderV2DataItemsFilterListInput>
    log_in: InputMaybe<StringQueryOperatorInput>
    no_results_text: InputMaybe<StringQueryOperatorInput>
    secondary_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    secondary_cta_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderV2DataTypeSortInput = {
    items: InputMaybe<PrismicHeaderV2DataItemsSortInput>
    log_in: InputMaybe<SortOrderEnum>
    no_results_text: InputMaybe<SortOrderEnum>
    secondary_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    secondary_cta_text: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderV2Dropdown = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeaderV2DropdownDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderV2DropdownFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderV2DropdownLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeaderV2DropdownConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderV2DropdownEdge>
    group: Array<PrismicHeaderV2DropdownGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderV2Dropdown>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderV2DropdownConnectionDistinctArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownConnectionGroupArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderV2DropdownConnectionMaxArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownConnectionMinArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownConnectionSumArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownDataBodyLinksGroup = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHeaderV2DropdownDataBodyLinksGroupItem>
    primary: PrismicHeaderV2DropdownDataBodyLinksGroupPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHeaderV2DropdownDataBodyLinksGroupItem = {
    link: Maybe<PrismicLinkType>
    sub_text: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderV2DropdownDataBodyLinksGroupPrimary = {
    label: Maybe<Scalars['String']['output']>
}

export type PrismicHeaderV2DropdownDataBodySlicesType = PrismicHeaderV2DropdownDataBodyLinksGroup

export type PrismicHeaderV2DropdownDataType = {
    body: Array<PrismicHeaderV2DropdownDataBodySlicesType>
}

export type PrismicHeaderV2DropdownEdge = {
    next: Maybe<PrismicHeaderV2Dropdown>
    node: PrismicHeaderV2Dropdown
    previous: Maybe<PrismicHeaderV2Dropdown>
}

export type PrismicHeaderV2DropdownFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderV2DropdownFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderV2DropdownGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderV2DropdownEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderV2DropdownGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderV2Dropdown>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderV2DropdownGroupConnectionDistinctArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownGroupConnectionGroupArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderV2DropdownGroupConnectionMaxArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownGroupConnectionMinArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownGroupConnectionSumArgs = {
    field: PrismicHeaderV2DropdownFieldSelector
}

export type PrismicHeaderV2DropdownSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeaderV2Edge = {
    next: Maybe<PrismicHeaderV2>
    node: PrismicHeaderV2
    previous: Maybe<PrismicHeaderV2>
}

export type PrismicHeaderV2FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeaderV2DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeaderV2FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeaderV2GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeaderV2Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeaderV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeaderV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeaderV2GroupConnectionDistinctArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2GroupConnectionGroupArgs = {
    field: PrismicHeaderV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeaderV2GroupConnectionMaxArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2GroupConnectionMinArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2GroupConnectionSumArgs = {
    field: PrismicHeaderV2FieldSelector
}

export type PrismicHeaderV2SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeaderV2DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTab = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHeroTabDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeroTabLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHeroTabConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabEdge>
    group: Array<PrismicHeroTabGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTab>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabConnectionDistinctArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabConnectionGroupArgs = {
    field: PrismicHeroTabFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabConnectionMaxArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabConnectionMinArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabConnectionSumArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHeroTabDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicHeroTabDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTabDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicHeroTabDataFormProductionIntegrationType>
    node: PrismicHeroTabDataFormProductionIntegrationType
    previous: Maybe<PrismicHeroTabDataFormProductionIntegrationType>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeroTabDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTabDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHeroTabDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicHeroTabDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTabDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput = {
    id: InputMaybe<IntQueryOperatorInput>
    required: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput = {
    id: InputMaybe<SortOrderEnum>
    required: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicHeroTabDataFormStagingIntegrationType>
    node: PrismicHeroTabDataFormStagingIntegrationType
    previous: Maybe<PrismicHeroTabDataFormStagingIntegrationType>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeroTabDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTabDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHeroTabDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHeroTabDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHeroTabDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHeroTabDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataLeadImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataLeadImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabDataLeadImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHeroTabDataLeadImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHeroTabDataLeadImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHeroTabDataLeadImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataLeadImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataLeadImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabDataType = {
    button_label: Maybe<Scalars['String']['output']>
    button_link: Maybe<PrismicLinkType>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicHeroTabDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicHeroTabDataFormStagingIntegrationType>
    image: Maybe<PrismicHeroTabDataImageImageType>
    lead_image: Maybe<PrismicHeroTabDataLeadImageImageType>
    lead_text: Maybe<PrismicStructuredTextType>
    lottie: Maybe<PrismicLinkType>
    secondary_cta_label: Maybe<Scalars['String']['output']>
    secondary_cta_link: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHeroTabDataTypeFieldSelector = {
    button_label: InputMaybe<FieldSelectorEnum>
    button_link: InputMaybe<PrismicLinkTypeFieldSelector>
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeFieldSelector>
    image: InputMaybe<PrismicHeroTabDataImageImageTypeFieldSelector>
    lead_image: InputMaybe<PrismicHeroTabDataLeadImageImageTypeFieldSelector>
    lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    lottie: InputMaybe<PrismicLinkTypeFieldSelector>
    secondary_cta_label: InputMaybe<FieldSelectorEnum>
    secondary_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabDataTypeFilterInput = {
    button_label: InputMaybe<StringQueryOperatorInput>
    button_link: InputMaybe<PrismicLinkTypeFilterInput>
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeFilterInput>
    image: InputMaybe<PrismicHeroTabDataImageImageTypeFilterInput>
    lead_image: InputMaybe<PrismicHeroTabDataLeadImageImageTypeFilterInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    lottie: InputMaybe<PrismicLinkTypeFilterInput>
    secondary_cta_label: InputMaybe<StringQueryOperatorInput>
    secondary_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabDataTypeSortInput = {
    button_label: InputMaybe<SortOrderEnum>
    button_link: InputMaybe<PrismicLinkTypeSortInput>
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeSortInput>
    image: InputMaybe<PrismicHeroTabDataImageImageTypeSortInput>
    lead_image: InputMaybe<PrismicHeroTabDataLeadImageImageTypeSortInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    lottie: InputMaybe<PrismicLinkTypeSortInput>
    secondary_cta_label: InputMaybe<SortOrderEnum>
    secondary_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicHeroTabEdge = {
    next: Maybe<PrismicHeroTab>
    node: PrismicHeroTab
    previous: Maybe<PrismicHeroTab>
}

export type PrismicHeroTabFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHeroTabDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHeroTabFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeroTabDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHeroTabGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHeroTabEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHeroTabGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHeroTab>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHeroTabGroupConnectionDistinctArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabGroupConnectionGroupArgs = {
    field: PrismicHeroTabFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHeroTabGroupConnectionMaxArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabGroupConnectionMinArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabGroupConnectionSumArgs = {
    field: PrismicHeroTabFieldSelector
}

export type PrismicHeroTabSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHeroTabDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHomepageV4DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHomepageV4Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHomepageV4Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4Edge>
    group: Array<PrismicHomepageV4GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4ConnectionDistinctArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4ConnectionGroupArgs = {
    field: PrismicHomepageV4FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4ConnectionMaxArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4ConnectionMinArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4ConnectionSumArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4DataBodyAnimationBlock = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyAnimationBlockPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyAnimationBlockPrimary = {
    animation_frames: Maybe<Scalars['Float']['output']>
    description: Maybe<PrismicStructuredTextType>
    lottie_json_file: Maybe<PrismicLinkType>
    placeholder: Maybe<PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyAnimationBlockPrimaryPlaceholderImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyBentoBox = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyBentoBoxItem>
    primary: PrismicHomepageV4DataBodyBentoBoxPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyBentoBoxItem = {
    card_image: Maybe<PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageType>
    card_subtitle: Maybe<Scalars['String']['output']>
    card_title: Maybe<Scalars['String']['output']>
    image_alignment: Maybe<Scalars['String']['output']>
    place_on_new_row: Maybe<Scalars['Boolean']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_poster: Maybe<PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyBentoBoxItemsVideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyBentoBoxPrimary = {
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyCardGridV2 = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyCardGridV2Item>
    primary: PrismicHomepageV4DataBodyCardGridV2Primary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyCardGridV2Item = {
    card_cta_link: Maybe<PrismicLinkType>
    card_cta_text: Maybe<Scalars['String']['output']>
    card_description: Maybe<Scalars['String']['output']>
    card_image: Maybe<PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageType>
    card_title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyCardGridV2ItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyCardGridV2Primary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCta = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyCustomerLogosPlusCtaItem>
    primary: PrismicHomepageV4DataBodyCustomerLogosPlusCtaPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItem = {
    logo: Maybe<PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageType>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyCustomerLogosPlusCtaPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    marquee_mode: Maybe<Scalars['Boolean']['output']>
    marquee_scroll_speed: Maybe<Scalars['String']['output']>
    marquee_width: Maybe<Scalars['String']['output']>
    stat_1_body: Maybe<Scalars['String']['output']>
    stat_1_highlight: Maybe<Scalars['String']['output']>
    stat_2_body: Maybe<Scalars['String']['output']>
    stat_2_highlight: Maybe<Scalars['String']['output']>
    stat_3_body: Maybe<Scalars['String']['output']>
    stat_3_highlight: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlock = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyFeatureBlockPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimary = {
    background: Maybe<Scalars['String']['output']>
    cta_hash_link: Maybe<Scalars['String']['output']>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<PrismicStructuredTextType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    is_circular_image: Maybe<Scalars['Boolean']['output']>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyFeatureBlockPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarquee = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItem>
    primary: PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItem = {
    link: Maybe<PrismicLinkType>
    logo: Maybe<PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageType>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueeItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimary = {
    body1: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    outline: Maybe<PrismicStructuredTextType>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyFeatureBlockWithMarqueePrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyFeaturePanel = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyFeaturePanelPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    content: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageType>
    is_media_on_the_right: Maybe<Scalars['Boolean']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    subtitle_color: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video: Maybe<PrismicLinkType>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyFeaturePanelPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyGetStarted = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyGetStartedItem>
    primary: PrismicHomepageV4DataBodyGetStartedPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyGetStartedItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    button_label: Maybe<Scalars['String']['output']>
    error_message: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
    form_subtitle: Maybe<Scalars['String']['output']>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryImageImageType>
    input_placeholder: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    redirection_page: Maybe<PrismicLinkType>
    section_color: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
    group: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
    node: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
    node: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyGetStartedPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCta = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyImagesMarqueeWithCtaItem>
    primary: PrismicHomepageV4DataBodyImagesMarqueeWithCtaPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItem = {
    image: Maybe<PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageType>
    link: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyImagesMarqueeWithCtaPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyLandingHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyLandingHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyLandingHeroPrimary = {
    background: Maybe<Scalars['String']['output']>
    cta_destination: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    headline_background_color: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    lead_text: Maybe<PrismicStructuredTextType>
    predefined_proof_point_badges: Maybe<PrismicLinkType>
    primary_cta_link: Maybe<PrismicLinkType>
    primary_cta_text: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyLandingHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyRatingsPlusHeadline = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyRatingsPlusHeadlineItem>
    primary: PrismicHomepageV4DataBodyRatingsPlusHeadlinePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyRatingsPlusHeadlineItem = {
    rating: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyRatingsPlusHeadlinePrimary = {
    cta_link: Maybe<PrismicLinkType>
    predefined_ratings: Maybe<PrismicLinkType>
    ratings_cta_text: Maybe<Scalars['String']['output']>
    ratings_lead_text: Maybe<Scalars['String']['output']>
    ratings_title: Maybe<PrismicStructuredTextType>
    section_html_id: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyResourceSlider = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyResourceSliderItem>
    primary: PrismicHomepageV4DataBodyResourceSliderPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyResourceSliderItem = {
    card_cta: Maybe<Scalars['String']['output']>
    card_description: Maybe<Scalars['String']['output']>
    card_image: Maybe<PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageType>
    card_title: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
    to: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyResourceSliderItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyResourceSliderPrimary = {
    description: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    top_link: Maybe<PrismicLinkType>
    top_link_text: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodySignUpHeroItem>
    primary: PrismicHomepageV4DataBodySignUpHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodySignUpHeroItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
    lead_text: Maybe<PrismicStructuredTextType>
    pre_title: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    thumbnail_video_mp4: Maybe<PrismicLinkType>
    thumbnail_video_webm: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    video_poster_image: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge>
    group: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
    node: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
    node: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodySignUpHeroPrimaryVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodySlicesType =
    | PrismicHomepageV4DataBodyAnimationBlock
    | PrismicHomepageV4DataBodyBentoBox
    | PrismicHomepageV4DataBodyCardGridV2
    | PrismicHomepageV4DataBodyCustomerLogosPlusCta
    | PrismicHomepageV4DataBodyFeatureBlock
    | PrismicHomepageV4DataBodyFeatureBlockWithMarquee
    | PrismicHomepageV4DataBodyFeaturePanel
    | PrismicHomepageV4DataBodyGetStarted
    | PrismicHomepageV4DataBodyImagesMarqueeWithCta
    | PrismicHomepageV4DataBodyLandingHero
    | PrismicHomepageV4DataBodyRatingsPlusHeadline
    | PrismicHomepageV4DataBodyResourceSlider
    | PrismicHomepageV4DataBodySignUpHero
    | PrismicHomepageV4DataBodySocialProof
    | PrismicHomepageV4DataBodyStickyCards
    | PrismicHomepageV4DataBodyStickyNavSections
    | PrismicHomepageV4DataBodyTabbedCarousel
    | PrismicHomepageV4DataBodyTabbedHero
    | PrismicHomepageV4DataBodyTest
    | PrismicHomepageV4DataBodyUseCase
    | PrismicHomepageV4DataBodyVideoHero
    | PrismicHomepageV4DataBodyVideoPopoverWithText

export type PrismicHomepageV4DataBodySocialProof = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodySocialProofItem>
    primary: PrismicHomepageV4DataBodySocialProofPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodySocialProofItem = {
    full_name: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodySocialProofItemsImageImageType>
    person_byline: Maybe<Scalars['String']['output']>
    predefined_testimonial: Maybe<PrismicLinkType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySocialProofItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodySocialProofItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodySocialProofItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodySocialProofItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodySocialProofItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodySocialProofPrimary = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyCards = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyStickyCardsItem>
    primary: PrismicHomepageV4DataBodyStickyCardsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyStickyCardsItem = {
    background_color: Maybe<Scalars['String']['output']>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHomepageV4DataBodyStickyCardsItemsImageImageType>
    video_mp4: Maybe<PrismicLinkType>
    video_poster_image: Maybe<PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageType>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyCardsItemsVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyCardsPrimary = {
    headline: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSections = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyStickyNavSectionsItem>
    primary: PrismicHomepageV4DataBodyStickyNavSectionsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItem = {
    card_1_body: Maybe<Scalars['String']['output']>
    card_1_image: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageType>
    card_1_title: Maybe<Scalars['String']['output']>
    card_1_video_mp4: Maybe<PrismicLinkType>
    card_1_video_poster: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageType>
    card_1_video_webm: Maybe<PrismicLinkType>
    card_2_body: Maybe<Scalars['String']['output']>
    card_2_image: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageType>
    card_2_title: Maybe<Scalars['String']['output']>
    card_2_video_mp4: Maybe<PrismicLinkType>
    card_2_video_poster: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageType>
    card_2_video_webm: Maybe<PrismicLinkType>
    card_3_body: Maybe<Scalars['String']['output']>
    card_3_image: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageType>
    card_3_title: Maybe<Scalars['String']['output']>
    card_3_video_mp4: Maybe<PrismicLinkType>
    card_3_video_poster: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageType>
    card_3_video_webm: Maybe<PrismicLinkType>
    image: Maybe<PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageType>
    subtitle: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyStickyNavSectionsPrimary = {
    cta_text: Maybe<Scalars['String']['output']>
    navigation_text: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyTabbedCarousel = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyTabbedCarouselItem>
    primary: PrismicHomepageV4DataBodyTabbedCarouselPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyTabbedCarouselItem = {
    carousel: Maybe<PrismicLinkType>
    tab_title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyTabbedCarouselPrimary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyTabbedHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyTabbedHeroItem>
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyTabbedHeroItem = {
    is_default: Maybe<Scalars['Boolean']['output']>
    tab: Maybe<PrismicLinkType>
    tab_title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyTest = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyTestPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyTestPrimary = {
    test: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyUseCase = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyUseCaseItem>
    primary: PrismicHomepageV4DataBodyUseCasePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyUseCaseItem = {
    icon: Maybe<PrismicHomepageV4DataBodyUseCaseItemsIconImageType>
    label: Maybe<Scalars['String']['output']>
    value: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyUseCaseItemsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyUseCaseItemsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyUseCaseItemsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyUseCaseItemsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyUseCaseItemsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyUseCasePrimary = {
    cta: Maybe<Scalars['String']['output']>
    secondary_cta_label: Maybe<Scalars['String']['output']>
    secondary_cta_link: Maybe<PrismicLinkType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyVideoHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicHomepageV4DataBodyVideoHeroItem>
    primary: PrismicHomepageV4DataBodyVideoHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyVideoHeroItem = {
    social_proof_icon: Maybe<PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageType>
    social_proof_text: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHomepageV4DataBodyVideoHeroItemsSocialProofIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    lead_text: Maybe<PrismicStructuredTextType>
    signup_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_poster_image: Maybe<PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageType>
    video_poster_image_mobile: Maybe<PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicHomepageV4DataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHomepageV4DataBodyVideoPopoverWithText = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicHomepageV4DataBodyVideoPopoverWithTextPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicHomepageV4DataBodyVideoPopoverWithTextPrimary = {
    body_text: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    pre_title: Maybe<Scalars['String']['output']>
    text_orientation: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicHomepageV4DataType = {
    body: Array<PrismicHomepageV4DataBodySlicesType>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hide_emails: Maybe<Scalars['Boolean']['output']>
    hide_left_nav: Maybe<Scalars['Boolean']['output']>
    hide_links: Maybe<Scalars['Boolean']['output']>
    hide_right_nav: Maybe<Scalars['Boolean']['output']>
    notification_banner: Maybe<PrismicLinkType>
    track_visible_sections: Maybe<Scalars['Boolean']['output']>
}

export type PrismicHomepageV4DataTypeFieldSelector = {
    exclude_production: InputMaybe<FieldSelectorEnum>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hide_emails: InputMaybe<FieldSelectorEnum>
    hide_left_nav: InputMaybe<FieldSelectorEnum>
    hide_links: InputMaybe<FieldSelectorEnum>
    hide_right_nav: InputMaybe<FieldSelectorEnum>
    notification_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    track_visible_sections: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4DataTypeFilterInput = {
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hide_emails: InputMaybe<BooleanQueryOperatorInput>
    hide_left_nav: InputMaybe<BooleanQueryOperatorInput>
    hide_links: InputMaybe<BooleanQueryOperatorInput>
    hide_right_nav: InputMaybe<BooleanQueryOperatorInput>
    notification_banner: InputMaybe<PrismicLinkTypeFilterInput>
    track_visible_sections: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicHomepageV4DataTypeSortInput = {
    exclude_production: InputMaybe<SortOrderEnum>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hide_emails: InputMaybe<SortOrderEnum>
    hide_left_nav: InputMaybe<SortOrderEnum>
    hide_links: InputMaybe<SortOrderEnum>
    hide_right_nav: InputMaybe<SortOrderEnum>
    notification_banner: InputMaybe<PrismicLinkTypeSortInput>
    track_visible_sections: InputMaybe<SortOrderEnum>
}

export type PrismicHomepageV4Edge = {
    next: Maybe<PrismicHomepageV4>
    node: PrismicHomepageV4
    previous: Maybe<PrismicHomepageV4>
}

export type PrismicHomepageV4FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHomepageV4DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHomepageV4FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHomepageV4DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHomepageV4GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHomepageV4Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHomepageV4GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHomepageV4>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHomepageV4GroupConnectionDistinctArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4GroupConnectionGroupArgs = {
    field: PrismicHomepageV4FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHomepageV4GroupConnectionMaxArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4GroupConnectionMinArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4GroupConnectionSumArgs = {
    field: PrismicHomepageV4FieldSelector
}

export type PrismicHomepageV4SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHomepageV4DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHowItWorksPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHowItWorksPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHowItWorksPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHowItWorksPageEdge>
    group: Array<PrismicHowItWorksPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHowItWorksPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHowItWorksPageConnectionDistinctArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageConnectionGroupArgs = {
    field: PrismicHowItWorksPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageConnectionMaxArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageConnectionMinArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageConnectionSumArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageDataFeatures = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicHowItWorksPageDataFeaturesImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataFeaturesFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicHowItWorksPageDataFeaturesImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataFeaturesFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicHowItWorksPageDataFeaturesImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicHowItWorksPageDataFeaturesFilterInput>
}

export type PrismicHowItWorksPageDataFeaturesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataFeaturesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataFeaturesSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicHowItWorksPageDataFeaturesImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicHowItWorksPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicHowItWorksPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicHowItWorksPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicHowItWorksPageDataHeroFilterInput>
}

export type PrismicHowItWorksPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicHowItWorksPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataHowItWorks = {
    image: Maybe<PrismicHowItWorksPageDataHowItWorksImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataHowItWorksFieldSelector = {
    image: InputMaybe<PrismicHowItWorksPageDataHowItWorksImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataHowItWorksFilterInput = {
    image: InputMaybe<PrismicHowItWorksPageDataHowItWorksImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataHowItWorksFilterListInput = {
    elemMatch: InputMaybe<PrismicHowItWorksPageDataHowItWorksFilterInput>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataHowItWorksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataHowItWorksSortInput = {
    image: InputMaybe<PrismicHowItWorksPageDataHowItWorksImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicHowItWorksPageDataQuestionsAnswersFilterInput>
}

export type PrismicHowItWorksPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageDataType = {
    features: Maybe<Array<Maybe<PrismicHowItWorksPageDataFeatures>>>
    features_title: Maybe<Scalars['String']['output']>
    hero: Maybe<Array<Maybe<PrismicHowItWorksPageDataHero>>>
    how_it_works: Maybe<Array<Maybe<PrismicHowItWorksPageDataHowItWorks>>>
    how_it_works_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicHowItWorksPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicHowItWorksPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    testimonial: Maybe<PrismicLinkType>
    what_is_pleo: Maybe<Array<Maybe<PrismicHowItWorksPageDataWhatIsPleo>>>
}

export type PrismicHowItWorksPageDataTypeFieldSelector = {
    features: InputMaybe<PrismicHowItWorksPageDataFeaturesFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicHowItWorksPageDataHeroFieldSelector>
    how_it_works: InputMaybe<PrismicHowItWorksPageDataHowItWorksFieldSelector>
    how_it_works_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicHowItWorksPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicHowItWorksPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
    what_is_pleo: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoFieldSelector>
}

export type PrismicHowItWorksPageDataTypeFilterInput = {
    features: InputMaybe<PrismicHowItWorksPageDataFeaturesFilterListInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    hero: InputMaybe<PrismicHowItWorksPageDataHeroFilterListInput>
    how_it_works: InputMaybe<PrismicHowItWorksPageDataHowItWorksFilterListInput>
    how_it_works_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicHowItWorksPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicHowItWorksPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
    what_is_pleo: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoFilterListInput>
}

export type PrismicHowItWorksPageDataTypeSortInput = {
    features: InputMaybe<PrismicHowItWorksPageDataFeaturesSortInput>
    features_title: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicHowItWorksPageDataHeroSortInput>
    how_it_works: InputMaybe<PrismicHowItWorksPageDataHowItWorksSortInput>
    how_it_works_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicHowItWorksPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicHowItWorksPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
    what_is_pleo: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoSortInput>
}

export type PrismicHowItWorksPageDataWhatIsPleo = {
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageType>
}

export type PrismicHowItWorksPageDataWhatIsPleoFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
    video_thumbnail: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFieldSelector>
}

export type PrismicHowItWorksPageDataWhatIsPleoFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
    video_thumbnail: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFilterInput>
}

export type PrismicHowItWorksPageDataWhatIsPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoFilterInput>
}

export type PrismicHowItWorksPageDataWhatIsPleoSortInput = {
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
    video_thumbnail: InputMaybe<PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeSortInput>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageDataWhatIsPleoVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHowItWorksPageEdge = {
    next: Maybe<PrismicHowItWorksPage>
    node: PrismicHowItWorksPage
    previous: Maybe<PrismicHowItWorksPage>
}

export type PrismicHowItWorksPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHowItWorksPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHowItWorksPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHowItWorksPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHowItWorksPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHowItWorksPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHowItWorksPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHowItWorksPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHowItWorksPageGroupConnectionDistinctArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageGroupConnectionGroupArgs = {
    field: PrismicHowItWorksPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHowItWorksPageGroupConnectionMaxArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageGroupConnectionMinArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageGroupConnectionSumArgs = {
    field: PrismicHowItWorksPageFieldSelector
}

export type PrismicHowItWorksPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHowItWorksPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotGlobalForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHubspotGlobalFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotGlobalFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHubspotGlobalFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHubspotGlobalFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormEdge>
    group: Array<PrismicHubspotGlobalFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormConnectionMinArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormConnectionSumArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
    node: PrismicHubspotGlobalFormDataFormProductionIntegrationType
    previous: Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
    node: PrismicHubspotGlobalFormDataFormStagingIntegrationType
    previous: Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicHubspotGlobalFormDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsProduction = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsProductionFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsProductionFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsProductionFilterListInput = {
    elemMatch: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsProductionFilterInput>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsProductionSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsStaging = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsStagingFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsStagingFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsStagingFilterListInput = {
    elemMatch: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsStagingFilterInput>
}

export type PrismicHubspotGlobalFormDataImperativeConsentsStagingSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicHubspotGlobalFormDataType = {
    body: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
    heading: Maybe<Scalars['String']['output']>
    imperative_consents_production: Maybe<
        Array<Maybe<PrismicHubspotGlobalFormDataImperativeConsentsProduction>>
    >
    imperative_consents_staging: Maybe<
        Array<Maybe<PrismicHubspotGlobalFormDataImperativeConsentsStaging>>
    >
}

export type PrismicHubspotGlobalFormDataTypeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFieldSelector>
    heading: InputMaybe<FieldSelectorEnum>
    imperative_consents_production: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsProductionFieldSelector>
    imperative_consents_staging: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsStagingFieldSelector>
}

export type PrismicHubspotGlobalFormDataTypeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFilterInput>
    heading: InputMaybe<StringQueryOperatorInput>
    imperative_consents_production: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsProductionFilterListInput>
    imperative_consents_staging: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsStagingFilterListInput>
}

export type PrismicHubspotGlobalFormDataTypeSortInput = {
    body: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeSortInput>
    heading: InputMaybe<SortOrderEnum>
    imperative_consents_production: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsProductionSortInput>
    imperative_consents_staging: InputMaybe<PrismicHubspotGlobalFormDataImperativeConsentsStagingSortInput>
}

export type PrismicHubspotGlobalFormEdge = {
    next: Maybe<PrismicHubspotGlobalForm>
    node: PrismicHubspotGlobalForm
    previous: Maybe<PrismicHubspotGlobalForm>
}

export type PrismicHubspotGlobalFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHubspotGlobalFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotGlobalFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHubspotGlobalFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotGlobalFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotGlobalFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHubspotGlobalFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotGlobalForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotGlobalFormGroupConnectionDistinctArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormGroupConnectionGroupArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotGlobalFormGroupConnectionMaxArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormGroupConnectionMinArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormGroupConnectionSumArgs = {
    field: PrismicHubspotGlobalFormFieldSelector
}

export type PrismicHubspotGlobalFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHubspotGlobalFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotReferralForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicHubspotReferralFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotReferralFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHubspotReferralFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicHubspotReferralFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotReferralFormEdge>
    group: Array<PrismicHubspotReferralFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotReferralForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotReferralFormConnectionDistinctArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormConnectionGroupArgs = {
    field: PrismicHubspotReferralFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotReferralFormConnectionMaxArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormConnectionMinArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormConnectionSumArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormDataType = {
    referral_fields_title: Maybe<Scalars['String']['output']>
    user_fields_title: Maybe<Scalars['String']['output']>
}

export type PrismicHubspotReferralFormDataTypeFieldSelector = {
    referral_fields_title: InputMaybe<FieldSelectorEnum>
    user_fields_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotReferralFormDataTypeFilterInput = {
    referral_fields_title: InputMaybe<StringQueryOperatorInput>
    user_fields_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotReferralFormDataTypeSortInput = {
    referral_fields_title: InputMaybe<SortOrderEnum>
    user_fields_title: InputMaybe<SortOrderEnum>
}

export type PrismicHubspotReferralFormEdge = {
    next: Maybe<PrismicHubspotReferralForm>
    node: PrismicHubspotReferralForm
    previous: Maybe<PrismicHubspotReferralForm>
}

export type PrismicHubspotReferralFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicHubspotReferralFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicHubspotReferralFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHubspotReferralFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicHubspotReferralFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicHubspotReferralFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicHubspotReferralFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicHubspotReferralForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicHubspotReferralFormGroupConnectionDistinctArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormGroupConnectionGroupArgs = {
    field: PrismicHubspotReferralFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicHubspotReferralFormGroupConnectionMaxArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormGroupConnectionMinArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormGroupConnectionSumArgs = {
    field: PrismicHubspotReferralFormFieldSelector
}

export type PrismicHubspotReferralFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicHubspotReferralFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicImageDimensionsType = {
    height: Scalars['Int']['output']
    width: Scalars['Int']['output']
}

export type PrismicImageDimensionsTypeFieldSelector = {
    height: InputMaybe<FieldSelectorEnum>
    width: InputMaybe<FieldSelectorEnum>
}

export type PrismicImageDimensionsTypeFilterInput = {
    height: InputMaybe<IntQueryOperatorInput>
    width: InputMaybe<IntQueryOperatorInput>
}

export type PrismicImageDimensionsTypeSortInput = {
    height: InputMaybe<SortOrderEnum>
    width: InputMaybe<SortOrderEnum>
}

export type PrismicImageThumbnailType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicImageThumbnailTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicImageThumbnailTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicImageThumbnailTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicImageThumbnailTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegration = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicIntegrationDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationEdge>
    group: Array<PrismicIntegrationGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegration>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationConnectionDistinctArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationConnectionGroupArgs = {
    field: PrismicIntegrationFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationConnectionMaxArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationConnectionMinArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationConnectionSumArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationDataLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationDataLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationDataLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationDataLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationDataLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationDataLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationDataLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationDataLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationDataType = {
    cta_link: Maybe<PrismicLinkType>
    logo: Maybe<PrismicIntegrationDataLogoImageType>
    name: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationDataTypeFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    logo: InputMaybe<PrismicIntegrationDataLogoImageTypeFieldSelector>
    name: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationDataTypeFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    logo: InputMaybe<PrismicIntegrationDataLogoImageTypeFilterInput>
    name: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationDataTypeSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    logo: InputMaybe<PrismicIntegrationDataLogoImageTypeSortInput>
    name: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationEdge = {
    next: Maybe<PrismicIntegration>
    node: PrismicIntegration
    previous: Maybe<PrismicIntegration>
}

export type PrismicIntegrationFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicIntegrationDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicIntegrationGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegration>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationGroupConnectionDistinctArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationGroupConnectionGroupArgs = {
    field: PrismicIntegrationFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationGroupConnectionMaxArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationGroupConnectionMinArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationGroupConnectionSumArgs = {
    field: PrismicIntegrationFieldSelector
}

export type PrismicIntegrationPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicIntegrationPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationPageEdge>
    group: Array<PrismicIntegrationPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationPageConnectionDistinctArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageConnectionGroupArgs = {
    field: PrismicIntegrationPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageConnectionMaxArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageConnectionMinArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageConnectionSumArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageDataCustomerQuote = {
    attribution_name: Maybe<Scalars['String']['output']>
    attribution_title: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicIntegrationPageDataCustomerQuoteImageImageType>
    mirrored: Maybe<Scalars['Boolean']['output']>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataCustomerQuoteFieldSelector = {
    attribution_name: InputMaybe<FieldSelectorEnum>
    attribution_title: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicIntegrationPageDataCustomerQuoteImageImageTypeFieldSelector>
    mirrored: InputMaybe<FieldSelectorEnum>
    quote: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataCustomerQuoteFilterInput = {
    attribution_name: InputMaybe<StringQueryOperatorInput>
    attribution_title: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicIntegrationPageDataCustomerQuoteImageImageTypeFilterInput>
    mirrored: InputMaybe<BooleanQueryOperatorInput>
    quote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataCustomerQuoteFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataCustomerQuoteFilterInput>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataCustomerQuoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataCustomerQuoteSortInput = {
    attribution_name: InputMaybe<SortOrderEnum>
    attribution_title: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicIntegrationPageDataCustomerQuoteImageImageTypeSortInput>
    mirrored: InputMaybe<SortOrderEnum>
    quote: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicIntegrationPageDataFeatureBlocksImageImageType>
    mirrored: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicIntegrationPageDataFeatureBlocksImageImageTypeFieldSelector>
    mirrored: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicIntegrationPageDataFeatureBlocksImageImageTypeFilterInput>
    mirrored: InputMaybe<BooleanQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataFeatureBlocksFilterInput>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicIntegrationPageDataFeatureBlocksImageImageTypeSortInput>
    mirrored: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    body_2: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicIntegrationPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    body_2: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicIntegrationPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    body_2: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicIntegrationPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataHeroFilterInput>
}

export type PrismicIntegrationPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    body_2: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicIntegrationPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks1 = {
    background_color: Maybe<Scalars['String']['output']>
    show_section: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks1FieldSelector = {
    background_color: InputMaybe<FieldSelectorEnum>
    show_section: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks1FilterInput = {
    background_color: InputMaybe<StringQueryOperatorInput>
    show_section: InputMaybe<BooleanQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks1FilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataHowItWorks1FilterInput>
}

export type PrismicIntegrationPageDataHowItWorks1Items = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicIntegrationPageDataHowItWorks1ItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsFilterInput>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks1ItemsSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks1SortInput = {
    background_color: InputMaybe<SortOrderEnum>
    show_section: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks2 = {
    background_color: Maybe<Scalars['String']['output']>
    show_section: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks2FieldSelector = {
    background_color: InputMaybe<FieldSelectorEnum>
    show_section: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks2FilterInput = {
    background_color: InputMaybe<StringQueryOperatorInput>
    show_section: InputMaybe<BooleanQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks2FilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataHowItWorks2FilterInput>
}

export type PrismicIntegrationPageDataHowItWorks2Items = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicIntegrationPageDataHowItWorks2ItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsFilterInput>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks2ItemsSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataHowItWorks2SortInput = {
    background_color: InputMaybe<SortOrderEnum>
    show_section: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataLearnMoreCards = {
    learn_more_card: Maybe<PrismicLinkType>
}

export type PrismicIntegrationPageDataLearnMoreCardsFieldSelector = {
    learn_more_card: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicIntegrationPageDataLearnMoreCardsFilterInput = {
    learn_more_card: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicIntegrationPageDataLearnMoreCardsFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataLearnMoreCardsFilterInput>
}

export type PrismicIntegrationPageDataLearnMoreCardsSortInput = {
    learn_more_card: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicIntegrationPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationPageDataQuestionsAnswersFilterInput>
}

export type PrismicIntegrationPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationPageDataType = {
    customer_quote: Maybe<Array<Maybe<PrismicIntegrationPageDataCustomerQuote>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks: Maybe<Array<Maybe<PrismicIntegrationPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicIntegrationPageDataHero>>>
    how_it_works_1: Maybe<Array<Maybe<PrismicIntegrationPageDataHowItWorks1>>>
    how_it_works_1_items: Maybe<Array<Maybe<PrismicIntegrationPageDataHowItWorks1Items>>>
    how_it_works_2: Maybe<Array<Maybe<PrismicIntegrationPageDataHowItWorks2>>>
    how_it_works_2_items: Maybe<Array<Maybe<PrismicIntegrationPageDataHowItWorks2Items>>>
    learn_more_cards: Maybe<Array<Maybe<PrismicIntegrationPageDataLearnMoreCards>>>
    learn_more_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicIntegrationPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicIntegrationPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    show_questions_section: Maybe<Scalars['Boolean']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
}

export type PrismicIntegrationPageDataTypeFieldSelector = {
    customer_quote: InputMaybe<PrismicIntegrationPageDataCustomerQuoteFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks: InputMaybe<PrismicIntegrationPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicIntegrationPageDataHeroFieldSelector>
    how_it_works_1: InputMaybe<PrismicIntegrationPageDataHowItWorks1FieldSelector>
    how_it_works_1_items: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsFieldSelector>
    how_it_works_2: InputMaybe<PrismicIntegrationPageDataHowItWorks2FieldSelector>
    how_it_works_2_items: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsFieldSelector>
    learn_more_cards: InputMaybe<PrismicIntegrationPageDataLearnMoreCardsFieldSelector>
    learn_more_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicIntegrationPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicIntegrationPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    show_questions_section: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicIntegrationPageDataTypeFilterInput = {
    customer_quote: InputMaybe<PrismicIntegrationPageDataCustomerQuoteFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks: InputMaybe<PrismicIntegrationPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicIntegrationPageDataHeroFilterListInput>
    how_it_works_1: InputMaybe<PrismicIntegrationPageDataHowItWorks1FilterListInput>
    how_it_works_1_items: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsFilterListInput>
    how_it_works_2: InputMaybe<PrismicIntegrationPageDataHowItWorks2FilterListInput>
    how_it_works_2_items: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsFilterListInput>
    learn_more_cards: InputMaybe<PrismicIntegrationPageDataLearnMoreCardsFilterListInput>
    learn_more_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicIntegrationPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicIntegrationPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    show_questions_section: InputMaybe<BooleanQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicIntegrationPageDataTypeSortInput = {
    customer_quote: InputMaybe<PrismicIntegrationPageDataCustomerQuoteSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks: InputMaybe<PrismicIntegrationPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicIntegrationPageDataHeroSortInput>
    how_it_works_1: InputMaybe<PrismicIntegrationPageDataHowItWorks1SortInput>
    how_it_works_1_items: InputMaybe<PrismicIntegrationPageDataHowItWorks1ItemsSortInput>
    how_it_works_2: InputMaybe<PrismicIntegrationPageDataHowItWorks2SortInput>
    how_it_works_2_items: InputMaybe<PrismicIntegrationPageDataHowItWorks2ItemsSortInput>
    learn_more_cards: InputMaybe<PrismicIntegrationPageDataLearnMoreCardsSortInput>
    learn_more_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicIntegrationPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicIntegrationPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    show_questions_section: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicIntegrationPageEdge = {
    next: Maybe<PrismicIntegrationPage>
    node: PrismicIntegrationPage
    previous: Maybe<PrismicIntegrationPage>
}

export type PrismicIntegrationPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicIntegrationPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicIntegrationPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationPageGroupConnectionDistinctArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageGroupConnectionGroupArgs = {
    field: PrismicIntegrationPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationPageGroupConnectionMaxArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageGroupConnectionMinArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageGroupConnectionSumArgs = {
    field: PrismicIntegrationPageFieldSelector
}

export type PrismicIntegrationPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicIntegrationPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicIntegrationDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsFeatureBlock = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicIntegrationsFeatureBlockDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsFeatureBlockFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationsFeatureBlockLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationsFeatureBlockConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationsFeatureBlockEdge>
    group: Array<PrismicIntegrationsFeatureBlockGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationsFeatureBlock>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationsFeatureBlockConnectionDistinctArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockConnectionGroupArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsFeatureBlockConnectionMaxArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockConnectionMinArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockConnectionSumArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockDataType = {
    feature_block: Maybe<PrismicLinkType>
}

export type PrismicIntegrationsFeatureBlockDataTypeFieldSelector = {
    feature_block: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicIntegrationsFeatureBlockDataTypeFilterInput = {
    feature_block: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicIntegrationsFeatureBlockDataTypeSortInput = {
    feature_block: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicIntegrationsFeatureBlockEdge = {
    next: Maybe<PrismicIntegrationsFeatureBlock>
    node: PrismicIntegrationsFeatureBlock
    previous: Maybe<PrismicIntegrationsFeatureBlock>
}

export type PrismicIntegrationsFeatureBlockFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicIntegrationsFeatureBlockDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsFeatureBlockFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationsFeatureBlockDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsFeatureBlockGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationsFeatureBlockEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicIntegrationsFeatureBlockGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationsFeatureBlock>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationsFeatureBlockGroupConnectionDistinctArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockGroupConnectionGroupArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsFeatureBlockGroupConnectionMaxArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockGroupConnectionMinArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockGroupConnectionSumArgs = {
    field: PrismicIntegrationsFeatureBlockFieldSelector
}

export type PrismicIntegrationsFeatureBlockSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicIntegrationsFeatureBlockDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicIntegrationsIndexPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationsIndexPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicIntegrationsIndexPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationsIndexPageEdge>
    group: Array<PrismicIntegrationsIndexPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationsIndexPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationsIndexPageConnectionDistinctArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageConnectionGroupArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsIndexPageConnectionMaxArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageConnectionMinArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageConnectionSumArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageDataCustomerQuote = {
    attribution_name: Maybe<Scalars['String']['output']>
    attribution_title: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicIntegrationsIndexPageDataCustomerQuoteImageImageType>
    mirrored: Maybe<Scalars['Boolean']['output']>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteFieldSelector = {
    attribution_name: InputMaybe<FieldSelectorEnum>
    attribution_title: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFieldSelector>
    mirrored: InputMaybe<FieldSelectorEnum>
    quote: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteFilterInput = {
    attribution_name: InputMaybe<StringQueryOperatorInput>
    attribution_title: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFilterInput>
    mirrored: InputMaybe<BooleanQueryOperatorInput>
    quote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteFilterInput>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPageDataCustomerQuoteSortInput = {
    attribution_name: InputMaybe<SortOrderEnum>
    attribution_title: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteImageImageTypeSortInput>
    mirrored: InputMaybe<SortOrderEnum>
    quote: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicIntegrationsIndexPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicIntegrationsIndexPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicIntegrationsIndexPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationsIndexPageDataHeroFilterInput>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicIntegrationsIndexPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPageDataIntegrations = {
    integration: Maybe<PrismicLinkType>
}

export type PrismicIntegrationsIndexPageDataIntegrationsFieldSelector = {
    integration: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicIntegrationsIndexPageDataIntegrationsFilterInput = {
    integration: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicIntegrationsIndexPageDataIntegrationsFilterListInput = {
    elemMatch: InputMaybe<PrismicIntegrationsIndexPageDataIntegrationsFilterInput>
}

export type PrismicIntegrationsIndexPageDataIntegrationsSortInput = {
    integration: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicIntegrationsIndexPageDataType = {
    customer_quote: Maybe<Array<Maybe<PrismicIntegrationsIndexPageDataCustomerQuote>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero: Maybe<Array<Maybe<PrismicIntegrationsIndexPageDataHero>>>
    integration_card_cta_text: Maybe<Scalars['String']['output']>
    integrations: Maybe<Array<Maybe<PrismicIntegrationsIndexPageDataIntegrations>>>
    integrations_subtitle: Maybe<Scalars['String']['output']>
    integrations_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicIntegrationsIndexPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    show_more_integrations_text: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
}

export type PrismicIntegrationsIndexPageDataTypeFieldSelector = {
    customer_quote: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicIntegrationsIndexPageDataHeroFieldSelector>
    integration_card_cta_text: InputMaybe<FieldSelectorEnum>
    integrations: InputMaybe<PrismicIntegrationsIndexPageDataIntegrationsFieldSelector>
    integrations_subtitle: InputMaybe<FieldSelectorEnum>
    integrations_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    show_more_integrations_text: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicIntegrationsIndexPageDataTypeFilterInput = {
    customer_quote: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero: InputMaybe<PrismicIntegrationsIndexPageDataHeroFilterListInput>
    integration_card_cta_text: InputMaybe<StringQueryOperatorInput>
    integrations: InputMaybe<PrismicIntegrationsIndexPageDataIntegrationsFilterListInput>
    integrations_subtitle: InputMaybe<StringQueryOperatorInput>
    integrations_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    show_more_integrations_text: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicIntegrationsIndexPageDataTypeSortInput = {
    customer_quote: InputMaybe<PrismicIntegrationsIndexPageDataCustomerQuoteSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicIntegrationsIndexPageDataHeroSortInput>
    integration_card_cta_text: InputMaybe<SortOrderEnum>
    integrations: InputMaybe<PrismicIntegrationsIndexPageDataIntegrationsSortInput>
    integrations_subtitle: InputMaybe<SortOrderEnum>
    integrations_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicIntegrationsIndexPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    show_more_integrations_text: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicIntegrationsIndexPageEdge = {
    next: Maybe<PrismicIntegrationsIndexPage>
    node: PrismicIntegrationsIndexPage
    previous: Maybe<PrismicIntegrationsIndexPage>
}

export type PrismicIntegrationsIndexPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicIntegrationsIndexPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicIntegrationsIndexPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationsIndexPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicIntegrationsIndexPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicIntegrationsIndexPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicIntegrationsIndexPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicIntegrationsIndexPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicIntegrationsIndexPageGroupConnectionDistinctArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageGroupConnectionGroupArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicIntegrationsIndexPageGroupConnectionMaxArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageGroupConnectionMinArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageGroupConnectionSumArgs = {
    field: PrismicIntegrationsIndexPageFieldSelector
}

export type PrismicIntegrationsIndexPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicIntegrationsIndexPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoice = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicInvoiceDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceEdge>
    group: Array<PrismicInvoiceGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoice>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceConnectionDistinctArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceConnectionGroupArgs = {
    field: PrismicInvoiceFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceConnectionMaxArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceConnectionMinArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceConnectionSumArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceDataType = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceDataTypeFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceDataTypeFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceDataTypeSortInput = {
    title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceEdge = {
    next: Maybe<PrismicInvoice>
    node: PrismicInvoice
    previous: Maybe<PrismicInvoice>
}

export type PrismicInvoiceFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicInvoiceDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGenerator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicInvoiceGeneratorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceGeneratorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceGeneratorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceGeneratorEdge>
    group: Array<PrismicInvoiceGeneratorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceGenerator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceGeneratorConnectionDistinctArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorConnectionGroupArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceGeneratorConnectionMaxArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorConnectionMinArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorConnectionSumArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModal = {
    form_production: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
    form_staging: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
    modal_image: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageType>
    modal_subtitle: Maybe<Scalars['String']['output']>
    modal_title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFieldSelector = {
    form_production: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFieldSelector>
    modal_subtitle: InputMaybe<FieldSelectorEnum>
    modal_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFilterInput = {
    form_production: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFilterInput>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFilterInput>
    modal_subtitle: InputMaybe<StringQueryOperatorInput>
    modal_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFilterInput>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeEdge>
        group: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
    node: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType
    previous: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeEdge>
    group: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
    node: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType
    previous: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFieldSelector
    }

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataGetYourInvoiceModalSortInput = {
    form_production: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeSortInput>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalModalImageImageTypeSortInput>
    modal_subtitle: InputMaybe<SortOrderEnum>
    modal_title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataThankYouModal = {
    download_pdf_button_text: Maybe<Scalars['String']['output']>
    modal_image: Maybe<PrismicInvoiceGeneratorDataThankYouModalModalImageImageType>
    modal_subtitle: Maybe<Scalars['String']['output']>
    modal_title: Maybe<Scalars['String']['output']>
    new_invoice_button_text: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataThankYouModalFieldSelector = {
    download_pdf_button_text: InputMaybe<FieldSelectorEnum>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFieldSelector>
    modal_subtitle: InputMaybe<FieldSelectorEnum>
    modal_title: InputMaybe<FieldSelectorEnum>
    new_invoice_button_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorDataThankYouModalFilterInput = {
    download_pdf_button_text: InputMaybe<StringQueryOperatorInput>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFilterInput>
    modal_subtitle: InputMaybe<StringQueryOperatorInput>
    modal_title: InputMaybe<StringQueryOperatorInput>
    new_invoice_button_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataThankYouModalFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalFilterInput>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataThankYouModalSortInput = {
    download_pdf_button_text: InputMaybe<SortOrderEnum>
    modal_image: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalModalImageImageTypeSortInput>
    modal_subtitle: InputMaybe<SortOrderEnum>
    modal_title: InputMaybe<SortOrderEnum>
    new_invoice_button_text: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorDataType = {
    add_item_label: Maybe<Scalars['String']['output']>
    due_date_label: Maybe<Scalars['String']['output']>
    get_invoice_label: Maybe<Scalars['String']['output']>
    get_your_invoice_modal: Maybe<Array<Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModal>>>
    invoice_details: Maybe<Scalars['String']['output']>
    invoice_items_form_title: Maybe<Scalars['String']['output']>
    invoice_number_label: Maybe<Scalars['String']['output']>
    invoice_title: Maybe<Scalars['String']['output']>
    issued_on_label: Maybe<Scalars['String']['output']>
    items_label: Maybe<Scalars['String']['output']>
    notes_label: Maybe<Scalars['String']['output']>
    preview_label: Maybe<Scalars['String']['output']>
    price_label: Maybe<Scalars['String']['output']>
    quantity_label: Maybe<Scalars['String']['output']>
    rate_label: Maybe<Scalars['String']['output']>
    recipient_company_form_title: Maybe<Scalars['String']['output']>
    subtotal_label: Maybe<Scalars['String']['output']>
    tax_label: Maybe<Scalars['String']['output']>
    tax_total_label: Maybe<Scalars['String']['output']>
    terms_label: Maybe<Scalars['String']['output']>
    thank_you_modal: Maybe<Array<Maybe<PrismicInvoiceGeneratorDataThankYouModal>>>
    title: Maybe<Scalars['String']['output']>
    total_label: Maybe<Scalars['String']['output']>
    your_company_form_title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceGeneratorDataTypeFieldSelector = {
    add_item_label: InputMaybe<FieldSelectorEnum>
    due_date_label: InputMaybe<FieldSelectorEnum>
    get_invoice_label: InputMaybe<FieldSelectorEnum>
    get_your_invoice_modal: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFieldSelector>
    invoice_details: InputMaybe<FieldSelectorEnum>
    invoice_items_form_title: InputMaybe<FieldSelectorEnum>
    invoice_number_label: InputMaybe<FieldSelectorEnum>
    invoice_title: InputMaybe<FieldSelectorEnum>
    issued_on_label: InputMaybe<FieldSelectorEnum>
    items_label: InputMaybe<FieldSelectorEnum>
    notes_label: InputMaybe<FieldSelectorEnum>
    preview_label: InputMaybe<FieldSelectorEnum>
    price_label: InputMaybe<FieldSelectorEnum>
    quantity_label: InputMaybe<FieldSelectorEnum>
    rate_label: InputMaybe<FieldSelectorEnum>
    recipient_company_form_title: InputMaybe<FieldSelectorEnum>
    subtotal_label: InputMaybe<FieldSelectorEnum>
    tax_label: InputMaybe<FieldSelectorEnum>
    tax_total_label: InputMaybe<FieldSelectorEnum>
    terms_label: InputMaybe<FieldSelectorEnum>
    thank_you_modal: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    total_label: InputMaybe<FieldSelectorEnum>
    your_company_form_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorDataTypeFilterInput = {
    add_item_label: InputMaybe<StringQueryOperatorInput>
    due_date_label: InputMaybe<StringQueryOperatorInput>
    get_invoice_label: InputMaybe<StringQueryOperatorInput>
    get_your_invoice_modal: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFilterListInput>
    invoice_details: InputMaybe<StringQueryOperatorInput>
    invoice_items_form_title: InputMaybe<StringQueryOperatorInput>
    invoice_number_label: InputMaybe<StringQueryOperatorInput>
    invoice_title: InputMaybe<StringQueryOperatorInput>
    issued_on_label: InputMaybe<StringQueryOperatorInput>
    items_label: InputMaybe<StringQueryOperatorInput>
    notes_label: InputMaybe<StringQueryOperatorInput>
    preview_label: InputMaybe<StringQueryOperatorInput>
    price_label: InputMaybe<StringQueryOperatorInput>
    quantity_label: InputMaybe<StringQueryOperatorInput>
    rate_label: InputMaybe<StringQueryOperatorInput>
    recipient_company_form_title: InputMaybe<StringQueryOperatorInput>
    subtotal_label: InputMaybe<StringQueryOperatorInput>
    tax_label: InputMaybe<StringQueryOperatorInput>
    tax_total_label: InputMaybe<StringQueryOperatorInput>
    terms_label: InputMaybe<StringQueryOperatorInput>
    thank_you_modal: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
    total_label: InputMaybe<StringQueryOperatorInput>
    your_company_form_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorDataTypeSortInput = {
    add_item_label: InputMaybe<SortOrderEnum>
    due_date_label: InputMaybe<SortOrderEnum>
    get_invoice_label: InputMaybe<SortOrderEnum>
    get_your_invoice_modal: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalSortInput>
    invoice_details: InputMaybe<SortOrderEnum>
    invoice_items_form_title: InputMaybe<SortOrderEnum>
    invoice_number_label: InputMaybe<SortOrderEnum>
    invoice_title: InputMaybe<SortOrderEnum>
    issued_on_label: InputMaybe<SortOrderEnum>
    items_label: InputMaybe<SortOrderEnum>
    notes_label: InputMaybe<SortOrderEnum>
    preview_label: InputMaybe<SortOrderEnum>
    price_label: InputMaybe<SortOrderEnum>
    quantity_label: InputMaybe<SortOrderEnum>
    rate_label: InputMaybe<SortOrderEnum>
    recipient_company_form_title: InputMaybe<SortOrderEnum>
    subtotal_label: InputMaybe<SortOrderEnum>
    tax_label: InputMaybe<SortOrderEnum>
    tax_total_label: InputMaybe<SortOrderEnum>
    terms_label: InputMaybe<SortOrderEnum>
    thank_you_modal: InputMaybe<PrismicInvoiceGeneratorDataThankYouModalSortInput>
    title: InputMaybe<SortOrderEnum>
    total_label: InputMaybe<SortOrderEnum>
    your_company_form_title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGeneratorEdge = {
    next: Maybe<PrismicInvoiceGenerator>
    node: PrismicInvoiceGenerator
    previous: Maybe<PrismicInvoiceGenerator>
}

export type PrismicInvoiceGeneratorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicInvoiceGeneratorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceGeneratorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceGeneratorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceGeneratorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceGeneratorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoiceGeneratorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceGenerator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceGeneratorGroupConnectionDistinctArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorGroupConnectionGroupArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceGeneratorGroupConnectionMaxArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorGroupConnectionMinArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorGroupConnectionSumArgs = {
    field: PrismicInvoiceGeneratorFieldSelector
}

export type PrismicInvoiceGeneratorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicInvoiceGeneratorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoiceGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoice>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceGroupConnectionDistinctArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceGroupConnectionGroupArgs = {
    field: PrismicInvoiceFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceGroupConnectionMaxArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceGroupConnectionMinArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceGroupConnectionSumArgs = {
    field: PrismicInvoiceFieldSelector
}

export type PrismicInvoiceSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicInvoiceDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicInvoiceTemplateFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceTemplateFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoiceTemplateFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormEdge>
    group: Array<PrismicInvoiceTemplateFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormConnectionDistinctArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
    node: PrismicInvoiceTemplateFormDataFormProductionIntegrationType
    previous: Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
    node: PrismicInvoiceTemplateFormDataFormStagingIntegrationType
    previous: Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsProduction = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsProductionFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsProductionFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsProductionFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsProductionFilterInput>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsProductionSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsStaging = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsStagingFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsStagingFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsStagingFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsStagingFilterInput>
}

export type PrismicInvoiceTemplateFormDataImperativeConsentsStagingSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicInvoiceTemplateFormDataType = {
    description: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
    imperative_consents_production: Maybe<
        Array<Maybe<PrismicInvoiceTemplateFormDataImperativeConsentsProduction>>
    >
    imperative_consents_staging: Maybe<
        Array<Maybe<PrismicInvoiceTemplateFormDataImperativeConsentsStaging>>
    >
    success_message: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoiceTemplateFormDataTypeFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents_production: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsProductionFieldSelector>
    imperative_consents_staging: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsStagingFieldSelector>
    success_message: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormDataTypeFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFilterInput>
    imperative_consents_production: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsProductionFilterListInput>
    imperative_consents_staging: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsStagingFilterListInput>
    success_message: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormDataTypeSortInput = {
    description: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeSortInput>
    imperative_consents_production: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsProductionSortInput>
    imperative_consents_staging: InputMaybe<PrismicInvoiceTemplateFormDataImperativeConsentsStagingSortInput>
    success_message: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoiceTemplateFormEdge = {
    next: Maybe<PrismicInvoiceTemplateForm>
    node: PrismicInvoiceTemplateForm
    previous: Maybe<PrismicInvoiceTemplateForm>
}

export type PrismicInvoiceTemplateFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicInvoiceTemplateFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoiceTemplateFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceTemplateFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoiceTemplateFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoiceTemplateFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoiceTemplateFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoiceTemplateForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoiceTemplateFormGroupConnectionDistinctArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormGroupConnectionGroupArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoiceTemplateFormGroupConnectionMaxArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormGroupConnectionMinArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormGroupConnectionSumArgs = {
    field: PrismicInvoiceTemplateFormFieldSelector
}

export type PrismicInvoiceTemplateFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicInvoiceTemplateFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovals = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicInvoicesApprovalsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoicesApprovalsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicInvoicesApprovalsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoicesApprovalsEdge>
    group: Array<PrismicInvoicesApprovalsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoicesApprovals>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoicesApprovalsConnectionDistinctArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsConnectionGroupArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsConnectionMaxArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsConnectionMinArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsConnectionSumArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsDataApprovalSuccess = {
    approval_success_text: Maybe<PrismicStructuredTextType>
    approval_success_title: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicInvoicesApprovalsDataApprovalSuccessImageImageType>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessFieldSelector = {
    approval_success_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    approval_success_title: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFieldSelector>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessFilterInput = {
    approval_success_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    approval_success_title: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFilterInput>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessFilterInput>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsDataApprovalSuccessSortInput = {
    approval_success_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    approval_success_title: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessImageImageTypeSortInput>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequest = {
    error_processing_request_text: Maybe<PrismicStructuredTextType>
    error_processing_request_title: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageType>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestFieldSelector = {
    error_processing_request_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    error_processing_request_title: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFieldSelector>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestFilterInput = {
    error_processing_request_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    error_processing_request_title: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFilterInput>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestFilterInput>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsDataErrorProcessingRequestSortInput = {
    error_processing_request_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    error_processing_request_title: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestImageImageTypeSortInput>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsDataRejectionSuccess = {
    image: Maybe<PrismicInvoicesApprovalsDataRejectionSuccessImageImageType>
    rejection_success_text: Maybe<PrismicStructuredTextType>
    rejection_success_title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessFieldSelector = {
    image: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFieldSelector>
    rejection_success_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    rejection_success_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessFilterInput = {
    image: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFilterInput>
    rejection_success_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    rejection_success_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessFilterListInput = {
    elemMatch: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessFilterInput>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsDataRejectionSuccessSortInput = {
    image: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessImageImageTypeSortInput>
    rejection_success_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    rejection_success_title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsDataType = {
    allow_indexing: Maybe<Scalars['Boolean']['output']>
    approval_success: Maybe<Array<Maybe<PrismicInvoicesApprovalsDataApprovalSuccess>>>
    error_processing_request: Maybe<
        Array<Maybe<PrismicInvoicesApprovalsDataErrorProcessingRequest>>
    >
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    header_cta: Maybe<Scalars['String']['output']>
    header_cta_link: Maybe<PrismicLinkType>
    header_link: Maybe<PrismicStructuredTextType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicInvoicesApprovalsDataOpenGraphImageImageType>
    page_cta_link: Maybe<PrismicLinkType>
    page_cta_text: Maybe<Scalars['String']['output']>
    rejection_success: Maybe<Array<Maybe<PrismicInvoicesApprovalsDataRejectionSuccess>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicInvoicesApprovalsDataTypeFieldSelector = {
    allow_indexing: InputMaybe<FieldSelectorEnum>
    approval_success: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessFieldSelector>
    error_processing_request: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    header_cta: InputMaybe<FieldSelectorEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    header_link: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFieldSelector>
    page_cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    page_cta_text: InputMaybe<FieldSelectorEnum>
    rejection_success: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsDataTypeFilterInput = {
    allow_indexing: InputMaybe<BooleanQueryOperatorInput>
    approval_success: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessFilterListInput>
    error_processing_request: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    header_cta: InputMaybe<StringQueryOperatorInput>
    header_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    header_link: InputMaybe<PrismicStructuredTextTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicInvoicesApprovalsDataOpenGraphImageImageTypeFilterInput>
    page_cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    page_cta_text: InputMaybe<StringQueryOperatorInput>
    rejection_success: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsDataTypeSortInput = {
    allow_indexing: InputMaybe<SortOrderEnum>
    approval_success: InputMaybe<PrismicInvoicesApprovalsDataApprovalSuccessSortInput>
    error_processing_request: InputMaybe<PrismicInvoicesApprovalsDataErrorProcessingRequestSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    header_cta: InputMaybe<SortOrderEnum>
    header_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    header_link: InputMaybe<PrismicStructuredTextTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicInvoicesApprovalsDataOpenGraphImageImageTypeSortInput>
    page_cta_link: InputMaybe<PrismicLinkTypeSortInput>
    page_cta_text: InputMaybe<SortOrderEnum>
    rejection_success: InputMaybe<PrismicInvoicesApprovalsDataRejectionSuccessSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicInvoicesApprovalsEdge = {
    next: Maybe<PrismicInvoicesApprovals>
    node: PrismicInvoicesApprovals
    previous: Maybe<PrismicInvoicesApprovals>
}

export type PrismicInvoicesApprovalsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicInvoicesApprovalsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicInvoicesApprovalsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoicesApprovalsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicInvoicesApprovalsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicInvoicesApprovalsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicInvoicesApprovalsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicInvoicesApprovals>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicInvoicesApprovalsGroupConnectionDistinctArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsGroupConnectionGroupArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicInvoicesApprovalsGroupConnectionMaxArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsGroupConnectionMinArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsGroupConnectionSumArgs = {
    field: PrismicInvoicesApprovalsFieldSelector
}

export type PrismicInvoicesApprovalsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicInvoicesApprovalsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobListing = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicJobListingDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicJobListingLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicJobListingConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicJobListingEdge>
    group: Array<PrismicJobListingGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicJobListing>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicJobListingConnectionDistinctArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingConnectionGroupArgs = {
    field: PrismicJobListingFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobListingConnectionMaxArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingConnectionMinArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingConnectionSumArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingDataHero = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicJobListingDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataHeroFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicJobListingDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataHeroFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicJobListingDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicJobListingDataHeroFilterInput>
}

export type PrismicJobListingDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobListingDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobListingDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobListingDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobListingDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingDataHeroSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicJobListingDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingDataListingTableHeadings = {
    all_departments_label: Maybe<Scalars['String']['output']>
    all_departments_placeholder: Maybe<Scalars['String']['output']>
    clear_filters: Maybe<Scalars['String']['output']>
    location: Maybe<Scalars['String']['output']>
    no_jobs_found: Maybe<Scalars['String']['output']>
    no_results_label: Maybe<Scalars['String']['output']>
    no_search_label: Maybe<Scalars['String']['output']>
    role: Maybe<Scalars['String']['output']>
    search_input_placeholder: Maybe<Scalars['String']['output']>
    showing_roles_by_department: Maybe<Scalars['String']['output']>
    showing_roles_by_department_with_search: Maybe<Scalars['String']['output']>
    team: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataListingTableHeadingsFieldSelector = {
    all_departments_label: InputMaybe<FieldSelectorEnum>
    all_departments_placeholder: InputMaybe<FieldSelectorEnum>
    clear_filters: InputMaybe<FieldSelectorEnum>
    location: InputMaybe<FieldSelectorEnum>
    no_jobs_found: InputMaybe<FieldSelectorEnum>
    no_results_label: InputMaybe<FieldSelectorEnum>
    no_search_label: InputMaybe<FieldSelectorEnum>
    role: InputMaybe<FieldSelectorEnum>
    search_input_placeholder: InputMaybe<FieldSelectorEnum>
    showing_roles_by_department: InputMaybe<FieldSelectorEnum>
    showing_roles_by_department_with_search: InputMaybe<FieldSelectorEnum>
    team: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataListingTableHeadingsFilterInput = {
    all_departments_label: InputMaybe<StringQueryOperatorInput>
    all_departments_placeholder: InputMaybe<StringQueryOperatorInput>
    clear_filters: InputMaybe<StringQueryOperatorInput>
    location: InputMaybe<StringQueryOperatorInput>
    no_jobs_found: InputMaybe<StringQueryOperatorInput>
    no_results_label: InputMaybe<StringQueryOperatorInput>
    no_search_label: InputMaybe<StringQueryOperatorInput>
    role: InputMaybe<StringQueryOperatorInput>
    search_input_placeholder: InputMaybe<StringQueryOperatorInput>
    showing_roles_by_department: InputMaybe<StringQueryOperatorInput>
    showing_roles_by_department_with_search: InputMaybe<StringQueryOperatorInput>
    team: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataListingTableHeadingsFilterListInput = {
    elemMatch: InputMaybe<PrismicJobListingDataListingTableHeadingsFilterInput>
}

export type PrismicJobListingDataListingTableHeadingsSortInput = {
    all_departments_label: InputMaybe<SortOrderEnum>
    all_departments_placeholder: InputMaybe<SortOrderEnum>
    clear_filters: InputMaybe<SortOrderEnum>
    location: InputMaybe<SortOrderEnum>
    no_jobs_found: InputMaybe<SortOrderEnum>
    no_results_label: InputMaybe<SortOrderEnum>
    no_search_label: InputMaybe<SortOrderEnum>
    role: InputMaybe<SortOrderEnum>
    search_input_placeholder: InputMaybe<SortOrderEnum>
    showing_roles_by_department: InputMaybe<SortOrderEnum>
    showing_roles_by_department_with_search: InputMaybe<SortOrderEnum>
    team: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobListingDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobListingDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobListingDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobListingDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingDataSteps = {
    background_color: Maybe<Scalars['String']['output']>
    content: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicJobListingDataStepsImageImageType>
}

export type PrismicJobListingDataStepsFieldSelector = {
    background_color: InputMaybe<FieldSelectorEnum>
    content: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicJobListingDataStepsImageImageTypeFieldSelector>
}

export type PrismicJobListingDataStepsFilterInput = {
    background_color: InputMaybe<StringQueryOperatorInput>
    content: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicJobListingDataStepsImageImageTypeFilterInput>
}

export type PrismicJobListingDataStepsFilterListInput = {
    elemMatch: InputMaybe<PrismicJobListingDataStepsFilterInput>
}

export type PrismicJobListingDataStepsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataStepsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobListingDataStepsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobListingDataStepsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobListingDataStepsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobListingDataStepsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataStepsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataStepsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingDataStepsSortInput = {
    background_color: InputMaybe<SortOrderEnum>
    content: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicJobListingDataStepsImageImageTypeSortInput>
}

export type PrismicJobListingDataType = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero: Maybe<Array<Maybe<PrismicJobListingDataHero>>>
    listing_table_headings: Maybe<Array<Maybe<PrismicJobListingDataListingTableHeadings>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicJobListingDataOpenGraphImageImageType>
    steps: Maybe<Array<Maybe<PrismicJobListingDataSteps>>>
    steps_title: Maybe<Scalars['String']['output']>
}

export type PrismicJobListingDataTypeFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero: InputMaybe<PrismicJobListingDataHeroFieldSelector>
    listing_table_headings: InputMaybe<PrismicJobListingDataListingTableHeadingsFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicJobListingDataOpenGraphImageImageTypeFieldSelector>
    steps: InputMaybe<PrismicJobListingDataStepsFieldSelector>
    steps_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingDataTypeFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero: InputMaybe<PrismicJobListingDataHeroFilterListInput>
    listing_table_headings: InputMaybe<PrismicJobListingDataListingTableHeadingsFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicJobListingDataOpenGraphImageImageTypeFilterInput>
    steps: InputMaybe<PrismicJobListingDataStepsFilterListInput>
    steps_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingDataTypeSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero: InputMaybe<PrismicJobListingDataHeroSortInput>
    listing_table_headings: InputMaybe<PrismicJobListingDataListingTableHeadingsSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicJobListingDataOpenGraphImageImageTypeSortInput>
    steps: InputMaybe<PrismicJobListingDataStepsSortInput>
    steps_title: InputMaybe<SortOrderEnum>
}

export type PrismicJobListingEdge = {
    next: Maybe<PrismicJobListing>
    node: PrismicJobListing
    previous: Maybe<PrismicJobListing>
}

export type PrismicJobListingFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicJobListingDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobListingFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicJobListingDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobListingGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicJobListingEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicJobListingGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicJobListing>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicJobListingGroupConnectionDistinctArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingGroupConnectionGroupArgs = {
    field: PrismicJobListingFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobListingGroupConnectionMaxArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingGroupConnectionMinArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingGroupConnectionSumArgs = {
    field: PrismicJobListingFieldSelector
}

export type PrismicJobListingSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicJobListingDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicJobPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicJobPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicJobPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicJobPageEdge>
    group: Array<PrismicJobPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicJobPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicJobPageConnectionDistinctArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageConnectionGroupArgs = {
    field: PrismicJobPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobPageConnectionMaxArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageConnectionMinArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageConnectionSumArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageDataFaq = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataFaqFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataFaqFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataFaqFilterListInput = {
    elemMatch: InputMaybe<PrismicJobPageDataFaqFilterInput>
}

export type PrismicJobPageDataFaqSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataForm = {
    attach_file: Maybe<Scalars['String']['output']>
    consent: Maybe<PrismicStructuredTextType>
    content: Maybe<Scalars['String']['output']>
    cv: Maybe<Scalars['String']['output']>
    email: Maybe<Scalars['String']['output']>
    excited_about: Maybe<Scalars['String']['output']>
    file_types: Maybe<Scalars['String']['output']>
    first_name: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicJobPageDataFormImageImageType>
    last_name: Maybe<Scalars['String']['output']>
    linkedin_profile: Maybe<Scalars['String']['output']>
    phone: Maybe<Scalars['String']['output']>
    recaptcha_message: Maybe<PrismicStructuredTextType>
    salary_expectations: Maybe<Scalars['String']['output']>
    submit: Maybe<Scalars['String']['output']>
    thank_you_content: Maybe<Scalars['String']['output']>
    thank_you_image: Maybe<PrismicJobPageDataFormThankYouImageImageType>
    thank_you_link: Maybe<PrismicLinkType>
    thank_you_link_text: Maybe<Scalars['String']['output']>
    thank_you_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    visa_option_is_not_required: Maybe<Scalars['String']['output']>
    visa_option_is_required: Maybe<Scalars['String']['output']>
    visa_required: Maybe<Scalars['String']['output']>
    visa_required_placeholder: Maybe<Scalars['String']['output']>
    why_pleo: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataFormErrors = {
    consent: Maybe<Scalars['String']['output']>
    cv: Maybe<Scalars['String']['output']>
    email: Maybe<Scalars['String']['output']>
    first_name: Maybe<Scalars['String']['output']>
    last_name: Maybe<Scalars['String']['output']>
    phone: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataFormErrorsFieldSelector = {
    consent: InputMaybe<FieldSelectorEnum>
    cv: InputMaybe<FieldSelectorEnum>
    email: InputMaybe<FieldSelectorEnum>
    first_name: InputMaybe<FieldSelectorEnum>
    last_name: InputMaybe<FieldSelectorEnum>
    phone: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataFormErrorsFilterInput = {
    consent: InputMaybe<StringQueryOperatorInput>
    cv: InputMaybe<StringQueryOperatorInput>
    email: InputMaybe<StringQueryOperatorInput>
    first_name: InputMaybe<StringQueryOperatorInput>
    last_name: InputMaybe<StringQueryOperatorInput>
    phone: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataFormErrorsFilterListInput = {
    elemMatch: InputMaybe<PrismicJobPageDataFormErrorsFilterInput>
}

export type PrismicJobPageDataFormErrorsSortInput = {
    consent: InputMaybe<SortOrderEnum>
    cv: InputMaybe<SortOrderEnum>
    email: InputMaybe<SortOrderEnum>
    first_name: InputMaybe<SortOrderEnum>
    last_name: InputMaybe<SortOrderEnum>
    phone: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataFormFieldSelector = {
    attach_file: InputMaybe<FieldSelectorEnum>
    consent: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    content: InputMaybe<FieldSelectorEnum>
    cv: InputMaybe<FieldSelectorEnum>
    email: InputMaybe<FieldSelectorEnum>
    excited_about: InputMaybe<FieldSelectorEnum>
    file_types: InputMaybe<FieldSelectorEnum>
    first_name: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicJobPageDataFormImageImageTypeFieldSelector>
    last_name: InputMaybe<FieldSelectorEnum>
    linkedin_profile: InputMaybe<FieldSelectorEnum>
    phone: InputMaybe<FieldSelectorEnum>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    salary_expectations: InputMaybe<FieldSelectorEnum>
    submit: InputMaybe<FieldSelectorEnum>
    thank_you_content: InputMaybe<FieldSelectorEnum>
    thank_you_image: InputMaybe<PrismicJobPageDataFormThankYouImageImageTypeFieldSelector>
    thank_you_link: InputMaybe<PrismicLinkTypeFieldSelector>
    thank_you_link_text: InputMaybe<FieldSelectorEnum>
    thank_you_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    visa_option_is_not_required: InputMaybe<FieldSelectorEnum>
    visa_option_is_required: InputMaybe<FieldSelectorEnum>
    visa_required: InputMaybe<FieldSelectorEnum>
    visa_required_placeholder: InputMaybe<FieldSelectorEnum>
    why_pleo: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataFormFilterInput = {
    attach_file: InputMaybe<StringQueryOperatorInput>
    consent: InputMaybe<PrismicStructuredTextTypeFilterInput>
    content: InputMaybe<StringQueryOperatorInput>
    cv: InputMaybe<StringQueryOperatorInput>
    email: InputMaybe<StringQueryOperatorInput>
    excited_about: InputMaybe<StringQueryOperatorInput>
    file_types: InputMaybe<StringQueryOperatorInput>
    first_name: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicJobPageDataFormImageImageTypeFilterInput>
    last_name: InputMaybe<StringQueryOperatorInput>
    linkedin_profile: InputMaybe<StringQueryOperatorInput>
    phone: InputMaybe<StringQueryOperatorInput>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    salary_expectations: InputMaybe<StringQueryOperatorInput>
    submit: InputMaybe<StringQueryOperatorInput>
    thank_you_content: InputMaybe<StringQueryOperatorInput>
    thank_you_image: InputMaybe<PrismicJobPageDataFormThankYouImageImageTypeFilterInput>
    thank_you_link: InputMaybe<PrismicLinkTypeFilterInput>
    thank_you_link_text: InputMaybe<StringQueryOperatorInput>
    thank_you_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    visa_option_is_not_required: InputMaybe<StringQueryOperatorInput>
    visa_option_is_required: InputMaybe<StringQueryOperatorInput>
    visa_required: InputMaybe<StringQueryOperatorInput>
    visa_required_placeholder: InputMaybe<StringQueryOperatorInput>
    why_pleo: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataFormFilterListInput = {
    elemMatch: InputMaybe<PrismicJobPageDataFormFilterInput>
}

export type PrismicJobPageDataFormImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataFormImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobPageDataFormImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobPageDataFormImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobPageDataFormImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobPageDataFormImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataFormImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataFormImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataFormSortInput = {
    attach_file: InputMaybe<SortOrderEnum>
    consent: InputMaybe<PrismicStructuredTextTypeSortInput>
    content: InputMaybe<SortOrderEnum>
    cv: InputMaybe<SortOrderEnum>
    email: InputMaybe<SortOrderEnum>
    excited_about: InputMaybe<SortOrderEnum>
    file_types: InputMaybe<SortOrderEnum>
    first_name: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicJobPageDataFormImageImageTypeSortInput>
    last_name: InputMaybe<SortOrderEnum>
    linkedin_profile: InputMaybe<SortOrderEnum>
    phone: InputMaybe<SortOrderEnum>
    recaptcha_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    salary_expectations: InputMaybe<SortOrderEnum>
    submit: InputMaybe<SortOrderEnum>
    thank_you_content: InputMaybe<SortOrderEnum>
    thank_you_image: InputMaybe<PrismicJobPageDataFormThankYouImageImageTypeSortInput>
    thank_you_link: InputMaybe<PrismicLinkTypeSortInput>
    thank_you_link_text: InputMaybe<SortOrderEnum>
    thank_you_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    visa_option_is_not_required: InputMaybe<SortOrderEnum>
    visa_option_is_required: InputMaybe<SortOrderEnum>
    visa_required: InputMaybe<SortOrderEnum>
    visa_required_placeholder: InputMaybe<SortOrderEnum>
    why_pleo: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataFormThankYouImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataFormThankYouImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobPageDataFormThankYouImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobPageDataFormThankYouImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobPageDataFormThankYouImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobPageDataFormThankYouImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataFormThankYouImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataFormThankYouImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataMoreJobs = {
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataMoreJobsFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataMoreJobsFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataMoreJobsFilterListInput = {
    elemMatch: InputMaybe<PrismicJobPageDataMoreJobsFilterInput>
}

export type PrismicJobPageDataMoreJobsSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicJobPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicJobPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicJobPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageDataType = {
    apply_now_label: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    extra_questions_button: Maybe<Scalars['String']['output']>
    extra_questions_title: Maybe<Scalars['String']['output']>
    faq: Maybe<Array<Maybe<PrismicJobPageDataFaq>>>
    faq_title: Maybe<Scalars['String']['output']>
    form: Maybe<Array<Maybe<PrismicJobPageDataForm>>>
    form_errors: Maybe<Array<Maybe<PrismicJobPageDataFormErrors>>>
    location_label: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    more_jobs: Maybe<Array<Maybe<PrismicJobPageDataMoreJobs>>>
    open_graph_image: Maybe<PrismicJobPageDataOpenGraphImageImageType>
    team_label: Maybe<Scalars['String']['output']>
}

export type PrismicJobPageDataTypeFieldSelector = {
    apply_now_label: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    extra_questions_button: InputMaybe<FieldSelectorEnum>
    extra_questions_title: InputMaybe<FieldSelectorEnum>
    faq: InputMaybe<PrismicJobPageDataFaqFieldSelector>
    faq_title: InputMaybe<FieldSelectorEnum>
    form: InputMaybe<PrismicJobPageDataFormFieldSelector>
    form_errors: InputMaybe<PrismicJobPageDataFormErrorsFieldSelector>
    location_label: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    more_jobs: InputMaybe<PrismicJobPageDataMoreJobsFieldSelector>
    open_graph_image: InputMaybe<PrismicJobPageDataOpenGraphImageImageTypeFieldSelector>
    team_label: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageDataTypeFilterInput = {
    apply_now_label: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    extra_questions_button: InputMaybe<StringQueryOperatorInput>
    extra_questions_title: InputMaybe<StringQueryOperatorInput>
    faq: InputMaybe<PrismicJobPageDataFaqFilterListInput>
    faq_title: InputMaybe<StringQueryOperatorInput>
    form: InputMaybe<PrismicJobPageDataFormFilterListInput>
    form_errors: InputMaybe<PrismicJobPageDataFormErrorsFilterListInput>
    location_label: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    more_jobs: InputMaybe<PrismicJobPageDataMoreJobsFilterListInput>
    open_graph_image: InputMaybe<PrismicJobPageDataOpenGraphImageImageTypeFilterInput>
    team_label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageDataTypeSortInput = {
    apply_now_label: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    extra_questions_button: InputMaybe<SortOrderEnum>
    extra_questions_title: InputMaybe<SortOrderEnum>
    faq: InputMaybe<PrismicJobPageDataFaqSortInput>
    faq_title: InputMaybe<SortOrderEnum>
    form: InputMaybe<PrismicJobPageDataFormSortInput>
    form_errors: InputMaybe<PrismicJobPageDataFormErrorsSortInput>
    location_label: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    more_jobs: InputMaybe<PrismicJobPageDataMoreJobsSortInput>
    open_graph_image: InputMaybe<PrismicJobPageDataOpenGraphImageImageTypeSortInput>
    team_label: InputMaybe<SortOrderEnum>
}

export type PrismicJobPageEdge = {
    next: Maybe<PrismicJobPage>
    node: PrismicJobPage
    previous: Maybe<PrismicJobPage>
}

export type PrismicJobPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicJobPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicJobPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicJobPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicJobPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicJobPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicJobPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicJobPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicJobPageGroupConnectionDistinctArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageGroupConnectionGroupArgs = {
    field: PrismicJobPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicJobPageGroupConnectionMaxArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageGroupConnectionMinArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageGroupConnectionSumArgs = {
    field: PrismicJobPageFieldSelector
}

export type PrismicJobPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicJobPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLearnMoreCard = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLearnMoreCardDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLearnMoreCardFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLearnMoreCardLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLearnMoreCardConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLearnMoreCardEdge>
    group: Array<PrismicLearnMoreCardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLearnMoreCard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLearnMoreCardConnectionDistinctArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardConnectionGroupArgs = {
    field: PrismicLearnMoreCardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLearnMoreCardConnectionMaxArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardConnectionMinArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardConnectionSumArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLearnMoreCardDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLearnMoreCardDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLearnMoreCardDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLearnMoreCardDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLearnMoreCardDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLearnMoreCardDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLearnMoreCardDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLearnMoreCardDataType = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    cta_url: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicLearnMoreCardDataImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLearnMoreCardDataTypeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    cta_url: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicLearnMoreCardDataImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLearnMoreCardDataTypeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    cta_url: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicLearnMoreCardDataImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLearnMoreCardDataTypeSortInput = {
    body: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    cta_url: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicLearnMoreCardDataImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLearnMoreCardEdge = {
    next: Maybe<PrismicLearnMoreCard>
    node: PrismicLearnMoreCard
    previous: Maybe<PrismicLearnMoreCard>
}

export type PrismicLearnMoreCardFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLearnMoreCardDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLearnMoreCardFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLearnMoreCardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLearnMoreCardGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLearnMoreCardEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLearnMoreCardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLearnMoreCard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLearnMoreCardGroupConnectionDistinctArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardGroupConnectionGroupArgs = {
    field: PrismicLearnMoreCardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLearnMoreCardGroupConnectionMaxArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardGroupConnectionMinArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardGroupConnectionSumArgs = {
    field: PrismicLearnMoreCardFieldSelector
}

export type PrismicLearnMoreCardSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLearnMoreCardDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocument = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalDocumentDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentEdge>
    group: Array<PrismicLegalDocumentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocument>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentConnectionDistinctArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentConnectionGroupArgs = {
    field: PrismicLegalDocumentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentConnectionMaxArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentConnectionMinArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentConnectionSumArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentDataType = {
    legal_document_pdf: Maybe<PrismicLinkType>
    legal_document_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentDataTypeFieldSelector = {
    legal_document_pdf: InputMaybe<PrismicLinkTypeFieldSelector>
    legal_document_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentDataTypeFilterInput = {
    legal_document_pdf: InputMaybe<PrismicLinkTypeFilterInput>
    legal_document_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentDataTypeSortInput = {
    legal_document_pdf: InputMaybe<PrismicLinkTypeSortInput>
    legal_document_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocumentEdge = {
    next: Maybe<PrismicLegalDocument>
    node: PrismicLegalDocument
    previous: Maybe<PrismicLegalDocument>
}

export type PrismicLegalDocumentFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalDocumentDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalDocumentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocument>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentGroupConnectionDistinctArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentGroupConnectionGroupArgs = {
    field: PrismicLegalDocumentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentGroupConnectionMaxArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentGroupConnectionMinArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentGroupConnectionSumArgs = {
    field: PrismicLegalDocumentFieldSelector
}

export type PrismicLegalDocumentSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalDocumentDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocuments = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalDocumentsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentsEdge>
    group: Array<PrismicLegalDocumentsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocuments>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentsConnectionDistinctArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsConnectionGroupArgs = {
    field: PrismicLegalDocumentsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentsConnectionMaxArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsConnectionMinArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsConnectionSumArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsDataDocuments = {
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentsDataDocumentsFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentsDataDocumentsFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentsDataDocumentsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalDocumentsDataDocumentsFilterInput>
}

export type PrismicLegalDocumentsDataDocumentsSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocumentsDataHistoricalDocuments = {
    document_title: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentsDataHistoricalDocumentsFieldSelector = {
    document_title: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentsDataHistoricalDocumentsFilterInput = {
    document_title: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentsDataHistoricalDocumentsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalDocumentsDataHistoricalDocumentsFilterInput>
}

export type PrismicLegalDocumentsDataHistoricalDocumentsSortInput = {
    document_title: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocumentsDataType = {
    documents: Maybe<Array<Maybe<PrismicLegalDocumentsDataDocuments>>>
    historical_documents: Maybe<Array<Maybe<PrismicLegalDocumentsDataHistoricalDocuments>>>
    historical_documents_title: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentsDataTypeFieldSelector = {
    documents: InputMaybe<PrismicLegalDocumentsDataDocumentsFieldSelector>
    historical_documents: InputMaybe<PrismicLegalDocumentsDataHistoricalDocumentsFieldSelector>
    historical_documents_title: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentsDataTypeFilterInput = {
    documents: InputMaybe<PrismicLegalDocumentsDataDocumentsFilterListInput>
    historical_documents: InputMaybe<PrismicLegalDocumentsDataHistoricalDocumentsFilterListInput>
    historical_documents_title: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentsDataTypeSortInput = {
    documents: InputMaybe<PrismicLegalDocumentsDataDocumentsSortInput>
    historical_documents: InputMaybe<PrismicLegalDocumentsDataHistoricalDocumentsSortInput>
    historical_documents_title: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocumentsDirectory = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalDocumentsDirectoryDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalDocumentsDirectoryFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentsDirectoryLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalDocumentsDirectoryConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentsDirectoryEdge>
    group: Array<PrismicLegalDocumentsDirectoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocumentsDirectory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentsDirectoryConnectionDistinctArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryConnectionGroupArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentsDirectoryConnectionMaxArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryConnectionMinArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryConnectionSumArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryDataLegalDocument = {
    document_friendly_name: Maybe<Scalars['String']['output']>
    filename: Maybe<Scalars['String']['output']>
    pdf_file: Maybe<PrismicLinkType>
}

export type PrismicLegalDocumentsDirectoryDataLegalDocumentFieldSelector = {
    document_friendly_name: InputMaybe<FieldSelectorEnum>
    filename: InputMaybe<FieldSelectorEnum>
    pdf_file: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicLegalDocumentsDirectoryDataLegalDocumentFilterInput = {
    document_friendly_name: InputMaybe<StringQueryOperatorInput>
    filename: InputMaybe<StringQueryOperatorInput>
    pdf_file: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicLegalDocumentsDirectoryDataLegalDocumentFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalDocumentsDirectoryDataLegalDocumentFilterInput>
}

export type PrismicLegalDocumentsDirectoryDataLegalDocumentSortInput = {
    document_friendly_name: InputMaybe<SortOrderEnum>
    filename: InputMaybe<SortOrderEnum>
    pdf_file: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicLegalDocumentsDirectoryDataType = {
    legal_document: Maybe<Array<Maybe<PrismicLegalDocumentsDirectoryDataLegalDocument>>>
}

export type PrismicLegalDocumentsDirectoryDataTypeFieldSelector = {
    legal_document: InputMaybe<PrismicLegalDocumentsDirectoryDataLegalDocumentFieldSelector>
}

export type PrismicLegalDocumentsDirectoryDataTypeFilterInput = {
    legal_document: InputMaybe<PrismicLegalDocumentsDirectoryDataLegalDocumentFilterListInput>
}

export type PrismicLegalDocumentsDirectoryDataTypeSortInput = {
    legal_document: InputMaybe<PrismicLegalDocumentsDirectoryDataLegalDocumentSortInput>
}

export type PrismicLegalDocumentsDirectoryEdge = {
    next: Maybe<PrismicLegalDocumentsDirectory>
    node: PrismicLegalDocumentsDirectory
    previous: Maybe<PrismicLegalDocumentsDirectory>
}

export type PrismicLegalDocumentsDirectoryFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalDocumentsDirectoryDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentsDirectoryFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentsDirectoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentsDirectoryGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentsDirectoryEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalDocumentsDirectoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocumentsDirectory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentsDirectoryGroupConnectionDistinctArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryGroupConnectionGroupArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentsDirectoryGroupConnectionMaxArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryGroupConnectionMinArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectoryGroupConnectionSumArgs = {
    field: PrismicLegalDocumentsDirectoryFieldSelector
}

export type PrismicLegalDocumentsDirectorySortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalDocumentsDirectoryDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalDocumentsEdge = {
    next: Maybe<PrismicLegalDocuments>
    node: PrismicLegalDocuments
    previous: Maybe<PrismicLegalDocuments>
}

export type PrismicLegalDocumentsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalDocumentsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalDocumentsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalDocumentsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalDocumentsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalDocumentsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalDocuments>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalDocumentsGroupConnectionDistinctArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsGroupConnectionGroupArgs = {
    field: PrismicLegalDocumentsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalDocumentsGroupConnectionMaxArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsGroupConnectionMinArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsGroupConnectionSumArgs = {
    field: PrismicLegalDocumentsFieldSelector
}

export type PrismicLegalDocumentsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalDocumentsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageEdge>
    group: Array<PrismicLegalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageConnectionDistinctArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageConnectionGroupArgs = {
    field: PrismicLegalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageConnectionMaxArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageConnectionMinArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageConnectionSumArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageCookiePolicy = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalPageCookiePolicyDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageCookiePolicyLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageCookiePolicyConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageCookiePolicyEdge>
    group: Array<PrismicLegalPageCookiePolicyGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageCookiePolicy>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageCookiePolicyConnectionDistinctArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyConnectionGroupArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageCookiePolicyConnectionMaxArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyConnectionMinArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyConnectionSumArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataSections = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_content: Maybe<PrismicStructuredTextType>
    section_image: Maybe<PrismicLegalPageCookiePolicyDataSectionsSectionImageImageType>
    section_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataSectionsFieldSelector = {
    inverse: InputMaybe<FieldSelectorEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFieldSelector>
    section_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsFilterInput = {
    inverse: InputMaybe<BooleanQueryOperatorInput>
    section_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFilterInput>
    section_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsFilterInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2 = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_content: Maybe<PrismicStructuredTextType>
    section_image: Maybe<PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageType>
    section_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2FieldSelector = {
    inverse: InputMaybe<FieldSelectorEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFieldSelector>
    section_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2FilterInput = {
    inverse: InputMaybe<BooleanQueryOperatorInput>
    section_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFilterInput>
    section_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2FilterListInput = {
    elemMatch: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2FilterInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsPart2SortInput = {
    inverse: InputMaybe<SortOrderEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeSortInput>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2SectionImageImageTypeSortInput>
    section_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataSectionsSortInput = {
    inverse: InputMaybe<SortOrderEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeSortInput>
    section_image: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsSectionImageImageTypeSortInput>
    section_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicLegalPageCookiePolicyDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    sections: Maybe<Array<Maybe<PrismicLegalPageCookiePolicyDataSections>>>
    sections_part_2: Maybe<Array<Maybe<PrismicLegalPageCookiePolicyDataSectionsPart2>>>
    title: Maybe<Scalars['String']['output']>
    used_cookies_details: Maybe<Array<Maybe<PrismicLegalPageCookiePolicyDataUsedCookiesDetails>>>
    used_cookies_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    sections: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsFieldSelector>
    sections_part_2: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2FieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    used_cookies_details: InputMaybe<PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFieldSelector>
    used_cookies_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    sections: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsFilterListInput>
    sections_part_2: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2FilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
    used_cookies_details: InputMaybe<PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFilterListInput>
    used_cookies_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicLegalPageCookiePolicyDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    sections: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsSortInput>
    sections_part_2: InputMaybe<PrismicLegalPageCookiePolicyDataSectionsPart2SortInput>
    title: InputMaybe<SortOrderEnum>
    used_cookies_details: InputMaybe<PrismicLegalPageCookiePolicyDataUsedCookiesDetailsSortInput>
    used_cookies_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyDataUsedCookiesDetails = {
    used_cookie_detail: Maybe<PrismicStructuredTextType>
    used_cookie_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFieldSelector = {
    used_cookie_detail: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    used_cookie_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFilterInput = {
    used_cookie_detail: InputMaybe<PrismicStructuredTextTypeFilterInput>
    used_cookie_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalPageCookiePolicyDataUsedCookiesDetailsFilterInput>
}

export type PrismicLegalPageCookiePolicyDataUsedCookiesDetailsSortInput = {
    used_cookie_detail: InputMaybe<PrismicStructuredTextTypeSortInput>
    used_cookie_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageCookiePolicyEdge = {
    next: Maybe<PrismicLegalPageCookiePolicy>
    node: PrismicLegalPageCookiePolicy
    previous: Maybe<PrismicLegalPageCookiePolicy>
}

export type PrismicLegalPageCookiePolicyFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalPageCookiePolicyDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageCookiePolicyFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageCookiePolicyDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageCookiePolicyGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageCookiePolicyEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalPageCookiePolicyGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageCookiePolicy>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageCookiePolicyGroupConnectionDistinctArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyGroupConnectionGroupArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageCookiePolicyGroupConnectionMaxArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyGroupConnectionMinArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicyGroupConnectionSumArgs = {
    field: PrismicLegalPageCookiePolicyFieldSelector
}

export type PrismicLegalPageCookiePolicySortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalPageCookiePolicyDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicLegalPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicLegalPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicLegalPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicLegalPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageDsr = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalPageDsrDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageDsrFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageDsrLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageDsrConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageDsrEdge>
    group: Array<PrismicLegalPageDsrGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageDsr>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageDsrConnectionDistinctArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrConnectionGroupArgs = {
    field: PrismicLegalPageDsrFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageDsrConnectionMaxArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrConnectionMinArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrConnectionSumArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageDsrDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageDsrDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicLegalPageDsrDataOpenGraphImageImageType>
    securiti_iframe_title: Maybe<Scalars['String']['output']>
    securiti_iframe_url: Maybe<PrismicLinkType>
}

export type PrismicLegalPageDsrDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicLegalPageDsrDataOpenGraphImageImageTypeFieldSelector>
    securiti_iframe_title: InputMaybe<FieldSelectorEnum>
    securiti_iframe_url: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicLegalPageDsrDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicLegalPageDsrDataOpenGraphImageImageTypeFilterInput>
    securiti_iframe_title: InputMaybe<StringQueryOperatorInput>
    securiti_iframe_url: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicLegalPageDsrDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicLegalPageDsrDataOpenGraphImageImageTypeSortInput>
    securiti_iframe_title: InputMaybe<SortOrderEnum>
    securiti_iframe_url: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicLegalPageDsrEdge = {
    next: Maybe<PrismicLegalPageDsr>
    node: PrismicLegalPageDsr
    previous: Maybe<PrismicLegalPageDsr>
}

export type PrismicLegalPageDsrFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalPageDsrDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageDsrFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageDsrDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageDsrGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageDsrEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalPageDsrGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageDsr>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageDsrGroupConnectionDistinctArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrGroupConnectionGroupArgs = {
    field: PrismicLegalPageDsrFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageDsrGroupConnectionMaxArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrGroupConnectionMinArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrGroupConnectionSumArgs = {
    field: PrismicLegalPageDsrFieldSelector
}

export type PrismicLegalPageDsrSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalPageDsrDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageEdge = {
    next: Maybe<PrismicLegalPage>
    node: PrismicLegalPage
    previous: Maybe<PrismicLegalPage>
}

export type PrismicLegalPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdpr = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalPageGdprDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageGdprFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageGdprLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageGdprConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageGdprEdge>
    group: Array<PrismicLegalPageGdprGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageGdpr>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageGdprConnectionDistinctArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprConnectionGroupArgs = {
    field: PrismicLegalPageGdprFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageGdprConnectionMaxArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprConnectionMinArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprConnectionSumArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdprDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageGdprDataSections = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_content: Maybe<PrismicStructuredTextType>
    section_image: Maybe<PrismicLegalPageGdprDataSectionsSectionImageImageType>
    section_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageGdprDataSectionsFieldSelector = {
    inverse: InputMaybe<FieldSelectorEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    section_image: InputMaybe<PrismicLegalPageGdprDataSectionsSectionImageImageTypeFieldSelector>
    section_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageGdprDataSectionsFilterInput = {
    inverse: InputMaybe<BooleanQueryOperatorInput>
    section_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    section_image: InputMaybe<PrismicLegalPageGdprDataSectionsSectionImageImageTypeFilterInput>
    section_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdprDataSectionsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalPageGdprDataSectionsFilterInput>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdprDataSectionsSectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageGdprDataSectionsSortInput = {
    inverse: InputMaybe<SortOrderEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeSortInput>
    section_image: InputMaybe<PrismicLegalPageGdprDataSectionsSectionImageImageTypeSortInput>
    section_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageGdprDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicLegalPageGdprDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    sections: Maybe<Array<Maybe<PrismicLegalPageGdprDataSections>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageGdprDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicLegalPageGdprDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    sections: InputMaybe<PrismicLegalPageGdprDataSectionsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageGdprDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicLegalPageGdprDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    sections: InputMaybe<PrismicLegalPageGdprDataSectionsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdprDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicLegalPageGdprDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    sections: InputMaybe<PrismicLegalPageGdprDataSectionsSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageGdprEdge = {
    next: Maybe<PrismicLegalPageGdpr>
    node: PrismicLegalPageGdpr
    previous: Maybe<PrismicLegalPageGdpr>
}

export type PrismicLegalPageGdprFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalPageGdprDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageGdprFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageGdprDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageGdprGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageGdprEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalPageGdprGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageGdpr>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageGdprGroupConnectionDistinctArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprGroupConnectionGroupArgs = {
    field: PrismicLegalPageGdprFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageGdprGroupConnectionMaxArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprGroupConnectionMinArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprGroupConnectionSumArgs = {
    field: PrismicLegalPageGdprFieldSelector
}

export type PrismicLegalPageGdprSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalPageGdprDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageGroupConnectionDistinctArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageGroupConnectionGroupArgs = {
    field: PrismicLegalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageGroupConnectionMaxArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageGroupConnectionMinArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageGroupConnectionSumArgs = {
    field: PrismicLegalPageFieldSelector
}

export type PrismicLegalPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageThirdPartyLicences = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLegalPageThirdPartyLicencesDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageThirdPartyLicencesFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageThirdPartyLicencesLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLegalPageThirdPartyLicencesConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageThirdPartyLicencesEdge>
    group: Array<PrismicLegalPageThirdPartyLicencesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageThirdPartyLicences>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageThirdPartyLicencesConnectionDistinctArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesConnectionGroupArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageThirdPartyLicencesConnectionMaxArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesConnectionMinArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesConnectionSumArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataSections = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_content: Maybe<PrismicStructuredTextType>
    section_image: Maybe<PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageType>
    section_title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsFieldSelector = {
    inverse: InputMaybe<FieldSelectorEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    section_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFieldSelector>
    section_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsFilterInput = {
    inverse: InputMaybe<BooleanQueryOperatorInput>
    section_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
    section_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFilterInput>
    section_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsFilterListInput = {
    elemMatch: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsFilterInput>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataSectionsSortInput = {
    inverse: InputMaybe<SortOrderEnum>
    section_content: InputMaybe<PrismicStructuredTextTypeSortInput>
    section_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsSectionImageImageTypeSortInput>
    section_title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageType>
    predefined_licences: Maybe<PrismicLinkType>
    prismic_title: Maybe<Scalars['String']['output']>
    recognition_title: Maybe<Scalars['String']['output']>
    sections: Maybe<Array<Maybe<PrismicLegalPageThirdPartyLicencesDataSections>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicLegalPageThirdPartyLicencesDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFieldSelector>
    predefined_licences: InputMaybe<PrismicLinkTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    recognition_title: InputMaybe<FieldSelectorEnum>
    sections: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageThirdPartyLicencesDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeFilterInput>
    predefined_licences: InputMaybe<PrismicLinkTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    recognition_title: InputMaybe<StringQueryOperatorInput>
    sections: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageThirdPartyLicencesDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicLegalPageThirdPartyLicencesDataOpenGraphImageImageTypeSortInput>
    predefined_licences: InputMaybe<PrismicLinkTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    recognition_title: InputMaybe<SortOrderEnum>
    sections: InputMaybe<PrismicLegalPageThirdPartyLicencesDataSectionsSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicLegalPageThirdPartyLicencesEdge = {
    next: Maybe<PrismicLegalPageThirdPartyLicences>
    node: PrismicLegalPageThirdPartyLicences
    previous: Maybe<PrismicLegalPageThirdPartyLicences>
}

export type PrismicLegalPageThirdPartyLicencesFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLegalPageThirdPartyLicencesDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLegalPageThirdPartyLicencesFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageThirdPartyLicencesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLegalPageThirdPartyLicencesGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLegalPageThirdPartyLicencesEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLegalPageThirdPartyLicencesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLegalPageThirdPartyLicences>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLegalPageThirdPartyLicencesGroupConnectionDistinctArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesGroupConnectionGroupArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLegalPageThirdPartyLicencesGroupConnectionMaxArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesGroupConnectionMinArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesGroupConnectionSumArgs = {
    field: PrismicLegalPageThirdPartyLicencesFieldSelector
}

export type PrismicLegalPageThirdPartyLicencesSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLegalPageThirdPartyLicencesDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLinkTest = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicLinkTestDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicLinkTestFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLinkTestLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicLinkTestConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLinkTestEdge>
    group: Array<PrismicLinkTestGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLinkTest>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLinkTestConnectionDistinctArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestConnectionGroupArgs = {
    field: PrismicLinkTestFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLinkTestConnectionMaxArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestConnectionMinArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestConnectionSumArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestDataType = {
    blog_document_link: Maybe<PrismicLinkType>
    broken_link: Maybe<PrismicLinkType>
    media_link: Maybe<PrismicLinkType>
    web_link: Maybe<PrismicLinkType>
    website_document_link: Maybe<PrismicLinkType>
}

export type PrismicLinkTestDataTypeFieldSelector = {
    blog_document_link: InputMaybe<PrismicLinkTypeFieldSelector>
    broken_link: InputMaybe<PrismicLinkTypeFieldSelector>
    media_link: InputMaybe<PrismicLinkTypeFieldSelector>
    web_link: InputMaybe<PrismicLinkTypeFieldSelector>
    website_document_link: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicLinkTestDataTypeFilterInput = {
    blog_document_link: InputMaybe<PrismicLinkTypeFilterInput>
    broken_link: InputMaybe<PrismicLinkTypeFilterInput>
    media_link: InputMaybe<PrismicLinkTypeFilterInput>
    web_link: InputMaybe<PrismicLinkTypeFilterInput>
    website_document_link: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicLinkTestDataTypeSortInput = {
    blog_document_link: InputMaybe<PrismicLinkTypeSortInput>
    broken_link: InputMaybe<PrismicLinkTypeSortInput>
    media_link: InputMaybe<PrismicLinkTypeSortInput>
    web_link: InputMaybe<PrismicLinkTypeSortInput>
    website_document_link: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicLinkTestEdge = {
    next: Maybe<PrismicLinkTest>
    node: PrismicLinkTest
    previous: Maybe<PrismicLinkTest>
}

export type PrismicLinkTestFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicLinkTestDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLinkTestFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLinkTestDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLinkTestGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicLinkTestEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicLinkTestGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicLinkTest>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicLinkTestGroupConnectionDistinctArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestGroupConnectionGroupArgs = {
    field: PrismicLinkTestFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicLinkTestGroupConnectionMaxArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestGroupConnectionMinArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestGroupConnectionSumArgs = {
    field: PrismicLinkTestFieldSelector
}

export type PrismicLinkTestSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicLinkTestDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicLinkType = {
    document: Maybe<PrismicAllDocumentTypes>
    id: Maybe<Scalars['ID']['output']>
    isBroken: Maybe<Scalars['Boolean']['output']>
    lang: Maybe<Scalars['String']['output']>
    link_type: Maybe<PrismicLinkTypeEnum>
    localFile: Maybe<File>
    raw: Maybe<Scalars['JSON']['output']>
    size: Maybe<Scalars['Int']['output']>
    slug: Maybe<Scalars['String']['output']>
    tags: Maybe<Array<Maybe<Scalars['String']['output']>>>
    target: Maybe<Scalars['String']['output']>
    type: Maybe<Scalars['String']['output']>
    uid: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export enum PrismicLinkTypeEnum {
    Any = 'Any',
    Document = 'Document',
    Media = 'Media',
    Web = 'Web',
}

export type PrismicLinkTypeEnumQueryOperatorInput = {
    eq: InputMaybe<PrismicLinkTypeEnum>
    in: InputMaybe<Array<InputMaybe<PrismicLinkTypeEnum>>>
    ne: InputMaybe<PrismicLinkTypeEnum>
    nin: InputMaybe<Array<InputMaybe<PrismicLinkTypeEnum>>>
}

export type PrismicLinkTypeFieldSelector = {
    id: InputMaybe<FieldSelectorEnum>
    isBroken: InputMaybe<FieldSelectorEnum>
    lang: InputMaybe<FieldSelectorEnum>
    link_type: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    raw: InputMaybe<FieldSelectorEnum>
    size: InputMaybe<FieldSelectorEnum>
    slug: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    target: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicLinkTypeFilterInput = {
    id: InputMaybe<IdQueryOperatorInput>
    isBroken: InputMaybe<BooleanQueryOperatorInput>
    lang: InputMaybe<StringQueryOperatorInput>
    link_type: InputMaybe<PrismicLinkTypeEnumQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    raw: InputMaybe<JsonQueryOperatorInput>
    size: InputMaybe<IntQueryOperatorInput>
    slug: InputMaybe<StringQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    target: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicLinkTypeSortInput = {
    id: InputMaybe<SortOrderEnum>
    isBroken: InputMaybe<SortOrderEnum>
    lang: InputMaybe<SortOrderEnum>
    link_type: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    raw: InputMaybe<SortOrderEnum>
    size: InputMaybe<SortOrderEnum>
    slug: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    target: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicMeetingBookerPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicMeetingBookerPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicMeetingBookerPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicMeetingBookerPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicMeetingBookerPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicMeetingBookerPageEdge>
    group: Array<PrismicMeetingBookerPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicMeetingBookerPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicMeetingBookerPageConnectionDistinctArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageConnectionGroupArgs = {
    field: PrismicMeetingBookerPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicMeetingBookerPageConnectionMaxArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageConnectionMinArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageConnectionSumArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicMeetingBookerPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicMeetingBookerPageDataRedirectLinks = {
    company_size_1: Maybe<PrismicLinkType>
    company_size_2: Maybe<PrismicLinkType>
    company_size_5: Maybe<PrismicLinkType>
    company_size_10: Maybe<PrismicLinkType>
    company_size_50: Maybe<PrismicLinkType>
    company_size_100: Maybe<PrismicLinkType>
    company_size_250: Maybe<PrismicLinkType>
    company_size_500: Maybe<PrismicLinkType>
    sole_trader: Maybe<PrismicLinkType>
}

export type PrismicMeetingBookerPageDataRedirectLinksFieldSelector = {
    company_size_1: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_2: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_5: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_10: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_50: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_100: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_250: InputMaybe<PrismicLinkTypeFieldSelector>
    company_size_500: InputMaybe<PrismicLinkTypeFieldSelector>
    sole_trader: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicMeetingBookerPageDataRedirectLinksFilterInput = {
    company_size_1: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_2: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_5: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_10: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_50: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_100: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_250: InputMaybe<PrismicLinkTypeFilterInput>
    company_size_500: InputMaybe<PrismicLinkTypeFilterInput>
    sole_trader: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicMeetingBookerPageDataRedirectLinksFilterListInput = {
    elemMatch: InputMaybe<PrismicMeetingBookerPageDataRedirectLinksFilterInput>
}

export type PrismicMeetingBookerPageDataRedirectLinksSortInput = {
    company_size_1: InputMaybe<PrismicLinkTypeSortInput>
    company_size_2: InputMaybe<PrismicLinkTypeSortInput>
    company_size_5: InputMaybe<PrismicLinkTypeSortInput>
    company_size_10: InputMaybe<PrismicLinkTypeSortInput>
    company_size_50: InputMaybe<PrismicLinkTypeSortInput>
    company_size_100: InputMaybe<PrismicLinkTypeSortInput>
    company_size_250: InputMaybe<PrismicLinkTypeSortInput>
    company_size_500: InputMaybe<PrismicLinkTypeSortInput>
    sole_trader: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicMeetingBookerPageDataSuccessMessages = {
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicMeetingBookerPageDataSuccessMessagesImageImageType>
    success_body: Maybe<Scalars['String']['output']>
    success_title: Maybe<Scalars['String']['output']>
}

export type PrismicMeetingBookerPageDataSuccessMessagesFieldSelector = {
    cta_label: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    image: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFieldSelector>
    success_body: InputMaybe<FieldSelectorEnum>
    success_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicMeetingBookerPageDataSuccessMessagesFilterInput = {
    cta_label: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    image: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFilterInput>
    success_body: InputMaybe<StringQueryOperatorInput>
    success_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicMeetingBookerPageDataSuccessMessagesFilterListInput = {
    elemMatch: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesFilterInput>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicMeetingBookerPageDataSuccessMessagesSortInput = {
    cta_label: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    image: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesImageImageTypeSortInput>
    success_body: InputMaybe<SortOrderEnum>
    success_title: InputMaybe<SortOrderEnum>
}

export type PrismicMeetingBookerPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicMeetingBookerPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    redirect_links: Maybe<Array<Maybe<PrismicMeetingBookerPageDataRedirectLinks>>>
    success_messages: Maybe<Array<Maybe<PrismicMeetingBookerPageDataSuccessMessages>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicMeetingBookerPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicMeetingBookerPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    redirect_links: InputMaybe<PrismicMeetingBookerPageDataRedirectLinksFieldSelector>
    success_messages: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicMeetingBookerPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicMeetingBookerPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    redirect_links: InputMaybe<PrismicMeetingBookerPageDataRedirectLinksFilterListInput>
    success_messages: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicMeetingBookerPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicMeetingBookerPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    redirect_links: InputMaybe<PrismicMeetingBookerPageDataRedirectLinksSortInput>
    success_messages: InputMaybe<PrismicMeetingBookerPageDataSuccessMessagesSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicMeetingBookerPageEdge = {
    next: Maybe<PrismicMeetingBookerPage>
    node: PrismicMeetingBookerPage
    previous: Maybe<PrismicMeetingBookerPage>
}

export type PrismicMeetingBookerPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicMeetingBookerPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicMeetingBookerPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicMeetingBookerPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicMeetingBookerPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicMeetingBookerPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicMeetingBookerPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicMeetingBookerPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicMeetingBookerPageGroupConnectionDistinctArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageGroupConnectionGroupArgs = {
    field: PrismicMeetingBookerPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicMeetingBookerPageGroupConnectionMaxArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageGroupConnectionMinArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageGroupConnectionSumArgs = {
    field: PrismicMeetingBookerPageFieldSelector
}

export type PrismicMeetingBookerPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicMeetingBookerPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicNotFoundPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicNotFoundPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicNotFoundPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicNotFoundPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicNotFoundPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicNotFoundPageEdge>
    group: Array<PrismicNotFoundPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicNotFoundPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicNotFoundPageConnectionDistinctArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageConnectionGroupArgs = {
    field: PrismicNotFoundPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicNotFoundPageConnectionMaxArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageConnectionMinArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageConnectionSumArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicNotFoundPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicNotFoundPageDataType = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicNotFoundPageDataOpenGraphImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicNotFoundPageDataTypeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicNotFoundPageDataOpenGraphImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicNotFoundPageDataTypeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicNotFoundPageDataOpenGraphImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicNotFoundPageDataTypeSortInput = {
    body: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicNotFoundPageDataOpenGraphImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicNotFoundPageEdge = {
    next: Maybe<PrismicNotFoundPage>
    node: PrismicNotFoundPage
    previous: Maybe<PrismicNotFoundPage>
}

export type PrismicNotFoundPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicNotFoundPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicNotFoundPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicNotFoundPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicNotFoundPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicNotFoundPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicNotFoundPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicNotFoundPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicNotFoundPageGroupConnectionDistinctArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageGroupConnectionGroupArgs = {
    field: PrismicNotFoundPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicNotFoundPageGroupConnectionMaxArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageGroupConnectionMinArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageGroupConnectionSumArgs = {
    field: PrismicNotFoundPageFieldSelector
}

export type PrismicNotFoundPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicNotFoundPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicNotificationBanner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicNotificationBannerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicNotificationBannerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicNotificationBannerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicNotificationBannerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicNotificationBannerEdge>
    group: Array<PrismicNotificationBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicNotificationBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicNotificationBannerConnectionDistinctArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerConnectionGroupArgs = {
    field: PrismicNotificationBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicNotificationBannerConnectionMaxArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerConnectionMinArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerConnectionSumArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerDataType = {
    banner_content: Maybe<PrismicStructuredTextType>
}

export type PrismicNotificationBannerDataTypeFieldSelector = {
    banner_content: InputMaybe<PrismicStructuredTextTypeFieldSelector>
}

export type PrismicNotificationBannerDataTypeFilterInput = {
    banner_content: InputMaybe<PrismicStructuredTextTypeFilterInput>
}

export type PrismicNotificationBannerDataTypeSortInput = {
    banner_content: InputMaybe<PrismicStructuredTextTypeSortInput>
}

export type PrismicNotificationBannerEdge = {
    next: Maybe<PrismicNotificationBanner>
    node: PrismicNotificationBanner
    previous: Maybe<PrismicNotificationBanner>
}

export type PrismicNotificationBannerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicNotificationBannerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicNotificationBannerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicNotificationBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicNotificationBannerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicNotificationBannerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicNotificationBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicNotificationBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicNotificationBannerGroupConnectionDistinctArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerGroupConnectionGroupArgs = {
    field: PrismicNotificationBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicNotificationBannerGroupConnectionMaxArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerGroupConnectionMinArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerGroupConnectionSumArgs = {
    field: PrismicNotificationBannerFieldSelector
}

export type PrismicNotificationBannerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicNotificationBannerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceCategory = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicOnDemandResourceCategoryDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceCategoryFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourceCategoryLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourceCategoryConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceCategoryEdge>
    group: Array<PrismicOnDemandResourceCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceCategoryConnectionDistinctArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryConnectionGroupArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceCategoryConnectionMaxArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryConnectionMinArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryConnectionSumArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryDataType = {
    name: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceCategoryDataTypeFieldSelector = {
    name: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceCategoryDataTypeFilterInput = {
    name: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceCategoryDataTypeSortInput = {
    name: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceCategoryEdge = {
    next: Maybe<PrismicOnDemandResourceCategory>
    node: PrismicOnDemandResourceCategory
    previous: Maybe<PrismicOnDemandResourceCategory>
}

export type PrismicOnDemandResourceCategoryFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicOnDemandResourceCategoryDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceCategoryFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourceCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceCategoryGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceCategoryEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandResourceCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceCategoryGroupConnectionDistinctArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryGroupConnectionGroupArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceCategoryGroupConnectionMaxArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryGroupConnectionMinArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategoryGroupConnectionSumArgs = {
    field: PrismicOnDemandResourceCategoryFieldSelector
}

export type PrismicOnDemandResourceCategorySortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicOnDemandResourceCategoryDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicOnDemandResourceFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourceFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourceFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormEdge>
    group: Array<PrismicOnDemandResourceFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormConnectionDistinctArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormConnectionMinArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormConnectionSumArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
    node: PrismicOnDemandResourceFormDataFormProductionIntegrationType
    previous: Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
    node: PrismicOnDemandResourceFormDataFormStagingIntegrationType
    previous: Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicOnDemandResourceFormDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsProduction = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsProductionFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsProductionFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsProductionFilterListInput = {
    elemMatch: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsProductionFilterInput>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsProductionSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsStaging = {
    consent: Maybe<PrismicLinkType>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsStagingFieldSelector = {
    consent: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsStagingFilterInput = {
    consent: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsStagingFilterListInput = {
    elemMatch: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsStagingFilterInput>
}

export type PrismicOnDemandResourceFormDataImperativeConsentsStagingSortInput = {
    consent: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicOnDemandResourceFormDataType = {
    form_description: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
    form_title: Maybe<Scalars['String']['output']>
    imperative_consents_production: Maybe<
        Array<Maybe<PrismicOnDemandResourceFormDataImperativeConsentsProduction>>
    >
    imperative_consents_staging: Maybe<
        Array<Maybe<PrismicOnDemandResourceFormDataImperativeConsentsStaging>>
    >
    recurrent_visitor_message: Maybe<Scalars['String']['output']>
    submit_button_text: Maybe<Scalars['String']['output']>
    success_message: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourceFormDataTypeFieldSelector = {
    form_description: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFieldSelector>
    form_title: InputMaybe<FieldSelectorEnum>
    imperative_consents_production: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsProductionFieldSelector>
    imperative_consents_staging: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsStagingFieldSelector>
    recurrent_visitor_message: InputMaybe<FieldSelectorEnum>
    submit_button_text: InputMaybe<FieldSelectorEnum>
    success_message: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormDataTypeFilterInput = {
    form_description: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFilterInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    imperative_consents_production: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsProductionFilterListInput>
    imperative_consents_staging: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsStagingFilterListInput>
    recurrent_visitor_message: InputMaybe<StringQueryOperatorInput>
    submit_button_text: InputMaybe<StringQueryOperatorInput>
    success_message: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormDataTypeSortInput = {
    form_description: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeSortInput>
    form_title: InputMaybe<SortOrderEnum>
    imperative_consents_production: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsProductionSortInput>
    imperative_consents_staging: InputMaybe<PrismicOnDemandResourceFormDataImperativeConsentsStagingSortInput>
    recurrent_visitor_message: InputMaybe<SortOrderEnum>
    submit_button_text: InputMaybe<SortOrderEnum>
    success_message: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourceFormEdge = {
    next: Maybe<PrismicOnDemandResourceForm>
    node: PrismicOnDemandResourceForm
    previous: Maybe<PrismicOnDemandResourceForm>
}

export type PrismicOnDemandResourceFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicOnDemandResourceFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourceFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourceFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourceFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourceFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandResourceFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourceForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourceFormGroupConnectionDistinctArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormGroupConnectionGroupArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourceFormGroupConnectionMaxArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormGroupConnectionMinArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormGroupConnectionSumArgs = {
    field: PrismicOnDemandResourceFormFieldSelector
}

export type PrismicOnDemandResourceFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicOnDemandResourceFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicOnDemandResourcePageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourcePageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandResourcePageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourcePageEdge>
    group: Array<PrismicOnDemandResourcePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourcePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourcePageConnectionDistinctArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageConnectionGroupArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageConnectionMaxArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageConnectionMinArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageConnectionSumArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageDataSpeakerImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePageDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePageDataType = {
    category: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    language_code: Maybe<Scalars['String']['output']>
    long_description: Maybe<PrismicStructuredTextType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    on_demand_resource_form: Maybe<PrismicLinkType>
    open_graph_image: Maybe<PrismicOnDemandResourcePageDataOpenGraphImageImageType>
    signup_banner: Maybe<PrismicLinkType>
    speaker_description: Maybe<Scalars['String']['output']>
    speaker_image: Maybe<PrismicOnDemandResourcePageDataSpeakerImageImageType>
    speaker_name: Maybe<Scalars['String']['output']>
    speaker_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_image: Maybe<PrismicOnDemandResourcePageDataTitleImageImageType>
    video_thumbnail: Maybe<PrismicOnDemandResourcePageDataVideoThumbnailImageType>
    watch_more_card_cta: Maybe<Scalars['String']['output']>
    watch_more_title: Maybe<Scalars['String']['output']>
    watch_more_top_link: Maybe<PrismicLinkType>
    watch_more_top_link_text: Maybe<Scalars['String']['output']>
    wistia_id: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageDataTypeFieldSelector = {
    category: InputMaybe<PrismicLinkTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    duration: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    language_code: InputMaybe<FieldSelectorEnum>
    long_description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    on_demand_resource_form: InputMaybe<PrismicLinkTypeFieldSelector>
    open_graph_image: InputMaybe<PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFieldSelector>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    speaker_description: InputMaybe<FieldSelectorEnum>
    speaker_image: InputMaybe<PrismicOnDemandResourcePageDataSpeakerImageImageTypeFieldSelector>
    speaker_name: InputMaybe<FieldSelectorEnum>
    speaker_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    title_image: InputMaybe<PrismicOnDemandResourcePageDataTitleImageImageTypeFieldSelector>
    video_thumbnail: InputMaybe<PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFieldSelector>
    watch_more_card_cta: InputMaybe<FieldSelectorEnum>
    watch_more_title: InputMaybe<FieldSelectorEnum>
    watch_more_top_link: InputMaybe<PrismicLinkTypeFieldSelector>
    watch_more_top_link_text: InputMaybe<FieldSelectorEnum>
    wistia_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageDataTypeFilterInput = {
    category: InputMaybe<PrismicLinkTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    duration: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    language_code: InputMaybe<StringQueryOperatorInput>
    long_description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    on_demand_resource_form: InputMaybe<PrismicLinkTypeFilterInput>
    open_graph_image: InputMaybe<PrismicOnDemandResourcePageDataOpenGraphImageImageTypeFilterInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    speaker_description: InputMaybe<StringQueryOperatorInput>
    speaker_image: InputMaybe<PrismicOnDemandResourcePageDataSpeakerImageImageTypeFilterInput>
    speaker_name: InputMaybe<StringQueryOperatorInput>
    speaker_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    title_image: InputMaybe<PrismicOnDemandResourcePageDataTitleImageImageTypeFilterInput>
    video_thumbnail: InputMaybe<PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFilterInput>
    watch_more_card_cta: InputMaybe<StringQueryOperatorInput>
    watch_more_title: InputMaybe<StringQueryOperatorInput>
    watch_more_top_link: InputMaybe<PrismicLinkTypeFilterInput>
    watch_more_top_link_text: InputMaybe<StringQueryOperatorInput>
    wistia_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageDataTypeSortInput = {
    category: InputMaybe<PrismicLinkTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    duration: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    language_code: InputMaybe<SortOrderEnum>
    long_description: InputMaybe<PrismicStructuredTextTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    on_demand_resource_form: InputMaybe<PrismicLinkTypeSortInput>
    open_graph_image: InputMaybe<PrismicOnDemandResourcePageDataOpenGraphImageImageTypeSortInput>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    speaker_description: InputMaybe<SortOrderEnum>
    speaker_image: InputMaybe<PrismicOnDemandResourcePageDataSpeakerImageImageTypeSortInput>
    speaker_name: InputMaybe<SortOrderEnum>
    speaker_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    title_image: InputMaybe<PrismicOnDemandResourcePageDataTitleImageImageTypeSortInput>
    video_thumbnail: InputMaybe<PrismicOnDemandResourcePageDataVideoThumbnailImageTypeSortInput>
    watch_more_card_cta: InputMaybe<SortOrderEnum>
    watch_more_title: InputMaybe<SortOrderEnum>
    watch_more_top_link: InputMaybe<PrismicLinkTypeSortInput>
    watch_more_top_link_text: InputMaybe<SortOrderEnum>
    wistia_id: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageDataVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandResourcePageEdge = {
    next: Maybe<PrismicOnDemandResourcePage>
    node: PrismicOnDemandResourcePage
    previous: Maybe<PrismicOnDemandResourcePage>
}

export type PrismicOnDemandResourcePageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicOnDemandResourcePageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandResourcePageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourcePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandResourcePageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandResourcePageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandResourcePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandResourcePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandResourcePageGroupConnectionDistinctArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageGroupConnectionGroupArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandResourcePageGroupConnectionMaxArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageGroupConnectionMinArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageGroupConnectionSumArgs = {
    field: PrismicOnDemandResourcePageFieldSelector
}

export type PrismicOnDemandResourcePageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicOnDemandResourcePageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandWebinarDetailPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicOnDemandWebinarDetailPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandWebinarDetailPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandWebinarDetailPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandWebinarDetailPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandWebinarDetailPageEdge>
    group: Array<PrismicOnDemandWebinarDetailPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandWebinarDetailPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandWebinarDetailPageConnectionDistinctArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageConnectionGroupArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandWebinarDetailPageConnectionMaxArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageConnectionMinArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageConnectionSumArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandWebinarDetailPageDataType = {
    category: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    title_image: Maybe<PrismicOnDemandWebinarDetailPageDataTitleImageImageType>
    webinar_form: Maybe<PrismicLinkType>
}

export type PrismicOnDemandWebinarDetailPageDataTypeFieldSelector = {
    category: InputMaybe<PrismicLinkTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    duration: InputMaybe<FieldSelectorEnum>
    language: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    title_image: InputMaybe<PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFieldSelector>
    webinar_form: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicOnDemandWebinarDetailPageDataTypeFilterInput = {
    category: InputMaybe<PrismicLinkTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    duration: InputMaybe<StringQueryOperatorInput>
    language: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    title_image: InputMaybe<PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeFilterInput>
    webinar_form: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicOnDemandWebinarDetailPageDataTypeSortInput = {
    category: InputMaybe<PrismicLinkTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    duration: InputMaybe<SortOrderEnum>
    language: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    title_image: InputMaybe<PrismicOnDemandWebinarDetailPageDataTitleImageImageTypeSortInput>
    webinar_form: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicOnDemandWebinarDetailPageEdge = {
    next: Maybe<PrismicOnDemandWebinarDetailPage>
    node: PrismicOnDemandWebinarDetailPage
    previous: Maybe<PrismicOnDemandWebinarDetailPage>
}

export type PrismicOnDemandWebinarDetailPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicOnDemandWebinarDetailPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandWebinarDetailPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandWebinarDetailPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandWebinarDetailPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandWebinarDetailPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandWebinarDetailPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandWebinarDetailPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandWebinarDetailPageGroupConnectionDistinctArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageGroupConnectionGroupArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandWebinarDetailPageGroupConnectionMaxArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageGroupConnectionMinArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageGroupConnectionSumArgs = {
    field: PrismicOnDemandWebinarDetailPageFieldSelector
}

export type PrismicOnDemandWebinarDetailPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicOnDemandWebinarDetailPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandWebinarForm = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicOnDemandWebinarFormDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandWebinarFormFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandWebinarFormLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicOnDemandWebinarFormConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandWebinarFormEdge>
    group: Array<PrismicOnDemandWebinarFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandWebinarForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandWebinarFormConnectionDistinctArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormConnectionGroupArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandWebinarFormConnectionMaxArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormConnectionMinArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormConnectionSumArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormDataType = {
    form_description: Maybe<Scalars['String']['output']>
    form_title: Maybe<Scalars['String']['output']>
    hubspot_production_form_id: Maybe<Scalars['String']['output']>
    hubspot_staging_form_id: Maybe<Scalars['String']['output']>
    success_message: Maybe<Scalars['String']['output']>
}

export type PrismicOnDemandWebinarFormDataTypeFieldSelector = {
    form_description: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    hubspot_production_form_id: InputMaybe<FieldSelectorEnum>
    hubspot_staging_form_id: InputMaybe<FieldSelectorEnum>
    success_message: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandWebinarFormDataTypeFilterInput = {
    form_description: InputMaybe<StringQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    hubspot_production_form_id: InputMaybe<StringQueryOperatorInput>
    hubspot_staging_form_id: InputMaybe<StringQueryOperatorInput>
    success_message: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandWebinarFormDataTypeSortInput = {
    form_description: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    hubspot_production_form_id: InputMaybe<SortOrderEnum>
    hubspot_staging_form_id: InputMaybe<SortOrderEnum>
    success_message: InputMaybe<SortOrderEnum>
}

export type PrismicOnDemandWebinarFormEdge = {
    next: Maybe<PrismicOnDemandWebinarForm>
    node: PrismicOnDemandWebinarForm
    previous: Maybe<PrismicOnDemandWebinarForm>
}

export type PrismicOnDemandWebinarFormFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicOnDemandWebinarFormDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicOnDemandWebinarFormFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandWebinarFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicOnDemandWebinarFormGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicOnDemandWebinarFormEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicOnDemandWebinarFormGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicOnDemandWebinarForm>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicOnDemandWebinarFormGroupConnectionDistinctArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormGroupConnectionGroupArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicOnDemandWebinarFormGroupConnectionMaxArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormGroupConnectionMinArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormGroupConnectionSumArgs = {
    field: PrismicOnDemandWebinarFormFieldSelector
}

export type PrismicOnDemandWebinarFormSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicOnDemandWebinarFormDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerBigform = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnerBigformDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerBigformLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerBigformConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformEdge>
    group: Array<PrismicPartnerBigformGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigform>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformConnectionDistinctArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformConnectionGroupArgs = {
    field: PrismicPartnerBigformFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformConnectionMaxArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformConnectionMinArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformConnectionSumArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformDataType = {
    form_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPartnerBigformDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    social_proof_logos_section: Maybe<PrismicLinkType>
}

export type PrismicPartnerBigformDataTypeFieldSelector = {
    form_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPartnerBigformDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPartnerBigformDataTypeFilterInput = {
    form_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPartnerBigformDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPartnerBigformDataTypeSortInput = {
    form_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPartnerBigformDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPartnerBigformEdge = {
    next: Maybe<PrismicPartnerBigform>
    node: PrismicPartnerBigform
    previous: Maybe<PrismicPartnerBigform>
}

export type PrismicPartnerBigformFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnerBigformDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerBigformDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerBigformGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigform>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformGroupConnectionDistinctArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformGroupConnectionGroupArgs = {
    field: PrismicPartnerBigformFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformGroupConnectionMaxArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformGroupConnectionMinArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformGroupConnectionSumArgs = {
    field: PrismicPartnerBigformFieldSelector
}

export type PrismicPartnerBigformPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnerBigformPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerBigformPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerBigformPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageEdge>
    group: Array<PrismicPartnerBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageConnectionDistinctArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageConnectionGroupArgs = {
    field: PrismicPartnerBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageConnectionMaxArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageConnectionMinArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageConnectionSumArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPageDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationType>
    node: PrismicPartnerBigformPageDataFormProductionIntegrationType
    previous: Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationType>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPageDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPageDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationType>
    node: PrismicPartnerBigformPageDataFormStagingIntegrationType
    previous: Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationType>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPageDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPartnerBigformPageDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicPartnerBigformPageDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPartnerBigformPageDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPartnerBigformPageDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerBigformPageDataImperativeConsentsFilterInput>
}

export type PrismicPartnerBigformPageDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataPartnerChannel = {
    accounting_partner: Maybe<Scalars['String']['output']>
    affiliate_partner: Maybe<Scalars['String']['output']>
    consulting_partner: Maybe<Scalars['String']['output']>
    error: Maybe<Scalars['String']['output']>
    integration_partner: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    other_reseller: Maybe<Scalars['String']['output']>
    placeholder: Maybe<Scalars['String']['output']>
    preselected_channel: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataPartnerChannelFieldSelector = {
    accounting_partner: InputMaybe<FieldSelectorEnum>
    affiliate_partner: InputMaybe<FieldSelectorEnum>
    consulting_partner: InputMaybe<FieldSelectorEnum>
    error: InputMaybe<FieldSelectorEnum>
    integration_partner: InputMaybe<FieldSelectorEnum>
    label: InputMaybe<FieldSelectorEnum>
    other_reseller: InputMaybe<FieldSelectorEnum>
    placeholder: InputMaybe<FieldSelectorEnum>
    preselected_channel: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataPartnerChannelFilterInput = {
    accounting_partner: InputMaybe<StringQueryOperatorInput>
    affiliate_partner: InputMaybe<StringQueryOperatorInput>
    consulting_partner: InputMaybe<StringQueryOperatorInput>
    error: InputMaybe<StringQueryOperatorInput>
    integration_partner: InputMaybe<StringQueryOperatorInput>
    label: InputMaybe<StringQueryOperatorInput>
    other_reseller: InputMaybe<StringQueryOperatorInput>
    placeholder: InputMaybe<StringQueryOperatorInput>
    preselected_channel: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataPartnerChannelFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerBigformPageDataPartnerChannelFilterInput>
}

export type PrismicPartnerBigformPageDataPartnerChannelSortInput = {
    accounting_partner: InputMaybe<SortOrderEnum>
    affiliate_partner: InputMaybe<SortOrderEnum>
    consulting_partner: InputMaybe<SortOrderEnum>
    error: InputMaybe<SortOrderEnum>
    integration_partner: InputMaybe<SortOrderEnum>
    label: InputMaybe<SortOrderEnum>
    other_reseller: InputMaybe<SortOrderEnum>
    placeholder: InputMaybe<SortOrderEnum>
    preselected_channel: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataPartnerLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageDataType = {
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationType>
    form_title: Maybe<Scalars['String']['output']>
    imperative_consents: Maybe<Array<Maybe<PrismicPartnerBigformPageDataImperativeConsents>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPartnerBigformPageDataOpenGraphImageImageType>
    partner: Maybe<Scalars['String']['output']>
    partner_channel: Maybe<Array<Maybe<PrismicPartnerBigformPageDataPartnerChannel>>>
    partner_logo: Maybe<PrismicPartnerBigformPageDataPartnerLogoImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    show_description_field: Maybe<Scalars['Boolean']['output']>
    social_proof_logos_section: Maybe<PrismicLinkType>
    submit_button_text: Maybe<Scalars['String']['output']>
    thank_you_subtitle: Maybe<Scalars['String']['output']>
    thank_you_title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerBigformPageDataTypeFieldSelector = {
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeFieldSelector>
    form_title: InputMaybe<FieldSelectorEnum>
    imperative_consents: InputMaybe<PrismicPartnerBigformPageDataImperativeConsentsFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPartnerBigformPageDataOpenGraphImageImageTypeFieldSelector>
    partner: InputMaybe<FieldSelectorEnum>
    partner_channel: InputMaybe<PrismicPartnerBigformPageDataPartnerChannelFieldSelector>
    partner_logo: InputMaybe<PrismicPartnerBigformPageDataPartnerLogoImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    show_description_field: InputMaybe<FieldSelectorEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_button_text: InputMaybe<FieldSelectorEnum>
    thank_you_subtitle: InputMaybe<FieldSelectorEnum>
    thank_you_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageDataTypeFilterInput = {
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeFilterInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    imperative_consents: InputMaybe<PrismicPartnerBigformPageDataImperativeConsentsFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPartnerBigformPageDataOpenGraphImageImageTypeFilterInput>
    partner: InputMaybe<StringQueryOperatorInput>
    partner_channel: InputMaybe<PrismicPartnerBigformPageDataPartnerChannelFilterListInput>
    partner_logo: InputMaybe<PrismicPartnerBigformPageDataPartnerLogoImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    show_description_field: InputMaybe<BooleanQueryOperatorInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    submit_button_text: InputMaybe<StringQueryOperatorInput>
    thank_you_subtitle: InputMaybe<StringQueryOperatorInput>
    thank_you_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageDataTypeSortInput = {
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeSortInput>
    form_title: InputMaybe<SortOrderEnum>
    imperative_consents: InputMaybe<PrismicPartnerBigformPageDataImperativeConsentsSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPartnerBigformPageDataOpenGraphImageImageTypeSortInput>
    partner: InputMaybe<SortOrderEnum>
    partner_channel: InputMaybe<PrismicPartnerBigformPageDataPartnerChannelSortInput>
    partner_logo: InputMaybe<PrismicPartnerBigformPageDataPartnerLogoImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    show_description_field: InputMaybe<SortOrderEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    submit_button_text: InputMaybe<SortOrderEnum>
    thank_you_subtitle: InputMaybe<SortOrderEnum>
    thank_you_title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformPageEdge = {
    next: Maybe<PrismicPartnerBigformPage>
    node: PrismicPartnerBigformPage
    previous: Maybe<PrismicPartnerBigformPage>
}

export type PrismicPartnerBigformPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnerBigformPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerBigformPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerBigformPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerBigformPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerBigformPageGroupConnectionDistinctArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageGroupConnectionGroupArgs = {
    field: PrismicPartnerBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerBigformPageGroupConnectionMaxArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageGroupConnectionMinArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageGroupConnectionSumArgs = {
    field: PrismicPartnerBigformPageFieldSelector
}

export type PrismicPartnerBigformPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnerBigformPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerBigformSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnerBigformDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerEdge>
    group: Array<PrismicPartnerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerConnectionDistinctArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerConnectionGroupArgs = {
    field: PrismicPartnerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerConnectionMaxArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerConnectionMinArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerConnectionSumArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerDataFeaturedSection = {
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    featured_image: Maybe<PrismicPartnerDataFeaturedSectionFeaturedImageImageType>
    lead_text: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerDataFeaturedSectionFieldSelector = {
    cta_label: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    featured_image: InputMaybe<PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFieldSelector>
    lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerDataFeaturedSectionFilterInput = {
    cta_label: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    featured_image: InputMaybe<PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeFilterInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerDataFeaturedSectionFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerDataFeaturedSectionFilterInput>
}

export type PrismicPartnerDataFeaturedSectionSortInput = {
    cta_label: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    featured_image: InputMaybe<PrismicPartnerDataFeaturedSectionFeaturedImageImageTypeSortInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerDataHeroSection = {
    hero_image: Maybe<PrismicPartnerDataHeroSectionHeroImageImageType>
    lead_text: Maybe<PrismicStructuredTextType>
    pre_title: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerDataHeroSectionFieldSelector = {
    hero_image: InputMaybe<PrismicPartnerDataHeroSectionHeroImageImageTypeFieldSelector>
    lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    pre_title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerDataHeroSectionFilterInput = {
    hero_image: InputMaybe<PrismicPartnerDataHeroSectionHeroImageImageTypeFilterInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    pre_title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerDataHeroSectionFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerDataHeroSectionFilterInput>
}

export type PrismicPartnerDataHeroSectionHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerDataHeroSectionHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerDataHeroSectionSortInput = {
    hero_image: InputMaybe<PrismicPartnerDataHeroSectionHeroImageImageTypeSortInput>
    lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    pre_title: InputMaybe<PrismicStructuredTextTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    featured_section: Maybe<Array<Maybe<PrismicPartnerDataFeaturedSection>>>
    hero_section: Maybe<Array<Maybe<PrismicPartnerDataHeroSection>>>
    meta_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
}

export type PrismicPartnerDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    featured_section: InputMaybe<PrismicPartnerDataFeaturedSectionFieldSelector>
    hero_section: InputMaybe<PrismicPartnerDataHeroSectionFieldSelector>
    meta_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPartnerDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    featured_section: InputMaybe<PrismicPartnerDataFeaturedSectionFilterListInput>
    hero_section: InputMaybe<PrismicPartnerDataHeroSectionFilterListInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPartnerDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    featured_section: InputMaybe<PrismicPartnerDataFeaturedSectionSortInput>
    hero_section: InputMaybe<PrismicPartnerDataHeroSectionSortInput>
    meta_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPartnerEdge = {
    next: Maybe<PrismicPartner>
    node: PrismicPartner
    previous: Maybe<PrismicPartner>
}

export type PrismicPartnerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerGroupConnectionDistinctArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerGroupConnectionGroupArgs = {
    field: PrismicPartnerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerGroupConnectionMaxArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerGroupConnectionMinArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerGroupConnectionSumArgs = {
    field: PrismicPartnerFieldSelector
}

export type PrismicPartnerPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnerPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerPageEdge>
    group: Array<PrismicPartnerPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerPageConnectionDistinctArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageConnectionGroupArgs = {
    field: PrismicPartnerPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageConnectionMaxArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageConnectionMinArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageConnectionSumArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageDataFeatures = {
    body: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicPartnerPageDataFeaturesIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataFeaturesFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicPartnerPageDataFeaturesIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataFeaturesFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicPartnerPageDataFeaturesIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerPageDataFeaturesFilterInput>
}

export type PrismicPartnerPageDataFeaturesIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataFeaturesIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataFeaturesSortInput = {
    body: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicPartnerPageDataFeaturesIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataIntegrations = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPartnerPageDataIntegrationsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataIntegrationsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPartnerPageDataIntegrationsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataIntegrationsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPartnerPageDataIntegrationsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataIntegrationsFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerPageDataIntegrationsFilterInput>
}

export type PrismicPartnerPageDataIntegrationsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataIntegrationsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataIntegrationsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPartnerPageDataIntegrationsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataOfferingImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataOfferingImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataOfferingImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataOfferingImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataOfferingImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataOfferingImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataOfferingImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataOfferingImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataPartnerLogos = {
    logo: Maybe<PrismicPartnerPageDataPartnerLogosLogoImageType>
}

export type PrismicPartnerPageDataPartnerLogosFieldSelector = {
    logo: InputMaybe<PrismicPartnerPageDataPartnerLogosLogoImageTypeFieldSelector>
}

export type PrismicPartnerPageDataPartnerLogosFilterInput = {
    logo: InputMaybe<PrismicPartnerPageDataPartnerLogosLogoImageTypeFilterInput>
}

export type PrismicPartnerPageDataPartnerLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerPageDataPartnerLogosFilterInput>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataPartnerLogosLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataPartnerLogosSortInput = {
    logo: InputMaybe<PrismicPartnerPageDataPartnerLogosLogoImageTypeSortInput>
}

export type PrismicPartnerPageDataTestimonials = {
    attribution: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPartnerPageDataTestimonialsImageImageType>
    link_text: Maybe<Scalars['String']['output']>
    link_url: Maybe<Scalars['String']['output']>
    quote: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataTestimonialsFieldSelector = {
    attribution: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    link_url: InputMaybe<FieldSelectorEnum>
    quote: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataTestimonialsFilterInput = {
    attribution: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    link_url: InputMaybe<StringQueryOperatorInput>
    quote: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnerPageDataTestimonialsFilterInput>
}

export type PrismicPartnerPageDataTestimonialsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataTestimonialsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataTestimonialsSortInput = {
    attribution: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    link_url: InputMaybe<SortOrderEnum>
    quote: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataTiersImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataTiersImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageDataTiersImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnerPageDataTiersImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnerPageDataTiersImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnerPageDataTiersImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataTiersImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataTiersImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageDataType = {
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    features: Maybe<Array<Maybe<PrismicPartnerPageDataFeatures>>>
    features_cta_text: Maybe<Scalars['String']['output']>
    features_title: Maybe<Scalars['String']['output']>
    hero_image: Maybe<PrismicPartnerPageDataHeroImageImageType>
    integrations: Maybe<Array<Maybe<PrismicPartnerPageDataIntegrations>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    notification_message: Maybe<PrismicStructuredTextType>
    offering_body: Maybe<PrismicStructuredTextType>
    offering_image: Maybe<PrismicPartnerPageDataOfferingImageImageType>
    offering_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPartnerPageDataOpenGraphImageImageType>
    partner_logos: Maybe<Array<Maybe<PrismicPartnerPageDataPartnerLogos>>>
    partner_logos_title: Maybe<Scalars['String']['output']>
    partner_programme_title: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    proof_point_badges: Maybe<PrismicLinkType>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    testimonials: Maybe<Array<Maybe<PrismicPartnerPageDataTestimonials>>>
    testimonials_image: Maybe<PrismicPartnerPageDataTestimonialsImageImageType>
    tiers_image: Maybe<PrismicPartnerPageDataTiersImageImageType>
    tiers_subtitle: Maybe<Scalars['String']['output']>
    tiers_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerPageDataTypeFieldSelector = {
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<PrismicPartnerPageDataFeaturesFieldSelector>
    features_cta_text: InputMaybe<FieldSelectorEnum>
    features_title: InputMaybe<FieldSelectorEnum>
    hero_image: InputMaybe<PrismicPartnerPageDataHeroImageImageTypeFieldSelector>
    integrations: InputMaybe<PrismicPartnerPageDataIntegrationsFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    notification_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    offering_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    offering_image: InputMaybe<PrismicPartnerPageDataOfferingImageImageTypeFieldSelector>
    offering_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPartnerPageDataOpenGraphImageImageTypeFieldSelector>
    partner_logos: InputMaybe<PrismicPartnerPageDataPartnerLogosFieldSelector>
    partner_logos_title: InputMaybe<FieldSelectorEnum>
    partner_programme_title: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    testimonials: InputMaybe<PrismicPartnerPageDataTestimonialsFieldSelector>
    testimonials_image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeFieldSelector>
    tiers_image: InputMaybe<PrismicPartnerPageDataTiersImageImageTypeFieldSelector>
    tiers_subtitle: InputMaybe<FieldSelectorEnum>
    tiers_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageDataTypeFilterInput = {
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    features: InputMaybe<PrismicPartnerPageDataFeaturesFilterListInput>
    features_cta_text: InputMaybe<StringQueryOperatorInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    hero_image: InputMaybe<PrismicPartnerPageDataHeroImageImageTypeFilterInput>
    integrations: InputMaybe<PrismicPartnerPageDataIntegrationsFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    notification_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    offering_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    offering_image: InputMaybe<PrismicPartnerPageDataOfferingImageImageTypeFilterInput>
    offering_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPartnerPageDataOpenGraphImageImageTypeFilterInput>
    partner_logos: InputMaybe<PrismicPartnerPageDataPartnerLogosFilterListInput>
    partner_logos_title: InputMaybe<StringQueryOperatorInput>
    partner_programme_title: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    testimonials: InputMaybe<PrismicPartnerPageDataTestimonialsFilterListInput>
    testimonials_image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeFilterInput>
    tiers_image: InputMaybe<PrismicPartnerPageDataTiersImageImageTypeFilterInput>
    tiers_subtitle: InputMaybe<StringQueryOperatorInput>
    tiers_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageDataTypeSortInput = {
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    features: InputMaybe<PrismicPartnerPageDataFeaturesSortInput>
    features_cta_text: InputMaybe<SortOrderEnum>
    features_title: InputMaybe<SortOrderEnum>
    hero_image: InputMaybe<PrismicPartnerPageDataHeroImageImageTypeSortInput>
    integrations: InputMaybe<PrismicPartnerPageDataIntegrationsSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    notification_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    offering_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    offering_image: InputMaybe<PrismicPartnerPageDataOfferingImageImageTypeSortInput>
    offering_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPartnerPageDataOpenGraphImageImageTypeSortInput>
    partner_logos: InputMaybe<PrismicPartnerPageDataPartnerLogosSortInput>
    partner_logos_title: InputMaybe<SortOrderEnum>
    partner_programme_title: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    testimonials: InputMaybe<PrismicPartnerPageDataTestimonialsSortInput>
    testimonials_image: InputMaybe<PrismicPartnerPageDataTestimonialsImageImageTypeSortInput>
    tiers_image: InputMaybe<PrismicPartnerPageDataTiersImageImageTypeSortInput>
    tiers_subtitle: InputMaybe<SortOrderEnum>
    tiers_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerPageEdge = {
    next: Maybe<PrismicPartnerPage>
    node: PrismicPartnerPage
    previous: Maybe<PrismicPartnerPage>
}

export type PrismicPartnerPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnerPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerPageGroupConnectionDistinctArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageGroupConnectionGroupArgs = {
    field: PrismicPartnerPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerPageGroupConnectionMaxArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageGroupConnectionMinArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageGroupConnectionSumArgs = {
    field: PrismicPartnerPageFieldSelector
}

export type PrismicPartnerPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnerPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerSignupBanner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnerSignupBannerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerSignupBannerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerSignupBannerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnerSignupBannerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerSignupBannerEdge>
    group: Array<PrismicPartnerSignupBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerSignupBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerSignupBannerConnectionDistinctArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerConnectionGroupArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerSignupBannerConnectionMaxArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerConnectionMinArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerConnectionSumArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerDataType = {
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnerSignupBannerDataTypeFieldSelector = {
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerSignupBannerDataTypeFilterInput = {
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerSignupBannerDataTypeSortInput = {
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerSignupBannerEdge = {
    next: Maybe<PrismicPartnerSignupBanner>
    node: PrismicPartnerSignupBanner
    previous: Maybe<PrismicPartnerSignupBanner>
}

export type PrismicPartnerSignupBannerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnerSignupBannerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnerSignupBannerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerSignupBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnerSignupBannerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnerSignupBannerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnerSignupBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnerSignupBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnerSignupBannerGroupConnectionDistinctArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerGroupConnectionGroupArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnerSignupBannerGroupConnectionMaxArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerGroupConnectionMinArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerGroupConnectionSumArgs = {
    field: PrismicPartnerSignupBannerFieldSelector
}

export type PrismicPartnerSignupBannerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnerSignupBannerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnersProgrammeTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnersProgrammeTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnersProgrammeTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnersProgrammeTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnersProgrammeTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnersProgrammeTableEdge>
    group: Array<PrismicPartnersProgrammeTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnersProgrammeTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnersProgrammeTableConnectionDistinctArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableConnectionGroupArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnersProgrammeTableConnectionMaxArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableConnectionMinArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableConnectionSumArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableDataRows = {
    bronze: Maybe<Scalars['Boolean']['output']>
    bronze_text: Maybe<Scalars['String']['output']>
    feature: Maybe<Scalars['String']['output']>
    feature_tooltip: Maybe<Scalars['String']['output']>
    gold: Maybe<Scalars['Boolean']['output']>
    gold_text: Maybe<Scalars['String']['output']>
    new_partner: Maybe<Scalars['Boolean']['output']>
    new_partner_text: Maybe<Scalars['String']['output']>
    platinum: Maybe<Scalars['Boolean']['output']>
    platinum_text: Maybe<Scalars['String']['output']>
    silver: Maybe<Scalars['Boolean']['output']>
    silver_text: Maybe<Scalars['String']['output']>
}

export type PrismicPartnersProgrammeTableDataRowsFieldSelector = {
    bronze: InputMaybe<FieldSelectorEnum>
    bronze_text: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    feature_tooltip: InputMaybe<FieldSelectorEnum>
    gold: InputMaybe<FieldSelectorEnum>
    gold_text: InputMaybe<FieldSelectorEnum>
    new_partner: InputMaybe<FieldSelectorEnum>
    new_partner_text: InputMaybe<FieldSelectorEnum>
    platinum: InputMaybe<FieldSelectorEnum>
    platinum_text: InputMaybe<FieldSelectorEnum>
    silver: InputMaybe<FieldSelectorEnum>
    silver_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnersProgrammeTableDataRowsFilterInput = {
    bronze: InputMaybe<BooleanQueryOperatorInput>
    bronze_text: InputMaybe<StringQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    feature_tooltip: InputMaybe<StringQueryOperatorInput>
    gold: InputMaybe<BooleanQueryOperatorInput>
    gold_text: InputMaybe<StringQueryOperatorInput>
    new_partner: InputMaybe<BooleanQueryOperatorInput>
    new_partner_text: InputMaybe<StringQueryOperatorInput>
    platinum: InputMaybe<BooleanQueryOperatorInput>
    platinum_text: InputMaybe<StringQueryOperatorInput>
    silver: InputMaybe<BooleanQueryOperatorInput>
    silver_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnersProgrammeTableDataRowsFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnersProgrammeTableDataRowsFilterInput>
}

export type PrismicPartnersProgrammeTableDataRowsSortInput = {
    bronze: InputMaybe<SortOrderEnum>
    bronze_text: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    feature_tooltip: InputMaybe<SortOrderEnum>
    gold: InputMaybe<SortOrderEnum>
    gold_text: InputMaybe<SortOrderEnum>
    new_partner: InputMaybe<SortOrderEnum>
    new_partner_text: InputMaybe<SortOrderEnum>
    platinum: InputMaybe<SortOrderEnum>
    platinum_text: InputMaybe<SortOrderEnum>
    silver: InputMaybe<SortOrderEnum>
    silver_text: InputMaybe<SortOrderEnum>
}

export type PrismicPartnersProgrammeTableDataType = {
    bronze_heading: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    disclaimer: Maybe<Scalars['String']['output']>
    gold_heading: Maybe<Scalars['String']['output']>
    new_partner_heading: Maybe<Scalars['String']['output']>
    platinum_heading: Maybe<Scalars['String']['output']>
    rows: Maybe<Array<Maybe<PrismicPartnersProgrammeTableDataRows>>>
    silver_heading: Maybe<Scalars['String']['output']>
}

export type PrismicPartnersProgrammeTableDataTypeFieldSelector = {
    bronze_heading: InputMaybe<FieldSelectorEnum>
    category: InputMaybe<FieldSelectorEnum>
    disclaimer: InputMaybe<FieldSelectorEnum>
    gold_heading: InputMaybe<FieldSelectorEnum>
    new_partner_heading: InputMaybe<FieldSelectorEnum>
    platinum_heading: InputMaybe<FieldSelectorEnum>
    rows: InputMaybe<PrismicPartnersProgrammeTableDataRowsFieldSelector>
    silver_heading: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnersProgrammeTableDataTypeFilterInput = {
    bronze_heading: InputMaybe<StringQueryOperatorInput>
    category: InputMaybe<StringQueryOperatorInput>
    disclaimer: InputMaybe<StringQueryOperatorInput>
    gold_heading: InputMaybe<StringQueryOperatorInput>
    new_partner_heading: InputMaybe<StringQueryOperatorInput>
    platinum_heading: InputMaybe<StringQueryOperatorInput>
    rows: InputMaybe<PrismicPartnersProgrammeTableDataRowsFilterListInput>
    silver_heading: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnersProgrammeTableDataTypeSortInput = {
    bronze_heading: InputMaybe<SortOrderEnum>
    category: InputMaybe<SortOrderEnum>
    disclaimer: InputMaybe<SortOrderEnum>
    gold_heading: InputMaybe<SortOrderEnum>
    new_partner_heading: InputMaybe<SortOrderEnum>
    platinum_heading: InputMaybe<SortOrderEnum>
    rows: InputMaybe<PrismicPartnersProgrammeTableDataRowsSortInput>
    silver_heading: InputMaybe<SortOrderEnum>
}

export type PrismicPartnersProgrammeTableEdge = {
    next: Maybe<PrismicPartnersProgrammeTable>
    node: PrismicPartnersProgrammeTable
    previous: Maybe<PrismicPartnersProgrammeTable>
}

export type PrismicPartnersProgrammeTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnersProgrammeTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnersProgrammeTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnersProgrammeTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnersProgrammeTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnersProgrammeTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnersProgrammeTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnersProgrammeTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnersProgrammeTableGroupConnectionDistinctArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableGroupConnectionGroupArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnersProgrammeTableGroupConnectionMaxArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableGroupConnectionMinArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableGroupConnectionSumArgs = {
    field: PrismicPartnersProgrammeTableFieldSelector
}

export type PrismicPartnersProgrammeTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnersProgrammeTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCase = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnershipCaseDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipCaseLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipCaseConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipCaseEdge>
    group: Array<PrismicPartnershipCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipCaseConnectionDistinctArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseConnectionGroupArgs = {
    field: PrismicPartnershipCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseConnectionMaxArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseConnectionMinArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseConnectionSumArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseDataChallengeList = {
    challenge_list_item_body: Maybe<PrismicStructuredTextType>
    challenge_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataChallengeListFieldSelector = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    challenge_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataChallengeListFilterInput = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    challenge_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataChallengeListFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataChallengeListFilterInput>
}

export type PrismicPartnershipCaseDataChallengeListSortInput = {
    challenge_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    challenge_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataDetailsCard = {
    client_size: Maybe<Scalars['String']['output']>
    location: Maybe<Scalars['String']['output']>
    logo: Maybe<PrismicPartnershipCaseDataDetailsCardLogoImageType>
    partner_type: Maybe<Scalars['String']['output']>
    quote: Maybe<Scalars['String']['output']>
    quote_author: Maybe<Scalars['String']['output']>
    quote_author_image: Maybe<PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageType>
}

export type PrismicPartnershipCaseDataDetailsCardFieldSelector = {
    client_size: InputMaybe<FieldSelectorEnum>
    location: InputMaybe<FieldSelectorEnum>
    logo: InputMaybe<PrismicPartnershipCaseDataDetailsCardLogoImageTypeFieldSelector>
    partner_type: InputMaybe<FieldSelectorEnum>
    quote: InputMaybe<FieldSelectorEnum>
    quote_author: InputMaybe<FieldSelectorEnum>
    quote_author_image: InputMaybe<PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFieldSelector>
}

export type PrismicPartnershipCaseDataDetailsCardFilterInput = {
    client_size: InputMaybe<StringQueryOperatorInput>
    location: InputMaybe<StringQueryOperatorInput>
    logo: InputMaybe<PrismicPartnershipCaseDataDetailsCardLogoImageTypeFilterInput>
    partner_type: InputMaybe<StringQueryOperatorInput>
    quote: InputMaybe<StringQueryOperatorInput>
    quote_author: InputMaybe<StringQueryOperatorInput>
    quote_author_image: InputMaybe<PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFilterInput>
}

export type PrismicPartnershipCaseDataDetailsCardFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataDetailsCardFilterInput>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataDetailsCardLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataDetailsCardSortInput = {
    client_size: InputMaybe<SortOrderEnum>
    location: InputMaybe<SortOrderEnum>
    logo: InputMaybe<PrismicPartnershipCaseDataDetailsCardLogoImageTypeSortInput>
    partner_type: InputMaybe<SortOrderEnum>
    quote: InputMaybe<SortOrderEnum>
    quote_author: InputMaybe<SortOrderEnum>
    quote_author_image: InputMaybe<PrismicPartnershipCaseDataDetailsCardQuoteAuthorImageImageTypeSortInput>
}

export type PrismicPartnershipCaseDataHeroSection = {
    image: Maybe<PrismicPartnershipCaseDataHeroSectionImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataHeroSectionFieldSelector = {
    image: InputMaybe<PrismicPartnershipCaseDataHeroSectionImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    wistia_video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataHeroSectionFilterInput = {
    image: InputMaybe<PrismicPartnershipCaseDataHeroSectionImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    wistia_video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataHeroSectionFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataHeroSectionFilterInput>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataHeroSectionImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataHeroSectionSortInput = {
    image: InputMaybe<PrismicPartnershipCaseDataHeroSectionImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    wistia_video_id: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataRelatedCases = {
    body: Maybe<Scalars['String']['output']>
    case_title: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicPartnershipCaseDataRelatedCasesImageImageType>
}

export type PrismicPartnershipCaseDataRelatedCasesFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    case_title: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    image: InputMaybe<PrismicPartnershipCaseDataRelatedCasesImageImageTypeFieldSelector>
}

export type PrismicPartnershipCaseDataRelatedCasesFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    case_title: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    image: InputMaybe<PrismicPartnershipCaseDataRelatedCasesImageImageTypeFilterInput>
}

export type PrismicPartnershipCaseDataRelatedCasesFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataRelatedCasesFilterInput>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataRelatedCasesImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataRelatedCasesSortInput = {
    body: InputMaybe<SortOrderEnum>
    case_title: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    image: InputMaybe<PrismicPartnershipCaseDataRelatedCasesImageImageTypeSortInput>
}

export type PrismicPartnershipCaseDataResultList = {
    result_list_item_body: Maybe<PrismicStructuredTextType>
    result_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataResultListFieldSelector = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    result_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataResultListFilterInput = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    result_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataResultListFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataResultListFilterInput>
}

export type PrismicPartnershipCaseDataResultListSortInput = {
    result_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    result_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataSolutionList = {
    solution_list_item_body: Maybe<PrismicStructuredTextType>
    solution_list_item_title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataSolutionListFieldSelector = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    solution_list_item_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataSolutionListFilterInput = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    solution_list_item_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataSolutionListFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipCaseDataSolutionListFilterInput>
}

export type PrismicPartnershipCaseDataSolutionListSortInput = {
    solution_list_item_body: InputMaybe<PrismicStructuredTextTypeSortInput>
    solution_list_item_title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseDataType = {
    challenge_lead_text: Maybe<PrismicStructuredTextType>
    challenge_list: Maybe<Array<Maybe<PrismicPartnershipCaseDataChallengeList>>>
    challenge_title: Maybe<Scalars['String']['output']>
    details_card: Maybe<Array<Maybe<PrismicPartnershipCaseDataDetailsCard>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    hero_section: Maybe<Array<Maybe<PrismicPartnershipCaseDataHeroSection>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    related_cases: Maybe<Array<Maybe<PrismicPartnershipCaseDataRelatedCases>>>
    related_cases_cta_text: Maybe<Scalars['String']['output']>
    related_cases_title: Maybe<Scalars['String']['output']>
    result_lead_text: Maybe<PrismicStructuredTextType>
    result_list: Maybe<Array<Maybe<PrismicPartnershipCaseDataResultList>>>
    result_title: Maybe<Scalars['String']['output']>
    solution_lead_text: Maybe<PrismicStructuredTextType>
    solution_list: Maybe<Array<Maybe<PrismicPartnershipCaseDataSolutionList>>>
    solution_title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipCaseDataTypeFieldSelector = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    challenge_list: InputMaybe<PrismicPartnershipCaseDataChallengeListFieldSelector>
    challenge_title: InputMaybe<FieldSelectorEnum>
    details_card: InputMaybe<PrismicPartnershipCaseDataDetailsCardFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    hero_section: InputMaybe<PrismicPartnershipCaseDataHeroSectionFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    predefined_signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    related_cases: InputMaybe<PrismicPartnershipCaseDataRelatedCasesFieldSelector>
    related_cases_cta_text: InputMaybe<FieldSelectorEnum>
    related_cases_title: InputMaybe<FieldSelectorEnum>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    result_list: InputMaybe<PrismicPartnershipCaseDataResultListFieldSelector>
    result_title: InputMaybe<FieldSelectorEnum>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    solution_list: InputMaybe<PrismicPartnershipCaseDataSolutionListFieldSelector>
    solution_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseDataTypeFilterInput = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    challenge_list: InputMaybe<PrismicPartnershipCaseDataChallengeListFilterListInput>
    challenge_title: InputMaybe<StringQueryOperatorInput>
    details_card: InputMaybe<PrismicPartnershipCaseDataDetailsCardFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    hero_section: InputMaybe<PrismicPartnershipCaseDataHeroSectionFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    predefined_signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    related_cases: InputMaybe<PrismicPartnershipCaseDataRelatedCasesFilterListInput>
    related_cases_cta_text: InputMaybe<StringQueryOperatorInput>
    related_cases_title: InputMaybe<StringQueryOperatorInput>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    result_list: InputMaybe<PrismicPartnershipCaseDataResultListFilterListInput>
    result_title: InputMaybe<StringQueryOperatorInput>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    solution_list: InputMaybe<PrismicPartnershipCaseDataSolutionListFilterListInput>
    solution_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseDataTypeSortInput = {
    challenge_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    challenge_list: InputMaybe<PrismicPartnershipCaseDataChallengeListSortInput>
    challenge_title: InputMaybe<SortOrderEnum>
    details_card: InputMaybe<PrismicPartnershipCaseDataDetailsCardSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    hero_section: InputMaybe<PrismicPartnershipCaseDataHeroSectionSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    predefined_signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    related_cases: InputMaybe<PrismicPartnershipCaseDataRelatedCasesSortInput>
    related_cases_cta_text: InputMaybe<SortOrderEnum>
    related_cases_title: InputMaybe<SortOrderEnum>
    result_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    result_list: InputMaybe<PrismicPartnershipCaseDataResultListSortInput>
    result_title: InputMaybe<SortOrderEnum>
    solution_lead_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    solution_list: InputMaybe<PrismicPartnershipCaseDataSolutionListSortInput>
    solution_title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipCaseEdge = {
    next: Maybe<PrismicPartnershipCase>
    node: PrismicPartnershipCase
    previous: Maybe<PrismicPartnershipCase>
}

export type PrismicPartnershipCaseFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnershipCaseDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipCaseFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipCaseGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipCaseEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnershipCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipCaseGroupConnectionDistinctArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseGroupConnectionGroupArgs = {
    field: PrismicPartnershipCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipCaseGroupConnectionMaxArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseGroupConnectionMinArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseGroupConnectionSumArgs = {
    field: PrismicPartnershipCaseFieldSelector
}

export type PrismicPartnershipCaseSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnershipCaseDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTier = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnershipTierDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTierFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipTierLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipTierConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipTierEdge>
    group: Array<PrismicPartnershipTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipTierConnectionDistinctArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierConnectionGroupArgs = {
    field: PrismicPartnershipTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTierConnectionMaxArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierConnectionMinArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierConnectionSumArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierDataIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTierDataIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTierDataIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipTierDataIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipTierDataIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipTierDataIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTierDataIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTierDataIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTierDataType = {
    features_list: Maybe<PrismicStructuredTextType>
    features_title: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicPartnershipTierDataIconImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTierDataTypeFieldSelector = {
    features_list: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicPartnershipTierDataIconImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTierDataTypeFilterInput = {
    features_list: InputMaybe<PrismicStructuredTextTypeFilterInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicPartnershipTierDataIconImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTierDataTypeSortInput = {
    features_list: InputMaybe<PrismicStructuredTextTypeSortInput>
    features_title: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicPartnershipTierDataIconImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTierEdge = {
    next: Maybe<PrismicPartnershipTier>
    node: PrismicPartnershipTier
    previous: Maybe<PrismicPartnershipTier>
}

export type PrismicPartnershipTierFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnershipTierDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTierFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTierGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipTierEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnershipTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipTierGroupConnectionDistinctArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierGroupConnectionGroupArgs = {
    field: PrismicPartnershipTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTierGroupConnectionMaxArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierGroupConnectionMinArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierGroupConnectionSumArgs = {
    field: PrismicPartnershipTierFieldSelector
}

export type PrismicPartnershipTierSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnershipTierDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTiers = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPartnershipTiersDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTiersFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipTiersLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPartnershipTiersConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipTiersEdge>
    group: Array<PrismicPartnershipTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipTiersConnectionDistinctArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersConnectionGroupArgs = {
    field: PrismicPartnershipTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTiersConnectionMaxArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersConnectionMinArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersConnectionSumArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersDataPlaceholderImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTiersDataPlaceholderImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTiersDataTiers = {
    tier: Maybe<PrismicLinkType>
}

export type PrismicPartnershipTiersDataTiersFieldSelector = {
    tier: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPartnershipTiersDataTiersFilterInput = {
    tier: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPartnershipTiersDataTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicPartnershipTiersDataTiersFilterInput>
}

export type PrismicPartnershipTiersDataTiersSortInput = {
    tier: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPartnershipTiersDataType = {
    disclaimer: Maybe<Scalars['String']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    placeholder_image: Maybe<PrismicPartnershipTiersDataPlaceholderImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    tiers: Maybe<Array<Maybe<PrismicPartnershipTiersDataTiers>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPartnershipTiersDataTypeFieldSelector = {
    disclaimer: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    placeholder_image: InputMaybe<PrismicPartnershipTiersDataPlaceholderImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    tiers: InputMaybe<PrismicPartnershipTiersDataTiersFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTiersDataTypeFilterInput = {
    disclaimer: InputMaybe<StringQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    placeholder_image: InputMaybe<PrismicPartnershipTiersDataPlaceholderImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    tiers: InputMaybe<PrismicPartnershipTiersDataTiersFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTiersDataTypeSortInput = {
    disclaimer: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    placeholder_image: InputMaybe<PrismicPartnershipTiersDataPlaceholderImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    tiers: InputMaybe<PrismicPartnershipTiersDataTiersSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPartnershipTiersEdge = {
    next: Maybe<PrismicPartnershipTiers>
    node: PrismicPartnershipTiers
    previous: Maybe<PrismicPartnershipTiers>
}

export type PrismicPartnershipTiersFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPartnershipTiersDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPartnershipTiersFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPartnershipTiersGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPartnershipTiersEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPartnershipTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPartnershipTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPartnershipTiersGroupConnectionDistinctArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersGroupConnectionGroupArgs = {
    field: PrismicPartnershipTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPartnershipTiersGroupConnectionMaxArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersGroupConnectionMinArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersGroupConnectionSumArgs = {
    field: PrismicPartnershipTiersFieldSelector
}

export type PrismicPartnershipTiersSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPartnershipTiersDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerk = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPerkDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerkFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPerkLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPerkConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPerkEdge>
    group: Array<PrismicPerkGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPerk>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPerkConnectionDistinctArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkConnectionGroupArgs = {
    field: PrismicPerkFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerkConnectionMaxArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkConnectionMinArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkConnectionSumArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkDataLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerkDataLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerkDataLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPerkDataLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPerkDataLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPerkDataLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerkDataLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerkDataLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerkDataMarkets = {
    danmark: Maybe<Scalars['Boolean']['output']>
    deutschland: Maybe<Scalars['Boolean']['output']>
    espana: Maybe<Scalars['Boolean']['output']>
    ireland: Maybe<Scalars['Boolean']['output']>
    sverige: Maybe<Scalars['Boolean']['output']>
    united_kingdom: Maybe<Scalars['Boolean']['output']>
}

export type PrismicPerkDataMarketsFieldSelector = {
    danmark: InputMaybe<FieldSelectorEnum>
    deutschland: InputMaybe<FieldSelectorEnum>
    espana: InputMaybe<FieldSelectorEnum>
    ireland: InputMaybe<FieldSelectorEnum>
    sverige: InputMaybe<FieldSelectorEnum>
    united_kingdom: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerkDataMarketsFilterInput = {
    danmark: InputMaybe<BooleanQueryOperatorInput>
    deutschland: InputMaybe<BooleanQueryOperatorInput>
    espana: InputMaybe<BooleanQueryOperatorInput>
    ireland: InputMaybe<BooleanQueryOperatorInput>
    sverige: InputMaybe<BooleanQueryOperatorInput>
    united_kingdom: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicPerkDataMarketsFilterListInput = {
    elemMatch: InputMaybe<PrismicPerkDataMarketsFilterInput>
}

export type PrismicPerkDataMarketsSortInput = {
    danmark: InputMaybe<SortOrderEnum>
    deutschland: InputMaybe<SortOrderEnum>
    espana: InputMaybe<SortOrderEnum>
    ireland: InputMaybe<SortOrderEnum>
    sverige: InputMaybe<SortOrderEnum>
    united_kingdom: InputMaybe<SortOrderEnum>
}

export type PrismicPerkDataType = {
    company_name: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    logo: Maybe<PrismicPerkDataLogoImageType>
    markets: Maybe<Array<Maybe<PrismicPerkDataMarkets>>>
    perk_details: Maybe<Scalars['String']['output']>
}

export type PrismicPerkDataTypeFieldSelector = {
    company_name: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    logo: InputMaybe<PrismicPerkDataLogoImageTypeFieldSelector>
    markets: InputMaybe<PrismicPerkDataMarketsFieldSelector>
    perk_details: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerkDataTypeFilterInput = {
    company_name: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    logo: InputMaybe<PrismicPerkDataLogoImageTypeFilterInput>
    markets: InputMaybe<PrismicPerkDataMarketsFilterListInput>
    perk_details: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerkDataTypeSortInput = {
    company_name: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    logo: InputMaybe<PrismicPerkDataLogoImageTypeSortInput>
    markets: InputMaybe<PrismicPerkDataMarketsSortInput>
    perk_details: InputMaybe<SortOrderEnum>
}

export type PrismicPerkEdge = {
    next: Maybe<PrismicPerk>
    node: PrismicPerk
    previous: Maybe<PrismicPerk>
}

export type PrismicPerkFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPerkDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerkFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPerkDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerkGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPerkEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPerkGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPerk>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPerkGroupConnectionDistinctArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkGroupConnectionGroupArgs = {
    field: PrismicPerkFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerkGroupConnectionMaxArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkGroupConnectionMinArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkGroupConnectionSumArgs = {
    field: PrismicPerkFieldSelector
}

export type PrismicPerkSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPerkDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPerksInternalPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPerksInternalPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPerksInternalPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPerksInternalPageEdge>
    group: Array<PrismicPerksInternalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPerksInternalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPerksInternalPageConnectionDistinctArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageConnectionGroupArgs = {
    field: PrismicPerksInternalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageConnectionMaxArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageConnectionMinArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageConnectionSumArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPerksInternalPageDataFeatureBlocksImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksFilterInput>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPerksInternalPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPerksInternalPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPerksInternalPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicPerksInternalPageDataHeroFilterInput>
}

export type PrismicPerksInternalPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPerksInternalPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataPerks = {
    perk: Maybe<PrismicLinkType>
}

export type PrismicPerksInternalPageDataPerksFieldSelector = {
    perk: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPerksInternalPageDataPerksFilterInput = {
    perk: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPerksInternalPageDataPerksFilterListInput = {
    elemMatch: InputMaybe<PrismicPerksInternalPageDataPerksFilterInput>
}

export type PrismicPerksInternalPageDataPerksPartner = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPerksInternalPageDataPerksPartnerImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataPerksPartnerFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPerksInternalPageDataPerksPartnerImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataPerksPartnerFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPerksInternalPageDataPerksPartnerImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataPerksPartnerFilterListInput = {
    elemMatch: InputMaybe<PrismicPerksInternalPageDataPerksPartnerFilterInput>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataPerksPartnerImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataPerksPartnerSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPerksInternalPageDataPerksPartnerImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataPerksSortInput = {
    perk: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPerksInternalPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicPerksInternalPageDataQuestionsAnswersFilterInput>
}

export type PrismicPerksInternalPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageDataType = {
    all_markets_option_text: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks: Maybe<Array<Maybe<PrismicPerksInternalPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicPerksInternalPageDataHero>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPerksInternalPageDataOpenGraphImageImageType>
    perk_card_cta_text: Maybe<Scalars['String']['output']>
    perks: Maybe<Array<Maybe<PrismicPerksInternalPageDataPerks>>>
    perks_partner: Maybe<Array<Maybe<PrismicPerksInternalPageDataPerksPartner>>>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicPerksInternalPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    show_more_perks_text: Maybe<Scalars['String']['output']>
}

export type PrismicPerksInternalPageDataTypeFieldSelector = {
    all_markets_option_text: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicPerksInternalPageDataHeroFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPerksInternalPageDataOpenGraphImageImageTypeFieldSelector>
    perk_card_cta_text: InputMaybe<FieldSelectorEnum>
    perks: InputMaybe<PrismicPerksInternalPageDataPerksFieldSelector>
    perks_partner: InputMaybe<PrismicPerksInternalPageDataPerksPartnerFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicPerksInternalPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    show_more_perks_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageDataTypeFilterInput = {
    all_markets_option_text: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicPerksInternalPageDataHeroFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPerksInternalPageDataOpenGraphImageImageTypeFilterInput>
    perk_card_cta_text: InputMaybe<StringQueryOperatorInput>
    perks: InputMaybe<PrismicPerksInternalPageDataPerksFilterListInput>
    perks_partner: InputMaybe<PrismicPerksInternalPageDataPerksPartnerFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicPerksInternalPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    show_more_perks_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageDataTypeSortInput = {
    all_markets_option_text: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks: InputMaybe<PrismicPerksInternalPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicPerksInternalPageDataHeroSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPerksInternalPageDataOpenGraphImageImageTypeSortInput>
    perk_card_cta_text: InputMaybe<SortOrderEnum>
    perks: InputMaybe<PrismicPerksInternalPageDataPerksSortInput>
    perks_partner: InputMaybe<PrismicPerksInternalPageDataPerksPartnerSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicPerksInternalPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    show_more_perks_text: InputMaybe<SortOrderEnum>
}

export type PrismicPerksInternalPageEdge = {
    next: Maybe<PrismicPerksInternalPage>
    node: PrismicPerksInternalPage
    previous: Maybe<PrismicPerksInternalPage>
}

export type PrismicPerksInternalPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPerksInternalPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPerksInternalPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPerksInternalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPerksInternalPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPerksInternalPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPerksInternalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPerksInternalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPerksInternalPageGroupConnectionDistinctArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageGroupConnectionGroupArgs = {
    field: PrismicPerksInternalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPerksInternalPageGroupConnectionMaxArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageGroupConnectionMinArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageGroupConnectionSumArgs = {
    field: PrismicPerksInternalPageFieldSelector
}

export type PrismicPerksInternalPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPerksInternalPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPleoEvent = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPleoEventDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPleoEventFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPleoEventLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPleoEventConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPleoEventEdge>
    group: Array<PrismicPleoEventGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPleoEvent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPleoEventConnectionDistinctArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventConnectionGroupArgs = {
    field: PrismicPleoEventFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPleoEventConnectionMaxArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventConnectionMinArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventConnectionSumArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPleoEventDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPleoEventDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPleoEventDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPleoEventDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPleoEventDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoEventDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoEventDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPleoEventDataType = {
    datetime: Maybe<Scalars['Date']['output']>
    description: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    event_type: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPleoEventDataImageImageType>
    language: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    location: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPleoEventDataTypeDatetimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPleoEventDataTypeFieldSelector = {
    datetime: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    duration: InputMaybe<FieldSelectorEnum>
    event_type: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPleoEventDataImageImageTypeFieldSelector>
    language: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    location: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoEventDataTypeFilterInput = {
    datetime: InputMaybe<DateQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    duration: InputMaybe<StringQueryOperatorInput>
    event_type: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPleoEventDataImageImageTypeFilterInput>
    language: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    location: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoEventDataTypeSortInput = {
    datetime: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    duration: InputMaybe<SortOrderEnum>
    event_type: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPleoEventDataImageImageTypeSortInput>
    language: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    location: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPleoEventEdge = {
    next: Maybe<PrismicPleoEvent>
    node: PrismicPleoEvent
    previous: Maybe<PrismicPleoEvent>
}

export type PrismicPleoEventFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPleoEventDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoEventFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPleoEventDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoEventGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPleoEventEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPleoEventGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPleoEvent>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPleoEventGroupConnectionDistinctArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventGroupConnectionGroupArgs = {
    field: PrismicPleoEventFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPleoEventGroupConnectionMaxArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventGroupConnectionMinArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventGroupConnectionSumArgs = {
    field: PrismicPleoEventFieldSelector
}

export type PrismicPleoEventSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPleoEventDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPleoPartnerTier = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPleoPartnerTierDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPleoPartnerTierFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPleoPartnerTierLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPleoPartnerTierConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPleoPartnerTierEdge>
    group: Array<PrismicPleoPartnerTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPleoPartnerTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPleoPartnerTierConnectionDistinctArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierConnectionGroupArgs = {
    field: PrismicPleoPartnerTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPleoPartnerTierConnectionMaxArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierConnectionMinArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierConnectionSumArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierDataFeatures = {
    feature: Maybe<Scalars['String']['output']>
}

export type PrismicPleoPartnerTierDataFeaturesFieldSelector = {
    feature: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoPartnerTierDataFeaturesFilterInput = {
    feature: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoPartnerTierDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPleoPartnerTierDataFeaturesFilterInput>
}

export type PrismicPleoPartnerTierDataFeaturesSortInput = {
    feature: InputMaybe<SortOrderEnum>
}

export type PrismicPleoPartnerTierDataType = {
    clients_text: Maybe<Scalars['String']['output']>
    features: Maybe<Array<Maybe<PrismicPleoPartnerTierDataFeatures>>>
    features_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPleoPartnerTierDataTypeFieldSelector = {
    clients_text: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<PrismicPleoPartnerTierDataFeaturesFieldSelector>
    features_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoPartnerTierDataTypeFilterInput = {
    clients_text: InputMaybe<StringQueryOperatorInput>
    features: InputMaybe<PrismicPleoPartnerTierDataFeaturesFilterListInput>
    features_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoPartnerTierDataTypeSortInput = {
    clients_text: InputMaybe<SortOrderEnum>
    features: InputMaybe<PrismicPleoPartnerTierDataFeaturesSortInput>
    features_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPleoPartnerTierEdge = {
    next: Maybe<PrismicPleoPartnerTier>
    node: PrismicPleoPartnerTier
    previous: Maybe<PrismicPleoPartnerTier>
}

export type PrismicPleoPartnerTierFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPleoPartnerTierDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPleoPartnerTierFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPleoPartnerTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPleoPartnerTierGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPleoPartnerTierEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPleoPartnerTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPleoPartnerTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPleoPartnerTierGroupConnectionDistinctArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierGroupConnectionGroupArgs = {
    field: PrismicPleoPartnerTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPleoPartnerTierGroupConnectionMaxArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierGroupConnectionMinArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierGroupConnectionSumArgs = {
    field: PrismicPleoPartnerTierFieldSelector
}

export type PrismicPleoPartnerTierSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPleoPartnerTierDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPocketPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPocketPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPocketPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPocketPageEdge>
    group: Array<PrismicPocketPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPocketPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPocketPageConnectionDistinctArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageConnectionGroupArgs = {
    field: PrismicPocketPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageConnectionMaxArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageConnectionMinArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageConnectionSumArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageDataFacts = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPocketPageDataFactsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataFactsFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPocketPageDataFactsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataFactsFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPocketPageDataFactsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataFactsFilterListInput = {
    elemMatch: InputMaybe<PrismicPocketPageDataFactsFilterInput>
}

export type PrismicPocketPageDataFactsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataFactsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageDataFactsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPocketPageDataFactsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPocketPageDataFactsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPocketPageDataFactsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataFactsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataFactsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataFactsSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPocketPageDataFactsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPocketPageDataFeatureBlocksImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicPocketPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPocketPageDataFeatureBlocksImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPocketPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPocketPageDataFeatureBlocksImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPocketPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicPocketPageDataFeatureBlocksFilterInput>
}

export type PrismicPocketPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPocketPageDataFeatureBlocksImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPocketPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPocketPageDataHeroImageImageType>
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPocketPageDataHeroImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPocketPageDataHeroImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicPocketPageDataHeroFilterInput>
}

export type PrismicPocketPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPocketPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPocketPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPocketPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPocketPageDataHeroImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPocketPageDataTestimonials = {
    testimonial: Maybe<PrismicLinkType>
}

export type PrismicPocketPageDataTestimonialsFieldSelector = {
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPocketPageDataTestimonialsFilterInput = {
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPocketPageDataTestimonialsFilterListInput = {
    elemMatch: InputMaybe<PrismicPocketPageDataTestimonialsFilterInput>
}

export type PrismicPocketPageDataTestimonialsSortInput = {
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPocketPageDataType = {
    facts: Maybe<Array<Maybe<PrismicPocketPageDataFacts>>>
    feature_blocks: Maybe<Array<Maybe<PrismicPocketPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicPocketPageDataHero>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPocketPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    testimonials: Maybe<Array<Maybe<PrismicPocketPageDataTestimonials>>>
}

export type PrismicPocketPageDataTypeFieldSelector = {
    facts: InputMaybe<PrismicPocketPageDataFactsFieldSelector>
    feature_blocks: InputMaybe<PrismicPocketPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicPocketPageDataHeroFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPocketPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    testimonials: InputMaybe<PrismicPocketPageDataTestimonialsFieldSelector>
}

export type PrismicPocketPageDataTypeFilterInput = {
    facts: InputMaybe<PrismicPocketPageDataFactsFilterListInput>
    feature_blocks: InputMaybe<PrismicPocketPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicPocketPageDataHeroFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPocketPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    testimonials: InputMaybe<PrismicPocketPageDataTestimonialsFilterListInput>
}

export type PrismicPocketPageDataTypeSortInput = {
    facts: InputMaybe<PrismicPocketPageDataFactsSortInput>
    feature_blocks: InputMaybe<PrismicPocketPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicPocketPageDataHeroSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPocketPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    testimonials: InputMaybe<PrismicPocketPageDataTestimonialsSortInput>
}

export type PrismicPocketPageEdge = {
    next: Maybe<PrismicPocketPage>
    node: PrismicPocketPage
    previous: Maybe<PrismicPocketPage>
}

export type PrismicPocketPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPocketPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPocketPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPocketPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPocketPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPocketPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPocketPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPocketPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPocketPageGroupConnectionDistinctArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageGroupConnectionGroupArgs = {
    field: PrismicPocketPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPocketPageGroupConnectionMaxArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageGroupConnectionMinArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageGroupConnectionSumArgs = {
    field: PrismicPocketPageFieldSelector
}

export type PrismicPocketPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPocketPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPodcastFormPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPodcastFormPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPodcastFormPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPodcastFormPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPodcastFormPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPodcastFormPageEdge>
    group: Array<PrismicPodcastFormPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPodcastFormPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPodcastFormPageConnectionDistinctArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageConnectionGroupArgs = {
    field: PrismicPodcastFormPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPodcastFormPageConnectionMaxArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageConnectionMinArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageConnectionSumArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageDataHubspotProperties = {
    campaign: Maybe<Scalars['String']['output']>
}

export type PrismicPodcastFormPageDataHubspotPropertiesFieldSelector = {
    campaign: InputMaybe<FieldSelectorEnum>
}

export type PrismicPodcastFormPageDataHubspotPropertiesFilterInput = {
    campaign: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPodcastFormPageDataHubspotPropertiesFilterListInput = {
    elemMatch: InputMaybe<PrismicPodcastFormPageDataHubspotPropertiesFilterInput>
}

export type PrismicPodcastFormPageDataHubspotPropertiesSortInput = {
    campaign: InputMaybe<SortOrderEnum>
}

export type PrismicPodcastFormPageDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPodcastFormPageDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPodcastFormPageDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPodcastFormPageDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPodcastFormPageDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPodcastFormPageDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPodcastFormPageDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPodcastFormPageDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPodcastFormPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPodcastFormPageDataType = {
    confirmation_page: Maybe<PrismicLinkType>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_title: Maybe<Scalars['String']['output']>
    hubspot_properties: Maybe<Array<Maybe<PrismicPodcastFormPageDataHubspotProperties>>>
    image: Maybe<PrismicPodcastFormPageDataImageImageType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPodcastFormPageDataOpenGraphImageImageType>
}

export type PrismicPodcastFormPageDataTypeFieldSelector = {
    confirmation_page: InputMaybe<PrismicLinkTypeFieldSelector>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    hubspot_properties: InputMaybe<PrismicPodcastFormPageDataHubspotPropertiesFieldSelector>
    image: InputMaybe<PrismicPodcastFormPageDataImageImageTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPodcastFormPageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicPodcastFormPageDataTypeFilterInput = {
    confirmation_page: InputMaybe<PrismicLinkTypeFilterInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    hubspot_properties: InputMaybe<PrismicPodcastFormPageDataHubspotPropertiesFilterListInput>
    image: InputMaybe<PrismicPodcastFormPageDataImageImageTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPodcastFormPageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicPodcastFormPageDataTypeSortInput = {
    confirmation_page: InputMaybe<PrismicLinkTypeSortInput>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    hubspot_properties: InputMaybe<PrismicPodcastFormPageDataHubspotPropertiesSortInput>
    image: InputMaybe<PrismicPodcastFormPageDataImageImageTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPodcastFormPageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicPodcastFormPageEdge = {
    next: Maybe<PrismicPodcastFormPage>
    node: PrismicPodcastFormPage
    previous: Maybe<PrismicPodcastFormPage>
}

export type PrismicPodcastFormPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPodcastFormPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPodcastFormPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPodcastFormPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPodcastFormPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPodcastFormPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPodcastFormPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPodcastFormPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPodcastFormPageGroupConnectionDistinctArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageGroupConnectionGroupArgs = {
    field: PrismicPodcastFormPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPodcastFormPageGroupConnectionMaxArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageGroupConnectionMinArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageGroupConnectionSumArgs = {
    field: PrismicPodcastFormPageFieldSelector
}

export type PrismicPodcastFormPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPodcastFormPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPreLaunchFormPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPreLaunchFormPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPreLaunchFormPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPreLaunchFormPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPreLaunchFormPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPreLaunchFormPageEdge>
    group: Array<PrismicPreLaunchFormPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPreLaunchFormPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPreLaunchFormPageConnectionDistinctArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageConnectionGroupArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPreLaunchFormPageConnectionMaxArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageConnectionMinArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageConnectionSumArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageDataHubspotProperties = {
    campaign: Maybe<Scalars['String']['output']>
}

export type PrismicPreLaunchFormPageDataHubspotPropertiesFieldSelector = {
    campaign: InputMaybe<FieldSelectorEnum>
}

export type PrismicPreLaunchFormPageDataHubspotPropertiesFilterInput = {
    campaign: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPreLaunchFormPageDataHubspotPropertiesFilterListInput = {
    elemMatch: InputMaybe<PrismicPreLaunchFormPageDataHubspotPropertiesFilterInput>
}

export type PrismicPreLaunchFormPageDataHubspotPropertiesSortInput = {
    campaign: InputMaybe<SortOrderEnum>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPreLaunchFormPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPreLaunchFormPageDataType = {
    confirmation_page: Maybe<PrismicLinkType>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_title: Maybe<Scalars['String']['output']>
    hubspot_properties: Maybe<Array<Maybe<PrismicPreLaunchFormPageDataHubspotProperties>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPreLaunchFormPageDataOpenGraphImageImageType>
    submit_text: Maybe<Scalars['String']['output']>
}

export type PrismicPreLaunchFormPageDataTypeFieldSelector = {
    confirmation_page: InputMaybe<PrismicLinkTypeFieldSelector>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    hubspot_properties: InputMaybe<PrismicPreLaunchFormPageDataHubspotPropertiesFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicPreLaunchFormPageDataTypeFilterInput = {
    confirmation_page: InputMaybe<PrismicLinkTypeFilterInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    hubspot_properties: InputMaybe<PrismicPreLaunchFormPageDataHubspotPropertiesFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPreLaunchFormPageDataOpenGraphImageImageTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPreLaunchFormPageDataTypeSortInput = {
    confirmation_page: InputMaybe<PrismicLinkTypeSortInput>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    hubspot_properties: InputMaybe<PrismicPreLaunchFormPageDataHubspotPropertiesSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPreLaunchFormPageDataOpenGraphImageImageTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
}

export type PrismicPreLaunchFormPageEdge = {
    next: Maybe<PrismicPreLaunchFormPage>
    node: PrismicPreLaunchFormPage
    previous: Maybe<PrismicPreLaunchFormPage>
}

export type PrismicPreLaunchFormPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPreLaunchFormPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPreLaunchFormPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPreLaunchFormPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPreLaunchFormPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPreLaunchFormPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPreLaunchFormPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPreLaunchFormPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPreLaunchFormPageGroupConnectionDistinctArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageGroupConnectionGroupArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPreLaunchFormPageGroupConnectionMaxArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageGroupConnectionMinArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageGroupConnectionSumArgs = {
    field: PrismicPreLaunchFormPageFieldSelector
}

export type PrismicPreLaunchFormPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPreLaunchFormPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingComparisonTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingComparisonTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingComparisonTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingComparisonTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingComparisonTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingComparisonTableEdge>
    group: Array<PrismicPricingComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingComparisonTableConnectionDistinctArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableConnectionGroupArgs = {
    field: PrismicPricingComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingComparisonTableConnectionMaxArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableConnectionMinArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableConnectionSumArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableDataFeatures = {
    advanced1: Maybe<Scalars['Boolean']['output']>
    advanced_excerpt: Maybe<Scalars['String']['output']>
    beyond1: Maybe<Scalars['Boolean']['output']>
    beyond_excerpt: Maybe<Scalars['String']['output']>
    essential1: Maybe<Scalars['Boolean']['output']>
    essential_excerpt: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    starter1: Maybe<Scalars['Boolean']['output']>
    starter_excerpt: Maybe<Scalars['String']['output']>
    tooltip_description: Maybe<Scalars['String']['output']>
}

export type PrismicPricingComparisonTableDataFeaturesFieldSelector = {
    advanced1: InputMaybe<FieldSelectorEnum>
    advanced_excerpt: InputMaybe<FieldSelectorEnum>
    beyond1: InputMaybe<FieldSelectorEnum>
    beyond_excerpt: InputMaybe<FieldSelectorEnum>
    essential1: InputMaybe<FieldSelectorEnum>
    essential_excerpt: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    starter1: InputMaybe<FieldSelectorEnum>
    starter_excerpt: InputMaybe<FieldSelectorEnum>
    tooltip_description: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingComparisonTableDataFeaturesFilterInput = {
    advanced1: InputMaybe<BooleanQueryOperatorInput>
    advanced_excerpt: InputMaybe<StringQueryOperatorInput>
    beyond1: InputMaybe<BooleanQueryOperatorInput>
    beyond_excerpt: InputMaybe<StringQueryOperatorInput>
    essential1: InputMaybe<BooleanQueryOperatorInput>
    essential_excerpt: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    starter1: InputMaybe<BooleanQueryOperatorInput>
    starter_excerpt: InputMaybe<StringQueryOperatorInput>
    tooltip_description: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingComparisonTableDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingComparisonTableDataFeaturesFilterInput>
}

export type PrismicPricingComparisonTableDataFeaturesSortInput = {
    advanced1: InputMaybe<SortOrderEnum>
    advanced_excerpt: InputMaybe<SortOrderEnum>
    beyond1: InputMaybe<SortOrderEnum>
    beyond_excerpt: InputMaybe<SortOrderEnum>
    essential1: InputMaybe<SortOrderEnum>
    essential_excerpt: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    starter1: InputMaybe<SortOrderEnum>
    starter_excerpt: InputMaybe<SortOrderEnum>
    tooltip_description: InputMaybe<SortOrderEnum>
}

export type PrismicPricingComparisonTableDataType = {
    features: Maybe<Array<Maybe<PrismicPricingComparisonTableDataFeatures>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingComparisonTableDataTypeFieldSelector = {
    features: InputMaybe<PrismicPricingComparisonTableDataFeaturesFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingComparisonTableDataTypeFilterInput = {
    features: InputMaybe<PrismicPricingComparisonTableDataFeaturesFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingComparisonTableDataTypeSortInput = {
    features: InputMaybe<PrismicPricingComparisonTableDataFeaturesSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingComparisonTableEdge = {
    next: Maybe<PrismicPricingComparisonTable>
    node: PrismicPricingComparisonTable
    previous: Maybe<PrismicPricingComparisonTable>
}

export type PrismicPricingComparisonTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingComparisonTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingComparisonTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingComparisonTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingComparisonTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingComparisonTableGroupConnectionDistinctArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableGroupConnectionGroupArgs = {
    field: PrismicPricingComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingComparisonTableGroupConnectionMaxArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableGroupConnectionMinArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableGroupConnectionSumArgs = {
    field: PrismicPricingComparisonTableFieldSelector
}

export type PrismicPricingComparisonTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingComparisonTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPageEdge>
    group: Array<PrismicPricingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPageConnectionDistinctArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageConnectionGroupArgs = {
    field: PrismicPricingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageConnectionMaxArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageConnectionMinArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageConnectionSumArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageDataComparisonLayover = {
    advanced_description: Maybe<Scalars['String']['output']>
    beyond_description: Maybe<Scalars['String']['output']>
    essential_description: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    starter_description: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataComparisonLayoverFieldSelector = {
    advanced_description: InputMaybe<FieldSelectorEnum>
    beyond_description: InputMaybe<FieldSelectorEnum>
    essential_description: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    starter_description: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataComparisonLayoverFilterInput = {
    advanced_description: InputMaybe<StringQueryOperatorInput>
    beyond_description: InputMaybe<StringQueryOperatorInput>
    essential_description: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    starter_description: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataComparisonLayoverFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageDataComparisonLayoverFilterInput>
}

export type PrismicPricingPageDataComparisonLayoverSortInput = {
    advanced_description: InputMaybe<SortOrderEnum>
    beyond_description: InputMaybe<SortOrderEnum>
    essential_description: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    starter_description: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataComparisonTables = {
    comparison_table: Maybe<PrismicLinkType>
}

export type PrismicPricingPageDataComparisonTablesFieldSelector = {
    comparison_table: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingPageDataComparisonTablesFilterInput = {
    comparison_table: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingPageDataComparisonTablesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageDataComparisonTablesFilterInput>
}

export type PrismicPricingPageDataComparisonTablesSortInput = {
    comparison_table: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingPageDataFeatureBlock = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPricingPageDataFeatureBlockImageImageType>
}

export type PrismicPricingPageDataFeatureBlockFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPricingPageDataFeatureBlockImageImageTypeFieldSelector>
}

export type PrismicPricingPageDataFeatureBlockFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPricingPageDataFeatureBlockImageImageTypeFilterInput>
}

export type PrismicPricingPageDataFeatureBlockFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageDataFeatureBlockFilterInput>
}

export type PrismicPricingPageDataFeatureBlockImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataFeatureBlockImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataFeatureBlockSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPricingPageDataFeatureBlockImageImageTypeSortInput>
}

export type PrismicPricingPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageDataQuestionsAnswersFilterInput>
}

export type PrismicPricingPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataTableTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataTableTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageDataTableTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageDataTableTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageDataTableTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageDataTableTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataTableTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataTableTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataType = {
    comparison_layover: Maybe<Array<Maybe<PrismicPricingPageDataComparisonLayover>>>
    comparison_tables: Maybe<Array<Maybe<PrismicPricingPageDataComparisonTables>>>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_block: Maybe<Array<Maybe<PrismicPricingPageDataFeatureBlock>>>
    is_v2: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPricingPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicPricingPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    show_tooltips: Maybe<Scalars['Boolean']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    table_title_image: Maybe<PrismicPricingPageDataTableTitleImageImageType>
    tables_fine_print: Maybe<Scalars['String']['output']>
    tables_tick_screen_reader_alt: Maybe<Scalars['String']['output']>
    tables_title: Maybe<Scalars['String']['output']>
    testimonial: Maybe<PrismicLinkType>
    title: Maybe<PrismicStructuredTextType>
    title1: Maybe<PrismicStructuredTextType>
    title_image: Maybe<PrismicPricingPageDataTitleImageImageType>
    why_pleo: Maybe<Array<Maybe<PrismicPricingPageDataWhyPleo>>>
}

export type PrismicPricingPageDataTypeFieldSelector = {
    comparison_layover: InputMaybe<PrismicPricingPageDataComparisonLayoverFieldSelector>
    comparison_tables: InputMaybe<PrismicPricingPageDataComparisonTablesFieldSelector>
    exclude_production: InputMaybe<FieldSelectorEnum>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_block: InputMaybe<PrismicPricingPageDataFeatureBlockFieldSelector>
    is_v2: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPricingPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicPricingPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    show_tooltips: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    table_title_image: InputMaybe<PrismicPricingPageDataTableTitleImageImageTypeFieldSelector>
    tables_fine_print: InputMaybe<FieldSelectorEnum>
    tables_tick_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    tables_title: InputMaybe<FieldSelectorEnum>
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title1: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title_image: InputMaybe<PrismicPricingPageDataTitleImageImageTypeFieldSelector>
    why_pleo: InputMaybe<PrismicPricingPageDataWhyPleoFieldSelector>
}

export type PrismicPricingPageDataTypeFilterInput = {
    comparison_layover: InputMaybe<PrismicPricingPageDataComparisonLayoverFilterListInput>
    comparison_tables: InputMaybe<PrismicPricingPageDataComparisonTablesFilterListInput>
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_block: InputMaybe<PrismicPricingPageDataFeatureBlockFilterListInput>
    is_v2: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPricingPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicPricingPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    show_tooltips: InputMaybe<BooleanQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    table_title_image: InputMaybe<PrismicPricingPageDataTableTitleImageImageTypeFilterInput>
    tables_fine_print: InputMaybe<StringQueryOperatorInput>
    tables_tick_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    tables_title: InputMaybe<StringQueryOperatorInput>
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title1: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title_image: InputMaybe<PrismicPricingPageDataTitleImageImageTypeFilterInput>
    why_pleo: InputMaybe<PrismicPricingPageDataWhyPleoFilterListInput>
}

export type PrismicPricingPageDataTypeSortInput = {
    comparison_layover: InputMaybe<PrismicPricingPageDataComparisonLayoverSortInput>
    comparison_tables: InputMaybe<PrismicPricingPageDataComparisonTablesSortInput>
    exclude_production: InputMaybe<SortOrderEnum>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_block: InputMaybe<PrismicPricingPageDataFeatureBlockSortInput>
    is_v2: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPricingPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicPricingPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    show_tooltips: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    table_title_image: InputMaybe<PrismicPricingPageDataTableTitleImageImageTypeSortInput>
    tables_fine_print: InputMaybe<SortOrderEnum>
    tables_tick_screen_reader_alt: InputMaybe<SortOrderEnum>
    tables_title: InputMaybe<SortOrderEnum>
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
    title1: InputMaybe<PrismicStructuredTextTypeSortInput>
    title_image: InputMaybe<PrismicPricingPageDataTitleImageImageTypeSortInput>
    why_pleo: InputMaybe<PrismicPricingPageDataWhyPleoSortInput>
}

export type PrismicPricingPageDataWhyPleo = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPricingPageDataWhyPleoImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataWhyPleoFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPricingPageDataWhyPleoImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataWhyPleoFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPricingPageDataWhyPleoImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataWhyPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageDataWhyPleoFilterInput>
}

export type PrismicPricingPageDataWhyPleoImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageDataWhyPleoImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageDataWhyPleoSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPricingPageDataWhyPleoImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageEdge = {
    next: Maybe<PrismicPricingPage>
    node: PrismicPricingPage
    previous: Maybe<PrismicPricingPage>
}

export type PrismicPricingPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPageGroupConnectionDistinctArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageGroupConnectionGroupArgs = {
    field: PrismicPricingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageGroupConnectionMaxArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageGroupConnectionMinArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageGroupConnectionSumArgs = {
    field: PrismicPricingPageFieldSelector
}

export type PrismicPricingPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingPageV2DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPageV2Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPageV2Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPageV2Edge>
    group: Array<PrismicPricingPageV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPageV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPageV2ConnectionDistinctArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2ConnectionGroupArgs = {
    field: PrismicPricingPageV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageV2ConnectionMaxArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2ConnectionMinArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2ConnectionSumArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2DataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2DataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2DataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2DataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2DataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2DataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageV2DataQuestionsAnswersFilterInput>
}

export type PrismicPricingPageV2DataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2DataTables = {
    table: Maybe<PrismicLinkType>
}

export type PrismicPricingPageV2DataTablesFieldSelector = {
    table: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingPageV2DataTablesFilterInput = {
    table: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingPageV2DataTablesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageV2DataTablesFilterInput>
}

export type PrismicPricingPageV2DataTablesSortInput = {
    table: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingPageV2DataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2DataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageV2DataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageV2DataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageV2DataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageV2DataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2DataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2DataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2DataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPricingPageV2DataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicPricingPageV2DataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    tables: Maybe<Array<Maybe<PrismicPricingPageV2DataTables>>>
    tables_tick_screen_reader_alt: Maybe<Scalars['String']['output']>
    tables_title: Maybe<Scalars['String']['output']>
    testimonial: Maybe<PrismicLinkType>
    title: Maybe<PrismicStructuredTextType>
    title1: Maybe<PrismicStructuredTextType>
    title_image: Maybe<PrismicPricingPageV2DataTitleImageImageType>
    why_pleo: Maybe<Array<Maybe<PrismicPricingPageV2DataWhyPleo>>>
}

export type PrismicPricingPageV2DataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPricingPageV2DataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicPricingPageV2DataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    tables: InputMaybe<PrismicPricingPageV2DataTablesFieldSelector>
    tables_tick_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    tables_title: InputMaybe<FieldSelectorEnum>
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title1: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title_image: InputMaybe<PrismicPricingPageV2DataTitleImageImageTypeFieldSelector>
    why_pleo: InputMaybe<PrismicPricingPageV2DataWhyPleoFieldSelector>
}

export type PrismicPricingPageV2DataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPricingPageV2DataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicPricingPageV2DataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    tables: InputMaybe<PrismicPricingPageV2DataTablesFilterListInput>
    tables_tick_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    tables_title: InputMaybe<StringQueryOperatorInput>
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title1: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title_image: InputMaybe<PrismicPricingPageV2DataTitleImageImageTypeFilterInput>
    why_pleo: InputMaybe<PrismicPricingPageV2DataWhyPleoFilterListInput>
}

export type PrismicPricingPageV2DataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPricingPageV2DataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicPricingPageV2DataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    tables: InputMaybe<PrismicPricingPageV2DataTablesSortInput>
    tables_tick_screen_reader_alt: InputMaybe<SortOrderEnum>
    tables_title: InputMaybe<SortOrderEnum>
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
    title1: InputMaybe<PrismicStructuredTextTypeSortInput>
    title_image: InputMaybe<PrismicPricingPageV2DataTitleImageImageTypeSortInput>
    why_pleo: InputMaybe<PrismicPricingPageV2DataWhyPleoSortInput>
}

export type PrismicPricingPageV2DataWhyPleo = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPricingPageV2DataWhyPleoImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2DataWhyPleoFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPricingPageV2DataWhyPleoImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2DataWhyPleoFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPricingPageV2DataWhyPleoImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2DataWhyPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPageV2DataWhyPleoFilterInput>
}

export type PrismicPricingPageV2DataWhyPleoImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2DataWhyPleoImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2DataWhyPleoSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPricingPageV2DataWhyPleoImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPageV2Edge = {
    next: Maybe<PrismicPricingPageV2>
    node: PrismicPricingPageV2
    previous: Maybe<PrismicPricingPageV2>
}

export type PrismicPricingPageV2FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingPageV2DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPageV2FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPageV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPageV2GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPageV2Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingPageV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPageV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPageV2GroupConnectionDistinctArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2GroupConnectionGroupArgs = {
    field: PrismicPricingPageV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPageV2GroupConnectionMaxArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2GroupConnectionMinArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2GroupConnectionSumArgs = {
    field: PrismicPricingPageV2FieldSelector
}

export type PrismicPricingPageV2SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingPageV2DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPicker = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingPlanPickerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPlanPickerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingPlanPickerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerEdge>
    group: Array<PrismicPricingPlanPickerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPicker>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerConnectionGroupArgs = {
    field: PrismicPricingPlanPickerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerConnectionMaxArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerConnectionMinArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerConnectionSumArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerDataAdvancedTierFeatures = {
    feature: Maybe<Scalars['String']['output']>
    tooltip: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataAdvancedTierFeaturesFieldSelector = {
    feature: InputMaybe<FieldSelectorEnum>
    tooltip: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataAdvancedTierFeaturesFilterInput = {
    feature: InputMaybe<StringQueryOperatorInput>
    tooltip: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataAdvancedTierFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataAdvancedTierFeaturesFilterInput>
}

export type PrismicPricingPlanPickerDataAdvancedTierFeaturesSortInput = {
    feature: InputMaybe<SortOrderEnum>
    tooltip: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataBeyondTierFeatures = {
    feature: Maybe<Scalars['String']['output']>
    tooltip: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataBeyondTierFeaturesFieldSelector = {
    feature: InputMaybe<FieldSelectorEnum>
    tooltip: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataBeyondTierFeaturesFilterInput = {
    feature: InputMaybe<StringQueryOperatorInput>
    tooltip: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataBeyondTierFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataBeyondTierFeaturesFilterInput>
}

export type PrismicPricingPlanPickerDataBeyondTierFeaturesSortInput = {
    feature: InputMaybe<SortOrderEnum>
    tooltip: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataEssentialTierFeatures = {
    feature: Maybe<Scalars['String']['output']>
    tooltip: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataEssentialTierFeaturesFieldSelector = {
    feature: InputMaybe<FieldSelectorEnum>
    tooltip: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataEssentialTierFeaturesFilterInput = {
    feature: InputMaybe<StringQueryOperatorInput>
    tooltip: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataEssentialTierFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataEssentialTierFeaturesFilterInput>
}

export type PrismicPricingPlanPickerDataEssentialTierFeaturesSortInput = {
    feature: InputMaybe<SortOrderEnum>
    tooltip: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPickerDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationType>
    node: PrismicPricingPlanPickerDataFormProductionIntegrationType
    previous: Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationType>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPickerDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPickerDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationType>
    node: PrismicPricingPlanPickerDataFormStagingIntegrationType
    previous: Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationType>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPickerDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingPlanPickerDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicPricingPlanPickerDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingPlanPickerDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingPlanPickerDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataImperativeConsentsFilterInput>
}

export type PrismicPricingPlanPickerDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataQuestions = {
    option_1: Maybe<Scalars['String']['output']>
    option_2: Maybe<Scalars['String']['output']>
    option_3: Maybe<Scalars['String']['output']>
    option_4: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataQuestionsFieldSelector = {
    option_1: InputMaybe<FieldSelectorEnum>
    option_2: InputMaybe<FieldSelectorEnum>
    option_3: InputMaybe<FieldSelectorEnum>
    option_4: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataQuestionsFilterInput = {
    option_1: InputMaybe<StringQueryOperatorInput>
    option_2: InputMaybe<StringQueryOperatorInput>
    option_3: InputMaybe<StringQueryOperatorInput>
    option_4: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataQuestionsFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataQuestionsFilterInput>
}

export type PrismicPricingPlanPickerDataQuestionsSortInput = {
    option_1: InputMaybe<SortOrderEnum>
    option_2: InputMaybe<SortOrderEnum>
    option_3: InputMaybe<SortOrderEnum>
    option_4: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataSignupModalFree = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPricingPlanPickerDataSignupModalFreeImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataSignupModalFreeFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataSignupModalFreeFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataSignupModalFreeFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeFilterInput>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataSignupModalFreeSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataSignupModalPro = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPricingPlanPickerDataSignupModalProImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataSignupModalProFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalProImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataSignupModalProFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalProImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataSignupModalProFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataSignupModalProFilterInput>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataSignupModalProImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataSignupModalProSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPricingPlanPickerDataSignupModalProImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataStarterTierFeatures = {
    feature: Maybe<Scalars['String']['output']>
    tooltip: Maybe<Scalars['String']['output']>
}

export type PrismicPricingPlanPickerDataStarterTierFeaturesFieldSelector = {
    feature: InputMaybe<FieldSelectorEnum>
    tooltip: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerDataStarterTierFeaturesFilterInput = {
    feature: InputMaybe<StringQueryOperatorInput>
    tooltip: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerDataStarterTierFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingPlanPickerDataStarterTierFeaturesFilterInput>
}

export type PrismicPricingPlanPickerDataStarterTierFeaturesSortInput = {
    feature: InputMaybe<SortOrderEnum>
    tooltip: InputMaybe<SortOrderEnum>
}

export type PrismicPricingPlanPickerDataType = {
    advanced_tier_features: Maybe<Array<Maybe<PrismicPricingPlanPickerDataAdvancedTierFeatures>>>
    beyond_tier_features: Maybe<Array<Maybe<PrismicPricingPlanPickerDataBeyondTierFeatures>>>
    billing_cycle_text: Maybe<Scalars['String']['output']>
    compare_plans_text: Maybe<Scalars['String']['output']>
    essential_tier_features: Maybe<Array<Maybe<PrismicPricingPlanPickerDataEssentialTierFeatures>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationType>
    imperative_consents: Maybe<Array<Maybe<PrismicPricingPlanPickerDataImperativeConsents>>>
    loading_text: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPricingPlanPickerDataOpenGraphImageImageType>
    plan_result_subtitle: Maybe<Scalars['String']['output']>
    plan_result_title: Maybe<Scalars['String']['output']>
    questions: Maybe<Array<Maybe<PrismicPricingPlanPickerDataQuestions>>>
    signup_modal_free: Maybe<Array<Maybe<PrismicPricingPlanPickerDataSignupModalFree>>>
    signup_modal_pro: Maybe<Array<Maybe<PrismicPricingPlanPickerDataSignupModalPro>>>
    start_again_text: Maybe<Scalars['String']['output']>
    starter_tier_features: Maybe<Array<Maybe<PrismicPricingPlanPickerDataStarterTierFeatures>>>
}

export type PrismicPricingPlanPickerDataTypeFieldSelector = {
    advanced_tier_features: InputMaybe<PrismicPricingPlanPickerDataAdvancedTierFeaturesFieldSelector>
    beyond_tier_features: InputMaybe<PrismicPricingPlanPickerDataBeyondTierFeaturesFieldSelector>
    billing_cycle_text: InputMaybe<FieldSelectorEnum>
    compare_plans_text: InputMaybe<FieldSelectorEnum>
    essential_tier_features: InputMaybe<PrismicPricingPlanPickerDataEssentialTierFeaturesFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicPricingPlanPickerDataImperativeConsentsFieldSelector>
    loading_text: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPricingPlanPickerDataOpenGraphImageImageTypeFieldSelector>
    plan_result_subtitle: InputMaybe<FieldSelectorEnum>
    plan_result_title: InputMaybe<FieldSelectorEnum>
    questions: InputMaybe<PrismicPricingPlanPickerDataQuestionsFieldSelector>
    signup_modal_free: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeFieldSelector>
    signup_modal_pro: InputMaybe<PrismicPricingPlanPickerDataSignupModalProFieldSelector>
    start_again_text: InputMaybe<FieldSelectorEnum>
    starter_tier_features: InputMaybe<PrismicPricingPlanPickerDataStarterTierFeaturesFieldSelector>
}

export type PrismicPricingPlanPickerDataTypeFilterInput = {
    advanced_tier_features: InputMaybe<PrismicPricingPlanPickerDataAdvancedTierFeaturesFilterListInput>
    beyond_tier_features: InputMaybe<PrismicPricingPlanPickerDataBeyondTierFeaturesFilterListInput>
    billing_cycle_text: InputMaybe<StringQueryOperatorInput>
    compare_plans_text: InputMaybe<StringQueryOperatorInput>
    essential_tier_features: InputMaybe<PrismicPricingPlanPickerDataEssentialTierFeaturesFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeFilterInput>
    imperative_consents: InputMaybe<PrismicPricingPlanPickerDataImperativeConsentsFilterListInput>
    loading_text: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPricingPlanPickerDataOpenGraphImageImageTypeFilterInput>
    plan_result_subtitle: InputMaybe<StringQueryOperatorInput>
    plan_result_title: InputMaybe<StringQueryOperatorInput>
    questions: InputMaybe<PrismicPricingPlanPickerDataQuestionsFilterListInput>
    signup_modal_free: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeFilterListInput>
    signup_modal_pro: InputMaybe<PrismicPricingPlanPickerDataSignupModalProFilterListInput>
    start_again_text: InputMaybe<StringQueryOperatorInput>
    starter_tier_features: InputMaybe<PrismicPricingPlanPickerDataStarterTierFeaturesFilterListInput>
}

export type PrismicPricingPlanPickerDataTypeSortInput = {
    advanced_tier_features: InputMaybe<PrismicPricingPlanPickerDataAdvancedTierFeaturesSortInput>
    beyond_tier_features: InputMaybe<PrismicPricingPlanPickerDataBeyondTierFeaturesSortInput>
    billing_cycle_text: InputMaybe<SortOrderEnum>
    compare_plans_text: InputMaybe<SortOrderEnum>
    essential_tier_features: InputMaybe<PrismicPricingPlanPickerDataEssentialTierFeaturesSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeSortInput>
    imperative_consents: InputMaybe<PrismicPricingPlanPickerDataImperativeConsentsSortInput>
    loading_text: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPricingPlanPickerDataOpenGraphImageImageTypeSortInput>
    plan_result_subtitle: InputMaybe<SortOrderEnum>
    plan_result_title: InputMaybe<SortOrderEnum>
    questions: InputMaybe<PrismicPricingPlanPickerDataQuestionsSortInput>
    signup_modal_free: InputMaybe<PrismicPricingPlanPickerDataSignupModalFreeSortInput>
    signup_modal_pro: InputMaybe<PrismicPricingPlanPickerDataSignupModalProSortInput>
    start_again_text: InputMaybe<SortOrderEnum>
    starter_tier_features: InputMaybe<PrismicPricingPlanPickerDataStarterTierFeaturesSortInput>
}

export type PrismicPricingPlanPickerEdge = {
    next: Maybe<PrismicPricingPlanPicker>
    node: PrismicPricingPlanPicker
    previous: Maybe<PrismicPricingPlanPicker>
}

export type PrismicPricingPlanPickerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingPlanPickerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingPlanPickerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPlanPickerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingPlanPickerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingPlanPickerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingPlanPickerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingPlanPicker>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingPlanPickerGroupConnectionDistinctArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerGroupConnectionGroupArgs = {
    field: PrismicPricingPlanPickerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingPlanPickerGroupConnectionMaxArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerGroupConnectionMinArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerGroupConnectionSumArgs = {
    field: PrismicPricingPlanPickerFieldSelector
}

export type PrismicPricingPlanPickerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingPlanPickerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTableEdge>
    group: Array<PrismicPricingTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTableConnectionDistinctArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableConnectionGroupArgs = {
    field: PrismicPricingTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTableConnectionMaxArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableConnectionMinArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableConnectionSumArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableDataRows = {
    beyond: Maybe<Scalars['Boolean']['output']>
    beyond_text: Maybe<Scalars['String']['output']>
    essential: Maybe<Scalars['Boolean']['output']>
    essential_text: Maybe<Scalars['String']['output']>
    feature: Maybe<Scalars['String']['output']>
    feature_tooltip: Maybe<Scalars['String']['output']>
    premium: Maybe<Scalars['Boolean']['output']>
    premium_text: Maybe<Scalars['String']['output']>
    pro: Maybe<Scalars['Boolean']['output']>
    pro_text: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTableDataRowsFieldSelector = {
    beyond: InputMaybe<FieldSelectorEnum>
    beyond_text: InputMaybe<FieldSelectorEnum>
    essential: InputMaybe<FieldSelectorEnum>
    essential_text: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    feature_tooltip: InputMaybe<FieldSelectorEnum>
    premium: InputMaybe<FieldSelectorEnum>
    premium_text: InputMaybe<FieldSelectorEnum>
    pro: InputMaybe<FieldSelectorEnum>
    pro_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTableDataRowsFilterInput = {
    beyond: InputMaybe<BooleanQueryOperatorInput>
    beyond_text: InputMaybe<StringQueryOperatorInput>
    essential: InputMaybe<BooleanQueryOperatorInput>
    essential_text: InputMaybe<StringQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    feature_tooltip: InputMaybe<StringQueryOperatorInput>
    premium: InputMaybe<BooleanQueryOperatorInput>
    premium_text: InputMaybe<StringQueryOperatorInput>
    pro: InputMaybe<BooleanQueryOperatorInput>
    pro_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTableDataRowsFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTableDataRowsFilterInput>
}

export type PrismicPricingTableDataRowsSortInput = {
    beyond: InputMaybe<SortOrderEnum>
    beyond_text: InputMaybe<SortOrderEnum>
    essential: InputMaybe<SortOrderEnum>
    essential_text: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    feature_tooltip: InputMaybe<SortOrderEnum>
    premium: InputMaybe<SortOrderEnum>
    premium_text: InputMaybe<SortOrderEnum>
    pro: InputMaybe<SortOrderEnum>
    pro_text: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTableDataType = {
    beyond_heading: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    essential_heading: Maybe<Scalars['String']['output']>
    premium_heading: Maybe<Scalars['String']['output']>
    pro_heading: Maybe<Scalars['String']['output']>
    rows: Maybe<Array<Maybe<PrismicPricingTableDataRows>>>
}

export type PrismicPricingTableDataTypeFieldSelector = {
    beyond_heading: InputMaybe<FieldSelectorEnum>
    category: InputMaybe<FieldSelectorEnum>
    essential_heading: InputMaybe<FieldSelectorEnum>
    premium_heading: InputMaybe<FieldSelectorEnum>
    pro_heading: InputMaybe<FieldSelectorEnum>
    rows: InputMaybe<PrismicPricingTableDataRowsFieldSelector>
}

export type PrismicPricingTableDataTypeFilterInput = {
    beyond_heading: InputMaybe<StringQueryOperatorInput>
    category: InputMaybe<StringQueryOperatorInput>
    essential_heading: InputMaybe<StringQueryOperatorInput>
    premium_heading: InputMaybe<StringQueryOperatorInput>
    pro_heading: InputMaybe<StringQueryOperatorInput>
    rows: InputMaybe<PrismicPricingTableDataRowsFilterListInput>
}

export type PrismicPricingTableDataTypeSortInput = {
    beyond_heading: InputMaybe<SortOrderEnum>
    category: InputMaybe<SortOrderEnum>
    essential_heading: InputMaybe<SortOrderEnum>
    premium_heading: InputMaybe<SortOrderEnum>
    pro_heading: InputMaybe<SortOrderEnum>
    rows: InputMaybe<PrismicPricingTableDataRowsSortInput>
}

export type PrismicPricingTableEdge = {
    next: Maybe<PrismicPricingTable>
    node: PrismicPricingTable
    previous: Maybe<PrismicPricingTable>
}

export type PrismicPricingTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTableGroupConnectionDistinctArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableGroupConnectionGroupArgs = {
    field: PrismicPricingTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTableGroupConnectionMaxArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableGroupConnectionMinArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableGroupConnectionSumArgs = {
    field: PrismicPricingTableFieldSelector
}

export type PrismicPricingTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTableV2 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingTableV2DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTableV2First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTableV2Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTableV2Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTableV2Edge>
    group: Array<PrismicPricingTableV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTableV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTableV2ConnectionDistinctArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2ConnectionGroupArgs = {
    field: PrismicPricingTableV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTableV2ConnectionMaxArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2ConnectionMinArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2ConnectionSumArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2DataRows = {
    essential: Maybe<Scalars['String']['output']>
    feature: Maybe<Scalars['String']['output']>
    premium: Maybe<Scalars['String']['output']>
    pro: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTableV2DataRowsFieldSelector = {
    essential: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    premium: InputMaybe<FieldSelectorEnum>
    pro: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTableV2DataRowsFilterInput = {
    essential: InputMaybe<StringQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    premium: InputMaybe<StringQueryOperatorInput>
    pro: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTableV2DataRowsFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTableV2DataRowsFilterInput>
}

export type PrismicPricingTableV2DataRowsSortInput = {
    essential: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    premium: InputMaybe<SortOrderEnum>
    pro: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTableV2DataType = {
    category: Maybe<Scalars['String']['output']>
    essential_heading: Maybe<Scalars['String']['output']>
    premium_heading: Maybe<Scalars['String']['output']>
    pro_heading: Maybe<Scalars['String']['output']>
    rows: Maybe<Array<Maybe<PrismicPricingTableV2DataRows>>>
}

export type PrismicPricingTableV2DataTypeFieldSelector = {
    category: InputMaybe<FieldSelectorEnum>
    essential_heading: InputMaybe<FieldSelectorEnum>
    premium_heading: InputMaybe<FieldSelectorEnum>
    pro_heading: InputMaybe<FieldSelectorEnum>
    rows: InputMaybe<PrismicPricingTableV2DataRowsFieldSelector>
}

export type PrismicPricingTableV2DataTypeFilterInput = {
    category: InputMaybe<StringQueryOperatorInput>
    essential_heading: InputMaybe<StringQueryOperatorInput>
    premium_heading: InputMaybe<StringQueryOperatorInput>
    pro_heading: InputMaybe<StringQueryOperatorInput>
    rows: InputMaybe<PrismicPricingTableV2DataRowsFilterListInput>
}

export type PrismicPricingTableV2DataTypeSortInput = {
    category: InputMaybe<SortOrderEnum>
    essential_heading: InputMaybe<SortOrderEnum>
    premium_heading: InputMaybe<SortOrderEnum>
    pro_heading: InputMaybe<SortOrderEnum>
    rows: InputMaybe<PrismicPricingTableV2DataRowsSortInput>
}

export type PrismicPricingTableV2Edge = {
    next: Maybe<PrismicPricingTableV2>
    node: PrismicPricingTableV2
    previous: Maybe<PrismicPricingTableV2>
}

export type PrismicPricingTableV2FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingTableV2DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTableV2FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTableV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTableV2GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTableV2Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTableV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTableV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTableV2GroupConnectionDistinctArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2GroupConnectionGroupArgs = {
    field: PrismicPricingTableV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTableV2GroupConnectionMaxArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2GroupConnectionMinArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2GroupConnectionSumArgs = {
    field: PrismicPricingTableV2FieldSelector
}

export type PrismicPricingTableV2SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingTableV2DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTier = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingTierDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTierFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTierLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTierConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTierEdge>
    group: Array<PrismicPricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTierConnectionDistinctArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierConnectionGroupArgs = {
    field: PrismicPricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTierConnectionMaxArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierConnectionMinArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierConnectionSumArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierDataFeatures = {
    disabled_monthly: Maybe<Scalars['Boolean']['output']>
    feature: Maybe<Scalars['String']['output']>
    is_highlighted: Maybe<Scalars['Boolean']['output']>
    tooltip_text: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTierDataFeaturesFieldSelector = {
    disabled_monthly: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    is_highlighted: InputMaybe<FieldSelectorEnum>
    tooltip_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTierDataFeaturesFilterInput = {
    disabled_monthly: InputMaybe<BooleanQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    is_highlighted: InputMaybe<BooleanQueryOperatorInput>
    tooltip_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTierDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTierDataFeaturesFilterInput>
}

export type PrismicPricingTierDataFeaturesSortInput = {
    disabled_monthly: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    is_highlighted: InputMaybe<SortOrderEnum>
    tooltip_text: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTierDataType = {
    annual_billing_screen_reader_alt: Maybe<Scalars['String']['output']>
    annual_cost: Maybe<Scalars['String']['output']>
    annual_cost_subtext_extra: Maybe<Scalars['String']['output']>
    annually_billed_cost: Maybe<Scalars['Float']['output']>
    annually_billed_user_cost: Maybe<Scalars['Float']['output']>
    cashback_text: Maybe<PrismicStructuredTextType>
    cost_subtext: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    cta_variant: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    features: Maybe<Array<Maybe<PrismicPricingTierDataFeatures>>>
    features_title: Maybe<Scalars['String']['output']>
    footnote: Maybe<Scalars['String']['output']>
    free_users_included: Maybe<Scalars['Float']['output']>
    monthly_billed_cost: Maybe<Scalars['Float']['output']>
    monthly_billed_user_cost: Maybe<Scalars['Float']['output']>
    monthly_billing_screen_reader_alt: Maybe<Scalars['String']['output']>
    monthly_cost: Maybe<Scalars['String']['output']>
    monthly_cost_subtext_extra: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    open_additional_users_modal_text: Maybe<Scalars['String']['output']>
    per_month_text: Maybe<Scalars['String']['output']>
    second_footnote: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTierDataTypeFieldSelector = {
    annual_billing_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    annual_cost: InputMaybe<FieldSelectorEnum>
    annual_cost_subtext_extra: InputMaybe<FieldSelectorEnum>
    annually_billed_cost: InputMaybe<FieldSelectorEnum>
    annually_billed_user_cost: InputMaybe<FieldSelectorEnum>
    cashback_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cost_subtext: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    cta_variant: InputMaybe<FieldSelectorEnum>
    excerpt: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<PrismicPricingTierDataFeaturesFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    footnote: InputMaybe<FieldSelectorEnum>
    free_users_included: InputMaybe<FieldSelectorEnum>
    monthly_billed_cost: InputMaybe<FieldSelectorEnum>
    monthly_billed_user_cost: InputMaybe<FieldSelectorEnum>
    monthly_billing_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    monthly_cost: InputMaybe<FieldSelectorEnum>
    monthly_cost_subtext_extra: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    open_additional_users_modal_text: InputMaybe<FieldSelectorEnum>
    per_month_text: InputMaybe<FieldSelectorEnum>
    second_footnote: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTierDataTypeFilterInput = {
    annual_billing_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    annual_cost: InputMaybe<StringQueryOperatorInput>
    annual_cost_subtext_extra: InputMaybe<StringQueryOperatorInput>
    annually_billed_cost: InputMaybe<FloatQueryOperatorInput>
    annually_billed_user_cost: InputMaybe<FloatQueryOperatorInput>
    cashback_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cost_subtext: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    cta_variant: InputMaybe<StringQueryOperatorInput>
    excerpt: InputMaybe<StringQueryOperatorInput>
    features: InputMaybe<PrismicPricingTierDataFeaturesFilterListInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    footnote: InputMaybe<StringQueryOperatorInput>
    free_users_included: InputMaybe<FloatQueryOperatorInput>
    monthly_billed_cost: InputMaybe<FloatQueryOperatorInput>
    monthly_billed_user_cost: InputMaybe<FloatQueryOperatorInput>
    monthly_billing_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    monthly_cost: InputMaybe<StringQueryOperatorInput>
    monthly_cost_subtext_extra: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    open_additional_users_modal_text: InputMaybe<StringQueryOperatorInput>
    per_month_text: InputMaybe<StringQueryOperatorInput>
    second_footnote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTierDataTypeSortInput = {
    annual_billing_screen_reader_alt: InputMaybe<SortOrderEnum>
    annual_cost: InputMaybe<SortOrderEnum>
    annual_cost_subtext_extra: InputMaybe<SortOrderEnum>
    annually_billed_cost: InputMaybe<SortOrderEnum>
    annually_billed_user_cost: InputMaybe<SortOrderEnum>
    cashback_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    cost_subtext: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    cta_variant: InputMaybe<SortOrderEnum>
    excerpt: InputMaybe<SortOrderEnum>
    features: InputMaybe<PrismicPricingTierDataFeaturesSortInput>
    features_title: InputMaybe<SortOrderEnum>
    footnote: InputMaybe<SortOrderEnum>
    free_users_included: InputMaybe<SortOrderEnum>
    monthly_billed_cost: InputMaybe<SortOrderEnum>
    monthly_billed_user_cost: InputMaybe<SortOrderEnum>
    monthly_billing_screen_reader_alt: InputMaybe<SortOrderEnum>
    monthly_cost: InputMaybe<SortOrderEnum>
    monthly_cost_subtext_extra: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    open_additional_users_modal_text: InputMaybe<SortOrderEnum>
    per_month_text: InputMaybe<SortOrderEnum>
    second_footnote: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTierEdge = {
    next: Maybe<PrismicPricingTier>
    node: PrismicPricingTier
    previous: Maybe<PrismicPricingTier>
}

export type PrismicPricingTierFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingTierDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTierFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTierGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTierEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTierGroupConnectionDistinctArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierGroupConnectionGroupArgs = {
    field: PrismicPricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTierGroupConnectionMaxArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierGroupConnectionMinArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierGroupConnectionSumArgs = {
    field: PrismicPricingTierFieldSelector
}

export type PrismicPricingTierSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingTierDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiers = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingTiersDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTiersLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTiersConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersEdge>
    group: Array<PrismicPricingTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersConnectionDistinctArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersConnectionGroupArgs = {
    field: PrismicPricingTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersConnectionMaxArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersConnectionMinArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersConnectionSumArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersDataAdditionalUsersModal = {
    description: Maybe<PrismicStructuredTextType>
    table: Maybe<PrismicLinkType>
    title1: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataAdditionalUsersModalFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    table: InputMaybe<PrismicLinkTypeFieldSelector>
    title1: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataAdditionalUsersModalFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    table: InputMaybe<PrismicLinkTypeFilterInput>
    title1: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataAdditionalUsersModalFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataAdditionalUsersModalFilterInput>
}

export type PrismicPricingTiersDataAdditionalUsersModalSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    table: InputMaybe<PrismicLinkTypeSortInput>
    title1: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataBillingCycle = {
    billed_monthly_label: Maybe<Scalars['String']['output']>
    billed_yearly_label: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    legend: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataBillingCycleFieldSelector = {
    billed_monthly_label: InputMaybe<FieldSelectorEnum>
    billed_yearly_label: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    legend: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataBillingCycleFilterInput = {
    billed_monthly_label: InputMaybe<StringQueryOperatorInput>
    billed_yearly_label: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    legend: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataBillingCycleFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataBillingCycleFilterInput>
}

export type PrismicPricingTiersDataBillingCycleSortInput = {
    billed_monthly_label: InputMaybe<SortOrderEnum>
    billed_yearly_label: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    legend: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicPricingTiersDataFormProductionIntegrationType>
    node: PrismicPricingTiersDataFormProductionIntegrationType
    previous: Maybe<PrismicPricingTiersDataFormProductionIntegrationType>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicPricingTiersDataFormStagingIntegrationType>
    node: PrismicPricingTiersDataFormStagingIntegrationType
    previous: Maybe<PrismicPricingTiersDataFormStagingIntegrationType>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicPricingTiersDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicPricingTiersDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingTiersDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingTiersDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataImperativeConsentsFilterInput>
}

export type PrismicPricingTiersDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingTiersDataPricingTiers = {
    pricing_tier: Maybe<PrismicLinkType>
}

export type PrismicPricingTiersDataPricingTiersFieldSelector = {
    pricing_tier: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingTiersDataPricingTiersFilterInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingTiersDataPricingTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataPricingTiersFilterInput>
}

export type PrismicPricingTiersDataPricingTiersSortInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingTiersDataSignupModalFree = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPricingTiersDataSignupModalFreeImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataSignupModalFreeFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPricingTiersDataSignupModalFreeImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataSignupModalFreeFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPricingTiersDataSignupModalFreeImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataSignupModalFreeFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataSignupModalFreeFilterInput>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataSignupModalFreeImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataSignupModalFreeSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPricingTiersDataSignupModalFreeImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataSignupModalPro = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicPricingTiersDataSignupModalProImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataSignupModalProFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicPricingTiersDataSignupModalProImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataSignupModalProFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicPricingTiersDataSignupModalProImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataSignupModalProFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersDataSignupModalProFilterInput>
}

export type PrismicPricingTiersDataSignupModalProImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataSignupModalProImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataSignupModalProSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicPricingTiersDataSignupModalProImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingTiersDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingTiersDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingTiersDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersDataType = {
    additional_users_modal: Maybe<Array<Maybe<PrismicPricingTiersDataAdditionalUsersModal>>>
    billing_cycle: Maybe<Array<Maybe<PrismicPricingTiersDataBillingCycle>>>
    billing_monthly_label_v2: Maybe<Scalars['String']['output']>
    billing_yearly_label_v2: Maybe<Scalars['String']['output']>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicPricingTiersDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicPricingTiersDataFormStagingIntegrationType>
    imperative_consents: Maybe<Array<Maybe<PrismicPricingTiersDataImperativeConsents>>>
    pricing_tiers: Maybe<Array<Maybe<PrismicPricingTiersDataPricingTiers>>>
    read_more_text: Maybe<Scalars['String']['output']>
    show_ctas: Maybe<Scalars['Boolean']['output']>
    signup_modal_free: Maybe<Array<Maybe<PrismicPricingTiersDataSignupModalFree>>>
    signup_modal_pro: Maybe<Array<Maybe<PrismicPricingTiersDataSignupModalPro>>>
    slider_label: Maybe<Scalars['String']['output']>
    slider_sub_text: Maybe<PrismicStructuredTextType>
    slider_tooltip_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    tier_1: Maybe<PrismicLinkType>
    tier_2: Maybe<PrismicLinkType>
    tier_3: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    title_image: Maybe<PrismicPricingTiersDataTitleImageImageType>
}

export type PrismicPricingTiersDataTypeFieldSelector = {
    additional_users_modal: InputMaybe<PrismicPricingTiersDataAdditionalUsersModalFieldSelector>
    billing_cycle: InputMaybe<PrismicPricingTiersDataBillingCycleFieldSelector>
    billing_monthly_label_v2: InputMaybe<FieldSelectorEnum>
    billing_yearly_label_v2: InputMaybe<FieldSelectorEnum>
    exclude_production: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicPricingTiersDataImperativeConsentsFieldSelector>
    pricing_tiers: InputMaybe<PrismicPricingTiersDataPricingTiersFieldSelector>
    read_more_text: InputMaybe<FieldSelectorEnum>
    show_ctas: InputMaybe<FieldSelectorEnum>
    signup_modal_free: InputMaybe<PrismicPricingTiersDataSignupModalFreeFieldSelector>
    signup_modal_pro: InputMaybe<PrismicPricingTiersDataSignupModalProFieldSelector>
    slider_label: InputMaybe<FieldSelectorEnum>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    slider_tooltip_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    tier_1: InputMaybe<PrismicLinkTypeFieldSelector>
    tier_2: InputMaybe<PrismicLinkTypeFieldSelector>
    tier_3: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    title_image: InputMaybe<PrismicPricingTiersDataTitleImageImageTypeFieldSelector>
}

export type PrismicPricingTiersDataTypeFilterInput = {
    additional_users_modal: InputMaybe<PrismicPricingTiersDataAdditionalUsersModalFilterListInput>
    billing_cycle: InputMaybe<PrismicPricingTiersDataBillingCycleFilterListInput>
    billing_monthly_label_v2: InputMaybe<StringQueryOperatorInput>
    billing_yearly_label_v2: InputMaybe<StringQueryOperatorInput>
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeFilterInput>
    imperative_consents: InputMaybe<PrismicPricingTiersDataImperativeConsentsFilterListInput>
    pricing_tiers: InputMaybe<PrismicPricingTiersDataPricingTiersFilterListInput>
    read_more_text: InputMaybe<StringQueryOperatorInput>
    show_ctas: InputMaybe<BooleanQueryOperatorInput>
    signup_modal_free: InputMaybe<PrismicPricingTiersDataSignupModalFreeFilterListInput>
    signup_modal_pro: InputMaybe<PrismicPricingTiersDataSignupModalProFilterListInput>
    slider_label: InputMaybe<StringQueryOperatorInput>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    slider_tooltip_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    tier_1: InputMaybe<PrismicLinkTypeFilterInput>
    tier_2: InputMaybe<PrismicLinkTypeFilterInput>
    tier_3: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    title_image: InputMaybe<PrismicPricingTiersDataTitleImageImageTypeFilterInput>
}

export type PrismicPricingTiersDataTypeSortInput = {
    additional_users_modal: InputMaybe<PrismicPricingTiersDataAdditionalUsersModalSortInput>
    billing_cycle: InputMaybe<PrismicPricingTiersDataBillingCycleSortInput>
    billing_monthly_label_v2: InputMaybe<SortOrderEnum>
    billing_yearly_label_v2: InputMaybe<SortOrderEnum>
    exclude_production: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeSortInput>
    imperative_consents: InputMaybe<PrismicPricingTiersDataImperativeConsentsSortInput>
    pricing_tiers: InputMaybe<PrismicPricingTiersDataPricingTiersSortInput>
    read_more_text: InputMaybe<SortOrderEnum>
    show_ctas: InputMaybe<SortOrderEnum>
    signup_modal_free: InputMaybe<PrismicPricingTiersDataSignupModalFreeSortInput>
    signup_modal_pro: InputMaybe<PrismicPricingTiersDataSignupModalProSortInput>
    slider_label: InputMaybe<SortOrderEnum>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    slider_tooltip_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    tier_1: InputMaybe<PrismicLinkTypeSortInput>
    tier_2: InputMaybe<PrismicLinkTypeSortInput>
    tier_3: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    title_image: InputMaybe<PrismicPricingTiersDataTitleImageImageTypeSortInput>
}

export type PrismicPricingTiersEdge = {
    next: Maybe<PrismicPricingTiers>
    node: PrismicPricingTiers
    previous: Maybe<PrismicPricingTiers>
}

export type PrismicPricingTiersFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingTiersDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersGroupConnectionDistinctArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersGroupConnectionGroupArgs = {
    field: PrismicPricingTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersGroupConnectionMaxArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersGroupConnectionMinArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersGroupConnectionSumArgs = {
    field: PrismicPricingTiersFieldSelector
}

export type PrismicPricingTiersSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingTiersDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingTiersV2DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTiersV2Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingTiersV2Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersV2Edge>
    group: Array<PrismicPricingTiersV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersV2ConnectionDistinctArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2ConnectionGroupArgs = {
    field: PrismicPricingTiersV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersV2ConnectionMaxArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2ConnectionMinArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2ConnectionSumArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2DataAdditionalUsersModal = {
    description: Maybe<PrismicStructuredTextType>
    table: Maybe<PrismicLinkType>
    title1: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataAdditionalUsersModalFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    table: InputMaybe<PrismicLinkTypeFieldSelector>
    title1: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataAdditionalUsersModalFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    table: InputMaybe<PrismicLinkTypeFilterInput>
    title1: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataAdditionalUsersModalFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersV2DataAdditionalUsersModalFilterInput>
}

export type PrismicPricingTiersV2DataAdditionalUsersModalSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    table: InputMaybe<PrismicLinkTypeSortInput>
    title1: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataBillingCycle = {
    billed_monthly_label: Maybe<Scalars['String']['output']>
    billed_yearly_label: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    legend: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataBillingCycleFieldSelector = {
    billed_monthly_label: InputMaybe<FieldSelectorEnum>
    billed_yearly_label: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    legend: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataBillingCycleFilterInput = {
    billed_monthly_label: InputMaybe<StringQueryOperatorInput>
    billed_yearly_label: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    legend: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataBillingCycleFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersV2DataBillingCycleFilterInput>
}

export type PrismicPricingTiersV2DataBillingCycleSortInput = {
    billed_monthly_label: InputMaybe<SortOrderEnum>
    billed_yearly_label: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    legend: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataPricingTiers = {
    pricing_tier: Maybe<PrismicLinkType>
}

export type PrismicPricingTiersV2DataPricingTiersFieldSelector = {
    pricing_tier: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingTiersV2DataPricingTiersFilterInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingTiersV2DataPricingTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersV2DataPricingTiersFilterInput>
}

export type PrismicPricingTiersV2DataPricingTiersSortInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingTiersV2DataSignupModalFree = {
    image: Maybe<PrismicPricingTiersV2DataSignupModalFreeImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataSignupModalFreeFieldSelector = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataSignupModalFreeFilterInput = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataSignupModalFreeFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeFilterInput>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataSignupModalFreeImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataSignupModalFreeSortInput = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataSignupModalPro = {
    image: Maybe<PrismicPricingTiersV2DataSignupModalProImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataSignupModalProFieldSelector = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalProImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataSignupModalProFilterInput = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalProImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataSignupModalProFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingTiersV2DataSignupModalProFilterInput>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataSignupModalProImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataSignupModalProSortInput = {
    image: InputMaybe<PrismicPricingTiersV2DataSignupModalProImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2DataType = {
    additional_users_modal: Maybe<Array<Maybe<PrismicPricingTiersV2DataAdditionalUsersModal>>>
    billing_cycle: Maybe<Array<Maybe<PrismicPricingTiersV2DataBillingCycle>>>
    pricing_tiers: Maybe<Array<Maybe<PrismicPricingTiersV2DataPricingTiers>>>
    promo_badge: Maybe<Scalars['String']['output']>
    read_more_text: Maybe<Scalars['String']['output']>
    signup_modal_free: Maybe<Array<Maybe<PrismicPricingTiersV2DataSignupModalFree>>>
    signup_modal_pro: Maybe<Array<Maybe<PrismicPricingTiersV2DataSignupModalPro>>>
    subtitle: Maybe<Scalars['String']['output']>
    tier_1: Maybe<PrismicLinkType>
    tier_2: Maybe<PrismicLinkType>
    tier_3: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingTiersV2DataTypeFieldSelector = {
    additional_users_modal: InputMaybe<PrismicPricingTiersV2DataAdditionalUsersModalFieldSelector>
    billing_cycle: InputMaybe<PrismicPricingTiersV2DataBillingCycleFieldSelector>
    pricing_tiers: InputMaybe<PrismicPricingTiersV2DataPricingTiersFieldSelector>
    promo_badge: InputMaybe<FieldSelectorEnum>
    read_more_text: InputMaybe<FieldSelectorEnum>
    signup_modal_free: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeFieldSelector>
    signup_modal_pro: InputMaybe<PrismicPricingTiersV2DataSignupModalProFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    tier_1: InputMaybe<PrismicLinkTypeFieldSelector>
    tier_2: InputMaybe<PrismicLinkTypeFieldSelector>
    tier_3: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2DataTypeFilterInput = {
    additional_users_modal: InputMaybe<PrismicPricingTiersV2DataAdditionalUsersModalFilterListInput>
    billing_cycle: InputMaybe<PrismicPricingTiersV2DataBillingCycleFilterListInput>
    pricing_tiers: InputMaybe<PrismicPricingTiersV2DataPricingTiersFilterListInput>
    promo_badge: InputMaybe<StringQueryOperatorInput>
    read_more_text: InputMaybe<StringQueryOperatorInput>
    signup_modal_free: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeFilterListInput>
    signup_modal_pro: InputMaybe<PrismicPricingTiersV2DataSignupModalProFilterListInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    tier_1: InputMaybe<PrismicLinkTypeFilterInput>
    tier_2: InputMaybe<PrismicLinkTypeFilterInput>
    tier_3: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2DataTypeSortInput = {
    additional_users_modal: InputMaybe<PrismicPricingTiersV2DataAdditionalUsersModalSortInput>
    billing_cycle: InputMaybe<PrismicPricingTiersV2DataBillingCycleSortInput>
    pricing_tiers: InputMaybe<PrismicPricingTiersV2DataPricingTiersSortInput>
    promo_badge: InputMaybe<SortOrderEnum>
    read_more_text: InputMaybe<SortOrderEnum>
    signup_modal_free: InputMaybe<PrismicPricingTiersV2DataSignupModalFreeSortInput>
    signup_modal_pro: InputMaybe<PrismicPricingTiersV2DataSignupModalProSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    tier_1: InputMaybe<PrismicLinkTypeSortInput>
    tier_2: InputMaybe<PrismicLinkTypeSortInput>
    tier_3: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingTiersV2Edge = {
    next: Maybe<PrismicPricingTiersV2>
    node: PrismicPricingTiersV2
    previous: Maybe<PrismicPricingTiersV2>
}

export type PrismicPricingTiersV2FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingTiersV2DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingTiersV2FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTiersV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingTiersV2GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingTiersV2Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingTiersV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingTiersV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingTiersV2GroupConnectionDistinctArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2GroupConnectionGroupArgs = {
    field: PrismicPricingTiersV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingTiersV2GroupConnectionMaxArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2GroupConnectionMinArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2GroupConnectionSumArgs = {
    field: PrismicPricingTiersV2FieldSelector
}

export type PrismicPricingTiersV2SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingTiersV2DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2 = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV2DataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2First_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV2Last_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV2Connection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV2Edge>
    group: Array<PrismicPricingV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV2ConnectionDistinctArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2ConnectionGroupArgs = {
    field: PrismicPricingV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV2ConnectionMaxArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2ConnectionMinArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2ConnectionSumArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2DataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2DataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2DataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2DataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2DataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2DataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingV2DataQuestionsAnswersFilterInput>
}

export type PrismicPricingV2DataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2DataTables = {
    table: Maybe<PrismicLinkType>
}

export type PrismicPricingV2DataTablesFieldSelector = {
    table: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingV2DataTablesFilterInput = {
    table: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingV2DataTablesFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingV2DataTablesFilterInput>
}

export type PrismicPricingV2DataTablesSortInput = {
    table: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingV2DataTiers = {
    advanced: Maybe<PrismicLinkType>
    essential: Maybe<PrismicLinkType>
    starter: Maybe<PrismicLinkType>
}

export type PrismicPricingV2DataTiersFieldSelector = {
    advanced: InputMaybe<PrismicLinkTypeFieldSelector>
    essential: InputMaybe<PrismicLinkTypeFieldSelector>
    starter: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicPricingV2DataTiersFilterInput = {
    advanced: InputMaybe<PrismicLinkTypeFilterInput>
    essential: InputMaybe<PrismicLinkTypeFilterInput>
    starter: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicPricingV2DataTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingV2DataTiersFilterInput>
}

export type PrismicPricingV2DataTiersSortInput = {
    advanced: InputMaybe<PrismicLinkTypeSortInput>
    essential: InputMaybe<PrismicLinkTypeSortInput>
    starter: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicPricingV2DataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2DataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV2DataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingV2DataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingV2DataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingV2DataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2DataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2DataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2DataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPricingV2DataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicPricingV2DataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    tables: Maybe<Array<Maybe<PrismicPricingV2DataTables>>>
    tables_tick_screen_reader_alt: Maybe<Scalars['String']['output']>
    tables_title: Maybe<Scalars['String']['output']>
    testimonial: Maybe<PrismicLinkType>
    tiers: Maybe<Array<Maybe<PrismicPricingV2DataTiers>>>
    title: Maybe<PrismicStructuredTextType>
    title1: Maybe<PrismicStructuredTextType>
    title_image: Maybe<PrismicPricingV2DataTitleImageImageType>
    why_pleo: Maybe<Array<Maybe<PrismicPricingV2DataWhyPleo>>>
}

export type PrismicPricingV2DataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPricingV2DataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicPricingV2DataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    tables: InputMaybe<PrismicPricingV2DataTablesFieldSelector>
    tables_tick_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    tables_title: InputMaybe<FieldSelectorEnum>
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
    tiers: InputMaybe<PrismicPricingV2DataTiersFieldSelector>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title1: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title_image: InputMaybe<PrismicPricingV2DataTitleImageImageTypeFieldSelector>
    why_pleo: InputMaybe<PrismicPricingV2DataWhyPleoFieldSelector>
}

export type PrismicPricingV2DataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPricingV2DataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicPricingV2DataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    tables: InputMaybe<PrismicPricingV2DataTablesFilterListInput>
    tables_tick_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    tables_title: InputMaybe<StringQueryOperatorInput>
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
    tiers: InputMaybe<PrismicPricingV2DataTiersFilterListInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title1: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title_image: InputMaybe<PrismicPricingV2DataTitleImageImageTypeFilterInput>
    why_pleo: InputMaybe<PrismicPricingV2DataWhyPleoFilterListInput>
}

export type PrismicPricingV2DataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPricingV2DataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicPricingV2DataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    tables: InputMaybe<PrismicPricingV2DataTablesSortInput>
    tables_tick_screen_reader_alt: InputMaybe<SortOrderEnum>
    tables_title: InputMaybe<SortOrderEnum>
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
    tiers: InputMaybe<PrismicPricingV2DataTiersSortInput>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
    title1: InputMaybe<PrismicStructuredTextTypeSortInput>
    title_image: InputMaybe<PrismicPricingV2DataTitleImageImageTypeSortInput>
    why_pleo: InputMaybe<PrismicPricingV2DataWhyPleoSortInput>
}

export type PrismicPricingV2DataWhyPleo = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicPricingV2DataWhyPleoImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2DataWhyPleoFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicPricingV2DataWhyPleoImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2DataWhyPleoFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicPricingV2DataWhyPleoImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2DataWhyPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingV2DataWhyPleoFilterInput>
}

export type PrismicPricingV2DataWhyPleoImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2DataWhyPleoImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2DataWhyPleoSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicPricingV2DataWhyPleoImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV2Edge = {
    next: Maybe<PrismicPricingV2>
    node: PrismicPricingV2
    previous: Maybe<PrismicPricingV2>
}

export type PrismicPricingV2FieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingV2DataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV2FilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV2GroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV2Edge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV2GroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV2>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV2GroupConnectionDistinctArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2GroupConnectionGroupArgs = {
    field: PrismicPricingV2FieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV2GroupConnectionMaxArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2GroupConnectionMinArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2GroupConnectionSumArgs = {
    field: PrismicPricingV2FieldSelector
}

export type PrismicPricingV2SortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingV2DataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3ComparisonTable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV3ComparisonTableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3ComparisonTableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3ComparisonTableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3ComparisonTableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3ComparisonTableEdge>
    group: Array<PrismicPricingV3ComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3ComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3ComparisonTableConnectionDistinctArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableConnectionGroupArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3ComparisonTableConnectionMaxArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableConnectionMinArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableConnectionSumArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategory = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryItem>
    primary: PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryItem = {
    feature: Maybe<Scalars['String']['output']>
    tier_1_text: Maybe<Scalars['String']['output']>
    tier_1_value: Maybe<Scalars['String']['output']>
    tier_2_text: Maybe<Scalars['String']['output']>
    tier_2_value: Maybe<Scalars['String']['output']>
    tier_3_text: Maybe<Scalars['String']['output']>
    tier_3_value: Maybe<Scalars['String']['output']>
    tier_4_text: Maybe<Scalars['String']['output']>
    tier_4_value: Maybe<Scalars['String']['output']>
    tooltip_aria_label: Maybe<Scalars['String']['output']>
    tooltip_label: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimary = {
    icon: Maybe<PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageType>
    name: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicPricingV3ComparisonTableDataBodyComparisonTableCategoryPrimaryIconImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicPricingV3ComparisonTableDataBodySlicesType =
    PrismicPricingV3ComparisonTableDataBodyComparisonTableCategory

export type PrismicPricingV3ComparisonTableDataTiers = {
    name: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3ComparisonTableDataTiersFieldSelector = {
    name: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3ComparisonTableDataTiersFilterInput = {
    name: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3ComparisonTableDataTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicPricingV3ComparisonTableDataTiersFilterInput>
}

export type PrismicPricingV3ComparisonTableDataTiersSortInput = {
    name: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3ComparisonTableDataType = {
    body: Array<PrismicPricingV3ComparisonTableDataBodySlicesType>
    check_alt_text: Maybe<Scalars['String']['output']>
    cross_alt_text: Maybe<Scalars['String']['output']>
    main_column_label: Maybe<Scalars['String']['output']>
    table_aria_label: Maybe<Scalars['String']['output']>
    tiers: Maybe<Array<Maybe<PrismicPricingV3ComparisonTableDataTiers>>>
}

export type PrismicPricingV3ComparisonTableDataTypeFieldSelector = {
    check_alt_text: InputMaybe<FieldSelectorEnum>
    cross_alt_text: InputMaybe<FieldSelectorEnum>
    main_column_label: InputMaybe<FieldSelectorEnum>
    table_aria_label: InputMaybe<FieldSelectorEnum>
    tiers: InputMaybe<PrismicPricingV3ComparisonTableDataTiersFieldSelector>
}

export type PrismicPricingV3ComparisonTableDataTypeFilterInput = {
    check_alt_text: InputMaybe<StringQueryOperatorInput>
    cross_alt_text: InputMaybe<StringQueryOperatorInput>
    main_column_label: InputMaybe<StringQueryOperatorInput>
    table_aria_label: InputMaybe<StringQueryOperatorInput>
    tiers: InputMaybe<PrismicPricingV3ComparisonTableDataTiersFilterListInput>
}

export type PrismicPricingV3ComparisonTableDataTypeSortInput = {
    check_alt_text: InputMaybe<SortOrderEnum>
    cross_alt_text: InputMaybe<SortOrderEnum>
    main_column_label: InputMaybe<SortOrderEnum>
    table_aria_label: InputMaybe<SortOrderEnum>
    tiers: InputMaybe<PrismicPricingV3ComparisonTableDataTiersSortInput>
}

export type PrismicPricingV3ComparisonTableEdge = {
    next: Maybe<PrismicPricingV3ComparisonTable>
    node: PrismicPricingV3ComparisonTable
    previous: Maybe<PrismicPricingV3ComparisonTable>
}

export type PrismicPricingV3ComparisonTableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingV3ComparisonTableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3ComparisonTableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3ComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3ComparisonTableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3ComparisonTableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV3ComparisonTableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3ComparisonTable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3ComparisonTableGroupConnectionDistinctArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableGroupConnectionGroupArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3ComparisonTableGroupConnectionMaxArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableGroupConnectionMinArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableGroupConnectionSumArgs = {
    field: PrismicPricingV3ComparisonTableFieldSelector
}

export type PrismicPricingV3ComparisonTableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingV3ComparisonTableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3Page = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV3PageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PageEdge>
    group: Array<PrismicPricingV3PageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3Page>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PageConnectionDistinctArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageConnectionGroupArgs = {
    field: PrismicPricingV3PageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PageConnectionMaxArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageConnectionMinArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageConnectionSumArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageDataBodyAccordion = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3PageDataBodyAccordionItem>
    primary: PrismicPricingV3PageDataBodyAccordionPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyAccordionItem = {
    content: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyAccordionPrimary = {
    headline: Maybe<Scalars['String']['output']>
    subheadline: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyComparisonTable = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicPricingV3PageDataBodyComparisonTablePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyComparisonTablePrimary = {
    table: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCta = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItem>
    primary: PrismicPricingV3PageDataBodyCustomerLogosPlusCtaPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItem = {
    logo: Maybe<PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageType>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingV3PageDataBodyCustomerLogosPlusCtaPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    marquee_mode: Maybe<Scalars['Boolean']['output']>
    marquee_scroll_speed: Maybe<Scalars['String']['output']>
    marquee_width: Maybe<Scalars['String']['output']>
    stat_1_body: Maybe<Scalars['String']['output']>
    stat_1_highlight: Maybe<Scalars['String']['output']>
    stat_2_body: Maybe<Scalars['String']['output']>
    stat_2_highlight: Maybe<Scalars['String']['output']>
    stat_3_body: Maybe<Scalars['String']['output']>
    stat_3_highlight: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3PageDataBodyHighlightsHeroItem>
    primary: PrismicPricingV3PageDataBodyHighlightsHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyHighlightsHeroItem = {
    text: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsHeroPrimary = {
    headline: Maybe<Scalars['String']['output']>
    subheadline: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsSignup = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3PageDataBodyHighlightsSignupItem>
    primary: PrismicPricingV3PageDataBodyHighlightsSignupPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyHighlightsSignupItem = {
    text: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimary = {
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType =
    Node & {
        children: Array<Node>
        consents: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsents>
        formId: Maybe<Scalars['String']['output']>
        id: Scalars['ID']['output']
        internal: Internal
        parent: Maybe<Node>
        prismicId: Maybe<Scalars['String']['output']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
    node: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
}

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeEdge>
        group: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
    node: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
}

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicPricingV3PageDataBodyPricingV3TierGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicPricingV3PageDataBodyPricingV3TierGridItem>
    primary: PrismicPricingV3PageDataBodyPricingV3TierGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicPricingV3PageDataBodyPricingV3TierGridItem = {
    pricing_tier: Maybe<PrismicLinkType>
}

export type PrismicPricingV3PageDataBodyPricingV3TierGridPrimary = {
    counter_aria_label: Maybe<Scalars['String']['output']>
    counter_input_aria_label: Maybe<Scalars['String']['output']>
    decrement_users_alt_text: Maybe<Scalars['String']['output']>
    increment_users_alt_text: Maybe<Scalars['String']['output']>
    pay_monthly_tab: Maybe<Scalars['String']['output']>
    pay_yearly_tab: Maybe<Scalars['String']['output']>
    users_input_placeholder_plural: Maybe<Scalars['String']['output']>
    users_input_placeholder_singular: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataBodySlicesType =
    | PrismicPricingV3PageDataBodyAccordion
    | PrismicPricingV3PageDataBodyComparisonTable
    | PrismicPricingV3PageDataBodyCustomerLogosPlusCta
    | PrismicPricingV3PageDataBodyHighlightsHero
    | PrismicPricingV3PageDataBodyHighlightsSignup
    | PrismicPricingV3PageDataBodyPricingV3TierGrid

export type PrismicPricingV3PageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3PageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3PageDataType = {
    body: Array<PrismicPricingV3PageDataBodySlicesType>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicPricingV3PageDataOpenGraphImageImageType>
}

export type PrismicPricingV3PageDataTypeFieldSelector = {
    exclude_production: InputMaybe<FieldSelectorEnum>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicPricingV3PageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicPricingV3PageDataTypeFilterInput = {
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicPricingV3PageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicPricingV3PageDataTypeSortInput = {
    exclude_production: InputMaybe<SortOrderEnum>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicPricingV3PageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicPricingV3PageEdge = {
    next: Maybe<PrismicPricingV3Page>
    node: PrismicPricingV3Page
    previous: Maybe<PrismicPricingV3Page>
}

export type PrismicPricingV3PageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingV3PageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3PageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3PageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3PageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV3PageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3Page>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PageGroupConnectionDistinctArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageGroupConnectionGroupArgs = {
    field: PrismicPricingV3PageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PageGroupConnectionMaxArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageGroupConnectionMinArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageGroupConnectionSumArgs = {
    field: PrismicPricingV3PageFieldSelector
}

export type PrismicPricingV3PageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingV3PageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3PricingTier = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV3PricingTierDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PricingTierFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PricingTierLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PricingTierConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PricingTierEdge>
    group: Array<PrismicPricingV3PricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3PricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PricingTierConnectionDistinctArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierConnectionGroupArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PricingTierConnectionMaxArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierConnectionMinArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierConnectionSumArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierDataType = {
    additional_users_cost_text: Maybe<Scalars['String']['output']>
    badge_text: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_modal_subtitle: Maybe<Scalars['String']['output']>
    cta_modal_title: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    feature_list: Maybe<PrismicLinkType>
    features_title: Maybe<Scalars['String']['output']>
    footnote: Maybe<Scalars['String']['output']>
    included_users_text: Maybe<Scalars['String']['output']>
    per_month_text: Maybe<Scalars['String']['output']>
    pricing_model: Maybe<PrismicLinkType>
    tier_description: Maybe<Scalars['String']['output']>
    tier_name: Maybe<Scalars['String']['output']>
    tier_variant: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PricingTierDataTypeFieldSelector = {
    additional_users_cost_text: InputMaybe<FieldSelectorEnum>
    badge_text: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_modal_subtitle: InputMaybe<FieldSelectorEnum>
    cta_modal_title: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    feature_list: InputMaybe<PrismicLinkTypeFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    footnote: InputMaybe<FieldSelectorEnum>
    included_users_text: InputMaybe<FieldSelectorEnum>
    per_month_text: InputMaybe<FieldSelectorEnum>
    pricing_model: InputMaybe<PrismicLinkTypeFieldSelector>
    tier_description: InputMaybe<FieldSelectorEnum>
    tier_name: InputMaybe<FieldSelectorEnum>
    tier_variant: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3PricingTierDataTypeFilterInput = {
    additional_users_cost_text: InputMaybe<StringQueryOperatorInput>
    badge_text: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_modal_subtitle: InputMaybe<StringQueryOperatorInput>
    cta_modal_title: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    feature_list: InputMaybe<PrismicLinkTypeFilterInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    footnote: InputMaybe<StringQueryOperatorInput>
    included_users_text: InputMaybe<StringQueryOperatorInput>
    per_month_text: InputMaybe<StringQueryOperatorInput>
    pricing_model: InputMaybe<PrismicLinkTypeFilterInput>
    tier_description: InputMaybe<StringQueryOperatorInput>
    tier_name: InputMaybe<StringQueryOperatorInput>
    tier_variant: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3PricingTierDataTypeSortInput = {
    additional_users_cost_text: InputMaybe<SortOrderEnum>
    badge_text: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_modal_subtitle: InputMaybe<SortOrderEnum>
    cta_modal_title: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    feature_list: InputMaybe<PrismicLinkTypeSortInput>
    features_title: InputMaybe<SortOrderEnum>
    footnote: InputMaybe<SortOrderEnum>
    included_users_text: InputMaybe<SortOrderEnum>
    per_month_text: InputMaybe<SortOrderEnum>
    pricing_model: InputMaybe<PrismicLinkTypeSortInput>
    tier_description: InputMaybe<SortOrderEnum>
    tier_name: InputMaybe<SortOrderEnum>
    tier_variant: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3PricingTierEdge = {
    next: Maybe<PrismicPricingV3PricingTier>
    node: PrismicPricingV3PricingTier
    previous: Maybe<PrismicPricingV3PricingTier>
}

export type PrismicPricingV3PricingTierFeatureList = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV3PricingTierFeatureListDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PricingTierFeatureListFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PricingTierFeatureListLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3PricingTierFeatureListConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PricingTierFeatureListEdge>
    group: Array<PrismicPricingV3PricingTierFeatureListGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3PricingTierFeatureList>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PricingTierFeatureListConnectionDistinctArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListConnectionGroupArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PricingTierFeatureListConnectionMaxArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListConnectionMinArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListConnectionSumArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategory =
    PrismicSliceType & {
        id: Scalars['ID']['output']
        items: Array<PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategoryItem>
        primary: PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategoryPrimary
        slice_label: Maybe<Scalars['String']['output']>
        slice_type: Scalars['String']['output']
    }

export type PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategoryItem = {
    enabled: Maybe<Scalars['String']['output']>
    feature: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategoryPrimary = {
    category_title: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3PricingTierFeatureListDataBodySlicesType =
    PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategory

export type PrismicPricingV3PricingTierFeatureListDataType = {
    body: Array<PrismicPricingV3PricingTierFeatureListDataBodySlicesType>
}

export type PrismicPricingV3PricingTierFeatureListEdge = {
    next: Maybe<PrismicPricingV3PricingTierFeatureList>
    node: PrismicPricingV3PricingTierFeatureList
    previous: Maybe<PrismicPricingV3PricingTierFeatureList>
}

export type PrismicPricingV3PricingTierFeatureListFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3PricingTierFeatureListFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3PricingTierFeatureListGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PricingTierFeatureListEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV3PricingTierFeatureListGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3PricingTierFeatureList>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PricingTierFeatureListGroupConnectionDistinctArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListGroupConnectionGroupArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PricingTierFeatureListGroupConnectionMaxArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListGroupConnectionMinArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListGroupConnectionSumArgs = {
    field: PrismicPricingV3PricingTierFeatureListFieldSelector
}

export type PrismicPricingV3PricingTierFeatureListSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3PricingTierFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingV3PricingTierDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3PricingTierFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3PricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3PricingTierGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3PricingTierEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV3PricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3PricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3PricingTierGroupConnectionDistinctArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierGroupConnectionGroupArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3PricingTierGroupConnectionMaxArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierGroupConnectionMinArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierGroupConnectionSumArgs = {
    field: PrismicPricingV3PricingTierFieldSelector
}

export type PrismicPricingV3PricingTierSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingV3PricingTierDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3TierPricingModel = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicPricingV3TierPricingModelDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicPricingV3TierPricingModelFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3TierPricingModelLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicPricingV3TierPricingModelConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3TierPricingModelEdge>
    group: Array<PrismicPricingV3TierPricingModelGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3TierPricingModel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3TierPricingModelConnectionDistinctArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelConnectionGroupArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3TierPricingModelConnectionMaxArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelConnectionMinArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelConnectionSumArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelDataType = {
    additional_users_cost: Maybe<Scalars['Float']['output']>
    additional_users_cost_monthly: Maybe<Scalars['Float']['output']>
    additional_users_cost_yearly: Maybe<Scalars['Float']['output']>
    included_users: Maybe<Scalars['Float']['output']>
    max_users: Maybe<Scalars['Float']['output']>
    monthly_cost: Maybe<Scalars['Float']['output']>
    yearly_cost: Maybe<Scalars['Float']['output']>
}

export type PrismicPricingV3TierPricingModelDataTypeFieldSelector = {
    additional_users_cost: InputMaybe<FieldSelectorEnum>
    additional_users_cost_monthly: InputMaybe<FieldSelectorEnum>
    additional_users_cost_yearly: InputMaybe<FieldSelectorEnum>
    included_users: InputMaybe<FieldSelectorEnum>
    max_users: InputMaybe<FieldSelectorEnum>
    monthly_cost: InputMaybe<FieldSelectorEnum>
    yearly_cost: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3TierPricingModelDataTypeFilterInput = {
    additional_users_cost: InputMaybe<FloatQueryOperatorInput>
    additional_users_cost_monthly: InputMaybe<FloatQueryOperatorInput>
    additional_users_cost_yearly: InputMaybe<FloatQueryOperatorInput>
    included_users: InputMaybe<FloatQueryOperatorInput>
    max_users: InputMaybe<FloatQueryOperatorInput>
    monthly_cost: InputMaybe<FloatQueryOperatorInput>
    yearly_cost: InputMaybe<FloatQueryOperatorInput>
}

export type PrismicPricingV3TierPricingModelDataTypeSortInput = {
    additional_users_cost: InputMaybe<SortOrderEnum>
    additional_users_cost_monthly: InputMaybe<SortOrderEnum>
    additional_users_cost_yearly: InputMaybe<SortOrderEnum>
    included_users: InputMaybe<SortOrderEnum>
    max_users: InputMaybe<SortOrderEnum>
    monthly_cost: InputMaybe<SortOrderEnum>
    yearly_cost: InputMaybe<SortOrderEnum>
}

export type PrismicPricingV3TierPricingModelEdge = {
    next: Maybe<PrismicPricingV3TierPricingModel>
    node: PrismicPricingV3TierPricingModel
    previous: Maybe<PrismicPricingV3TierPricingModel>
}

export type PrismicPricingV3TierPricingModelFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicPricingV3TierPricingModelDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicPricingV3TierPricingModelFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3TierPricingModelDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicPricingV3TierPricingModelGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicPricingV3TierPricingModelEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicPricingV3TierPricingModelGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicPricingV3TierPricingModel>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicPricingV3TierPricingModelGroupConnectionDistinctArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelGroupConnectionGroupArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicPricingV3TierPricingModelGroupConnectionMaxArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelGroupConnectionMinArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelGroupConnectionSumArgs = {
    field: PrismicPricingV3TierPricingModelFieldSelector
}

export type PrismicPricingV3TierPricingModelSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicPricingV3TierPricingModelDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadges = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicProofPointBadgesDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicProofPointBadgesLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicProofPointBadgesConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicProofPointBadgesEdge>
    group: Array<PrismicProofPointBadgesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicProofPointBadges>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicProofPointBadgesConnectionDistinctArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesConnectionGroupArgs = {
    field: PrismicProofPointBadgesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesConnectionMaxArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesConnectionMinArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesConnectionSumArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesDataProofPointReviews = {
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesDataProofPointReviewsFieldSelector = {
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesDataProofPointReviewsFilterInput = {
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesDataProofPointReviewsFilterListInput = {
    elemMatch: InputMaybe<PrismicProofPointBadgesDataProofPointReviewsFilterInput>
}

export type PrismicProofPointBadgesDataProofPointReviewsSortInput = {
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesDataProofPointSecurity = {
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesDataProofPointSecurityFieldSelector = {
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesDataProofPointSecurityFilterInput = {
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesDataProofPointSecurityFilterListInput = {
    elemMatch: InputMaybe<PrismicProofPointBadgesDataProofPointSecurityFilterInput>
}

export type PrismicProofPointBadgesDataProofPointSecuritySortInput = {
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesDataType = {
    proof_point_reviews: Maybe<Array<Maybe<PrismicProofPointBadgesDataProofPointReviews>>>
    proof_point_security: Maybe<Array<Maybe<PrismicProofPointBadgesDataProofPointSecurity>>>
}

export type PrismicProofPointBadgesDataTypeFieldSelector = {
    proof_point_reviews: InputMaybe<PrismicProofPointBadgesDataProofPointReviewsFieldSelector>
    proof_point_security: InputMaybe<PrismicProofPointBadgesDataProofPointSecurityFieldSelector>
}

export type PrismicProofPointBadgesDataTypeFilterInput = {
    proof_point_reviews: InputMaybe<PrismicProofPointBadgesDataProofPointReviewsFilterListInput>
    proof_point_security: InputMaybe<PrismicProofPointBadgesDataProofPointSecurityFilterListInput>
}

export type PrismicProofPointBadgesDataTypeSortInput = {
    proof_point_reviews: InputMaybe<PrismicProofPointBadgesDataProofPointReviewsSortInput>
    proof_point_security: InputMaybe<PrismicProofPointBadgesDataProofPointSecuritySortInput>
}

export type PrismicProofPointBadgesEdge = {
    next: Maybe<PrismicProofPointBadges>
    node: PrismicProofPointBadges
    previous: Maybe<PrismicProofPointBadges>
}

export type PrismicProofPointBadgesFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicProofPointBadgesDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicProofPointBadgesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicProofPointBadgesEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicProofPointBadgesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicProofPointBadges>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicProofPointBadgesGroupConnectionDistinctArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesGroupConnectionGroupArgs = {
    field: PrismicProofPointBadgesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesGroupConnectionMaxArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesGroupConnectionMinArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesGroupConnectionSumArgs = {
    field: PrismicProofPointBadgesFieldSelector
}

export type PrismicProofPointBadgesRepeatable = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicProofPointBadgesRepeatableDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesRepeatableFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicProofPointBadgesRepeatableLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicProofPointBadgesRepeatableConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicProofPointBadgesRepeatableEdge>
    group: Array<PrismicProofPointBadgesRepeatableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicProofPointBadgesRepeatable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicProofPointBadgesRepeatableConnectionDistinctArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableConnectionGroupArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesRepeatableConnectionMaxArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableConnectionMinArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableConnectionSumArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirst = {
    icon: Maybe<PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstFieldSelector = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstFilterInput = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstFilterListInput = {
    elemMatch: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstFilterInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointFirstSortInput = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstIconImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecond = {
    icon: Maybe<PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondFieldSelector = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondFilterInput = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondFilterListInput = {
    elemMatch: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondFilterInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesRepeatableDataProofPointSecondSortInput = {
    icon: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondIconImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesRepeatableDataType = {
    proof_point_first: Maybe<Array<Maybe<PrismicProofPointBadgesRepeatableDataProofPointFirst>>>
    proof_point_second: Maybe<Array<Maybe<PrismicProofPointBadgesRepeatableDataProofPointSecond>>>
}

export type PrismicProofPointBadgesRepeatableDataTypeFieldSelector = {
    proof_point_first: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstFieldSelector>
    proof_point_second: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondFieldSelector>
}

export type PrismicProofPointBadgesRepeatableDataTypeFilterInput = {
    proof_point_first: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstFilterListInput>
    proof_point_second: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondFilterListInput>
}

export type PrismicProofPointBadgesRepeatableDataTypeSortInput = {
    proof_point_first: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointFirstSortInput>
    proof_point_second: InputMaybe<PrismicProofPointBadgesRepeatableDataProofPointSecondSortInput>
}

export type PrismicProofPointBadgesRepeatableEdge = {
    next: Maybe<PrismicProofPointBadgesRepeatable>
    node: PrismicProofPointBadgesRepeatable
    previous: Maybe<PrismicProofPointBadgesRepeatable>
}

export type PrismicProofPointBadgesRepeatableFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicProofPointBadgesRepeatableDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicProofPointBadgesRepeatableFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicProofPointBadgesRepeatableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicProofPointBadgesRepeatableGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicProofPointBadgesRepeatableEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicProofPointBadgesRepeatableGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicProofPointBadgesRepeatable>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicProofPointBadgesRepeatableGroupConnectionDistinctArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableGroupConnectionGroupArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicProofPointBadgesRepeatableGroupConnectionMaxArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableGroupConnectionMinArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableGroupConnectionSumArgs = {
    field: PrismicProofPointBadgesRepeatableFieldSelector
}

export type PrismicProofPointBadgesRepeatableSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicProofPointBadgesRepeatableDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicProofPointBadgesSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicProofPointBadgesDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRating = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicRatingDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRatingFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRatingLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRatingConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRatingEdge>
    group: Array<PrismicRatingGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRating>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRatingConnectionDistinctArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingConnectionGroupArgs = {
    field: PrismicRatingFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRatingConnectionMaxArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingConnectionMinArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingConnectionSumArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingDataLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRatingDataLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRatingDataLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRatingDataLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRatingDataLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRatingDataLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRatingDataLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRatingDataLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRatingDataType = {
    link: Maybe<Scalars['String']['output']>
    logo: Maybe<PrismicRatingDataLogoImageType>
    platform: Maybe<Scalars['String']['output']>
    rating_number: Maybe<Scalars['Float']['output']>
    stars: Maybe<Scalars['String']['output']>
}

export type PrismicRatingDataTypeFieldSelector = {
    link: InputMaybe<FieldSelectorEnum>
    logo: InputMaybe<PrismicRatingDataLogoImageTypeFieldSelector>
    platform: InputMaybe<FieldSelectorEnum>
    rating_number: InputMaybe<FieldSelectorEnum>
    stars: InputMaybe<FieldSelectorEnum>
}

export type PrismicRatingDataTypeFilterInput = {
    link: InputMaybe<StringQueryOperatorInput>
    logo: InputMaybe<PrismicRatingDataLogoImageTypeFilterInput>
    platform: InputMaybe<StringQueryOperatorInput>
    rating_number: InputMaybe<FloatQueryOperatorInput>
    stars: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRatingDataTypeSortInput = {
    link: InputMaybe<SortOrderEnum>
    logo: InputMaybe<PrismicRatingDataLogoImageTypeSortInput>
    platform: InputMaybe<SortOrderEnum>
    rating_number: InputMaybe<SortOrderEnum>
    stars: InputMaybe<SortOrderEnum>
}

export type PrismicRatingEdge = {
    next: Maybe<PrismicRating>
    node: PrismicRating
    previous: Maybe<PrismicRating>
}

export type PrismicRatingFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicRatingDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRatingFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRatingDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRatingGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRatingEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRatingGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRating>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRatingGroupConnectionDistinctArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingGroupConnectionGroupArgs = {
    field: PrismicRatingFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRatingGroupConnectionMaxArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingGroupConnectionMinArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingGroupConnectionSumArgs = {
    field: PrismicRatingFieldSelector
}

export type PrismicRatingSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicRatingDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRatingsGroup = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicRatingsGroupDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRatingsGroupFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRatingsGroupLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRatingsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRatingsGroupEdge>
    group: Array<PrismicRatingsGroupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRatingsGroup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRatingsGroupConnectionDistinctArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupConnectionGroupArgs = {
    field: PrismicRatingsGroupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRatingsGroupConnectionMaxArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupConnectionMinArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupConnectionSumArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupDataRatings = {
    rating: Maybe<PrismicLinkType>
}

export type PrismicRatingsGroupDataRatingsFieldSelector = {
    rating: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicRatingsGroupDataRatingsFilterInput = {
    rating: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicRatingsGroupDataRatingsFilterListInput = {
    elemMatch: InputMaybe<PrismicRatingsGroupDataRatingsFilterInput>
}

export type PrismicRatingsGroupDataRatingsSortInput = {
    rating: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicRatingsGroupDataType = {
    ratings: Maybe<Array<Maybe<PrismicRatingsGroupDataRatings>>>
}

export type PrismicRatingsGroupDataTypeFieldSelector = {
    ratings: InputMaybe<PrismicRatingsGroupDataRatingsFieldSelector>
}

export type PrismicRatingsGroupDataTypeFilterInput = {
    ratings: InputMaybe<PrismicRatingsGroupDataRatingsFilterListInput>
}

export type PrismicRatingsGroupDataTypeSortInput = {
    ratings: InputMaybe<PrismicRatingsGroupDataRatingsSortInput>
}

export type PrismicRatingsGroupEdge = {
    next: Maybe<PrismicRatingsGroup>
    node: PrismicRatingsGroup
    previous: Maybe<PrismicRatingsGroup>
}

export type PrismicRatingsGroupFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicRatingsGroupDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRatingsGroupFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRatingsGroupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRatingsGroupGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRatingsGroupEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRatingsGroupGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRatingsGroup>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRatingsGroupGroupConnectionDistinctArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupGroupConnectionGroupArgs = {
    field: PrismicRatingsGroupFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRatingsGroupGroupConnectionMaxArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupGroupConnectionMinArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupGroupConnectionSumArgs = {
    field: PrismicRatingsGroupFieldSelector
}

export type PrismicRatingsGroupSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicRatingsGroupDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicResourceDetailPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicResourceDetailPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicResourceDetailPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicResourceDetailPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicResourceDetailPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicResourceDetailPageEdge>
    group: Array<PrismicResourceDetailPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicResourceDetailPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicResourceDetailPageConnectionDistinctArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageConnectionGroupArgs = {
    field: PrismicResourceDetailPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicResourceDetailPageConnectionMaxArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageConnectionMinArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageConnectionSumArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicResourceDetailPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicResourceDetailPageDataThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicResourceDetailPageDataThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicResourceDetailPageDataType = {
    category: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    more_videos_section_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicResourceDetailPageDataOpenGraphImageImageType>
    thumbnail: Maybe<PrismicResourceDetailPageDataThumbnailImageType>
    title: Maybe<Scalars['String']['output']>
    tracking_id: Maybe<Scalars['String']['output']>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicResourceDetailPageDataTypeFieldSelector = {
    category: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    duration: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    more_videos_section_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicResourceDetailPageDataOpenGraphImageImageTypeFieldSelector>
    thumbnail: InputMaybe<PrismicResourceDetailPageDataThumbnailImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    tracking_id: InputMaybe<FieldSelectorEnum>
    wistia_video_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicResourceDetailPageDataTypeFilterInput = {
    category: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    duration: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    more_videos_section_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicResourceDetailPageDataOpenGraphImageImageTypeFilterInput>
    thumbnail: InputMaybe<PrismicResourceDetailPageDataThumbnailImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    tracking_id: InputMaybe<StringQueryOperatorInput>
    wistia_video_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicResourceDetailPageDataTypeSortInput = {
    category: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    duration: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    more_videos_section_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicResourceDetailPageDataOpenGraphImageImageTypeSortInput>
    thumbnail: InputMaybe<PrismicResourceDetailPageDataThumbnailImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    tracking_id: InputMaybe<SortOrderEnum>
    wistia_video_id: InputMaybe<SortOrderEnum>
}

export type PrismicResourceDetailPageEdge = {
    next: Maybe<PrismicResourceDetailPage>
    node: PrismicResourceDetailPage
    previous: Maybe<PrismicResourceDetailPage>
}

export type PrismicResourceDetailPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicResourceDetailPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicResourceDetailPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicResourceDetailPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicResourceDetailPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicResourceDetailPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicResourceDetailPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicResourceDetailPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicResourceDetailPageGroupConnectionDistinctArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageGroupConnectionGroupArgs = {
    field: PrismicResourceDetailPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicResourceDetailPageGroupConnectionMaxArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageGroupConnectionMinArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageGroupConnectionSumArgs = {
    field: PrismicResourceDetailPageFieldSelector
}

export type PrismicResourceDetailPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicResourceDetailPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicRoiCalculatorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRoiCalculatorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRoiCalculatorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorEdge>
    group: Array<PrismicRoiCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorConnectionDistinctArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorConnectionGroupArgs = {
    field: PrismicRoiCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorConnectionMaxArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorConnectionMinArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorConnectionSumArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorDataAvgExpenseAmount = {
    icon1: Maybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageType>
    icon2: Maybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageType>
    icon3: Maybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountFieldSelector = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountFilterInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountFilterInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgExpenseAmountSortInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalary = {
    icon1: Maybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageType>
    icon2: Maybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageType>
    icon3: Maybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryFieldSelector = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryFilterInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryFilterInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataAvgMonthlySalarySortInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomatic = {
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFilterInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticSortInput = {
    description: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManual = {
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualFilterInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodManualSortInput = {
    description: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomatic = {
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFilterInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticSortInput = {
    description: InputMaybe<SortOrderEnum>
    icon: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataFinal = {
    body: Maybe<Scalars['String']['output']>
    company_email_error: Maybe<Scalars['String']['output']>
    consent_label: Maybe<PrismicStructuredTextType>
    copy_sharable_link: Maybe<Scalars['String']['output']>
    download_now: Maybe<Scalars['String']['output']>
    download_pdf: Maybe<Scalars['String']['output']>
    email_label: Maybe<Scalars['String']['output']>
    email_placeholder: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataFinalFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    company_email_error: InputMaybe<FieldSelectorEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    copy_sharable_link: InputMaybe<FieldSelectorEnum>
    download_now: InputMaybe<FieldSelectorEnum>
    download_pdf: InputMaybe<FieldSelectorEnum>
    email_label: InputMaybe<FieldSelectorEnum>
    email_placeholder: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataFinalFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    company_email_error: InputMaybe<StringQueryOperatorInput>
    consent_label: InputMaybe<PrismicStructuredTextTypeFilterInput>
    copy_sharable_link: InputMaybe<StringQueryOperatorInput>
    download_now: InputMaybe<StringQueryOperatorInput>
    download_pdf: InputMaybe<StringQueryOperatorInput>
    email_label: InputMaybe<StringQueryOperatorInput>
    email_placeholder: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataFinalFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataFinalFilterInput>
}

export type PrismicRoiCalculatorDataFinalSortInput = {
    body: InputMaybe<SortOrderEnum>
    company_email_error: InputMaybe<SortOrderEnum>
    consent_label: InputMaybe<PrismicStructuredTextTypeSortInput>
    copy_sharable_link: InputMaybe<SortOrderEnum>
    download_now: InputMaybe<SortOrderEnum>
    download_pdf: InputMaybe<SortOrderEnum>
    email_label: InputMaybe<SortOrderEnum>
    email_placeholder: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculatorDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicRoiCalculatorDataFormProductionIntegrationType>
    node: PrismicRoiCalculatorDataFormProductionIntegrationType
    previous: Maybe<PrismicRoiCalculatorDataFormProductionIntegrationType>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculatorDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculatorDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicRoiCalculatorDataFormStagingIntegrationType>
    node: PrismicRoiCalculatorDataFormStagingIntegrationType
    previous: Maybe<PrismicRoiCalculatorDataFormStagingIntegrationType>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculatorDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicRoiCalculatorDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicRoiCalculatorDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicRoiCalculatorDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicRoiCalculatorDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataImperativeConsentsFilterInput>
}

export type PrismicRoiCalculatorDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicRoiCalculatorDataNumEmployees = {
    icon1: Maybe<PrismicRoiCalculatorDataNumEmployeesIcon1ImageType>
    icon2: Maybe<PrismicRoiCalculatorDataNumEmployeesIcon2ImageType>
    icon3: Maybe<PrismicRoiCalculatorDataNumEmployeesIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumEmployeesFieldSelector = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesFilterInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumEmployeesFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataNumEmployeesFilterInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumEmployeesSortInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumEmployeesIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumExpenses = {
    icon1: Maybe<PrismicRoiCalculatorDataNumExpensesIcon1ImageType>
    icon2: Maybe<PrismicRoiCalculatorDataNumExpensesIcon2ImageType>
    icon3: Maybe<PrismicRoiCalculatorDataNumExpensesIcon3ImageType>
    label: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumExpensesFieldSelector = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFieldSelector>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFieldSelector>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFieldSelector>
    label: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumExpensesFilterInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFilterInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFilterInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFilterInput>
    label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumExpensesFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataNumExpensesFilterInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataNumExpensesSortInput = {
    icon1: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon1ImageTypeSortInput>
    icon2: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon2ImageTypeSortInput>
    icon3: InputMaybe<PrismicRoiCalculatorDataNumExpensesIcon3ImageTypeSortInput>
    label: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataResults = {
    default_title: Maybe<Scalars['String']['output']>
    hours_per_year: Maybe<Scalars['String']['output']>
    money_saved: Maybe<Scalars['String']['output']>
    money_saved_icon: Maybe<PrismicRoiCalculatorDataResultsMoneySavedIconImageType>
    money_spent: Maybe<Scalars['String']['output']>
    per_year: Maybe<Scalars['String']['output']>
    time_saved: Maybe<Scalars['String']['output']>
    time_saved_icon: Maybe<PrismicRoiCalculatorDataResultsTimeSavedIconImageType>
    time_spent: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataResultsFieldSelector = {
    default_title: InputMaybe<FieldSelectorEnum>
    hours_per_year: InputMaybe<FieldSelectorEnum>
    money_saved: InputMaybe<FieldSelectorEnum>
    money_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFieldSelector>
    money_spent: InputMaybe<FieldSelectorEnum>
    per_year: InputMaybe<FieldSelectorEnum>
    time_saved: InputMaybe<FieldSelectorEnum>
    time_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFieldSelector>
    time_spent: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataResultsFilterInput = {
    default_title: InputMaybe<StringQueryOperatorInput>
    hours_per_year: InputMaybe<StringQueryOperatorInput>
    money_saved: InputMaybe<StringQueryOperatorInput>
    money_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFilterInput>
    money_spent: InputMaybe<StringQueryOperatorInput>
    per_year: InputMaybe<StringQueryOperatorInput>
    time_saved: InputMaybe<StringQueryOperatorInput>
    time_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFilterInput>
    time_spent: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataResultsFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataResultsFilterInput>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataResultsSortInput = {
    default_title: InputMaybe<SortOrderEnum>
    hours_per_year: InputMaybe<SortOrderEnum>
    money_saved: InputMaybe<SortOrderEnum>
    money_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsMoneySavedIconImageTypeSortInput>
    money_spent: InputMaybe<SortOrderEnum>
    per_year: InputMaybe<SortOrderEnum>
    time_saved: InputMaybe<SortOrderEnum>
    time_saved_icon: InputMaybe<PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeSortInput>
    time_spent: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataResultsTimeSavedIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorDataType = {
    avg_expense_amount: Maybe<Array<Maybe<PrismicRoiCalculatorDataAvgExpenseAmount>>>
    avg_monthly_salary: Maybe<Array<Maybe<PrismicRoiCalculatorDataAvgMonthlySalary>>>
    calculation_explanation: Maybe<Scalars['String']['output']>
    calculation_explanation_cta: Maybe<Scalars['String']['output']>
    close_preview: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    expense_handling_method_automatic: Maybe<
        Array<Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomatic>>
    >
    expense_handling_method_label: Maybe<Scalars['String']['output']>
    expense_handling_method_manual: Maybe<
        Array<Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodManual>>
    >
    expense_handling_method_semi_automatic: Maybe<
        Array<Maybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomatic>>
    >
    final: Maybe<Array<Maybe<PrismicRoiCalculatorDataFinal>>>
    form_production: Maybe<PrismicRoiCalculatorDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicRoiCalculatorDataFormStagingIntegrationType>
    imperative_consents: Maybe<Array<Maybe<PrismicRoiCalculatorDataImperativeConsents>>>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    next: Maybe<Scalars['String']['output']>
    num_employees: Maybe<Array<Maybe<PrismicRoiCalculatorDataNumEmployees>>>
    num_expenses: Maybe<Array<Maybe<PrismicRoiCalculatorDataNumExpenses>>>
    open_graph_image: Maybe<PrismicRoiCalculatorDataOpenGraphImageImageType>
    previous: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
    results: Maybe<Array<Maybe<PrismicRoiCalculatorDataResults>>>
    show_preview: Maybe<Scalars['String']['output']>
    welcome: Maybe<Array<Maybe<PrismicRoiCalculatorDataWelcome>>>
}

export type PrismicRoiCalculatorDataTypeFieldSelector = {
    avg_expense_amount: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountFieldSelector>
    avg_monthly_salary: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryFieldSelector>
    calculation_explanation: InputMaybe<FieldSelectorEnum>
    calculation_explanation_cta: InputMaybe<FieldSelectorEnum>
    close_preview: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    expense_handling_method_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFieldSelector>
    expense_handling_method_label: InputMaybe<FieldSelectorEnum>
    expense_handling_method_manual: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualFieldSelector>
    expense_handling_method_semi_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFieldSelector>
    final: InputMaybe<PrismicRoiCalculatorDataFinalFieldSelector>
    form_production: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicRoiCalculatorDataImperativeConsentsFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    next: InputMaybe<FieldSelectorEnum>
    num_employees: InputMaybe<PrismicRoiCalculatorDataNumEmployeesFieldSelector>
    num_expenses: InputMaybe<PrismicRoiCalculatorDataNumExpensesFieldSelector>
    open_graph_image: InputMaybe<PrismicRoiCalculatorDataOpenGraphImageImageTypeFieldSelector>
    previous: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
    results: InputMaybe<PrismicRoiCalculatorDataResultsFieldSelector>
    show_preview: InputMaybe<FieldSelectorEnum>
    welcome: InputMaybe<PrismicRoiCalculatorDataWelcomeFieldSelector>
}

export type PrismicRoiCalculatorDataTypeFilterInput = {
    avg_expense_amount: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountFilterListInput>
    avg_monthly_salary: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalaryFilterListInput>
    calculation_explanation: InputMaybe<StringQueryOperatorInput>
    calculation_explanation_cta: InputMaybe<StringQueryOperatorInput>
    close_preview: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    expense_handling_method_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticFilterListInput>
    expense_handling_method_label: InputMaybe<StringQueryOperatorInput>
    expense_handling_method_manual: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualFilterListInput>
    expense_handling_method_semi_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticFilterListInput>
    final: InputMaybe<PrismicRoiCalculatorDataFinalFilterListInput>
    form_production: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeFilterInput>
    imperative_consents: InputMaybe<PrismicRoiCalculatorDataImperativeConsentsFilterListInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    next: InputMaybe<StringQueryOperatorInput>
    num_employees: InputMaybe<PrismicRoiCalculatorDataNumEmployeesFilterListInput>
    num_expenses: InputMaybe<PrismicRoiCalculatorDataNumExpensesFilterListInput>
    open_graph_image: InputMaybe<PrismicRoiCalculatorDataOpenGraphImageImageTypeFilterInput>
    previous: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
    results: InputMaybe<PrismicRoiCalculatorDataResultsFilterListInput>
    show_preview: InputMaybe<StringQueryOperatorInput>
    welcome: InputMaybe<PrismicRoiCalculatorDataWelcomeFilterListInput>
}

export type PrismicRoiCalculatorDataTypeSortInput = {
    avg_expense_amount: InputMaybe<PrismicRoiCalculatorDataAvgExpenseAmountSortInput>
    avg_monthly_salary: InputMaybe<PrismicRoiCalculatorDataAvgMonthlySalarySortInput>
    calculation_explanation: InputMaybe<SortOrderEnum>
    calculation_explanation_cta: InputMaybe<SortOrderEnum>
    close_preview: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    expense_handling_method_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodAutomaticSortInput>
    expense_handling_method_label: InputMaybe<SortOrderEnum>
    expense_handling_method_manual: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodManualSortInput>
    expense_handling_method_semi_automatic: InputMaybe<PrismicRoiCalculatorDataExpenseHandlingMethodSemiAutomaticSortInput>
    final: InputMaybe<PrismicRoiCalculatorDataFinalSortInput>
    form_production: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeSortInput>
    imperative_consents: InputMaybe<PrismicRoiCalculatorDataImperativeConsentsSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    next: InputMaybe<SortOrderEnum>
    num_employees: InputMaybe<PrismicRoiCalculatorDataNumEmployeesSortInput>
    num_expenses: InputMaybe<PrismicRoiCalculatorDataNumExpensesSortInput>
    open_graph_image: InputMaybe<PrismicRoiCalculatorDataOpenGraphImageImageTypeSortInput>
    previous: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
    results: InputMaybe<PrismicRoiCalculatorDataResultsSortInput>
    show_preview: InputMaybe<SortOrderEnum>
    welcome: InputMaybe<PrismicRoiCalculatorDataWelcomeSortInput>
}

export type PrismicRoiCalculatorDataWelcome = {
    body: Maybe<Scalars['String']['output']>
    company_name_label: Maybe<Scalars['String']['output']>
    company_name_placeholder: Maybe<Scalars['String']['output']>
    skip: Maybe<Scalars['String']['output']>
    start: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoiCalculatorDataWelcomeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    company_name_label: InputMaybe<FieldSelectorEnum>
    company_name_placeholder: InputMaybe<FieldSelectorEnum>
    skip: InputMaybe<FieldSelectorEnum>
    start: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorDataWelcomeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    company_name_label: InputMaybe<StringQueryOperatorInput>
    company_name_placeholder: InputMaybe<StringQueryOperatorInput>
    skip: InputMaybe<StringQueryOperatorInput>
    start: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorDataWelcomeFilterListInput = {
    elemMatch: InputMaybe<PrismicRoiCalculatorDataWelcomeFilterInput>
}

export type PrismicRoiCalculatorDataWelcomeSortInput = {
    body: InputMaybe<SortOrderEnum>
    company_name_label: InputMaybe<SortOrderEnum>
    company_name_placeholder: InputMaybe<SortOrderEnum>
    skip: InputMaybe<SortOrderEnum>
    start: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoiCalculatorEdge = {
    next: Maybe<PrismicRoiCalculator>
    node: PrismicRoiCalculator
    previous: Maybe<PrismicRoiCalculator>
}

export type PrismicRoiCalculatorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicRoiCalculatorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoiCalculatorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRoiCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoiCalculatorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoiCalculatorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRoiCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoiCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoiCalculatorGroupConnectionDistinctArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorGroupConnectionGroupArgs = {
    field: PrismicRoiCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoiCalculatorGroupConnectionMaxArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorGroupConnectionMinArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorGroupConnectionSumArgs = {
    field: PrismicRoiCalculatorFieldSelector
}

export type PrismicRoiCalculatorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicRoiCalculatorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoicPreview = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicRoicPreviewDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoicPreviewFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRoicPreviewLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRoicPreviewConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoicPreviewEdge>
    group: Array<PrismicRoicPreviewGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoicPreview>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoicPreviewConnectionDistinctArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewConnectionGroupArgs = {
    field: PrismicRoicPreviewFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoicPreviewConnectionMaxArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewConnectionMinArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewConnectionSumArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewDataFeature = {
    body: Maybe<PrismicStructuredTextType>
    icon: Maybe<PrismicRoicPreviewDataFeatureIconImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicRoicPreviewDataFeatureFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    icon: InputMaybe<PrismicRoicPreviewDataFeatureIconImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoicPreviewDataFeatureFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    icon: InputMaybe<PrismicRoicPreviewDataFeatureIconImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoicPreviewDataFeatureFilterListInput = {
    elemMatch: InputMaybe<PrismicRoicPreviewDataFeatureFilterInput>
}

export type PrismicRoicPreviewDataFeatureIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoicPreviewDataFeatureIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRoicPreviewDataFeatureSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    icon: InputMaybe<PrismicRoicPreviewDataFeatureIconImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicRoicPreviewDataType = {
    average_claim_fix_time: Maybe<Scalars['String']['output']>
    average_claim_fix_time_link: Maybe<PrismicLinkType>
    average_claim_fix_time_text: Maybe<Scalars['String']['output']>
    average_processing_time: Maybe<PrismicStructuredTextType>
    average_processing_time_link: Maybe<PrismicLinkType>
    average_processing_time_text: Maybe<Scalars['String']['output']>
    average_processing_time_unit: Maybe<Scalars['String']['output']>
    company_name_replacement: Maybe<Scalars['String']['output']>
    cta_button_link: Maybe<PrismicLinkType>
    cta_button_text: Maybe<Scalars['String']['output']>
    cta_question: Maybe<Scalars['String']['output']>
    expense_claims_error: Maybe<Scalars['String']['output']>
    expense_claims_error_link: Maybe<PrismicLinkType>
    expense_claims_error_text: Maybe<Scalars['String']['output']>
    feature: Maybe<Array<Maybe<PrismicRoicPreviewDataFeature>>>
    feature_header: Maybe<Scalars['String']['output']>
    highlight_description: Maybe<Scalars['String']['output']>
    highlight_header: Maybe<Scalars['String']['output']>
    highlight_money_saved_text: Maybe<Scalars['String']['output']>
    highlight_time_saved_text: Maybe<Scalars['String']['output']>
    money_lost: Maybe<Scalars['String']['output']>
    money_lost_link: Maybe<PrismicLinkType>
    money_lost_text: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    processing_cost: Maybe<PrismicStructuredTextType>
    processing_cost_text: Maybe<Scalars['String']['output']>
    processing_method_automatic: Maybe<Scalars['String']['output']>
    processing_method_manual: Maybe<Scalars['String']['output']>
    processing_method_semi_automatic: Maybe<Scalars['String']['output']>
    roic_title: Maybe<Scalars['String']['output']>
    summary_description: Maybe<PrismicStructuredTextType>
    summary_title: Maybe<Scalars['String']['output']>
}

export type PrismicRoicPreviewDataTypeFieldSelector = {
    average_claim_fix_time: InputMaybe<FieldSelectorEnum>
    average_claim_fix_time_link: InputMaybe<PrismicLinkTypeFieldSelector>
    average_claim_fix_time_text: InputMaybe<FieldSelectorEnum>
    average_processing_time: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    average_processing_time_link: InputMaybe<PrismicLinkTypeFieldSelector>
    average_processing_time_text: InputMaybe<FieldSelectorEnum>
    average_processing_time_unit: InputMaybe<FieldSelectorEnum>
    company_name_replacement: InputMaybe<FieldSelectorEnum>
    cta_button_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_button_text: InputMaybe<FieldSelectorEnum>
    cta_question: InputMaybe<FieldSelectorEnum>
    expense_claims_error: InputMaybe<FieldSelectorEnum>
    expense_claims_error_link: InputMaybe<PrismicLinkTypeFieldSelector>
    expense_claims_error_text: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<PrismicRoicPreviewDataFeatureFieldSelector>
    feature_header: InputMaybe<FieldSelectorEnum>
    highlight_description: InputMaybe<FieldSelectorEnum>
    highlight_header: InputMaybe<FieldSelectorEnum>
    highlight_money_saved_text: InputMaybe<FieldSelectorEnum>
    highlight_time_saved_text: InputMaybe<FieldSelectorEnum>
    money_lost: InputMaybe<FieldSelectorEnum>
    money_lost_link: InputMaybe<PrismicLinkTypeFieldSelector>
    money_lost_text: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    processing_cost: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    processing_cost_text: InputMaybe<FieldSelectorEnum>
    processing_method_automatic: InputMaybe<FieldSelectorEnum>
    processing_method_manual: InputMaybe<FieldSelectorEnum>
    processing_method_semi_automatic: InputMaybe<FieldSelectorEnum>
    roic_title: InputMaybe<FieldSelectorEnum>
    summary_description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    summary_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoicPreviewDataTypeFilterInput = {
    average_claim_fix_time: InputMaybe<StringQueryOperatorInput>
    average_claim_fix_time_link: InputMaybe<PrismicLinkTypeFilterInput>
    average_claim_fix_time_text: InputMaybe<StringQueryOperatorInput>
    average_processing_time: InputMaybe<PrismicStructuredTextTypeFilterInput>
    average_processing_time_link: InputMaybe<PrismicLinkTypeFilterInput>
    average_processing_time_text: InputMaybe<StringQueryOperatorInput>
    average_processing_time_unit: InputMaybe<StringQueryOperatorInput>
    company_name_replacement: InputMaybe<StringQueryOperatorInput>
    cta_button_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_button_text: InputMaybe<StringQueryOperatorInput>
    cta_question: InputMaybe<StringQueryOperatorInput>
    expense_claims_error: InputMaybe<StringQueryOperatorInput>
    expense_claims_error_link: InputMaybe<PrismicLinkTypeFilterInput>
    expense_claims_error_text: InputMaybe<StringQueryOperatorInput>
    feature: InputMaybe<PrismicRoicPreviewDataFeatureFilterListInput>
    feature_header: InputMaybe<StringQueryOperatorInput>
    highlight_description: InputMaybe<StringQueryOperatorInput>
    highlight_header: InputMaybe<StringQueryOperatorInput>
    highlight_money_saved_text: InputMaybe<StringQueryOperatorInput>
    highlight_time_saved_text: InputMaybe<StringQueryOperatorInput>
    money_lost: InputMaybe<StringQueryOperatorInput>
    money_lost_link: InputMaybe<PrismicLinkTypeFilterInput>
    money_lost_text: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    processing_cost: InputMaybe<PrismicStructuredTextTypeFilterInput>
    processing_cost_text: InputMaybe<StringQueryOperatorInput>
    processing_method_automatic: InputMaybe<StringQueryOperatorInput>
    processing_method_manual: InputMaybe<StringQueryOperatorInput>
    processing_method_semi_automatic: InputMaybe<StringQueryOperatorInput>
    roic_title: InputMaybe<StringQueryOperatorInput>
    summary_description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    summary_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoicPreviewDataTypeSortInput = {
    average_claim_fix_time: InputMaybe<SortOrderEnum>
    average_claim_fix_time_link: InputMaybe<PrismicLinkTypeSortInput>
    average_claim_fix_time_text: InputMaybe<SortOrderEnum>
    average_processing_time: InputMaybe<PrismicStructuredTextTypeSortInput>
    average_processing_time_link: InputMaybe<PrismicLinkTypeSortInput>
    average_processing_time_text: InputMaybe<SortOrderEnum>
    average_processing_time_unit: InputMaybe<SortOrderEnum>
    company_name_replacement: InputMaybe<SortOrderEnum>
    cta_button_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_button_text: InputMaybe<SortOrderEnum>
    cta_question: InputMaybe<SortOrderEnum>
    expense_claims_error: InputMaybe<SortOrderEnum>
    expense_claims_error_link: InputMaybe<PrismicLinkTypeSortInput>
    expense_claims_error_text: InputMaybe<SortOrderEnum>
    feature: InputMaybe<PrismicRoicPreviewDataFeatureSortInput>
    feature_header: InputMaybe<SortOrderEnum>
    highlight_description: InputMaybe<SortOrderEnum>
    highlight_header: InputMaybe<SortOrderEnum>
    highlight_money_saved_text: InputMaybe<SortOrderEnum>
    highlight_time_saved_text: InputMaybe<SortOrderEnum>
    money_lost: InputMaybe<SortOrderEnum>
    money_lost_link: InputMaybe<PrismicLinkTypeSortInput>
    money_lost_text: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    processing_cost: InputMaybe<PrismicStructuredTextTypeSortInput>
    processing_cost_text: InputMaybe<SortOrderEnum>
    processing_method_automatic: InputMaybe<SortOrderEnum>
    processing_method_manual: InputMaybe<SortOrderEnum>
    processing_method_semi_automatic: InputMaybe<SortOrderEnum>
    roic_title: InputMaybe<SortOrderEnum>
    summary_description: InputMaybe<PrismicStructuredTextTypeSortInput>
    summary_title: InputMaybe<SortOrderEnum>
}

export type PrismicRoicPreviewEdge = {
    next: Maybe<PrismicRoicPreview>
    node: PrismicRoicPreview
    previous: Maybe<PrismicRoicPreview>
}

export type PrismicRoicPreviewFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicRoicPreviewDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRoicPreviewFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRoicPreviewDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRoicPreviewGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRoicPreviewEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRoicPreviewGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRoicPreview>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRoicPreviewGroupConnectionDistinctArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewGroupConnectionGroupArgs = {
    field: PrismicRoicPreviewFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRoicPreviewGroupConnectionMaxArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewGroupConnectionMinArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewGroupConnectionSumArgs = {
    field: PrismicRoicPreviewFieldSelector
}

export type PrismicRoicPreviewSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicRoicPreviewDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicRytisEbookDetails = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicRytisEbookDetailsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRytisEbookDetailsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicRytisEbookDetailsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRytisEbookDetailsEdge>
    group: Array<PrismicRytisEbookDetailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRytisEbookDetails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRytisEbookDetailsConnectionDistinctArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsConnectionGroupArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRytisEbookDetailsConnectionMaxArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsConnectionMinArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsConnectionSumArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsEdge = {
    next: Maybe<PrismicRytisEbookDetails>
    node: PrismicRytisEbookDetails
    previous: Maybe<PrismicRytisEbookDetails>
}

export type PrismicRytisEbookDetailsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicRytisEbookDetailsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicRytisEbookDetailsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicRytisEbookDetailsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicRytisEbookDetailsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicRytisEbookDetails>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicRytisEbookDetailsGroupConnectionDistinctArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsGroupConnectionGroupArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicRytisEbookDetailsGroupConnectionMaxArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsGroupConnectionMinArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsGroupConnectionSumArgs = {
    field: PrismicRytisEbookDetailsFieldSelector
}

export type PrismicRytisEbookDetailsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryHomepage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryHomepageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryHomepageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryHomepageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryHomepageEdge>
    group: Array<PrismicSecondaryHomepageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryHomepage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryHomepageConnectionDistinctArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageConnectionGroupArgs = {
    field: PrismicSecondaryHomepageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageConnectionMaxArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageConnectionMinArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageConnectionSumArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageDataBodyAnimationBlock = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSecondaryHomepageDataBodyAnimationBlockPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimary = {
    animation_frames: Maybe<Scalars['Float']['output']>
    description: Maybe<PrismicStructuredTextType>
    lottie_json_file: Maybe<PrismicLinkType>
    placeholder: Maybe<PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyAnimationBlockPrimaryPlaceholderImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCta = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItem>
    primary: PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItem = {
    logo: Maybe<PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageType>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyCustomerLogosPlusCtaPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    marquee_mode: Maybe<Scalars['Boolean']['output']>
    marquee_scroll_speed: Maybe<Scalars['String']['output']>
    stat_1_body: Maybe<Scalars['String']['output']>
    stat_1_highlight: Maybe<Scalars['String']['output']>
    stat_2_body: Maybe<Scalars['String']['output']>
    stat_2_highlight: Maybe<Scalars['String']['output']>
    stat_3_body: Maybe<Scalars['String']['output']>
    stat_3_highlight: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarquee = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItem>
    primary: PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItem = {
    link: Maybe<PrismicLinkType>
    logo: Maybe<PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageType>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimary = {
    body1: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    outline: Maybe<PrismicStructuredTextType>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanel = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSecondaryHomepageDataBodyFeaturePanelPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    content: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageType>
    is_media_on_the_right: Maybe<Scalars['Boolean']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    subtitle_color: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video: Maybe<PrismicLinkType>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryHomepageDataBodyFeaturePanelPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyGetStarted = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyGetStartedItem>
    primary: PrismicSecondaryHomepageDataBodyGetStartedPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyGetStartedItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    button_label: Maybe<Scalars['String']['output']>
    error_message: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    form_subtitle: Maybe<Scalars['String']['output']>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageType>
    input_placeholder: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    redirection_page: Maybe<PrismicLinkType>
    section_color: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType =
    Node & {
        children: Array<Node>
        consents: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents>
        formId: Maybe<Scalars['String']['output']>
        id: Scalars['ID']['output']
        internal: Internal
        parent: Maybe<Node>
        prismicId: Maybe<Scalars['String']['output']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    node: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
        group: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    node: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryHomepageDataBodyGetStartedPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyResourceSlider = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyResourceSliderItem>
    primary: PrismicSecondaryHomepageDataBodyResourceSliderPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyResourceSliderItem = {
    card_cta: Maybe<Scalars['String']['output']>
    card_description: Maybe<Scalars['String']['output']>
    card_image: Maybe<PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageType>
    card_title: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
    to: Maybe<PrismicLinkType>
}

export type PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyResourceSliderItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyResourceSliderPrimary = {
    description: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    top_link: Maybe<PrismicLinkType>
    top_link_text: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodySlicesType =
    | PrismicSecondaryHomepageDataBodyAnimationBlock
    | PrismicSecondaryHomepageDataBodyCustomerLogosPlusCta
    | PrismicSecondaryHomepageDataBodyFeatureBlockWithMarquee
    | PrismicSecondaryHomepageDataBodyFeaturePanel
    | PrismicSecondaryHomepageDataBodyGetStarted
    | PrismicSecondaryHomepageDataBodyResourceSlider
    | PrismicSecondaryHomepageDataBodyStickyNavSections
    | PrismicSecondaryHomepageDataBodyTest
    | PrismicSecondaryHomepageDataBodyUseCase
    | PrismicSecondaryHomepageDataBodyVideoHero

export type PrismicSecondaryHomepageDataBodyStickyNavSections = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyStickyNavSectionsItem>
    primary: PrismicSecondaryHomepageDataBodyStickyNavSectionsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItem = {
    card_1_body: Maybe<Scalars['String']['output']>
    card_1_image: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageType>
    card_1_title: Maybe<Scalars['String']['output']>
    card_1_video_mp4: Maybe<PrismicLinkType>
    card_1_video_poster: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageType>
    card_1_video_webm: Maybe<PrismicLinkType>
    card_2_body: Maybe<Scalars['String']['output']>
    card_2_image: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageType>
    card_2_title: Maybe<Scalars['String']['output']>
    card_2_video_mp4: Maybe<PrismicLinkType>
    card_2_video_poster: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageType>
    card_2_video_webm: Maybe<PrismicLinkType>
    card_3_body: Maybe<Scalars['String']['output']>
    card_3_image: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageType>
    card_3_title: Maybe<Scalars['String']['output']>
    card_3_video_mp4: Maybe<PrismicLinkType>
    card_3_video_poster: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageType>
    card_3_video_webm: Maybe<PrismicLinkType>
    image: Maybe<PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageType>
    subtitle: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard1VideoPosterImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard2VideoPosterImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3ImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsCard3VideoPosterImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyStickyNavSectionsPrimary = {
    cta_text: Maybe<Scalars['String']['output']>
    navigation_text: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyTest = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSecondaryHomepageDataBodyTestPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyTestPrimary = {
    test: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyUseCase = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyUseCaseItem>
    primary: PrismicSecondaryHomepageDataBodyUseCasePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyUseCaseItem = {
    icon: Maybe<PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageType>
    label: Maybe<Scalars['String']['output']>
    value: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryHomepageDataBodyUseCaseItemsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyUseCasePrimary = {
    cta: Maybe<Scalars['String']['output']>
    secondary_cta_label: Maybe<Scalars['String']['output']>
    secondary_cta_link: Maybe<PrismicLinkType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyVideoHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSecondaryHomepageDataBodyVideoHeroItem>
    primary: PrismicSecondaryHomepageDataBodyVideoHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSecondaryHomepageDataBodyVideoHeroItem = {
    social_proof_icon: Maybe<PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageType>
    social_proof_text: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyVideoHeroItemsSocialProofIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    lead_text: Maybe<PrismicStructuredTextType>
    signup_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_poster_image: Maybe<PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageType>
    video_poster_image_mobile: Maybe<PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSecondaryHomepageDataBodyVideoHeroPrimaryVideoPosterImageMobileImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSecondaryHomepageDataType = {
    body: Array<PrismicSecondaryHomepageDataBodySlicesType>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    track_visible_sections: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSecondaryHomepageDataTypeFieldSelector = {
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    track_visible_sections: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryHomepageDataTypeFilterInput = {
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    track_visible_sections: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicSecondaryHomepageDataTypeSortInput = {
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    track_visible_sections: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryHomepageEdge = {
    next: Maybe<PrismicSecondaryHomepage>
    node: PrismicSecondaryHomepage
    previous: Maybe<PrismicSecondaryHomepage>
}

export type PrismicSecondaryHomepageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryHomepageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryHomepageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryHomepageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryHomepageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryHomepageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryHomepageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryHomepage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryHomepageGroupConnectionDistinctArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageGroupConnectionGroupArgs = {
    field: PrismicSecondaryHomepageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryHomepageGroupConnectionMaxArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageGroupConnectionMinArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageGroupConnectionSumArgs = {
    field: PrismicSecondaryHomepageFieldSelector
}

export type PrismicSecondaryHomepageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryHomepageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalDocuments = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryLegalDocumentsDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalDocumentsFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryLegalDocumentsLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryLegalDocumentsConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryLegalDocumentsEdge>
    group: Array<PrismicSecondaryLegalDocumentsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryLegalDocuments>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryLegalDocumentsConnectionDistinctArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsConnectionGroupArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryLegalDocumentsConnectionMaxArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsConnectionMinArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsConnectionSumArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsDataDocuments = {
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalDocumentsDataDocumentsFieldSelector = {
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalDocumentsDataDocumentsFilterInput = {
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalDocumentsDataDocumentsFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryLegalDocumentsDataDocumentsFilterInput>
}

export type PrismicSecondaryLegalDocumentsDataDocumentsSortInput = {
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalDocumentsDataHistoricalDocuments = {
    document_title: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    link_text: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFieldSelector = {
    document_title: InputMaybe<FieldSelectorEnum>
    link: InputMaybe<PrismicLinkTypeFieldSelector>
    link_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFilterInput = {
    document_title: InputMaybe<StringQueryOperatorInput>
    link: InputMaybe<PrismicLinkTypeFilterInput>
    link_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFilterInput>
}

export type PrismicSecondaryLegalDocumentsDataHistoricalDocumentsSortInput = {
    document_title: InputMaybe<SortOrderEnum>
    link: InputMaybe<PrismicLinkTypeSortInput>
    link_text: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalDocumentsDataType = {
    documents: Maybe<Array<Maybe<PrismicSecondaryLegalDocumentsDataDocuments>>>
    historical_documents: Maybe<Array<Maybe<PrismicSecondaryLegalDocumentsDataHistoricalDocuments>>>
    historical_documents_title: Maybe<Scalars['String']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalDocumentsDataTypeFieldSelector = {
    documents: InputMaybe<PrismicSecondaryLegalDocumentsDataDocumentsFieldSelector>
    historical_documents: InputMaybe<PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFieldSelector>
    historical_documents_title: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalDocumentsDataTypeFilterInput = {
    documents: InputMaybe<PrismicSecondaryLegalDocumentsDataDocumentsFilterListInput>
    historical_documents: InputMaybe<PrismicSecondaryLegalDocumentsDataHistoricalDocumentsFilterListInput>
    historical_documents_title: InputMaybe<StringQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalDocumentsDataTypeSortInput = {
    documents: InputMaybe<PrismicSecondaryLegalDocumentsDataDocumentsSortInput>
    historical_documents: InputMaybe<PrismicSecondaryLegalDocumentsDataHistoricalDocumentsSortInput>
    historical_documents_title: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalDocumentsEdge = {
    next: Maybe<PrismicSecondaryLegalDocuments>
    node: PrismicSecondaryLegalDocuments
    previous: Maybe<PrismicSecondaryLegalDocuments>
}

export type PrismicSecondaryLegalDocumentsFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryLegalDocumentsDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalDocumentsFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryLegalDocumentsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalDocumentsGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryLegalDocumentsEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryLegalDocumentsGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryLegalDocuments>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryLegalDocumentsGroupConnectionDistinctArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsGroupConnectionGroupArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryLegalDocumentsGroupConnectionMaxArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsGroupConnectionMinArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsGroupConnectionSumArgs = {
    field: PrismicSecondaryLegalDocumentsFieldSelector
}

export type PrismicSecondaryLegalDocumentsSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryLegalDocumentsDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryLegalPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryLegalPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryLegalPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryLegalPageEdge>
    group: Array<PrismicSecondaryLegalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryLegalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryLegalPageConnectionDistinctArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageConnectionGroupArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryLegalPageConnectionMaxArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageConnectionMinArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageConnectionSumArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalPageDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSecondaryLegalPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryLegalPageDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalPageDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSecondaryLegalPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalPageDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSecondaryLegalPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryLegalPageEdge = {
    next: Maybe<PrismicSecondaryLegalPage>
    node: PrismicSecondaryLegalPage
    previous: Maybe<PrismicSecondaryLegalPage>
}

export type PrismicSecondaryLegalPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryLegalPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryLegalPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryLegalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryLegalPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryLegalPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryLegalPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryLegalPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryLegalPageGroupConnectionDistinctArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageGroupConnectionGroupArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryLegalPageGroupConnectionMaxArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageGroupConnectionMinArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageGroupConnectionSumArgs = {
    field: PrismicSecondaryLegalPageFieldSelector
}

export type PrismicSecondaryLegalPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryLegalPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryNotFoundPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryNotFoundPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryNotFoundPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryNotFoundPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryNotFoundPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryNotFoundPageEdge>
    group: Array<PrismicSecondaryNotFoundPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryNotFoundPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryNotFoundPageConnectionDistinctArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageConnectionGroupArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryNotFoundPageConnectionMaxArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageConnectionMinArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageConnectionSumArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryNotFoundPageDataType = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSecondaryNotFoundPageDataOpenGraphImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryNotFoundPageDataTypeFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryNotFoundPageDataTypeFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryNotFoundPageDataTypeSortInput = {
    body: InputMaybe<SortOrderEnum>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSecondaryNotFoundPageDataOpenGraphImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryNotFoundPageEdge = {
    next: Maybe<PrismicSecondaryNotFoundPage>
    node: PrismicSecondaryNotFoundPage
    previous: Maybe<PrismicSecondaryNotFoundPage>
}

export type PrismicSecondaryNotFoundPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryNotFoundPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryNotFoundPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryNotFoundPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryNotFoundPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryNotFoundPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryNotFoundPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryNotFoundPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryNotFoundPageGroupConnectionDistinctArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageGroupConnectionGroupArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryNotFoundPageGroupConnectionMaxArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageGroupConnectionMinArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageGroupConnectionSumArgs = {
    field: PrismicSecondaryNotFoundPageFieldSelector
}

export type PrismicSecondaryNotFoundPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryNotFoundPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryPricingPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingPageEdge>
    group: Array<PrismicSecondaryPricingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingPageConnectionDistinctArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageConnectionGroupArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageConnectionMaxArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageConnectionMinArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageConnectionSumArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageDataComparisonLayover = {
    advanced_description: Maybe<Scalars['String']['output']>
    beyond_description: Maybe<Scalars['String']['output']>
    essential_description: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    starter_description: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataComparisonLayoverFieldSelector = {
    advanced_description: InputMaybe<FieldSelectorEnum>
    beyond_description: InputMaybe<FieldSelectorEnum>
    essential_description: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    starter_description: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataComparisonLayoverFilterInput = {
    advanced_description: InputMaybe<StringQueryOperatorInput>
    beyond_description: InputMaybe<StringQueryOperatorInput>
    essential_description: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    starter_description: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataComparisonLayoverFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataComparisonLayoverFilterInput>
}

export type PrismicSecondaryPricingPageDataComparisonLayoverSortInput = {
    advanced_description: InputMaybe<SortOrderEnum>
    beyond_description: InputMaybe<SortOrderEnum>
    essential_description: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    starter_description: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataComparisonTables = {
    comparison_table: Maybe<PrismicLinkType>
}

export type PrismicSecondaryPricingPageDataComparisonTablesFieldSelector = {
    comparison_table: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSecondaryPricingPageDataComparisonTablesFilterInput = {
    comparison_table: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSecondaryPricingPageDataComparisonTablesFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataComparisonTablesFilterInput>
}

export type PrismicSecondaryPricingPageDataComparisonTablesSortInput = {
    comparison_table: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSecondaryPricingPageDataFeatureBlock = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSecondaryPricingPageDataFeatureBlockImageImageType>
}

export type PrismicSecondaryPricingPageDataFeatureBlockFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    heading: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFieldSelector>
}

export type PrismicSecondaryPricingPageDataFeatureBlockFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    heading: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFilterInput>
}

export type PrismicSecondaryPricingPageDataFeatureBlockFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockFilterInput>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataFeatureBlockSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    heading: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockImageImageTypeSortInput>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataQuestionsAnswers = {
    answer: Maybe<PrismicStructuredTextType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataQuestionsAnswersFieldSelector = {
    answer: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataQuestionsAnswersFilterInput = {
    answer: InputMaybe<PrismicStructuredTextTypeFilterInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataQuestionsAnswersFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataQuestionsAnswersFilterInput>
}

export type PrismicSecondaryPricingPageDataQuestionsAnswersSortInput = {
    answer: InputMaybe<PrismicStructuredTextTypeSortInput>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataTableTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataTables = {
    table: Maybe<PrismicLinkType>
}

export type PrismicSecondaryPricingPageDataTablesFieldSelector = {
    table: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSecondaryPricingPageDataTablesFilterInput = {
    table: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSecondaryPricingPageDataTablesFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataTablesFilterInput>
}

export type PrismicSecondaryPricingPageDataTablesSortInput = {
    table: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSecondaryPricingPageDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataType = {
    comparison_layover: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataComparisonLayover>>>
    comparison_tables: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataComparisonTables>>>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_block: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataFeatureBlock>>>
    is_v2: Maybe<Scalars['Boolean']['output']>
    locale_code: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSecondaryPricingPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    questions_answers: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataQuestionsAnswers>>>
    questions_title: Maybe<Scalars['String']['output']>
    show_tooltips: Maybe<Scalars['Boolean']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    table_title_image: Maybe<PrismicSecondaryPricingPageDataTableTitleImageImageType>
    tables: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataTables>>>
    tables_fine_print: Maybe<Scalars['String']['output']>
    tables_tick_screen_reader_alt: Maybe<Scalars['String']['output']>
    tables_title: Maybe<Scalars['String']['output']>
    testimonial: Maybe<PrismicLinkType>
    title: Maybe<PrismicStructuredTextType>
    title1: Maybe<PrismicStructuredTextType>
    title_image: Maybe<PrismicSecondaryPricingPageDataTitleImageImageType>
    why_pleo: Maybe<Array<Maybe<PrismicSecondaryPricingPageDataWhyPleo>>>
}

export type PrismicSecondaryPricingPageDataTypeFieldSelector = {
    comparison_layover: InputMaybe<PrismicSecondaryPricingPageDataComparisonLayoverFieldSelector>
    comparison_tables: InputMaybe<PrismicSecondaryPricingPageDataComparisonTablesFieldSelector>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_block: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockFieldSelector>
    is_v2: InputMaybe<FieldSelectorEnum>
    locale_code: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    questions_answers: InputMaybe<PrismicSecondaryPricingPageDataQuestionsAnswersFieldSelector>
    questions_title: InputMaybe<FieldSelectorEnum>
    show_tooltips: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    table_title_image: InputMaybe<PrismicSecondaryPricingPageDataTableTitleImageImageTypeFieldSelector>
    tables: InputMaybe<PrismicSecondaryPricingPageDataTablesFieldSelector>
    tables_fine_print: InputMaybe<FieldSelectorEnum>
    tables_tick_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    tables_title: InputMaybe<FieldSelectorEnum>
    testimonial: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title1: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    title_image: InputMaybe<PrismicSecondaryPricingPageDataTitleImageImageTypeFieldSelector>
    why_pleo: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoFieldSelector>
}

export type PrismicSecondaryPricingPageDataTypeFilterInput = {
    comparison_layover: InputMaybe<PrismicSecondaryPricingPageDataComparisonLayoverFilterListInput>
    comparison_tables: InputMaybe<PrismicSecondaryPricingPageDataComparisonTablesFilterListInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_block: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockFilterListInput>
    is_v2: InputMaybe<BooleanQueryOperatorInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSecondaryPricingPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    questions_answers: InputMaybe<PrismicSecondaryPricingPageDataQuestionsAnswersFilterListInput>
    questions_title: InputMaybe<StringQueryOperatorInput>
    show_tooltips: InputMaybe<BooleanQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    table_title_image: InputMaybe<PrismicSecondaryPricingPageDataTableTitleImageImageTypeFilterInput>
    tables: InputMaybe<PrismicSecondaryPricingPageDataTablesFilterListInput>
    tables_fine_print: InputMaybe<StringQueryOperatorInput>
    tables_tick_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    tables_title: InputMaybe<StringQueryOperatorInput>
    testimonial: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title1: InputMaybe<PrismicStructuredTextTypeFilterInput>
    title_image: InputMaybe<PrismicSecondaryPricingPageDataTitleImageImageTypeFilterInput>
    why_pleo: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoFilterListInput>
}

export type PrismicSecondaryPricingPageDataTypeSortInput = {
    comparison_layover: InputMaybe<PrismicSecondaryPricingPageDataComparisonLayoverSortInput>
    comparison_tables: InputMaybe<PrismicSecondaryPricingPageDataComparisonTablesSortInput>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_block: InputMaybe<PrismicSecondaryPricingPageDataFeatureBlockSortInput>
    is_v2: InputMaybe<SortOrderEnum>
    locale_code: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSecondaryPricingPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    questions_answers: InputMaybe<PrismicSecondaryPricingPageDataQuestionsAnswersSortInput>
    questions_title: InputMaybe<SortOrderEnum>
    show_tooltips: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    table_title_image: InputMaybe<PrismicSecondaryPricingPageDataTableTitleImageImageTypeSortInput>
    tables: InputMaybe<PrismicSecondaryPricingPageDataTablesSortInput>
    tables_fine_print: InputMaybe<SortOrderEnum>
    tables_tick_screen_reader_alt: InputMaybe<SortOrderEnum>
    tables_title: InputMaybe<SortOrderEnum>
    testimonial: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
    title1: InputMaybe<PrismicStructuredTextTypeSortInput>
    title_image: InputMaybe<PrismicSecondaryPricingPageDataTitleImageImageTypeSortInput>
    why_pleo: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoSortInput>
}

export type PrismicSecondaryPricingPageDataWhyPleo = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicSecondaryPricingPageDataWhyPleoImageImageType>
    pre_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataWhyPleoFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFieldSelector>
    pre_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataWhyPleoFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFilterInput>
    pre_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataWhyPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoFilterInput>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageDataWhyPleoImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageDataWhyPleoSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicSecondaryPricingPageDataWhyPleoImageImageTypeSortInput>
    pre_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingPageEdge = {
    next: Maybe<PrismicSecondaryPricingPage>
    node: PrismicSecondaryPricingPage
    previous: Maybe<PrismicSecondaryPricingPage>
}

export type PrismicSecondaryPricingPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryPricingPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryPricingPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingPageGroupConnectionDistinctArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageGroupConnectionGroupArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingPageGroupConnectionMaxArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageGroupConnectionMinArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageGroupConnectionSumArgs = {
    field: PrismicSecondaryPricingPageFieldSelector
}

export type PrismicSecondaryPricingPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryPricingPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTier = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryPricingTierDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTierFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingTierLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingTierConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTierEdge>
    group: Array<PrismicSecondaryPricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTierConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierConnectionGroupArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTierConnectionMaxArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierConnectionMinArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierConnectionSumArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierDataFeatures = {
    disabled_monthly: Maybe<Scalars['Boolean']['output']>
    feature: Maybe<Scalars['String']['output']>
    is_highlighted: Maybe<Scalars['Boolean']['output']>
    tooltip_text: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTierDataFeaturesFieldSelector = {
    disabled_monthly: InputMaybe<FieldSelectorEnum>
    feature: InputMaybe<FieldSelectorEnum>
    is_highlighted: InputMaybe<FieldSelectorEnum>
    tooltip_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTierDataFeaturesFilterInput = {
    disabled_monthly: InputMaybe<BooleanQueryOperatorInput>
    feature: InputMaybe<StringQueryOperatorInput>
    is_highlighted: InputMaybe<BooleanQueryOperatorInput>
    tooltip_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTierDataFeaturesFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTierDataFeaturesFilterInput>
}

export type PrismicSecondaryPricingTierDataFeaturesSortInput = {
    disabled_monthly: InputMaybe<SortOrderEnum>
    feature: InputMaybe<SortOrderEnum>
    is_highlighted: InputMaybe<SortOrderEnum>
    tooltip_text: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTierDataType = {
    annual_billing_screen_reader_alt: Maybe<Scalars['String']['output']>
    annual_cost: Maybe<Scalars['String']['output']>
    annual_cost_subtext_extra: Maybe<Scalars['String']['output']>
    annually_billed_cost: Maybe<Scalars['Float']['output']>
    annually_billed_user_cost: Maybe<Scalars['Float']['output']>
    cashback_text: Maybe<PrismicStructuredTextType>
    cost_subtext: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    cta_variant: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    features: Maybe<Array<Maybe<PrismicSecondaryPricingTierDataFeatures>>>
    features_title: Maybe<Scalars['String']['output']>
    footnote: Maybe<Scalars['String']['output']>
    free_users_included: Maybe<Scalars['Float']['output']>
    monthly_billed_cost: Maybe<Scalars['Float']['output']>
    monthly_billed_user_cost: Maybe<Scalars['Float']['output']>
    monthly_billing_screen_reader_alt: Maybe<Scalars['String']['output']>
    monthly_cost: Maybe<Scalars['String']['output']>
    monthly_cost_subtext_extra: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    open_additional_users_modal_text: Maybe<Scalars['String']['output']>
    per_month_text: Maybe<Scalars['String']['output']>
    second_footnote: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTierDataTypeFieldSelector = {
    annual_billing_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    annual_cost: InputMaybe<FieldSelectorEnum>
    annual_cost_subtext_extra: InputMaybe<FieldSelectorEnum>
    annually_billed_cost: InputMaybe<FieldSelectorEnum>
    annually_billed_user_cost: InputMaybe<FieldSelectorEnum>
    cashback_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cost_subtext: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    cta_variant: InputMaybe<FieldSelectorEnum>
    excerpt: InputMaybe<FieldSelectorEnum>
    features: InputMaybe<PrismicSecondaryPricingTierDataFeaturesFieldSelector>
    features_title: InputMaybe<FieldSelectorEnum>
    footnote: InputMaybe<FieldSelectorEnum>
    free_users_included: InputMaybe<FieldSelectorEnum>
    monthly_billed_cost: InputMaybe<FieldSelectorEnum>
    monthly_billed_user_cost: InputMaybe<FieldSelectorEnum>
    monthly_billing_screen_reader_alt: InputMaybe<FieldSelectorEnum>
    monthly_cost: InputMaybe<FieldSelectorEnum>
    monthly_cost_subtext_extra: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    open_additional_users_modal_text: InputMaybe<FieldSelectorEnum>
    per_month_text: InputMaybe<FieldSelectorEnum>
    second_footnote: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTierDataTypeFilterInput = {
    annual_billing_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    annual_cost: InputMaybe<StringQueryOperatorInput>
    annual_cost_subtext_extra: InputMaybe<StringQueryOperatorInput>
    annually_billed_cost: InputMaybe<FloatQueryOperatorInput>
    annually_billed_user_cost: InputMaybe<FloatQueryOperatorInput>
    cashback_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cost_subtext: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    cta_variant: InputMaybe<StringQueryOperatorInput>
    excerpt: InputMaybe<StringQueryOperatorInput>
    features: InputMaybe<PrismicSecondaryPricingTierDataFeaturesFilterListInput>
    features_title: InputMaybe<StringQueryOperatorInput>
    footnote: InputMaybe<StringQueryOperatorInput>
    free_users_included: InputMaybe<FloatQueryOperatorInput>
    monthly_billed_cost: InputMaybe<FloatQueryOperatorInput>
    monthly_billed_user_cost: InputMaybe<FloatQueryOperatorInput>
    monthly_billing_screen_reader_alt: InputMaybe<StringQueryOperatorInput>
    monthly_cost: InputMaybe<StringQueryOperatorInput>
    monthly_cost_subtext_extra: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    open_additional_users_modal_text: InputMaybe<StringQueryOperatorInput>
    per_month_text: InputMaybe<StringQueryOperatorInput>
    second_footnote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTierDataTypeSortInput = {
    annual_billing_screen_reader_alt: InputMaybe<SortOrderEnum>
    annual_cost: InputMaybe<SortOrderEnum>
    annual_cost_subtext_extra: InputMaybe<SortOrderEnum>
    annually_billed_cost: InputMaybe<SortOrderEnum>
    annually_billed_user_cost: InputMaybe<SortOrderEnum>
    cashback_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    cost_subtext: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    cta_variant: InputMaybe<SortOrderEnum>
    excerpt: InputMaybe<SortOrderEnum>
    features: InputMaybe<PrismicSecondaryPricingTierDataFeaturesSortInput>
    features_title: InputMaybe<SortOrderEnum>
    footnote: InputMaybe<SortOrderEnum>
    free_users_included: InputMaybe<SortOrderEnum>
    monthly_billed_cost: InputMaybe<SortOrderEnum>
    monthly_billed_user_cost: InputMaybe<SortOrderEnum>
    monthly_billing_screen_reader_alt: InputMaybe<SortOrderEnum>
    monthly_cost: InputMaybe<SortOrderEnum>
    monthly_cost_subtext_extra: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    open_additional_users_modal_text: InputMaybe<SortOrderEnum>
    per_month_text: InputMaybe<SortOrderEnum>
    second_footnote: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTierEdge = {
    next: Maybe<PrismicSecondaryPricingTier>
    node: PrismicSecondaryPricingTier
    previous: Maybe<PrismicSecondaryPricingTier>
}

export type PrismicSecondaryPricingTierFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryPricingTierDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTierFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTierGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTierEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryPricingTierGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTier>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTierGroupConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierGroupConnectionGroupArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTierGroupConnectionMaxArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierGroupConnectionMinArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierGroupConnectionSumArgs = {
    field: PrismicSecondaryPricingTierFieldSelector
}

export type PrismicSecondaryPricingTierSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryPricingTierDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiers = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSecondaryPricingTiersDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingTiersLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSecondaryPricingTiersConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersEdge>
    group: Array<PrismicSecondaryPricingTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersConnectionGroupArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersDataAdditionalUsersModal = {
    description: Maybe<PrismicStructuredTextType>
    table: Maybe<PrismicLinkType>
    title1: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataAdditionalUsersModalFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    table: InputMaybe<PrismicLinkTypeFieldSelector>
    title1: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataAdditionalUsersModalFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    table: InputMaybe<PrismicLinkTypeFilterInput>
    title1: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataAdditionalUsersModalFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataAdditionalUsersModalFilterInput>
}

export type PrismicSecondaryPricingTiersDataAdditionalUsersModalSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    table: InputMaybe<PrismicLinkTypeSortInput>
    title1: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataBillingCycle = {
    billed_monthly_label: Maybe<Scalars['String']['output']>
    billed_yearly_label: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    legend: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataBillingCycleFieldSelector = {
    billed_monthly_label: InputMaybe<FieldSelectorEnum>
    billed_yearly_label: InputMaybe<FieldSelectorEnum>
    description: InputMaybe<FieldSelectorEnum>
    legend: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataBillingCycleFilterInput = {
    billed_monthly_label: InputMaybe<StringQueryOperatorInput>
    billed_yearly_label: InputMaybe<StringQueryOperatorInput>
    description: InputMaybe<StringQueryOperatorInput>
    legend: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataBillingCycleFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataBillingCycleFilterInput>
}

export type PrismicSecondaryPricingTiersDataBillingCycleSortInput = {
    billed_monthly_label: InputMaybe<SortOrderEnum>
    billed_yearly_label: InputMaybe<SortOrderEnum>
    description: InputMaybe<SortOrderEnum>
    legend: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
    node: PrismicSecondaryPricingTiersDataFormProductionIntegrationType
    previous: Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
    node: PrismicSecondaryPricingTiersDataFormStagingIntegrationType
    previous: Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicSecondaryPricingTiersDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSecondaryPricingTiersDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSecondaryPricingTiersDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataImperativeConsentsFilterInput>
}

export type PrismicSecondaryPricingTiersDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSecondaryPricingTiersDataPricingTiers = {
    pricing_tier: Maybe<PrismicLinkType>
}

export type PrismicSecondaryPricingTiersDataPricingTiersFieldSelector = {
    pricing_tier: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSecondaryPricingTiersDataPricingTiersFilterInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSecondaryPricingTiersDataPricingTiersFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataPricingTiersFilterInput>
}

export type PrismicSecondaryPricingTiersDataPricingTiersSortInput = {
    pricing_tier: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalFree = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSecondaryPricingTiersDataSignupModalFreeImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeFilterInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalFreeSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalPro = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSecondaryPricingTiersDataSignupModalProImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataSignupModalProFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalProFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalProFilterListInput = {
    elemMatch: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProFilterInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataSignupModalProSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersDataTitleImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSecondaryPricingTiersDataType = {
    additional_users_modal: Maybe<
        Array<Maybe<PrismicSecondaryPricingTiersDataAdditionalUsersModal>>
    >
    billing_cycle: Maybe<Array<Maybe<PrismicSecondaryPricingTiersDataBillingCycle>>>
    billing_monthly_label_v2: Maybe<Scalars['String']['output']>
    billing_yearly_label_v2: Maybe<Scalars['String']['output']>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    form_production: Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
    imperative_consents: Maybe<Array<Maybe<PrismicSecondaryPricingTiersDataImperativeConsents>>>
    locale_code: Maybe<Scalars['String']['output']>
    pricing_tiers: Maybe<Array<Maybe<PrismicSecondaryPricingTiersDataPricingTiers>>>
    read_more_text: Maybe<Scalars['String']['output']>
    show_ctas: Maybe<Scalars['Boolean']['output']>
    signup_modal_free: Maybe<Array<Maybe<PrismicSecondaryPricingTiersDataSignupModalFree>>>
    signup_modal_pro: Maybe<Array<Maybe<PrismicSecondaryPricingTiersDataSignupModalPro>>>
    slider_label: Maybe<Scalars['String']['output']>
    slider_sub_text: Maybe<PrismicStructuredTextType>
    slider_tooltip_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_image: Maybe<PrismicSecondaryPricingTiersDataTitleImageImageType>
}

export type PrismicSecondaryPricingTiersDataTypeFieldSelector = {
    additional_users_modal: InputMaybe<PrismicSecondaryPricingTiersDataAdditionalUsersModalFieldSelector>
    billing_cycle: InputMaybe<PrismicSecondaryPricingTiersDataBillingCycleFieldSelector>
    billing_monthly_label_v2: InputMaybe<FieldSelectorEnum>
    billing_yearly_label_v2: InputMaybe<FieldSelectorEnum>
    exclude_production: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicSecondaryPricingTiersDataImperativeConsentsFieldSelector>
    locale_code: InputMaybe<FieldSelectorEnum>
    pricing_tiers: InputMaybe<PrismicSecondaryPricingTiersDataPricingTiersFieldSelector>
    read_more_text: InputMaybe<FieldSelectorEnum>
    show_ctas: InputMaybe<FieldSelectorEnum>
    signup_modal_free: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeFieldSelector>
    signup_modal_pro: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProFieldSelector>
    slider_label: InputMaybe<FieldSelectorEnum>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    slider_tooltip_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    title_image: InputMaybe<PrismicSecondaryPricingTiersDataTitleImageImageTypeFieldSelector>
}

export type PrismicSecondaryPricingTiersDataTypeFilterInput = {
    additional_users_modal: InputMaybe<PrismicSecondaryPricingTiersDataAdditionalUsersModalFilterListInput>
    billing_cycle: InputMaybe<PrismicSecondaryPricingTiersDataBillingCycleFilterListInput>
    billing_monthly_label_v2: InputMaybe<StringQueryOperatorInput>
    billing_yearly_label_v2: InputMaybe<StringQueryOperatorInput>
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    form_production: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFilterInput>
    imperative_consents: InputMaybe<PrismicSecondaryPricingTiersDataImperativeConsentsFilterListInput>
    locale_code: InputMaybe<StringQueryOperatorInput>
    pricing_tiers: InputMaybe<PrismicSecondaryPricingTiersDataPricingTiersFilterListInput>
    read_more_text: InputMaybe<StringQueryOperatorInput>
    show_ctas: InputMaybe<BooleanQueryOperatorInput>
    signup_modal_free: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeFilterListInput>
    signup_modal_pro: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProFilterListInput>
    slider_label: InputMaybe<StringQueryOperatorInput>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    slider_tooltip_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    title_image: InputMaybe<PrismicSecondaryPricingTiersDataTitleImageImageTypeFilterInput>
}

export type PrismicSecondaryPricingTiersDataTypeSortInput = {
    additional_users_modal: InputMaybe<PrismicSecondaryPricingTiersDataAdditionalUsersModalSortInput>
    billing_cycle: InputMaybe<PrismicSecondaryPricingTiersDataBillingCycleSortInput>
    billing_monthly_label_v2: InputMaybe<SortOrderEnum>
    billing_yearly_label_v2: InputMaybe<SortOrderEnum>
    exclude_production: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeSortInput>
    imperative_consents: InputMaybe<PrismicSecondaryPricingTiersDataImperativeConsentsSortInput>
    locale_code: InputMaybe<SortOrderEnum>
    pricing_tiers: InputMaybe<PrismicSecondaryPricingTiersDataPricingTiersSortInput>
    read_more_text: InputMaybe<SortOrderEnum>
    show_ctas: InputMaybe<SortOrderEnum>
    signup_modal_free: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalFreeSortInput>
    signup_modal_pro: InputMaybe<PrismicSecondaryPricingTiersDataSignupModalProSortInput>
    slider_label: InputMaybe<SortOrderEnum>
    slider_sub_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    slider_tooltip_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    title_image: InputMaybe<PrismicSecondaryPricingTiersDataTitleImageImageTypeSortInput>
}

export type PrismicSecondaryPricingTiersEdge = {
    next: Maybe<PrismicSecondaryPricingTiers>
    node: PrismicSecondaryPricingTiers
    previous: Maybe<PrismicSecondaryPricingTiers>
}

export type PrismicSecondaryPricingTiersFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSecondaryPricingTiersDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSecondaryPricingTiersFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSecondaryPricingTiersGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSecondaryPricingTiersEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSecondaryPricingTiersGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSecondaryPricingTiers>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSecondaryPricingTiersGroupConnectionDistinctArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersGroupConnectionGroupArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSecondaryPricingTiersGroupConnectionMaxArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersGroupConnectionMinArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersGroupConnectionSumArgs = {
    field: PrismicSecondaryPricingTiersFieldSelector
}

export type PrismicSecondaryPricingTiersSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSecondaryPricingTiersDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSeo = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSeoDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSeoFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSeoLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSeoConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSeoEdge>
    group: Array<PrismicSeoGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSeo>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSeoConnectionDistinctArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoConnectionGroupArgs = {
    field: PrismicSeoFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSeoConnectionMaxArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoConnectionMinArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoConnectionSumArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoDataDefaultOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSeoDataDefaultOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSeoDataKeywords = {
    keyword: Maybe<Scalars['String']['output']>
}

export type PrismicSeoDataKeywordsFieldSelector = {
    keyword: InputMaybe<FieldSelectorEnum>
}

export type PrismicSeoDataKeywordsFilterInput = {
    keyword: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSeoDataKeywordsFilterListInput = {
    elemMatch: InputMaybe<PrismicSeoDataKeywordsFilterInput>
}

export type PrismicSeoDataKeywordsSortInput = {
    keyword: InputMaybe<SortOrderEnum>
}

export type PrismicSeoDataType = {
    default_open_graph_image: Maybe<PrismicSeoDataDefaultOpenGraphImageImageType>
    description: Maybe<Scalars['String']['output']>
    keywords: Maybe<Array<Maybe<PrismicSeoDataKeywords>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSeoDataTypeFieldSelector = {
    default_open_graph_image: InputMaybe<PrismicSeoDataDefaultOpenGraphImageImageTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    keywords: InputMaybe<PrismicSeoDataKeywordsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSeoDataTypeFilterInput = {
    default_open_graph_image: InputMaybe<PrismicSeoDataDefaultOpenGraphImageImageTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    keywords: InputMaybe<PrismicSeoDataKeywordsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSeoDataTypeSortInput = {
    default_open_graph_image: InputMaybe<PrismicSeoDataDefaultOpenGraphImageImageTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    keywords: InputMaybe<PrismicSeoDataKeywordsSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSeoEdge = {
    next: Maybe<PrismicSeo>
    node: PrismicSeo
    previous: Maybe<PrismicSeo>
}

export type PrismicSeoFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSeoDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSeoFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSeoDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSeoGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSeoEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSeoGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSeo>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSeoGroupConnectionDistinctArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoGroupConnectionGroupArgs = {
    field: PrismicSeoFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSeoGroupConnectionMaxArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoGroupConnectionMinArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoGroupConnectionSumArgs = {
    field: PrismicSeoFieldSelector
}

export type PrismicSeoSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSeoDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSharedSliceType = {
    id: Scalars['ID']['output']
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
    variation: Scalars['String']['output']
    version: Scalars['String']['output']
}

export type PrismicSignUpModal = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignUpModalDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignUpModalFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignUpModalLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignUpModalConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalEdge>
    group: Array<PrismicSignUpModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalConnectionDistinctArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalConnectionGroupArgs = {
    field: PrismicSignUpModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalConnectionMaxArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalConnectionMinArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalConnectionSumArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSignUpModalDataFormProductionIntegrationType>
    node: PrismicSignUpModalDataFormProductionIntegrationType
    previous: Maybe<PrismicSignUpModalDataFormProductionIntegrationType>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicSignUpModalDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSignUpModalDataFormStagingIntegrationType>
    node: PrismicSignUpModalDataFormStagingIntegrationType
    previous: Maybe<PrismicSignUpModalDataFormStagingIntegrationType>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignUpModalDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicSignUpModalDataSignupModal = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSignUpModalDataSignupModalImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignUpModalDataSignupModalFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSignUpModalDataSignupModalImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignUpModalDataSignupModalFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSignUpModalDataSignupModalImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignUpModalDataSignupModalFilterListInput = {
    elemMatch: InputMaybe<PrismicSignUpModalDataSignupModalFilterInput>
}

export type PrismicSignUpModalDataSignupModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignUpModalDataSignupModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignUpModalDataSignupModalSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSignUpModalDataSignupModalImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignUpModalDataType = {
    form_production: Maybe<PrismicSignUpModalDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicSignUpModalDataFormStagingIntegrationType>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    signup_modal: Maybe<Array<Maybe<PrismicSignUpModalDataSignupModal>>>
}

export type PrismicSignUpModalDataTypeFieldSelector = {
    form_production: InputMaybe<PrismicSignUpModalDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicSignUpModalDataFormStagingIntegrationTypeFieldSelector>
    hubspot_form_id_production: InputMaybe<FieldSelectorEnum>
    hubspot_form_id_staging: InputMaybe<FieldSelectorEnum>
    signup_modal: InputMaybe<PrismicSignUpModalDataSignupModalFieldSelector>
}

export type PrismicSignUpModalDataTypeFilterInput = {
    form_production: InputMaybe<PrismicSignUpModalDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicSignUpModalDataFormStagingIntegrationTypeFilterInput>
    hubspot_form_id_production: InputMaybe<StringQueryOperatorInput>
    hubspot_form_id_staging: InputMaybe<StringQueryOperatorInput>
    signup_modal: InputMaybe<PrismicSignUpModalDataSignupModalFilterListInput>
}

export type PrismicSignUpModalDataTypeSortInput = {
    form_production: InputMaybe<PrismicSignUpModalDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicSignUpModalDataFormStagingIntegrationTypeSortInput>
    hubspot_form_id_production: InputMaybe<SortOrderEnum>
    hubspot_form_id_staging: InputMaybe<SortOrderEnum>
    signup_modal: InputMaybe<PrismicSignUpModalDataSignupModalSortInput>
}

export type PrismicSignUpModalEdge = {
    next: Maybe<PrismicSignUpModal>
    node: PrismicSignUpModal
    previous: Maybe<PrismicSignUpModal>
}

export type PrismicSignUpModalFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignUpModalDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignUpModalFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignUpModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignUpModalGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignUpModalEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignUpModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignUpModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignUpModalGroupConnectionDistinctArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalGroupConnectionGroupArgs = {
    field: PrismicSignUpModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignUpModalGroupConnectionMaxArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalGroupConnectionMinArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalGroupConnectionSumArgs = {
    field: PrismicSignUpModalFieldSelector
}

export type PrismicSignUpModalSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignUpModalDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBanner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupBannerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupBannerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupBannerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerEdge>
    group: Array<PrismicSignupBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerConnectionDistinctArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerConnectionGroupArgs = {
    field: PrismicSignupBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerConnectionMaxArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerConnectionMinArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerConnectionSumArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBannerDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSignupBannerDataFormProductionIntegrationType>
    node: PrismicSignupBannerDataFormProductionIntegrationType
    previous: Maybe<PrismicSignupBannerDataFormProductionIntegrationType>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBannerDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBannerDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSignupBannerDataFormStagingIntegrationType>
    node: PrismicSignupBannerDataFormStagingIntegrationType
    previous: Maybe<PrismicSignupBannerDataFormStagingIntegrationType>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBannerDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupBannerDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupBannerDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupBannerDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupBannerDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerDataImperativeConsents = {
    production: Maybe<PrismicLinkType>
    staging: Maybe<PrismicLinkType>
}

export type PrismicSignupBannerDataImperativeConsentsFieldSelector = {
    production: InputMaybe<PrismicLinkTypeFieldSelector>
    staging: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSignupBannerDataImperativeConsentsFilterInput = {
    production: InputMaybe<PrismicLinkTypeFilterInput>
    staging: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSignupBannerDataImperativeConsentsFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupBannerDataImperativeConsentsFilterInput>
}

export type PrismicSignupBannerDataImperativeConsentsSortInput = {
    production: InputMaybe<PrismicLinkTypeSortInput>
    staging: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSignupBannerDataType = {
    aria_label: Maybe<Scalars['String']['output']>
    disclaimer_copy: Maybe<PrismicStructuredTextType>
    disclaimer_text: Maybe<Scalars['String']['output']>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_name: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicSignupBannerDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicSignupBannerDataFormStagingIntegrationType>
    image: Maybe<PrismicSignupBannerDataImageImageType>
    imperative_consents: Maybe<Array<Maybe<PrismicSignupBannerDataImperativeConsents>>>
    partner_signup_redirect: Maybe<Scalars['Boolean']['output']>
    redirect_link: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupBannerDataTypeFieldSelector = {
    aria_label: InputMaybe<FieldSelectorEnum>
    disclaimer_copy: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    disclaimer_text: InputMaybe<FieldSelectorEnum>
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    form_name: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeFieldSelector>
    image: InputMaybe<PrismicSignupBannerDataImageImageTypeFieldSelector>
    imperative_consents: InputMaybe<PrismicSignupBannerDataImperativeConsentsFieldSelector>
    partner_signup_redirect: InputMaybe<FieldSelectorEnum>
    redirect_link: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerDataTypeFilterInput = {
    aria_label: InputMaybe<StringQueryOperatorInput>
    disclaimer_copy: InputMaybe<PrismicStructuredTextTypeFilterInput>
    disclaimer_text: InputMaybe<StringQueryOperatorInput>
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    form_name: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeFilterInput>
    image: InputMaybe<PrismicSignupBannerDataImageImageTypeFilterInput>
    imperative_consents: InputMaybe<PrismicSignupBannerDataImperativeConsentsFilterListInput>
    partner_signup_redirect: InputMaybe<BooleanQueryOperatorInput>
    redirect_link: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerDataTypeSortInput = {
    aria_label: InputMaybe<SortOrderEnum>
    disclaimer_copy: InputMaybe<PrismicStructuredTextTypeSortInput>
    disclaimer_text: InputMaybe<SortOrderEnum>
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    form_name: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeSortInput>
    image: InputMaybe<PrismicSignupBannerDataImageImageTypeSortInput>
    imperative_consents: InputMaybe<PrismicSignupBannerDataImperativeConsentsSortInput>
    partner_signup_redirect: InputMaybe<SortOrderEnum>
    redirect_link: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupBannerEdge = {
    next: Maybe<PrismicSignupBanner>
    node: PrismicSignupBanner
    previous: Maybe<PrismicSignupBanner>
}

export type PrismicSignupBannerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupBannerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupBannerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupBannerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupBannerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupBannerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupBanner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupBannerGroupConnectionDistinctArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerGroupConnectionGroupArgs = {
    field: PrismicSignupBannerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupBannerGroupConnectionMaxArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerGroupConnectionMinArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerGroupConnectionSumArgs = {
    field: PrismicSignupBannerFieldSelector
}

export type PrismicSignupBannerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupBannerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupFunnelExperiment = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupFunnelExperimentDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupFunnelExperimentFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupFunnelExperimentLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupFunnelExperimentConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupFunnelExperimentEdge>
    group: Array<PrismicSignupFunnelExperimentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupFunnelExperiment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupFunnelExperimentConnectionDistinctArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentConnectionGroupArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupFunnelExperimentConnectionMaxArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentConnectionMinArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentConnectionSumArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentDataBackgroundImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupFunnelExperimentDataBackgroundImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupFunnelExperimentDataType = {
    background: Maybe<PrismicSignupFunnelExperimentDataBackgroundImageType>
    form_type: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSignupFunnelExperimentDataOpenGraphImageImageType>
    title: Maybe<Scalars['String']['output']>
    wizard: Maybe<Array<Maybe<PrismicSignupFunnelExperimentDataWizard>>>
}

export type PrismicSignupFunnelExperimentDataTypeFieldSelector = {
    background: InputMaybe<PrismicSignupFunnelExperimentDataBackgroundImageTypeFieldSelector>
    form_type: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    wizard: InputMaybe<PrismicSignupFunnelExperimentDataWizardFieldSelector>
}

export type PrismicSignupFunnelExperimentDataTypeFilterInput = {
    background: InputMaybe<PrismicSignupFunnelExperimentDataBackgroundImageTypeFilterInput>
    form_type: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    wizard: InputMaybe<PrismicSignupFunnelExperimentDataWizardFilterListInput>
}

export type PrismicSignupFunnelExperimentDataTypeSortInput = {
    background: InputMaybe<PrismicSignupFunnelExperimentDataBackgroundImageTypeSortInput>
    form_type: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSignupFunnelExperimentDataOpenGraphImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    wizard: InputMaybe<PrismicSignupFunnelExperimentDataWizardSortInput>
}

export type PrismicSignupFunnelExperimentDataWizard = {
    back: Maybe<Scalars['String']['output']>
    company_email: Maybe<Scalars['String']['output']>
    company_size: Maybe<Scalars['String']['output']>
    employee: Maybe<Scalars['String']['output']>
    employees: Maybe<Scalars['String']['output']>
    error_company_size: Maybe<Scalars['String']['output']>
    error_name: Maybe<Scalars['String']['output']>
    error_phone_number: Maybe<Scalars['String']['output']>
    full_name: Maybe<Scalars['String']['output']>
    get_started: Maybe<Scalars['String']['output']>
    must_be_company_email: Maybe<Scalars['String']['output']>
    next: Maybe<Scalars['String']['output']>
    of: Maybe<Scalars['String']['output']>
    select: Maybe<Scalars['String']['output']>
    sole_trader: Maybe<Scalars['String']['output']>
    step: Maybe<Scalars['String']['output']>
    terms: Maybe<PrismicStructuredTextType>
    whats_your_company_size: Maybe<Scalars['String']['output']>
    whats_your_email: Maybe<Scalars['String']['output']>
    whats_your_name: Maybe<Scalars['String']['output']>
    whats_your_phone_number: Maybe<Scalars['String']['output']>
}

export type PrismicSignupFunnelExperimentDataWizardFieldSelector = {
    back: InputMaybe<FieldSelectorEnum>
    company_email: InputMaybe<FieldSelectorEnum>
    company_size: InputMaybe<FieldSelectorEnum>
    employee: InputMaybe<FieldSelectorEnum>
    employees: InputMaybe<FieldSelectorEnum>
    error_company_size: InputMaybe<FieldSelectorEnum>
    error_name: InputMaybe<FieldSelectorEnum>
    error_phone_number: InputMaybe<FieldSelectorEnum>
    full_name: InputMaybe<FieldSelectorEnum>
    get_started: InputMaybe<FieldSelectorEnum>
    must_be_company_email: InputMaybe<FieldSelectorEnum>
    next: InputMaybe<FieldSelectorEnum>
    of: InputMaybe<FieldSelectorEnum>
    select: InputMaybe<FieldSelectorEnum>
    sole_trader: InputMaybe<FieldSelectorEnum>
    step: InputMaybe<FieldSelectorEnum>
    terms: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    whats_your_company_size: InputMaybe<FieldSelectorEnum>
    whats_your_email: InputMaybe<FieldSelectorEnum>
    whats_your_name: InputMaybe<FieldSelectorEnum>
    whats_your_phone_number: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupFunnelExperimentDataWizardFilterInput = {
    back: InputMaybe<StringQueryOperatorInput>
    company_email: InputMaybe<StringQueryOperatorInput>
    company_size: InputMaybe<StringQueryOperatorInput>
    employee: InputMaybe<StringQueryOperatorInput>
    employees: InputMaybe<StringQueryOperatorInput>
    error_company_size: InputMaybe<StringQueryOperatorInput>
    error_name: InputMaybe<StringQueryOperatorInput>
    error_phone_number: InputMaybe<StringQueryOperatorInput>
    full_name: InputMaybe<StringQueryOperatorInput>
    get_started: InputMaybe<StringQueryOperatorInput>
    must_be_company_email: InputMaybe<StringQueryOperatorInput>
    next: InputMaybe<StringQueryOperatorInput>
    of: InputMaybe<StringQueryOperatorInput>
    select: InputMaybe<StringQueryOperatorInput>
    sole_trader: InputMaybe<StringQueryOperatorInput>
    step: InputMaybe<StringQueryOperatorInput>
    terms: InputMaybe<PrismicStructuredTextTypeFilterInput>
    whats_your_company_size: InputMaybe<StringQueryOperatorInput>
    whats_your_email: InputMaybe<StringQueryOperatorInput>
    whats_your_name: InputMaybe<StringQueryOperatorInput>
    whats_your_phone_number: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupFunnelExperimentDataWizardFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupFunnelExperimentDataWizardFilterInput>
}

export type PrismicSignupFunnelExperimentDataWizardSortInput = {
    back: InputMaybe<SortOrderEnum>
    company_email: InputMaybe<SortOrderEnum>
    company_size: InputMaybe<SortOrderEnum>
    employee: InputMaybe<SortOrderEnum>
    employees: InputMaybe<SortOrderEnum>
    error_company_size: InputMaybe<SortOrderEnum>
    error_name: InputMaybe<SortOrderEnum>
    error_phone_number: InputMaybe<SortOrderEnum>
    full_name: InputMaybe<SortOrderEnum>
    get_started: InputMaybe<SortOrderEnum>
    must_be_company_email: InputMaybe<SortOrderEnum>
    next: InputMaybe<SortOrderEnum>
    of: InputMaybe<SortOrderEnum>
    select: InputMaybe<SortOrderEnum>
    sole_trader: InputMaybe<SortOrderEnum>
    step: InputMaybe<SortOrderEnum>
    terms: InputMaybe<PrismicStructuredTextTypeSortInput>
    whats_your_company_size: InputMaybe<SortOrderEnum>
    whats_your_email: InputMaybe<SortOrderEnum>
    whats_your_name: InputMaybe<SortOrderEnum>
    whats_your_phone_number: InputMaybe<SortOrderEnum>
}

export type PrismicSignupFunnelExperimentEdge = {
    next: Maybe<PrismicSignupFunnelExperiment>
    node: PrismicSignupFunnelExperiment
    previous: Maybe<PrismicSignupFunnelExperiment>
}

export type PrismicSignupFunnelExperimentFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupFunnelExperimentDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupFunnelExperimentFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupFunnelExperimentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupFunnelExperimentGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupFunnelExperimentEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupFunnelExperimentGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupFunnelExperiment>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupFunnelExperimentGroupConnectionDistinctArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentGroupConnectionGroupArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupFunnelExperimentGroupConnectionMaxArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentGroupConnectionMinArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentGroupConnectionSumArgs = {
    field: PrismicSignupFunnelExperimentFieldSelector
}

export type PrismicSignupFunnelExperimentSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupFunnelExperimentDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupModal = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupModalDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupModalFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupModalLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupModalConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalEdge>
    group: Array<PrismicSignupModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalConnectionDistinctArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalConnectionGroupArgs = {
    field: PrismicSignupModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalConnectionMaxArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalConnectionMinArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalConnectionSumArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicSignupModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSignupModalDataFormProductionIntegrationType>
    node: PrismicSignupModalDataFormProductionIntegrationType
    previous: Maybe<PrismicSignupModalDataFormProductionIntegrationType>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicSignupModalDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicSignupModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSignupModalDataFormStagingIntegrationType>
    node: PrismicSignupModalDataFormStagingIntegrationType
    previous: Maybe<PrismicSignupModalDataFormStagingIntegrationType>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupModalDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type PrismicSignupModalDataSignupModal = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSignupModalDataSignupModalImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupModalDataSignupModalFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSignupModalDataSignupModalImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupModalDataSignupModalFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSignupModalDataSignupModalImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupModalDataSignupModalFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupModalDataSignupModalFilterInput>
}

export type PrismicSignupModalDataSignupModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupModalDataSignupModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalDataSignupModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupModalDataSignupModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupModalDataSignupModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupModalDataSignupModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupModalDataSignupModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupModalDataSignupModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupModalDataSignupModalSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSignupModalDataSignupModalImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupModalDataType = {
    form_production: Maybe<PrismicSignupModalDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicSignupModalDataFormStagingIntegrationType>
    signup_modal: Maybe<Array<Maybe<PrismicSignupModalDataSignupModal>>>
}

export type PrismicSignupModalDataTypeFieldSelector = {
    form_production: InputMaybe<PrismicSignupModalDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicSignupModalDataFormStagingIntegrationTypeFieldSelector>
    signup_modal: InputMaybe<PrismicSignupModalDataSignupModalFieldSelector>
}

export type PrismicSignupModalDataTypeFilterInput = {
    form_production: InputMaybe<PrismicSignupModalDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicSignupModalDataFormStagingIntegrationTypeFilterInput>
    signup_modal: InputMaybe<PrismicSignupModalDataSignupModalFilterListInput>
}

export type PrismicSignupModalDataTypeSortInput = {
    form_production: InputMaybe<PrismicSignupModalDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicSignupModalDataFormStagingIntegrationTypeSortInput>
    signup_modal: InputMaybe<PrismicSignupModalDataSignupModalSortInput>
}

export type PrismicSignupModalEdge = {
    next: Maybe<PrismicSignupModal>
    node: PrismicSignupModal
    previous: Maybe<PrismicSignupModal>
}

export type PrismicSignupModalFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupModalDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupModalFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupModalGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupModalEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupModalGroupConnectionDistinctArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalGroupConnectionGroupArgs = {
    field: PrismicSignupModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupModalGroupConnectionMaxArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalGroupConnectionMinArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalGroupConnectionSumArgs = {
    field: PrismicSignupModalFieldSelector
}

export type PrismicSignupModalSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupModalDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupPageEdge>
    group: Array<PrismicSignupPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupPageConnectionDistinctArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageConnectionGroupArgs = {
    field: PrismicSignupPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupPageConnectionMaxArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageConnectionMinArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageConnectionSumArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageDataBackgroundImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupPageDataBackgroundImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupPageDataBackgroundImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupPageDataBackgroundImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupPageDataBackgroundImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupPageDataBackgroundImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupPageDataBackgroundImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupPageDataBackgroundImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupPageDataType = {
    background_image: Maybe<PrismicSignupPageDataBackgroundImageImageType>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSignupPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSignupPageDataTypeFieldSelector = {
    background_image: InputMaybe<PrismicSignupPageDataBackgroundImageImageTypeFieldSelector>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSignupPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    variant: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupPageDataTypeFilterInput = {
    background_image: InputMaybe<PrismicSignupPageDataBackgroundImageImageTypeFilterInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSignupPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    variant: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupPageDataTypeSortInput = {
    background_image: InputMaybe<PrismicSignupPageDataBackgroundImageImageTypeSortInput>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSignupPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    variant: InputMaybe<SortOrderEnum>
}

export type PrismicSignupPageEdge = {
    next: Maybe<PrismicSignupPage>
    node: PrismicSignupPage
    previous: Maybe<PrismicSignupPage>
}

export type PrismicSignupPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupPageGroupConnectionDistinctArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageGroupConnectionGroupArgs = {
    field: PrismicSignupPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupPageGroupConnectionMaxArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageGroupConnectionMinArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageGroupConnectionSumArgs = {
    field: PrismicSignupPageFieldSelector
}

export type PrismicSignupPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupReason = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupReasonDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupReasonFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupReasonLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupReasonConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupReasonEdge>
    group: Array<PrismicSignupReasonGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupReason>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupReasonConnectionDistinctArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonConnectionGroupArgs = {
    field: PrismicSignupReasonFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupReasonConnectionMaxArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonConnectionMinArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonConnectionSumArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonDataIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupReasonDataIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupReasonDataIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupReasonDataIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupReasonDataIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupReasonDataIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupReasonDataIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupReasonDataIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupReasonDataType = {
    icon: Maybe<PrismicSignupReasonDataIconImageType>
    primary: Maybe<Scalars['String']['output']>
    secondary: Maybe<Scalars['String']['output']>
}

export type PrismicSignupReasonDataTypeFieldSelector = {
    icon: InputMaybe<PrismicSignupReasonDataIconImageTypeFieldSelector>
    primary: InputMaybe<FieldSelectorEnum>
    secondary: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupReasonDataTypeFilterInput = {
    icon: InputMaybe<PrismicSignupReasonDataIconImageTypeFilterInput>
    primary: InputMaybe<StringQueryOperatorInput>
    secondary: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupReasonDataTypeSortInput = {
    icon: InputMaybe<PrismicSignupReasonDataIconImageTypeSortInput>
    primary: InputMaybe<SortOrderEnum>
    secondary: InputMaybe<SortOrderEnum>
}

export type PrismicSignupReasonEdge = {
    next: Maybe<PrismicSignupReason>
    node: PrismicSignupReason
    previous: Maybe<PrismicSignupReason>
}

export type PrismicSignupReasonFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupReasonDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupReasonFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupReasonDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupReasonGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupReasonEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupReasonGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupReason>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupReasonGroupConnectionDistinctArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonGroupConnectionGroupArgs = {
    field: PrismicSignupReasonFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupReasonGroupConnectionMaxArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonGroupConnectionMinArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonGroupConnectionSumArgs = {
    field: PrismicSignupReasonFieldSelector
}

export type PrismicSignupReasonSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupReasonDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizard = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupWizardDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupWizardLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupWizardConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupWizardEdge>
    group: Array<PrismicSignupWizardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupWizard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupWizardConnectionDistinctArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardConnectionGroupArgs = {
    field: PrismicSignupWizardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardConnectionMaxArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardConnectionMinArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardConnectionSumArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardDataAccountingSystem = {
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemFieldSelector = {
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemFilterInput = {
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataAccountingSystemFilterInput>
}

export type PrismicSignupWizardDataAccountingSystemSortInput = {
    question: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogos = {
    billy: Maybe<PrismicSignupWizardDataAccountingSystemsLogosBillyImageType>
    datev: Maybe<PrismicSignupWizardDataAccountingSystemsLogosDatevImageType>
    economic: Maybe<PrismicSignupWizardDataAccountingSystemsLogosEconomicImageType>
    fortnox: Maybe<PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageType>
    lexoffice: Maybe<PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageType>
    microsoft_dynamics: Maybe<PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageType>
    quickbooks: Maybe<PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageType>
    sage: Maybe<PrismicSignupWizardDataAccountingSystemsLogosSageImageType>
    visma: Maybe<PrismicSignupWizardDataAccountingSystemsLogosVismaImageType>
    xero: Maybe<PrismicSignupWizardDataAccountingSystemsLogosXeroImageType>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFieldSelector = {
    billy: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFieldSelector>
    datev: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFieldSelector>
    economic: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFieldSelector>
    fortnox: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFieldSelector>
    lexoffice: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFieldSelector>
    microsoft_dynamics: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFieldSelector>
    quickbooks: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFieldSelector>
    sage: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFieldSelector>
    visma: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFieldSelector>
    xero: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFieldSelector>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFilterInput = {
    billy: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeFilterInput>
    datev: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeFilterInput>
    economic: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeFilterInput>
    fortnox: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFilterInput>
    lexoffice: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFilterInput>
    microsoft_dynamics: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFilterInput>
    quickbooks: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFilterInput>
    sage: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFilterInput>
    visma: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFilterInput>
    xero: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFilterInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFilterInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosSortInput = {
    billy: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosBillyImageTypeSortInput>
    datev: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosDatevImageTypeSortInput>
    economic: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosEconomicImageTypeSortInput>
    fortnox: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFortnoxImageTypeSortInput>
    lexoffice: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosLexofficeImageTypeSortInput>
    microsoft_dynamics: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosMicrosoftDynamicsImageTypeSortInput>
    quickbooks: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosQuickbooksImageTypeSortInput>
    sage: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosSageImageTypeSortInput>
    visma: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeSortInput>
    xero: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeSortInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosVismaImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAccountingSystemsLogosXeroImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataAllDone = {
    consent_text: Maybe<Scalars['String']['output']>
    email_placeholder: Maybe<Scalars['String']['output']>
    expenses_sync: Maybe<Scalars['String']['output']>
    export_expenses: Maybe<Scalars['String']['output']>
    form_title: Maybe<Scalars['String']['output']>
    name_placeholder: Maybe<Scalars['String']['output']>
    phone_placeholder: Maybe<Scalars['String']['output']>
    receipt_capture: Maybe<Scalars['String']['output']>
    smart_company_cards: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataAllDoneFieldSelector = {
    consent_text: InputMaybe<FieldSelectorEnum>
    email_placeholder: InputMaybe<FieldSelectorEnum>
    expenses_sync: InputMaybe<FieldSelectorEnum>
    export_expenses: InputMaybe<FieldSelectorEnum>
    form_title: InputMaybe<FieldSelectorEnum>
    name_placeholder: InputMaybe<FieldSelectorEnum>
    phone_placeholder: InputMaybe<FieldSelectorEnum>
    receipt_capture: InputMaybe<FieldSelectorEnum>
    smart_company_cards: InputMaybe<FieldSelectorEnum>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataAllDoneFilterInput = {
    consent_text: InputMaybe<StringQueryOperatorInput>
    email_placeholder: InputMaybe<StringQueryOperatorInput>
    expenses_sync: InputMaybe<StringQueryOperatorInput>
    export_expenses: InputMaybe<StringQueryOperatorInput>
    form_title: InputMaybe<StringQueryOperatorInput>
    name_placeholder: InputMaybe<StringQueryOperatorInput>
    phone_placeholder: InputMaybe<StringQueryOperatorInput>
    receipt_capture: InputMaybe<StringQueryOperatorInput>
    smart_company_cards: InputMaybe<StringQueryOperatorInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataAllDoneFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataAllDoneFilterInput>
}

export type PrismicSignupWizardDataAllDoneSortInput = {
    consent_text: InputMaybe<SortOrderEnum>
    email_placeholder: InputMaybe<SortOrderEnum>
    expenses_sync: InputMaybe<SortOrderEnum>
    export_expenses: InputMaybe<SortOrderEnum>
    form_title: InputMaybe<SortOrderEnum>
    name_placeholder: InputMaybe<SortOrderEnum>
    phone_placeholder: InputMaybe<SortOrderEnum>
    receipt_capture: InputMaybe<SortOrderEnum>
    smart_company_cards: InputMaybe<SortOrderEnum>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataCompanyLocation = {
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataCompanyLocationFieldSelector = {
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataCompanyLocationFilterInput = {
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataCompanyLocationFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataCompanyLocationFilterInput>
}

export type PrismicSignupWizardDataCompanyLocationSortInput = {
    question: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataCompanySize = {
    employee: Maybe<Scalars['String']['output']>
    employees: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
    sole_trader: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataCompanySizeFieldSelector = {
    employee: InputMaybe<FieldSelectorEnum>
    employees: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
    sole_trader: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataCompanySizeFilterInput = {
    employee: InputMaybe<StringQueryOperatorInput>
    employees: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
    sole_trader: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataCompanySizeFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataCompanySizeFilterInput>
}

export type PrismicSignupWizardDataCompanySizeSortInput = {
    employee: InputMaybe<SortOrderEnum>
    employees: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
    sole_trader: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataHateMost = {
    all_of_the_above: Maybe<Scalars['String']['output']>
    manual_expense_reporting: Maybe<Scalars['String']['output']>
    paper_receipts: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
    shared_company_cards: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataHateMostFieldSelector = {
    all_of_the_above: InputMaybe<FieldSelectorEnum>
    manual_expense_reporting: InputMaybe<FieldSelectorEnum>
    paper_receipts: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
    shared_company_cards: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataHateMostFilterInput = {
    all_of_the_above: InputMaybe<StringQueryOperatorInput>
    manual_expense_reporting: InputMaybe<StringQueryOperatorInput>
    paper_receipts: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
    shared_company_cards: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataHateMostFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataHateMostFilterInput>
}

export type PrismicSignupWizardDataHateMostSortInput = {
    all_of_the_above: InputMaybe<SortOrderEnum>
    manual_expense_reporting: InputMaybe<SortOrderEnum>
    paper_receipts: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
    shared_company_cards: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataIneligibleOtherCountry = {
    message: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataIneligibleOtherCountryFieldSelector = {
    message: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataIneligibleOtherCountryFilterInput = {
    message: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataIneligibleOtherCountryFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataIneligibleOtherCountryFilterInput>
}

export type PrismicSignupWizardDataIneligibleOtherCountrySortInput = {
    message: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataIneligibleSoleTrader = {
    message: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataIneligibleSoleTraderFieldSelector = {
    message: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataIneligibleSoleTraderFilterInput = {
    message: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataIneligibleSoleTraderFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupWizardDataIneligibleSoleTraderFilterInput>
}

export type PrismicSignupWizardDataIneligibleSoleTraderSortInput = {
    message: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardDataType = {
    accounting_system: Maybe<Array<Maybe<PrismicSignupWizardDataAccountingSystem>>>
    accounting_systems_logos: Maybe<Array<Maybe<PrismicSignupWizardDataAccountingSystemsLogos>>>
    all_done: Maybe<Array<Maybe<PrismicSignupWizardDataAllDone>>>
    back: Maybe<Scalars['String']['output']>
    calendly_title: Maybe<Scalars['String']['output']>
    company_location: Maybe<Array<Maybe<PrismicSignupWizardDataCompanyLocation>>>
    company_size: Maybe<Array<Maybe<PrismicSignupWizardDataCompanySize>>>
    hate_most: Maybe<Array<Maybe<PrismicSignupWizardDataHateMost>>>
    ineligible_other_country: Maybe<Array<Maybe<PrismicSignupWizardDataIneligibleOtherCountry>>>
    ineligible_sole_trader: Maybe<Array<Maybe<PrismicSignupWizardDataIneligibleSoleTrader>>>
    no_credit_card: Maybe<Scalars['String']['output']>
    of: Maybe<Scalars['String']['output']>
    other: Maybe<Scalars['String']['output']>
    signup_form: Maybe<PrismicLinkType>
    step: Maybe<Scalars['String']['output']>
}

export type PrismicSignupWizardDataTypeFieldSelector = {
    accounting_system: InputMaybe<PrismicSignupWizardDataAccountingSystemFieldSelector>
    accounting_systems_logos: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFieldSelector>
    all_done: InputMaybe<PrismicSignupWizardDataAllDoneFieldSelector>
    back: InputMaybe<FieldSelectorEnum>
    calendly_title: InputMaybe<FieldSelectorEnum>
    company_location: InputMaybe<PrismicSignupWizardDataCompanyLocationFieldSelector>
    company_size: InputMaybe<PrismicSignupWizardDataCompanySizeFieldSelector>
    hate_most: InputMaybe<PrismicSignupWizardDataHateMostFieldSelector>
    ineligible_other_country: InputMaybe<PrismicSignupWizardDataIneligibleOtherCountryFieldSelector>
    ineligible_sole_trader: InputMaybe<PrismicSignupWizardDataIneligibleSoleTraderFieldSelector>
    no_credit_card: InputMaybe<FieldSelectorEnum>
    of: InputMaybe<FieldSelectorEnum>
    other: InputMaybe<FieldSelectorEnum>
    signup_form: InputMaybe<PrismicLinkTypeFieldSelector>
    step: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardDataTypeFilterInput = {
    accounting_system: InputMaybe<PrismicSignupWizardDataAccountingSystemFilterListInput>
    accounting_systems_logos: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosFilterListInput>
    all_done: InputMaybe<PrismicSignupWizardDataAllDoneFilterListInput>
    back: InputMaybe<StringQueryOperatorInput>
    calendly_title: InputMaybe<StringQueryOperatorInput>
    company_location: InputMaybe<PrismicSignupWizardDataCompanyLocationFilterListInput>
    company_size: InputMaybe<PrismicSignupWizardDataCompanySizeFilterListInput>
    hate_most: InputMaybe<PrismicSignupWizardDataHateMostFilterListInput>
    ineligible_other_country: InputMaybe<PrismicSignupWizardDataIneligibleOtherCountryFilterListInput>
    ineligible_sole_trader: InputMaybe<PrismicSignupWizardDataIneligibleSoleTraderFilterListInput>
    no_credit_card: InputMaybe<StringQueryOperatorInput>
    of: InputMaybe<StringQueryOperatorInput>
    other: InputMaybe<StringQueryOperatorInput>
    signup_form: InputMaybe<PrismicLinkTypeFilterInput>
    step: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardDataTypeSortInput = {
    accounting_system: InputMaybe<PrismicSignupWizardDataAccountingSystemSortInput>
    accounting_systems_logos: InputMaybe<PrismicSignupWizardDataAccountingSystemsLogosSortInput>
    all_done: InputMaybe<PrismicSignupWizardDataAllDoneSortInput>
    back: InputMaybe<SortOrderEnum>
    calendly_title: InputMaybe<SortOrderEnum>
    company_location: InputMaybe<PrismicSignupWizardDataCompanyLocationSortInput>
    company_size: InputMaybe<PrismicSignupWizardDataCompanySizeSortInput>
    hate_most: InputMaybe<PrismicSignupWizardDataHateMostSortInput>
    ineligible_other_country: InputMaybe<PrismicSignupWizardDataIneligibleOtherCountrySortInput>
    ineligible_sole_trader: InputMaybe<PrismicSignupWizardDataIneligibleSoleTraderSortInput>
    no_credit_card: InputMaybe<SortOrderEnum>
    of: InputMaybe<SortOrderEnum>
    other: InputMaybe<SortOrderEnum>
    signup_form: InputMaybe<PrismicLinkTypeSortInput>
    step: InputMaybe<SortOrderEnum>
}

export type PrismicSignupWizardEdge = {
    next: Maybe<PrismicSignupWizard>
    node: PrismicSignupWizard
    previous: Maybe<PrismicSignupWizard>
}

export type PrismicSignupWizardFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupWizardDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupWizardFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupWizardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupWizardGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupWizardEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupWizardGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupWizard>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupWizardGroupConnectionDistinctArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardGroupConnectionGroupArgs = {
    field: PrismicSignupWizardFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupWizardGroupConnectionMaxArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardGroupConnectionMinArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardGroupConnectionSumArgs = {
    field: PrismicSignupWizardFieldSelector
}

export type PrismicSignupWizardSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupWizardDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodal = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSignupmodalDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupmodalLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSignupmodalConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalEdge>
    group: Array<PrismicSignupmodalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalConnectionDistinctArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalConnectionGroupArgs = {
    field: PrismicSignupmodalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalConnectionMaxArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalConnectionMinArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalConnectionSumArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSignupmodalDataFormProductionIntegrationType>
    node: PrismicSignupmodalDataFormProductionIntegrationType
    previous: Maybe<PrismicSignupmodalDataFormProductionIntegrationType>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<Maybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsents>>
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSignupmodalDataFormStagingIntegrationType>
    node: PrismicSignupmodalDataFormStagingIntegrationType
    previous: Maybe<PrismicSignupmodalDataFormStagingIntegrationType>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicSignupmodalDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataItems = {
    value_item: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataItemsFieldSelector = {
    value_item: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataItemsFilterInput = {
    value_item: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupmodalDataItemsFilterInput>
}

export type PrismicSignupmodalDataItemsSortInput = {
    value_item: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataSignupModal = {
    highlighted_feature_1: Maybe<Scalars['String']['output']>
    highlighted_feature_2: Maybe<Scalars['String']['output']>
    highlighted_feature_3: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSignupmodalDataSignupModalImageImageType>
    partner_subtitle: Maybe<Scalars['String']['output']>
    partner_title: Maybe<Scalars['String']['output']>
    rating_image: Maybe<PrismicSignupmodalDataSignupModalRatingImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataSignupModalFieldSelector = {
    highlighted_feature_1: InputMaybe<FieldSelectorEnum>
    highlighted_feature_2: InputMaybe<FieldSelectorEnum>
    highlighted_feature_3: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSignupmodalDataSignupModalImageImageTypeFieldSelector>
    partner_subtitle: InputMaybe<FieldSelectorEnum>
    partner_title: InputMaybe<FieldSelectorEnum>
    rating_image: InputMaybe<PrismicSignupmodalDataSignupModalRatingImageImageTypeFieldSelector>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataSignupModalFilterInput = {
    highlighted_feature_1: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_2: InputMaybe<StringQueryOperatorInput>
    highlighted_feature_3: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSignupmodalDataSignupModalImageImageTypeFilterInput>
    partner_subtitle: InputMaybe<StringQueryOperatorInput>
    partner_title: InputMaybe<StringQueryOperatorInput>
    rating_image: InputMaybe<PrismicSignupmodalDataSignupModalRatingImageImageTypeFilterInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataSignupModalFilterListInput = {
    elemMatch: InputMaybe<PrismicSignupmodalDataSignupModalFilterInput>
}

export type PrismicSignupmodalDataSignupModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataSignupModalImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalDataSignupModalRatingImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataSignupModalSortInput = {
    highlighted_feature_1: InputMaybe<SortOrderEnum>
    highlighted_feature_2: InputMaybe<SortOrderEnum>
    highlighted_feature_3: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSignupmodalDataSignupModalImageImageTypeSortInput>
    partner_subtitle: InputMaybe<SortOrderEnum>
    partner_title: InputMaybe<SortOrderEnum>
    rating_image: InputMaybe<PrismicSignupmodalDataSignupModalRatingImageImageTypeSortInput>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSignupmodalDataType = {
    form_production: Maybe<PrismicSignupmodalDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicSignupmodalDataFormStagingIntegrationType>
    items: Maybe<Array<Maybe<PrismicSignupmodalDataItems>>>
    signup_modal: Maybe<Array<Maybe<PrismicSignupmodalDataSignupModal>>>
}

export type PrismicSignupmodalDataTypeFieldSelector = {
    form_production: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeFieldSelector>
    items: InputMaybe<PrismicSignupmodalDataItemsFieldSelector>
    signup_modal: InputMaybe<PrismicSignupmodalDataSignupModalFieldSelector>
}

export type PrismicSignupmodalDataTypeFilterInput = {
    form_production: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeFilterInput>
    items: InputMaybe<PrismicSignupmodalDataItemsFilterListInput>
    signup_modal: InputMaybe<PrismicSignupmodalDataSignupModalFilterListInput>
}

export type PrismicSignupmodalDataTypeSortInput = {
    form_production: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeSortInput>
    items: InputMaybe<PrismicSignupmodalDataItemsSortInput>
    signup_modal: InputMaybe<PrismicSignupmodalDataSignupModalSortInput>
}

export type PrismicSignupmodalEdge = {
    next: Maybe<PrismicSignupmodal>
    node: PrismicSignupmodal
    previous: Maybe<PrismicSignupmodal>
}

export type PrismicSignupmodalFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSignupmodalDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSignupmodalFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupmodalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSignupmodalGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSignupmodalEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSignupmodalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSignupmodal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSignupmodalGroupConnectionDistinctArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalGroupConnectionGroupArgs = {
    field: PrismicSignupmodalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSignupmodalGroupConnectionMaxArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalGroupConnectionMinArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalGroupConnectionSumArgs = {
    field: PrismicSignupmodalFieldSelector
}

export type PrismicSignupmodalSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSignupmodalDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSkillEvaluationTool = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSkillEvaluationToolDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSkillEvaluationToolFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSkillEvaluationToolLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSkillEvaluationToolConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSkillEvaluationToolEdge>
    group: Array<PrismicSkillEvaluationToolGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSkillEvaluationTool>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSkillEvaluationToolConnectionDistinctArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolConnectionGroupArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSkillEvaluationToolConnectionMaxArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolConnectionMinArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolConnectionSumArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSkillEvaluationToolDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSkillEvaluationToolDataProgress = {
    of: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSkillEvaluationToolDataProgressFieldSelector = {
    of: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicSkillEvaluationToolDataProgressFilterInput = {
    of: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSkillEvaluationToolDataProgressFilterListInput = {
    elemMatch: InputMaybe<PrismicSkillEvaluationToolDataProgressFilterInput>
}

export type PrismicSkillEvaluationToolDataProgressSortInput = {
    of: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicSkillEvaluationToolDataQuestions = {
    background_color: Maybe<Scalars['String']['output']>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSkillEvaluationToolDataQuestionsFieldSelector = {
    background_color: InputMaybe<FieldSelectorEnum>
    question: InputMaybe<FieldSelectorEnum>
}

export type PrismicSkillEvaluationToolDataQuestionsFilterInput = {
    background_color: InputMaybe<StringQueryOperatorInput>
    question: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSkillEvaluationToolDataQuestionsFilterListInput = {
    elemMatch: InputMaybe<PrismicSkillEvaluationToolDataQuestionsFilterInput>
}

export type PrismicSkillEvaluationToolDataQuestionsSortInput = {
    background_color: InputMaybe<SortOrderEnum>
    question: InputMaybe<SortOrderEnum>
}

export type PrismicSkillEvaluationToolDataType = {
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSkillEvaluationToolDataOpenGraphImageImageType>
    progress: Maybe<Array<Maybe<PrismicSkillEvaluationToolDataProgress>>>
    questions: Maybe<Array<Maybe<PrismicSkillEvaluationToolDataQuestions>>>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSkillEvaluationToolDataTypeFieldSelector = {
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFieldSelector>
    progress: InputMaybe<PrismicSkillEvaluationToolDataProgressFieldSelector>
    questions: InputMaybe<PrismicSkillEvaluationToolDataQuestionsFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSkillEvaluationToolDataTypeFilterInput = {
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSkillEvaluationToolDataOpenGraphImageImageTypeFilterInput>
    progress: InputMaybe<PrismicSkillEvaluationToolDataProgressFilterListInput>
    questions: InputMaybe<PrismicSkillEvaluationToolDataQuestionsFilterListInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSkillEvaluationToolDataTypeSortInput = {
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSkillEvaluationToolDataOpenGraphImageImageTypeSortInput>
    progress: InputMaybe<PrismicSkillEvaluationToolDataProgressSortInput>
    questions: InputMaybe<PrismicSkillEvaluationToolDataQuestionsSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSkillEvaluationToolEdge = {
    next: Maybe<PrismicSkillEvaluationTool>
    node: PrismicSkillEvaluationTool
    previous: Maybe<PrismicSkillEvaluationTool>
}

export type PrismicSkillEvaluationToolFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSkillEvaluationToolDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSkillEvaluationToolFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSkillEvaluationToolDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSkillEvaluationToolGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSkillEvaluationToolEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSkillEvaluationToolGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSkillEvaluationTool>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSkillEvaluationToolGroupConnectionDistinctArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolGroupConnectionGroupArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSkillEvaluationToolGroupConnectionMaxArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolGroupConnectionMinArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolGroupConnectionSumArgs = {
    field: PrismicSkillEvaluationToolFieldSelector
}

export type PrismicSkillEvaluationToolSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSkillEvaluationToolDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSlicePageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSlicePageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSlicePageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageEdge>
    group: Array<PrismicSlicePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageConnectionDistinctArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageConnectionGroupArgs = {
    field: PrismicSlicePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageConnectionMaxArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageConnectionMinArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageConnectionSumArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageDataBodyAccordion = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyAccordionItem>
    primary: PrismicSlicePageDataBodyAccordionPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyAccordionItem = {
    content: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyAccordionPrimary = {
    headline: Maybe<Scalars['String']['output']>
    subheadline: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyBackgroundMediaHeroItem>
    primary: PrismicSlicePageDataBodyBackgroundMediaHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    background_image: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageType>
    background_video_mp4: Maybe<PrismicLinkType>
    background_video_poster: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageType>
    background_video_webm: Maybe<PrismicLinkType>
    email_error_input_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
    lead_text: Maybe<Scalars['String']['output']>
    overlay: Maybe<Scalars['String']['output']>
    overlay_opacity: Maybe<Scalars['String']['output']>
    pretitle_image: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageType>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryBackgroundVideoPosterImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType =
    Node & {
        children: Array<Node>
        consents: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsents>
        formId: Maybe<Scalars['String']['output']>
        id: Scalars['ID']['output']
        internal: Internal
        parent: Maybe<Node>
        prismicId: Maybe<Scalars['String']['output']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
    node: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeEdge>
        group: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
    node: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryPretitleImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyBentoBox = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyBentoBoxItem>
    primary: PrismicSlicePageDataBodyBentoBoxPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyBentoBoxItem = {
    card_image: Maybe<PrismicSlicePageDataBodyBentoBoxItemsCardImageImageType>
    card_subtitle: Maybe<Scalars['String']['output']>
    card_title: Maybe<Scalars['String']['output']>
    image_alignment: Maybe<Scalars['String']['output']>
    place_on_new_row: Maybe<Scalars['Boolean']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_poster: Maybe<PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyBentoBoxItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyBentoBoxItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyBentoBoxItemsVideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyBentoBoxPrimary = {
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCardGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyCardGridItem>
    primary: PrismicSlicePageDataBodyCardGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCardGridItem = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    filter_keywords: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyCardGridItemsImageImageType>
    tag_color: Maybe<Scalars['String']['output']>
    tag_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCardGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCardGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyCardGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyCardGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyCardGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyCardGridPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    card_cta_as_button: Maybe<Scalars['Boolean']['output']>
    card_cta_text: Maybe<Scalars['String']['output']>
    image_fit: Maybe<Scalars['String']['output']>
    initial_cards_shown: Maybe<Scalars['String']['output']>
    initial_cards_shown_on_desktop: Maybe<Scalars['String']['output']>
    initial_cards_shown_on_mobile: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    no_padding: Maybe<Scalars['Boolean']['output']>
    show_filter: Maybe<Scalars['Boolean']['output']>
    show_more_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicSlicePageDataBodyCardGridV2 = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyCardGridV2Item>
    primary: PrismicSlicePageDataBodyCardGridV2Primary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCardGridV2Item = {
    card_cta_link: Maybe<PrismicLinkType>
    card_cta_text: Maybe<Scalars['String']['output']>
    card_description: Maybe<Scalars['String']['output']>
    card_image: Maybe<PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageType>
    card_title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyCardGridV2ItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyCardGridV2Primary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyChat = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyChatPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyChatPrimary = {
    body1: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyChatPrimaryImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyChatPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyChatPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyChatPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyChatPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyChatPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyComparison = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyComparisonItem>
    primary: PrismicSlicePageDataBodyComparisonPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyComparisonItem = {
    comparison_label: Maybe<Scalars['String']['output']>
    item_1_label: Maybe<Scalars['String']['output']>
    item_1_percentage: Maybe<Scalars['Float']['output']>
    item_2_label: Maybe<Scalars['String']['output']>
    item_2_percentage: Maybe<Scalars['Float']['output']>
}

export type PrismicSlicePageDataBodyComparisonPrimary = {
    card_body: Maybe<PrismicStructuredTextType>
    card_logo: Maybe<PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyComparisonPrimaryCardLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyComparisonTable = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyComparisonTableItem>
    primary: PrismicSlicePageDataBodyComparisonTablePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyComparisonTableItem = {
    data_1: Maybe<Scalars['String']['output']>
    data_2: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyComparisonTablePrimary = {
    column_1_heading: Maybe<Scalars['String']['output']>
    column_2_heading: Maybe<Scalars['String']['output']>
    section_heading: Maybe<Scalars['String']['output']>
    section_subheading: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyComponentPlaceholder = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyComponentPlaceholderPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyComponentPlaceholderPrimary = {
    component: Maybe<Scalars['String']['output']>
    predefined_component: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyContactEmails = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyContactEmailsItem>
    primary: PrismicSlicePageDataBodyContactEmailsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyContactEmailsItem = {
    contact_email: Maybe<Scalars['String']['output']>
    contact_title: Maybe<Scalars['String']['output']>
    destination_link: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyContactEmailsPrimary = {
    body1: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContactHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyContactHeroItem>
    primary: PrismicSlicePageDataBodyContactHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyContactHeroItem = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyContactHeroItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContactHeroItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContactHeroItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyContactHeroItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyContactHeroItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyContactHeroItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyContactHeroPrimary = {
    headline: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusBlocks = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyContentPlusBlocksItem>
    primary: PrismicSlicePageDataBodyContentPlusBlocksPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyContentPlusBlocksItem = {
    block_content: Maybe<PrismicStructuredTextType>
    block_image: Maybe<PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageType>
    block_title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyContentPlusBlocksItemsBlockImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyContentPlusBlocksPrimary = {
    background: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    text_under_title: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusShortBullets = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyContentPlusShortBulletsItem>
    primary: PrismicSlicePageDataBodyContentPlusShortBulletsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsItem = {
    bullet_image: Maybe<PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageType>
    bullet_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyContentPlusShortBulletsItemsBulletImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyContentPlusShortBulletsPrimary = {
    body: Maybe<PrismicStructuredTextType>
    heading: Maybe<PrismicStructuredTextType>
    highlight_color: Maybe<Scalars['String']['output']>
    inverse: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSlicePageDataBodyCountdown = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyCountdownPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCountdownPrimary = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description_text: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    target_date_time: Maybe<Scalars['Date']['output']>
}

export type PrismicSlicePageDataBodyCountdownPrimaryTarget_Date_TimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCta = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyCustomerLogosPlusCtaItem>
    primary: PrismicSlicePageDataBodyCustomerLogosPlusCtaPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItem = {
    logo: Maybe<PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageType>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyCustomerLogosPlusCtaPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    marquee_mode: Maybe<Scalars['Boolean']['output']>
    marquee_scroll_speed: Maybe<Scalars['String']['output']>
    marquee_width: Maybe<Scalars['String']['output']>
    stat_1_body: Maybe<Scalars['String']['output']>
    stat_1_highlight: Maybe<Scalars['String']['output']>
    stat_2_body: Maybe<Scalars['String']['output']>
    stat_2_highlight: Maybe<Scalars['String']['output']>
    stat_3_body: Maybe<Scalars['String']['output']>
    stat_3_highlight: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomers = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyCustomersItem>
    primary: PrismicSlicePageDataBodyCustomersPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCustomersItem = {
    logo: Maybe<PrismicSlicePageDataBodyCustomersItemsLogoImageType>
    stars: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomersItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomersItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyCustomersItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyCustomersItemsLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyCustomersItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadline = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItem>
    primary: PrismicSlicePageDataBodyCustomersLogosPlusHeadlinePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItem = {
    customer_logo: Maybe<PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageType>
}

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyCustomersLogosPlusHeadlinePrimary = {
    customer_logos_title: Maybe<PrismicStructuredTextType>
    predefined_logos: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyCustomersPrimary = {
    large_title: Maybe<Scalars['Boolean']['output']>
    predefined_logos: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    show_stars: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyDemoHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyDemoHeroItem>
    primary: PrismicSlicePageDataBodyDemoHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyDemoHeroItem = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyDemoHeroItemsImageImageType>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyDemoHeroItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyDemoHeroItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyDemoHeroItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyDemoHeroItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyDemoHeroItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyDemoHeroPrimary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyEventCards = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyEventCardsItem>
    primary: PrismicSlicePageDataBodyEventCardsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyEventCardsItem = {
    category: Maybe<Scalars['String']['output']>
    date: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    duration: Maybe<Scalars['String']['output']>
    event_cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicSlicePageDataBodyEventCardsItemsImageImageType>
    time: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    tracking_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyEventCardsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyEventCardsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyEventCardsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyEventCardsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyEventCardsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyEventCardsPrimary = {
    event_cta_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFaq = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyFaqItem>
    primary: PrismicSlicePageDataBodyFaqPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFaqItem = {
    answer: Maybe<PrismicStructuredTextType>
    icon: Maybe<PrismicSlicePageDataBodyFaqItemsIconImageType>
    image: Maybe<PrismicSlicePageDataBodyFaqItemsImageImageType>
    question: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFaqItemsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFaqItemsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFaqItemsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFaqItemsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyFaqItemsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFaqItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFaqItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFaqItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFaqItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyFaqItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFaqPrimary = {
    collapsible: Maybe<Scalars['Boolean']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlock = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyFeatureBlockPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFeatureBlockPrimary = {
    background: Maybe<Scalars['String']['output']>
    cta_hash_link: Maybe<Scalars['String']['output']>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<PrismicStructuredTextType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    is_circular_image: Maybe<Scalars['Boolean']['output']>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyFeatureBlockPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarquee = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyFeatureBlockWithMarqueeItem>
    primary: PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItem = {
    link: Maybe<PrismicLinkType>
    logo: Maybe<PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageType>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueeItemsLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimary = {
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    outline: Maybe<PrismicStructuredTextType>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyFeatureBlockWithMarqueePrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFeatureComparison = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyFeatureComparisonItem>
    primary: PrismicSlicePageDataBodyFeatureComparisonPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFeatureComparisonItem = {
    column_checked_1: Maybe<Scalars['Boolean']['output']>
    column_checked_2: Maybe<Scalars['Boolean']['output']>
    feature: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureComparisonPrimary = {
    background: Maybe<Scalars['String']['output']>
    column_heading_1: Maybe<Scalars['String']['output']>
    column_heading_2: Maybe<Scalars['String']['output']>
    feature_column_heading: Maybe<Scalars['String']['output']>
    tick_alt_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyFeatureGridItem>
    primary: PrismicSlicePageDataBodyFeatureGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFeatureGridItem = {
    feature_description: Maybe<PrismicStructuredTextType>
    feature_title: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyFeatureGridItemsImageImageType>
    predefined_feature: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyFeatureGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFeatureGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyFeatureGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyFeatureGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyFeatureGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyFeatureGridPrimary = {
    background: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyForm = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyFormItem>
    primary: PrismicSlicePageDataBodyFormPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyFormItem = {
    label: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    obligatory: Maybe<Scalars['Boolean']['output']>
    placeholder: Maybe<Scalars['String']['output']>
    select_options: Maybe<Scalars['String']['output']>
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyFormPrimary = {
    hubspot_form_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStarted = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyGetStartedItem>
    primary: PrismicSlicePageDataBodyGetStartedPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyGetStartedItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    button_label: Maybe<Scalars['String']['output']>
    error_message: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    form_subtitle: Maybe<Scalars['String']['output']>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryImageImageType>
    input_placeholder: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    redirection_page: Maybe<PrismicLinkType>
    section_color: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
    group: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    node: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    node: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyGetStartedPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyGlassdoorWidget = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyGlassdoorWidgetPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyGlassdoorWidgetPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    widget_alt_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyHeroPrimary = {
    image: Maybe<PrismicSlicePageDataBodyHeroPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    is_oversized_image: Maybe<Scalars['Boolean']['output']>
    lead_text: Maybe<PrismicStructuredTextType>
    predefined_proof_point_badges: Maybe<PrismicLinkType>
    predefined_signup_banner: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyHighlight = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyHighlightItem>
    primary: PrismicSlicePageDataBodyHighlightPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyHighlightItem = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    highlight_color: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyHighlightItemsImageImageType>
    slide_body: Maybe<PrismicStructuredTextType>
    slide_title: Maybe<Scalars['String']['output']>
    tracking_event: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyHighlightItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHighlightItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyHighlightItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyHighlightItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyHighlightItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyHighlightPrimary = {
    highlight_color: Maybe<Scalars['String']['output']>
    mirrored: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotForm = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyHubspotFormPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyHubspotFormPrimary = {
    featured_image: Maybe<PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageType>
    form: Maybe<PrismicLinkType>
    inverse: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyHubspotFormPrimaryFeaturedImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyHubspotHeroForm = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyHubspotHeroFormItem>
    primary: PrismicSlicePageDataBodyHubspotHeroFormPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyHubspotHeroFormItem = {
    icon: Maybe<PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormItemsIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimary = {
    form_production: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
    form_submit_text: Maybe<Scalars['String']['output']>
    form_title: Maybe<Scalars['String']['output']>
    redirect_to: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
    node: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
    node: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHub = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimary = {
    pre_title: Maybe<Scalars['String']['output']>
    video_description: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageType>
    video_title: Maybe<PrismicStructuredTextType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodyInlineVideoPlayerResourceHubPrimaryVideoThumbnailImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicSlicePageDataBodyIntegrationCards = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyIntegrationCardsItem>
    primary: PrismicSlicePageDataBodyIntegrationCardsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyIntegrationCardsItem = {
    cta_link: Maybe<PrismicLinkType>
    image: Maybe<PrismicSlicePageDataBodyIntegrationCardsItemsImageImageType>
    name: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationCardsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationCardsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyIntegrationCardsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyIntegrationCardsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyIntegrationCardsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyIntegrationCardsPrimary = {
    cta_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationOverview = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyIntegrationOverviewPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyIntegrationOverviewPrimary = {
    copy: Maybe<PrismicStructuredTextType>
    developers: Maybe<Scalars['String']['output']>
    developers_label: Maybe<Scalars['String']['output']>
    links: Maybe<PrismicStructuredTextType>
    links_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrations = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyIntegrationsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyIntegrationsGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyIntegrationsGridItem>
    primary: PrismicSlicePageDataBodyIntegrationsGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyIntegrationsGridItem = {
    featured_integration: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyIntegrationsGridPrimary = {
    card_cta_text: Maybe<Scalars['String']['output']>
    category_filter_all_label: Maybe<Scalars['String']['output']>
    category_filter_placeholder: Maybe<Scalars['String']['output']>
    no_results_found: Maybe<Scalars['String']['output']>
    remove_filter: Maybe<Scalars['String']['output']>
    search_placeholder: Maybe<Scalars['String']['output']>
    showing_all_results: Maybe<Scalars['String']['output']>
    showing_results_for: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    logo_1: Maybe<PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageType>
    logo_1_link: Maybe<PrismicLinkType>
    logo_2: Maybe<PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageType>
    logo_2_link: Maybe<PrismicLinkType>
    logo_3: Maybe<PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageType>
    logo_3_link: Maybe<PrismicLinkType>
    more_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo1ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo2ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyIntegrationsPrimaryLogo3ImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyInteractiveDemo = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyInteractiveDemoItem>
    primary: PrismicSlicePageDataBodyInteractiveDemoPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyInteractiveDemoItem = {
    body1: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicSlicePageDataBodyInteractiveDemoItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInteractiveDemoItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInteractiveDemoItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyInteractiveDemoItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyInteractiveDemoItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyInteractiveDemoItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimary = {
    compact_layout: Maybe<Scalars['Boolean']['output']>
    interactive_demo_link_production: Maybe<PrismicLinkType>
    interactive_demo_link_staging: Maybe<PrismicLinkType>
    modal_button_text: Maybe<Scalars['String']['output']>
    modal_image: Maybe<PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageType>
    modal_subtitle: Maybe<Scalars['String']['output']>
    modal_title: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyInteractiveDemoPrimaryModalImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyJobListings = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyJobListingsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyJobListingsPrimary = {
    all_departments_label: Maybe<Scalars['String']['output']>
    clear_filters_label: Maybe<Scalars['String']['output']>
    departments_select_label: Maybe<Scalars['String']['output']>
    location_label: Maybe<Scalars['String']['output']>
    no_results_label: Maybe<Scalars['String']['output']>
    no_search_label: Maybe<Scalars['String']['output']>
    role_label: Maybe<Scalars['String']['output']>
    search_input_label: Maybe<Scalars['String']['output']>
    showing_roles_by_department_label: Maybe<Scalars['String']['output']>
    showing_roles_by_department_with_search_label: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    team_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyJobsGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyJobsGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyJobsGridPrimary = {
    cta_text: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyLandingHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyLandingHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyLandingHeroPrimary = {
    background: Maybe<Scalars['String']['output']>
    cta_destination: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    headline_background_color: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyLandingHeroPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    lead_text: Maybe<PrismicStructuredTextType>
    predefined_proof_point_badges: Maybe<PrismicLinkType>
    primary_cta_link: Maybe<PrismicLinkType>
    primary_cta_text: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyLandingHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyLandingHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyLandingHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyLandingHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyLandingHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyLatestBlogPosts = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyLatestBlogPostsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyLatestBlogPostsPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyMagnetHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyMagnetHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyMagnetHeroPrimary = {
    description: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyMagnetHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyMediaItemGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyMediaItemGridItem>
    primary: PrismicSlicePageDataBodyMediaItemGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyMediaItemGridItem = {
    image: Maybe<PrismicSlicePageDataBodyMediaItemGridItemsImageImageType>
    item_description: Maybe<PrismicStructuredTextType>
    item_title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyMediaItemGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyMediaItemGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyMediaItemGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyMediaItemGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyMediaItemGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyMediaItemGridPrimary = {
    background: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyOnDemandResources = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyOnDemandResourcesPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyOnDemandResourcesPrimary = {
    filter_clear: Maybe<Scalars['String']['output']>
    filter_language_all: Maybe<Scalars['String']['output']>
    filter_language_placeholder: Maybe<Scalars['String']['output']>
    filter_resource_type_all: Maybe<Scalars['String']['output']>
    filter_resource_type_placeholder: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    no_events_found: Maybe<Scalars['String']['output']>
    no_resources_found: Maybe<Scalars['String']['output']>
    resource_cta_text: Maybe<Scalars['String']['output']>
    search_placeholder: Maybe<Scalars['String']['output']>
    showing_all_results: Maybe<Scalars['String']['output']>
    showing_all_results_for: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    top_link: Maybe<PrismicLinkType>
    top_link_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyPanelGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyPanelGridItem>
    primary: PrismicSlicePageDataBodyPanelGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyPanelGridItem = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    excerpt: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    label_color: Maybe<Scalars['String']['output']>
    label_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyPanelGridPrimary = {
    excerpt: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyPartnerProgramme = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyPartnerProgrammeItem>
    primary: PrismicSlicePageDataBodyPartnerProgrammePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyPartnerProgrammeItem = {
    partner_programme_tables: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyPartnerProgrammePrimary = {
    tables_tick_screen_reader_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyPricing = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyPricingPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyPricingPrimary = {
    pricing_tiers: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicSlicePageDataBodyRatingsPlusHeadline = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyRatingsPlusHeadlineItem>
    primary: PrismicSlicePageDataBodyRatingsPlusHeadlinePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyRatingsPlusHeadlineItem = {
    rating: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyRatingsPlusHeadlinePrimary = {
    cta_link: Maybe<PrismicLinkType>
    predefined_ratings: Maybe<PrismicLinkType>
    ratings_cta_text: Maybe<Scalars['String']['output']>
    ratings_lead_text: Maybe<Scalars['String']['output']>
    ratings_title: Maybe<PrismicStructuredTextType>
    section_html_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyReferralHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyReferralHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyReferralHeroPrimary = {
    alternative_lead: Maybe<Scalars['String']['output']>
    background: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    headline_background_color: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyReferralHeroPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    lead: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyReferralHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyReferralHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyReferralHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyReferralHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyReferralHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyResourceSlider = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyResourceSliderItem>
    primary: PrismicSlicePageDataBodyResourceSliderPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyResourceSliderItem = {
    card_cta: Maybe<Scalars['String']['output']>
    card_description: Maybe<Scalars['String']['output']>
    card_image: Maybe<PrismicSlicePageDataBodyResourceSliderItemsCardImageImageType>
    card_title: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    language: Maybe<Scalars['String']['output']>
    to: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyResourceSliderItemsCardImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyResourceSliderItemsCardImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyResourceSliderItemsCardImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyResourceSliderItemsCardImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyResourceSliderItemsCardImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyResourceSliderPrimary = {
    description: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    top_link: Maybe<PrismicLinkType>
    top_link_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyReviewsGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyReviewsGridItem>
    primary: PrismicSlicePageDataBodyReviewsGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyReviewsGridItem = {
    author: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    number_of_stars: Maybe<Scalars['Float']['output']>
    review_origin: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyReviewsGridPrimary = {
    author_subtext: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyRichText = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyRichTextPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyRichTextPrimary = {
    copy: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodySignUpHeroItem>
    primary: PrismicSlicePageDataBodySignUpHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodySignUpHeroItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
    lead_text: Maybe<PrismicStructuredTextType>
    pre_title: Maybe<Scalars['String']['output']>
    submit_text: Maybe<Scalars['String']['output']>
    thumbnail_video_mp4: Maybe<PrismicLinkType>
    thumbnail_video_webm: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
    video_poster_image: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge>
    group: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
    node: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
    node: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicSlicePageDataBodySignUpHeroPrimaryVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodySimpleCardGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodySimpleCardGridItem>
    primary: PrismicSlicePageDataBodySimpleCardGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodySimpleCardGridItem = {
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodySimpleCardGridItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySimpleCardGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySimpleCardGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodySimpleCardGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodySimpleCardGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodySimpleCardGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodySimpleCardGridPrimary = {
    card_cta_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    tracking_event: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySlicesType =
    | PrismicSlicePageDataBodyAccordion
    | PrismicSlicePageDataBodyBackgroundMediaHero
    | PrismicSlicePageDataBodyBentoBox
    | PrismicSlicePageDataBodyCardGrid
    | PrismicSlicePageDataBodyCardGridV2
    | PrismicSlicePageDataBodyChat
    | PrismicSlicePageDataBodyComparison
    | PrismicSlicePageDataBodyComparisonTable
    | PrismicSlicePageDataBodyComponentPlaceholder
    | PrismicSlicePageDataBodyContactEmails
    | PrismicSlicePageDataBodyContactHero
    | PrismicSlicePageDataBodyContentPlusBlocks
    | PrismicSlicePageDataBodyContentPlusShortBullets
    | PrismicSlicePageDataBodyCountdown
    | PrismicSlicePageDataBodyCustomerLogosPlusCta
    | PrismicSlicePageDataBodyCustomers
    | PrismicSlicePageDataBodyCustomersLogosPlusHeadline
    | PrismicSlicePageDataBodyDemoHero
    | PrismicSlicePageDataBodyEventCards
    | PrismicSlicePageDataBodyFaq
    | PrismicSlicePageDataBodyFeatureBlock
    | PrismicSlicePageDataBodyFeatureBlockWithMarquee
    | PrismicSlicePageDataBodyFeatureComparison
    | PrismicSlicePageDataBodyFeatureGrid
    | PrismicSlicePageDataBodyForm
    | PrismicSlicePageDataBodyGetStarted
    | PrismicSlicePageDataBodyGlassdoorWidget
    | PrismicSlicePageDataBodyHero
    | PrismicSlicePageDataBodyHighlight
    | PrismicSlicePageDataBodyHubspotForm
    | PrismicSlicePageDataBodyHubspotHeroForm
    | PrismicSlicePageDataBodyInlineVideoPlayerResourceHub
    | PrismicSlicePageDataBodyIntegrationCards
    | PrismicSlicePageDataBodyIntegrationOverview
    | PrismicSlicePageDataBodyIntegrations
    | PrismicSlicePageDataBodyIntegrationsGrid
    | PrismicSlicePageDataBodyInteractiveDemo
    | PrismicSlicePageDataBodyJobListings
    | PrismicSlicePageDataBodyJobsGrid
    | PrismicSlicePageDataBodyLandingHero
    | PrismicSlicePageDataBodyLatestBlogPosts
    | PrismicSlicePageDataBodyMagnetHero
    | PrismicSlicePageDataBodyMediaItemGrid
    | PrismicSlicePageDataBodyOnDemandResources
    | PrismicSlicePageDataBodyPanelGrid
    | PrismicSlicePageDataBodyPartnerProgramme
    | PrismicSlicePageDataBodyPricing
    | PrismicSlicePageDataBodyRatingsPlusHeadline
    | PrismicSlicePageDataBodyReferralHero
    | PrismicSlicePageDataBodyResourceSlider
    | PrismicSlicePageDataBodyReviewsGrid
    | PrismicSlicePageDataBodyRichText
    | PrismicSlicePageDataBodySignUpHero
    | PrismicSlicePageDataBodySimpleCardGrid
    | PrismicSlicePageDataBodySliderCards
    | PrismicSlicePageDataBodySocialProof
    | PrismicSlicePageDataBodyStats
    | PrismicSlicePageDataBodySteps
    | PrismicSlicePageDataBodyStickyCards
    | PrismicSlicePageDataBodyTabbedCarousel
    | PrismicSlicePageDataBodyTabbedHero
    | PrismicSlicePageDataBodyTable
    | PrismicSlicePageDataBodyTitleWithSideText
    | PrismicSlicePageDataBodyTwoImageHero
    | PrismicSlicePageDataBodyUpcomingEvents
    | PrismicSlicePageDataBodyVideo
    | PrismicSlicePageDataBodyVideoLibrary
    | PrismicSlicePageDataBodyVideoPopoverWithText
    | PrismicSlicePageDataBodyWideImageHero

export type PrismicSlicePageDataBodySliderCards = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodySliderCardsItem>
    primary: PrismicSlicePageDataBodySliderCardsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodySliderCardsItem = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodySliderCardsItemsImageImageType>
    item_heading: Maybe<Scalars['String']['output']>
    sub_description: Maybe<Scalars['String']['output']>
    sub_heading: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySliderCardsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySliderCardsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodySliderCardsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodySliderCardsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodySliderCardsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodySliderCardsPrimary = {
    card_background_color: Maybe<Scalars['String']['output']>
    hide_media_on_mobile: Maybe<Scalars['Boolean']['output']>
    highlight_first_card: Maybe<Scalars['Boolean']['output']>
    slider_heading: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySocialProof = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodySocialProofItem>
    primary: PrismicSlicePageDataBodySocialProofPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodySocialProofItem = {
    full_name: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodySocialProofItemsImageImageType>
    person_byline: Maybe<Scalars['String']['output']>
    predefined_testimonial: Maybe<PrismicLinkType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySocialProofItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySocialProofItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodySocialProofItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodySocialProofItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodySocialProofItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodySocialProofPrimary = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStats = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyStatsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyStatsPrimary = {
    first_stat_amount: Maybe<Scalars['Float']['output']>
    first_stat_as_percentile: Maybe<Scalars['Boolean']['output']>
    first_stat_text: Maybe<Scalars['String']['output']>
    predefined_statistics: Maybe<PrismicLinkType>
    second_stat_amount: Maybe<Scalars['Float']['output']>
    second_stat_as_percentile: Maybe<Scalars['Boolean']['output']>
    second_stat_text: Maybe<Scalars['String']['output']>
    source_text: Maybe<PrismicStructuredTextType>
    third_stat_amount: Maybe<Scalars['Float']['output']>
    third_stat_as_percentile: Maybe<Scalars['Boolean']['output']>
    third_stat_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodySteps = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyStepsItem>
    primary: PrismicSlicePageDataBodyStepsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyStepsItem = {
    background_color: Maybe<Scalars['String']['output']>
    content: Maybe<Scalars['String']['output']>
    heading: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyStepsItemsImageImageType>
    image_as_icon: Maybe<Scalars['Boolean']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_poster: Maybe<PrismicSlicePageDataBodyStepsItemsVideoPosterImageType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSlicePageDataBodyStepsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStepsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyStepsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyStepsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyStepsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyStepsItemsVideoPosterImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStepsItemsVideoPosterImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyStepsItemsVideoPosterImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyStepsItemsVideoPosterImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyStepsItemsVideoPosterImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyStepsPrimary = {
    align_text: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    description: Maybe<PrismicStructuredTextType>
    has_small_copy: Maybe<Scalars['Boolean']['output']>
    show_count: Maybe<Scalars['Boolean']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStickyCards = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyStickyCardsItem>
    primary: PrismicSlicePageDataBodyStickyCardsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyStickyCardsItem = {
    background_color: Maybe<Scalars['String']['output']>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyStickyCardsItemsImageImageType>
    video_mp4: Maybe<PrismicLinkType>
    video_poster_image: Maybe<PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageType>
}

export type PrismicSlicePageDataBodyStickyCardsItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyStickyCardsItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyStickyCardsItemsVideoPosterImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyStickyCardsPrimary = {
    headline: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTabbedCarousel = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyTabbedCarouselItem>
    primary: PrismicSlicePageDataBodyTabbedCarouselPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyTabbedCarouselItem = {
    carousel: Maybe<PrismicLinkType>
    tab_title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTabbedCarouselPrimary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTabbedHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyTabbedHeroItem>
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyTabbedHeroItem = {
    is_default: Maybe<Scalars['Boolean']['output']>
    tab: Maybe<PrismicLinkType>
    tab_title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTable = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicSlicePageDataBodyTableItem>
    primary: PrismicSlicePageDataBodyTablePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyTableItem = {
    column_1_content: Maybe<PrismicStructuredTextType>
    column_2_content: Maybe<PrismicStructuredTextType>
    column_3_content: Maybe<PrismicStructuredTextType>
    column_4_content: Maybe<PrismicStructuredTextType>
    column_5_content: Maybe<PrismicStructuredTextType>
    column_6_content: Maybe<PrismicStructuredTextType>
    column_7_content: Maybe<PrismicStructuredTextType>
    row_heading: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTablePrimary = {
    column_1_heading: Maybe<Scalars['String']['output']>
    column_2_heading: Maybe<Scalars['String']['output']>
    column_3_heading: Maybe<Scalars['String']['output']>
    column_4_heading: Maybe<Scalars['String']['output']>
    column_5_heading: Maybe<Scalars['String']['output']>
    column_6_heading: Maybe<Scalars['String']['output']>
    column_7_heading: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTitleWithSideText = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyTitleWithSideTextPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyTitleWithSideTextPrimary = {
    copy: Maybe<PrismicStructuredTextType>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTwoImageHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyTwoImageHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimary = {
    content: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image_button: Maybe<PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageType>
    image_left: Maybe<PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageType>
    image_right: Maybe<PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageType>
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageButtonImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageLeftImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyTwoImageHeroPrimaryImageRightImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyUpcomingEvents = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyUpcomingEventsPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyUpcomingEventsPrimary = {
    event_cta_text: Maybe<Scalars['String']['output']>
    filter_clear: Maybe<Scalars['String']['output']>
    filter_event_type_all: Maybe<Scalars['String']['output']>
    filter_event_type_deminar: Maybe<Scalars['String']['output']>
    filter_event_type_live_event: Maybe<Scalars['String']['output']>
    filter_event_type_placeholder: Maybe<Scalars['String']['output']>
    filter_event_type_webinar: Maybe<Scalars['String']['output']>
    filter_location_all: Maybe<Scalars['String']['output']>
    filter_location_placeholder: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    no_events_found: Maybe<Scalars['String']['output']>
    search_placeholder: Maybe<Scalars['String']['output']>
    showing_all_results: Maybe<Scalars['String']['output']>
    showing_all_results_for: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    top_link: Maybe<PrismicLinkType>
    top_link_text: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyVideo = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyVideoPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyVideoLibrary = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyVideoLibraryPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyVideoLibraryPrimary = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyVideoPopoverWithText = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyVideoPopoverWithTextPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyVideoPopoverWithTextPrimary = {
    body_text: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    pre_title: Maybe<Scalars['String']['output']>
    text_orientation: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyVideoPrimary = {
    section_html_id: Maybe<Scalars['String']['output']>
    thumbnail: Maybe<PrismicSlicePageDataBodyVideoPrimaryThumbnailImageType>
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyVideoPrimaryThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyVideoPrimaryThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyVideoPrimaryThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyVideoPrimaryThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyVideoPrimaryThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataBodyWideImageHero = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicSlicePageDataBodyWideImageHeroPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSlicePageDataBodyWideImageHeroPrimary = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageType>
    lead_text: Maybe<PrismicStructuredTextType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataBodyWideImageHeroPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageDataType = {
    body: Array<PrismicSlicePageDataBodySlicesType>
    description: Maybe<PrismicStructuredTextType>
    exclude_production: Maybe<Scalars['Boolean']['output']>
    exclude_robots: Maybe<Scalars['Boolean']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    header_cta_destination: Maybe<Scalars['String']['output']>
    header_explore_product_destination: Maybe<Scalars['String']['output']>
    hide_emails: Maybe<Scalars['Boolean']['output']>
    hide_footer: Maybe<Scalars['Boolean']['output']>
    hide_header: Maybe<Scalars['Boolean']['output']>
    hide_left_nav: Maybe<Scalars['Boolean']['output']>
    hide_links: Maybe<Scalars['Boolean']['output']>
    hide_right_nav: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    notification_message: Maybe<PrismicStructuredTextType>
    open_graph_image: Maybe<PrismicSlicePageDataOpenGraphImageImageType>
    parent_document: Maybe<PrismicLinkType>
    pre_title: Maybe<PrismicStructuredTextType>
    pretitle: Maybe<PrismicStructuredTextType>
    prismic_title: Maybe<Scalars['String']['output']>
    track_visible_sections: Maybe<Scalars['Boolean']['output']>
}

export type PrismicSlicePageDataTypeFieldSelector = {
    description: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    exclude_production: InputMaybe<FieldSelectorEnum>
    exclude_robots: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    header_cta_destination: InputMaybe<FieldSelectorEnum>
    header_explore_product_destination: InputMaybe<FieldSelectorEnum>
    hide_emails: InputMaybe<FieldSelectorEnum>
    hide_footer: InputMaybe<FieldSelectorEnum>
    hide_header: InputMaybe<FieldSelectorEnum>
    hide_left_nav: InputMaybe<FieldSelectorEnum>
    hide_links: InputMaybe<FieldSelectorEnum>
    hide_right_nav: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    notification_message: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    open_graph_image: InputMaybe<PrismicSlicePageDataOpenGraphImageImageTypeFieldSelector>
    parent_document: InputMaybe<PrismicLinkTypeFieldSelector>
    pre_title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    pretitle: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    track_visible_sections: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageDataTypeFilterInput = {
    description: InputMaybe<PrismicStructuredTextTypeFilterInput>
    exclude_production: InputMaybe<BooleanQueryOperatorInput>
    exclude_robots: InputMaybe<BooleanQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    header_cta_destination: InputMaybe<StringQueryOperatorInput>
    header_explore_product_destination: InputMaybe<StringQueryOperatorInput>
    hide_emails: InputMaybe<BooleanQueryOperatorInput>
    hide_footer: InputMaybe<BooleanQueryOperatorInput>
    hide_header: InputMaybe<BooleanQueryOperatorInput>
    hide_left_nav: InputMaybe<BooleanQueryOperatorInput>
    hide_links: InputMaybe<BooleanQueryOperatorInput>
    hide_right_nav: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    notification_message: InputMaybe<PrismicStructuredTextTypeFilterInput>
    open_graph_image: InputMaybe<PrismicSlicePageDataOpenGraphImageImageTypeFilterInput>
    parent_document: InputMaybe<PrismicLinkTypeFilterInput>
    pre_title: InputMaybe<PrismicStructuredTextTypeFilterInput>
    pretitle: InputMaybe<PrismicStructuredTextTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    track_visible_sections: InputMaybe<BooleanQueryOperatorInput>
}

export type PrismicSlicePageDataTypeSortInput = {
    description: InputMaybe<PrismicStructuredTextTypeSortInput>
    exclude_production: InputMaybe<SortOrderEnum>
    exclude_robots: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    header_cta_destination: InputMaybe<SortOrderEnum>
    header_explore_product_destination: InputMaybe<SortOrderEnum>
    hide_emails: InputMaybe<SortOrderEnum>
    hide_footer: InputMaybe<SortOrderEnum>
    hide_header: InputMaybe<SortOrderEnum>
    hide_left_nav: InputMaybe<SortOrderEnum>
    hide_links: InputMaybe<SortOrderEnum>
    hide_right_nav: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    notification_message: InputMaybe<PrismicStructuredTextTypeSortInput>
    open_graph_image: InputMaybe<PrismicSlicePageDataOpenGraphImageImageTypeSortInput>
    parent_document: InputMaybe<PrismicLinkTypeSortInput>
    pre_title: InputMaybe<PrismicStructuredTextTypeSortInput>
    pretitle: InputMaybe<PrismicStructuredTextTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    track_visible_sections: InputMaybe<SortOrderEnum>
}

export type PrismicSlicePageEdge = {
    next: Maybe<PrismicSlicePage>
    node: PrismicSlicePage
    previous: Maybe<PrismicSlicePage>
}

export type PrismicSlicePageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSlicePageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSlicePageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSlicePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSlicePageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSlicePageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSlicePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSlicePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSlicePageGroupConnectionDistinctArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageGroupConnectionGroupArgs = {
    field: PrismicSlicePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSlicePageGroupConnectionMaxArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageGroupConnectionMinArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageGroupConnectionSumArgs = {
    field: PrismicSlicePageFieldSelector
}

export type PrismicSlicePageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSlicePageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSliceType = {
    id: Scalars['ID']['output']
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicSocialProofIndicator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSocialProofIndicatorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofIndicatorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofIndicatorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofIndicatorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofIndicatorEdge>
    group: Array<PrismicSocialProofIndicatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofIndicator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofIndicatorConnectionDistinctArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorConnectionGroupArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofIndicatorConnectionMaxArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorConnectionMinArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorConnectionSumArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorDataIconImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofIndicatorDataIconImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofIndicatorDataIconImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSocialProofIndicatorDataIconImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSocialProofIndicatorDataIconImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSocialProofIndicatorDataIconImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofIndicatorDataIconImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofIndicatorDataIconImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofIndicatorDataType = {
    icon: Maybe<PrismicSocialProofIndicatorDataIconImageType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofIndicatorDataTypeFieldSelector = {
    icon: InputMaybe<PrismicSocialProofIndicatorDataIconImageTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofIndicatorDataTypeFilterInput = {
    icon: InputMaybe<PrismicSocialProofIndicatorDataIconImageTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofIndicatorDataTypeSortInput = {
    icon: InputMaybe<PrismicSocialProofIndicatorDataIconImageTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofIndicatorEdge = {
    next: Maybe<PrismicSocialProofIndicator>
    node: PrismicSocialProofIndicator
    previous: Maybe<PrismicSocialProofIndicator>
}

export type PrismicSocialProofIndicatorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSocialProofIndicatorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofIndicatorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofIndicatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofIndicatorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofIndicatorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSocialProofIndicatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofIndicator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofIndicatorGroupConnectionDistinctArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorGroupConnectionGroupArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofIndicatorGroupConnectionMaxArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorGroupConnectionMinArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorGroupConnectionSumArgs = {
    field: PrismicSocialProofIndicatorFieldSelector
}

export type PrismicSocialProofIndicatorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSocialProofIndicatorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofLogosExtendedSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSocialProofLogosExtendedSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofLogosExtendedSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofLogosExtendedSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofLogosExtendedSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofLogosExtendedSectionEdge>
    group: Array<PrismicSocialProofLogosExtendedSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofLogosExtendedSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofLogosExtendedSectionConnectionDistinctArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionConnectionGroupArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosExtendedSectionConnectionMaxArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionConnectionMinArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionConnectionSumArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionDataLogos = {
    logo: Maybe<PrismicSocialProofLogosExtendedSectionDataLogosLogoImageType>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosFieldSelector = {
    logo: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFieldSelector>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosFilterInput = {
    logo: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFilterInput>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosFilterInput>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofLogosExtendedSectionDataLogosSortInput = {
    logo: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosLogoImageTypeSortInput>
}

export type PrismicSocialProofLogosExtendedSectionDataType = {
    cta_text: Maybe<Scalars['String']['output']>
    logos: Maybe<Array<Maybe<PrismicSocialProofLogosExtendedSectionDataLogos>>>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicSocialProofLogosExtendedSectionDataTypeFieldSelector = {
    cta_text: InputMaybe<FieldSelectorEnum>
    logos: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
}

export type PrismicSocialProofLogosExtendedSectionDataTypeFilterInput = {
    cta_text: InputMaybe<StringQueryOperatorInput>
    logos: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
}

export type PrismicSocialProofLogosExtendedSectionDataTypeSortInput = {
    cta_text: InputMaybe<SortOrderEnum>
    logos: InputMaybe<PrismicSocialProofLogosExtendedSectionDataLogosSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
}

export type PrismicSocialProofLogosExtendedSectionEdge = {
    next: Maybe<PrismicSocialProofLogosExtendedSection>
    node: PrismicSocialProofLogosExtendedSection
    previous: Maybe<PrismicSocialProofLogosExtendedSection>
}

export type PrismicSocialProofLogosExtendedSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSocialProofLogosExtendedSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofLogosExtendedSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofLogosExtendedSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofLogosExtendedSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofLogosExtendedSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSocialProofLogosExtendedSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofLogosExtendedSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofLogosExtendedSectionGroupConnectionDistinctArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionGroupConnectionGroupArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosExtendedSectionGroupConnectionMaxArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionGroupConnectionMinArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionGroupConnectionSumArgs = {
    field: PrismicSocialProofLogosExtendedSectionFieldSelector
}

export type PrismicSocialProofLogosExtendedSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSocialProofLogosExtendedSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofLogosSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSocialProofLogosSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofLogosSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofLogosSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofLogosSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofLogosSectionEdge>
    group: Array<PrismicSocialProofLogosSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofLogosSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofLogosSectionConnectionDistinctArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionConnectionGroupArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosSectionConnectionMaxArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionConnectionMinArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionConnectionSumArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionDataLogos = {
    logo: Maybe<PrismicSocialProofLogosSectionDataLogosLogoImageType>
}

export type PrismicSocialProofLogosSectionDataLogosFieldSelector = {
    logo: InputMaybe<PrismicSocialProofLogosSectionDataLogosLogoImageTypeFieldSelector>
}

export type PrismicSocialProofLogosSectionDataLogosFilterInput = {
    logo: InputMaybe<PrismicSocialProofLogosSectionDataLogosLogoImageTypeFilterInput>
}

export type PrismicSocialProofLogosSectionDataLogosFilterListInput = {
    elemMatch: InputMaybe<PrismicSocialProofLogosSectionDataLogosFilterInput>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofLogosSectionDataLogosLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofLogosSectionDataLogosSortInput = {
    logo: InputMaybe<PrismicSocialProofLogosSectionDataLogosLogoImageTypeSortInput>
}

export type PrismicSocialProofLogosSectionDataType = {
    logos: Maybe<Array<Maybe<PrismicSocialProofLogosSectionDataLogos>>>
    prismic_title: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofLogosSectionDataTypeFieldSelector = {
    logos: InputMaybe<PrismicSocialProofLogosSectionDataLogosFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofLogosSectionDataTypeFilterInput = {
    logos: InputMaybe<PrismicSocialProofLogosSectionDataLogosFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofLogosSectionDataTypeSortInput = {
    logos: InputMaybe<PrismicSocialProofLogosSectionDataLogosSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofLogosSectionEdge = {
    next: Maybe<PrismicSocialProofLogosSection>
    node: PrismicSocialProofLogosSection
    previous: Maybe<PrismicSocialProofLogosSection>
}

export type PrismicSocialProofLogosSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSocialProofLogosSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofLogosSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofLogosSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofLogosSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofLogosSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSocialProofLogosSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofLogosSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofLogosSectionGroupConnectionDistinctArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionGroupConnectionGroupArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofLogosSectionGroupConnectionMaxArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionGroupConnectionMinArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionGroupConnectionSumArgs = {
    field: PrismicSocialProofLogosSectionFieldSelector
}

export type PrismicSocialProofLogosSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSocialProofLogosSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSocialProofRatingsSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSocialProofRatingsSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSocialProofRatingsSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofRatingsSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSocialProofRatingsSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofRatingsSectionEdge>
    group: Array<PrismicSocialProofRatingsSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofRatingsSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofRatingsSectionConnectionDistinctArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionConnectionGroupArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofRatingsSectionConnectionMaxArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionConnectionMinArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionConnectionSumArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionDataRatings = {
    rating: Maybe<PrismicLinkType>
}

export type PrismicSocialProofRatingsSectionDataRatingsFieldSelector = {
    rating: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSocialProofRatingsSectionDataRatingsFilterInput = {
    rating: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSocialProofRatingsSectionDataRatingsFilterListInput = {
    elemMatch: InputMaybe<PrismicSocialProofRatingsSectionDataRatingsFilterInput>
}

export type PrismicSocialProofRatingsSectionDataRatingsSortInput = {
    rating: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSocialProofRatingsSectionDataType = {
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    lead_text: Maybe<Scalars['String']['output']>
    prismic_title: Maybe<Scalars['String']['output']>
    ratings: Maybe<Array<Maybe<PrismicSocialProofRatingsSectionDataRatings>>>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicSocialProofRatingsSectionDataTypeFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    lead_text: InputMaybe<FieldSelectorEnum>
    prismic_title: InputMaybe<FieldSelectorEnum>
    ratings: InputMaybe<PrismicSocialProofRatingsSectionDataRatingsFieldSelector>
    title: InputMaybe<PrismicStructuredTextTypeFieldSelector>
}

export type PrismicSocialProofRatingsSectionDataTypeFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    lead_text: InputMaybe<StringQueryOperatorInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    ratings: InputMaybe<PrismicSocialProofRatingsSectionDataRatingsFilterListInput>
    title: InputMaybe<PrismicStructuredTextTypeFilterInput>
}

export type PrismicSocialProofRatingsSectionDataTypeSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    lead_text: InputMaybe<SortOrderEnum>
    prismic_title: InputMaybe<SortOrderEnum>
    ratings: InputMaybe<PrismicSocialProofRatingsSectionDataRatingsSortInput>
    title: InputMaybe<PrismicStructuredTextTypeSortInput>
}

export type PrismicSocialProofRatingsSectionEdge = {
    next: Maybe<PrismicSocialProofRatingsSection>
    node: PrismicSocialProofRatingsSection
    previous: Maybe<PrismicSocialProofRatingsSection>
}

export type PrismicSocialProofRatingsSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSocialProofRatingsSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSocialProofRatingsSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofRatingsSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSocialProofRatingsSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSocialProofRatingsSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSocialProofRatingsSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSocialProofRatingsSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSocialProofRatingsSectionGroupConnectionDistinctArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionGroupConnectionGroupArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSocialProofRatingsSectionGroupConnectionMaxArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionGroupConnectionMinArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionGroupConnectionSumArgs = {
    field: PrismicSocialProofRatingsSectionFieldSelector
}

export type PrismicSocialProofRatingsSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSocialProofRatingsSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicStarterBigformPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicStarterBigformPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicStarterBigformPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicStarterBigformPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicStarterBigformPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicStarterBigformPageEdge>
    group: Array<PrismicStarterBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicStarterBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicStarterBigformPageConnectionDistinctArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageConnectionGroupArgs = {
    field: PrismicStarterBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicStarterBigformPageConnectionMaxArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageConnectionMinArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageConnectionSumArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStarterBigformPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicStarterBigformPageDataType = {
    form_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicStarterBigformPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    social_proof_logos_section: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
}

export type PrismicStarterBigformPageDataTypeFieldSelector = {
    form_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicStarterBigformPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicStarterBigformPageDataTypeFilterInput = {
    form_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicStarterBigformPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStarterBigformPageDataTypeSortInput = {
    form_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicStarterBigformPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
}

export type PrismicStarterBigformPageEdge = {
    next: Maybe<PrismicStarterBigformPage>
    node: PrismicStarterBigformPage
    previous: Maybe<PrismicStarterBigformPage>
}

export type PrismicStarterBigformPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicStarterBigformPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicStarterBigformPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicStarterBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStarterBigformPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicStarterBigformPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicStarterBigformPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicStarterBigformPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicStarterBigformPageGroupConnectionDistinctArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageGroupConnectionGroupArgs = {
    field: PrismicStarterBigformPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicStarterBigformPageGroupConnectionMaxArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageGroupConnectionMinArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageGroupConnectionSumArgs = {
    field: PrismicStarterBigformPageFieldSelector
}

export type PrismicStarterBigformPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicStarterBigformPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicStatisticsSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicStatisticsSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicStatisticsSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicStatisticsSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicStatisticsSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicStatisticsSectionEdge>
    group: Array<PrismicStatisticsSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicStatisticsSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicStatisticsSectionConnectionDistinctArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionConnectionGroupArgs = {
    field: PrismicStatisticsSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicStatisticsSectionConnectionMaxArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionConnectionMinArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionConnectionSumArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionDataFirstStat = {
    amount: Maybe<Scalars['Float']['output']>
    as_percentile: Maybe<Scalars['Boolean']['output']>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicStatisticsSectionDataFirstStatFieldSelector = {
    amount: InputMaybe<FieldSelectorEnum>
    as_percentile: InputMaybe<FieldSelectorEnum>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicStatisticsSectionDataFirstStatFilterInput = {
    amount: InputMaybe<FloatQueryOperatorInput>
    as_percentile: InputMaybe<BooleanQueryOperatorInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStatisticsSectionDataFirstStatFilterListInput = {
    elemMatch: InputMaybe<PrismicStatisticsSectionDataFirstStatFilterInput>
}

export type PrismicStatisticsSectionDataFirstStatSortInput = {
    amount: InputMaybe<SortOrderEnum>
    as_percentile: InputMaybe<SortOrderEnum>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicStatisticsSectionDataSecondStat = {
    amount: Maybe<Scalars['Float']['output']>
    as_percentile: Maybe<Scalars['Boolean']['output']>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicStatisticsSectionDataSecondStatFieldSelector = {
    amount: InputMaybe<FieldSelectorEnum>
    as_percentile: InputMaybe<FieldSelectorEnum>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicStatisticsSectionDataSecondStatFilterInput = {
    amount: InputMaybe<FloatQueryOperatorInput>
    as_percentile: InputMaybe<BooleanQueryOperatorInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStatisticsSectionDataSecondStatFilterListInput = {
    elemMatch: InputMaybe<PrismicStatisticsSectionDataSecondStatFilterInput>
}

export type PrismicStatisticsSectionDataSecondStatSortInput = {
    amount: InputMaybe<SortOrderEnum>
    as_percentile: InputMaybe<SortOrderEnum>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicStatisticsSectionDataThirdStat = {
    amount: Maybe<Scalars['Float']['output']>
    as_percentile: Maybe<Scalars['Boolean']['output']>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicStatisticsSectionDataThirdStatFieldSelector = {
    amount: InputMaybe<FieldSelectorEnum>
    as_percentile: InputMaybe<FieldSelectorEnum>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicStatisticsSectionDataThirdStatFilterInput = {
    amount: InputMaybe<FloatQueryOperatorInput>
    as_percentile: InputMaybe<BooleanQueryOperatorInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStatisticsSectionDataThirdStatFilterListInput = {
    elemMatch: InputMaybe<PrismicStatisticsSectionDataThirdStatFilterInput>
}

export type PrismicStatisticsSectionDataThirdStatSortInput = {
    amount: InputMaybe<SortOrderEnum>
    as_percentile: InputMaybe<SortOrderEnum>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicStatisticsSectionDataType = {
    first_stat: Maybe<Array<Maybe<PrismicStatisticsSectionDataFirstStat>>>
    second_stat: Maybe<Array<Maybe<PrismicStatisticsSectionDataSecondStat>>>
    source_text: Maybe<PrismicStructuredTextType>
    third_stat: Maybe<Array<Maybe<PrismicStatisticsSectionDataThirdStat>>>
}

export type PrismicStatisticsSectionDataTypeFieldSelector = {
    first_stat: InputMaybe<PrismicStatisticsSectionDataFirstStatFieldSelector>
    second_stat: InputMaybe<PrismicStatisticsSectionDataSecondStatFieldSelector>
    source_text: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    third_stat: InputMaybe<PrismicStatisticsSectionDataThirdStatFieldSelector>
}

export type PrismicStatisticsSectionDataTypeFilterInput = {
    first_stat: InputMaybe<PrismicStatisticsSectionDataFirstStatFilterListInput>
    second_stat: InputMaybe<PrismicStatisticsSectionDataSecondStatFilterListInput>
    source_text: InputMaybe<PrismicStructuredTextTypeFilterInput>
    third_stat: InputMaybe<PrismicStatisticsSectionDataThirdStatFilterListInput>
}

export type PrismicStatisticsSectionDataTypeSortInput = {
    first_stat: InputMaybe<PrismicStatisticsSectionDataFirstStatSortInput>
    second_stat: InputMaybe<PrismicStatisticsSectionDataSecondStatSortInput>
    source_text: InputMaybe<PrismicStructuredTextTypeSortInput>
    third_stat: InputMaybe<PrismicStatisticsSectionDataThirdStatSortInput>
}

export type PrismicStatisticsSectionEdge = {
    next: Maybe<PrismicStatisticsSection>
    node: PrismicStatisticsSection
    previous: Maybe<PrismicStatisticsSection>
}

export type PrismicStatisticsSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicStatisticsSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicStatisticsSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicStatisticsSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStatisticsSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicStatisticsSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicStatisticsSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicStatisticsSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicStatisticsSectionGroupConnectionDistinctArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionGroupConnectionGroupArgs = {
    field: PrismicStatisticsSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicStatisticsSectionGroupConnectionMaxArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionGroupConnectionMinArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionGroupConnectionSumArgs = {
    field: PrismicStatisticsSectionFieldSelector
}

export type PrismicStatisticsSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicStatisticsSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicStructuredTextQueryOperatorInput = {
    eq: InputMaybe<Scalars['PrismicStructuredText']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['PrismicStructuredText']['input']>>>
    ne: InputMaybe<Scalars['PrismicStructuredText']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['PrismicStructuredText']['input']>>>
}

export type PrismicStructuredTextType = {
    html: Maybe<Scalars['String']['output']>
    /** @deprecated This field has been renamed to `richText`. The `richText` field has the same value the `raw` field. */
    raw: Scalars['PrismicStructuredText']['output']
    richText: Scalars['PrismicStructuredText']['output']
    text: Maybe<Scalars['String']['output']>
}

export type PrismicStructuredTextTypeFieldSelector = {
    html: InputMaybe<FieldSelectorEnum>
    raw: InputMaybe<FieldSelectorEnum>
    richText: InputMaybe<FieldSelectorEnum>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicStructuredTextTypeFilterInput = {
    html: InputMaybe<StringQueryOperatorInput>
    raw: InputMaybe<PrismicStructuredTextQueryOperatorInput>
    richText: InputMaybe<PrismicStructuredTextQueryOperatorInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicStructuredTextTypeSortInput = {
    html: InputMaybe<SortOrderEnum>
    raw: InputMaybe<SortOrderEnum>
    richText: InputMaybe<SortOrderEnum>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSubscriptionsPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSubscriptionsPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSubscriptionsPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSubscriptionsPageEdge>
    group: Array<PrismicSubscriptionsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSubscriptionsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSubscriptionsPageConnectionDistinctArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageConnectionGroupArgs = {
    field: PrismicSubscriptionsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageConnectionMaxArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageConnectionMinArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageConnectionSumArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageDataCustomerQuote = {
    attribution_name: Maybe<Scalars['String']['output']>
    attribution_title: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSubscriptionsPageDataCustomerQuoteImageImageType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataCustomerQuoteFieldSelector = {
    attribution_name: InputMaybe<FieldSelectorEnum>
    attribution_title: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFieldSelector>
    quote: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataCustomerQuoteFilterInput = {
    attribution_name: InputMaybe<StringQueryOperatorInput>
    attribution_title: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFilterInput>
    quote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataCustomerQuoteFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteFilterInput>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataCustomerQuoteSortInput = {
    attribution_name: InputMaybe<SortOrderEnum>
    attribution_title: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteImageImageTypeSortInput>
    quote: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicSubscriptionsPageDataFeatureBlocksImageImageType>
    title: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
}

export type PrismicSubscriptionsPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
    video_mp4: InputMaybe<PrismicLinkTypeFieldSelector>
    video_webm: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSubscriptionsPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
    video_mp4: InputMaybe<PrismicLinkTypeFilterInput>
    video_webm: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSubscriptionsPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksFilterInput>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
    video_mp4: InputMaybe<PrismicLinkTypeSortInput>
    video_webm: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSubscriptionsPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicSubscriptionsPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    submit_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicSubscriptionsPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicSubscriptionsPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataHeroFilterInput>
}

export type PrismicSubscriptionsPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicSubscriptionsPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataHowItWorksItems = {
    body: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicSubscriptionsPageDataHowItWorksItemsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsFieldSelector = {
    body: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsFilterInput = {
    body: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsFilterInput>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataHowItWorksItemsSortInput = {
    body: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataLearnMoreCards = {
    learn_more_card: Maybe<PrismicLinkType>
}

export type PrismicSubscriptionsPageDataLearnMoreCardsFieldSelector = {
    learn_more_card: InputMaybe<PrismicLinkTypeFieldSelector>
}

export type PrismicSubscriptionsPageDataLearnMoreCardsFilterInput = {
    learn_more_card: InputMaybe<PrismicLinkTypeFilterInput>
}

export type PrismicSubscriptionsPageDataLearnMoreCardsFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataLearnMoreCardsFilterInput>
}

export type PrismicSubscriptionsPageDataLearnMoreCardsSortInput = {
    learn_more_card: InputMaybe<PrismicLinkTypeSortInput>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataSteps = {
    image: Maybe<PrismicSubscriptionsPageDataStepsImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataStepsFieldSelector = {
    image: InputMaybe<PrismicSubscriptionsPageDataStepsImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataStepsFilterInput = {
    image: InputMaybe<PrismicSubscriptionsPageDataStepsImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataStepsFilterListInput = {
    elemMatch: InputMaybe<PrismicSubscriptionsPageDataStepsFilterInput>
}

export type PrismicSubscriptionsPageDataStepsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataStepsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataStepsSortInput = {
    image: InputMaybe<PrismicSubscriptionsPageDataStepsImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageDataType = {
    customer_quote: Maybe<Array<Maybe<PrismicSubscriptionsPageDataCustomerQuote>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks: Maybe<Array<Maybe<PrismicSubscriptionsPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicSubscriptionsPageDataHero>>>
    how_it_works_items: Maybe<Array<Maybe<PrismicSubscriptionsPageDataHowItWorksItems>>>
    how_it_works_title: Maybe<Scalars['String']['output']>
    learn_more_cards: Maybe<Array<Maybe<PrismicSubscriptionsPageDataLearnMoreCards>>>
    learn_more_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSubscriptionsPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_logos_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    steps: Maybe<Array<Maybe<PrismicSubscriptionsPageDataSteps>>>
    steps_title: Maybe<Scalars['String']['output']>
}

export type PrismicSubscriptionsPageDataTypeFieldSelector = {
    customer_quote: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicSubscriptionsPageDataHeroFieldSelector>
    how_it_works_items: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsFieldSelector>
    how_it_works_title: InputMaybe<FieldSelectorEnum>
    learn_more_cards: InputMaybe<PrismicSubscriptionsPageDataLearnMoreCardsFieldSelector>
    learn_more_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSubscriptionsPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    steps: InputMaybe<PrismicSubscriptionsPageDataStepsFieldSelector>
    steps_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageDataTypeFilterInput = {
    customer_quote: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicSubscriptionsPageDataHeroFilterListInput>
    how_it_works_items: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsFilterListInput>
    how_it_works_title: InputMaybe<StringQueryOperatorInput>
    learn_more_cards: InputMaybe<PrismicSubscriptionsPageDataLearnMoreCardsFilterListInput>
    learn_more_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSubscriptionsPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    steps: InputMaybe<PrismicSubscriptionsPageDataStepsFilterListInput>
    steps_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageDataTypeSortInput = {
    customer_quote: InputMaybe<PrismicSubscriptionsPageDataCustomerQuoteSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks: InputMaybe<PrismicSubscriptionsPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicSubscriptionsPageDataHeroSortInput>
    how_it_works_items: InputMaybe<PrismicSubscriptionsPageDataHowItWorksItemsSortInput>
    how_it_works_title: InputMaybe<SortOrderEnum>
    learn_more_cards: InputMaybe<PrismicSubscriptionsPageDataLearnMoreCardsSortInput>
    learn_more_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSubscriptionsPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    steps: InputMaybe<PrismicSubscriptionsPageDataStepsSortInput>
    steps_title: InputMaybe<SortOrderEnum>
}

export type PrismicSubscriptionsPageEdge = {
    next: Maybe<PrismicSubscriptionsPage>
    node: PrismicSubscriptionsPage
    previous: Maybe<PrismicSubscriptionsPage>
}

export type PrismicSubscriptionsPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSubscriptionsPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSubscriptionsPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSubscriptionsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSubscriptionsPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSubscriptionsPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSubscriptionsPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSubscriptionsPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSubscriptionsPageGroupConnectionDistinctArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageGroupConnectionGroupArgs = {
    field: PrismicSubscriptionsPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSubscriptionsPageGroupConnectionMaxArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageGroupConnectionMinArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageGroupConnectionSumArgs = {
    field: PrismicSubscriptionsPageFieldSelector
}

export type PrismicSubscriptionsPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSubscriptionsPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegration = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSyncedIntegrationDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSyncedIntegrationLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSyncedIntegrationConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationEdge>
    group: Array<PrismicSyncedIntegrationGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegration>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationConnectionGroupArgs = {
    field: PrismicSyncedIntegrationFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationConnectionMaxArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationConnectionMinArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationConnectionSumArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationType = Node & {
    category: Maybe<Scalars['String']['output']>
    children: Array<Node>
    id: Scalars['ID']['output']
    initiationUrl: Maybe<Scalars['String']['output']>
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
    slug: Maybe<Scalars['String']['output']>
    status: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeEdge>
    group: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnectionGroupArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnectionMaxArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnectionMinArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnectionSumArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeEdge = {
    next: Maybe<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
    node: PrismicSyncedIntegrationDataEndymionAppIntegrationType
    previous: Maybe<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector = {
    category: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    initiationUrl: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    slug: InputMaybe<FieldSelectorEnum>
    status: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFilterInput = {
    category: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    initiationUrl: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    slug: InputMaybe<StringQueryOperatorInput>
    status: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector
}

export type PrismicSyncedIntegrationDataEndymionAppIntegrationTypeSortInput = {
    category: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    initiationUrl: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    slug: InputMaybe<SortOrderEnum>
    status: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegrationDataLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationDataLogoImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationDataLogoImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSyncedIntegrationDataLogoImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSyncedIntegrationDataLogoImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSyncedIntegrationDataLogoImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationDataLogoImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationDataLogoImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegrationDataType = {
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<Scalars['String']['output']>
    endymion_app: Maybe<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    logo: Maybe<PrismicSyncedIntegrationDataLogoImageType>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicSyncedIntegrationDataOpenGraphImageImageType>
}

export type PrismicSyncedIntegrationDataTypeFieldSelector = {
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    description: InputMaybe<FieldSelectorEnum>
    endymion_app: InputMaybe<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    logo: InputMaybe<PrismicSyncedIntegrationDataLogoImageTypeFieldSelector>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicSyncedIntegrationDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicSyncedIntegrationDataTypeFilterInput = {
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    description: InputMaybe<StringQueryOperatorInput>
    endymion_app: InputMaybe<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFilterInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    logo: InputMaybe<PrismicSyncedIntegrationDataLogoImageTypeFilterInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicSyncedIntegrationDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicSyncedIntegrationDataTypeSortInput = {
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    description: InputMaybe<SortOrderEnum>
    endymion_app: InputMaybe<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    logo: InputMaybe<PrismicSyncedIntegrationDataLogoImageTypeSortInput>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicSyncedIntegrationDataOpenGraphImageImageTypeSortInput>
}

export type PrismicSyncedIntegrationEdge = {
    next: Maybe<PrismicSyncedIntegration>
    node: PrismicSyncedIntegration
    previous: Maybe<PrismicSyncedIntegration>
}

export type PrismicSyncedIntegrationFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSyncedIntegrationDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSyncedIntegrationDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSyncedIntegrationGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegration>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationGroupConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationGroupConnectionGroupArgs = {
    field: PrismicSyncedIntegrationFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationGroupConnectionMaxArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationGroupConnectionMinArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationGroupConnectionSumArgs = {
    field: PrismicSyncedIntegrationFieldSelector
}

export type PrismicSyncedIntegrationSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSyncedIntegrationDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegrationsCategories = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicSyncedIntegrationsCategoriesDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationsCategoriesFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSyncedIntegrationsCategoriesLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicSyncedIntegrationsCategoriesConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationsCategoriesEdge>
    group: Array<PrismicSyncedIntegrationsCategoriesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegrationsCategories>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationsCategoriesConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesConnectionGroupArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationsCategoriesConnectionMaxArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesConnectionMinArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesConnectionSumArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesDataCategories = {
    category: Maybe<Scalars['String']['output']>
    label_color: Maybe<Scalars['String']['output']>
    label_text: Maybe<Scalars['String']['output']>
}

export type PrismicSyncedIntegrationsCategoriesDataCategoriesFieldSelector = {
    category: InputMaybe<FieldSelectorEnum>
    label_color: InputMaybe<FieldSelectorEnum>
    label_text: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationsCategoriesDataCategoriesFilterInput = {
    category: InputMaybe<StringQueryOperatorInput>
    label_color: InputMaybe<StringQueryOperatorInput>
    label_text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationsCategoriesDataCategoriesFilterListInput = {
    elemMatch: InputMaybe<PrismicSyncedIntegrationsCategoriesDataCategoriesFilterInput>
}

export type PrismicSyncedIntegrationsCategoriesDataCategoriesSortInput = {
    category: InputMaybe<SortOrderEnum>
    label_color: InputMaybe<SortOrderEnum>
    label_text: InputMaybe<SortOrderEnum>
}

export type PrismicSyncedIntegrationsCategoriesDataType = {
    categories: Maybe<Array<Maybe<PrismicSyncedIntegrationsCategoriesDataCategories>>>
}

export type PrismicSyncedIntegrationsCategoriesDataTypeFieldSelector = {
    categories: InputMaybe<PrismicSyncedIntegrationsCategoriesDataCategoriesFieldSelector>
}

export type PrismicSyncedIntegrationsCategoriesDataTypeFilterInput = {
    categories: InputMaybe<PrismicSyncedIntegrationsCategoriesDataCategoriesFilterListInput>
}

export type PrismicSyncedIntegrationsCategoriesDataTypeSortInput = {
    categories: InputMaybe<PrismicSyncedIntegrationsCategoriesDataCategoriesSortInput>
}

export type PrismicSyncedIntegrationsCategoriesEdge = {
    next: Maybe<PrismicSyncedIntegrationsCategories>
    node: PrismicSyncedIntegrationsCategories
    previous: Maybe<PrismicSyncedIntegrationsCategories>
}

export type PrismicSyncedIntegrationsCategoriesFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicSyncedIntegrationsCategoriesDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicSyncedIntegrationsCategoriesFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSyncedIntegrationsCategoriesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicSyncedIntegrationsCategoriesGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicSyncedIntegrationsCategoriesEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicSyncedIntegrationsCategoriesGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicSyncedIntegrationsCategories>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicSyncedIntegrationsCategoriesGroupConnectionDistinctArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesGroupConnectionGroupArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicSyncedIntegrationsCategoriesGroupConnectionMaxArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesGroupConnectionMinArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesGroupConnectionSumArgs = {
    field: PrismicSyncedIntegrationsCategoriesFieldSelector
}

export type PrismicSyncedIntegrationsCategoriesSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicSyncedIntegrationsCategoriesDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTemplateCustomerCase = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicTemplateCustomerCaseDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTemplateCustomerCaseLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTemplateCustomerCaseConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTemplateCustomerCaseEdge>
    group: Array<PrismicTemplateCustomerCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTemplateCustomerCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTemplateCustomerCaseConnectionDistinctArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseConnectionGroupArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseConnectionMaxArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseConnectionMinArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseConnectionSumArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseDataBodyCardGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplateCustomerCaseDataBodyCardGridItem>
    primary: PrismicTemplateCustomerCaseDataBodyCardGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItem = {
    body: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    filter_keywords: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageType>
    tag_color: Maybe<Scalars['String']['output']>
    tag_text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplateCustomerCaseDataBodyCardGridPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    card_cta_text: Maybe<Scalars['String']['output']>
    image_fit: Maybe<Scalars['String']['output']>
    initial_cards_shown: Maybe<Scalars['String']['output']>
    initial_cards_shown_on_desktop: Maybe<Scalars['String']['output']>
    initial_cards_shown_on_mobile: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    no_padding: Maybe<Scalars['Boolean']['output']>
    show_filter: Maybe<Scalars['Boolean']['output']>
    show_more_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<PrismicStructuredTextType>
}

export type PrismicTemplateCustomerCaseDataBodyGetStarted = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplateCustomerCaseDataBodyGetStartedItem>
    primary: PrismicTemplateCustomerCaseDataBodyGetStartedPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    button_label: Maybe<Scalars['String']['output']>
    error_message: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
    form_subtitle: Maybe<Scalars['String']['output']>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageType>
    input_placeholder: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    section_color: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType =
    Node & {
        children: Array<Node>
        consents: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents>
        formId: Maybe<Scalars['String']['output']>
        id: Scalars['ID']['output']
        internal: Internal
        parent: Maybe<Node>
        prismicId: Maybe<Scalars['String']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge =
    {
        next: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
        node: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType
        previous: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType =
    Node & {
        children: Array<Node>
        consents: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents>
        formId: Maybe<Scalars['String']['output']>
        id: Scalars['ID']['output']
        internal: Internal
        parent: Maybe<Node>
        prismicId: Maybe<Scalars['String']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
        group: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents =
    {
        communicationConsents: Maybe<
            Array<
                Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
            >
        >
        type: Maybe<Scalars['String']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
    node: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplateCustomerCaseDataBodyMediaItemGridItem>
    primary: PrismicTemplateCustomerCaseDataBodyMediaItemGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItem = {
    image: Maybe<PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageType>
    item_description: Maybe<PrismicStructuredTextType>
    item_title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplateCustomerCaseDataBodyMediaItemGridPrimary = {
    background: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataBodySlicesType =
    | PrismicTemplateCustomerCaseDataBodyCardGrid
    | PrismicTemplateCustomerCaseDataBodyGetStarted
    | PrismicTemplateCustomerCaseDataBodyMediaItemGrid

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTemplateCustomerCaseDataType = {
    body: Array<PrismicTemplateCustomerCaseDataBodySlicesType>
    meta_description: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicTemplateCustomerCaseDataOpenGraphImageImageType>
}

export type PrismicTemplateCustomerCaseDataTypeFieldSelector = {
    meta_description: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicTemplateCustomerCaseDataTypeFilterInput = {
    meta_description: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicTemplateCustomerCaseDataTypeSortInput = {
    meta_description: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicTemplateCustomerCaseDataOpenGraphImageImageTypeSortInput>
}

export type PrismicTemplateCustomerCaseEdge = {
    next: Maybe<PrismicTemplateCustomerCase>
    node: PrismicTemplateCustomerCase
    previous: Maybe<PrismicTemplateCustomerCase>
}

export type PrismicTemplateCustomerCaseFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicTemplateCustomerCaseDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTemplateCustomerCaseFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTemplateCustomerCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTemplateCustomerCaseGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTemplateCustomerCaseEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTemplateCustomerCaseGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTemplateCustomerCase>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTemplateCustomerCaseGroupConnectionDistinctArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseGroupConnectionGroupArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplateCustomerCaseGroupConnectionMaxArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseGroupConnectionMinArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseGroupConnectionSumArgs = {
    field: PrismicTemplateCustomerCaseFieldSelector
}

export type PrismicTemplateCustomerCaseSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicTemplateCustomerCaseDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTemplatePartner = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicTemplatePartnerDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTemplatePartnerLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTemplatePartnerConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTemplatePartnerEdge>
    group: Array<PrismicTemplatePartnerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTemplatePartner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTemplatePartnerConnectionDistinctArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerConnectionGroupArgs = {
    field: PrismicTemplatePartnerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerConnectionMaxArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerConnectionMinArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerConnectionSumArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadline = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItem>
    primary: PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlinePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItem = {
    customer_logo: Maybe<PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageType>
}

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeFixedArgs =
    {
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams?: InputMaybe<ImgixParamsInput>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        quality: InputMaybe<Scalars['Int']['input']>
        width?: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeFluidArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
        maxHeight: InputMaybe<Scalars['Int']['input']>
        maxWidth?: InputMaybe<Scalars['Int']['input']>
        placeholderImgixParams?: InputMaybe<ImgixParamsInput>
        srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    }

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlineItemsCustomerLogoImageTypeUrlArgs =
    {
        imgixParams?: InputMaybe<ImgixParamsInput>
    }

export type PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadlinePrimary = {
    customer_logos_title: Maybe<PrismicStructuredTextType>
    predefined_logos: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyFeatureBlock = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicTemplatePartnerDataBodyFeatureBlockPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimary = {
    background: Maybe<Scalars['String']['output']>
    cta_hash_link: Maybe<Scalars['String']['output']>
    cta_label: Maybe<Scalars['String']['output']>
    cta_link: Maybe<PrismicLinkType>
    description: Maybe<PrismicStructuredTextType>
    headline: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageType>
    inverse: Maybe<Scalars['Boolean']['output']>
    is_circular_image: Maybe<Scalars['Boolean']['output']>
    pre_cta_links: Maybe<PrismicStructuredTextType>
    predefined_feature_block: Maybe<PrismicLinkType>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    title_over_section: Maybe<Scalars['String']['output']>
    video_mp4: Maybe<PrismicLinkType>
    video_webm: Maybe<PrismicLinkType>
    wistia_video_id: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplatePartnerDataBodyFeatureBlockPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplatePartnerDataBodyGetStarted = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplatePartnerDataBodyGetStartedItem>
    primary: PrismicTemplatePartnerDataBodyGetStartedPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodyGetStartedItem = {
    highlight_item: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimary = {
    aria_label: Maybe<Scalars['String']['output']>
    button_label: Maybe<Scalars['String']['output']>
    error_message: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
    form_staging: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
    form_subtitle: Maybe<Scalars['String']['output']>
    hubspot_form_id_production: Maybe<Scalars['String']['output']>
    hubspot_form_id_staging: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageType>
    input_placeholder: Maybe<Scalars['String']['output']>
    predefined_signup_banner: Maybe<PrismicLinkType>
    section_color: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    variant: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        group: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionMinArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnectionSumArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
    node: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType
    previous: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput =
    {
        children: InputMaybe<NodeSortInput>
        consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsSortInput>
        formId: InputMaybe<SortOrderEnum>
        id: InputMaybe<SortOrderEnum>
        internal: InputMaybe<InternalSortInput>
        parent: InputMaybe<NodeSortInput>
        prismicId: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
    group: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionDistinctArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionGroupArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMaxArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionMinArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnectionSumArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
        type: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
        type: InputMaybe<StringQueryOperatorInput>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput =
    {
        communicationConsents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
        type: InputMaybe<SortOrderEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
    node: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType
    previous: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector =
    {
        children: InputMaybe<NodeFieldSelector>
        consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFieldSelector>
        formId: InputMaybe<FieldSelectorEnum>
        id: InputMaybe<FieldSelectorEnum>
        internal: InputMaybe<InternalFieldSelector>
        parent: InputMaybe<NodeFieldSelector>
        prismicId: InputMaybe<FieldSelectorEnum>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection =
    {
        distinct: Array<Scalars['String']['output']>
        edges: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeEdge>
        field: Scalars['String']['output']
        fieldValue: Maybe<Scalars['String']['output']>
        group: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnection>
        max: Maybe<Scalars['Float']['output']>
        min: Maybe<Scalars['Float']['output']>
        nodes: Array<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
        pageInfo: PageInfo
        sum: Maybe<Scalars['Float']['output']>
        totalCount: Scalars['Int']['output']
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionGroupArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMaxArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionMinArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeGroupConnectionSumArgs =
    {
        field: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFieldSelector
    }

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplatePartnerDataBodyGetStartedPrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplatePartnerDataBodyMediaItemGrid = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplatePartnerDataBodyMediaItemGridItem>
    primary: PrismicTemplatePartnerDataBodyMediaItemGridPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItem = {
    image: Maybe<PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageType>
    item_description: Maybe<PrismicStructuredTextType>
    item_title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplatePartnerDataBodyMediaItemGridPrimary = {
    background: Maybe<Scalars['String']['output']>
    layout: Maybe<Scalars['String']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodyRatingsPlusHeadline = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplatePartnerDataBodyRatingsPlusHeadlineItem>
    primary: PrismicTemplatePartnerDataBodyRatingsPlusHeadlinePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodyRatingsPlusHeadlineItem = {
    rating: Maybe<PrismicLinkType>
}

export type PrismicTemplatePartnerDataBodyRatingsPlusHeadlinePrimary = {
    cta_link: Maybe<PrismicLinkType>
    predefined_ratings: Maybe<PrismicLinkType>
    ratings_cta_text: Maybe<Scalars['String']['output']>
    ratings_lead_text: Maybe<Scalars['String']['output']>
    ratings_title: Maybe<PrismicStructuredTextType>
    section_html_id: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodySlicesType =
    | PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadline
    | PrismicTemplatePartnerDataBodyFeatureBlock
    | PrismicTemplatePartnerDataBodyGetStarted
    | PrismicTemplatePartnerDataBodyMediaItemGrid
    | PrismicTemplatePartnerDataBodyRatingsPlusHeadline
    | PrismicTemplatePartnerDataBodySocialProof

export type PrismicTemplatePartnerDataBodySocialProof = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicTemplatePartnerDataBodySocialProofItem>
    primary: PrismicTemplatePartnerDataBodySocialProofPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicTemplatePartnerDataBodySocialProofItem = {
    full_name: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTemplatePartnerDataBodySocialProofItemsImageImageType>
    person_byline: Maybe<Scalars['String']['output']>
    predefined_testimonial: Maybe<PrismicLinkType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodySocialProofItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataBodySocialProofItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerDataBodySocialProofItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplatePartnerDataBodySocialProofItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplatePartnerDataBodySocialProofItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplatePartnerDataBodySocialProofPrimary = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTemplatePartnerDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTemplatePartnerDataType = {
    body: Array<PrismicTemplatePartnerDataBodySlicesType>
    meta_description: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicTemplatePartnerDataOpenGraphImageImageType>
}

export type PrismicTemplatePartnerDataTypeFieldSelector = {
    meta_description: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicTemplatePartnerDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicTemplatePartnerDataTypeFilterInput = {
    meta_description: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicTemplatePartnerDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicTemplatePartnerDataTypeSortInput = {
    meta_description: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicTemplatePartnerDataOpenGraphImageImageTypeSortInput>
}

export type PrismicTemplatePartnerEdge = {
    next: Maybe<PrismicTemplatePartner>
    node: PrismicTemplatePartner
    previous: Maybe<PrismicTemplatePartner>
}

export type PrismicTemplatePartnerFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicTemplatePartnerDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTemplatePartnerFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTemplatePartnerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTemplatePartnerGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTemplatePartnerEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTemplatePartnerGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTemplatePartner>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTemplatePartnerGroupConnectionDistinctArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerGroupConnectionGroupArgs = {
    field: PrismicTemplatePartnerFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTemplatePartnerGroupConnectionMaxArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerGroupConnectionMinArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerGroupConnectionSumArgs = {
    field: PrismicTemplatePartnerFieldSelector
}

export type PrismicTemplatePartnerSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicTemplatePartnerDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTestAaa = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTestAaaFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTestAaaLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTestAaaConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTestAaaEdge>
    group: Array<PrismicTestAaaGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTestAaa>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTestAaaConnectionDistinctArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaConnectionGroupArgs = {
    field: PrismicTestAaaFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTestAaaConnectionMaxArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaConnectionMinArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaConnectionSumArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaEdge = {
    next: Maybe<PrismicTestAaa>
    node: PrismicTestAaa
    previous: Maybe<PrismicTestAaa>
}

export type PrismicTestAaaFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTestAaaFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTestAaaGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTestAaaEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTestAaaGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTestAaa>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTestAaaGroupConnectionDistinctArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaGroupConnectionGroupArgs = {
    field: PrismicTestAaaFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTestAaaGroupConnectionMaxArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaGroupConnectionMinArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaGroupConnectionSumArgs = {
    field: PrismicTestAaaFieldSelector
}

export type PrismicTestAaaSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTestimonial = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicTestimonialDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTestimonialFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTestimonialLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTestimonialConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTestimonialEdge>
    group: Array<PrismicTestimonialGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTestimonial>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTestimonialConnectionDistinctArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialConnectionGroupArgs = {
    field: PrismicTestimonialFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTestimonialConnectionMaxArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialConnectionMinArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialConnectionSumArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialDataImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTestimonialDataImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTestimonialDataImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicTestimonialDataImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicTestimonialDataImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicTestimonialDataImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTestimonialDataImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTestimonialDataImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTestimonialDataType = {
    attribution_name: Maybe<Scalars['String']['output']>
    attribution_title: Maybe<Scalars['String']['output']>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicTestimonialDataImageImageType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicTestimonialDataTypeFieldSelector = {
    attribution_name: InputMaybe<FieldSelectorEnum>
    attribution_title: InputMaybe<FieldSelectorEnum>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicTestimonialDataImageImageTypeFieldSelector>
    quote: InputMaybe<FieldSelectorEnum>
}

export type PrismicTestimonialDataTypeFilterInput = {
    attribution_name: InputMaybe<StringQueryOperatorInput>
    attribution_title: InputMaybe<StringQueryOperatorInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicTestimonialDataImageImageTypeFilterInput>
    quote: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTestimonialDataTypeSortInput = {
    attribution_name: InputMaybe<SortOrderEnum>
    attribution_title: InputMaybe<SortOrderEnum>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicTestimonialDataImageImageTypeSortInput>
    quote: InputMaybe<SortOrderEnum>
}

export type PrismicTestimonialEdge = {
    next: Maybe<PrismicTestimonial>
    node: PrismicTestimonial
    previous: Maybe<PrismicTestimonial>
}

export type PrismicTestimonialFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicTestimonialDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTestimonialFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTestimonialDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTestimonialGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTestimonialEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTestimonialGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTestimonial>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTestimonialGroupConnectionDistinctArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialGroupConnectionGroupArgs = {
    field: PrismicTestimonialFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTestimonialGroupConnectionMaxArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialGroupConnectionMinArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialGroupConnectionSumArgs = {
    field: PrismicTestimonialFieldSelector
}

export type PrismicTestimonialSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicTestimonialDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicThirdPartyLicencesSection = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicThirdPartyLicencesSectionDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicThirdPartyLicencesSectionFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicThirdPartyLicencesSectionLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicThirdPartyLicencesSectionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicThirdPartyLicencesSectionEdge>
    group: Array<PrismicThirdPartyLicencesSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicThirdPartyLicencesSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicThirdPartyLicencesSectionConnectionDistinctArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionConnectionGroupArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicThirdPartyLicencesSectionConnectionMaxArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionConnectionMinArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionConnectionSumArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionDataLicences = {
    licence_type: Maybe<Scalars['String']['output']>
    program_name: Maybe<Scalars['String']['output']>
    program_url: Maybe<Scalars['String']['output']>
}

export type PrismicThirdPartyLicencesSectionDataLicencesFieldSelector = {
    licence_type: InputMaybe<FieldSelectorEnum>
    program_name: InputMaybe<FieldSelectorEnum>
    program_url: InputMaybe<FieldSelectorEnum>
}

export type PrismicThirdPartyLicencesSectionDataLicencesFilterInput = {
    licence_type: InputMaybe<StringQueryOperatorInput>
    program_name: InputMaybe<StringQueryOperatorInput>
    program_url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicThirdPartyLicencesSectionDataLicencesFilterListInput = {
    elemMatch: InputMaybe<PrismicThirdPartyLicencesSectionDataLicencesFilterInput>
}

export type PrismicThirdPartyLicencesSectionDataLicencesSortInput = {
    licence_type: InputMaybe<SortOrderEnum>
    program_name: InputMaybe<SortOrderEnum>
    program_url: InputMaybe<SortOrderEnum>
}

export type PrismicThirdPartyLicencesSectionDataType = {
    licences: Maybe<Array<Maybe<PrismicThirdPartyLicencesSectionDataLicences>>>
    prismic_title: Maybe<Scalars['String']['output']>
}

export type PrismicThirdPartyLicencesSectionDataTypeFieldSelector = {
    licences: InputMaybe<PrismicThirdPartyLicencesSectionDataLicencesFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
}

export type PrismicThirdPartyLicencesSectionDataTypeFilterInput = {
    licences: InputMaybe<PrismicThirdPartyLicencesSectionDataLicencesFilterListInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicThirdPartyLicencesSectionDataTypeSortInput = {
    licences: InputMaybe<PrismicThirdPartyLicencesSectionDataLicencesSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
}

export type PrismicThirdPartyLicencesSectionEdge = {
    next: Maybe<PrismicThirdPartyLicencesSection>
    node: PrismicThirdPartyLicencesSection
    previous: Maybe<PrismicThirdPartyLicencesSection>
}

export type PrismicThirdPartyLicencesSectionFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicThirdPartyLicencesSectionDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicThirdPartyLicencesSectionFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicThirdPartyLicencesSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicThirdPartyLicencesSectionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicThirdPartyLicencesSectionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicThirdPartyLicencesSectionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicThirdPartyLicencesSection>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicThirdPartyLicencesSectionGroupConnectionDistinctArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionGroupConnectionGroupArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicThirdPartyLicencesSectionGroupConnectionMaxArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionGroupConnectionMinArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionGroupConnectionSumArgs = {
    field: PrismicThirdPartyLicencesSectionFieldSelector
}

export type PrismicThirdPartyLicencesSectionSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicThirdPartyLicencesSectionDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicTypePathType = Node & {
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    kind: Scalars['String']['output']
    parent: Maybe<Node>
    path: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
}

export type PrismicTypePathTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTypePathTypeEdge>
    group: Array<PrismicTypePathTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTypePathType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTypePathTypeConnectionDistinctArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeConnectionGroupArgs = {
    field: PrismicTypePathTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTypePathTypeConnectionMaxArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeConnectionMinArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeConnectionSumArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeEdge = {
    next: Maybe<PrismicTypePathType>
    node: PrismicTypePathType
    previous: Maybe<PrismicTypePathType>
}

export type PrismicTypePathTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    kind: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    path: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicTypePathTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    kind: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    path: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTypePathTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTypePathTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTypePathTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTypePathType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTypePathTypeGroupConnectionDistinctArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeGroupConnectionGroupArgs = {
    field: PrismicTypePathTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTypePathTypeGroupConnectionMaxArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeGroupConnectionMinArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeGroupConnectionSumArgs = {
    field: PrismicTypePathTypeFieldSelector
}

export type PrismicTypePathTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    kind: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    path: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicTypeformSurveys = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicTypeformSurveysDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicTypeformSurveysFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTypeformSurveysLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicTypeformSurveysConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTypeformSurveysEdge>
    group: Array<PrismicTypeformSurveysGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTypeformSurveys>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTypeformSurveysConnectionDistinctArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysConnectionGroupArgs = {
    field: PrismicTypeformSurveysFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTypeformSurveysConnectionMaxArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysConnectionMinArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysConnectionSumArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysDataHiddenSurveyPaths = {
    path: Maybe<Scalars['String']['output']>
}

export type PrismicTypeformSurveysDataHiddenSurveyPathsFieldSelector = {
    path: InputMaybe<FieldSelectorEnum>
}

export type PrismicTypeformSurveysDataHiddenSurveyPathsFilterInput = {
    path: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTypeformSurveysDataHiddenSurveyPathsFilterListInput = {
    elemMatch: InputMaybe<PrismicTypeformSurveysDataHiddenSurveyPathsFilterInput>
}

export type PrismicTypeformSurveysDataHiddenSurveyPathsSortInput = {
    path: InputMaybe<SortOrderEnum>
}

export type PrismicTypeformSurveysDataType = {
    hidden_survey_paths: Maybe<Array<Maybe<PrismicTypeformSurveysDataHiddenSurveyPaths>>>
    is_staging_only: Maybe<Scalars['Boolean']['output']>
    typeform_id: Maybe<Scalars['String']['output']>
}

export type PrismicTypeformSurveysDataTypeFieldSelector = {
    hidden_survey_paths: InputMaybe<PrismicTypeformSurveysDataHiddenSurveyPathsFieldSelector>
    is_staging_only: InputMaybe<FieldSelectorEnum>
    typeform_id: InputMaybe<FieldSelectorEnum>
}

export type PrismicTypeformSurveysDataTypeFilterInput = {
    hidden_survey_paths: InputMaybe<PrismicTypeformSurveysDataHiddenSurveyPathsFilterListInput>
    is_staging_only: InputMaybe<BooleanQueryOperatorInput>
    typeform_id: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTypeformSurveysDataTypeSortInput = {
    hidden_survey_paths: InputMaybe<PrismicTypeformSurveysDataHiddenSurveyPathsSortInput>
    is_staging_only: InputMaybe<SortOrderEnum>
    typeform_id: InputMaybe<SortOrderEnum>
}

export type PrismicTypeformSurveysEdge = {
    next: Maybe<PrismicTypeformSurveys>
    node: PrismicTypeformSurveys
    previous: Maybe<PrismicTypeformSurveys>
}

export type PrismicTypeformSurveysFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicTypeformSurveysDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicTypeformSurveysFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTypeformSurveysDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicTypeformSurveysGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicTypeformSurveysEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicTypeformSurveysGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicTypeformSurveys>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicTypeformSurveysGroupConnectionDistinctArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysGroupConnectionGroupArgs = {
    field: PrismicTypeformSurveysFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicTypeformSurveysGroupConnectionMaxArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysGroupConnectionMinArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysGroupConnectionSumArgs = {
    field: PrismicTypeformSurveysFieldSelector
}

export type PrismicTypeformSurveysSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicTypeformSurveysDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModal = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicUnifiedSignupModalDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicUnifiedSignupModalLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicUnifiedSignupModalConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalEdge>
    group: Array<PrismicUnifiedSignupModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalConnectionDistinctArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalConnectionMinArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalConnectionSumArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalDataBodyCroppedImage = PrismicSliceType & {
    id: Scalars['ID']['output']
    primary: PrismicUnifiedSignupModalDataBodyCroppedImagePrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimary = {
    image: Maybe<PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageTypeGatsbyImageDataArgs =
    {
        aspectRatio: InputMaybe<Scalars['Float']['input']>
        backgroundColor: InputMaybe<Scalars['String']['input']>
        breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
        height: InputMaybe<Scalars['Int']['input']>
        imgixParams: InputMaybe<ImgixParamsInput>
        layout: InputMaybe<GatsbyImageLayout>
        outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
        placeholder: InputMaybe<ImgixPlaceholder>
        placeholderImgixParams: InputMaybe<ImgixParamsInput>
        sizes: InputMaybe<Scalars['String']['input']>
        srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
        srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
        width: InputMaybe<Scalars['Int']['input']>
        widthTolerance?: InputMaybe<Scalars['Float']['input']>
    }

export type PrismicUnifiedSignupModalDataBodyCroppedImagePrimaryImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicUnifiedSignupModalDataBodySlicesType =
    PrismicUnifiedSignupModalDataBodyCroppedImage | PrismicUnifiedSignupModalDataBodySocialProof

export type PrismicUnifiedSignupModalDataBodySocialProof = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicUnifiedSignupModalDataBodySocialProofItem>
    primary: PrismicUnifiedSignupModalDataBodySocialProofPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicUnifiedSignupModalDataBodySocialProofItem = {
    full_name: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageType>
    person_byline: Maybe<Scalars['String']['output']>
    predefined_testimonial: Maybe<PrismicLinkType>
    quote: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicUnifiedSignupModalDataBodySocialProofItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicUnifiedSignupModalDataBodySocialProofPrimary = {
    inverse: Maybe<Scalars['Boolean']['output']>
    section_html_id: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeEdge>
    group: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnectionDistinctArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnectionMinArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnectionSumArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsents =
    {
        id: Maybe<Scalars['Int']['output']>
        required: Maybe<Scalars['Boolean']['output']>
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeEdge = {
    next: Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
    node: PrismicUnifiedSignupModalDataFormProductionIntegrationType
    previous: Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnectionDistinctArgs =
    {
        field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
    }

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormProductionIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationType = Node & {
    children: Array<Node>
    consents: Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsents>
    formId: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
    prismicId: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeEdge>
    group: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnectionDistinctArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnectionMinArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnectionSumArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsents = {
    communicationConsents: Maybe<
        Array<
            Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsents>
        >
    >
    type: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsents = {
    id: Maybe<Scalars['Int']['output']>
    required: Maybe<Scalars['Boolean']['output']>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector =
    {
        id: InputMaybe<FieldSelectorEnum>
        required: InputMaybe<FieldSelectorEnum>
    }

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput =
    {
        id: InputMaybe<IntQueryOperatorInput>
        required: InputMaybe<BooleanQueryOperatorInput>
    }

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput =
    {
        elemMatch: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterInput>
    }

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput =
    {
        id: InputMaybe<SortOrderEnum>
        required: InputMaybe<SortOrderEnum>
    }

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsFieldSelector = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFieldSelector>
    type: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsFilterInput = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsFilterListInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsSortInput = {
    communicationConsents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsCommunicationConsentsSortInput>
    type: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeEdge = {
    next: Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
    node: PrismicUnifiedSignupModalDataFormStagingIntegrationType
    previous: Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsFieldSelector>
    formId: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnectionDistinctArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnectionMinArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeGroupConnectionSumArgs = {
    field: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector
}

export type PrismicUnifiedSignupModalDataFormStagingIntegrationTypeSortInput = {
    children: InputMaybe<NodeSortInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsSortInput>
    formId: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataHighlightItems = {
    image: Maybe<PrismicUnifiedSignupModalDataHighlightItemsImageImageType>
    text: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataHighlightItemsFieldSelector = {
    image: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFieldSelector>
    text: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataHighlightItemsFilterInput = {
    image: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFilterInput>
    text: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataHighlightItemsFilterListInput = {
    elemMatch: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsFilterInput>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataHighlightItemsSortInput = {
    image: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsImageImageTypeSortInput>
    text: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalDataType = {
    aria_label: Maybe<Scalars['String']['output']>
    body: Array<PrismicUnifiedSignupModalDataBodySlicesType>
    email_input_error_text: Maybe<Scalars['String']['output']>
    email_input_placeholder: Maybe<Scalars['String']['output']>
    form_production: Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
    form_staging: Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
    highlight_items: Maybe<Array<Maybe<PrismicUnifiedSignupModalDataHighlightItems>>>
    submit_text: Maybe<Scalars['String']['output']>
    subtitle: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicUnifiedSignupModalDataTypeFieldSelector = {
    aria_label: InputMaybe<FieldSelectorEnum>
    email_input_error_text: InputMaybe<FieldSelectorEnum>
    email_input_placeholder: InputMaybe<FieldSelectorEnum>
    form_production: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFieldSelector>
    form_staging: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFieldSelector>
    highlight_items: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsFieldSelector>
    submit_text: InputMaybe<FieldSelectorEnum>
    subtitle: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalDataTypeFilterInput = {
    aria_label: InputMaybe<StringQueryOperatorInput>
    email_input_error_text: InputMaybe<StringQueryOperatorInput>
    email_input_placeholder: InputMaybe<StringQueryOperatorInput>
    form_production: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFilterInput>
    form_staging: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFilterInput>
    highlight_items: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsFilterListInput>
    submit_text: InputMaybe<StringQueryOperatorInput>
    subtitle: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalDataTypeSortInput = {
    aria_label: InputMaybe<SortOrderEnum>
    email_input_error_text: InputMaybe<SortOrderEnum>
    email_input_placeholder: InputMaybe<SortOrderEnum>
    form_production: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeSortInput>
    form_staging: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeSortInput>
    highlight_items: InputMaybe<PrismicUnifiedSignupModalDataHighlightItemsSortInput>
    submit_text: InputMaybe<SortOrderEnum>
    subtitle: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicUnifiedSignupModalEdge = {
    next: Maybe<PrismicUnifiedSignupModal>
    node: PrismicUnifiedSignupModal
    previous: Maybe<PrismicUnifiedSignupModal>
}

export type PrismicUnifiedSignupModalFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicUnifiedSignupModalDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicUnifiedSignupModalFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicUnifiedSignupModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicUnifiedSignupModalGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicUnifiedSignupModalEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicUnifiedSignupModalGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicUnifiedSignupModal>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicUnifiedSignupModalGroupConnectionDistinctArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalGroupConnectionGroupArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicUnifiedSignupModalGroupConnectionMaxArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalGroupConnectionMinArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalGroupConnectionSumArgs = {
    field: PrismicUnifiedSignupModalFieldSelector
}

export type PrismicUnifiedSignupModalSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicUnifiedSignupModalDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicVatCalculator = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicVatCalculatorDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicVatCalculatorFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicVatCalculatorLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicVatCalculatorConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicVatCalculatorEdge>
    group: Array<PrismicVatCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicVatCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicVatCalculatorConnectionDistinctArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorConnectionGroupArgs = {
    field: PrismicVatCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicVatCalculatorConnectionMaxArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorConnectionMinArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorConnectionSumArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorDataType = {
    add_vat_label: Maybe<Scalars['String']['output']>
    amount_label: Maybe<Scalars['String']['output']>
    body: Maybe<PrismicStructuredTextType>
    remove_vat_label: Maybe<Scalars['String']['output']>
    results_title: Maybe<Scalars['String']['output']>
    results_vat_added_label: Maybe<Scalars['String']['output']>
    results_vat_removed_label: Maybe<Scalars['String']['output']>
    submit_label: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
    total_gross_label: Maybe<Scalars['String']['output']>
    total_label: Maybe<Scalars['String']['output']>
    total_net_label: Maybe<Scalars['String']['output']>
    vat_label: Maybe<Scalars['String']['output']>
}

export type PrismicVatCalculatorDataTypeFieldSelector = {
    add_vat_label: InputMaybe<FieldSelectorEnum>
    amount_label: InputMaybe<FieldSelectorEnum>
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    remove_vat_label: InputMaybe<FieldSelectorEnum>
    results_title: InputMaybe<FieldSelectorEnum>
    results_vat_added_label: InputMaybe<FieldSelectorEnum>
    results_vat_removed_label: InputMaybe<FieldSelectorEnum>
    submit_label: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
    total_gross_label: InputMaybe<FieldSelectorEnum>
    total_label: InputMaybe<FieldSelectorEnum>
    total_net_label: InputMaybe<FieldSelectorEnum>
    vat_label: InputMaybe<FieldSelectorEnum>
}

export type PrismicVatCalculatorDataTypeFilterInput = {
    add_vat_label: InputMaybe<StringQueryOperatorInput>
    amount_label: InputMaybe<StringQueryOperatorInput>
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    remove_vat_label: InputMaybe<StringQueryOperatorInput>
    results_title: InputMaybe<StringQueryOperatorInput>
    results_vat_added_label: InputMaybe<StringQueryOperatorInput>
    results_vat_removed_label: InputMaybe<StringQueryOperatorInput>
    submit_label: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
    total_gross_label: InputMaybe<StringQueryOperatorInput>
    total_label: InputMaybe<StringQueryOperatorInput>
    total_net_label: InputMaybe<StringQueryOperatorInput>
    vat_label: InputMaybe<StringQueryOperatorInput>
}

export type PrismicVatCalculatorDataTypeSortInput = {
    add_vat_label: InputMaybe<SortOrderEnum>
    amount_label: InputMaybe<SortOrderEnum>
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    remove_vat_label: InputMaybe<SortOrderEnum>
    results_title: InputMaybe<SortOrderEnum>
    results_vat_added_label: InputMaybe<SortOrderEnum>
    results_vat_removed_label: InputMaybe<SortOrderEnum>
    submit_label: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
    total_gross_label: InputMaybe<SortOrderEnum>
    total_label: InputMaybe<SortOrderEnum>
    total_net_label: InputMaybe<SortOrderEnum>
    vat_label: InputMaybe<SortOrderEnum>
}

export type PrismicVatCalculatorEdge = {
    next: Maybe<PrismicVatCalculator>
    node: PrismicVatCalculator
    previous: Maybe<PrismicVatCalculator>
}

export type PrismicVatCalculatorFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicVatCalculatorDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicVatCalculatorFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicVatCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicVatCalculatorGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicVatCalculatorEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicVatCalculatorGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicVatCalculator>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicVatCalculatorGroupConnectionDistinctArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorGroupConnectionGroupArgs = {
    field: PrismicVatCalculatorFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicVatCalculatorGroupConnectionMaxArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorGroupConnectionMinArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorGroupConnectionSumArgs = {
    field: PrismicVatCalculatorFieldSelector
}

export type PrismicVatCalculatorSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicVatCalculatorDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWebinarCategory = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicWebinarCategoryDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWebinarCategoryFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWebinarCategoryLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWebinarCategoryConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWebinarCategoryEdge>
    group: Array<PrismicWebinarCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWebinarCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWebinarCategoryConnectionDistinctArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryConnectionGroupArgs = {
    field: PrismicWebinarCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWebinarCategoryConnectionMaxArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryConnectionMinArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryConnectionSumArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryDataType = {
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    name: Maybe<Scalars['String']['output']>
}

export type PrismicWebinarCategoryDataTypeFieldSelector = {
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    name: InputMaybe<FieldSelectorEnum>
}

export type PrismicWebinarCategoryDataTypeFilterInput = {
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWebinarCategoryDataTypeSortInput = {
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    name: InputMaybe<SortOrderEnum>
}

export type PrismicWebinarCategoryEdge = {
    next: Maybe<PrismicWebinarCategory>
    node: PrismicWebinarCategory
    previous: Maybe<PrismicWebinarCategory>
}

export type PrismicWebinarCategoryFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicWebinarCategoryDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWebinarCategoryFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWebinarCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWebinarCategoryGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWebinarCategoryEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicWebinarCategoryGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWebinarCategory>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWebinarCategoryGroupConnectionDistinctArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryGroupConnectionGroupArgs = {
    field: PrismicWebinarCategoryFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWebinarCategoryGroupConnectionMaxArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryGroupConnectionMinArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategoryGroupConnectionSumArgs = {
    field: PrismicWebinarCategoryFieldSelector
}

export type PrismicWebinarCategorySortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicWebinarCategoryDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicWhyPleoPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWhyPleoPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWhyPleoPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWhyPleoPageEdge>
    group: Array<PrismicWhyPleoPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWhyPleoPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWhyPleoPageConnectionDistinctArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageConnectionGroupArgs = {
    field: PrismicWhyPleoPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageConnectionMaxArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageConnectionMinArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageConnectionSumArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageDataBodyBigList = PrismicSliceType & {
    id: Scalars['ID']['output']
    items: Array<PrismicWhyPleoPageDataBodyBigListItem>
    primary: PrismicWhyPleoPageDataBodyBigListPrimary
    slice_label: Maybe<Scalars['String']['output']>
    slice_type: Scalars['String']['output']
}

export type PrismicWhyPleoPageDataBodyBigListItem = {
    icon: Maybe<Scalars['String']['output']>
    label: Maybe<Scalars['String']['output']>
    link: Maybe<PrismicLinkType>
    secondary_label: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataBodyBigListPrimary = {
    background_color: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataBodySlicesType = PrismicWhyPleoPageDataBodyBigList

export type PrismicWhyPleoPageDataCustomers = {
    body: Maybe<PrismicStructuredTextType>
    cta_link: Maybe<PrismicLinkType>
    cta_text: Maybe<Scalars['String']['output']>
    image: Maybe<PrismicWhyPleoPageDataCustomersImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataCustomersFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    cta_link: InputMaybe<PrismicLinkTypeFieldSelector>
    cta_text: InputMaybe<FieldSelectorEnum>
    image: InputMaybe<PrismicWhyPleoPageDataCustomersImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataCustomersFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    cta_link: InputMaybe<PrismicLinkTypeFilterInput>
    cta_text: InputMaybe<StringQueryOperatorInput>
    image: InputMaybe<PrismicWhyPleoPageDataCustomersImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataCustomersFilterListInput = {
    elemMatch: InputMaybe<PrismicWhyPleoPageDataCustomersFilterInput>
}

export type PrismicWhyPleoPageDataCustomersImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataCustomersImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataCustomersSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    cta_link: InputMaybe<PrismicLinkTypeSortInput>
    cta_text: InputMaybe<SortOrderEnum>
    image: InputMaybe<PrismicWhyPleoPageDataCustomersImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataFeatureBlocks = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicWhyPleoPageDataFeatureBlocksImageImageType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataFeatureBlocksFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataFeatureBlocksFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataFeatureBlocksFilterListInput = {
    elemMatch: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksFilterInput>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataFeatureBlocksImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataFeatureBlocksSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksImageImageTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataHero = {
    body: Maybe<PrismicStructuredTextType>
    image: Maybe<PrismicWhyPleoPageDataHeroImageImageType>
    proof_point_badges: Maybe<PrismicLinkType>
    title: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataHeroFieldSelector = {
    body: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    image: InputMaybe<PrismicWhyPleoPageDataHeroImageImageTypeFieldSelector>
    proof_point_badges: InputMaybe<PrismicLinkTypeFieldSelector>
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataHeroFilterInput = {
    body: InputMaybe<PrismicStructuredTextTypeFilterInput>
    image: InputMaybe<PrismicWhyPleoPageDataHeroImageImageTypeFilterInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeFilterInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataHeroFilterListInput = {
    elemMatch: InputMaybe<PrismicWhyPleoPageDataHeroFilterInput>
}

export type PrismicWhyPleoPageDataHeroImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataHeroImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataHeroSortInput = {
    body: InputMaybe<PrismicStructuredTextTypeSortInput>
    image: InputMaybe<PrismicWhyPleoPageDataHeroImageImageTypeSortInput>
    proof_point_badges: InputMaybe<PrismicLinkTypeSortInput>
    title: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataHowToSteps = {
    title: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataHowToStepsFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataHowToStepsFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataHowToStepsFilterListInput = {
    elemMatch: InputMaybe<PrismicWhyPleoPageDataHowToStepsFilterInput>
}

export type PrismicWhyPleoPageDataHowToStepsSortInput = {
    title: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageDataType = {
    body: Array<PrismicWhyPleoPageDataBodySlicesType>
    comparison_table: Maybe<PrismicLinkType>
    comparison_table_title: Maybe<Scalars['String']['output']>
    customers: Maybe<Array<Maybe<PrismicWhyPleoPageDataCustomers>>>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    feature_blocks: Maybe<Array<Maybe<PrismicWhyPleoPageDataFeatureBlocks>>>
    hero: Maybe<Array<Maybe<PrismicWhyPleoPageDataHero>>>
    how_to_steps: Maybe<Array<Maybe<PrismicWhyPleoPageDataHowToSteps>>>
    how_to_subtitle: Maybe<PrismicStructuredTextType>
    how_to_title: Maybe<Scalars['String']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicWhyPleoPageDataOpenGraphImageImageType>
    prismic_title: Maybe<Scalars['String']['output']>
    signup_banner: Maybe<PrismicLinkType>
    social_proof_logos_extended_section: Maybe<PrismicLinkType>
    social_proof_ratings_section: Maybe<PrismicLinkType>
    what_is_pleo: Maybe<Array<Maybe<PrismicWhyPleoPageDataWhatIsPleo>>>
}

export type PrismicWhyPleoPageDataTypeFieldSelector = {
    comparison_table: InputMaybe<PrismicLinkTypeFieldSelector>
    comparison_table_title: InputMaybe<FieldSelectorEnum>
    customers: InputMaybe<PrismicWhyPleoPageDataCustomersFieldSelector>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    feature_blocks: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksFieldSelector>
    hero: InputMaybe<PrismicWhyPleoPageDataHeroFieldSelector>
    how_to_steps: InputMaybe<PrismicWhyPleoPageDataHowToStepsFieldSelector>
    how_to_subtitle: InputMaybe<PrismicStructuredTextTypeFieldSelector>
    how_to_title: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicWhyPleoPageDataOpenGraphImageImageTypeFieldSelector>
    prismic_title: InputMaybe<FieldSelectorEnum>
    signup_banner: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFieldSelector>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFieldSelector>
    what_is_pleo: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoFieldSelector>
}

export type PrismicWhyPleoPageDataTypeFilterInput = {
    comparison_table: InputMaybe<PrismicLinkTypeFilterInput>
    comparison_table_title: InputMaybe<StringQueryOperatorInput>
    customers: InputMaybe<PrismicWhyPleoPageDataCustomersFilterListInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    feature_blocks: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksFilterListInput>
    hero: InputMaybe<PrismicWhyPleoPageDataHeroFilterListInput>
    how_to_steps: InputMaybe<PrismicWhyPleoPageDataHowToStepsFilterListInput>
    how_to_subtitle: InputMaybe<PrismicStructuredTextTypeFilterInput>
    how_to_title: InputMaybe<StringQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicWhyPleoPageDataOpenGraphImageImageTypeFilterInput>
    prismic_title: InputMaybe<StringQueryOperatorInput>
    signup_banner: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeFilterInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeFilterInput>
    what_is_pleo: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoFilterListInput>
}

export type PrismicWhyPleoPageDataTypeSortInput = {
    comparison_table: InputMaybe<PrismicLinkTypeSortInput>
    comparison_table_title: InputMaybe<SortOrderEnum>
    customers: InputMaybe<PrismicWhyPleoPageDataCustomersSortInput>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    feature_blocks: InputMaybe<PrismicWhyPleoPageDataFeatureBlocksSortInput>
    hero: InputMaybe<PrismicWhyPleoPageDataHeroSortInput>
    how_to_steps: InputMaybe<PrismicWhyPleoPageDataHowToStepsSortInput>
    how_to_subtitle: InputMaybe<PrismicStructuredTextTypeSortInput>
    how_to_title: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicWhyPleoPageDataOpenGraphImageImageTypeSortInput>
    prismic_title: InputMaybe<SortOrderEnum>
    signup_banner: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_logos_extended_section: InputMaybe<PrismicLinkTypeSortInput>
    social_proof_ratings_section: InputMaybe<PrismicLinkTypeSortInput>
    what_is_pleo: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoSortInput>
}

export type PrismicWhyPleoPageDataWhatIsPleo = {
    title: Maybe<Scalars['String']['output']>
    video_id: Maybe<Scalars['String']['output']>
    video_thumbnail: Maybe<PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageType>
}

export type PrismicWhyPleoPageDataWhatIsPleoFieldSelector = {
    title: InputMaybe<FieldSelectorEnum>
    video_id: InputMaybe<FieldSelectorEnum>
    video_thumbnail: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFieldSelector>
}

export type PrismicWhyPleoPageDataWhatIsPleoFilterInput = {
    title: InputMaybe<StringQueryOperatorInput>
    video_id: InputMaybe<StringQueryOperatorInput>
    video_thumbnail: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFilterInput>
}

export type PrismicWhyPleoPageDataWhatIsPleoFilterListInput = {
    elemMatch: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoFilterInput>
}

export type PrismicWhyPleoPageDataWhatIsPleoSortInput = {
    title: InputMaybe<SortOrderEnum>
    video_id: InputMaybe<SortOrderEnum>
    video_thumbnail: InputMaybe<PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeSortInput>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageDataWhatIsPleoVideoThumbnailImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWhyPleoPageEdge = {
    next: Maybe<PrismicWhyPleoPage>
    node: PrismicWhyPleoPage
    previous: Maybe<PrismicWhyPleoPage>
}

export type PrismicWhyPleoPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicWhyPleoPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWhyPleoPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWhyPleoPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWhyPleoPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWhyPleoPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicWhyPleoPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWhyPleoPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWhyPleoPageGroupConnectionDistinctArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageGroupConnectionGroupArgs = {
    field: PrismicWhyPleoPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWhyPleoPageGroupConnectionMaxArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageGroupConnectionMinArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageGroupConnectionSumArgs = {
    field: PrismicWhyPleoPageFieldSelector
}

export type PrismicWhyPleoPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicWhyPleoPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWistaChannelPage = Node & {
    _previewable: Scalars['ID']['output']
    alternate_languages: Array<PrismicAlternateLanguageType>
    children: Array<Node>
    data: PrismicWistaChannelPageDataType
    dataRaw: Scalars['JSON']['output']
    first_publication_date: Scalars['Date']['output']
    href: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    lang: Scalars['String']['output']
    last_publication_date: Scalars['Date']['output']
    parent: Maybe<Node>
    prismicId: Scalars['ID']['output']
    tags: Array<Scalars['String']['output']>
    type: Scalars['String']['output']
    uid: Scalars['String']['output']
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWistaChannelPageFirst_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWistaChannelPageLast_Publication_DateArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type PrismicWistaChannelPageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWistaChannelPageEdge>
    group: Array<PrismicWistaChannelPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWistaChannelPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWistaChannelPageConnectionDistinctArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageConnectionGroupArgs = {
    field: PrismicWistaChannelPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWistaChannelPageConnectionMaxArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageConnectionMinArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageConnectionSumArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageDataOpenGraphImageImageType = {
    alt: Maybe<Scalars['String']['output']>
    copyright: Maybe<Scalars['String']['output']>
    dimensions: Maybe<PrismicImageDimensionsType>
    /** Should be used to generate fixed-width images (i.e. the size of the image doesn't change when the size of the browser changes, and are "fixed"). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFixed fragment should be used. See the project's README for more information. */
    fixed: Maybe<ImgixFixed>
    /** Should be used to generate fluid-width images (i.e. images that change when the size of the browser changes). Returns data compatible with gatsby-image. Instead of accessing this data directly, the GatsbySourceImgixFluid fragment should be used. See the project's README for more information. */
    fluid: Maybe<ImgixFluid>
    gatsbyImageData: Maybe<Scalars['JSON']['output']>
    localFile: Maybe<File>
    /** A plain imgix URL with the URL and params applied. */
    url: Maybe<Scalars['String']['output']>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeFixedArgs = {
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams?: InputMaybe<ImgixParamsInput>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    quality: InputMaybe<Scalars['Int']['input']>
    width?: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeFluidArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
    maxHeight: InputMaybe<Scalars['Int']['input']>
    maxWidth?: InputMaybe<Scalars['Int']['input']>
    placeholderImgixParams?: InputMaybe<ImgixParamsInput>
    srcSetBreakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeGatsbyImageDataArgs = {
    aspectRatio: InputMaybe<Scalars['Float']['input']>
    backgroundColor: InputMaybe<Scalars['String']['input']>
    breakpoints: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
    height: InputMaybe<Scalars['Int']['input']>
    imgixParams: InputMaybe<ImgixParamsInput>
    layout: InputMaybe<GatsbyImageLayout>
    outputPixelDensities: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
    placeholder: InputMaybe<ImgixPlaceholder>
    placeholderImgixParams: InputMaybe<ImgixParamsInput>
    sizes: InputMaybe<Scalars['String']['input']>
    srcSetMaxWidth?: InputMaybe<Scalars['Int']['input']>
    srcSetMinWidth?: InputMaybe<Scalars['Int']['input']>
    width: InputMaybe<Scalars['Int']['input']>
    widthTolerance?: InputMaybe<Scalars['Float']['input']>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeUrlArgs = {
    imgixParams?: InputMaybe<ImgixParamsInput>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeFieldSelector = {
    alt: InputMaybe<FieldSelectorEnum>
    copyright: InputMaybe<FieldSelectorEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFieldSelector>
    fixed: InputMaybe<ImgixFixedFieldSelector>
    fluid: InputMaybe<ImgixFluidFieldSelector>
    gatsbyImageData: InputMaybe<FieldSelectorEnum>
    localFile: InputMaybe<FileFieldSelector>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeFilterInput = {
    alt: InputMaybe<StringQueryOperatorInput>
    copyright: InputMaybe<StringQueryOperatorInput>
    dimensions: InputMaybe<PrismicImageDimensionsTypeFilterInput>
    fixed: InputMaybe<ImgixFixedFilterInput>
    fluid: InputMaybe<ImgixFluidFilterInput>
    gatsbyImageData: InputMaybe<JsonQueryOperatorInput>
    localFile: InputMaybe<FileFilterInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWistaChannelPageDataOpenGraphImageImageTypeSortInput = {
    alt: InputMaybe<SortOrderEnum>
    copyright: InputMaybe<SortOrderEnum>
    dimensions: InputMaybe<PrismicImageDimensionsTypeSortInput>
    fixed: InputMaybe<ImgixFixedSortInput>
    fluid: InputMaybe<ImgixFluidSortInput>
    gatsbyImageData: InputMaybe<SortOrderEnum>
    localFile: InputMaybe<FileSortInput>
    url: InputMaybe<SortOrderEnum>
}

export type PrismicWistaChannelPageDataType = {
    channel_id: Maybe<Scalars['String']['output']>
    exclude_sitemap: Maybe<Scalars['Boolean']['output']>
    meta_description: Maybe<Scalars['String']['output']>
    meta_title: Maybe<Scalars['String']['output']>
    open_graph_image: Maybe<PrismicWistaChannelPageDataOpenGraphImageImageType>
}

export type PrismicWistaChannelPageDataTypeFieldSelector = {
    channel_id: InputMaybe<FieldSelectorEnum>
    exclude_sitemap: InputMaybe<FieldSelectorEnum>
    meta_description: InputMaybe<FieldSelectorEnum>
    meta_title: InputMaybe<FieldSelectorEnum>
    open_graph_image: InputMaybe<PrismicWistaChannelPageDataOpenGraphImageImageTypeFieldSelector>
}

export type PrismicWistaChannelPageDataTypeFilterInput = {
    channel_id: InputMaybe<StringQueryOperatorInput>
    exclude_sitemap: InputMaybe<BooleanQueryOperatorInput>
    meta_description: InputMaybe<StringQueryOperatorInput>
    meta_title: InputMaybe<StringQueryOperatorInput>
    open_graph_image: InputMaybe<PrismicWistaChannelPageDataOpenGraphImageImageTypeFilterInput>
}

export type PrismicWistaChannelPageDataTypeSortInput = {
    channel_id: InputMaybe<SortOrderEnum>
    exclude_sitemap: InputMaybe<SortOrderEnum>
    meta_description: InputMaybe<SortOrderEnum>
    meta_title: InputMaybe<SortOrderEnum>
    open_graph_image: InputMaybe<PrismicWistaChannelPageDataOpenGraphImageImageTypeSortInput>
}

export type PrismicWistaChannelPageEdge = {
    next: Maybe<PrismicWistaChannelPage>
    node: PrismicWistaChannelPage
    previous: Maybe<PrismicWistaChannelPage>
}

export type PrismicWistaChannelPageFieldSelector = {
    _previewable: InputMaybe<FieldSelectorEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFieldSelector>
    children: InputMaybe<NodeFieldSelector>
    data: InputMaybe<PrismicWistaChannelPageDataTypeFieldSelector>
    dataRaw: InputMaybe<FieldSelectorEnum>
    first_publication_date: InputMaybe<FieldSelectorEnum>
    href: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    lang: InputMaybe<FieldSelectorEnum>
    last_publication_date: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    prismicId: InputMaybe<FieldSelectorEnum>
    tags: InputMaybe<FieldSelectorEnum>
    type: InputMaybe<FieldSelectorEnum>
    uid: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type PrismicWistaChannelPageFilterInput = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWistaChannelPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type PrismicWistaChannelPageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<PrismicWistaChannelPageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<PrismicWistaChannelPageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<PrismicWistaChannelPage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type PrismicWistaChannelPageGroupConnectionDistinctArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageGroupConnectionGroupArgs = {
    field: PrismicWistaChannelPageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type PrismicWistaChannelPageGroupConnectionMaxArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageGroupConnectionMinArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageGroupConnectionSumArgs = {
    field: PrismicWistaChannelPageFieldSelector
}

export type PrismicWistaChannelPageSortInput = {
    _previewable: InputMaybe<SortOrderEnum>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeSortInput>
    children: InputMaybe<NodeSortInput>
    data: InputMaybe<PrismicWistaChannelPageDataTypeSortInput>
    dataRaw: InputMaybe<SortOrderEnum>
    first_publication_date: InputMaybe<SortOrderEnum>
    href: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    lang: InputMaybe<SortOrderEnum>
    last_publication_date: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    prismicId: InputMaybe<SortOrderEnum>
    tags: InputMaybe<SortOrderEnum>
    type: InputMaybe<SortOrderEnum>
    uid: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type Query = {
    allDirectory: DirectoryConnection
    allFile: FileConnection
    allPrismicAboutUsPage: PrismicAboutUsPageConnection
    allPrismicAdditionalUsersTable: PrismicAdditionalUsersTableConnection
    allPrismicApplePayPage: PrismicApplePayPageConnection
    allPrismicBigform: PrismicBigformConnection
    allPrismicBigformDataSandboxHubspotFormIntegrationType: PrismicBigformDataSandboxHubspotFormIntegrationTypeConnection
    allPrismicBigformPage: PrismicBigformPageConnection
    allPrismicBillsCalculator: PrismicBillsCalculatorConnection
    allPrismicBillsStatus: PrismicBillsStatusConnection
    allPrismicBillsTracker: PrismicBillsTrackerConnection
    allPrismicCalendlyPage: PrismicCalendlyPageConnection
    allPrismicCardCreationFunnel: PrismicCardCreationFunnelConnection
    allPrismicCareersPage: PrismicCareersPageConnection
    allPrismicCarousel: PrismicCarouselConnection
    allPrismicCashbackCalculator: PrismicCashbackCalculatorConnection
    allPrismicComaprisonTable: PrismicComaprisonTableConnection
    allPrismicComparisonTable: PrismicComparisonTableConnection
    allPrismicCookieBanner: PrismicCookieBannerConnection
    allPrismicCookieCategory: PrismicCookieCategoryConnection
    allPrismicCookieManager: PrismicCookieManagerConnection
    allPrismicCookieSegment: PrismicCookieSegmentConnection
    allPrismicCookieSettingsPage: PrismicCookieSettingsPageConnection
    allPrismicCopyExperiment: PrismicCopyExperimentConnection
    allPrismicCustomerCase: PrismicCustomerCaseConnection
    allPrismicCustomerLogos: PrismicCustomerLogosConnection
    allPrismicCustomerStoriesSection: PrismicCustomerStoriesSectionConnection
    allPrismicCustomersLogosSection: PrismicCustomersLogosSectionConnection
    allPrismicCustomersPage: PrismicCustomersPageConnection
    allPrismicDemoPage: PrismicDemoPageConnection
    allPrismicDemoPageDataFormProductionIntegrationType: PrismicDemoPageDataFormProductionIntegrationTypeConnection
    allPrismicDemoPageDataFormStagingIntegrationType: PrismicDemoPageDataFormStagingIntegrationTypeConnection
    allPrismicDisallowedEmails: PrismicDisallowedEmailsConnection
    allPrismicEbook: PrismicEbookConnection
    allPrismicEbookDataFormProductionIntegrationType: PrismicEbookDataFormProductionIntegrationTypeConnection
    allPrismicEbookDataFormStagingIntegrationType: PrismicEbookDataFormStagingIntegrationTypeConnection
    allPrismicEbookDetails: PrismicEbookDetailsConnection
    allPrismicEbookMarketingDownload: PrismicEbookMarketingDownloadConnection
    allPrismicEbookMarketingPage: PrismicEbookMarketingPageConnection
    allPrismicEbooksIndex: PrismicEbooksIndexConnection
    allPrismicEmbedType: PrismicEmbedTypeConnection
    allPrismicEvent: PrismicEventConnection
    allPrismicEventBigformPage: PrismicEventBigformPageConnection
    allPrismicEventForm: PrismicEventFormConnection
    allPrismicExpensePolicyBuilder: PrismicExpensePolicyBuilderConnection
    allPrismicExpensePolicyBuilderDataFormProductionIntegrationType: PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConnection
    allPrismicExpensePolicyBuilderDataFormStagingIntegrationType: PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConnection
    allPrismicExpenseReportGenerator: PrismicExpenseReportGeneratorConnection
    allPrismicExperimentalLandingPage: PrismicExperimentalLandingPageConnection
    allPrismicExploreProduct: PrismicExploreProductConnection
    allPrismicExploreProductDataFormProductionIntegrationType: PrismicExploreProductDataFormProductionIntegrationTypeConnection
    allPrismicExploreProductDataFormStagingIntegrationType: PrismicExploreProductDataFormStagingIntegrationTypeConnection
    allPrismicFaqPage: PrismicFaqPageConnection
    allPrismicFeatureBlock: PrismicFeatureBlockConnection
    allPrismicFeatureBlockGroup: PrismicFeatureBlockGroupConnection
    allPrismicFeatureIconCard: PrismicFeatureIconCardConnection
    allPrismicFeatureIconCards: PrismicFeatureIconCardsConnection
    allPrismicFetchPage: PrismicFetchPageConnection
    allPrismicFincirclePage: PrismicFincirclePageConnection
    allPrismicFlexBenefitsPage: PrismicFlexBenefitsPageConnection
    allPrismicFooter: PrismicFooterConnection
    allPrismicFooterSignup: PrismicFooterSignupConnection
    allPrismicFormConsent: PrismicFormConsentConnection
    allPrismicFormConsentDataSubscriptionTypeProductionIntegrationType: PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeConnection
    allPrismicFormConsentDataSubscriptionTypeStagingIntegrationType: PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeConnection
    allPrismicGettingStartedExperience: PrismicGettingStartedExperienceConnection
    allPrismicGettingStartedExperienceDataFormProductionIntegrationType: PrismicGettingStartedExperienceDataFormProductionIntegrationTypeConnection
    allPrismicGettingStartedExperienceDataFormStagingIntegrationType: PrismicGettingStartedExperienceDataFormStagingIntegrationTypeConnection
    allPrismicGlobalStrings: PrismicGlobalStringsConnection
    allPrismicHeader: PrismicHeaderConnection
    allPrismicHeaderDropdown: PrismicHeaderDropdownConnection
    allPrismicHeaderDropdownColumn: PrismicHeaderDropdownColumnConnection
    allPrismicHeaderDropdownCta: PrismicHeaderDropdownCtaConnection
    allPrismicHeaderV2: PrismicHeaderV2Connection
    allPrismicHeaderV2Dropdown: PrismicHeaderV2DropdownConnection
    allPrismicHeroTab: PrismicHeroTabConnection
    allPrismicHeroTabDataFormProductionIntegrationType: PrismicHeroTabDataFormProductionIntegrationTypeConnection
    allPrismicHeroTabDataFormStagingIntegrationType: PrismicHeroTabDataFormStagingIntegrationTypeConnection
    allPrismicHomepageV4: PrismicHomepageV4Connection
    allPrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType: PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection
    allPrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType: PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection
    allPrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType: PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnection
    allPrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType: PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnection
    allPrismicHowItWorksPage: PrismicHowItWorksPageConnection
    allPrismicHubspotGlobalForm: PrismicHubspotGlobalFormConnection
    allPrismicHubspotGlobalFormDataFormProductionIntegrationType: PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConnection
    allPrismicHubspotGlobalFormDataFormStagingIntegrationType: PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConnection
    allPrismicHubspotReferralForm: PrismicHubspotReferralFormConnection
    allPrismicIntegration: PrismicIntegrationConnection
    allPrismicIntegrationPage: PrismicIntegrationPageConnection
    allPrismicIntegrationsFeatureBlock: PrismicIntegrationsFeatureBlockConnection
    allPrismicIntegrationsIndexPage: PrismicIntegrationsIndexPageConnection
    allPrismicInvoice: PrismicInvoiceConnection
    allPrismicInvoiceGenerator: PrismicInvoiceGeneratorConnection
    allPrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConnection
    allPrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType: PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConnection
    allPrismicInvoiceTemplateForm: PrismicInvoiceTemplateFormConnection
    allPrismicInvoiceTemplateFormDataFormProductionIntegrationType: PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConnection
    allPrismicInvoiceTemplateFormDataFormStagingIntegrationType: PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConnection
    allPrismicInvoicesApprovals: PrismicInvoicesApprovalsConnection
    allPrismicJobListing: PrismicJobListingConnection
    allPrismicJobPage: PrismicJobPageConnection
    allPrismicLearnMoreCard: PrismicLearnMoreCardConnection
    allPrismicLegalDocument: PrismicLegalDocumentConnection
    allPrismicLegalDocuments: PrismicLegalDocumentsConnection
    allPrismicLegalDocumentsDirectory: PrismicLegalDocumentsDirectoryConnection
    allPrismicLegalPage: PrismicLegalPageConnection
    allPrismicLegalPageCookiePolicy: PrismicLegalPageCookiePolicyConnection
    allPrismicLegalPageDsr: PrismicLegalPageDsrConnection
    allPrismicLegalPageGdpr: PrismicLegalPageGdprConnection
    allPrismicLegalPageThirdPartyLicences: PrismicLegalPageThirdPartyLicencesConnection
    allPrismicLinkTest: PrismicLinkTestConnection
    allPrismicMeetingBookerPage: PrismicMeetingBookerPageConnection
    allPrismicNotFoundPage: PrismicNotFoundPageConnection
    allPrismicNotificationBanner: PrismicNotificationBannerConnection
    allPrismicOnDemandResourceCategory: PrismicOnDemandResourceCategoryConnection
    allPrismicOnDemandResourceForm: PrismicOnDemandResourceFormConnection
    allPrismicOnDemandResourceFormDataFormProductionIntegrationType: PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConnection
    allPrismicOnDemandResourceFormDataFormStagingIntegrationType: PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConnection
    allPrismicOnDemandResourcePage: PrismicOnDemandResourcePageConnection
    allPrismicOnDemandWebinarDetailPage: PrismicOnDemandWebinarDetailPageConnection
    allPrismicOnDemandWebinarForm: PrismicOnDemandWebinarFormConnection
    allPrismicPartner: PrismicPartnerConnection
    allPrismicPartnerBigform: PrismicPartnerBigformConnection
    allPrismicPartnerBigformPage: PrismicPartnerBigformPageConnection
    allPrismicPartnerBigformPageDataFormProductionIntegrationType: PrismicPartnerBigformPageDataFormProductionIntegrationTypeConnection
    allPrismicPartnerBigformPageDataFormStagingIntegrationType: PrismicPartnerBigformPageDataFormStagingIntegrationTypeConnection
    allPrismicPartnerPage: PrismicPartnerPageConnection
    allPrismicPartnerSignupBanner: PrismicPartnerSignupBannerConnection
    allPrismicPartnersProgrammeTable: PrismicPartnersProgrammeTableConnection
    allPrismicPartnershipCase: PrismicPartnershipCaseConnection
    allPrismicPartnershipTier: PrismicPartnershipTierConnection
    allPrismicPartnershipTiers: PrismicPartnershipTiersConnection
    allPrismicPerk: PrismicPerkConnection
    allPrismicPerksInternalPage: PrismicPerksInternalPageConnection
    allPrismicPleoEvent: PrismicPleoEventConnection
    allPrismicPleoPartnerTier: PrismicPleoPartnerTierConnection
    allPrismicPocketPage: PrismicPocketPageConnection
    allPrismicPodcastFormPage: PrismicPodcastFormPageConnection
    allPrismicPreLaunchFormPage: PrismicPreLaunchFormPageConnection
    allPrismicPricingComparisonTable: PrismicPricingComparisonTableConnection
    allPrismicPricingPage: PrismicPricingPageConnection
    allPrismicPricingPageV2: PrismicPricingPageV2Connection
    allPrismicPricingPlanPicker: PrismicPricingPlanPickerConnection
    allPrismicPricingPlanPickerDataFormProductionIntegrationType: PrismicPricingPlanPickerDataFormProductionIntegrationTypeConnection
    allPrismicPricingPlanPickerDataFormStagingIntegrationType: PrismicPricingPlanPickerDataFormStagingIntegrationTypeConnection
    allPrismicPricingTable: PrismicPricingTableConnection
    allPrismicPricingTableV2: PrismicPricingTableV2Connection
    allPrismicPricingTier: PrismicPricingTierConnection
    allPrismicPricingTiers: PrismicPricingTiersConnection
    allPrismicPricingTiersDataFormProductionIntegrationType: PrismicPricingTiersDataFormProductionIntegrationTypeConnection
    allPrismicPricingTiersDataFormStagingIntegrationType: PrismicPricingTiersDataFormStagingIntegrationTypeConnection
    allPrismicPricingTiersV2: PrismicPricingTiersV2Connection
    allPrismicPricingV2: PrismicPricingV2Connection
    allPrismicPricingV3ComparisonTable: PrismicPricingV3ComparisonTableConnection
    allPrismicPricingV3Page: PrismicPricingV3PageConnection
    allPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConnection
    allPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType: PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConnection
    allPrismicPricingV3PricingTier: PrismicPricingV3PricingTierConnection
    allPrismicPricingV3PricingTierFeatureList: PrismicPricingV3PricingTierFeatureListConnection
    allPrismicPricingV3TierPricingModel: PrismicPricingV3TierPricingModelConnection
    allPrismicProofPointBadges: PrismicProofPointBadgesConnection
    allPrismicProofPointBadgesRepeatable: PrismicProofPointBadgesRepeatableConnection
    allPrismicRating: PrismicRatingConnection
    allPrismicRatingsGroup: PrismicRatingsGroupConnection
    allPrismicResourceDetailPage: PrismicResourceDetailPageConnection
    allPrismicRoiCalculator: PrismicRoiCalculatorConnection
    allPrismicRoiCalculatorDataFormProductionIntegrationType: PrismicRoiCalculatorDataFormProductionIntegrationTypeConnection
    allPrismicRoiCalculatorDataFormStagingIntegrationType: PrismicRoiCalculatorDataFormStagingIntegrationTypeConnection
    allPrismicRoicPreview: PrismicRoicPreviewConnection
    allPrismicRytisEbookDetails: PrismicRytisEbookDetailsConnection
    allPrismicSecondaryHomepage: PrismicSecondaryHomepageConnection
    allPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection
    allPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType: PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection
    allPrismicSecondaryLegalDocuments: PrismicSecondaryLegalDocumentsConnection
    allPrismicSecondaryLegalPage: PrismicSecondaryLegalPageConnection
    allPrismicSecondaryNotFoundPage: PrismicSecondaryNotFoundPageConnection
    allPrismicSecondaryPricingPage: PrismicSecondaryPricingPageConnection
    allPrismicSecondaryPricingTier: PrismicSecondaryPricingTierConnection
    allPrismicSecondaryPricingTiers: PrismicSecondaryPricingTiersConnection
    allPrismicSecondaryPricingTiersDataFormProductionIntegrationType: PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConnection
    allPrismicSecondaryPricingTiersDataFormStagingIntegrationType: PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConnection
    allPrismicSeo: PrismicSeoConnection
    allPrismicSignUpModal: PrismicSignUpModalConnection
    allPrismicSignUpModalDataFormProductionIntegrationType: PrismicSignUpModalDataFormProductionIntegrationTypeConnection
    allPrismicSignUpModalDataFormStagingIntegrationType: PrismicSignUpModalDataFormStagingIntegrationTypeConnection
    allPrismicSignupBanner: PrismicSignupBannerConnection
    allPrismicSignupBannerDataFormProductionIntegrationType: PrismicSignupBannerDataFormProductionIntegrationTypeConnection
    allPrismicSignupBannerDataFormStagingIntegrationType: PrismicSignupBannerDataFormStagingIntegrationTypeConnection
    allPrismicSignupFunnelExperiment: PrismicSignupFunnelExperimentConnection
    allPrismicSignupModal: PrismicSignupModalConnection
    allPrismicSignupModalDataFormProductionIntegrationType: PrismicSignupModalDataFormProductionIntegrationTypeConnection
    allPrismicSignupModalDataFormStagingIntegrationType: PrismicSignupModalDataFormStagingIntegrationTypeConnection
    allPrismicSignupPage: PrismicSignupPageConnection
    allPrismicSignupReason: PrismicSignupReasonConnection
    allPrismicSignupWizard: PrismicSignupWizardConnection
    allPrismicSignupmodal: PrismicSignupmodalConnection
    allPrismicSignupmodalDataFormProductionIntegrationType: PrismicSignupmodalDataFormProductionIntegrationTypeConnection
    allPrismicSignupmodalDataFormStagingIntegrationType: PrismicSignupmodalDataFormStagingIntegrationTypeConnection
    allPrismicSkillEvaluationTool: PrismicSkillEvaluationToolConnection
    allPrismicSlicePage: PrismicSlicePageConnection
    allPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConnection
    allPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType: PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConnection
    allPrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType: PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection
    allPrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType: PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection
    allPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConnection
    allPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType: PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConnection
    allPrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType: PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConnection
    allPrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType: PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConnection
    allPrismicSocialProofIndicator: PrismicSocialProofIndicatorConnection
    allPrismicSocialProofLogosExtendedSection: PrismicSocialProofLogosExtendedSectionConnection
    allPrismicSocialProofLogosSection: PrismicSocialProofLogosSectionConnection
    allPrismicSocialProofRatingsSection: PrismicSocialProofRatingsSectionConnection
    allPrismicStarterBigformPage: PrismicStarterBigformPageConnection
    allPrismicStatisticsSection: PrismicStatisticsSectionConnection
    allPrismicSubscriptionsPage: PrismicSubscriptionsPageConnection
    allPrismicSyncedIntegration: PrismicSyncedIntegrationConnection
    allPrismicSyncedIntegrationDataEndymionAppIntegrationType: PrismicSyncedIntegrationDataEndymionAppIntegrationTypeConnection
    allPrismicSyncedIntegrationsCategories: PrismicSyncedIntegrationsCategoriesConnection
    allPrismicTemplateCustomerCase: PrismicTemplateCustomerCaseConnection
    allPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection
    allPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType: PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection
    allPrismicTemplatePartner: PrismicTemplatePartnerConnection
    allPrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConnection
    allPrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType: PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConnection
    allPrismicTestAaa: PrismicTestAaaConnection
    allPrismicTestimonial: PrismicTestimonialConnection
    allPrismicThirdPartyLicencesSection: PrismicThirdPartyLicencesSectionConnection
    allPrismicTypePathType: PrismicTypePathTypeConnection
    allPrismicTypeformSurveys: PrismicTypeformSurveysConnection
    allPrismicUnifiedSignupModal: PrismicUnifiedSignupModalConnection
    allPrismicUnifiedSignupModalDataFormProductionIntegrationType: PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConnection
    allPrismicUnifiedSignupModalDataFormStagingIntegrationType: PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConnection
    allPrismicVatCalculator: PrismicVatCalculatorConnection
    allPrismicWebinarCategory: PrismicWebinarCategoryConnection
    allPrismicWhyPleoPage: PrismicWhyPleoPageConnection
    allPrismicWistaChannelPage: PrismicWistaChannelPageConnection
    allSite: SiteConnection
    allSiteBuildMetadata: SiteBuildMetadataConnection
    allSiteFunction: SiteFunctionConnection
    allSitePage: SitePageConnection
    allSitePlugin: SitePluginConnection
    directory: Maybe<Directory>
    file: Maybe<File>
    prismicAboutUsPage: Maybe<PrismicAboutUsPage>
    prismicAdditionalUsersTable: Maybe<PrismicAdditionalUsersTable>
    prismicApplePayPage: Maybe<PrismicApplePayPage>
    prismicBigform: Maybe<PrismicBigform>
    prismicBigformDataSandboxHubspotFormIntegrationType: Maybe<PrismicBigformDataSandboxHubspotFormIntegrationType>
    prismicBigformPage: Maybe<PrismicBigformPage>
    prismicBillsCalculator: Maybe<PrismicBillsCalculator>
    prismicBillsStatus: Maybe<PrismicBillsStatus>
    prismicBillsTracker: Maybe<PrismicBillsTracker>
    prismicCalendlyPage: Maybe<PrismicCalendlyPage>
    prismicCardCreationFunnel: Maybe<PrismicCardCreationFunnel>
    prismicCareersPage: Maybe<PrismicCareersPage>
    prismicCarousel: Maybe<PrismicCarousel>
    prismicCashbackCalculator: Maybe<PrismicCashbackCalculator>
    prismicComaprisonTable: Maybe<PrismicComaprisonTable>
    prismicComparisonTable: Maybe<PrismicComparisonTable>
    prismicCookieBanner: Maybe<PrismicCookieBanner>
    prismicCookieCategory: Maybe<PrismicCookieCategory>
    prismicCookieManager: Maybe<PrismicCookieManager>
    prismicCookieSegment: Maybe<PrismicCookieSegment>
    prismicCookieSettingsPage: Maybe<PrismicCookieSettingsPage>
    prismicCopyExperiment: Maybe<PrismicCopyExperiment>
    prismicCustomerCase: Maybe<PrismicCustomerCase>
    prismicCustomerLogos: Maybe<PrismicCustomerLogos>
    prismicCustomerStoriesSection: Maybe<PrismicCustomerStoriesSection>
    prismicCustomersLogosSection: Maybe<PrismicCustomersLogosSection>
    prismicCustomersPage: Maybe<PrismicCustomersPage>
    prismicDemoPage: Maybe<PrismicDemoPage>
    prismicDemoPageDataFormProductionIntegrationType: Maybe<PrismicDemoPageDataFormProductionIntegrationType>
    prismicDemoPageDataFormStagingIntegrationType: Maybe<PrismicDemoPageDataFormStagingIntegrationType>
    prismicDisallowedEmails: Maybe<PrismicDisallowedEmails>
    prismicEbook: Maybe<PrismicEbook>
    prismicEbookDataFormProductionIntegrationType: Maybe<PrismicEbookDataFormProductionIntegrationType>
    prismicEbookDataFormStagingIntegrationType: Maybe<PrismicEbookDataFormStagingIntegrationType>
    prismicEbookDetails: Maybe<PrismicEbookDetails>
    prismicEbookMarketingDownload: Maybe<PrismicEbookMarketingDownload>
    prismicEbookMarketingPage: Maybe<PrismicEbookMarketingPage>
    prismicEbooksIndex: Maybe<PrismicEbooksIndex>
    prismicEmbedType: Maybe<PrismicEmbedType>
    prismicEvent: Maybe<PrismicEvent>
    prismicEventBigformPage: Maybe<PrismicEventBigformPage>
    prismicEventForm: Maybe<PrismicEventForm>
    prismicExpensePolicyBuilder: Maybe<PrismicExpensePolicyBuilder>
    prismicExpensePolicyBuilderDataFormProductionIntegrationType: Maybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationType>
    prismicExpensePolicyBuilderDataFormStagingIntegrationType: Maybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationType>
    prismicExpenseReportGenerator: Maybe<PrismicExpenseReportGenerator>
    prismicExperimentalLandingPage: Maybe<PrismicExperimentalLandingPage>
    prismicExploreProduct: Maybe<PrismicExploreProduct>
    prismicExploreProductDataFormProductionIntegrationType: Maybe<PrismicExploreProductDataFormProductionIntegrationType>
    prismicExploreProductDataFormStagingIntegrationType: Maybe<PrismicExploreProductDataFormStagingIntegrationType>
    prismicFaqPage: Maybe<PrismicFaqPage>
    prismicFeatureBlock: Maybe<PrismicFeatureBlock>
    prismicFeatureBlockGroup: Maybe<PrismicFeatureBlockGroup>
    prismicFeatureIconCard: Maybe<PrismicFeatureIconCard>
    prismicFeatureIconCards: Maybe<PrismicFeatureIconCards>
    prismicFetchPage: Maybe<PrismicFetchPage>
    prismicFincirclePage: Maybe<PrismicFincirclePage>
    prismicFlexBenefitsPage: Maybe<PrismicFlexBenefitsPage>
    prismicFooter: Maybe<PrismicFooter>
    prismicFooterSignup: Maybe<PrismicFooterSignup>
    prismicFormConsent: Maybe<PrismicFormConsent>
    prismicFormConsentDataSubscriptionTypeProductionIntegrationType: Maybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationType>
    prismicFormConsentDataSubscriptionTypeStagingIntegrationType: Maybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationType>
    prismicGettingStartedExperience: Maybe<PrismicGettingStartedExperience>
    prismicGettingStartedExperienceDataFormProductionIntegrationType: Maybe<PrismicGettingStartedExperienceDataFormProductionIntegrationType>
    prismicGettingStartedExperienceDataFormStagingIntegrationType: Maybe<PrismicGettingStartedExperienceDataFormStagingIntegrationType>
    prismicGlobalStrings: Maybe<PrismicGlobalStrings>
    prismicHeader: Maybe<PrismicHeader>
    prismicHeaderDropdown: Maybe<PrismicHeaderDropdown>
    prismicHeaderDropdownColumn: Maybe<PrismicHeaderDropdownColumn>
    prismicHeaderDropdownCta: Maybe<PrismicHeaderDropdownCta>
    prismicHeaderV2: Maybe<PrismicHeaderV2>
    prismicHeaderV2Dropdown: Maybe<PrismicHeaderV2Dropdown>
    prismicHeroTab: Maybe<PrismicHeroTab>
    prismicHeroTabDataFormProductionIntegrationType: Maybe<PrismicHeroTabDataFormProductionIntegrationType>
    prismicHeroTabDataFormStagingIntegrationType: Maybe<PrismicHeroTabDataFormStagingIntegrationType>
    prismicHomepageV4: Maybe<PrismicHomepageV4>
    prismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationType>
    prismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType: Maybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationType>
    prismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationType>
    prismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType: Maybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationType>
    prismicHowItWorksPage: Maybe<PrismicHowItWorksPage>
    prismicHubspotGlobalForm: Maybe<PrismicHubspotGlobalForm>
    prismicHubspotGlobalFormDataFormProductionIntegrationType: Maybe<PrismicHubspotGlobalFormDataFormProductionIntegrationType>
    prismicHubspotGlobalFormDataFormStagingIntegrationType: Maybe<PrismicHubspotGlobalFormDataFormStagingIntegrationType>
    prismicHubspotReferralForm: Maybe<PrismicHubspotReferralForm>
    prismicIntegration: Maybe<PrismicIntegration>
    prismicIntegrationPage: Maybe<PrismicIntegrationPage>
    prismicIntegrationsFeatureBlock: Maybe<PrismicIntegrationsFeatureBlock>
    prismicIntegrationsIndexPage: Maybe<PrismicIntegrationsIndexPage>
    prismicInvoice: Maybe<PrismicInvoice>
    prismicInvoiceGenerator: Maybe<PrismicInvoiceGenerator>
    prismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationType>
    prismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType: Maybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationType>
    prismicInvoiceTemplateForm: Maybe<PrismicInvoiceTemplateForm>
    prismicInvoiceTemplateFormDataFormProductionIntegrationType: Maybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationType>
    prismicInvoiceTemplateFormDataFormStagingIntegrationType: Maybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationType>
    prismicInvoicesApprovals: Maybe<PrismicInvoicesApprovals>
    prismicJobListing: Maybe<PrismicJobListing>
    prismicJobPage: Maybe<PrismicJobPage>
    prismicLearnMoreCard: Maybe<PrismicLearnMoreCard>
    prismicLegalDocument: Maybe<PrismicLegalDocument>
    prismicLegalDocuments: Maybe<PrismicLegalDocuments>
    prismicLegalDocumentsDirectory: Maybe<PrismicLegalDocumentsDirectory>
    prismicLegalPage: Maybe<PrismicLegalPage>
    prismicLegalPageCookiePolicy: Maybe<PrismicLegalPageCookiePolicy>
    prismicLegalPageDsr: Maybe<PrismicLegalPageDsr>
    prismicLegalPageGdpr: Maybe<PrismicLegalPageGdpr>
    prismicLegalPageThirdPartyLicences: Maybe<PrismicLegalPageThirdPartyLicences>
    prismicLinkTest: Maybe<PrismicLinkTest>
    prismicMeetingBookerPage: Maybe<PrismicMeetingBookerPage>
    prismicNotFoundPage: Maybe<PrismicNotFoundPage>
    prismicNotificationBanner: Maybe<PrismicNotificationBanner>
    prismicOnDemandResourceCategory: Maybe<PrismicOnDemandResourceCategory>
    prismicOnDemandResourceForm: Maybe<PrismicOnDemandResourceForm>
    prismicOnDemandResourceFormDataFormProductionIntegrationType: Maybe<PrismicOnDemandResourceFormDataFormProductionIntegrationType>
    prismicOnDemandResourceFormDataFormStagingIntegrationType: Maybe<PrismicOnDemandResourceFormDataFormStagingIntegrationType>
    prismicOnDemandResourcePage: Maybe<PrismicOnDemandResourcePage>
    prismicOnDemandWebinarDetailPage: Maybe<PrismicOnDemandWebinarDetailPage>
    prismicOnDemandWebinarForm: Maybe<PrismicOnDemandWebinarForm>
    prismicPartner: Maybe<PrismicPartner>
    prismicPartnerBigform: Maybe<PrismicPartnerBigform>
    prismicPartnerBigformPage: Maybe<PrismicPartnerBigformPage>
    prismicPartnerBigformPageDataFormProductionIntegrationType: Maybe<PrismicPartnerBigformPageDataFormProductionIntegrationType>
    prismicPartnerBigformPageDataFormStagingIntegrationType: Maybe<PrismicPartnerBigformPageDataFormStagingIntegrationType>
    prismicPartnerPage: Maybe<PrismicPartnerPage>
    prismicPartnerSignupBanner: Maybe<PrismicPartnerSignupBanner>
    prismicPartnersProgrammeTable: Maybe<PrismicPartnersProgrammeTable>
    prismicPartnershipCase: Maybe<PrismicPartnershipCase>
    prismicPartnershipTier: Maybe<PrismicPartnershipTier>
    prismicPartnershipTiers: Maybe<PrismicPartnershipTiers>
    prismicPerk: Maybe<PrismicPerk>
    prismicPerksInternalPage: Maybe<PrismicPerksInternalPage>
    prismicPleoEvent: Maybe<PrismicPleoEvent>
    prismicPleoPartnerTier: Maybe<PrismicPleoPartnerTier>
    prismicPocketPage: Maybe<PrismicPocketPage>
    prismicPodcastFormPage: Maybe<PrismicPodcastFormPage>
    prismicPreLaunchFormPage: Maybe<PrismicPreLaunchFormPage>
    prismicPricingComparisonTable: Maybe<PrismicPricingComparisonTable>
    prismicPricingPage: Maybe<PrismicPricingPage>
    prismicPricingPageV2: Maybe<PrismicPricingPageV2>
    prismicPricingPlanPicker: Maybe<PrismicPricingPlanPicker>
    prismicPricingPlanPickerDataFormProductionIntegrationType: Maybe<PrismicPricingPlanPickerDataFormProductionIntegrationType>
    prismicPricingPlanPickerDataFormStagingIntegrationType: Maybe<PrismicPricingPlanPickerDataFormStagingIntegrationType>
    prismicPricingTable: Maybe<PrismicPricingTable>
    prismicPricingTableV2: Maybe<PrismicPricingTableV2>
    prismicPricingTier: Maybe<PrismicPricingTier>
    prismicPricingTiers: Maybe<PrismicPricingTiers>
    prismicPricingTiersDataFormProductionIntegrationType: Maybe<PrismicPricingTiersDataFormProductionIntegrationType>
    prismicPricingTiersDataFormStagingIntegrationType: Maybe<PrismicPricingTiersDataFormStagingIntegrationType>
    prismicPricingTiersV2: Maybe<PrismicPricingTiersV2>
    prismicPricingV2: Maybe<PrismicPricingV2>
    prismicPricingV3ComparisonTable: Maybe<PrismicPricingV3ComparisonTable>
    prismicPricingV3Page: Maybe<PrismicPricingV3Page>
    prismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationType>
    prismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType: Maybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationType>
    prismicPricingV3PricingTier: Maybe<PrismicPricingV3PricingTier>
    prismicPricingV3PricingTierFeatureList: Maybe<PrismicPricingV3PricingTierFeatureList>
    prismicPricingV3TierPricingModel: Maybe<PrismicPricingV3TierPricingModel>
    prismicProofPointBadges: Maybe<PrismicProofPointBadges>
    prismicProofPointBadgesRepeatable: Maybe<PrismicProofPointBadgesRepeatable>
    prismicRating: Maybe<PrismicRating>
    prismicRatingsGroup: Maybe<PrismicRatingsGroup>
    prismicResourceDetailPage: Maybe<PrismicResourceDetailPage>
    prismicRoiCalculator: Maybe<PrismicRoiCalculator>
    prismicRoiCalculatorDataFormProductionIntegrationType: Maybe<PrismicRoiCalculatorDataFormProductionIntegrationType>
    prismicRoiCalculatorDataFormStagingIntegrationType: Maybe<PrismicRoiCalculatorDataFormStagingIntegrationType>
    prismicRoicPreview: Maybe<PrismicRoicPreview>
    prismicRytisEbookDetails: Maybe<PrismicRytisEbookDetails>
    prismicSecondaryHomepage: Maybe<PrismicSecondaryHomepage>
    prismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    prismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType: Maybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    prismicSecondaryLegalDocuments: Maybe<PrismicSecondaryLegalDocuments>
    prismicSecondaryLegalPage: Maybe<PrismicSecondaryLegalPage>
    prismicSecondaryNotFoundPage: Maybe<PrismicSecondaryNotFoundPage>
    prismicSecondaryPricingPage: Maybe<PrismicSecondaryPricingPage>
    prismicSecondaryPricingTier: Maybe<PrismicSecondaryPricingTier>
    prismicSecondaryPricingTiers: Maybe<PrismicSecondaryPricingTiers>
    prismicSecondaryPricingTiersDataFormProductionIntegrationType: Maybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationType>
    prismicSecondaryPricingTiersDataFormStagingIntegrationType: Maybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationType>
    prismicSeo: Maybe<PrismicSeo>
    prismicSignUpModal: Maybe<PrismicSignUpModal>
    prismicSignUpModalDataFormProductionIntegrationType: Maybe<PrismicSignUpModalDataFormProductionIntegrationType>
    prismicSignUpModalDataFormStagingIntegrationType: Maybe<PrismicSignUpModalDataFormStagingIntegrationType>
    prismicSignupBanner: Maybe<PrismicSignupBanner>
    prismicSignupBannerDataFormProductionIntegrationType: Maybe<PrismicSignupBannerDataFormProductionIntegrationType>
    prismicSignupBannerDataFormStagingIntegrationType: Maybe<PrismicSignupBannerDataFormStagingIntegrationType>
    prismicSignupFunnelExperiment: Maybe<PrismicSignupFunnelExperiment>
    prismicSignupModal: Maybe<PrismicSignupModal>
    prismicSignupModalDataFormProductionIntegrationType: Maybe<PrismicSignupModalDataFormProductionIntegrationType>
    prismicSignupModalDataFormStagingIntegrationType: Maybe<PrismicSignupModalDataFormStagingIntegrationType>
    prismicSignupPage: Maybe<PrismicSignupPage>
    prismicSignupReason: Maybe<PrismicSignupReason>
    prismicSignupWizard: Maybe<PrismicSignupWizard>
    prismicSignupmodal: Maybe<PrismicSignupmodal>
    prismicSignupmodalDataFormProductionIntegrationType: Maybe<PrismicSignupmodalDataFormProductionIntegrationType>
    prismicSignupmodalDataFormStagingIntegrationType: Maybe<PrismicSignupmodalDataFormStagingIntegrationType>
    prismicSkillEvaluationTool: Maybe<PrismicSkillEvaluationTool>
    prismicSlicePage: Maybe<PrismicSlicePage>
    prismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationType>
    prismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType: Maybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationType>
    prismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationType>
    prismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType: Maybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationType>
    prismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationType>
    prismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType: Maybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationType>
    prismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationType>
    prismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType: Maybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationType>
    prismicSocialProofIndicator: Maybe<PrismicSocialProofIndicator>
    prismicSocialProofLogosExtendedSection: Maybe<PrismicSocialProofLogosExtendedSection>
    prismicSocialProofLogosSection: Maybe<PrismicSocialProofLogosSection>
    prismicSocialProofRatingsSection: Maybe<PrismicSocialProofRatingsSection>
    prismicStarterBigformPage: Maybe<PrismicStarterBigformPage>
    prismicStatisticsSection: Maybe<PrismicStatisticsSection>
    prismicSubscriptionsPage: Maybe<PrismicSubscriptionsPage>
    prismicSyncedIntegration: Maybe<PrismicSyncedIntegration>
    prismicSyncedIntegrationDataEndymionAppIntegrationType: Maybe<PrismicSyncedIntegrationDataEndymionAppIntegrationType>
    prismicSyncedIntegrationsCategories: Maybe<PrismicSyncedIntegrationsCategories>
    prismicTemplateCustomerCase: Maybe<PrismicTemplateCustomerCase>
    prismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationType>
    prismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType: Maybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationType>
    prismicTemplatePartner: Maybe<PrismicTemplatePartner>
    prismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationType>
    prismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType: Maybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationType>
    prismicTestAaa: Maybe<PrismicTestAaa>
    prismicTestimonial: Maybe<PrismicTestimonial>
    prismicThirdPartyLicencesSection: Maybe<PrismicThirdPartyLicencesSection>
    prismicTypePathType: Maybe<PrismicTypePathType>
    prismicTypeformSurveys: Maybe<PrismicTypeformSurveys>
    prismicUnifiedSignupModal: Maybe<PrismicUnifiedSignupModal>
    prismicUnifiedSignupModalDataFormProductionIntegrationType: Maybe<PrismicUnifiedSignupModalDataFormProductionIntegrationType>
    prismicUnifiedSignupModalDataFormStagingIntegrationType: Maybe<PrismicUnifiedSignupModalDataFormStagingIntegrationType>
    prismicVatCalculator: Maybe<PrismicVatCalculator>
    prismicWebinarCategory: Maybe<PrismicWebinarCategory>
    prismicWhyPleoPage: Maybe<PrismicWhyPleoPage>
    prismicWistaChannelPage: Maybe<PrismicWistaChannelPage>
    site: Maybe<Site>
    siteBuildMetadata: Maybe<SiteBuildMetadata>
    siteFunction: Maybe<SiteFunction>
    sitePage: Maybe<SitePage>
    sitePlugin: Maybe<SitePlugin>
}

export type QueryAllDirectoryArgs = {
    filter: InputMaybe<DirectoryFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<DirectorySortInput>>>
}

export type QueryAllFileArgs = {
    filter: InputMaybe<FileFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<FileSortInput>>>
}

export type QueryAllPrismicAboutUsPageArgs = {
    filter: InputMaybe<PrismicAboutUsPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicAboutUsPageSortInput>>>
}

export type QueryAllPrismicAdditionalUsersTableArgs = {
    filter: InputMaybe<PrismicAdditionalUsersTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicAdditionalUsersTableSortInput>>>
}

export type QueryAllPrismicApplePayPageArgs = {
    filter: InputMaybe<PrismicApplePayPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicApplePayPageSortInput>>>
}

export type QueryAllPrismicBigformArgs = {
    filter: InputMaybe<PrismicBigformFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicBigformSortInput>>>
}

export type QueryAllPrismicBigformDataSandboxHubspotFormIntegrationTypeArgs = {
    filter: InputMaybe<PrismicBigformDataSandboxHubspotFormIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicBigformDataSandboxHubspotFormIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicBigformPageArgs = {
    filter: InputMaybe<PrismicBigformPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicBigformPageSortInput>>>
}

export type QueryAllPrismicBillsCalculatorArgs = {
    filter: InputMaybe<PrismicBillsCalculatorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicBillsCalculatorSortInput>>>
}

export type QueryAllPrismicBillsStatusArgs = {
    filter: InputMaybe<PrismicBillsStatusFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicBillsStatusSortInput>>>
}

export type QueryAllPrismicBillsTrackerArgs = {
    filter: InputMaybe<PrismicBillsTrackerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicBillsTrackerSortInput>>>
}

export type QueryAllPrismicCalendlyPageArgs = {
    filter: InputMaybe<PrismicCalendlyPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCalendlyPageSortInput>>>
}

export type QueryAllPrismicCardCreationFunnelArgs = {
    filter: InputMaybe<PrismicCardCreationFunnelFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCardCreationFunnelSortInput>>>
}

export type QueryAllPrismicCareersPageArgs = {
    filter: InputMaybe<PrismicCareersPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCareersPageSortInput>>>
}

export type QueryAllPrismicCarouselArgs = {
    filter: InputMaybe<PrismicCarouselFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCarouselSortInput>>>
}

export type QueryAllPrismicCashbackCalculatorArgs = {
    filter: InputMaybe<PrismicCashbackCalculatorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCashbackCalculatorSortInput>>>
}

export type QueryAllPrismicComaprisonTableArgs = {
    filter: InputMaybe<PrismicComaprisonTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicComaprisonTableSortInput>>>
}

export type QueryAllPrismicComparisonTableArgs = {
    filter: InputMaybe<PrismicComparisonTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicComparisonTableSortInput>>>
}

export type QueryAllPrismicCookieBannerArgs = {
    filter: InputMaybe<PrismicCookieBannerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCookieBannerSortInput>>>
}

export type QueryAllPrismicCookieCategoryArgs = {
    filter: InputMaybe<PrismicCookieCategoryFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCookieCategorySortInput>>>
}

export type QueryAllPrismicCookieManagerArgs = {
    filter: InputMaybe<PrismicCookieManagerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCookieManagerSortInput>>>
}

export type QueryAllPrismicCookieSegmentArgs = {
    filter: InputMaybe<PrismicCookieSegmentFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCookieSegmentSortInput>>>
}

export type QueryAllPrismicCookieSettingsPageArgs = {
    filter: InputMaybe<PrismicCookieSettingsPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCookieSettingsPageSortInput>>>
}

export type QueryAllPrismicCopyExperimentArgs = {
    filter: InputMaybe<PrismicCopyExperimentFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCopyExperimentSortInput>>>
}

export type QueryAllPrismicCustomerCaseArgs = {
    filter: InputMaybe<PrismicCustomerCaseFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCustomerCaseSortInput>>>
}

export type QueryAllPrismicCustomerLogosArgs = {
    filter: InputMaybe<PrismicCustomerLogosFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCustomerLogosSortInput>>>
}

export type QueryAllPrismicCustomerStoriesSectionArgs = {
    filter: InputMaybe<PrismicCustomerStoriesSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCustomerStoriesSectionSortInput>>>
}

export type QueryAllPrismicCustomersLogosSectionArgs = {
    filter: InputMaybe<PrismicCustomersLogosSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCustomersLogosSectionSortInput>>>
}

export type QueryAllPrismicCustomersPageArgs = {
    filter: InputMaybe<PrismicCustomersPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicCustomersPageSortInput>>>
}

export type QueryAllPrismicDemoPageArgs = {
    filter: InputMaybe<PrismicDemoPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicDemoPageSortInput>>>
}

export type QueryAllPrismicDemoPageDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeSortInput>>>
}

export type QueryAllPrismicDemoPageDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicDisallowedEmailsArgs = {
    filter: InputMaybe<PrismicDisallowedEmailsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicDisallowedEmailsSortInput>>>
}

export type QueryAllPrismicEbookArgs = {
    filter: InputMaybe<PrismicEbookFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookSortInput>>>
}

export type QueryAllPrismicEbookDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookDataFormProductionIntegrationTypeSortInput>>>
}

export type QueryAllPrismicEbookDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicEbookDetailsArgs = {
    filter: InputMaybe<PrismicEbookDetailsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookDetailsSortInput>>>
}

export type QueryAllPrismicEbookMarketingDownloadArgs = {
    filter: InputMaybe<PrismicEbookMarketingDownloadFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookMarketingDownloadSortInput>>>
}

export type QueryAllPrismicEbookMarketingPageArgs = {
    filter: InputMaybe<PrismicEbookMarketingPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbookMarketingPageSortInput>>>
}

export type QueryAllPrismicEbooksIndexArgs = {
    filter: InputMaybe<PrismicEbooksIndexFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEbooksIndexSortInput>>>
}

export type QueryAllPrismicEmbedTypeArgs = {
    filter: InputMaybe<PrismicEmbedTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEmbedTypeSortInput>>>
}

export type QueryAllPrismicEventArgs = {
    filter: InputMaybe<PrismicEventFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEventSortInput>>>
}

export type QueryAllPrismicEventBigformPageArgs = {
    filter: InputMaybe<PrismicEventBigformPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEventBigformPageSortInput>>>
}

export type QueryAllPrismicEventFormArgs = {
    filter: InputMaybe<PrismicEventFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicEventFormSortInput>>>
}

export type QueryAllPrismicExpensePolicyBuilderArgs = {
    filter: InputMaybe<PrismicExpensePolicyBuilderFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicExpensePolicyBuilderSortInput>>>
}

export type QueryAllPrismicExpensePolicyBuilderDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicExpensePolicyBuilderDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicExpenseReportGeneratorArgs = {
    filter: InputMaybe<PrismicExpenseReportGeneratorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicExpenseReportGeneratorSortInput>>>
}

export type QueryAllPrismicExperimentalLandingPageArgs = {
    filter: InputMaybe<PrismicExperimentalLandingPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicExperimentalLandingPageSortInput>>>
}

export type QueryAllPrismicExploreProductArgs = {
    filter: InputMaybe<PrismicExploreProductFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicExploreProductSortInput>>>
}

export type QueryAllPrismicExploreProductDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicExploreProductDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicFaqPageArgs = {
    filter: InputMaybe<PrismicFaqPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFaqPageSortInput>>>
}

export type QueryAllPrismicFeatureBlockArgs = {
    filter: InputMaybe<PrismicFeatureBlockFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFeatureBlockSortInput>>>
}

export type QueryAllPrismicFeatureBlockGroupArgs = {
    filter: InputMaybe<PrismicFeatureBlockGroupFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFeatureBlockGroupSortInput>>>
}

export type QueryAllPrismicFeatureIconCardArgs = {
    filter: InputMaybe<PrismicFeatureIconCardFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFeatureIconCardSortInput>>>
}

export type QueryAllPrismicFeatureIconCardsArgs = {
    filter: InputMaybe<PrismicFeatureIconCardsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFeatureIconCardsSortInput>>>
}

export type QueryAllPrismicFetchPageArgs = {
    filter: InputMaybe<PrismicFetchPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFetchPageSortInput>>>
}

export type QueryAllPrismicFincirclePageArgs = {
    filter: InputMaybe<PrismicFincirclePageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFincirclePageSortInput>>>
}

export type QueryAllPrismicFlexBenefitsPageArgs = {
    filter: InputMaybe<PrismicFlexBenefitsPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFlexBenefitsPageSortInput>>>
}

export type QueryAllPrismicFooterArgs = {
    filter: InputMaybe<PrismicFooterFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFooterSortInput>>>
}

export type QueryAllPrismicFooterSignupArgs = {
    filter: InputMaybe<PrismicFooterSignupFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFooterSignupSortInput>>>
}

export type QueryAllPrismicFormConsentArgs = {
    filter: InputMaybe<PrismicFormConsentFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicFormConsentSortInput>>>
}

export type QueryAllPrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicGettingStartedExperienceArgs = {
    filter: InputMaybe<PrismicGettingStartedExperienceFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicGettingStartedExperienceSortInput>>>
}

export type QueryAllPrismicGettingStartedExperienceDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicGettingStartedExperienceDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicGettingStartedExperienceDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicGettingStartedExperienceDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicGlobalStringsArgs = {
    filter: InputMaybe<PrismicGlobalStringsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicGlobalStringsSortInput>>>
}

export type QueryAllPrismicHeaderArgs = {
    filter: InputMaybe<PrismicHeaderFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderSortInput>>>
}

export type QueryAllPrismicHeaderDropdownArgs = {
    filter: InputMaybe<PrismicHeaderDropdownFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderDropdownSortInput>>>
}

export type QueryAllPrismicHeaderDropdownColumnArgs = {
    filter: InputMaybe<PrismicHeaderDropdownColumnFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderDropdownColumnSortInput>>>
}

export type QueryAllPrismicHeaderDropdownCtaArgs = {
    filter: InputMaybe<PrismicHeaderDropdownCtaFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderDropdownCtaSortInput>>>
}

export type QueryAllPrismicHeaderV2Args = {
    filter: InputMaybe<PrismicHeaderV2FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderV2SortInput>>>
}

export type QueryAllPrismicHeaderV2DropdownArgs = {
    filter: InputMaybe<PrismicHeaderV2DropdownFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeaderV2DropdownSortInput>>>
}

export type QueryAllPrismicHeroTabArgs = {
    filter: InputMaybe<PrismicHeroTabFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeroTabSortInput>>>
}

export type QueryAllPrismicHeroTabDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeSortInput>>>
}

export type QueryAllPrismicHeroTabDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicHomepageV4Args = {
    filter: InputMaybe<PrismicHomepageV4FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHomepageV4SortInput>>>
}

export type QueryAllPrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicHowItWorksPageArgs = {
    filter: InputMaybe<PrismicHowItWorksPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHowItWorksPageSortInput>>>
}

export type QueryAllPrismicHubspotGlobalFormArgs = {
    filter: InputMaybe<PrismicHubspotGlobalFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHubspotGlobalFormSortInput>>>
}

export type QueryAllPrismicHubspotGlobalFormDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicHubspotGlobalFormDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicHubspotReferralFormArgs = {
    filter: InputMaybe<PrismicHubspotReferralFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicHubspotReferralFormSortInput>>>
}

export type QueryAllPrismicIntegrationArgs = {
    filter: InputMaybe<PrismicIntegrationFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicIntegrationSortInput>>>
}

export type QueryAllPrismicIntegrationPageArgs = {
    filter: InputMaybe<PrismicIntegrationPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicIntegrationPageSortInput>>>
}

export type QueryAllPrismicIntegrationsFeatureBlockArgs = {
    filter: InputMaybe<PrismicIntegrationsFeatureBlockFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicIntegrationsFeatureBlockSortInput>>>
}

export type QueryAllPrismicIntegrationsIndexPageArgs = {
    filter: InputMaybe<PrismicIntegrationsIndexPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicIntegrationsIndexPageSortInput>>>
}

export type QueryAllPrismicInvoiceArgs = {
    filter: InputMaybe<PrismicInvoiceFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicInvoiceSortInput>>>
}

export type QueryAllPrismicInvoiceGeneratorArgs = {
    filter: InputMaybe<PrismicInvoiceGeneratorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicInvoiceGeneratorSortInput>>>
}

export type QueryAllPrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicInvoiceTemplateFormArgs = {
    filter: InputMaybe<PrismicInvoiceTemplateFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicInvoiceTemplateFormSortInput>>>
}

export type QueryAllPrismicInvoiceTemplateFormDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicInvoiceTemplateFormDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicInvoicesApprovalsArgs = {
    filter: InputMaybe<PrismicInvoicesApprovalsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicInvoicesApprovalsSortInput>>>
}

export type QueryAllPrismicJobListingArgs = {
    filter: InputMaybe<PrismicJobListingFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicJobListingSortInput>>>
}

export type QueryAllPrismicJobPageArgs = {
    filter: InputMaybe<PrismicJobPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicJobPageSortInput>>>
}

export type QueryAllPrismicLearnMoreCardArgs = {
    filter: InputMaybe<PrismicLearnMoreCardFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLearnMoreCardSortInput>>>
}

export type QueryAllPrismicLegalDocumentArgs = {
    filter: InputMaybe<PrismicLegalDocumentFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalDocumentSortInput>>>
}

export type QueryAllPrismicLegalDocumentsArgs = {
    filter: InputMaybe<PrismicLegalDocumentsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalDocumentsSortInput>>>
}

export type QueryAllPrismicLegalDocumentsDirectoryArgs = {
    filter: InputMaybe<PrismicLegalDocumentsDirectoryFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalDocumentsDirectorySortInput>>>
}

export type QueryAllPrismicLegalPageArgs = {
    filter: InputMaybe<PrismicLegalPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalPageSortInput>>>
}

export type QueryAllPrismicLegalPageCookiePolicyArgs = {
    filter: InputMaybe<PrismicLegalPageCookiePolicyFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalPageCookiePolicySortInput>>>
}

export type QueryAllPrismicLegalPageDsrArgs = {
    filter: InputMaybe<PrismicLegalPageDsrFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalPageDsrSortInput>>>
}

export type QueryAllPrismicLegalPageGdprArgs = {
    filter: InputMaybe<PrismicLegalPageGdprFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalPageGdprSortInput>>>
}

export type QueryAllPrismicLegalPageThirdPartyLicencesArgs = {
    filter: InputMaybe<PrismicLegalPageThirdPartyLicencesFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLegalPageThirdPartyLicencesSortInput>>>
}

export type QueryAllPrismicLinkTestArgs = {
    filter: InputMaybe<PrismicLinkTestFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicLinkTestSortInput>>>
}

export type QueryAllPrismicMeetingBookerPageArgs = {
    filter: InputMaybe<PrismicMeetingBookerPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicMeetingBookerPageSortInput>>>
}

export type QueryAllPrismicNotFoundPageArgs = {
    filter: InputMaybe<PrismicNotFoundPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicNotFoundPageSortInput>>>
}

export type QueryAllPrismicNotificationBannerArgs = {
    filter: InputMaybe<PrismicNotificationBannerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicNotificationBannerSortInput>>>
}

export type QueryAllPrismicOnDemandResourceCategoryArgs = {
    filter: InputMaybe<PrismicOnDemandResourceCategoryFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicOnDemandResourceCategorySortInput>>>
}

export type QueryAllPrismicOnDemandResourceFormArgs = {
    filter: InputMaybe<PrismicOnDemandResourceFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicOnDemandResourceFormSortInput>>>
}

export type QueryAllPrismicOnDemandResourceFormDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicOnDemandResourceFormDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicOnDemandResourcePageArgs = {
    filter: InputMaybe<PrismicOnDemandResourcePageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicOnDemandResourcePageSortInput>>>
}

export type QueryAllPrismicOnDemandWebinarDetailPageArgs = {
    filter: InputMaybe<PrismicOnDemandWebinarDetailPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicOnDemandWebinarDetailPageSortInput>>>
}

export type QueryAllPrismicOnDemandWebinarFormArgs = {
    filter: InputMaybe<PrismicOnDemandWebinarFormFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicOnDemandWebinarFormSortInput>>>
}

export type QueryAllPrismicPartnerArgs = {
    filter: InputMaybe<PrismicPartnerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnerSortInput>>>
}

export type QueryAllPrismicPartnerBigformArgs = {
    filter: InputMaybe<PrismicPartnerBigformFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnerBigformSortInput>>>
}

export type QueryAllPrismicPartnerBigformPageArgs = {
    filter: InputMaybe<PrismicPartnerBigformPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnerBigformPageSortInput>>>
}

export type QueryAllPrismicPartnerBigformPageDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicPartnerBigformPageDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicPartnerPageArgs = {
    filter: InputMaybe<PrismicPartnerPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnerPageSortInput>>>
}

export type QueryAllPrismicPartnerSignupBannerArgs = {
    filter: InputMaybe<PrismicPartnerSignupBannerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnerSignupBannerSortInput>>>
}

export type QueryAllPrismicPartnersProgrammeTableArgs = {
    filter: InputMaybe<PrismicPartnersProgrammeTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnersProgrammeTableSortInput>>>
}

export type QueryAllPrismicPartnershipCaseArgs = {
    filter: InputMaybe<PrismicPartnershipCaseFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnershipCaseSortInput>>>
}

export type QueryAllPrismicPartnershipTierArgs = {
    filter: InputMaybe<PrismicPartnershipTierFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnershipTierSortInput>>>
}

export type QueryAllPrismicPartnershipTiersArgs = {
    filter: InputMaybe<PrismicPartnershipTiersFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPartnershipTiersSortInput>>>
}

export type QueryAllPrismicPerkArgs = {
    filter: InputMaybe<PrismicPerkFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPerkSortInput>>>
}

export type QueryAllPrismicPerksInternalPageArgs = {
    filter: InputMaybe<PrismicPerksInternalPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPerksInternalPageSortInput>>>
}

export type QueryAllPrismicPleoEventArgs = {
    filter: InputMaybe<PrismicPleoEventFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPleoEventSortInput>>>
}

export type QueryAllPrismicPleoPartnerTierArgs = {
    filter: InputMaybe<PrismicPleoPartnerTierFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPleoPartnerTierSortInput>>>
}

export type QueryAllPrismicPocketPageArgs = {
    filter: InputMaybe<PrismicPocketPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPocketPageSortInput>>>
}

export type QueryAllPrismicPodcastFormPageArgs = {
    filter: InputMaybe<PrismicPodcastFormPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPodcastFormPageSortInput>>>
}

export type QueryAllPrismicPreLaunchFormPageArgs = {
    filter: InputMaybe<PrismicPreLaunchFormPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPreLaunchFormPageSortInput>>>
}

export type QueryAllPrismicPricingComparisonTableArgs = {
    filter: InputMaybe<PrismicPricingComparisonTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingComparisonTableSortInput>>>
}

export type QueryAllPrismicPricingPageArgs = {
    filter: InputMaybe<PrismicPricingPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingPageSortInput>>>
}

export type QueryAllPrismicPricingPageV2Args = {
    filter: InputMaybe<PrismicPricingPageV2FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingPageV2SortInput>>>
}

export type QueryAllPrismicPricingPlanPickerArgs = {
    filter: InputMaybe<PrismicPricingPlanPickerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingPlanPickerSortInput>>>
}

export type QueryAllPrismicPricingPlanPickerDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicPricingPlanPickerDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicPricingTableArgs = {
    filter: InputMaybe<PrismicPricingTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTableSortInput>>>
}

export type QueryAllPrismicPricingTableV2Args = {
    filter: InputMaybe<PrismicPricingTableV2FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTableV2SortInput>>>
}

export type QueryAllPrismicPricingTierArgs = {
    filter: InputMaybe<PrismicPricingTierFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTierSortInput>>>
}

export type QueryAllPrismicPricingTiersArgs = {
    filter: InputMaybe<PrismicPricingTiersFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTiersSortInput>>>
}

export type QueryAllPrismicPricingTiersDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicPricingTiersDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicPricingTiersV2Args = {
    filter: InputMaybe<PrismicPricingTiersV2FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingTiersV2SortInput>>>
}

export type QueryAllPrismicPricingV2Args = {
    filter: InputMaybe<PrismicPricingV2FilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV2SortInput>>>
}

export type QueryAllPrismicPricingV3ComparisonTableArgs = {
    filter: InputMaybe<PrismicPricingV3ComparisonTableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV3ComparisonTableSortInput>>>
}

export type QueryAllPrismicPricingV3PageArgs = {
    filter: InputMaybe<PrismicPricingV3PageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV3PageSortInput>>>
}

export type QueryAllPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicPricingV3PricingTierArgs = {
    filter: InputMaybe<PrismicPricingV3PricingTierFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV3PricingTierSortInput>>>
}

export type QueryAllPrismicPricingV3PricingTierFeatureListArgs = {
    filter: InputMaybe<PrismicPricingV3PricingTierFeatureListFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV3PricingTierFeatureListSortInput>>>
}

export type QueryAllPrismicPricingV3TierPricingModelArgs = {
    filter: InputMaybe<PrismicPricingV3TierPricingModelFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicPricingV3TierPricingModelSortInput>>>
}

export type QueryAllPrismicProofPointBadgesArgs = {
    filter: InputMaybe<PrismicProofPointBadgesFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicProofPointBadgesSortInput>>>
}

export type QueryAllPrismicProofPointBadgesRepeatableArgs = {
    filter: InputMaybe<PrismicProofPointBadgesRepeatableFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicProofPointBadgesRepeatableSortInput>>>
}

export type QueryAllPrismicRatingArgs = {
    filter: InputMaybe<PrismicRatingFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRatingSortInput>>>
}

export type QueryAllPrismicRatingsGroupArgs = {
    filter: InputMaybe<PrismicRatingsGroupFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRatingsGroupSortInput>>>
}

export type QueryAllPrismicResourceDetailPageArgs = {
    filter: InputMaybe<PrismicResourceDetailPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicResourceDetailPageSortInput>>>
}

export type QueryAllPrismicRoiCalculatorArgs = {
    filter: InputMaybe<PrismicRoiCalculatorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRoiCalculatorSortInput>>>
}

export type QueryAllPrismicRoiCalculatorDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicRoiCalculatorDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicRoicPreviewArgs = {
    filter: InputMaybe<PrismicRoicPreviewFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRoicPreviewSortInput>>>
}

export type QueryAllPrismicRytisEbookDetailsArgs = {
    filter: InputMaybe<PrismicRytisEbookDetailsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicRytisEbookDetailsSortInput>>>
}

export type QueryAllPrismicSecondaryHomepageArgs = {
    filter: InputMaybe<PrismicSecondaryHomepageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryHomepageSortInput>>>
}

export type QueryAllPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicSecondaryLegalDocumentsArgs = {
    filter: InputMaybe<PrismicSecondaryLegalDocumentsFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryLegalDocumentsSortInput>>>
}

export type QueryAllPrismicSecondaryLegalPageArgs = {
    filter: InputMaybe<PrismicSecondaryLegalPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryLegalPageSortInput>>>
}

export type QueryAllPrismicSecondaryNotFoundPageArgs = {
    filter: InputMaybe<PrismicSecondaryNotFoundPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryNotFoundPageSortInput>>>
}

export type QueryAllPrismicSecondaryPricingPageArgs = {
    filter: InputMaybe<PrismicSecondaryPricingPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryPricingPageSortInput>>>
}

export type QueryAllPrismicSecondaryPricingTierArgs = {
    filter: InputMaybe<PrismicSecondaryPricingTierFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryPricingTierSortInput>>>
}

export type QueryAllPrismicSecondaryPricingTiersArgs = {
    filter: InputMaybe<PrismicSecondaryPricingTiersFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSecondaryPricingTiersSortInput>>>
}

export type QueryAllPrismicSecondaryPricingTiersDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSecondaryPricingTiersDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSeoArgs = {
    filter: InputMaybe<PrismicSeoFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSeoSortInput>>>
}

export type QueryAllPrismicSignUpModalArgs = {
    filter: InputMaybe<PrismicSignUpModalFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignUpModalSortInput>>>
}

export type QueryAllPrismicSignUpModalDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignUpModalDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSignUpModalDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSignUpModalDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignUpModalDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignUpModalDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicSignupBannerArgs = {
    filter: InputMaybe<PrismicSignupBannerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupBannerSortInput>>>
}

export type QueryAllPrismicSignupBannerDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSignupBannerDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicSignupFunnelExperimentArgs = {
    filter: InputMaybe<PrismicSignupFunnelExperimentFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupFunnelExperimentSortInput>>>
}

export type QueryAllPrismicSignupModalArgs = {
    filter: InputMaybe<PrismicSignupModalFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupModalSortInput>>>
}

export type QueryAllPrismicSignupModalDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupModalDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSignupModalDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSignupModalDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupModalDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupModalDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicSignupPageArgs = {
    filter: InputMaybe<PrismicSignupPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupPageSortInput>>>
}

export type QueryAllPrismicSignupReasonArgs = {
    filter: InputMaybe<PrismicSignupReasonFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupReasonSortInput>>>
}

export type QueryAllPrismicSignupWizardArgs = {
    filter: InputMaybe<PrismicSignupWizardFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupWizardSortInput>>>
}

export type QueryAllPrismicSignupmodalArgs = {
    filter: InputMaybe<PrismicSignupmodalFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupmodalSortInput>>>
}

export type QueryAllPrismicSignupmodalDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSignupmodalDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeSortInput>>>
}

export type QueryAllPrismicSkillEvaluationToolArgs = {
    filter: InputMaybe<PrismicSkillEvaluationToolFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSkillEvaluationToolSortInput>>>
}

export type QueryAllPrismicSlicePageArgs = {
    filter: InputMaybe<PrismicSlicePageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSlicePageSortInput>>>
}

export type QueryAllPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<
            InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeSortInput>
        >
    >
}

export type QueryAllPrismicSocialProofIndicatorArgs = {
    filter: InputMaybe<PrismicSocialProofIndicatorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSocialProofIndicatorSortInput>>>
}

export type QueryAllPrismicSocialProofLogosExtendedSectionArgs = {
    filter: InputMaybe<PrismicSocialProofLogosExtendedSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSocialProofLogosExtendedSectionSortInput>>>
}

export type QueryAllPrismicSocialProofLogosSectionArgs = {
    filter: InputMaybe<PrismicSocialProofLogosSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSocialProofLogosSectionSortInput>>>
}

export type QueryAllPrismicSocialProofRatingsSectionArgs = {
    filter: InputMaybe<PrismicSocialProofRatingsSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSocialProofRatingsSectionSortInput>>>
}

export type QueryAllPrismicStarterBigformPageArgs = {
    filter: InputMaybe<PrismicStarterBigformPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicStarterBigformPageSortInput>>>
}

export type QueryAllPrismicStatisticsSectionArgs = {
    filter: InputMaybe<PrismicStatisticsSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicStatisticsSectionSortInput>>>
}

export type QueryAllPrismicSubscriptionsPageArgs = {
    filter: InputMaybe<PrismicSubscriptionsPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSubscriptionsPageSortInput>>>
}

export type QueryAllPrismicSyncedIntegrationArgs = {
    filter: InputMaybe<PrismicSyncedIntegrationFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSyncedIntegrationSortInput>>>
}

export type QueryAllPrismicSyncedIntegrationDataEndymionAppIntegrationTypeArgs = {
    filter: InputMaybe<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicSyncedIntegrationDataEndymionAppIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicSyncedIntegrationsCategoriesArgs = {
    filter: InputMaybe<PrismicSyncedIntegrationsCategoriesFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicSyncedIntegrationsCategoriesSortInput>>>
}

export type QueryAllPrismicTemplateCustomerCaseArgs = {
    filter: InputMaybe<PrismicTemplateCustomerCaseFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTemplateCustomerCaseSortInput>>>
}

export type QueryAllPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicTemplatePartnerArgs = {
    filter: InputMaybe<PrismicTemplatePartnerFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTemplatePartnerSortInput>>>
}

export type QueryAllPrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs =
    {
        filter: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeFilterInput>
        limit: InputMaybe<Scalars['Int']['input']>
        skip: InputMaybe<Scalars['Int']['input']>
        sort: InputMaybe<
            Array<
                InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeSortInput>
            >
        >
    }

export type QueryAllPrismicTestAaaArgs = {
    filter: InputMaybe<PrismicTestAaaFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTestAaaSortInput>>>
}

export type QueryAllPrismicTestimonialArgs = {
    filter: InputMaybe<PrismicTestimonialFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTestimonialSortInput>>>
}

export type QueryAllPrismicThirdPartyLicencesSectionArgs = {
    filter: InputMaybe<PrismicThirdPartyLicencesSectionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicThirdPartyLicencesSectionSortInput>>>
}

export type QueryAllPrismicTypePathTypeArgs = {
    filter: InputMaybe<PrismicTypePathTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTypePathTypeSortInput>>>
}

export type QueryAllPrismicTypeformSurveysArgs = {
    filter: InputMaybe<PrismicTypeformSurveysFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicTypeformSurveysSortInput>>>
}

export type QueryAllPrismicUnifiedSignupModalArgs = {
    filter: InputMaybe<PrismicUnifiedSignupModalFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicUnifiedSignupModalSortInput>>>
}

export type QueryAllPrismicUnifiedSignupModalDataFormProductionIntegrationTypeArgs = {
    filter: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicUnifiedSignupModalDataFormStagingIntegrationTypeArgs = {
    filter: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<
        Array<InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeSortInput>>
    >
}

export type QueryAllPrismicVatCalculatorArgs = {
    filter: InputMaybe<PrismicVatCalculatorFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicVatCalculatorSortInput>>>
}

export type QueryAllPrismicWebinarCategoryArgs = {
    filter: InputMaybe<PrismicWebinarCategoryFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicWebinarCategorySortInput>>>
}

export type QueryAllPrismicWhyPleoPageArgs = {
    filter: InputMaybe<PrismicWhyPleoPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicWhyPleoPageSortInput>>>
}

export type QueryAllPrismicWistaChannelPageArgs = {
    filter: InputMaybe<PrismicWistaChannelPageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<PrismicWistaChannelPageSortInput>>>
}

export type QueryAllSiteArgs = {
    filter: InputMaybe<SiteFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<SiteSortInput>>>
}

export type QueryAllSiteBuildMetadataArgs = {
    filter: InputMaybe<SiteBuildMetadataFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<SiteBuildMetadataSortInput>>>
}

export type QueryAllSiteFunctionArgs = {
    filter: InputMaybe<SiteFunctionFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<SiteFunctionSortInput>>>
}

export type QueryAllSitePageArgs = {
    filter: InputMaybe<SitePageFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<SitePageSortInput>>>
}

export type QueryAllSitePluginArgs = {
    filter: InputMaybe<SitePluginFilterInput>
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
    sort: InputMaybe<Array<InputMaybe<SitePluginSortInput>>>
}

export type QueryDirectoryArgs = {
    absolutePath: InputMaybe<StringQueryOperatorInput>
    accessTime: InputMaybe<DateQueryOperatorInput>
    atime: InputMaybe<DateQueryOperatorInput>
    atimeMs: InputMaybe<FloatQueryOperatorInput>
    base: InputMaybe<StringQueryOperatorInput>
    birthTime: InputMaybe<DateQueryOperatorInput>
    birthtime: InputMaybe<DateQueryOperatorInput>
    birthtimeMs: InputMaybe<FloatQueryOperatorInput>
    changeTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    ctime: InputMaybe<DateQueryOperatorInput>
    ctimeMs: InputMaybe<FloatQueryOperatorInput>
    dev: InputMaybe<IntQueryOperatorInput>
    dir: InputMaybe<StringQueryOperatorInput>
    ext: InputMaybe<StringQueryOperatorInput>
    extension: InputMaybe<StringQueryOperatorInput>
    gid: InputMaybe<IntQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    ino: InputMaybe<FloatQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    mode: InputMaybe<IntQueryOperatorInput>
    modifiedTime: InputMaybe<DateQueryOperatorInput>
    mtime: InputMaybe<DateQueryOperatorInput>
    mtimeMs: InputMaybe<FloatQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    nlink: InputMaybe<IntQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prettySize: InputMaybe<StringQueryOperatorInput>
    rdev: InputMaybe<IntQueryOperatorInput>
    relativeDirectory: InputMaybe<StringQueryOperatorInput>
    relativePath: InputMaybe<StringQueryOperatorInput>
    root: InputMaybe<StringQueryOperatorInput>
    size: InputMaybe<IntQueryOperatorInput>
    sourceInstanceName: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<IntQueryOperatorInput>
}

export type QueryFileArgs = {
    absolutePath: InputMaybe<StringQueryOperatorInput>
    accessTime: InputMaybe<DateQueryOperatorInput>
    atime: InputMaybe<DateQueryOperatorInput>
    atimeMs: InputMaybe<FloatQueryOperatorInput>
    base: InputMaybe<StringQueryOperatorInput>
    birthTime: InputMaybe<DateQueryOperatorInput>
    birthtime: InputMaybe<DateQueryOperatorInput>
    birthtimeMs: InputMaybe<FloatQueryOperatorInput>
    changeTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    ctime: InputMaybe<DateQueryOperatorInput>
    ctimeMs: InputMaybe<FloatQueryOperatorInput>
    dev: InputMaybe<IntQueryOperatorInput>
    dir: InputMaybe<StringQueryOperatorInput>
    ext: InputMaybe<StringQueryOperatorInput>
    extension: InputMaybe<StringQueryOperatorInput>
    gid: InputMaybe<IntQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    ino: InputMaybe<FloatQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    mode: InputMaybe<IntQueryOperatorInput>
    modifiedTime: InputMaybe<DateQueryOperatorInput>
    mtime: InputMaybe<DateQueryOperatorInput>
    mtimeMs: InputMaybe<FloatQueryOperatorInput>
    name: InputMaybe<StringQueryOperatorInput>
    nlink: InputMaybe<IntQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prettySize: InputMaybe<StringQueryOperatorInput>
    rdev: InputMaybe<IntQueryOperatorInput>
    relativeDirectory: InputMaybe<StringQueryOperatorInput>
    relativePath: InputMaybe<StringQueryOperatorInput>
    root: InputMaybe<StringQueryOperatorInput>
    size: InputMaybe<IntQueryOperatorInput>
    sourceInstanceName: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<IntQueryOperatorInput>
}

export type QueryPrismicAboutUsPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicAboutUsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicAdditionalUsersTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicAdditionalUsersTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicApplePayPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicApplePayPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicBigformArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBigformDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicBigformDataSandboxHubspotFormIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicBigformPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicBillsCalculatorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicBillsStatusArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsStatusDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicBillsTrackerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicBillsTrackerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCalendlyPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCalendlyPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCardCreationFunnelArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCardCreationFunnelDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCareersPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCareersPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCarouselArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCarouselDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCashbackCalculatorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCashbackCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicComaprisonTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicComparisonTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCookieBannerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCookieCategoryArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCookieManagerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieManagerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCookieSegmentArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieSegmentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCookieSettingsPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCookieSettingsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCopyExperimentArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCustomerCaseArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCustomerLogosArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerLogosDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCustomerStoriesSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomerStoriesSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCustomersLogosSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomersLogosSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicCustomersPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicCustomersPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicDemoPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicDemoPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicDemoPageDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicDemoPageDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicDemoPageDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicDemoPageDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicDisallowedEmailsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicDisallowedEmailsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicEbookDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicEbookDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookDetailsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookDetailsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookMarketingDownloadArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookMarketingDownloadDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbookMarketingPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbookMarketingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEbooksIndexArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEbooksIndexDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEmbedTypeArgs = {
    aspectRatio: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    height: InputMaybe<StringQueryOperatorInput>
    html: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    width: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEventArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEventBigformPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicEventFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicEventFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExpensePolicyBuilderArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExpensePolicyBuilderDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExpensePolicyBuilderDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExpensePolicyBuilderDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExpensePolicyBuilderDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExpenseReportGeneratorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExpenseReportGeneratorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExperimentalLandingPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExperimentalLandingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExploreProductArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicExploreProductDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExploreProductDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExploreProductDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicExploreProductDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicExploreProductDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFaqPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFaqPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFeatureBlockArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureBlockDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFeatureBlockGroupArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureBlockGroupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFeatureIconCardArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureIconCardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFeatureIconCardsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFeatureIconCardsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFetchPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFetchPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFincirclePageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFincirclePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFlexBenefitsPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFlexBenefitsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFooterArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFooterDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFooterSignupArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFooterSignupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFormConsentArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicFormConsentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicFormConsentDataSubscriptionTypeProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    subscriptionId: InputMaybe<IntQueryOperatorInput>
}

export type QueryPrismicFormConsentDataSubscriptionTypeStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    subscriptionId: InputMaybe<IntQueryOperatorInput>
}

export type QueryPrismicGettingStartedExperienceArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicGettingStartedExperienceDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicGettingStartedExperienceDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicGettingStartedExperienceDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicGlobalStringsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicGlobalStringsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderDropdownArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderDropdownColumnArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownColumnDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderDropdownCtaArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderDropdownCtaDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderV2Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeaderV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeaderV2DropdownArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeroTabArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHeroTabDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeroTabDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHeroTabDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHeroTabDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHeroTabDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHomepageV4Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHomepageV4DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHomepageV4DataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHowItWorksPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHowItWorksPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHubspotGlobalFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHubspotGlobalFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHubspotGlobalFormDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHubspotGlobalFormDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicHubspotGlobalFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicHubspotReferralFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicHubspotReferralFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicIntegrationArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicIntegrationPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicIntegrationsFeatureBlockArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationsFeatureBlockDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicIntegrationsIndexPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicIntegrationsIndexPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceGeneratorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceGeneratorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceGeneratorDataGetYourInvoiceModalFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceTemplateFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoiceTemplateFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceTemplateFormDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoiceTemplateFormDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicInvoiceTemplateFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicInvoicesApprovalsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicInvoicesApprovalsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicJobListingArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicJobListingDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicJobPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicJobPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLearnMoreCardArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLearnMoreCardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalDocumentArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalDocumentsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalDocumentsDirectoryArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalDocumentsDirectoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalPageCookiePolicyArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageCookiePolicyDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalPageDsrArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageDsrDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalPageGdprArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageGdprDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLegalPageThirdPartyLicencesArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLegalPageThirdPartyLicencesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicLinkTestArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicLinkTestDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicMeetingBookerPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicMeetingBookerPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicNotFoundPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicNotFoundPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicNotificationBannerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicNotificationBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandResourceCategoryArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourceCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandResourceFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourceFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandResourceFormDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandResourceFormDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicOnDemandResourceFormDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandResourcePageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandResourcePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandWebinarDetailPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandWebinarDetailPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicOnDemandWebinarFormArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicOnDemandWebinarFormDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerBigformArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerBigformDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerBigformPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerBigformPageDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerBigformPageDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPartnerBigformPageDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnerSignupBannerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnerSignupBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnersProgrammeTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnersProgrammeTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnershipCaseArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnershipTierArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPartnershipTiersArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPartnershipTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPerkArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPerkDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPerksInternalPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPerksInternalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPleoEventArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPleoEventDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPleoPartnerTierArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPleoPartnerTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPocketPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPocketPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPodcastFormPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPodcastFormPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPreLaunchFormPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPreLaunchFormPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingComparisonTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingPageV2Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPageV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingPlanPickerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingPlanPickerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingPlanPickerDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingPlanPickerDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingPlanPickerDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTableV2Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTableV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTierArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTiersArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTiersDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTiersDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingTiersV2Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingTiersV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV2Args = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV2DataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV3ComparisonTableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3ComparisonTableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV3PageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3PageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicPricingV3PageDataBodyHighlightsSignupPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicPricingV3PricingTierArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3PricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV3PricingTierFeatureListArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicPricingV3TierPricingModelArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicPricingV3TierPricingModelDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicProofPointBadgesArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicProofPointBadgesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicProofPointBadgesRepeatableArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicProofPointBadgesRepeatableDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRatingArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRatingDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRatingsGroupArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRatingsGroupDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicResourceDetailPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicResourceDetailPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRoiCalculatorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRoiCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRoiCalculatorDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRoiCalculatorDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicRoiCalculatorDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRoicPreviewArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicRoicPreviewDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicRytisEbookDetailsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryHomepageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryHomepageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSecondaryHomepageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryLegalDocumentsArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryLegalDocumentsDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryLegalPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryLegalPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryNotFoundPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryNotFoundPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryPricingPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryPricingTierArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingTierDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryPricingTiersArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSecondaryPricingTiersDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryPricingTiersDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSecondaryPricingTiersDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSecondaryPricingTiersDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSeoArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSeoDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignUpModalArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignUpModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignUpModalDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicSignUpModalDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicSignupBannerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupBannerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupBannerDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupBannerDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupBannerDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupBannerDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupFunnelExperimentArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupFunnelExperimentDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupModalArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupModalDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicSignupModalDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QueryPrismicSignupPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupReasonArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupReasonDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupWizardArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupWizardDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupmodalArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSignupmodalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupmodalDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupmodalDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSignupmodalDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSignupmodalDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSkillEvaluationToolArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSkillEvaluationToolDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSlicePageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicSlicePageDataBodyBackgroundMediaHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodyHubspotHeroFormPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicSlicePageDataBodySignUpHeroPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSocialProofIndicatorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofIndicatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSocialProofLogosExtendedSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofLogosExtendedSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSocialProofLogosSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofLogosSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSocialProofRatingsSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSocialProofRatingsSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicStarterBigformPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicStarterBigformPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicStatisticsSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicStatisticsSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSubscriptionsPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSubscriptionsPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSyncedIntegrationArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSyncedIntegrationDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSyncedIntegrationDataEndymionAppIntegrationTypeArgs = {
    category: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    initiationUrl: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
    slug: InputMaybe<StringQueryOperatorInput>
    status: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicSyncedIntegrationsCategoriesArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicSyncedIntegrationsCategoriesDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTemplateCustomerCaseArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTemplateCustomerCaseDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplateCustomerCaseDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicTemplatePartnerArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTemplatePartnerDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeArgs =
    {
        children: InputMaybe<NodeFilterListInput>
        consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormProductionIntegrationTypeConsentsFilterInput>
        formId: InputMaybe<StringQueryOperatorInput>
        id: InputMaybe<StringQueryOperatorInput>
        internal: InputMaybe<InternalFilterInput>
        parent: InputMaybe<NodeFilterInput>
        prismicId: InputMaybe<StringQueryOperatorInput>
    }

export type QueryPrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicTemplatePartnerDataBodyGetStartedPrimaryFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTestAaaArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTestimonialArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTestimonialDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicThirdPartyLicencesSectionArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicThirdPartyLicencesSectionDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTypePathTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    kind: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    path: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicTypeformSurveysArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicTypeformSurveysDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicUnifiedSignupModalArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicUnifiedSignupModalDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicUnifiedSignupModalDataFormProductionIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormProductionIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicUnifiedSignupModalDataFormStagingIntegrationTypeArgs = {
    children: InputMaybe<NodeFilterListInput>
    consents: InputMaybe<PrismicUnifiedSignupModalDataFormStagingIntegrationTypeConsentsFilterInput>
    formId: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicVatCalculatorArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicVatCalculatorDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicWebinarCategoryArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWebinarCategoryDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicWhyPleoPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWhyPleoPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QueryPrismicWistaChannelPageArgs = {
    _previewable: InputMaybe<IdQueryOperatorInput>
    alternate_languages: InputMaybe<PrismicAlternateLanguageTypeFilterListInput>
    children: InputMaybe<NodeFilterListInput>
    data: InputMaybe<PrismicWistaChannelPageDataTypeFilterInput>
    dataRaw: InputMaybe<JsonQueryOperatorInput>
    first_publication_date: InputMaybe<DateQueryOperatorInput>
    href: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    lang: InputMaybe<StringQueryOperatorInput>
    last_publication_date: InputMaybe<DateQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    prismicId: InputMaybe<IdQueryOperatorInput>
    tags: InputMaybe<StringQueryOperatorInput>
    type: InputMaybe<StringQueryOperatorInput>
    uid: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type QuerySiteArgs = {
    buildTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    graphqlTypegen: InputMaybe<BooleanQueryOperatorInput>
    host: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    jsxRuntime: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pathPrefix: InputMaybe<StringQueryOperatorInput>
    polyfill: InputMaybe<BooleanQueryOperatorInput>
    port: InputMaybe<IntQueryOperatorInput>
    proxy: InputMaybe<SiteProxyFilterListInput>
    siteMetadata: InputMaybe<SiteSiteMetadataFilterInput>
    trailingSlash: InputMaybe<StringQueryOperatorInput>
}

export type QuerySiteBuildMetadataArgs = {
    buildTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type QuerySiteFunctionArgs = {
    absoluteCompiledFilePath: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    functionRoute: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    matchPath: InputMaybe<StringQueryOperatorInput>
    originalAbsoluteFilePath: InputMaybe<StringQueryOperatorInput>
    originalRelativeFilePath: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pluginName: InputMaybe<StringQueryOperatorInput>
    relativeCompiledFilePath: InputMaybe<StringQueryOperatorInput>
}

export type QuerySitePageArgs = {
    children: InputMaybe<NodeFilterListInput>
    component: InputMaybe<StringQueryOperatorInput>
    componentChunkName: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    internalComponentName: InputMaybe<StringQueryOperatorInput>
    matchPath: InputMaybe<StringQueryOperatorInput>
    pageContext: InputMaybe<JsonQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    path: InputMaybe<StringQueryOperatorInput>
    pluginCreator: InputMaybe<SitePluginFilterInput>
}

export type QuerySitePluginArgs = {
    browserAPIs: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    name: InputMaybe<StringQueryOperatorInput>
    nodeAPIs: InputMaybe<StringQueryOperatorInput>
    packageJson: InputMaybe<JsonQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pluginFilepath: InputMaybe<StringQueryOperatorInput>
    pluginOptions: InputMaybe<JsonQueryOperatorInput>
    resolve: InputMaybe<StringQueryOperatorInput>
    ssrAPIs: InputMaybe<StringQueryOperatorInput>
    version: InputMaybe<StringQueryOperatorInput>
}

export type Site = Node & {
    buildTime: Maybe<Scalars['Date']['output']>
    children: Array<Node>
    graphqlTypegen: Maybe<Scalars['Boolean']['output']>
    host: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    internal: Internal
    jsxRuntime: Maybe<Scalars['String']['output']>
    parent: Maybe<Node>
    pathPrefix: Maybe<Scalars['String']['output']>
    polyfill: Maybe<Scalars['Boolean']['output']>
    port: Maybe<Scalars['Int']['output']>
    proxy: Maybe<Array<Maybe<SiteProxy>>>
    siteMetadata: Maybe<SiteSiteMetadata>
    trailingSlash: Maybe<Scalars['String']['output']>
}

export type SiteBuildTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type SiteBuildMetadata = Node & {
    buildTime: Maybe<Scalars['Date']['output']>
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    parent: Maybe<Node>
}

export type SiteBuildMetadataBuildTimeArgs = {
    difference: InputMaybe<Scalars['String']['input']>
    formatString: InputMaybe<Scalars['String']['input']>
    fromNow: InputMaybe<Scalars['Boolean']['input']>
    locale: InputMaybe<Scalars['String']['input']>
}

export type SiteBuildMetadataConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteBuildMetadataEdge>
    group: Array<SiteBuildMetadataGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SiteBuildMetadata>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteBuildMetadataConnectionDistinctArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataConnectionGroupArgs = {
    field: SiteBuildMetadataFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteBuildMetadataConnectionMaxArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataConnectionMinArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataConnectionSumArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataEdge = {
    next: Maybe<SiteBuildMetadata>
    node: SiteBuildMetadata
    previous: Maybe<SiteBuildMetadata>
}

export type SiteBuildMetadataFieldSelector = {
    buildTime: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    parent: InputMaybe<NodeFieldSelector>
}

export type SiteBuildMetadataFilterInput = {
    buildTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    parent: InputMaybe<NodeFilterInput>
}

export type SiteBuildMetadataGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteBuildMetadataEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<SiteBuildMetadataGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SiteBuildMetadata>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteBuildMetadataGroupConnectionDistinctArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataGroupConnectionGroupArgs = {
    field: SiteBuildMetadataFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteBuildMetadataGroupConnectionMaxArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataGroupConnectionMinArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataGroupConnectionSumArgs = {
    field: SiteBuildMetadataFieldSelector
}

export type SiteBuildMetadataSortInput = {
    buildTime: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    parent: InputMaybe<NodeSortInput>
}

export type SiteConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteEdge>
    group: Array<SiteGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<Site>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteConnectionDistinctArgs = {
    field: SiteFieldSelector
}

export type SiteConnectionGroupArgs = {
    field: SiteFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteConnectionMaxArgs = {
    field: SiteFieldSelector
}

export type SiteConnectionMinArgs = {
    field: SiteFieldSelector
}

export type SiteConnectionSumArgs = {
    field: SiteFieldSelector
}

export type SiteEdge = {
    next: Maybe<Site>
    node: Site
    previous: Maybe<Site>
}

export type SiteFieldSelector = {
    buildTime: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    graphqlTypegen: InputMaybe<FieldSelectorEnum>
    host: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    jsxRuntime: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    pathPrefix: InputMaybe<FieldSelectorEnum>
    polyfill: InputMaybe<FieldSelectorEnum>
    port: InputMaybe<FieldSelectorEnum>
    proxy: InputMaybe<SiteProxyFieldSelector>
    siteMetadata: InputMaybe<SiteSiteMetadataFieldSelector>
    trailingSlash: InputMaybe<FieldSelectorEnum>
}

export type SiteFilterInput = {
    buildTime: InputMaybe<DateQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    graphqlTypegen: InputMaybe<BooleanQueryOperatorInput>
    host: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    jsxRuntime: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pathPrefix: InputMaybe<StringQueryOperatorInput>
    polyfill: InputMaybe<BooleanQueryOperatorInput>
    port: InputMaybe<IntQueryOperatorInput>
    proxy: InputMaybe<SiteProxyFilterListInput>
    siteMetadata: InputMaybe<SiteSiteMetadataFilterInput>
    trailingSlash: InputMaybe<StringQueryOperatorInput>
}

export type SiteFunction = Node & {
    absoluteCompiledFilePath: Scalars['String']['output']
    children: Array<Node>
    functionRoute: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    matchPath: Maybe<Scalars['String']['output']>
    originalAbsoluteFilePath: Scalars['String']['output']
    originalRelativeFilePath: Scalars['String']['output']
    parent: Maybe<Node>
    pluginName: Scalars['String']['output']
    relativeCompiledFilePath: Scalars['String']['output']
}

export type SiteFunctionConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteFunctionEdge>
    group: Array<SiteFunctionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SiteFunction>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteFunctionConnectionDistinctArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionConnectionGroupArgs = {
    field: SiteFunctionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteFunctionConnectionMaxArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionConnectionMinArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionConnectionSumArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionEdge = {
    next: Maybe<SiteFunction>
    node: SiteFunction
    previous: Maybe<SiteFunction>
}

export type SiteFunctionFieldSelector = {
    absoluteCompiledFilePath: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    functionRoute: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    matchPath: InputMaybe<FieldSelectorEnum>
    originalAbsoluteFilePath: InputMaybe<FieldSelectorEnum>
    originalRelativeFilePath: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    pluginName: InputMaybe<FieldSelectorEnum>
    relativeCompiledFilePath: InputMaybe<FieldSelectorEnum>
}

export type SiteFunctionFilterInput = {
    absoluteCompiledFilePath: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    functionRoute: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    matchPath: InputMaybe<StringQueryOperatorInput>
    originalAbsoluteFilePath: InputMaybe<StringQueryOperatorInput>
    originalRelativeFilePath: InputMaybe<StringQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pluginName: InputMaybe<StringQueryOperatorInput>
    relativeCompiledFilePath: InputMaybe<StringQueryOperatorInput>
}

export type SiteFunctionGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteFunctionEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<SiteFunctionGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SiteFunction>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteFunctionGroupConnectionDistinctArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionGroupConnectionGroupArgs = {
    field: SiteFunctionFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteFunctionGroupConnectionMaxArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionGroupConnectionMinArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionGroupConnectionSumArgs = {
    field: SiteFunctionFieldSelector
}

export type SiteFunctionSortInput = {
    absoluteCompiledFilePath: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    functionRoute: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    matchPath: InputMaybe<SortOrderEnum>
    originalAbsoluteFilePath: InputMaybe<SortOrderEnum>
    originalRelativeFilePath: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    pluginName: InputMaybe<SortOrderEnum>
    relativeCompiledFilePath: InputMaybe<SortOrderEnum>
}

export type SiteGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SiteEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<SiteGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<Site>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SiteGroupConnectionDistinctArgs = {
    field: SiteFieldSelector
}

export type SiteGroupConnectionGroupArgs = {
    field: SiteFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SiteGroupConnectionMaxArgs = {
    field: SiteFieldSelector
}

export type SiteGroupConnectionMinArgs = {
    field: SiteFieldSelector
}

export type SiteGroupConnectionSumArgs = {
    field: SiteFieldSelector
}

export type SitePage = Node & {
    children: Array<Node>
    component: Scalars['String']['output']
    componentChunkName: Scalars['String']['output']
    id: Scalars['ID']['output']
    internal: Internal
    internalComponentName: Scalars['String']['output']
    matchPath: Maybe<Scalars['String']['output']>
    pageContext: Maybe<Scalars['JSON']['output']>
    parent: Maybe<Node>
    path: Scalars['String']['output']
    pluginCreator: Maybe<SitePlugin>
}

export type SitePageConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SitePageEdge>
    group: Array<SitePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SitePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SitePageConnectionDistinctArgs = {
    field: SitePageFieldSelector
}

export type SitePageConnectionGroupArgs = {
    field: SitePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SitePageConnectionMaxArgs = {
    field: SitePageFieldSelector
}

export type SitePageConnectionMinArgs = {
    field: SitePageFieldSelector
}

export type SitePageConnectionSumArgs = {
    field: SitePageFieldSelector
}

export type SitePageEdge = {
    next: Maybe<SitePage>
    node: SitePage
    previous: Maybe<SitePage>
}

export type SitePageFieldSelector = {
    children: InputMaybe<NodeFieldSelector>
    component: InputMaybe<FieldSelectorEnum>
    componentChunkName: InputMaybe<FieldSelectorEnum>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    internalComponentName: InputMaybe<FieldSelectorEnum>
    matchPath: InputMaybe<FieldSelectorEnum>
    pageContext: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    path: InputMaybe<FieldSelectorEnum>
    pluginCreator: InputMaybe<SitePluginFieldSelector>
}

export type SitePageFilterInput = {
    children: InputMaybe<NodeFilterListInput>
    component: InputMaybe<StringQueryOperatorInput>
    componentChunkName: InputMaybe<StringQueryOperatorInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    internalComponentName: InputMaybe<StringQueryOperatorInput>
    matchPath: InputMaybe<StringQueryOperatorInput>
    pageContext: InputMaybe<JsonQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    path: InputMaybe<StringQueryOperatorInput>
    pluginCreator: InputMaybe<SitePluginFilterInput>
}

export type SitePageGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SitePageEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<SitePageGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SitePage>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SitePageGroupConnectionDistinctArgs = {
    field: SitePageFieldSelector
}

export type SitePageGroupConnectionGroupArgs = {
    field: SitePageFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SitePageGroupConnectionMaxArgs = {
    field: SitePageFieldSelector
}

export type SitePageGroupConnectionMinArgs = {
    field: SitePageFieldSelector
}

export type SitePageGroupConnectionSumArgs = {
    field: SitePageFieldSelector
}

export type SitePageSortInput = {
    children: InputMaybe<NodeSortInput>
    component: InputMaybe<SortOrderEnum>
    componentChunkName: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    internalComponentName: InputMaybe<SortOrderEnum>
    matchPath: InputMaybe<SortOrderEnum>
    pageContext: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    path: InputMaybe<SortOrderEnum>
    pluginCreator: InputMaybe<SitePluginSortInput>
}

export type SitePlugin = Node & {
    browserAPIs: Maybe<Array<Maybe<Scalars['String']['output']>>>
    children: Array<Node>
    id: Scalars['ID']['output']
    internal: Internal
    name: Maybe<Scalars['String']['output']>
    nodeAPIs: Maybe<Array<Maybe<Scalars['String']['output']>>>
    packageJson: Maybe<Scalars['JSON']['output']>
    parent: Maybe<Node>
    pluginFilepath: Maybe<Scalars['String']['output']>
    pluginOptions: Maybe<Scalars['JSON']['output']>
    resolve: Maybe<Scalars['String']['output']>
    ssrAPIs: Maybe<Array<Maybe<Scalars['String']['output']>>>
    version: Maybe<Scalars['String']['output']>
}

export type SitePluginConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SitePluginEdge>
    group: Array<SitePluginGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SitePlugin>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SitePluginConnectionDistinctArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginConnectionGroupArgs = {
    field: SitePluginFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SitePluginConnectionMaxArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginConnectionMinArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginConnectionSumArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginEdge = {
    next: Maybe<SitePlugin>
    node: SitePlugin
    previous: Maybe<SitePlugin>
}

export type SitePluginFieldSelector = {
    browserAPIs: InputMaybe<FieldSelectorEnum>
    children: InputMaybe<NodeFieldSelector>
    id: InputMaybe<FieldSelectorEnum>
    internal: InputMaybe<InternalFieldSelector>
    name: InputMaybe<FieldSelectorEnum>
    nodeAPIs: InputMaybe<FieldSelectorEnum>
    packageJson: InputMaybe<FieldSelectorEnum>
    parent: InputMaybe<NodeFieldSelector>
    pluginFilepath: InputMaybe<FieldSelectorEnum>
    pluginOptions: InputMaybe<FieldSelectorEnum>
    resolve: InputMaybe<FieldSelectorEnum>
    ssrAPIs: InputMaybe<FieldSelectorEnum>
    version: InputMaybe<FieldSelectorEnum>
}

export type SitePluginFilterInput = {
    browserAPIs: InputMaybe<StringQueryOperatorInput>
    children: InputMaybe<NodeFilterListInput>
    id: InputMaybe<StringQueryOperatorInput>
    internal: InputMaybe<InternalFilterInput>
    name: InputMaybe<StringQueryOperatorInput>
    nodeAPIs: InputMaybe<StringQueryOperatorInput>
    packageJson: InputMaybe<JsonQueryOperatorInput>
    parent: InputMaybe<NodeFilterInput>
    pluginFilepath: InputMaybe<StringQueryOperatorInput>
    pluginOptions: InputMaybe<JsonQueryOperatorInput>
    resolve: InputMaybe<StringQueryOperatorInput>
    ssrAPIs: InputMaybe<StringQueryOperatorInput>
    version: InputMaybe<StringQueryOperatorInput>
}

export type SitePluginGroupConnection = {
    distinct: Array<Scalars['String']['output']>
    edges: Array<SitePluginEdge>
    field: Scalars['String']['output']
    fieldValue: Maybe<Scalars['String']['output']>
    group: Array<SitePluginGroupConnection>
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
    nodes: Array<SitePlugin>
    pageInfo: PageInfo
    sum: Maybe<Scalars['Float']['output']>
    totalCount: Scalars['Int']['output']
}

export type SitePluginGroupConnectionDistinctArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginGroupConnectionGroupArgs = {
    field: SitePluginFieldSelector
    limit: InputMaybe<Scalars['Int']['input']>
    skip: InputMaybe<Scalars['Int']['input']>
}

export type SitePluginGroupConnectionMaxArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginGroupConnectionMinArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginGroupConnectionSumArgs = {
    field: SitePluginFieldSelector
}

export type SitePluginSortInput = {
    browserAPIs: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    name: InputMaybe<SortOrderEnum>
    nodeAPIs: InputMaybe<SortOrderEnum>
    packageJson: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    pluginFilepath: InputMaybe<SortOrderEnum>
    pluginOptions: InputMaybe<SortOrderEnum>
    resolve: InputMaybe<SortOrderEnum>
    ssrAPIs: InputMaybe<SortOrderEnum>
    version: InputMaybe<SortOrderEnum>
}

export type SiteProxy = {
    prefix: Maybe<Scalars['String']['output']>
    url: Maybe<Scalars['String']['output']>
}

export type SiteProxyFieldSelector = {
    prefix: InputMaybe<FieldSelectorEnum>
    url: InputMaybe<FieldSelectorEnum>
}

export type SiteProxyFilterInput = {
    prefix: InputMaybe<StringQueryOperatorInput>
    url: InputMaybe<StringQueryOperatorInput>
}

export type SiteProxyFilterListInput = {
    elemMatch: InputMaybe<SiteProxyFilterInput>
}

export type SiteProxySortInput = {
    prefix: InputMaybe<SortOrderEnum>
    url: InputMaybe<SortOrderEnum>
}

export type SiteSiteMetadata = {
    description: Maybe<Scalars['String']['output']>
    siteName: Maybe<Scalars['String']['output']>
    siteUrl: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type SiteSiteMetadataFieldSelector = {
    description: InputMaybe<FieldSelectorEnum>
    siteName: InputMaybe<FieldSelectorEnum>
    siteUrl: InputMaybe<FieldSelectorEnum>
    title: InputMaybe<FieldSelectorEnum>
}

export type SiteSiteMetadataFilterInput = {
    description: InputMaybe<StringQueryOperatorInput>
    siteName: InputMaybe<StringQueryOperatorInput>
    siteUrl: InputMaybe<StringQueryOperatorInput>
    title: InputMaybe<StringQueryOperatorInput>
}

export type SiteSiteMetadataSortInput = {
    description: InputMaybe<SortOrderEnum>
    siteName: InputMaybe<SortOrderEnum>
    siteUrl: InputMaybe<SortOrderEnum>
    title: InputMaybe<SortOrderEnum>
}

export type SiteSortInput = {
    buildTime: InputMaybe<SortOrderEnum>
    children: InputMaybe<NodeSortInput>
    graphqlTypegen: InputMaybe<SortOrderEnum>
    host: InputMaybe<SortOrderEnum>
    id: InputMaybe<SortOrderEnum>
    internal: InputMaybe<InternalSortInput>
    jsxRuntime: InputMaybe<SortOrderEnum>
    parent: InputMaybe<NodeSortInput>
    pathPrefix: InputMaybe<SortOrderEnum>
    polyfill: InputMaybe<SortOrderEnum>
    port: InputMaybe<SortOrderEnum>
    proxy: InputMaybe<SiteProxySortInput>
    siteMetadata: InputMaybe<SiteSiteMetadataSortInput>
    trailingSlash: InputMaybe<SortOrderEnum>
}

export enum SortOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}

export type StringQueryOperatorInput = {
    eq: InputMaybe<Scalars['String']['input']>
    glob: InputMaybe<Scalars['String']['input']>
    in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    ne: InputMaybe<Scalars['String']['input']>
    nin: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
    regex: InputMaybe<Scalars['String']['input']>
}

export type FooterQueryVariables = Exact<{[key: string]: never}>

export type FooterQuery = {
    allPrismicFooter: {
        nodes: Array<{
            lang: string
            data: {
                entity: string
                terms_body: string
                copyright_text: string
                financial_partner_copyright_text: string
                contact_us: string
                sales_email: string
                info_email: string
                support_email: string
                product_heading: string
                resources_heading: string
                company_heading: string
                legal_heading: string
                solutions_heading: string
                partnerships_heading: string
                address: {richText: any}
                financial_partner_terms_text: {richText: any}
                product_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                resources_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                company_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                legal_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                solutions_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                partnerships_links: Array<{
                    text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type HeaderQueryVariables = Exact<{[key: string]: never}>

export type HeaderQuery = {
    allPrismicHeader: {nodes: Array<{lang: string; data: {start_free_trial: string}}>}
    allPrismicHeaderV2: {
        nodes: Array<{
            lang: string
            data: {
                logInText: string
                secondaryCtaText: string
                noResultsText: string
                secondaryCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                items: Array<{
                    label: string
                    hide_on: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    dropdown: {
                        document:
                            | {
                                  data: {
                                      body: Array<{
                                          primary: {label: string}
                                          items: Array<{
                                              text: string
                                              sub_text: string
                                              link: {
                                                  link_type: PrismicLinkTypeEnum
                                                  uid: string
                                                  type: string
                                                  lang: string
                                                  target: string
                                                  url: string
                                              }
                                          }>
                                      }>
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
            }
        }>
    }
}

export type HubspotGlobalFormFragment = {
    __typename: 'PrismicHubspotGlobalForm'
    data: {
        heading: string
        body: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        imperative_consents_production: Array<{
            consent: {
                document:
                    | {
                          _previewable: string
                          lang: string
                          data: {
                              type: string
                              isDefault: boolean
                              subscriptionTypeStaging: {subscriptionId: number}
                              subscriptionTypeProduction: {subscriptionId: number}
                              text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }>
        imperative_consents_staging: Array<{
            consent: {
                document:
                    | {
                          _previewable: string
                          lang: string
                          data: {
                              type: string
                              isDefault: boolean
                              subscriptionTypeStaging: {subscriptionId: number}
                              subscriptionTypeProduction: {subscriptionId: number}
                              text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }>
    }
}

export type PricingFragment = {
    lang: string
    data: {
        show_ctas: boolean
        slider_label: string
        slider_tooltip_text: string
        billing_monthly_label_v2: string
        billing_yearly_label_v2: string
        title_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        billing_cycle: Array<{
            billed_monthly_label: string
            billed_yearly_label: string
            description: string
            legend: string
        }>
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        signup_modal_free: Array<{
            title: string
            subtitle: string
            highlighted_feature_1: string
            highlighted_feature_2: string
            highlighted_feature_3: string
            image: {fluid: {base64: string}}
        }>
        signup_modal_pro: Array<{
            title: string
            subtitle: string
            highlighted_feature_1: string
            highlighted_feature_2: string
            highlighted_feature_3: string
            image: {fluid: {base64: string}}
        }>
        slider_sub_text: {richText: any}
        pricing_tiers: Array<{
            pricing_tier: {
                document:
                    | {
                          data: {
                              name: string
                              per_month_text: string
                              cost_subtext: string
                              excerpt: string
                              cta_text: string
                              features_title: string
                              annual_cost: string
                              monthly_cost: string
                              monthly_billing_screen_reader_alt: string
                              annual_billing_screen_reader_alt: string
                              monthly_cost_subtext_extra: string
                              annual_cost_subtext_extra: string
                              footnote: string
                              second_footnote: string
                              monthly_billed_cost: number
                              annually_billed_cost: number
                              monthly_billed_user_cost: number
                              annually_billed_user_cost: number
                              cta_variant: string
                              free_users_included: number
                              features: Array<{
                                  feature: string
                                  disabled_monthly: boolean
                                  is_highlighted: boolean
                                  tooltip_text: string
                              }>
                              cashback_text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }>
    }
}

export type PricingTiersFragmentFragment = {
    lang: string
    data: {
        pricing_tiers: Array<{
            pricing_tier: {
                document:
                    | {
                          data: {
                              name: string
                              per_month_text: string
                              cost_subtext: string
                              excerpt: string
                              cta_text: string
                              features_title: string
                              annual_cost: string
                              monthly_cost: string
                              monthly_billing_screen_reader_alt: string
                              annual_billing_screen_reader_alt: string
                              monthly_cost_subtext_extra: string
                              annual_cost_subtext_extra: string
                              footnote: string
                              second_footnote: string
                              monthly_billed_cost: number
                              annually_billed_cost: number
                              monthly_billed_user_cost: number
                              annually_billed_user_cost: number
                              cta_variant: string
                              free_users_included: number
                              features: Array<{
                                  feature: string
                                  disabled_monthly: boolean
                                  is_highlighted: boolean
                                  tooltip_text: string
                              }>
                              cashback_text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }>
    }
}

export type SecondaryPricingFragment = {
    lang: string
    data: {
        locale_code: string
        show_ctas: boolean
        slider_label: string
        slider_tooltip_text: string
        billing_monthly_label_v2: string
        billing_yearly_label_v2: string
        title_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        billing_cycle: Array<{
            billed_monthly_label: string
            billed_yearly_label: string
            description: string
            legend: string
        }>
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        signup_modal_free: Array<{
            title: string
            subtitle: string
            highlighted_feature_1: string
            highlighted_feature_2: string
            highlighted_feature_3: string
            image: {fluid: {base64: string}}
        }>
        signup_modal_pro: Array<{
            title: string
            subtitle: string
            highlighted_feature_1: string
            highlighted_feature_2: string
            highlighted_feature_3: string
            image: {fluid: {base64: string}}
        }>
        slider_sub_text: {richText: any}
        pricing_tiers: Array<{
            pricing_tier: {
                document:
                    | {
                          data: {
                              name: string
                              per_month_text: string
                              cost_subtext: string
                              excerpt: string
                              cta_text: string
                              features_title: string
                              annual_cost: string
                              monthly_cost: string
                              monthly_billing_screen_reader_alt: string
                              annual_billing_screen_reader_alt: string
                              monthly_cost_subtext_extra: string
                              annual_cost_subtext_extra: string
                              footnote: string
                              second_footnote: string
                              monthly_billed_cost: number
                              annually_billed_cost: number
                              monthly_billed_user_cost: number
                              annually_billed_user_cost: number
                              cta_variant: string
                              free_users_included: number
                              features: Array<{
                                  feature: string
                                  disabled_monthly: boolean
                                  is_highlighted: boolean
                                  tooltip_text: string
                              }>
                              cashback_text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }>
    }
}

export type SeoQueryVariables = Exact<{[key: string]: never}>

export type SeoQuery = {
    site: {siteMetadata: {siteName: string}}
    allPrismicSeo: {
        nodes: Array<{
            lang: string
            data: {title: string; description: string; defaultOpenGraphImage: {url: string}}
        }>
    }
}

export type DefaultSignupModalQueryVariables = Exact<{[key: string]: never}>

export type DefaultSignupModalQuery = {
    allPrismicSignupmodal: {
        nodes: Array<{
            lang: string
            data: {
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                signup_modal: Array<{
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    title: string
                    subtitle: string
                    partner_title: string
                    partner_subtitle: string
                    image: {fluid: {base64: string}}
                }>
            }
        }>
    }
}

export type UnifiedSignupModalQueryVariables = Exact<{[key: string]: never}>

export type UnifiedSignupModalQuery = {
    allPrismicUnifiedSignupModal: {
        nodes: Array<{
            lang: string
            data: {
                title: string
                subtitle: string
                placeholder: string
                ariaLabel: string
                submitText: string
                errorText: string
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                highlightItems: Array<{
                    text: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        gatsbyImageData: any
                        dimensions: {height: number; width: number}
                    }
                }>
                body: Array<
                    | {
                          __typename: 'PrismicUnifiedSignupModalDataBodyCroppedImage'
                          primary: {
                              text: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  gatsbyImageData: any
                                  dimensions: {height: number; width: number}
                              }
                          }
                      }
                    | {
                          __typename: 'PrismicUnifiedSignupModalDataBodySocialProof'
                          items: Array<{
                              quote: string
                              full_name: string
                              person_byline: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  gatsbyImageData: any
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                >
            }
        }>
    }
}

export type UnifiedSignupModalCroppedImageFragment = {
    __typename: 'PrismicUnifiedSignupModalDataBodyCroppedImage'
    primary: {
        text: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type UnifiedSignupModalSocialProofFragment = {
    __typename: 'PrismicUnifiedSignupModalDataBodySocialProof'
    items: Array<{
        quote: string
        full_name: string
        person_byline: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type AllPagesQueryVariables = Exact<{[key: string]: never}>

export type AllPagesQuery = {
    site: {siteMetadata: {siteUrl: string}}
    allSitePage: {nodes: Array<{path: string; pageContext: any}>}
}

export type WrapPageElementQueryVariables = Exact<{[key: string]: never}>

export type WrapPageElementQuery = {
    allPrismicTypeformSurveys: {
        nodes: Array<{
            lang: string
            data: {
                typeform_id: string
                is_staging_only: boolean
                hidden_survey_paths: Array<{path: string}>
            }
        }>
    }
    allPrismicGlobalStrings: {
        nodes: Array<{
            lang: string
            data: {
                close_button_text: string
                visit_website: string
                read_more: string
                learn_more: string
                show_more: string
                watch_now: string
                show_me: string
                all: string
                copied_to_clipboard: string
                something_went_wrong: string
                first_name: string
                last_name: string
                work_email: string
                company_name: string
                company_size: string
                select: string
                phone_number: string
                submit: string
                this_field_is_required: string
                must_be_company_email: string
                sole_trader: string
                employee: string
                employees: string
                your_full_name: string
                your_work_email: string
                please_select_number_of_employees: string
                please_enter_your_work_email: string
                please_enter_a_work_email: string
                sticky_cta_button_text: string
                play: string
                admin: string
                industry: string
                location: string
                days: string
                hours: string
                minutes: string
                back: string
                continue: string
                home: string
                menu: string
                invalid_email_error: string
                loading: string
                play_video: string
                preview: string
                mins_read: string
                min_read: string
                latest_articles: string
                tags: string
                panel: string
                related_posts_text: string
                sequence_posts_text: string
                non_work_email_error_cta_text: string
                non_work_email_error: string
                country: string
                locale_selector_global_label: string
                your_email_label: string
                sign_up: string
                skip_to_content: string
                country_placeholder: string
                discovered_via_label: string
                discovered_via_placeholder: string
                demo_submit_text: string
                other: string
                peer_recommendation: string
                trust_pilot: string
                google_search: string
                youtube: string
                tv: string
                outdoor_advertising: string
                social_media: string
                press: string
                first_name_error: string
                last_name_error: string
                phone_number_error: string
                company_size_error: string
                country_error: string
                has_consented_error: string
                get_started: string
                watch_the_video: string
                file_upload_too_large: string
                file_type: string
                upload_text: string
                your_message: string
                send_message: string
                form_submission_error: string
                num_customers: string
                consents_error: string
                feedback: string
                interest_message_label: string
                contact_sales: string
                back_to_pleo_io: string
                financial_partner_disclaimer: string
                email: string
                address: string
                city: string
                postcode: string
                state: string
                invoice_number: string
                issued_on: string
                due_date: string
                company_logo: string
                currency: string
                free_plan_cost_label: string
                panels: string
                copy_to_clipboard: string
                filter_items: string
                previous: string
                next: string
                slides: string
                labels: string
                recaptcha_and_privacy_terms: {richText: any}
                accept_terms_and_privacy: {richText: any}
                clearbit_credits: {richText: any}
                marketing_emails_consent_text: {richText: any}
                consent_label: {richText: any}
                privacy_consent_text: {richText: any}
            }
        }>
    }
}

export type VideoFragment = {url: string}

export type CustomerLogosFragment = {
    data: {
        title: string
        logos: Array<{
            logo: {
                url: string
                alt: string
                copyright: string
                dimensions: {width: number; height: number}
            }
        }>
    }
}

export type PrismicLinkFragment = {
    link_type: PrismicLinkTypeEnum
    uid: string
    type: string
    lang: string
    target: string
    url: string
}

export type NotificationBannerLinkFragment = {
    document: {data: {banner_content: {richText: any}}} | Record<PropertyKey, never>
}

export type CookieDetailsFragment = {
    data: {
        title: string
        banner_title: string
        description: string
        link_text: string
        toggle_text: string
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        cookies: Array<{
            cookie_id: string
            duration: string
            name: string
            origin: string
            purpose: string
        }>
    }
}

export type ConsentWebsiteFragment = {
    _previewable: string
    lang: string
    data: {
        type: string
        isDefault: boolean
        subscriptionTypeStaging: {subscriptionId: number}
        subscriptionTypeProduction: {subscriptionId: number}
        text: {richText: any}
    }
}

export type PricingTableFragment = {
    _previewable: string
    id: string
    data: {
        category: string
        essential_heading: string
        pro_heading: string
        premium_heading: string
        beyond_heading: string
        rows: Array<{
            feature: string
            feature_tooltip: string
            essential_text: string
            essential: boolean
            pro_text: string
            pro: boolean
            premium_text: string
            premium: boolean
            beyond_text: string
            beyond: boolean
        }>
    }
}

export type PricingComparisonTableFragment = {
    _previewable: string
    id: string
    data: {
        title: string
        features: Array<{
            name: string
            tooltip_description: string
            starter1: boolean
            essential1: boolean
            advanced1: boolean
            beyond1: boolean
            starter_excerpt: string
            essential_excerpt: string
            advanced_excerpt: string
            beyond_excerpt: string
        }>
    }
}

export type FormConsentQueryVariables = Exact<{[key: string]: never}>

export type FormConsentQuery = {
    allPrismicFormConsent: {
        nodes: Array<{
            _previewable: string
            lang: string
            data: {
                type: string
                isDefault: boolean
                subscriptionTypeStaging: {subscriptionId: number}
                subscriptionTypeProduction: {subscriptionId: number}
                text: {richText: any}
            }
        }>
    }
}

export type DisallowedEmailsQueryVariables = Exact<{[key: string]: never}>

export type DisallowedEmailsQuery = {
    allPrismicDisallowedEmails: {
        nodes: Array<{lang: string; data: {emails: Array<{email: string}>}}>
    }
}

export type BigListSliceFragment = {
    __typename: 'PrismicWhyPleoPageDataBodyBigList'
    primary: {background_color: string; description: string}
    items: Array<{
        icon: string
        label: string
        secondary_label: string
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type BillsCalculatorFragment = {
    type: string
    data: {
        section_title: string
        section_description: string
        button_cta_text: string
        num_invoices: Array<{
            label: string
            icon1: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon2: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon3: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }>
        average_time_to_process: Array<{
            label: string
            icon1: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon2: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon3: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }>
        num_of_people_involved: Array<{
            label: string
            icon1: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon2: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            icon3: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }>
        results: Array<{
            results_title: string
            invoices_take: string
            with_pleo_bills: string
            time_saved: string
        }>
    }
}

export type CashbackCalculatorFragment = {
    type: string
    data: {
        title: string
        results_title: string
        results_line_cashback: string
        results_subheading: string
        cta_text: string
        monthly_spend: Array<{
            heading: string
            subheading: string
            low_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            medium_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            high_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }>
        num_of_employees: Array<{
            heading: string
            subheading: string
            low_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            medium_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            high_icon: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }>
    }
}

export type ComparisonTableFragment = {
    __typename: 'PrismicSlicePageDataBodyComparisonTable'
    primary: {
        section_heading: string
        section_subheading: string
        column_1_heading: string
        column_2_heading: string
    }
    items: Array<{heading: string; data_1: string; data_2: string}>
}

export type ComparisonFragment = {
    __typename: 'PrismicSlicePageDataBodyComparison'
    primary: {
        title: string
        cta_label: string
        card_body: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        card_logo: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        comparison_label: string
        item_1_label: string
        item_2_label: string
        item_1_percentage: number
        item_2_percentage: number
    }>
}

export type ContactEmailsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyContactEmails'
    primary: {title: string; body1: string}
    items: Array<{
        contact_title: string
        contact_email: string
        destination_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type ContactHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyContactHero'
    primary: {headline: string}
    items: Array<{
        title: string
        description: string
        cta_text: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type CountdownFragment = {
    __typename: 'PrismicSlicePageDataBodyCountdown'
    primary: {
        description_text: string
        target_date_time: any
        cta_text: string
        headingText: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type FeaturesComparisonTableFragment = {
    type: string
    id: string
    data: {
        title: string
        category: string
        pleo_heading: string
        corporate_cards_heading: string
        expense_software_heading: string
        corporate_cards_expense_software_heading: string
        yes_value: string
        no_value: string
        rows: Array<{
            feature: string
            feature_subtext: string
            pleo: boolean
            corporate_cards: boolean
            expense_software: boolean
            corporate_cards_expense_software: boolean
        }>
    }
}

export type HighlightFragment = {
    __typename: 'PrismicSlicePageDataBodyHighlight'
    primary: {title: string; mirrored: boolean; highlight_color: string}
    items: Array<{
        slide_title: string
        cta_text: string
        tracking_event: string
        slide_body: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }>
}

export type HubspotHeroFormFragment = {
    __typename: 'PrismicSlicePageDataBodyHubspotHeroForm'
    primary: {
        title: string
        variant: string
        form_title: string
        form_submit_text: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        redirect_to: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        text: string
        icon: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type IntegrationOverviewFragment = {
    __typename: 'PrismicSlicePageDataBodyIntegrationOverview'
    primary: {
        title: string
        developers_label: string
        developers: string
        links_label: string
        links: {richText: any}
        copy: {richText: any}
    }
}

export type IntegrationCardsFragment = {
    __typename: 'PrismicSlicePageDataBodyIntegrationCards'
    primary: {title: string; subtitle: string; cta_text: string}
    items: Array<{
        name: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type InvoiceGeneratorFragment = {
    __typename: 'PrismicInvoiceGenerator'
    data: {
        title: string
        your_company_form_title: string
        preview_label: string
        invoice_details: string
        get_invoice_label: string
        recipient_company_form_title: string
        invoice_items_form_title: string
        items_label: string
        price_label: string
        quantity_label: string
        rate_label: string
        total_label: string
        subtotal_label: string
        tax_label: string
        tax_total_label: string
        notes_label: string
        terms_label: string
        add_item_label: string
        invoice_title: string
        get_your_invoice_modal: Array<{
            modal_title: string
            modal_subtitle: string
            modal_image: {fluid: {base64: string}}
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
        }>
        thank_you_modal: Array<{
            modal_title: string
            modal_subtitle: string
            download_pdf_button_text: string
            new_invoice_button_text: string
            modal_image: {fluid: {base64: string}}
        }>
    }
}

export type InvoiceTemplateFormFragment = {
    __typename: 'PrismicInvoiceTemplateForm'
    data: {
        title: string
        description: string
        successMessage: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
    }
}

export type PricingSectionQueryVariables = Exact<{[key: string]: never}>

export type PricingSectionQuery = {
    allPrismicPricingTiers: {
        nodes: Array<{
            lang: string
            data: {
                show_ctas: boolean
                slider_label: string
                slider_tooltip_text: string
                billing_monthly_label_v2: string
                billing_yearly_label_v2: string
                title_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                billing_cycle: Array<{
                    billed_monthly_label: string
                    billed_yearly_label: string
                    description: string
                    legend: string
                }>
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                signup_modal_free: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                signup_modal_pro: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                slider_sub_text: {richText: any}
                pricing_tiers: Array<{
                    pricing_tier: {
                        document:
                            | {
                                  data: {
                                      name: string
                                      per_month_text: string
                                      cost_subtext: string
                                      excerpt: string
                                      cta_text: string
                                      features_title: string
                                      annual_cost: string
                                      monthly_cost: string
                                      monthly_billing_screen_reader_alt: string
                                      annual_billing_screen_reader_alt: string
                                      monthly_cost_subtext_extra: string
                                      annual_cost_subtext_extra: string
                                      footnote: string
                                      second_footnote: string
                                      monthly_billed_cost: number
                                      annually_billed_cost: number
                                      monthly_billed_user_cost: number
                                      annually_billed_user_cost: number
                                      cta_variant: string
                                      free_users_included: number
                                      features: Array<{
                                          feature: string
                                          disabled_monthly: boolean
                                          is_highlighted: boolean
                                          tooltip_text: string
                                      }>
                                      cashback_text: {richText: any}
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
            }
        }>
    }
    allPrismicSecondaryPricingTiers: {
        nodes: Array<{
            lang: string
            data: {
                locale_code: string
                show_ctas: boolean
                slider_label: string
                slider_tooltip_text: string
                billing_monthly_label_v2: string
                billing_yearly_label_v2: string
                title_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                billing_cycle: Array<{
                    billed_monthly_label: string
                    billed_yearly_label: string
                    description: string
                    legend: string
                }>
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                signup_modal_free: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                signup_modal_pro: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                slider_sub_text: {richText: any}
                pricing_tiers: Array<{
                    pricing_tier: {
                        document:
                            | {
                                  data: {
                                      name: string
                                      per_month_text: string
                                      cost_subtext: string
                                      excerpt: string
                                      cta_text: string
                                      features_title: string
                                      annual_cost: string
                                      monthly_cost: string
                                      monthly_billing_screen_reader_alt: string
                                      annual_billing_screen_reader_alt: string
                                      monthly_cost_subtext_extra: string
                                      annual_cost_subtext_extra: string
                                      footnote: string
                                      second_footnote: string
                                      monthly_billed_cost: number
                                      annually_billed_cost: number
                                      monthly_billed_user_cost: number
                                      annually_billed_user_cost: number
                                      cta_variant: string
                                      free_users_included: number
                                      features: Array<{
                                          feature: string
                                          disabled_monthly: boolean
                                          is_highlighted: boolean
                                          tooltip_text: string
                                      }>
                                      cashback_text: {richText: any}
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
            }
        }>
    }
}

export type SignupBannerFragment = {
    _previewable: string
    type: string
    data: {
        title: string
        subtitle: string
        email_input_placeholder: string
        email_input_error_text: string
        submit_text: string
        aria_label: string
        partner_signup_redirect: boolean
        form_name: string
        disclaimer_copy: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {width: number; height: number}
        }
        redirect_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
    }
}

export type TitleWithSideTextFragment = {
    __typename: 'PrismicSlicePageDataBodyTitleWithSideText'
    primary: {
        title: string
        cta_label: string
        copy: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type TwoImageHeroFragment = {
    __typename: 'PrismicSlicePageDataBodyTwoImageHero'
    primary: {
        title: string
        content: string
        cta_text: string
        video_id: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image_left: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        image_right: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        image_button: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type VatCalculatorFragment = {
    __typename: 'PrismicVatCalculator'
    data: {
        title: string
        vat_label: string
        amount_label: string
        add_vat_label: string
        remove_vat_label: string
        total_net_label: string
        total_gross_label: string
        submit_label: string
        results_title: string
        results_vat_added_label: string
        results_vat_removed_label: string
        body: {richText: any}
    }
}

export type AccordionSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyAccordion'
    primary: {headline: string; subheadline: string}
    items: Array<{title: string; itemContent: {richText: any}}>
}

export type BackgroundMediaHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyBackgroundMediaHero'
    primary: {
        title: string
        overlay: string
        leadText: string
        inputPlaceholder: string
        ariaLabel: string
        submitText: string
        inputErrorText: string
        overlayOpacity: string
        preTitleImage: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        backgroundImage: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        background_video_webm: {url: string}
        background_video_mp4: {url: string}
        backgroundVideoPoster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{highlight_item: string}>
}

export type BentoBoxSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyBentoBox'
    primary: {title: string; subtitle: string}
    items: Array<{
        place_on_new_row: boolean
        card_title: string
        card_subtitle: string
        image_alignment: string
        card_image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        video_poster: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }>
}

export type CardGridV2SliceFragment = {
    __typename: 'PrismicSlicePageDataBodyCardGridV2'
    primary: {title: string}
    items: Array<{
        card_title: string
        card_description: string
        card_cta_text: string
        card_image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        card_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type CardGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyCardGrid'
    primary: {
        subtitle: string
        show_more_text: string
        initial_cards_shown: string
        initial_cards_shown_on_mobile: string
        initial_cards_shown_on_desktop: string
        card_cta_text: string
        show_filter: boolean
        layout: string
        background_color: string
        no_padding: boolean
        blockTitle: {richText: any}
    }
    items: Array<{
        title: string
        body: string
        tag_text: string
        tag_color: string
        filterKeywords: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type ComponentPlaceholderSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyComponentPlaceholder'
    primary: {
        component: string
        predefined_component: {
            type: string
            document:
                | {
                      type: string
                      data: {
                          section_title: string
                          section_description: string
                          button_cta_text: string
                          num_invoices: Array<{
                              label: string
                              icon1: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon2: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon3: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          average_time_to_process: Array<{
                              label: string
                              icon1: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon2: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon3: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          num_of_people_involved: Array<{
                              label: string
                              icon1: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon2: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              icon3: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          results: Array<{
                              results_title: string
                              invoices_take: string
                              with_pleo_bills: string
                              time_saved: string
                          }>
                      }
                  }
                | {
                      type: string
                      data: {
                          title: string
                          results_title: string
                          results_line_cashback: string
                          results_subheading: string
                          cta_text: string
                          monthly_spend: Array<{
                              heading: string
                              subheading: string
                              low_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              medium_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              high_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          num_of_employees: Array<{
                              heading: string
                              subheading: string
                              low_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              medium_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              high_icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | {
                      type: string
                      id: string
                      data: {
                          title: string
                          category: string
                          pleo_heading: string
                          corporate_cards_heading: string
                          expense_software_heading: string
                          corporate_cards_expense_software_heading: string
                          yes_value: string
                          no_value: string
                          rows: Array<{
                              feature: string
                              feature_subtext: string
                              pleo: boolean
                              corporate_cards: boolean
                              expense_software: boolean
                              corporate_cards_expense_software: boolean
                          }>
                      }
                  }
                | {
                      __typename: 'PrismicInvoiceGenerator'
                      data: {
                          title: string
                          your_company_form_title: string
                          preview_label: string
                          invoice_details: string
                          get_invoice_label: string
                          recipient_company_form_title: string
                          invoice_items_form_title: string
                          items_label: string
                          price_label: string
                          quantity_label: string
                          rate_label: string
                          total_label: string
                          subtotal_label: string
                          tax_label: string
                          tax_total_label: string
                          notes_label: string
                          terms_label: string
                          add_item_label: string
                          invoice_title: string
                          get_your_invoice_modal: Array<{
                              modal_title: string
                              modal_subtitle: string
                              modal_image: {fluid: {base64: string}}
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }>
                          thank_you_modal: Array<{
                              modal_title: string
                              modal_subtitle: string
                              download_pdf_button_text: string
                              new_invoice_button_text: string
                              modal_image: {fluid: {base64: string}}
                          }>
                      }
                  }
                | {
                      __typename: 'PrismicInvoiceTemplateForm'
                      data: {
                          title: string
                          description: string
                          successMessage: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | {
                      __typename: 'PrismicVatCalculator'
                      data: {
                          title: string
                          vat_label: string
                          amount_label: string
                          add_vat_label: string
                          remove_vat_label: string
                          total_net_label: string
                          total_gross_label: string
                          submit_label: string
                          results_title: string
                          results_vat_added_label: string
                          results_vat_removed_label: string
                          body: {richText: any}
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type ContentPlusBlocksSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyContentPlusBlocks'
    primary: {background: string; plainTitle: string; text_under_title: {richText: any}}
    items: Array<{
        block_title: string
        block_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        block_content: {richText: any}
    }>
}

export type ContentPlusShortBulletsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyContentPlusShortBullets'
    primary: {
        inverse: boolean
        highlight_color: string
        heading: {richText: any}
        body: {richText: any}
    }
    items: Array<{
        bullet_text: string
        bullet_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type CustomersLogosPlusHeadlineSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyCustomersLogosPlusHeadline'
    primary: {
        predefined_logos: {
            document:
                | {
                      data: {
                          title: {richText: any}
                          logos: Array<{
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
        customer_logos_title: {richText: any}
    }
    items: Array<{
        icon: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type CustomersSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyCustomers'
    primary: {
        title: string
        predefined_logos: {
            document:
                | {
                      data: {
                          title: {richText: any}
                          logos: Array<{
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{
        logo: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type DemoHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyDemoHero'
    primary: {title: string}
    items: Array<{
        title: string
        subtitle: string
        cta_text: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type EventCardsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyEventCards'
    primary: {title: string; event_cta_text: string}
    items: Array<{
        title: string
        description: string
        tracking_id: string
        category: string
        duration: string
        date: string
        time: string
        event_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type FaqSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyFaq'
    primary: {title: string; collapsible: boolean}
    items: Array<{
        question: string
        answer: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        icon: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type FeatureBlockSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyFeatureBlock'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        background: string
        headline: string
        is_circular_image: boolean
        cta_label: string
        cta_hash_link: string
        wistia_video_id: string
        description: {richText: any}
        pre_cta_links: {richText: any}
        predefined_feature_block: {
            document:
                | {
                      data: {
                          title: string
                          subtitle: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          body: {richText: any}
                      }
                  }
                | Record<PropertyKey, never>
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }
}

export type FeatureComparisonSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyFeatureComparison'
    primary: {
        title: string
        background: string
        feature_column_heading: string
        column_heading_1: string
        column_heading_2: string
        tick_alt_text: string
    }
    items: Array<{feature: string; column_checked_1: boolean; column_checked_2: boolean}>
}

export type FeatureGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyFeatureGrid'
    primary: {title: string; background: string}
    items: Array<{
        feature_title: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        feature_description: {richText: any}
        predefined_feature: {
            document:
                | {
                      data: {
                          title: string
                          body: string
                          icon: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type GetStartedSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyGetStarted'
    primary: {
        title: string
        error_message: string
        button_label: string
        input_placeholder: string
        form_subtitle: string
        aria_label: string
        section_color: string
        variant: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {width: number; height: number}
        }
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{highlight_item: string}>
}

export type GlassdoorWidgetSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyGlassdoorWidget'
    primary: {
        cta_text: string
        widget_alt_text: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type HeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyHero'
    primary: {
        section_html_id: string
        title: string
        inverse: boolean
        is_oversized_image: boolean
        wistia_video_id: string
        lead_text: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        predefined_signup_banner: {
            type: string
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
        predefined_proof_point_badges: {
            document:
                | {
                      data: {
                          proof_point_first: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          proof_point_second: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type HubspotFormSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyHubspotForm'
    primary: {
        inverse: boolean
        featured_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        form: {
            document:
                | {
                      __typename: 'PrismicHubspotGlobalForm'
                      data: {
                          heading: string
                          body: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          imperative_consents_production: Array<{
                              consent: {
                                  document:
                                      | {
                                            _previewable: string
                                            lang: string
                                            data: {
                                                type: string
                                                isDefault: boolean
                                                subscriptionTypeStaging: {subscriptionId: number}
                                                subscriptionTypeProduction: {subscriptionId: number}
                                                text: {richText: any}
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                          imperative_consents_staging: Array<{
                              consent: {
                                  document:
                                      | {
                                            _previewable: string
                                            lang: string
                                            data: {
                                                type: string
                                                isDefault: boolean
                                                subscriptionTypeStaging: {subscriptionId: number}
                                                subscriptionTypeProduction: {subscriptionId: number}
                                                text: {richText: any}
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type IntegrationsGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyIntegrationsGrid'
    primary: {
        title: string
        cardCtaText: string
        categoryFilterPlaceholder: string
        categoryFilterAllLabel: string
        showingAllResults: string
        showingResultsFor: string
        removeFilter: string
        noResultsFound: string
        searchPlaceholder: string
    }
    items: Array<{featured_integration: {document: {id: string} | Record<PropertyKey, never>}}>
}

export type SyncedIntegrationsQueryVariables = Exact<{
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
}>

export type SyncedIntegrationsQuery = {
    allPrismicSyncedIntegration: {
        nodes: Array<{
            _previewable: string
            lang: string
            id: string
            data: {
                name: string
                description: string
                logo: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                endymionApp: {category: string; slug: string}
            }
        }>
    }
    prismicSyncedIntegrationsCategories: {
        data: {categories: Array<{category: string; labelText: string; labelColor: string}>}
    }
}

export type InteractiveDemoSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyInteractiveDemo'
    primary: {
        title: string
        subtitle: string
        modal_title: string
        modal_subtitle: string
        modal_button_text: string
        compact_layout: boolean
        interactive_demo_link_production: {url: string}
        interactive_demo_link_staging: {url: string}
        modal_image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        title: string
        body1: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type JobListingsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyJobListings'
    primary: {
        title: string
        subtitle: string
        location_label: string
        team_label: string
        role_label: string
        all_departments_label: string
        clear_filters_label: string
        departments_select_label: string
        no_results_label: string
        no_search_label: string
        search_input_label: string
        showing_roles_by_department_label: string
        showing_roles_by_department_with_search_label: string
    }
}

export type JobsGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyJobsGrid'
    primary: {headline: string; text: string; cta_text: string}
}

export type LandingHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyLandingHero'
    primary: {
        headline: string
        headline_background_color: string
        title: string
        cta_text: string
        primary_cta_text: string
        cta_destination: string
        inverse: boolean
        background: string
        wistia_video_id: string
        lead_text: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        primary_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        predefined_proof_point_badges: {
            document:
                | {
                      data: {
                          proof_point_first: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          proof_point_second: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type MagnetHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyMagnetHero'
    primary: {
        title: string
        description: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type MediaItemGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyMediaItemGrid'
    primary: {title: string; layout: string; background: string}
    items: Array<{
        item_title: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        item_description: {richText: any}
    }>
}

export type OnDemandResourcesSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyOnDemandResources'
    primary: {
        title: string
        top_link_text: string
        layout: string
        resource_cta_text: string
        showing_all_results: string
        showing_all_results_for: string
        filter_resource_type_placeholder: string
        filter_resource_type_all: string
        filter_language_placeholder: string
        filter_language_all: string
        filter_clear: string
        no_resources_found: string
        search_placeholder: string
        top_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type OnDemandResourcePagesQueryVariables = Exact<{
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
}>

export type OnDemandResourcePagesQuery = {
    allPrismicOnDemandResourcePage: {
        nodes: Array<{
            _previewable: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            data: {
                title: string
                duration: string
                description: string
                language_code: string
                title_image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                category: {
                    document: {id: string; data: {name: string}} | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type PanelGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyPanelGrid'
    primary: {title: string; excerpt: string}
    items: Array<{
        label_color: string
        label_text: string
        heading: string
        excerpt: string
        cta_text: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type PartnerProgrammeSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyPartnerProgramme'
    primary: {title: string; tables_tick_screen_reader_text: string}
    items: Array<{
        partner_programme_tables: {
            document:
                | {
                      id: string
                      data: {
                          category: string
                          new_partner_heading: string
                          bronze_heading: string
                          silver_heading: string
                          gold_heading: string
                          platinum_heading: string
                          disclaimer: string
                          rows: Array<{
                              feature: string
                              feature_tooltip: string
                              new_partner: boolean
                              new_partner_text: string
                              bronze: boolean
                              bronze_text: string
                              silver: boolean
                              silver_text: string
                              gold: boolean
                              gold_text: string
                              platinum: boolean
                              platinum_text: string
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type PricingSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyPricing'
    primary: {pricingTitle: {richText: any}}
}

export type RatingsPlusHeadlineSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyRatingsPlusHeadline'
    primary: {
        ratings_lead_text: string
        ratings_cta_text: string
        ratings_title: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        predefined_ratings: {
            document:
                | {
                      data: {
                          lead_text: string
                          cta_text: string
                          title: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          ratings: Array<{
                              rating: {
                                  document:
                                      | {
                                            data: {
                                                rating_number: number
                                                link: string
                                                logo: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{
        rating: {
            document:
                | {
                      data: {
                          rating_number: number
                          link: string
                          logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type ReferralHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyReferralHero'
    primary: {
        headline: string
        headline_background_color: string
        title: string
        lead: string
        alternative_lead: string
        inverse: boolean
        background: string
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type ReviewsGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyReviewsGrid'
    primary: {headline: string; variant: string; author_subtext: string}
    items: Array<{
        headline: string
        description: string
        number_of_stars: number
        review_origin: string
        author: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type RichTextSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyRichText'
    primary: {title: string; copy: {richText: any}}
}

export type SimpleCardGridSliceFragment = {
    __typename: 'PrismicSlicePageDataBodySimpleCardGrid'
    primary: {title: string; card_cta_text: string; tracking_event: string}
    items: Array<{
        title: string
        description: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type SliderCardsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodySliderCards'
    primary: {
        slider_heading: string
        highlight_first_card: boolean
        hide_media_on_mobile: boolean
        card_background_color: string
    }
    items: Array<{
        item_heading: string
        sub_heading: string
        description: string
        sub_description: string
        video_id: string
        cta_text: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type SocialProofSliceFragment = {
    __typename: 'PrismicSlicePageDataBodySocialProof'
    primary: {title: string; inverse: boolean}
    items: Array<{
        quote: string
        full_name: string
        person_byline: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        predefined_testimonial: {
            document:
                | {
                      data: {
                          quote: string
                          attribution_name: string
                          attribution_title: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type StatisticsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyStats'
    primary: {
        first_stat_amount: number
        first_stat_text: string
        first_stat_as_percentile: boolean
        second_stat_amount: number
        second_stat_text: string
        second_stat_as_percentile: boolean
        third_stat_amount: number
        third_stat_text: string
        third_stat_as_percentile: boolean
        source_text: {richText: any}
        predefined_statistics: {
            document:
                | {
                      data: {
                          first_stat: Array<{amount: number; text: string; as_percentile: boolean}>
                          second_stat: Array<{amount: number; text: string; as_percentile: boolean}>
                          third_stat: Array<{amount: number; text: string; as_percentile: boolean}>
                          source_text: {richText: any}
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type StepsFragment = {
    __typename: 'PrismicSlicePageDataBodySteps'
    primary: {
        title: string
        show_count: boolean
        has_small_copy: boolean
        cta_text: string
        align_text: string
        description: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        heading: string
        content: string
        background_color: string
        image_as_icon: boolean
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_poster: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }>
}

export type TabbedHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyTabbedHero'
    items: Array<{
        tab_title: string
        is_default: boolean
        tab: {
            document:
                | {
                      data: {
                          title: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          button_label: string
                          secondary_cta_label: string
                          lead_image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          lead_text: {richText: any}
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          button_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          secondary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          lottie: {url: string}
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type TableSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyTable'
    primary: {
        title: string
        column_1_heading: string
        column_2_heading: string
        column_3_heading: string
        column_4_heading: string
        column_5_heading: string
        column_6_heading: string
        column_7_heading: string
    }
    items: Array<{
        row_heading: string
        column_1_content: {richText: any}
        column_2_content: {richText: any}
        column_3_content: {richText: any}
        column_4_content: {richText: any}
        column_5_content: {richText: any}
        column_6_content: {richText: any}
        column_7_content: {richText: any}
    }>
}

export type UpcomingEventsSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyUpcomingEvents'
    primary: {
        title: string
        top_link_text: string
        layout: string
        event_cta_text: string
        showing_all_results: string
        showing_all_results_for: string
        filter_event_type_placeholder: string
        filter_event_type_all: string
        filter_event_type_live_event: string
        filter_event_type_deminar: string
        filter_event_type_webinar: string
        filter_location_placeholder: string
        filter_location_all: string
        filter_clear: string
        no_events_found: string
        search_placeholder: string
        top_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type PleoEventsQueryVariables = Exact<{
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
}>

export type PleoEventsQuery = {
    allPrismicPleoEvent: {
        nodes: Array<{
            _previewable: string
            lang: string
            data: {
                title: string
                description: string
                datetime: any
                event_type: string
                duration: string
                language: string
                location: string
                link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }
        }>
    }
}

export type ResourceDetailPageVideoLibraryQueryVariables = Exact<{[key: string]: never}>

export type ResourceDetailPageVideoLibraryQuery = {
    allPrismicResourceDetailPage: {
        nodes: Array<{
            uid: string
            lang: string
            data: {
                title: string
                description: string
                category: string
                duration: string
                thumbnail: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }
        }>
    }
}

export type VideoLibrarySliceFragment = {
    __typename: 'PrismicSlicePageDataBodyVideoLibrary'
    primary: {title: string}
}

export type VideoPopoverWithTextSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyVideoPopoverWithText'
    id: string
    primary: {
        text_orientation: string
        pre_title: string
        title: string
        body_text: string
        wistia_video_id: string
        cta_text: string
        video_mp4: {url: string}
        video_webm: {url: string}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type VideoSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyVideo'
    primary: {
        title: string
        video_id: string
        thumbnail: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
}

export type AboutQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type AboutQuery = {
    prismicAboutUsPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            hero: Array<{
                title: string
                body: {richText: any}
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
            }>
            social_proof_logos_section: {
                document:
                    | {
                          data: {
                              title: string
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            feature_blocks_1: Array<{
                title: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
            }>
            inline_video: Array<{
                title: string
                video_id: string
                video_thumbnail: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
            }>
            feature_blocks_2: Array<{
                title: string
                cta_text: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }>
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              cta_text: string
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    rating_number: number
                                                    link: string
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type CreateAboutPageQueryVariables = Exact<{[key: string]: never}>

export type CreateAboutPageQuery = {
    allPrismicAboutUsPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type ApplePayQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type ApplePayQuery = {
    allPrismicApplePayPage: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                page_type: string
                title: string
                add_card_title: string
                add_card_subtitle: string
                add_card_cta_text: string
                questions_title: string
                benefits_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                hero_badge: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                subtitle: {richText: any}
                hero_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                fast_payments: Array<{
                    title: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    video_mp4: {url: string}
                    video_webm: {url: string}
                }>
                safe_payments: Array<{
                    title: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                check_out: Array<{
                    title: string
                    video_mp4: {url: string}
                    video_webm: {url: string}
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                add_card_steps: Array<{
                    title: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                questions_answers: Array<{question: string; answer: {richText: any}}>
                perks: Array<{
                    title: string
                    cta_text: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                fetch: Array<{
                    title: string
                    cta_text: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                signup_banner: {
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type CreateApplePayQueryVariables = Exact<{[key: string]: never}>

export type CreateApplePayQuery = {
    allPrismicApplePayPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type BillsStatusQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type BillsStatusQuery = {
    allPrismicBillsStatus: {
        nodes: Array<{
            data: {
                allow_indexing: boolean
                meta_title: string
                meta_description: string
                title: string
                company: string
                customer_logos_title: string
                questions_title: string
                signup_box_title: string
                signup_box_placeholder: string
                submit_text: string
                accept_terms_error: string
                input_aria_label: string
                lastEdited: string
                headerCta: string
                invoiceId: string
                invoiceDate: string
                totalAmount: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                headerCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                headerLink: {richText: any}
                marketingCard: Array<{
                    ctaText: string
                    body: {richText: any}
                    ctaLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                errorContent: Array<{
                    errorTitle: string
                    ctaText: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    ctaLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    body: {richText: any}
                }>
                statusReceived: Array<{
                    statusReceivedTitle: string
                    statusReceivedSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                statusProcessing: Array<{
                    statusProcessingTitle: string
                    statusProcessingSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                statusPaid: Array<{
                    statusPaidTitle: string
                    statusPaidSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                customer_logos: {
                    document:
                        | {
                              data: {
                                  title: string
                                  logos: Array<{
                                      logo: {
                                          url: string
                                          alt: string
                                          copyright: string
                                          dimensions: {width: number; height: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                questions: Array<{title: string; body: {richText: any}}>
                signup_success_message: {richText: any}
            }
        }>
    }
}

export type CreateBillsStatusPageQueryVariables = Exact<{[key: string]: never}>

export type CreateBillsStatusPageQuery = {
    allPrismicBillsStatus: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type BillsTrackerQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type BillsTrackerQuery = {
    allPrismicBillsTracker: {
        nodes: Array<{
            data: {
                allow_indexing: boolean
                meta_title: string
                meta_description: string
                title: string
                company: string
                customer_logos_title: string
                questions_title: string
                signup_box_title: string
                signup_box_placeholder: string
                submit_text: string
                accept_terms_error: string
                input_aria_label: string
                lastEdited: string
                headerCta: string
                invoiceId: string
                invoiceDate: string
                totalAmount: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                headerCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                headerLink: {richText: any}
                marketingCard: Array<{
                    ctaText: string
                    body: {richText: any}
                    ctaLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                errorContent: Array<{
                    errorTitle: string
                    ctaText: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    ctaLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    body: {richText: any}
                }>
                statusReceived: Array<{
                    statusReceivedTitle: string
                    statusReceivedSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                statusProcessing: Array<{
                    statusProcessingTitle: string
                    statusProcessingSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                statusPaid: Array<{
                    statusPaidTitle: string
                    statusPaidSubtitle: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                customer_logos: {
                    document:
                        | {
                              data: {
                                  title: string
                                  logos: Array<{
                                      logo: {
                                          url: string
                                          alt: string
                                          copyright: string
                                          dimensions: {width: number; height: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                questions: Array<{title: string; body: {richText: any}}>
                signup_success_message: {richText: any}
            }
        }>
    }
}

export type CreateBillsTrackerPageQueryVariables = Exact<{[key: string]: never}>

export type CreateBillsTrackerPageQuery = {
    allPrismicBillsTracker: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type LegalPageCookiePolicyQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type LegalPageCookiePolicyQuery = {
    allPrismicLegalPageCookiePolicy: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                used_cookies_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                sections: Array<{
                    section_title: string
                    inverse: boolean
                    section_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    section_content: {richText: any}
                }>
                used_cookies_details: Array<{
                    used_cookie_title: string
                    used_cookie_detail: {richText: any}
                }>
                sections_part_2: Array<{
                    section_title: string
                    inverse: boolean
                    section_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    section_content: {richText: any}
                }>
            }
        }>
    }
    allPrismicLegalDocuments: {
        nodes: Array<{
            _previewable: string
            data: {
                title: string
                historical_documents_title: string
                documents: Array<{
                    title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                historical_documents: Array<{
                    document_title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type CreateLegalPageCookiePolicyQueryVariables = Exact<{[key: string]: never}>

export type CreateLegalPageCookiePolicyQuery = {
    allPrismicLegalPageCookiePolicy: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type CreateCustomerCasePageQueryVariables = Exact<{[key: string]: never}>

export type CreateCustomerCasePageQuery = {
    allPrismicCustomerCase: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type CustomerCaseQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type CustomerCaseQuery = {
    allPrismicCustomerCase: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                challenge_title: string
                result_title: string
                solution_title: string
                media_item_grid_title: string
                related_customer_cases_title: string
                related_customer_cases_cta_text: string
                hero_section: Array<{
                    pre_title: string
                    title: string
                    wistia_video_id: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                customer_card: Array<{
                    location: string
                    industry: string
                    employees: string
                    quote: string
                    quote_author: string
                    logo: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    quote_author_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                challenge_lead_text: {richText: any}
                challenge_list: Array<{
                    challenge_list_item_title: string
                    challenge_list_item_body: {richText: any}
                }>
                result_lead_text: {richText: any}
                result_list: Array<{
                    result_list_item_title: string
                    result_list_item_body: {richText: any}
                }>
                solution_lead_text: {richText: any}
                media_item_grid: Array<{
                    title: string
                    body: {richText: any}
                    icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                related_customer_cases: Array<{
                    body: string
                    case_title: string
                    cta_link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        gatsbyImageData: any
                        dimensions: {height: number; width: number}
                    }
                }>
            }
        }>
    }
    allPrismicTemplateCustomerCase: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_description: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: Array<
                    | {
                          __typename: 'PrismicTemplateCustomerCaseDataBodyCardGrid'
                          primary: {
                              subtitle: string
                              show_more_text: string
                              initial_cards_shown: string
                              initial_cards_shown_on_mobile: string
                              initial_cards_shown_on_desktop: string
                              card_cta_text: string
                              show_filter: boolean
                              layout: string
                              background_color: string
                              no_padding: boolean
                              blockTitle: {richText: any}
                          }
                          items: Array<{
                              title: string
                              body: string
                              tag_text: string
                              tag_color: string
                              filterKeywords: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              ctaLink: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                          }>
                      }
                    | {
                          __typename: 'PrismicTemplateCustomerCaseDataBodyGetStarted'
                          primary: {
                              title: string
                              error_message: string
                              button_label: string
                              input_placeholder: string
                              form_subtitle: string
                              aria_label: string
                              variant: string
                              section_color: string
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              predefined_signup_banner: {
                                  document:
                                      | {
                                            _previewable: string
                                            type: string
                                            data: {
                                                title: string
                                                subtitle: string
                                                email_input_placeholder: string
                                                email_input_error_text: string
                                                submit_text: string
                                                aria_label: string
                                                partner_signup_redirect: boolean
                                                form_name: string
                                                disclaimer_copy: {richText: any}
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {width: number; height: number}
                                                }
                                                redirect_link: {
                                                    link_type: PrismicLinkTypeEnum
                                                    uid: string
                                                    type: string
                                                    lang: string
                                                    target: string
                                                    url: string
                                                }
                                                form_production: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                                form_staging: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }
                          items: Array<{highlight_item: string}>
                      }
                    | {
                          __typename: 'PrismicTemplateCustomerCaseDataBodyMediaItemGrid'
                          primary: {title: string; layout: string; background: string}
                          items: Array<{
                              item_title: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              item_description: {richText: any}
                          }>
                      }
                >
            }
        }>
    }
}

export type CustomerCaseMediaItemGridFragment = {
    __typename: 'PrismicTemplateCustomerCaseDataBodyMediaItemGrid'
    primary: {title: string; layout: string; background: string}
    items: Array<{
        item_title: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        item_description: {richText: any}
    }>
}

export type CustomerCaseGetStartedFragment = {
    __typename: 'PrismicTemplateCustomerCaseDataBodyGetStarted'
    primary: {
        title: string
        error_message: string
        button_label: string
        input_placeholder: string
        form_subtitle: string
        aria_label: string
        variant: string
        section_color: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {width: number; height: number}
        }
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{highlight_item: string}>
}

export type CustomerCaseCardGridFragment = {
    __typename: 'PrismicTemplateCustomerCaseDataBodyCardGrid'
    primary: {
        subtitle: string
        show_more_text: string
        initial_cards_shown: string
        initial_cards_shown_on_mobile: string
        initial_cards_shown_on_desktop: string
        card_cta_text: string
        show_filter: boolean
        layout: string
        background_color: string
        no_padding: boolean
        blockTitle: {richText: any}
    }
    items: Array<{
        title: string
        body: string
        tag_text: string
        tag_color: string
        filterKeywords: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        ctaLink: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type CreateCustomersPageQueryVariables = Exact<{[key: string]: never}>

export type CreateCustomersPageQuery = {
    allPrismicCustomersPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type CustomersQueryVariables = Exact<{
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    twoColumnsAsymmetric: InputMaybe<Scalars['String']['input']>
    fourColumns: InputMaybe<Scalars['String']['input']>
}>

export type CustomersQuery = {
    prismicCustomersPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            customer_card_cta_text: string
            show_more_customers_text: string
            industry_select_text: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            hero: Array<{
                title: string
                body: {richText: any}
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }>
            social_proof_logos_section: {
                document:
                    | {
                          data: {
                              title: string
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            testimonials: Array<{
                testimonial: {
                    document:
                        | {
                              id: string
                              data: {
                                  quote: string
                                  attribution_name: string
                                  attribution_title: string
                                  cta_text: string
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      gatsbyImageData: any
                                      dimensions: {height: number; width: number}
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            industries: Array<{
                all: string
                design: string
                financial_services: string
                food_and_drink: string
                logistics: string
                marketing: string
                media: string
                property: string
                sports_and_events: string
                technology: string
                travel: string
            }>
            customer_cards: Array<{
                title: string
                body: string
                design: boolean
                financial_services: boolean
                food_and_drink: boolean
                logistics: boolean
                marketing: boolean
                media: boolean
                property: boolean
                sports_and_events: boolean
                technology: boolean
                travel: boolean
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                ctaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }>
            why_pleo: Array<{
                title: string
                cta_text: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }>
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    rating_number: number
                                                    link: string
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type CreateDemoPageQueryVariables = Exact<{[key: string]: never}>

export type CreateDemoPageQuery = {
    allPrismicDemoPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type DemoPageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type DemoPageQuery = {
    prismicDemoPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            title: string
            form_title: string
            form_submit_text: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            bullet_points: Array<{
                text: string
                icon: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
            }>
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            imperative_consents_production: Array<{
                consent: {
                    document:
                        | {
                              _previewable: string
                              lang: string
                              data: {
                                  type: string
                                  isDefault: boolean
                                  subscriptionTypeStaging: {subscriptionId: number}
                                  subscriptionTypeProduction: {subscriptionId: number}
                                  text: {richText: any}
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            imperative_consents_staging: Array<{
                consent: {
                    document:
                        | {
                              _previewable: string
                              lang: string
                              data: {
                                  type: string
                                  isDefault: boolean
                                  subscriptionTypeStaging: {subscriptionId: number}
                                  subscriptionTypeProduction: {subscriptionId: number}
                                  text: {richText: any}
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            social_proof_logos_section: {
                document:
                    | {
                          data: {
                              title: string
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type CreateLegalPageDsrQueryVariables = Exact<{[key: string]: never}>

export type CreateLegalPageDsrQuery = {
    allPrismicLegalPageDsr: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type LegalPageDsrQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type LegalPageDsrQuery = {
    prismicLegalPageDsr: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            securiti_iframe_title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            securiti_iframe_url: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }
    }
}

export type CreateEbookPageQueryVariables = Exact<{[key: string]: never}>

export type CreateEbookPageQuery = {
    allPrismicEbook: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type EbookPageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type EbookPageQuery = {
    prismicEbook: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            form_pre_title: string
            title: string
            campaign: string
            form_submit_text: string
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            imperative_consents_production: Array<{
                consent: {
                    document:
                        | {
                              _previewable: string
                              lang: string
                              data: {
                                  type: string
                                  isDefault: boolean
                                  subscriptionTypeStaging: {subscriptionId: number}
                                  subscriptionTypeProduction: {subscriptionId: number}
                                  text: {richText: any}
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            imperative_consents_staging: Array<{
                consent: {
                    document:
                        | {
                              _previewable: string
                              lang: string
                              data: {
                                  type: string
                                  isDefault: boolean
                                  subscriptionTypeStaging: {subscriptionId: number}
                                  subscriptionTypeProduction: {subscriptionId: number}
                                  text: {richText: any}
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            predefined_details: {
                document:
                    | {
                          data: {
                              form_pre_title: string
                              form_submit_text: string
                              what_s_inside_text: string
                              thank_you_heading: string
                              thank_you_return_button_label: string
                              thank_you_download_button_label: string
                              signup_banner: {
                                  document:
                                      | {
                                            _previewable: string
                                            type: string
                                            data: {
                                                title: string
                                                subtitle: string
                                                email_input_placeholder: string
                                                email_input_error_text: string
                                                submit_text: string
                                                aria_label: string
                                                partner_signup_redirect: boolean
                                                form_name: string
                                                disclaimer_copy: {richText: any}
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {width: number; height: number}
                                                }
                                                redirect_link: {
                                                    link_type: PrismicLinkTypeEnum
                                                    uid: string
                                                    type: string
                                                    lang: string
                                                    target: string
                                                    url: string
                                                }
                                                form_production: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                                form_staging: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                              thank_you_image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              thank_you_text: {richText: any}
                          }
                      }
                    | Record<PropertyKey, never>
            }
            cover_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            what_s_inside_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            what_s_inside_points: Array<{point: string}>
            file: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }
    }
}

export type CreateExpensePolicyBuilderPageQueryVariables = Exact<{[key: string]: never}>

export type CreateExpensePolicyBuilderPageQuery = {
    allPrismicExpensePolicyBuilder: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type ExpensePolicyBuilderQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type ExpensePolicyBuilderQuery = {
    allPrismicExpensePolicyBuilder: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                welcome: Array<{
                    title: string
                    body: string
                    company_name: string
                    company_name_placeholder: string
                    start_button_label: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    description: {richText: any}
                }>
                sidebar: Array<{
                    preview: string
                    step: string
                    of: string
                    skip: string
                    next: string
                }>
                accommodation: Array<{
                    title: string
                    subtitle: string
                    how_to_book_trips: string
                    how_to_book_trips_placeholder: string
                    budget_per_night: string
                    budget_per_night_placeholder: string
                    covered_by_per_diem: string
                    extra: string
                    extra_placeholder: string
                }>
                food: Array<{
                    title: string
                    subtitle: string
                    breakfast: string
                    breakfast_placeholder: string
                    lunch: string
                    lunch_placeholder: string
                    dinner: string
                    dinner_placeholder: string
                    covered_by_per_diem: string
                    extra: string
                    extra_placeholder: string
                }>
                transport: Array<{
                    title: string
                    subtitle: string
                    air_travel_policy: string
                    air_travel_policy_placeholder: string
                    city_travel_policy: string
                    city_travel_policy_placeholder: string
                    mileage_amount: string
                    mileage_amount_placeholder: string
                    extra: string
                    extra_placeholder: string
                }>
                conferences: Array<{
                    title: string
                    subtitle: string
                    conference_amount: string
                    conference_amount_placeholder: string
                    extra: string
                    extra_placeholder: string
                }>
                remote: Array<{
                    title: string
                    hardware_amount: string
                    hardware_amount_placeholder: string
                    software_amount: string
                    software_amount_placeholder: string
                    extra: string
                    extra_placeholder: string
                }>
                gifts: Array<{
                    title: string
                    subtitle: string
                    client_amount: string
                    client_amount_placeholder: string
                    employee_amount: string
                    employee_amount_placeholder: string
                    extra: string
                    extra_placeholder: string
                }>
                details: Array<{
                    title: string
                    subtitle: string
                    detail_days: string
                    detail_days_placeholder: string
                    details_reimbursement: string
                    details_reimbursement_placeholder: string
                    contact: string
                    contact_name: string
                    contact_email: string
                    extra: string
                    extra_placeholder: string
                }>
                all_done: Array<{
                    title: string
                    subtitle: string
                    download_pdf: string
                    download_pdf_cta_text: string
                    sharable_link_cta_text: string
                    email: string
                    email_placeholder: string
                    submit_text: string
                    privacy_policy: {richText: any}
                }>
                preview: Array<{
                    title: string
                    subtitle: string
                    accommodation_heading: string
                    how_to_book_trips: string
                    budget_per_night: string
                    budget_per_night_per_diem: string
                    food_heading: string
                    food_subtitle: string
                    food_covered_by_per_diem: string
                    breakfast: string
                    lunch: string
                    dinner: string
                    food_budget: string
                    transport_heading: string
                    air_travel_budget: string
                    city_transport_budget: string
                    mileage_budget: string
                    conferences_heading: string
                    conference_amount: string
                    remote_heading: string
                    hardware_amount: string
                    software_amount: string
                    gifts_heading: string
                    client_amount: string
                    employee_amount: string
                    details_heading: string
                    detail_days: string
                    detail_reimbursements: string
                    contact: string
                    accommodation_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    food_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    transport_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    conferences_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    remote_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    gifts_icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
            }
        }>
    }
}

export type CreateExpenseReportGeneratorPageQueryVariables = Exact<{[key: string]: never}>

export type CreateExpenseReportGeneratorPageQuery = {
    allPrismicExpenseReportGenerator: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type ExpenseReportGeneratorQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type ExpenseReportGeneratorQuery = {
    allPrismicExpenseReportGenerator: {
        nodes: Array<{
            _previewable: string
            data: {
                allow_indexing: boolean
                meta_title: string
                meta_description: string
                preview: string
                title: string
                subtitle: string
                date: string
                description: string
                merchant: string
                category: string
                project: string
                amount: string
                total: string
                expense: string
                employee: string
                headerCta: string
                addExpense: string
                generateExpenseReport: string
                expensesDashboard: string
                deleteExpense: string
                didYouKnow: string
                reportGenerating: string
                expenseReport: string
                reportNumber: string
                previewDisclaimer: string
                submittedBy: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                headerCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                headerLink: {richText: any}
                almostThere: Array<{
                    title: string
                    shareButtonText: string
                    downloadButtonText: string
                    shareTitle: string
                    shareText: string
                    shareUrl: string
                    mailToSubject: string
                    mailToBody: string
                    yourCompanyName: string
                    yourName: string
                    yourFirstAndLastName: string
                    reportNumber: string
                    yourReportNumber: string
                    generateReportButtonText: string
                    receiveReportButtonText: string
                    body: {richText: any}
                    disclaimer: {richText: any}
                    logoPlaceholder: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                loadingImage: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                loadingVideo: {url: string}
                loadingFacts: Array<{fact: string}>
                previewFooter: {richText: any}
                madeByPleo: {richText: any}
                successScreen: Array<{
                    title: string
                    body: string
                    buttonText: string
                    createAnotherReport: string
                    explorePleoButtonText: string
                    downloadReportButtonText: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    buttonLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    explorePleoButtonLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                emailContent: Array<{
                    emailSubject: string
                    helloThere: string
                    emailBody: string
                    explorePleoButtonText: string
                    explorePleoButtonLink: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type CreateExperimentalLandingPagePageQueryVariables = Exact<{[key: string]: never}>

export type CreateExperimentalLandingPagePageQuery = {
    allPrismicExperimentalLandingPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type ExperimentalLandingPageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type ExperimentalLandingPageQuery = {
    allPrismicExperimentalLandingPage: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                hero: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                    proof_point_badges: {
                        document:
                            | {
                                  data: {
                                      proof_point_first: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                      proof_point_second: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                social_proof_logos_section: {
                    document:
                        | {
                              data: {
                                  title: string
                                  logos: Array<{
                                      icon: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                feature_blocks: Array<{
                    title: string
                    preTitle: string
                    video_mp4: {url: string}
                    video_webm: {url: string}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                }>
                testimonials: Array<{
                    testimonial: {
                        document:
                            | {
                                  id: string
                                  data: {
                                      quote: string
                                      attribution_name: string
                                      attribution_title: string
                                      cta_text: string
                                      image: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                social_proof_logos_extended_section: {
                    document:
                        | {
                              data: {
                                  cta_text: string
                                  title: {richText: any}
                                  logos: Array<{
                                      icon: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                social_proof_ratings_section: {
                    document:
                        | {
                              data: {
                                  title: {richText: any}
                                  ratings: Array<{
                                      rating: {
                                          document:
                                              | {
                                                    data: {
                                                        stars: string
                                                        rating_number: number
                                                        link: string
                                                        icon: {
                                                            alt: string
                                                            copyright: string
                                                            url: string
                                                            dimensions: {
                                                                height: number
                                                                width: number
                                                            }
                                                        }
                                                    }
                                                }
                                              | Record<PropertyKey, never>
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                signup_banner: {
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type ExploreProductV1QueryVariables = Exact<{[key: string]: never}>

export type ExploreProductV1Query = {
    allPrismicExploreProduct: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {
                interactive_demo_frame_title: string
                version: string
                excludeSitemap: boolean
                navattic_link: {url: string}
            }
        }>
    }
}

export type ExploreProductPageV1QueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
}>

export type ExploreProductPageV1Query = {
    prismicExploreProduct: {
        _previewable: string
        data: {
            version: string
            meta_title: string
            meta_description: string
            interactive_demo_frame_title: string
            open_graph_image: {url: string}
            navattic_link: {url: string}
            navattic_link_staging: {url: string}
            main_placeholder_image: {
                alt: string
                url: string
                copyright: string
                dimensions: {height: number; width: number}
            }
            side_placeholder_image: {
                alt: string
                url: string
                copyright: string
                dimensions: {height: number; width: number}
            }
            mobile_modal: Array<{
                subtitle: string
                button_text: string
                link_text: string
                image: {
                    alt: string
                    url: string
                    copyright: string
                    dimensions: {height: number; width: number}
                }
            }>
        }
    }
}

export type ExploreProductQueryVariables = Exact<{[key: string]: never}>

export type ExploreProductQuery = {
    allPrismicExploreProduct: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {
                interactive_demo_frame_title: string
                version: string
                excludeSitemap: boolean
                navattic_link: {url: string}
            }
        }>
    }
}

export type ExploreProductPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
}>

export type ExploreProductPageQuery = {
    prismicExploreProduct: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            version: string
            title: string
            copy_and_share_text: string
            share_this_demo_text: string
            start_the_demo_text: string
            mobile_first_step_title: string
            mobile_first_step_button_text: string
            mobile_first_step_swipe_text: string
            last_step_title: string
            redirect_to_app_text: string
            open_graph_image: {url: string}
            title_image: {
                alt: string
                url: string
                copyright: string
                dimensions: {height: number; width: number}
            }
            mobile_first_step_image: {
                alt: string
                url: string
                copyright: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            last_step_image: {
                alt: string
                url: string
                copyright: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            items: Array<{
                heading: string
                description: string
                navigation_label: string
                navattic_url_production: {url: string}
                navattic_url_staging: {url: string}
                video_placeholder_image: {
                    alt: string
                    url: string
                    copyright: string
                    dimensions: {height: number; width: number}
                }
                demo_placeholder_image: {
                    alt: string
                    url: string
                    copyright: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                video_webm: {url: string}
                video_mp4: {url: string}
                navigation_icon: {fluid: {base64: string}}
            }>
            social_proof: Array<{
                platform: {
                    document:
                        | {
                              data: {
                                  rating_number: number
                                  link: string
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
        }
    }
}

export type CreateFaqPageQueryVariables = Exact<{[key: string]: never}>

export type CreateFaqPageQuery = {
    allPrismicFaqPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type FaqPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type FaqPageQuery = {
    prismicFaqPage: {
        _previewable: string
        data: {
            title: string
            subtitle: string
            faq_basic_title: string
            faq_basic_button_label: string
            faq_use_title: string
            faq_use_button_label: string
            faq_feature_title: string
            faq_feature_button_label: string
            faq_security_title: string
            faq_security_button_label: string
            meta_title: string
            meta_description: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            faq_security: Array<{question: string; answer: {richText: any}}>
            faq_feature: Array<{question: string; answer: {richText: any}}>
            faq_use: Array<{question: string; answer: {richText: any}}>
            faq_basic: Array<{question: string; answer: {richText: any}}>
            testimonials: Array<{
                testimonial: {
                    document:
                        | {
                              id: string
                              data: {
                                  quote: string
                                  attribution_name: string
                                  attribution_title: string
                                  cta_text: string
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    rating_number: number
                                                    link: string
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type CreateFetchPageQueryVariables = Exact<{[key: string]: never}>

export type CreateFetchPageQuery = {
    allPrismicFetchPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type FetchQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type FetchQuery = {
    allPrismicFetchPage: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                pre_title: string
                video_id: string
                features_title: string
                how_to_title: string
                questions_title: string
                testimonials_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                title: {richText: any}
                hero_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                features: Array<{title: string; body: {richText: any}}>
                how_to_steps: Array<{title: string}>
                questions: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                    body_2: {richText: any}
                }>
                testimonials: Array<{stars: number; quote: string; attribution: {richText: any}}>
                signup_banner: {
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type CreateLegalPageGdprQueryVariables = Exact<{[key: string]: never}>

export type CreateLegalPageGdprQuery = {
    allPrismicLegalPageGdpr: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type LegalPageGdprQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type LegalPageGdprQuery = {
    prismicLegalPageGdpr: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            sections: Array<{
                section_title: string
                inverse: boolean
                section_content: {richText: any}
                section_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
            }>
        }
    }
    allPrismicLegalDocuments: {
        nodes: Array<{
            _previewable: string
            data: {
                title: string
                historical_documents_title: string
                documents: Array<{
                    title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                historical_documents: Array<{
                    document_title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type GettingStartedExperienceQueryVariables = Exact<{[key: string]: never}>

export type GettingStartedExperienceQuery = {
    allPrismicGettingStartedExperience: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {title: string; excludeSitemap: boolean}
        }>
    }
}

export type GettingStartedExperiencePageQueryVariables = Exact<{
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    twoColumns: InputMaybe<Scalars['String']['input']>
}>

export type GettingStartedExperiencePageQuery = {
    prismicGettingStartedExperience: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            back_to_home_page_text: string
            account_question: string
            account_option_1_label: string
            account_option_1_description: string
            account_option_2_label: string
            account_option_2_description: string
            account_option_3_label: string
            account_option_3_description: string
            existing_client_title: string
            existing_client_description: string
            existing_client_help_title: string
            existing_client_wistia_id: string
            waiting_list_title: string
            waiting_list_description: string
            form_submit_text: string
            success_message_title: string
            success_message_description: string
            multi_entity_title: string
            multi_entity_description: string
            multi_entity_get_started_button_text: string
            multi_entity_book_a_demo_button_text: string
            multi_entity_banner_title: string
            entity_title: string
            entity_description: string
            entity_select_label: string
            entity_select_placeholder: string
            entity_no_entity_option: string
            entity_i_dont_know_option: string
            entity_continue_button: string
            where_pleo_operates_label: string
            marquee_title: string
            open_graph_image: {url: string}
            account_option_1_icon: {fluid: {base64: string}}
            account_option_2_icon: {fluid: {base64: string}}
            account_option_3_icon: {fluid: {base64: string}}
            existing_client_help_text: {richText: any}
            existing_client_wistia_thumbnail: {
                url: string
                alt: string
                copyright: string
                gatsbyImageData: any
                dimensions: {width: number; height: number}
            }
            success_image: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            multi_entity_banner_description: {richText: any}
            multi_entity_banner_image: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            where_pleo_operates_img: {
                url: string
                alt: string
                copyright: string
                gatsbyImageData: any
                dimensions: {width: number; height: number}
            }
            images: Array<{
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }>
        }
    }
}

export type CreateHomepageV4PageQueryVariables = Exact<{[key: string]: never}>

export type CreateHomepageV4PageQuery = {
    allPrismicHomepageV4: {
        nodes: Array<{
            lang: string
            type: string
            uid: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {
                excludeSitemap: boolean
                excludeProduction: boolean
                hideLeftNav: boolean
                hideRightNav: boolean
            }
        }>
    }
}

export type HomepageV4QueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
    twoColumnsAsymmetric: InputMaybe<Scalars['String']['input']>
}>

export type HomepageV4Query = {
    prismicHomepageV4: {
        _previewable: string
        data: {
            exclude_robots: boolean
            hide_left_nav: boolean
            hide_right_nav: boolean
            hide_links: boolean
            track_visible_sections: boolean
            notification_banner: {
                document: {data: {banner_content: {richText: any}}} | Record<PropertyKey, never>
            }
            body: Array<
                | {
                      __typename: 'PrismicHomepageV4DataBodyAnimationBlock'
                      primary: {
                          title: string
                          animation_frames: number
                          body: {richText: any}
                          lottie_json_file: {url: string}
                          placeholder: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyBentoBox'
                      primary: {title: string; subtitle: string}
                      items: Array<{
                          place_on_new_row: boolean
                          card_title: string
                          card_subtitle: string
                          image_alignment: string
                          card_image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          video_poster: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyCardGridV2'
                      primary: {title: string}
                      items: Array<{
                          card_title: string
                          card_description: string
                          card_cta_text: string
                          card_image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          card_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyCustomerLogosPlusCta'
                      primary: {
                          title: string
                          cta_text: string
                          marquee_mode: boolean
                          marquee_scroll_speed: string
                          marquee_width: string
                          background_color: string
                          stat_1_highlight: string
                          stat_2_highlight: string
                          stat_3_highlight: string
                          stat_1_body: string
                          stat_2_body: string
                          stat_3_body: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyFeatureBlock'
                      primary: {
                          title_over_section: string
                          title: string
                          inverse: boolean
                          background: string
                          headline: string
                          is_circular_image: boolean
                          cta_label: string
                          cta_hash_link: string
                          wistia_video_id: string
                          description: {richText: any}
                          pre_cta_links: {richText: any}
                          predefined_feature_block: {
                              document:
                                  | {
                                        data: {
                                            title: string
                                            subtitle: string
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            body: {richText: any}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyFeatureBlockWithMarquee'
                      primary: {
                          title_over_section: string
                          title: string
                          inverse: boolean
                          headline: string
                          cta_label: string
                          outline: {richText: any}
                          pre_cta_links: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyFeaturePanel'
                      primary: {
                          background_color: string
                          is_media_on_the_right: boolean
                          subtitle: string
                          subtitle_color: string
                          title: string
                          cta_label: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          content: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyGetStarted'
                      primary: {
                          title: string
                          error_message: string
                          button_label: string
                          input_placeholder: string
                          form_subtitle: string
                          aria_label: string
                          variant: string
                          section_color: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          predefined_signup_banner: {
                              document:
                                  | {
                                        _previewable: string
                                        type: string
                                        data: {
                                            title: string
                                            subtitle: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            submit_text: string
                                            aria_label: string
                                            partner_signup_redirect: boolean
                                            form_name: string
                                            disclaimer_copy: {richText: any}
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {width: number; height: number}
                                            }
                                            redirect_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyImagesMarqueeWithCta'
                      primary: {
                          heading: string
                          excerpt: string
                          ctaText: string
                          ctaLink: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyLandingHero'
                      primary: {
                          headline: string
                          headline_background_color: string
                          title: string
                          cta_text: string
                          primary_cta_text: string
                          cta_destination: string
                          inverse: boolean
                          background: string
                          wistia_video_id: string
                          lead_text: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          primary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          predefined_proof_point_badges: {
                              document:
                                  | {
                                        data: {
                                            proof_point_first: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            proof_point_second: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyRatingsPlusHeadline'
                      primary: {
                          ratings_lead_text: string
                          ratings_cta_text: string
                          ratings_title: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          predefined_ratings: {
                              document:
                                  | {
                                        data: {
                                            lead_text: string
                                            cta_text: string
                                            title: {richText: any}
                                            cta_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            ratings: Array<{
                                                rating: {
                                                    document:
                                                        | {
                                                              data: {
                                                                  stars: string
                                                                  rating_number: number
                                                                  link: string
                                                                  logo: {
                                                                      alt: string
                                                                      copyright: string
                                                                      url: string
                                                                      dimensions: {
                                                                          height: number
                                                                          width: number
                                                                      }
                                                                  }
                                                              }
                                                          }
                                                        | Record<PropertyKey, never>
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{
                          rating: {
                              document:
                                  | {
                                        data: {
                                            stars: string
                                            rating_number: number
                                            link: string
                                            logo: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {height: number; width: number}
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyResourceSlider'
                      primary: {
                          title: string
                          top_link_text: string
                          resourceSliderDescription: string
                          top_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          card_title: string
                          card_description: string
                          card_cta: string
                          category: string
                          language: string
                          to: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          card_image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodySignUpHero'
                      primary: {
                          pre_title: string
                          title: string
                          email_input_placeholder: string
                          aria_label: string
                          submit_text: string
                          email_input_error_text: string
                          wistia_video_id: string
                          lead_text: {richText: any}
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          thumbnail_video_mp4: {url: string}
                          thumbnail_video_webm: {url: string}
                          video_poster_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodySocialProof'
                      primary: {title: string; inverse: boolean}
                      items: Array<{
                          quote: string
                          full_name: string
                          person_byline: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          predefined_testimonial: {
                              document:
                                  | {
                                        data: {
                                            quote: string
                                            attribution_name: string
                                            attribution_title: string
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyStickyCards'
                      primary: {headline: string}
                      items: Array<{
                          headline: string
                          description: string
                          backgroundColor: string
                          ctaLabel: string
                          ctaLink: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          videoMp4: {url: string}
                          videoPosterImage: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyStickyNavSections'
                      primary: {navigation_text: string; cta_text: string}
                      items: Array<{
                          title: string
                          card_1_title: string
                          card_1_body: string
                          card_2_title: string
                          card_2_body: string
                          card_3_title: string
                          card_3_body: string
                          subtitle: {richText: any}
                          image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          card_1_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_1_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_1_video_webm: {url: string}
                          card_1_video_mp4: {url: string}
                          card_2_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_2_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_2_video_webm: {url: string}
                          card_2_video_mp4: {url: string}
                          card_3_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_3_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_3_video_webm: {url: string}
                          card_3_video_mp4: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyTabbedCarousel'
                      primary: {title: string}
                      items: Array<{
                          tab_title: string
                          carousel: {
                              document:
                                  | {
                                        data: {
                                            items: Array<{
                                                heading: string
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    gatsbyImageData: any
                                                    dimensions: {height: number; width: number}
                                                }
                                                link: {
                                                    link_type: PrismicLinkTypeEnum
                                                    uid: string
                                                    type: string
                                                    lang: string
                                                    target: string
                                                    url: string
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyTabbedHero'
                      items: Array<{
                          tab_title: string
                          is_default: boolean
                          tab: {
                              document:
                                  | {
                                        data: {
                                            title: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            button_label: string
                                            secondary_cta_label: string
                                            lead_image: {
                                                alt: string
                                                url: string
                                                copyright: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            lead_text: {richText: any}
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            button_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            secondary_cta_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            image: {
                                                alt: string
                                                url: string
                                                copyright: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            lottie: {url: string}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyUseCase'
                      primary: {
                          title: string
                          subtitle: string
                          cta: string
                          secondary_cta_label: string
                          secondary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{label: string; value: string; icon: {fluid: {base64: string}}}>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyVideoHero'
                      primary: {
                          title: string
                          signup_label: string
                          cta_text: string
                          lead_text: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          video_poster_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          social_proof_text: string
                          social_proof_icon: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicHomepageV4DataBodyVideoPopoverWithText'
                      id: string
                      primary: {
                          text_orientation: string
                          pre_title: string
                          title: string
                          body_text: string
                          wistia_video_id: string
                          cta_text: string
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | Record<PropertyKey, never>
            >
        }
    }
}

export type FeatureBlockWithMarqueeFragment = {
    __typename: 'PrismicHomepageV4DataBodyFeatureBlockWithMarquee'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        headline: string
        cta_label: string
        outline: {richText: any}
        pre_cta_links: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type HomepageV4CustomerLogosPlusCtaFragment = {
    __typename: 'PrismicHomepageV4DataBodyCustomerLogosPlusCta'
    primary: {
        title: string
        cta_text: string
        marquee_mode: boolean
        marquee_scroll_speed: string
        marquee_width: string
        background_color: string
        stat_1_highlight: string
        stat_2_highlight: string
        stat_3_highlight: string
        stat_1_body: string
        stat_2_body: string
        stat_3_body: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type VideoHeroV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyVideoHero'
    primary: {
        title: string
        signup_label: string
        cta_text: string
        lead_text: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        video_poster_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        social_proof_text: string
        social_proof_icon: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type GetStartedV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyGetStarted'
    primary: {
        title: string
        error_message: string
        button_label: string
        input_placeholder: string
        form_subtitle: string
        aria_label: string
        variant: string
        section_color: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{highlight_item: string}>
}

export type StickyNavSectionsFragment = {
    __typename: 'PrismicHomepageV4DataBodyStickyNavSections'
    primary: {navigation_text: string; cta_text: string}
    items: Array<{
        title: string
        card_1_title: string
        card_1_body: string
        card_2_title: string
        card_2_body: string
        card_3_title: string
        card_3_body: string
        subtitle: {richText: any}
        image: {
            alt: string
            url: string
            copyright: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        card_1_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_1_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_1_video_webm: {url: string}
        card_1_video_mp4: {url: string}
        card_2_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_2_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_2_video_webm: {url: string}
        card_2_video_mp4: {url: string}
        card_3_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_3_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_3_video_webm: {url: string}
        card_3_video_mp4: {url: string}
    }>
}

export type ResourceSliderFragment = {
    __typename: 'PrismicHomepageV4DataBodyResourceSlider'
    primary: {
        title: string
        top_link_text: string
        resourceSliderDescription: string
        top_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        card_title: string
        card_description: string
        card_cta: string
        category: string
        language: string
        to: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        card_image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type AnimationBlockFragment = {
    __typename: 'PrismicHomepageV4DataBodyAnimationBlock'
    primary: {
        title: string
        animation_frames: number
        body: {richText: any}
        lottie_json_file: {url: string}
        placeholder: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type FeaturePanelFragment = {
    __typename: 'PrismicHomepageV4DataBodyFeaturePanel'
    primary: {
        background_color: string
        is_media_on_the_right: boolean
        subtitle: string
        subtitle_color: string
        title: string
        cta_label: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        content: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type UseCaseV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyUseCase'
    primary: {
        title: string
        subtitle: string
        cta: string
        secondary_cta_label: string
        secondary_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{label: string; value: string; icon: {fluid: {base64: string}}}>
}

export type StickyCardsFragment = {
    __typename: 'PrismicHomepageV4DataBodyStickyCards'
    primary: {headline: string}
    items: Array<{
        headline: string
        description: string
        backgroundColor: string
        ctaLabel: string
        ctaLink: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {alt: string; url: string; dimensions: {height: number; width: number}}
        videoMp4: {url: string}
        videoPosterImage: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type HomepageV4LandingHeroSliceFragment = {
    __typename: 'PrismicHomepageV4DataBodyLandingHero'
    primary: {
        headline: string
        headline_background_color: string
        title: string
        cta_text: string
        primary_cta_text: string
        cta_destination: string
        inverse: boolean
        background: string
        wistia_video_id: string
        lead_text: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        primary_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        predefined_proof_point_badges: {
            document:
                | {
                      data: {
                          proof_point_first: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                          proof_point_second: Array<{
                              title: string
                              subtitle: string
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type FeatureBlockV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyFeatureBlock'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        background: string
        headline: string
        is_circular_image: boolean
        cta_label: string
        cta_hash_link: string
        wistia_video_id: string
        description: {richText: any}
        pre_cta_links: {richText: any}
        predefined_feature_block: {
            document:
                | {
                      data: {
                          title: string
                          subtitle: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          body: {richText: any}
                      }
                  }
                | Record<PropertyKey, never>
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }
}

export type SocialProofV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodySocialProof'
    primary: {title: string; inverse: boolean}
    items: Array<{
        quote: string
        full_name: string
        person_byline: string
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        predefined_testimonial: {
            document:
                | {
                      data: {
                          quote: string
                          attribution_name: string
                          attribution_title: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type ImagesMarqueeWithCtaFragment = {
    __typename: 'PrismicHomepageV4DataBodyImagesMarqueeWithCta'
    primary: {
        heading: string
        excerpt: string
        ctaText: string
        ctaLink: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type CardGridV2Fragment = {
    __typename: 'PrismicHomepageV4DataBodyCardGridV2'
    primary: {title: string}
    items: Array<{
        card_title: string
        card_description: string
        card_cta_text: string
        card_image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        card_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type RatingsPlusHeadlineV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyRatingsPlusHeadline'
    primary: {
        ratings_lead_text: string
        ratings_cta_text: string
        ratings_title: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        predefined_ratings: {
            document:
                | {
                      data: {
                          lead_text: string
                          cta_text: string
                          title: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          ratings: Array<{
                              rating: {
                                  document:
                                      | {
                                            data: {
                                                stars: string
                                                rating_number: number
                                                link: string
                                                logo: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{
        rating: {
            document:
                | {
                      data: {
                          stars: string
                          rating_number: number
                          link: string
                          logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type SignupHeroV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodySignUpHero'
    primary: {
        pre_title: string
        title: string
        email_input_placeholder: string
        aria_label: string
        submit_text: string
        email_input_error_text: string
        wistia_video_id: string
        lead_text: {richText: any}
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        thumbnail_video_mp4: {url: string}
        thumbnail_video_webm: {url: string}
        video_poster_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{highlight_item: string}>
}

export type VideoPopoverWithTextV4Fragment = {
    __typename: 'PrismicHomepageV4DataBodyVideoPopoverWithText'
    id: string
    primary: {
        text_orientation: string
        pre_title: string
        title: string
        body_text: string
        wistia_video_id: string
        cta_text: string
        video_mp4: {url: string}
        video_webm: {url: string}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type TabbedCarouselFragment = {
    __typename: 'PrismicHomepageV4DataBodyTabbedCarousel'
    primary: {title: string}
    items: Array<{
        tab_title: string
        carousel: {
            document:
                | {
                      data: {
                          items: Array<{
                              heading: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  gatsbyImageData: any
                                  dimensions: {height: number; width: number}
                              }
                              link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type TabbedHeroFragment = {
    __typename: 'PrismicHomepageV4DataBodyTabbedHero'
    items: Array<{
        tab_title: string
        is_default: boolean
        tab: {
            document:
                | {
                      data: {
                          title: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          button_label: string
                          secondary_cta_label: string
                          lead_image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          lead_text: {richText: any}
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          button_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          secondary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          lottie: {url: string}
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type BentoBoxFragment = {
    __typename: 'PrismicHomepageV4DataBodyBentoBox'
    primary: {title: string; subtitle: string}
    items: Array<{
        place_on_new_row: boolean
        card_title: string
        card_subtitle: string
        image_alignment: string
        card_image: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        video_poster: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }>
}

export type CreateInvoicesApprovalsPageQueryVariables = Exact<{[key: string]: never}>

export type CreateInvoicesApprovalsPageQuery = {
    allPrismicInvoicesApprovals: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type InvoicesApprovalsQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type InvoicesApprovalsQuery = {
    allPrismicInvoicesApprovals: {
        nodes: Array<{
            data: {
                allow_indexing: boolean
                meta_title: string
                meta_description: string
                title: string
                headerCta: string
                pageCtaText: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                headerCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                headerLink: {richText: any}
                pageCtaLink: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                approvalSuccess: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    approval_success_text: {richText: any}
                }>
                rejectionSuccess: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    rejection_success_text: {richText: any}
                }>
                errorProcessingRequest: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    error_processing_request_text: {richText: any}
                }>
            }
        }>
    }
}

export type CreateLegalPageQueryVariables = Exact<{[key: string]: never}>

export type CreateLegalPageQuery = {
    allPrismicLegalPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type LegalDocumentsGridFragment = {
    data: {
        title: string
        historical_documents_title: string
        documents: Array<{
            title: string
            link_text: string
            link: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }>
        historical_documents: Array<{
            document_title: string
            link_text: string
            link: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }>
    }
}

export type SecondaryLegalDocumentsGridFragment = {
    data: {
        title: string
        locale_code: string
        historical_documents_title: string
        documents: Array<{
            title: string
            link_text: string
            link: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }>
        historical_documents: Array<{
            document_title: string
            link_text: string
            link: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
        }>
    }
}

export type LegalPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type LegalPageQuery = {
    prismicLegalPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }
    }
    allPrismicLegalDocuments: {
        nodes: Array<{
            _previewable: string
            data: {
                title: string
                historical_documents_title: string
                documents: Array<{
                    title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                historical_documents: Array<{
                    document_title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type CreateMeetingBookerPageQueryVariables = Exact<{[key: string]: never}>

export type CreateMeetingBookerPageQuery = {
    allPrismicMeetingBookerPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type MeetingBookerPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type MeetingBookerPageQuery = {
    prismicMeetingBookerPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            success_messages: Array<{
                cta_label: string
                success_title: string
                success_body: string
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                image: {
                    alt: string
                    url: string
                    copyright: string
                    dimensions: {height: number; width: number}
                }
            }>
        }
    }
}

export type CreateOnDemandResourcePageQueryVariables = Exact<{[key: string]: never}>

export type CreateOnDemandResourcePageQuery = {
    allPrismicOnDemandResourcePage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type OnDemandResourcePageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
}>

export type OnDemandResourcePageQuery = {
    prismicOnDemandResourcePage: {
        _previewable: string
        id: string
        uid: string
        lang: string
        type: string
        last_publication_date: any
        alternate_languages: Array<{uid: string; lang: string; type: string}>
        data: {
            meta_title: string
            meta_description: string
            title: string
            duration: string
            description: string
            speaker_name: string
            speaker_title: string
            speaker_description: string
            language_code: string
            wistia_id: string
            watch_more_title: string
            watch_more_top_link_text: string
            watch_more_card_cta: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            title_image: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            long_description: {richText: any}
            speaker_image: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            category: {document: {id: string; data: {name: string}} | Record<PropertyKey, never>}
            video_thumbnail: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            watch_more_top_link: {
                link_type: PrismicLinkTypeEnum
                uid: string
                type: string
                lang: string
                target: string
                url: string
            }
            on_demand_resource_form: {
                document:
                    | {
                          data: {
                              form_title: string
                              form_description: string
                              submit_button_text: string
                              success_message: string
                              recurrent_visitor_message: string
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              imperative_consents_production: Array<{
                                  consent: {
                                      document:
                                          | {
                                                _previewable: string
                                                lang: string
                                                data: {
                                                    type: string
                                                    isDefault: boolean
                                                    subscriptionTypeStaging: {
                                                        subscriptionId: number
                                                    }
                                                    subscriptionTypeProduction: {
                                                        subscriptionId: number
                                                    }
                                                    text: {richText: any}
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                              imperative_consents_staging: Array<{
                                  consent: {
                                      document:
                                          | {
                                                _previewable: string
                                                lang: string
                                                data: {
                                                    type: string
                                                    isDefault: boolean
                                                    subscriptionTypeStaging: {
                                                        subscriptionId: number
                                                    }
                                                    subscriptionTypeProduction: {
                                                        subscriptionId: number
                                                    }
                                                    text: {richText: any}
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
    allPrismicOnDemandResourcePage: {
        nodes: Array<{
            _previewable: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            data: {
                title: string
                duration: string
                description: string
                language_code: string
                title_image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                category: {
                    document: {id: string; data: {name: string}} | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type CreatePartnerBigformPageQueryVariables = Exact<{[key: string]: never}>

export type CreatePartnerBigformPageQuery = {
    allPrismicPartnerBigformPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type PartnerBigformPageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type PartnerBigformPageQuery = {
    prismicPartnerBigformPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            form_title: string
            partner: string
            thank_you_title: string
            thank_you_subtitle: string
            submit_button_text: string
            show_description_field: boolean
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            partner_logo: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            partner_channel: Array<{
                preselected_channel: string
                label: string
                accounting_partner: string
                affiliate_partner: string
                consulting_partner: string
                integration_partner: string
                error: string
                placeholder: string
            }>
            social_proof_logos_section: {
                document:
                    | {
                          data: {
                              title: string
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type CreatePartnerPageQueryVariables = Exact<{[key: string]: never}>

export type CreatePartnerPageQuery = {
    allPrismicPartner: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type PartnerTemplateQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type PartnerTemplateQuery = {
    allPrismicPartner: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                hero_section: Array<{
                    title: string
                    hero_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    pre_title: {richText: any}
                    lead_text: {richText: any}
                }>
                signup_banner: {
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
                social_proof_logos_section: {
                    document:
                        | {
                              data: {
                                  title: string
                                  logos: Array<{
                                      icon: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                featured_section: Array<{
                    title: string
                    cta_label: string
                    featured_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    lead_text: {richText: any}
                    cta_link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
    allPrismicTemplatePartner: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_description: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: Array<
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadline'
                          primary: {
                              predefined_logos: {
                                  document:
                                      | {
                                            data: {
                                                title: {richText: any}
                                                logos: Array<{
                                                    icon: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }>
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                              customer_logos_title: {richText: any}
                          }
                          items: Array<{
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodyFeatureBlock'
                          primary: {
                              title_over_section: string
                              title: string
                              inverse: boolean
                              background: string
                              headline: string
                              cta_label: string
                              is_circular_image: boolean
                              cta_hash_link: string
                              wistia_video_id: string
                              description: {richText: any}
                              pre_cta_links: {richText: any}
                              predefined_feature_block: {
                                  document:
                                      | {
                                            data: {
                                                title: string
                                                subtitle: string
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                body: {richText: any}
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                              cta_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              video_mp4: {url: string}
                              video_webm: {url: string}
                          }
                      }
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodyGetStarted'
                          primary: {
                              title: string
                              error_message: string
                              button_label: string
                              input_placeholder: string
                              form_subtitle: string
                              aria_label: string
                              variant: string
                              section_color: string
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              predefined_signup_banner: {
                                  document:
                                      | {
                                            _previewable: string
                                            type: string
                                            data: {
                                                title: string
                                                subtitle: string
                                                email_input_placeholder: string
                                                email_input_error_text: string
                                                submit_text: string
                                                aria_label: string
                                                partner_signup_redirect: boolean
                                                form_name: string
                                                disclaimer_copy: {richText: any}
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {width: number; height: number}
                                                }
                                                redirect_link: {
                                                    link_type: PrismicLinkTypeEnum
                                                    uid: string
                                                    type: string
                                                    lang: string
                                                    target: string
                                                    url: string
                                                }
                                                form_production: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                                form_staging: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }
                          items: Array<{highlight_item: string}>
                      }
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodyMediaItemGrid'
                          primary: {title: string; layout: string; background: string}
                          items: Array<{
                              item_title: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              item_description: {richText: any}
                          }>
                      }
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodyRatingsPlusHeadline'
                          primary: {
                              ratings_lead_text: string
                              ratings_cta_text: string
                              ratings_title: {richText: any}
                              cta_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              predefined_ratings: {
                                  document:
                                      | {
                                            data: {
                                                lead_text: string
                                                cta_text: string
                                                title: {richText: any}
                                                cta_link: {
                                                    link_type: PrismicLinkTypeEnum
                                                    uid: string
                                                    type: string
                                                    lang: string
                                                    target: string
                                                    url: string
                                                }
                                                ratings: Array<{
                                                    rating: {
                                                        document:
                                                            | {
                                                                  data: {
                                                                      stars: string
                                                                      rating_number: number
                                                                      link: string
                                                                      logo: {
                                                                          alt: string
                                                                          copyright: string
                                                                          url: string
                                                                          dimensions: {
                                                                              height: number
                                                                              width: number
                                                                          }
                                                                      }
                                                                  }
                                                              }
                                                            | Record<PropertyKey, never>
                                                    }
                                                }>
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }
                          items: Array<{
                              rating: {
                                  document:
                                      | {
                                            data: {
                                                stars: string
                                                rating_number: number
                                                link: string
                                                logo: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                    | {
                          __typename: 'PrismicTemplatePartnerDataBodySocialProof'
                          primary: {title: string; inverse: boolean}
                          items: Array<{
                              quote: string
                              full_name: string
                              person_byline: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                              predefined_testimonial: {
                                  document:
                                      | {
                                            data: {
                                                quote: string
                                                attribution_name: string
                                                attribution_title: string
                                                image: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                >
            }
        }>
    }
}

export type PartnerTemplateGetStartedFragment = {
    __typename: 'PrismicTemplatePartnerDataBodyGetStarted'
    primary: {
        title: string
        error_message: string
        button_label: string
        input_placeholder: string
        form_subtitle: string
        aria_label: string
        variant: string
        section_color: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {width: number; height: number}
        }
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{highlight_item: string}>
}

export type PartnerTemplateFeatureBlockFragment = {
    __typename: 'PrismicTemplatePartnerDataBodyFeatureBlock'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        background: string
        headline: string
        cta_label: string
        is_circular_image: boolean
        cta_hash_link: string
        wistia_video_id: string
        description: {richText: any}
        pre_cta_links: {richText: any}
        predefined_feature_block: {
            document:
                | {
                      data: {
                          title: string
                          subtitle: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          body: {richText: any}
                      }
                  }
                | Record<PropertyKey, never>
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
    }
}

export type PartnerTemplateCustomersLogosPlusHeadlineFragment = {
    __typename: 'PrismicTemplatePartnerDataBodyCustomersLogosPlusHeadline'
    primary: {
        predefined_logos: {
            document:
                | {
                      data: {
                          title: {richText: any}
                          logos: Array<{
                              icon: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
        customer_logos_title: {richText: any}
    }
    items: Array<{
        icon: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type PartnerTemplateRatingsPlusHeadlineFragment = {
    __typename: 'PrismicTemplatePartnerDataBodyRatingsPlusHeadline'
    primary: {
        ratings_lead_text: string
        ratings_cta_text: string
        ratings_title: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        predefined_ratings: {
            document:
                | {
                      data: {
                          lead_text: string
                          cta_text: string
                          title: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          ratings: Array<{
                              rating: {
                                  document:
                                      | {
                                            data: {
                                                stars: string
                                                rating_number: number
                                                link: string
                                                logo: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }
                                        }
                                      | Record<PropertyKey, never>
                              }
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{
        rating: {
            document:
                | {
                      data: {
                          stars: string
                          rating_number: number
                          link: string
                          logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type PartnerTemplateSocialProofFragment = {
    __typename: 'PrismicTemplatePartnerDataBodySocialProof'
    primary: {title: string; inverse: boolean}
    items: Array<{
        quote: string
        full_name: string
        person_byline: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        predefined_testimonial: {
            document:
                | {
                      data: {
                          quote: string
                          attribution_name: string
                          attribution_title: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type PartnerTemplateMediaItemGridFragment = {
    __typename: 'PrismicTemplatePartnerDataBodyMediaItemGrid'
    primary: {title: string; layout: string; background: string}
    items: Array<{
        item_title: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        item_description: {richText: any}
    }>
}

export type CreatePartnershipCasePageQueryVariables = Exact<{[key: string]: never}>

export type CreatePartnershipCasePageQuery = {
    allPrismicPartnershipCase: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type PartnershipCaseQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
}>

export type PartnershipCaseQuery = {
    allPrismicPartnershipCase: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                challenge_title: string
                result_title: string
                solution_title: string
                related_cases_title: string
                related_cases_cta_text: string
                hero_section: Array<{
                    pre_title: string
                    title: string
                    wistia_video_id: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                details_card: Array<{
                    location: string
                    partner_type: string
                    client_size: string
                    quote: string
                    quote_author: string
                    logo: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    quote_author_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                challenge_lead_text: {richText: any}
                challenge_list: Array<{
                    challenge_list_item_title: string
                    challenge_list_item_body: {richText: any}
                }>
                result_lead_text: {richText: any}
                result_list: Array<{
                    result_list_item_title: string
                    result_list_item_body: {richText: any}
                }>
                solution_lead_text: {richText: any}
                related_cases: Array<{
                    body: string
                    case_title: string
                    cta_link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        gatsbyImageData: any
                        dimensions: {height: number; width: number}
                    }
                }>
                predefined_signup_banner: {
                    type: string
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type CreatePerksInternalPageQueryVariables = Exact<{[key: string]: never}>

export type CreatePerksInternalPageQuery = {
    allPrismicPerksInternalPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type PerksInternalPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type PerksInternalPageQuery = {
    allPrismicPerksInternalPage: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                perk_card_cta_text: string
                show_more_perks_text: string
                questions_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                hero: Array<{
                    title: string
                    cta_text: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                    proof_point_badges: {
                        document:
                            | {
                                  data: {
                                      proof_point_first: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                      proof_point_second: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                feature_blocks: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                }>
                perks: Array<{
                    perk: {
                        document:
                            | {
                                  id: string
                                  data: {
                                      company_name: string
                                      perk_details: string
                                      logo: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                      link: {
                                          link_type: PrismicLinkTypeEnum
                                          uid: string
                                          type: string
                                          lang: string
                                          target: string
                                          url: string
                                      }
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                perks_partner: Array<{
                    title: string
                    cta_text: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    body: {richText: any}
                    cta_link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                questions_answers: Array<{question: string; answer: {richText: any}}>
            }
        }>
    }
}

export type CreatePricingPlanPickerQueryQueryVariables = Exact<{[key: string]: never}>

export type CreatePricingPlanPickerQueryQuery = {
    allPrismicPricingPlanPicker: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type PricingPlanPickerQueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
}>

export type PricingPlanPickerQuery = {
    allPrismicPricingPlanPicker: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                loading_text: string
                start_again_text: string
                plan_result_title: string
                plan_result_subtitle: string
                compare_plans_text: string
                billing_cycle_text: string
                open_graph_image: {
                    alt: string
                    url: string
                    copyright: string
                    dimensions: {height: number; width: number}
                }
                questions: Array<{
                    question: string
                    option_1: string
                    option_2: string
                    option_3: string
                    option_4: string
                }>
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                signup_modal_free: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                signup_modal_pro: Array<{
                    title: string
                    subtitle: string
                    highlighted_feature_1: string
                    highlighted_feature_2: string
                    highlighted_feature_3: string
                    image: {fluid: {base64: string}}
                }>
                starter_tier_features: Array<{feature: string; tooltip: string}>
                essential_tier_features: Array<{feature: string; tooltip: string}>
                advanced_tier_features: Array<{feature: string; tooltip: string}>
                beyond_tier_features: Array<{feature: string; tooltip: string}>
            }
        }>
    }
    allPrismicPricingTiers: {
        nodes: Array<{
            lang: string
            data: {
                pricing_tiers: Array<{
                    pricing_tier: {
                        document:
                            | {
                                  data: {
                                      name: string
                                      per_month_text: string
                                      cost_subtext: string
                                      excerpt: string
                                      cta_text: string
                                      features_title: string
                                      annual_cost: string
                                      monthly_cost: string
                                      monthly_billing_screen_reader_alt: string
                                      annual_billing_screen_reader_alt: string
                                      monthly_cost_subtext_extra: string
                                      annual_cost_subtext_extra: string
                                      footnote: string
                                      second_footnote: string
                                      monthly_billed_cost: number
                                      annually_billed_cost: number
                                      monthly_billed_user_cost: number
                                      annually_billed_user_cost: number
                                      cta_variant: string
                                      free_users_included: number
                                      features: Array<{
                                          feature: string
                                          disabled_monthly: boolean
                                          is_highlighted: boolean
                                          tooltip_text: string
                                      }>
                                      cashback_text: {richText: any}
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
            }
        }>
    }
}

export type CreatePricingV3PageQueryVariables = Exact<{[key: string]: never}>

export type CreatePricingV3PageQuery = {
    allPrismicPricingV3Page: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean; excludeProduction: boolean}
        }>
    }
}

export type PricingV3PageQueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
}>

export type PricingV3PageQuery = {
    prismicPricingV3Page: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            body: Array<
                | {
                      __typename: 'PrismicPricingV3PageDataBodyAccordion'
                      primary: {headline: string; subheadline: string}
                      items: Array<{title: string; content: {richText: any}}>
                  }
                | {
                      __typename: 'PrismicPricingV3PageDataBodyComparisonTable'
                      primary: {
                          title: string
                          table: {
                              document:
                                  | {
                                        data: {
                                            mainColumnLabel: string
                                            tableAriaLabel: string
                                            checkAltText: string
                                            crossAltText: string
                                            tiers: Array<{name: string}>
                                            categoriesData: Array<{
                                                primary: {
                                                    name: string
                                                    icon: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                                items: Array<{
                                                    feature: string
                                                    tooltip_label: string
                                                    tooltip_aria_label: string
                                                    tier_1_text: string
                                                    tier_1_value: string
                                                    tier_2_text: string
                                                    tier_2_value: string
                                                    tier_3_text: string
                                                    tier_3_value: string
                                                    tier_4_text: string
                                                    tier_4_value: string
                                                }>
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicPricingV3PageDataBodyCustomerLogosPlusCta'
                      primary: {
                          title: string
                          cta_text: string
                          marquee_mode: boolean
                          marquee_scroll_speed: string
                          marquee_width: string
                          background_color: string
                          stat_1_highlight: string
                          stat_2_highlight: string
                          stat_3_highlight: string
                          stat_1_body: string
                          stat_2_body: string
                          stat_3_body: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicPricingV3PageDataBodyHighlightsHero'
                      primary: {headline: string; subheadline: string}
                      items: Array<{text: string}>
                  }
                | {
                      __typename: 'PrismicPricingV3PageDataBodyHighlightsSignup'
                      primary: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          submit_text: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                      items: Array<{text: string}>
                  }
                | {
                      __typename: 'PrismicPricingV3PageDataBodyPricingV3TierGrid'
                      primary: {
                          tabMonthly: string
                          tabYearly: string
                          userPlaceholderSingular: string
                          userPlaceholderPlural: string
                          incrementUserAltText: string
                          decrementUserAltText: string
                          counterInputAriaLabel: string
                          counterAriaLabel: string
                      }
                      items: Array<{
                          pricing_tier: {
                              document:
                                  | {
                                        data: {
                                            footnote: string
                                            tierName: string
                                            tierDescription: string
                                            badgeText: string
                                            tierVariant: string
                                            perMonthText: string
                                            includedUsersText: string
                                            additionalUsersCostText: string
                                            ctaText: string
                                            ctaModalTitle: string
                                            ctaModalSubtitle: string
                                            featureTitle: string
                                            ctaLink: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            featureList: {
                                                document:
                                                    | {
                                                          data: {
                                                              body: Array<{
                                                                  __typename: 'PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategory'
                                                                  primary: {category_title: string}
                                                                  items: Array<{
                                                                      feature: string
                                                                      enabled: string
                                                                  }>
                                                              }>
                                                          }
                                                      }
                                                    | Record<PropertyKey, never>
                                            }
                                            pricingModel: {
                                                document:
                                                    | {
                                                          data: {
                                                              monthlyCost: number
                                                              yearlyCost: number
                                                              includedUsers: number
                                                              maxUsers: number
                                                              additionalUsersCostMonthly: number
                                                              additionalUsersCostYearly: number
                                                          }
                                                      }
                                                    | Record<PropertyKey, never>
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
            >
        }
    }
}

export type PricingV3HighlightsHeroFragment = {
    __typename: 'PrismicPricingV3PageDataBodyHighlightsHero'
    primary: {headline: string; subheadline: string}
    items: Array<{text: string}>
}

export type PricingV3AccordionFragment = {
    __typename: 'PrismicPricingV3PageDataBodyAccordion'
    primary: {headline: string; subheadline: string}
    items: Array<{title: string; content: {richText: any}}>
}

export type PricingV3HighlightsSignupFragment = {
    __typename: 'PrismicPricingV3PageDataBodyHighlightsSignup'
    primary: {
        title: string
        subtitle: string
        email_input_placeholder: string
        submit_text: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
    }
    items: Array<{text: string}>
}

export type PricingV3CustomerLogosPlusCtaFragment = {
    __typename: 'PrismicPricingV3PageDataBodyCustomerLogosPlusCta'
    primary: {
        title: string
        cta_text: string
        marquee_mode: boolean
        marquee_scroll_speed: string
        marquee_width: string
        background_color: string
        stat_1_highlight: string
        stat_2_highlight: string
        stat_3_highlight: string
        stat_1_body: string
        stat_2_body: string
        stat_3_body: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type PricingV3ComparisonTableFragment = {
    __typename: 'PrismicPricingV3PageDataBodyComparisonTable'
    primary: {
        title: string
        table: {
            document:
                | {
                      data: {
                          mainColumnLabel: string
                          tableAriaLabel: string
                          checkAltText: string
                          crossAltText: string
                          tiers: Array<{name: string}>
                          categoriesData: Array<{
                              primary: {
                                  name: string
                                  icon: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }
                              items: Array<{
                                  feature: string
                                  tooltip_label: string
                                  tooltip_aria_label: string
                                  tier_1_text: string
                                  tier_1_value: string
                                  tier_2_text: string
                                  tier_2_value: string
                                  tier_3_text: string
                                  tier_3_value: string
                                  tier_4_text: string
                                  tier_4_value: string
                              }>
                          }>
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
}

export type PricingV3TierGridFragment = {
    __typename: 'PrismicPricingV3PageDataBodyPricingV3TierGrid'
    primary: {
        tabMonthly: string
        tabYearly: string
        userPlaceholderSingular: string
        userPlaceholderPlural: string
        incrementUserAltText: string
        decrementUserAltText: string
        counterInputAriaLabel: string
        counterAriaLabel: string
    }
    items: Array<{
        pricing_tier: {
            document:
                | {
                      data: {
                          footnote: string
                          tierName: string
                          tierDescription: string
                          badgeText: string
                          tierVariant: string
                          perMonthText: string
                          includedUsersText: string
                          additionalUsersCostText: string
                          ctaText: string
                          ctaModalTitle: string
                          ctaModalSubtitle: string
                          featureTitle: string
                          ctaLink: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          featureList: {
                              document:
                                  | {
                                        data: {
                                            body: Array<{
                                                __typename: 'PrismicPricingV3PricingTierFeatureListDataBodyPricingV3PricingTierCategory'
                                                primary: {category_title: string}
                                                items: Array<{feature: string; enabled: string}>
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          pricingModel: {
                              document:
                                  | {
                                        data: {
                                            monthlyCost: number
                                            yearlyCost: number
                                            includedUsers: number
                                            maxUsers: number
                                            additionalUsersCostMonthly: number
                                            additionalUsersCostYearly: number
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }>
}

export type CreatePricingPageQueryVariables = Exact<{[key: string]: never}>

export type CreatePricingPageQuery = {
    allPrismicPricingPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean; excludeProduction: boolean}
        }>
    }
}

export type PricingPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
    uid: Scalars['String']['input']
}>

export type PricingPageQuery = {
    prismicPricingPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            show_tooltips: boolean
            tables_title: string
            tables_fine_print: string
            tables_tick_screen_reader_alt: string
            questions_title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            title_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            title: {richText: any}
            comparison_tables: Array<{
                comparison_table: {
                    document:
                        | {
                              _previewable: string
                              id: string
                              data: {
                                  title: string
                                  features: Array<{
                                      name: string
                                      tooltip_description: string
                                      starter1: boolean
                                      essential1: boolean
                                      advanced1: boolean
                                      beyond1: boolean
                                      starter_excerpt: string
                                      essential_excerpt: string
                                      advanced_excerpt: string
                                      beyond_excerpt: string
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            comparison_layover: Array<{heading: string}>
            questions_answers: Array<{question: string; answer: {richText: any}}>
            testimonial: {
                document:
                    | {
                          id: string
                          data: {
                              quote: string
                              attribution_name: string
                              attribution_title: string
                              cta_text: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    rating_number: number
                                                    link: string
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            why_pleo: Array<{
                pre_title: string
                title: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
            }>
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
    prismicPricingTiers: {
        data: {
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            signup_modal_free: Array<{
                title: string
                subtitle: string
                highlighted_feature_1: string
                highlighted_feature_2: string
                highlighted_feature_3: string
                image: {fluid: {base64: string}}
            }>
            signup_modal_pro: Array<{
                title: string
                subtitle: string
                highlighted_feature_1: string
                highlighted_feature_2: string
                highlighted_feature_3: string
                image: {fluid: {base64: string}}
            }>
            pricing_tiers: Array<{
                pricing_tier: {document: {data: {cta_text: string}} | Record<PropertyKey, never>}
            }>
        }
    }
}

export type CreateResourceDetailPageQueryVariables = Exact<{[key: string]: never}>

export type CreateResourceDetailPageQuery = {
    allPrismicResourceDetailPage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type ResourceDetailPageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
}>

export type ResourceDetailPageQuery = {
    prismicResourceDetailPage: {
        _previewable: string
        id: string
        uid: string
        lang: string
        type: string
        last_publication_date: any
        alternate_languages: Array<{uid: string; lang: string; type: string}>
        data: {
            category: string
            description: string
            duration: string
            title: string
            wistia_video_id: string
            tracking_id: string
            meta_title: string
            meta_description: string
            more_videos_section_title: string
            thumbnail: {
                alt: string
                copyright: string
                url: string
                gatsbyImageData: any
                dimensions: {height: number; width: number}
            }
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }
    }
    allPrismicResourceDetailPage: {
        nodes: Array<{
            uid: string
            data: {
                title: string
                description: string
                category: string
                duration: string
                thumbnail: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }
        }>
    }
}

export type CreateRoiCalculatorPageQueryVariables = Exact<{[key: string]: never}>

export type CreateRoiCalculatorPageQuery = {
    allPrismicRoiCalculator: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type RoiCalculatorQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type RoiCalculatorQuery = {
    allPrismicRoiCalculator: {
        nodes: Array<{
            data: {
                meta_title: string
                meta_description: string
                question: string
                previous: string
                next: string
                expenseHandlingMethodLabel: string
                calculationExplanation: string
                calculationExplanationCTA: string
                showPreview: string
                closePreview: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                results: Array<{
                    defaultTitle: string
                    timeSpent: string
                    moneySpent: string
                    timeSaved: string
                    moneySaved: string
                    hoursPerYear: string
                    perYear: string
                    timeSavedIcon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    moneySavedIcon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                welcome: Array<{
                    title: string
                    body: string
                    skip: string
                    start: string
                    companyNameLabel: string
                    companyNamePlaceholder: string
                }>
                numEmployees: Array<{
                    label: string
                    icon1: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon2: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon3: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                numExpenses: Array<{
                    label: string
                    icon1: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon2: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon3: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                avgExpenseAmount: Array<{
                    label: string
                    icon1: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon2: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon3: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                avgMonthlySalary: Array<{
                    label: string
                    icon1: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon2: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    icon3: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                expenseHandlingMethodManual: Array<{
                    title: string
                    description: string
                    icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                expenseHandlingMethodSemiAutomatic: Array<{
                    title: string
                    description: string
                    icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                expenseHandlingMethodAutomatic: Array<{
                    title: string
                    description: string
                    icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                final: Array<{
                    title: string
                    body: string
                    emailLabel: string
                    emailPlaceholder: string
                    submitText: string
                    downloadNow: string
                    downloadPDF: string
                    copySharableLink: string
                    companyEmailError: string
                }>
                form_production: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
                form_staging: {
                    formId: string
                    consents: {
                        type: string
                        communicationConsents: Array<{id: number; required: boolean}>
                    }
                }
            }
        }>
    }
    allPrismicRoicPreview: {
        nodes: Array<{
            _previewable: string
            lang: string
            data: {
                roic_title: string
                company_name_replacement: string
                highlight_header: string
                highlight_description: string
                highlight_time_saved_text: string
                highlight_money_saved_text: string
                summary_title: string
                processing_method_semi_automatic: string
                processing_method_automatic: string
                processing_method_manual: string
                average_processing_time_unit: string
                average_processing_time_text: string
                expense_claims_error_text: string
                average_claim_fix_time_text: string
                processing_cost_text: string
                money_lost_text: string
                feature_header: string
                cta_question: string
                cta_button_text: string
                summary_description: {richText: any}
                average_processing_time_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                expense_claims_error_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                average_claim_fix_time_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                money_lost_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
                feature: Array<{
                    title: string
                    body: {richText: any}
                    icon: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                cta_button_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }
        }>
    }
}

export type CreateSecondaryNotFoundPageQueryVariables = Exact<{[key: string]: never}>

export type CreateSecondaryNotFoundPageQuery = {
    allPrismicSecondaryNotFoundPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {localeCode: string; excludeSitemap: boolean}
        }>
    }
}

export type SecondaryNotFoundPageQueryVariables = Exact<{
    id: Scalars['String']['input']
}>

export type SecondaryNotFoundPageQuery = {
    prismicSecondaryNotFoundPage: {
        _previewable: string
        data: {
            locale_code: string
            meta_title: string
            meta_description: string
            title: string
            body: string
            ctaText: string
            open_graph_image: {url: string}
            cta_link: {
                document: {type: string; data: {localeCode: string}} | Record<PropertyKey, never>
            }
        }
    }
}

export type CreateSecondaryHomepageQueryVariables = Exact<{[key: string]: never}>

export type CreateSecondaryHomepageQuery = {
    allPrismicSecondaryHomepage: {
        nodes: Array<{
            lang: string
            type: string
            uid: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean; localeCode: string}
        }>
    }
}

export type SecondaryHomepageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    threeColumns: InputMaybe<Scalars['String']['input']>
    twoColumnsAsymmetric: InputMaybe<Scalars['String']['input']>
}>

export type SecondaryHomepageQuery = {
    prismicSecondaryHomepage: {
        _previewable: string
        data: {
            exclude_robots: boolean
            track_visible_sections: boolean
            locale_code: string
            body: Array<
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyAnimationBlock'
                      primary: {
                          title: string
                          animation_frames: number
                          body: {richText: any}
                          lottie_json_file: {url: string}
                          placeholder: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyCustomerLogosPlusCta'
                      primary: {
                          title: string
                          cta_text: string
                          marquee_mode: boolean
                          marquee_scroll_speed: string
                          background_color: string
                          stat_1_highlight: string
                          stat_2_highlight: string
                          stat_3_highlight: string
                          stat_1_body: string
                          stat_2_body: string
                          stat_3_body: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyFeatureBlockWithMarquee'
                      primary: {
                          title_over_section: string
                          title: string
                          inverse: boolean
                          headline: string
                          cta_label: string
                          outline: {richText: any}
                          pre_cta_links: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyFeaturePanel'
                      primary: {
                          background_color: string
                          is_media_on_the_right: boolean
                          subtitle: string
                          subtitle_color: string
                          title: string
                          cta_label: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          content: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyGetStarted'
                      primary: {
                          title: string
                          error_message: string
                          button_label: string
                          input_placeholder: string
                          form_subtitle: string
                          aria_label: string
                          variant: string
                          section_color: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          predefined_signup_banner: {
                              document:
                                  | {
                                        _previewable: string
                                        type: string
                                        data: {
                                            title: string
                                            subtitle: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            submit_text: string
                                            aria_label: string
                                            partner_signup_redirect: boolean
                                            form_name: string
                                            disclaimer_copy: {richText: any}
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {width: number; height: number}
                                            }
                                            redirect_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyResourceSlider'
                      primary: {
                          title: string
                          top_link_text: string
                          resourceSliderDescription: string
                          top_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          card_title: string
                          card_description: string
                          card_cta: string
                          category: string
                          language: string
                          to: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          card_image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyStickyNavSections'
                      primary: {navigation_text: string; cta_text: string}
                      items: Array<{
                          title: string
                          card_1_title: string
                          card_1_body: string
                          card_2_title: string
                          card_2_body: string
                          card_3_title: string
                          card_3_body: string
                          subtitle: {richText: any}
                          image: {
                              alt: string
                              url: string
                              copyright: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          card_1_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_1_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_1_video_webm: {url: string}
                          card_1_video_mp4: {url: string}
                          card_2_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_2_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_2_video_webm: {url: string}
                          card_2_video_mp4: {url: string}
                          card_3_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_3_video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          card_3_video_webm: {url: string}
                          card_3_video_mp4: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyUseCase'
                      primary: {
                          title: string
                          subtitle: string
                          cta: string
                          secondary_cta_label: string
                          secondary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{label: string; value: string; icon: {fluid: {base64: string}}}>
                  }
                | {
                      __typename: 'PrismicSecondaryHomepageDataBodyVideoHero'
                      primary: {
                          title: string
                          signup_label: string
                          cta_text: string
                          lead_text: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          video_poster_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          social_proof_text: string
                          social_proof_icon: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | Record<PropertyKey, never>
            >
        }
    }
}

export type FeatureBlockWithMarqueeSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyFeatureBlockWithMarquee'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        headline: string
        cta_label: string
        outline: {richText: any}
        pre_cta_links: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type HomepageV4CustomerLogosPlusCtaSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyCustomerLogosPlusCta'
    primary: {
        title: string
        cta_text: string
        marquee_mode: boolean
        marquee_scroll_speed: string
        background_color: string
        stat_1_highlight: string
        stat_2_highlight: string
        stat_3_highlight: string
        stat_1_body: string
        stat_2_body: string
        stat_3_body: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type VideoHeroV4SecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyVideoHero'
    primary: {
        title: string
        signup_label: string
        cta_text: string
        lead_text: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        video_poster_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        social_proof_text: string
        social_proof_icon: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type GetStartedV4SecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyGetStarted'
    primary: {
        title: string
        error_message: string
        button_label: string
        input_placeholder: string
        form_subtitle: string
        aria_label: string
        variant: string
        section_color: string
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        predefined_signup_banner: {
            document:
                | {
                      _previewable: string
                      type: string
                      data: {
                          title: string
                          subtitle: string
                          email_input_placeholder: string
                          email_input_error_text: string
                          submit_text: string
                          aria_label: string
                          partner_signup_redirect: boolean
                          form_name: string
                          disclaimer_copy: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          redirect_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                      }
                  }
                | Record<PropertyKey, never>
        }
    }
    items: Array<{highlight_item: string}>
}

export type StickyNavSectionsSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyStickyNavSections'
    primary: {navigation_text: string; cta_text: string}
    items: Array<{
        title: string
        card_1_title: string
        card_1_body: string
        card_2_title: string
        card_2_body: string
        card_3_title: string
        card_3_body: string
        subtitle: {richText: any}
        image: {
            alt: string
            url: string
            copyright: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        card_1_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_1_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_1_video_webm: {url: string}
        card_1_video_mp4: {url: string}
        card_2_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_2_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_2_video_webm: {url: string}
        card_2_video_mp4: {url: string}
        card_3_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_3_video_poster: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        card_3_video_webm: {url: string}
        card_3_video_mp4: {url: string}
    }>
}

export type ResourceSliderSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyResourceSlider'
    primary: {
        title: string
        top_link_text: string
        resourceSliderDescription: string
        top_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        card_title: string
        card_description: string
        card_cta: string
        category: string
        language: string
        to: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        card_image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type AnimationBlockSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyAnimationBlock'
    primary: {
        title: string
        animation_frames: number
        body: {richText: any}
        lottie_json_file: {url: string}
        placeholder: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }
}

export type FeaturePanelSecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyFeaturePanel'
    primary: {
        background_color: string
        is_media_on_the_right: boolean
        subtitle: string
        subtitle_color: string
        title: string
        cta_label: string
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        video_mp4: {url: string}
        video_webm: {url: string}
        content: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type UseCaseV4SecondaryFragment = {
    __typename: 'PrismicSecondaryHomepageDataBodyUseCase'
    primary: {
        title: string
        subtitle: string
        cta: string
        secondary_cta_label: string
        secondary_cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{label: string; value: string; icon: {fluid: {base64: string}}}>
}

export type CreateSecondaryLegalPageQueryVariables = Exact<{[key: string]: never}>

export type CreateSecondaryLegalPageQuery = {
    allPrismicSecondaryLegalPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean; localeCode: string}
        }>
    }
}

export type SecondaryLegalPageQueryVariables = Exact<{
    id: Scalars['String']['input']
}>

export type SecondaryLegalPageQuery = {
    prismicSecondaryLegalPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            locale_code: string
            title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
        }
    }
    allPrismicSecondaryLegalDocuments: {
        nodes: Array<{
            _previewable: string
            data: {
                title: string
                locale_code: string
                historical_documents_title: string
                documents: Array<{
                    title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                historical_documents: Array<{
                    document_title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type CreateSecondaryPricingPageQueryVariables = Exact<{[key: string]: never}>

export type CreateSecondaryPricingPageQuery = {
    allPrismicSecondaryPricingPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean; localeCode: string}
        }>
    }
}

export type SecondaryPricingPageQueryVariables = Exact<{
    id: Scalars['String']['input']
}>

export type SecondaryPricingPageQuery = {
    prismicSecondaryPricingPage: {
        _previewable: string
        data: {
            is_v2: boolean
            locale_code: string
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            show_tooltips: boolean
            tables_title: string
            tables_fine_print: string
            tables_tick_screen_reader_alt: string
            questions_title: string
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            title_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            title: {richText: any}
            table_title_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            comparison_tables: Array<{
                comparison_table: {
                    document:
                        | {
                              _previewable: string
                              id: string
                              data: {
                                  title: string
                                  features: Array<{
                                      name: string
                                      tooltip_description: string
                                      starter1: boolean
                                      essential1: boolean
                                      advanced1: boolean
                                      beyond1: boolean
                                      starter_excerpt: string
                                      essential_excerpt: string
                                      advanced_excerpt: string
                                      beyond_excerpt: string
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            feature_block: Array<{
                heading: string
                description: string
                cta_text: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }>
            comparison_layover: Array<{
                heading: string
                starter_description: string
                essential_description: string
                advanced_description: string
                beyond_description: string
            }>
            tables: Array<{
                table: {
                    document:
                        | {
                              _previewable: string
                              id: string
                              data: {
                                  category: string
                                  essential_heading: string
                                  pro_heading: string
                                  premium_heading: string
                                  beyond_heading: string
                                  rows: Array<{
                                      feature: string
                                      feature_tooltip: string
                                      essential_text: string
                                      essential: boolean
                                      pro_text: string
                                      pro: boolean
                                      premium_text: string
                                      premium: boolean
                                      beyond_text: string
                                      beyond: boolean
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            questions_answers: Array<{question: string; answer: {richText: any}}>
            testimonial: {
                document:
                    | {
                          id: string
                          data: {
                              quote: string
                              attribution_name: string
                              attribution_title: string
                              cta_text: string
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {height: number; width: number}
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    rating_number: number
                                                    link: string
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            why_pleo: Array<{
                pre_title: string
                title: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
            }>
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
    prismicPricingTiers: {
        data: {
            form_production: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            form_staging: {
                formId: string
                consents: {
                    type: string
                    communicationConsents: Array<{id: number; required: boolean}>
                }
            }
            signup_modal_free: Array<{
                title: string
                subtitle: string
                highlighted_feature_1: string
                highlighted_feature_2: string
                highlighted_feature_3: string
                image: {fluid: {base64: string}}
            }>
            signup_modal_pro: Array<{
                title: string
                subtitle: string
                highlighted_feature_1: string
                highlighted_feature_2: string
                highlighted_feature_3: string
                image: {fluid: {base64: string}}
            }>
            pricing_tiers: Array<{
                pricing_tier: {document: {data: {cta_text: string}} | Record<PropertyKey, never>}
            }>
        }
    }
}

export type CreateSlicePageQueryVariables = Exact<{[key: string]: never}>

export type CreateSlicePageQuery = {
    allPrismicSlicePage: {
        nodes: Array<{
            id: string
            uid: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {
                hideFooter: boolean
                hideFooterLinks: boolean
                excludeSitemap: boolean
                excludeProduction: boolean
                hideHeader: boolean
                hideLeftNav: boolean
                hideRightNav: boolean
                headerCtaDestination: string
                headerExploreProductDestination: string
                notification_message: {richText: any}
                parent_document: {uid: string}
            }
        }>
    }
}

export type SlicePageQueryVariables = Exact<{
    uid: Scalars['String']['input']
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    twoColumns: InputMaybe<Scalars['String']['input']>
    twoColumnsAsymmetric: InputMaybe<Scalars['String']['input']>
    threeColumns: InputMaybe<Scalars['String']['input']>
    fourColumns: InputMaybe<Scalars['String']['input']>
}>

export type SlicePageQuery = {
    prismicSlicePage: {
        _previewable: string
        uid: string
        data: {
            track_visible_sections: boolean
            hide_header: boolean
            hide_left_nav: boolean
            hide_right_nav: boolean
            hide_links: boolean
            hide_footer: boolean
            header_cta_destination: string
            header_explore_product_destination: string
            meta_title: string
            meta_description: string
            exclude_robots: boolean
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            body: Array<
                | {
                      __typename: 'PrismicSlicePageDataBodyAccordion'
                      primary: {headline: string; subheadline: string}
                      items: Array<{title: string; itemContent: {richText: any}}>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyBackgroundMediaHero'
                      primary: {
                          title: string
                          overlay: string
                          leadText: string
                          inputPlaceholder: string
                          ariaLabel: string
                          submitText: string
                          inputErrorText: string
                          overlayOpacity: string
                          preTitleImage: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          backgroundImage: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          background_video_webm: {url: string}
                          background_video_mp4: {url: string}
                          backgroundVideoPoster: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyBentoBox'
                      primary: {title: string; subtitle: string}
                      items: Array<{
                          place_on_new_row: boolean
                          card_title: string
                          card_subtitle: string
                          image_alignment: string
                          card_image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          video_poster: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCardGrid'
                      primary: {
                          subtitle: string
                          show_more_text: string
                          initial_cards_shown: string
                          initial_cards_shown_on_mobile: string
                          initial_cards_shown_on_desktop: string
                          card_cta_text: string
                          show_filter: boolean
                          layout: string
                          background_color: string
                          no_padding: boolean
                          blockTitle: {richText: any}
                      }
                      items: Array<{
                          title: string
                          body: string
                          tag_text: string
                          tag_color: string
                          filterKeywords: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCardGridV2'
                      primary: {title: string}
                      items: Array<{
                          card_title: string
                          card_description: string
                          card_cta_text: string
                          card_image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          card_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyComparison'
                      primary: {
                          title: string
                          cta_label: string
                          card_body: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          card_logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          comparison_label: string
                          item_1_label: string
                          item_2_label: string
                          item_1_percentage: number
                          item_2_percentage: number
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyComparisonTable'
                      primary: {
                          section_heading: string
                          section_subheading: string
                          column_1_heading: string
                          column_2_heading: string
                      }
                      items: Array<{heading: string; data_1: string; data_2: string}>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyComponentPlaceholder'
                      primary: {
                          component: string
                          predefined_component: {
                              type: string
                              document:
                                  | {
                                        type: string
                                        data: {
                                            section_title: string
                                            section_description: string
                                            button_cta_text: string
                                            num_invoices: Array<{
                                                label: string
                                                icon1: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon2: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon3: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            average_time_to_process: Array<{
                                                label: string
                                                icon1: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon2: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon3: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            num_of_people_involved: Array<{
                                                label: string
                                                icon1: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon2: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                icon3: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            results: Array<{
                                                results_title: string
                                                invoices_take: string
                                                with_pleo_bills: string
                                                time_saved: string
                                            }>
                                        }
                                    }
                                  | {
                                        type: string
                                        data: {
                                            title: string
                                            results_title: string
                                            results_line_cashback: string
                                            results_subheading: string
                                            cta_text: string
                                            monthly_spend: Array<{
                                                heading: string
                                                subheading: string
                                                low_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                medium_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                high_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            num_of_employees: Array<{
                                                heading: string
                                                subheading: string
                                                low_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                medium_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                                high_icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | {
                                        type: string
                                        id: string
                                        data: {
                                            title: string
                                            category: string
                                            pleo_heading: string
                                            corporate_cards_heading: string
                                            expense_software_heading: string
                                            corporate_cards_expense_software_heading: string
                                            yes_value: string
                                            no_value: string
                                            rows: Array<{
                                                feature: string
                                                feature_subtext: string
                                                pleo: boolean
                                                corporate_cards: boolean
                                                expense_software: boolean
                                                corporate_cards_expense_software: boolean
                                            }>
                                        }
                                    }
                                  | {
                                        __typename: 'PrismicInvoiceGenerator'
                                        data: {
                                            title: string
                                            your_company_form_title: string
                                            preview_label: string
                                            invoice_details: string
                                            get_invoice_label: string
                                            recipient_company_form_title: string
                                            invoice_items_form_title: string
                                            items_label: string
                                            price_label: string
                                            quantity_label: string
                                            rate_label: string
                                            total_label: string
                                            subtotal_label: string
                                            tax_label: string
                                            tax_total_label: string
                                            notes_label: string
                                            terms_label: string
                                            add_item_label: string
                                            invoice_title: string
                                            get_your_invoice_modal: Array<{
                                                modal_title: string
                                                modal_subtitle: string
                                                modal_image: {fluid: {base64: string}}
                                                form_production: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                                form_staging: {
                                                    formId: string
                                                    consents: {
                                                        type: string
                                                        communicationConsents: Array<{
                                                            id: number
                                                            required: boolean
                                                        }>
                                                    }
                                                }
                                            }>
                                            thank_you_modal: Array<{
                                                modal_title: string
                                                modal_subtitle: string
                                                download_pdf_button_text: string
                                                new_invoice_button_text: string
                                                modal_image: {fluid: {base64: string}}
                                            }>
                                        }
                                    }
                                  | {
                                        __typename: 'PrismicInvoiceTemplateForm'
                                        data: {
                                            title: string
                                            description: string
                                            successMessage: string
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | {
                                        __typename: 'PrismicVatCalculator'
                                        data: {
                                            title: string
                                            vat_label: string
                                            amount_label: string
                                            add_vat_label: string
                                            remove_vat_label: string
                                            total_net_label: string
                                            total_gross_label: string
                                            submit_label: string
                                            results_title: string
                                            results_vat_added_label: string
                                            results_vat_removed_label: string
                                            body: {richText: any}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyContactEmails'
                      primary: {title: string; body1: string}
                      items: Array<{
                          contact_title: string
                          contact_email: string
                          destination_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyContactHero'
                      primary: {headline: string}
                      items: Array<{
                          title: string
                          description: string
                          cta_text: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyContentPlusBlocks'
                      primary: {
                          background: string
                          plainTitle: string
                          text_under_title: {richText: any}
                      }
                      items: Array<{
                          block_title: string
                          block_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          block_content: {richText: any}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyContentPlusShortBullets'
                      primary: {
                          inverse: boolean
                          highlight_color: string
                          heading: {richText: any}
                          body: {richText: any}
                      }
                      items: Array<{
                          bullet_text: string
                          bullet_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCountdown'
                      primary: {
                          description_text: string
                          target_date_time: any
                          cta_text: string
                          headingText: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCustomerLogosPlusCta'
                      primary: {
                          variant: string
                          title: string
                          cta_text: string
                          marquee_mode: boolean
                          marquee_scroll_speed: string
                          marquee_width: string
                          background_color: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCustomers'
                      primary: {
                          title: string
                          predefined_logos: {
                              document:
                                  | {
                                        data: {
                                            title: {richText: any}
                                            logos: Array<{
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyCustomersLogosPlusHeadline'
                      primary: {
                          predefined_logos: {
                              document:
                                  | {
                                        data: {
                                            title: {richText: any}
                                            logos: Array<{
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          customer_logos_title: {richText: any}
                      }
                      items: Array<{
                          icon: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyDemoHero'
                      primary: {title: string}
                      items: Array<{
                          title: string
                          subtitle: string
                          cta_text: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyEventCards'
                      primary: {title: string; event_cta_text: string}
                      items: Array<{
                          title: string
                          description: string
                          tracking_id: string
                          category: string
                          duration: string
                          date: string
                          time: string
                          event_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyFaq'
                      primary: {title: string; collapsible: boolean}
                      items: Array<{
                          question: string
                          answer: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          icon: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyFeatureBlock'
                      primary: {
                          title_over_section: string
                          title: string
                          inverse: boolean
                          background: string
                          headline: string
                          is_circular_image: boolean
                          cta_label: string
                          cta_hash_link: string
                          wistia_video_id: string
                          description: {richText: any}
                          pre_cta_links: {richText: any}
                          predefined_feature_block: {
                              document:
                                  | {
                                        data: {
                                            title: string
                                            subtitle: string
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            body: {richText: any}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyFeatureBlockWithMarquee'
                      primary: {
                          title_over_section: string
                          title: string
                          inverse: boolean
                          headline: string
                          cta_label: string
                          outline: {richText: any}
                          pre_cta_links: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          logo: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                          link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyFeatureComparison'
                      primary: {
                          title: string
                          background: string
                          feature_column_heading: string
                          column_heading_1: string
                          column_heading_2: string
                          tick_alt_text: string
                      }
                      items: Array<{
                          feature: string
                          column_checked_1: boolean
                          column_checked_2: boolean
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyFeatureGrid'
                      primary: {title: string; background: string}
                      items: Array<{
                          feature_title: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          feature_description: {richText: any}
                          predefined_feature: {
                              document:
                                  | {
                                        data: {
                                            title: string
                                            body: string
                                            icon: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {height: number; width: number}
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyGetStarted'
                      primary: {
                          title: string
                          error_message: string
                          button_label: string
                          input_placeholder: string
                          form_subtitle: string
                          aria_label: string
                          section_color: string
                          variant: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {width: number; height: number}
                          }
                          predefined_signup_banner: {
                              document:
                                  | {
                                        _previewable: string
                                        type: string
                                        data: {
                                            title: string
                                            subtitle: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            submit_text: string
                                            aria_label: string
                                            partner_signup_redirect: boolean
                                            form_name: string
                                            disclaimer_copy: {richText: any}
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {width: number; height: number}
                                            }
                                            redirect_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyGlassdoorWidget'
                      primary: {
                          cta_text: string
                          widget_alt_text: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyHero'
                      primary: {
                          section_html_id: string
                          title: string
                          inverse: boolean
                          is_oversized_image: boolean
                          wistia_video_id: string
                          lead_text: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          predefined_signup_banner: {
                              type: string
                              document:
                                  | {
                                        _previewable: string
                                        type: string
                                        data: {
                                            title: string
                                            subtitle: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            submit_text: string
                                            aria_label: string
                                            partner_signup_redirect: boolean
                                            form_name: string
                                            disclaimer_copy: {richText: any}
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {width: number; height: number}
                                            }
                                            redirect_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          predefined_proof_point_badges: {
                              document:
                                  | {
                                        data: {
                                            proof_point_first: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            proof_point_second: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyHighlight'
                      primary: {title: string; mirrored: boolean; highlight_color: string}
                      items: Array<{
                          slide_title: string
                          cta_text: string
                          tracking_event: string
                          slide_body: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyHubspotForm'
                      primary: {
                          inverse: boolean
                          featured_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          form: {
                              document:
                                  | {
                                        __typename: 'PrismicHubspotGlobalForm'
                                        data: {
                                            heading: string
                                            body: string
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            imperative_consents_production: Array<{
                                                consent: {
                                                    document:
                                                        | {
                                                              _previewable: string
                                                              lang: string
                                                              data: {
                                                                  type: string
                                                                  isDefault: boolean
                                                                  subscriptionTypeStaging: {
                                                                      subscriptionId: number
                                                                  }
                                                                  subscriptionTypeProduction: {
                                                                      subscriptionId: number
                                                                  }
                                                                  text: {richText: any}
                                                              }
                                                          }
                                                        | Record<PropertyKey, never>
                                                }
                                            }>
                                            imperative_consents_staging: Array<{
                                                consent: {
                                                    document:
                                                        | {
                                                              _previewable: string
                                                              lang: string
                                                              data: {
                                                                  type: string
                                                                  isDefault: boolean
                                                                  subscriptionTypeStaging: {
                                                                      subscriptionId: number
                                                                  }
                                                                  subscriptionTypeProduction: {
                                                                      subscriptionId: number
                                                                  }
                                                                  text: {richText: any}
                                                              }
                                                          }
                                                        | Record<PropertyKey, never>
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyHubspotHeroForm'
                      primary: {
                          title: string
                          variant: string
                          form_title: string
                          form_submit_text: string
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          redirect_to: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          text: string
                          icon: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyIntegrationCards'
                      primary: {title: string; subtitle: string; cta_text: string}
                      items: Array<{
                          name: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyIntegrationOverview'
                      primary: {
                          title: string
                          developers_label: string
                          developers: string
                          links_label: string
                          links: {richText: any}
                          copy: {richText: any}
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyIntegrations'
                      primary: {
                          title: string
                          cta_text: string
                          more_text: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          logo_1: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          logo_1_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          logo_2: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          logo_2_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          logo_3: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          logo_3_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyIntegrationsGrid'
                      primary: {
                          title: string
                          cardCtaText: string
                          categoryFilterPlaceholder: string
                          categoryFilterAllLabel: string
                          showingAllResults: string
                          showingResultsFor: string
                          removeFilter: string
                          noResultsFound: string
                          searchPlaceholder: string
                      }
                      items: Array<{
                          featured_integration: {
                              document: {id: string} | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyInteractiveDemo'
                      primary: {
                          title: string
                          subtitle: string
                          modal_title: string
                          modal_subtitle: string
                          modal_button_text: string
                          compact_layout: boolean
                          interactive_demo_link_production: {url: string}
                          interactive_demo_link_staging: {url: string}
                          modal_image: {
                              alt: string
                              url: string
                              copyright: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{
                          title: string
                          body1: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyJobListings'
                      primary: {
                          title: string
                          subtitle: string
                          location_label: string
                          team_label: string
                          role_label: string
                          all_departments_label: string
                          clear_filters_label: string
                          departments_select_label: string
                          no_results_label: string
                          no_search_label: string
                          search_input_label: string
                          showing_roles_by_department_label: string
                          showing_roles_by_department_with_search_label: string
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyJobsGrid'
                      primary: {headline: string; text: string; cta_text: string}
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyLandingHero'
                      primary: {
                          headline: string
                          headline_background_color: string
                          title: string
                          cta_text: string
                          primary_cta_text: string
                          cta_destination: string
                          inverse: boolean
                          background: string
                          wistia_video_id: string
                          lead_text: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          primary_cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          predefined_proof_point_badges: {
                              document:
                                  | {
                                        data: {
                                            proof_point_first: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                            proof_point_second: Array<{
                                                title: string
                                                subtitle: string
                                                icon: {
                                                    alt: string
                                                    copyright: string
                                                    url: string
                                                    dimensions: {height: number; width: number}
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyMagnetHero'
                      primary: {
                          title: string
                          description: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyMediaItemGrid'
                      primary: {title: string; layout: string; background: string}
                      items: Array<{
                          item_title: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          item_description: {richText: any}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyOnDemandResources'
                      primary: {
                          title: string
                          top_link_text: string
                          layout: string
                          resource_cta_text: string
                          showing_all_results: string
                          showing_all_results_for: string
                          filter_resource_type_placeholder: string
                          filter_resource_type_all: string
                          filter_language_placeholder: string
                          filter_language_all: string
                          filter_clear: string
                          no_resources_found: string
                          search_placeholder: string
                          top_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyPanelGrid'
                      primary: {title: string; excerpt: string}
                      items: Array<{
                          label_color: string
                          label_text: string
                          heading: string
                          excerpt: string
                          cta_text: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyPartnerProgramme'
                      primary: {title: string; tables_tick_screen_reader_text: string}
                      items: Array<{
                          partner_programme_tables: {
                              document:
                                  | {
                                        id: string
                                        data: {
                                            category: string
                                            new_partner_heading: string
                                            bronze_heading: string
                                            silver_heading: string
                                            gold_heading: string
                                            platinum_heading: string
                                            disclaimer: string
                                            rows: Array<{
                                                feature: string
                                                feature_tooltip: string
                                                new_partner: boolean
                                                new_partner_text: string
                                                bronze: boolean
                                                bronze_text: string
                                                silver: boolean
                                                silver_text: string
                                                gold: boolean
                                                gold_text: string
                                                platinum: boolean
                                                platinum_text: string
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyPricing'
                      primary: {pricingTitle: {richText: any}}
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyRatingsPlusHeadline'
                      primary: {
                          ratings_lead_text: string
                          ratings_cta_text: string
                          ratings_title: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          predefined_ratings: {
                              document:
                                  | {
                                        data: {
                                            lead_text: string
                                            cta_text: string
                                            title: {richText: any}
                                            cta_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            ratings: Array<{
                                                rating: {
                                                    document:
                                                        | {
                                                              data: {
                                                                  rating_number: number
                                                                  link: string
                                                                  logo: {
                                                                      alt: string
                                                                      copyright: string
                                                                      url: string
                                                                      dimensions: {
                                                                          height: number
                                                                          width: number
                                                                      }
                                                                  }
                                                              }
                                                          }
                                                        | Record<PropertyKey, never>
                                                }
                                            }>
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                      items: Array<{
                          rating: {
                              document:
                                  | {
                                        data: {
                                            rating_number: number
                                            link: string
                                            logo: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {height: number; width: number}
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyReferralHero'
                      primary: {
                          headline: string
                          headline_background_color: string
                          title: string
                          lead: string
                          alternative_lead: string
                          inverse: boolean
                          background: string
                          predefined_signup_banner: {
                              document:
                                  | {
                                        _previewable: string
                                        type: string
                                        data: {
                                            title: string
                                            subtitle: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            submit_text: string
                                            aria_label: string
                                            partner_signup_redirect: boolean
                                            form_name: string
                                            disclaimer_copy: {richText: any}
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                dimensions: {width: number; height: number}
                                            }
                                            redirect_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyResourceSlider'
                      primary: {
                          title: string
                          top_link_text: string
                          resourceSliderDescription: string
                          top_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          card_title: string
                          card_description: string
                          card_cta: string
                          category: string
                          language: string
                          to: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          card_image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyReviewsGrid'
                      primary: {headline: string; variant: string; author_subtext: string}
                      items: Array<{
                          headline: string
                          description: string
                          number_of_stars: number
                          review_origin: string
                          author: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyRichText'
                      primary: {title: string; copy: {richText: any}}
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodySignUpHero'
                      primary: {
                          pre_title: string
                          title: string
                          email_input_placeholder: string
                          aria_label: string
                          submit_text: string
                          email_input_error_text: string
                          wistia_video_id: string
                          lead_text: {richText: any}
                          form_production: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          form_staging: {
                              formId: string
                              consents: {
                                  type: string
                                  communicationConsents: Array<{id: number; required: boolean}>
                              }
                          }
                          thumbnail_video_mp4: {url: string}
                          thumbnail_video_webm: {url: string}
                          video_poster_image: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                      items: Array<{highlight_item: string}>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodySimpleCardGrid'
                      primary: {title: string; card_cta_text: string; tracking_event: string}
                      items: Array<{
                          title: string
                          description: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodySliderCards'
                      primary: {
                          slider_heading: string
                          highlight_first_card: boolean
                          hide_media_on_mobile: boolean
                          card_background_color: string
                      }
                      items: Array<{
                          item_heading: string
                          sub_heading: string
                          description: string
                          sub_description: string
                          video_id: string
                          cta_text: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodySocialProof'
                      primary: {title: string; inverse: boolean}
                      items: Array<{
                          quote: string
                          full_name: string
                          person_byline: string
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          predefined_testimonial: {
                              document:
                                  | {
                                        data: {
                                            quote: string
                                            attribution_name: string
                                            attribution_title: string
                                            image: {
                                                alt: string
                                                copyright: string
                                                url: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyStats'
                      primary: {
                          first_stat_amount: number
                          first_stat_text: string
                          first_stat_as_percentile: boolean
                          second_stat_amount: number
                          second_stat_text: string
                          second_stat_as_percentile: boolean
                          third_stat_amount: number
                          third_stat_text: string
                          third_stat_as_percentile: boolean
                          source_text: {richText: any}
                          predefined_statistics: {
                              document:
                                  | {
                                        data: {
                                            first_stat: Array<{
                                                amount: number
                                                text: string
                                                as_percentile: boolean
                                            }>
                                            second_stat: Array<{
                                                amount: number
                                                text: string
                                                as_percentile: boolean
                                            }>
                                            third_stat: Array<{
                                                amount: number
                                                text: string
                                                as_percentile: boolean
                                            }>
                                            source_text: {richText: any}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodySteps'
                      primary: {
                          title: string
                          show_count: boolean
                          has_small_copy: boolean
                          cta_text: string
                          align_text: string
                          description: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                      items: Array<{
                          heading: string
                          content: string
                          background_color: string
                          image_as_icon: boolean
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_poster: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          video_mp4: {url: string}
                          video_webm: {url: string}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyStickyCards'
                      primary: {headline: string}
                      items: Array<{
                          headline: string
                          description: string
                          backgroundColor: string
                          ctaLabel: string
                          ctaLink: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image: {
                              alt: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                          videoMp4: {url: string}
                          videoPosterImage: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyTabbedHero'
                      items: Array<{
                          tab_title: string
                          is_default: boolean
                          tab: {
                              document:
                                  | {
                                        data: {
                                            title: string
                                            email_input_placeholder: string
                                            email_input_error_text: string
                                            button_label: string
                                            secondary_cta_label: string
                                            lead_image: {
                                                alt: string
                                                url: string
                                                copyright: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            lead_text: {richText: any}
                                            form_production: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            form_staging: {
                                                formId: string
                                                consents: {
                                                    type: string
                                                    communicationConsents: Array<{
                                                        id: number
                                                        required: boolean
                                                    }>
                                                }
                                            }
                                            button_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            secondary_cta_link: {
                                                link_type: PrismicLinkTypeEnum
                                                uid: string
                                                type: string
                                                lang: string
                                                target: string
                                                url: string
                                            }
                                            image: {
                                                alt: string
                                                url: string
                                                copyright: string
                                                gatsbyImageData: any
                                                dimensions: {height: number; width: number}
                                            }
                                            lottie: {url: string}
                                        }
                                    }
                                  | Record<PropertyKey, never>
                          }
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyTable'
                      primary: {
                          title: string
                          column_1_heading: string
                          column_2_heading: string
                          column_3_heading: string
                          column_4_heading: string
                          column_5_heading: string
                          column_6_heading: string
                          column_7_heading: string
                      }
                      items: Array<{
                          row_heading: string
                          column_1_content: {richText: any}
                          column_2_content: {richText: any}
                          column_3_content: {richText: any}
                          column_4_content: {richText: any}
                          column_5_content: {richText: any}
                          column_6_content: {richText: any}
                          column_7_content: {richText: any}
                      }>
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyTitleWithSideText'
                      primary: {
                          title: string
                          cta_label: string
                          copy: {richText: any}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyTwoImageHero'
                      primary: {
                          title: string
                          content: string
                          cta_text: string
                          video_id: string
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                          image_left: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          image_right: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          image_button: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyUpcomingEvents'
                      primary: {
                          title: string
                          top_link_text: string
                          layout: string
                          event_cta_text: string
                          showing_all_results: string
                          showing_all_results_for: string
                          filter_event_type_placeholder: string
                          filter_event_type_all: string
                          filter_event_type_live_event: string
                          filter_event_type_deminar: string
                          filter_event_type_webinar: string
                          filter_location_placeholder: string
                          filter_location_all: string
                          filter_clear: string
                          no_events_found: string
                          search_placeholder: string
                          top_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyVideo'
                      primary: {
                          title: string
                          video_id: string
                          thumbnail: {
                              alt: string
                              copyright: string
                              url: string
                              dimensions: {height: number; width: number}
                          }
                      }
                  }
                | {__typename: 'PrismicSlicePageDataBodyVideoLibrary'; primary: {title: string}}
                | {
                      __typename: 'PrismicSlicePageDataBodyVideoPopoverWithText'
                      id: string
                      primary: {
                          text_orientation: string
                          pre_title: string
                          title: string
                          body_text: string
                          wistia_video_id: string
                          cta_text: string
                          video_mp4: {url: string}
                          video_webm: {url: string}
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | {
                      __typename: 'PrismicSlicePageDataBodyWideImageHero'
                      id: string
                      slice_type: string
                      primary: {
                          title: string
                          cta_text: string
                          lead_text: {richText: any}
                          image: {
                              alt: string
                              copyright: string
                              url: string
                              gatsbyImageData: any
                              dimensions: {height: number; width: number}
                          }
                          cta_link: {
                              link_type: PrismicLinkTypeEnum
                              uid: string
                              type: string
                              lang: string
                              target: string
                              url: string
                          }
                      }
                  }
                | Record<PropertyKey, never>
            >
        }
    }
}

export type SlicePageIntegrationsFragment = {
    __typename: 'PrismicSlicePageDataBodyIntegrations'
    primary: {
        title: string
        cta_text: string
        more_text: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        logo_1: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        logo_1_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        logo_2: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        logo_2_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        logo_3: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
        logo_3_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type SlicePageStickyCardsFragment = {
    __typename: 'PrismicSlicePageDataBodyStickyCards'
    primary: {headline: string}
    items: Array<{
        headline: string
        description: string
        backgroundColor: string
        ctaLabel: string
        ctaLink: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {alt: string; url: string; dimensions: {height: number; width: number}}
        videoMp4: {url: string}
        videoPosterImage: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type SlicePageCustomerLogosPlusCtaFragment = {
    __typename: 'PrismicSlicePageDataBodyCustomerLogosPlusCta'
    primary: {
        variant: string
        title: string
        cta_text: string
        marquee_mode: boolean
        marquee_scroll_speed: string
        marquee_width: string
        background_color: string
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        logo: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }>
}

export type ResourceSliderSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyResourceSlider'
    primary: {
        title: string
        top_link_text: string
        resourceSliderDescription: string
        top_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
    items: Array<{
        card_title: string
        card_description: string
        card_cta: string
        category: string
        language: string
        to: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        card_image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
    }>
}

export type SlicePageFeatureBlockWithMarqueeFragment = {
    __typename: 'PrismicSlicePageDataBodyFeatureBlockWithMarquee'
    primary: {
        title_over_section: string
        title: string
        inverse: boolean
        headline: string
        cta_label: string
        outline: {richText: any}
        pre_cta_links: {richText: any}
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
        image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{
        logo: {
            alt: string
            url: string
            copyright: string
            dimensions: {height: number; width: number}
        }
        link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }>
}

export type SlicePageSignupHeroFragment = {
    __typename: 'PrismicSlicePageDataBodySignUpHero'
    primary: {
        pre_title: string
        title: string
        email_input_placeholder: string
        aria_label: string
        submit_text: string
        email_input_error_text: string
        wistia_video_id: string
        lead_text: {richText: any}
        form_production: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        form_staging: {
            formId: string
            consents: {type: string; communicationConsents: Array<{id: number; required: boolean}>}
        }
        thumbnail_video_mp4: {url: string}
        thumbnail_video_webm: {url: string}
        video_poster_image: {
            alt: string
            copyright: string
            url: string
            dimensions: {height: number; width: number}
        }
    }
    items: Array<{highlight_item: string}>
}

export type WideImageHeroSliceFragment = {
    __typename: 'PrismicSlicePageDataBodyWideImageHero'
    id: string
    slice_type: string
    primary: {
        title: string
        cta_text: string
        lead_text: {richText: any}
        image: {
            alt: string
            copyright: string
            url: string
            gatsbyImageData: any
            dimensions: {height: number; width: number}
        }
        cta_link: {
            link_type: PrismicLinkTypeEnum
            uid: string
            type: string
            lang: string
            target: string
            url: string
        }
    }
}

export type CreateSubscriptionsPageQueryVariables = Exact<{[key: string]: never}>

export type CreateSubscriptionsPageQuery = {
    allPrismicSubscriptionsPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type SubscriptionsPageQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type SubscriptionsPageQuery = {
    allPrismicSubscriptionsPage: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                steps_title: string
                how_it_works_title: string
                learn_more_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                hero: Array<{
                    title: string
                    submit_text: string
                    body: {richText: any}
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    proof_point_badges: {
                        document:
                            | {
                                  data: {
                                      proof_point_first: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                      proof_point_second: Array<{
                                          title: string
                                          subtitle: string
                                          icon: {
                                              alt: string
                                              copyright: string
                                              url: string
                                              dimensions: {height: number; width: number}
                                          }
                                      }>
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                social_proof_logos_section: {
                    document:
                        | {
                              data: {
                                  title: string
                                  logos: Array<{
                                      logo: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                steps: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                how_it_works_items: Array<{
                    title: string
                    body: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                feature_blocks: Array<{
                    title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    video_mp4: {url: string}
                    video_webm: {url: string}
                    body: {richText: any}
                }>
                social_proof_logos_extended_section: {
                    document:
                        | {
                              data: {
                                  title: {richText: any}
                                  logos: Array<{
                                      logo: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                social_proof_ratings_section: {
                    document:
                        | {
                              data: {
                                  title: {richText: any}
                                  ratings: Array<{
                                      rating: {
                                          document:
                                              | {
                                                    data: {
                                                        stars: string
                                                        rating_number: number
                                                        link: string
                                                        logo: {
                                                            alt: string
                                                            copyright: string
                                                            url: string
                                                            dimensions: {
                                                                height: number
                                                                width: number
                                                            }
                                                        }
                                                    }
                                                }
                                              | Record<PropertyKey, never>
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
                customer_quote: Array<{
                    quote: string
                    attribution_name: string
                    attribution_title: string
                    image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                }>
                learn_more_cards: Array<{
                    learn_more_card: {
                        document:
                            | {
                                  id: string
                                  data: {
                                      title: string
                                      body: string
                                      cta_text: string
                                      image: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                      cta_link: {
                                          link_type: PrismicLinkTypeEnum
                                          uid: string
                                          type: string
                                          lang: string
                                          target: string
                                          url: string
                                      }
                                  }
                              }
                            | Record<PropertyKey, never>
                    }
                }>
                signup_banner: {
                    document:
                        | {
                              _previewable: string
                              type: string
                              data: {
                                  title: string
                                  subtitle: string
                                  email_input_placeholder: string
                                  email_input_error_text: string
                                  submit_text: string
                                  aria_label: string
                                  partner_signup_redirect: boolean
                                  form_name: string
                                  disclaimer_copy: {richText: any}
                                  image: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {width: number; height: number}
                                  }
                                  redirect_link: {
                                      link_type: PrismicLinkTypeEnum
                                      uid: string
                                      type: string
                                      lang: string
                                      target: string
                                      url: string
                                  }
                                  form_production: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                                  form_staging: {
                                      formId: string
                                      consents: {
                                          type: string
                                          communicationConsents: Array<{
                                              id: number
                                              required: boolean
                                          }>
                                      }
                                  }
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
}

export type CreateLegalPageThirdPartyLicencesQueryVariables = Exact<{[key: string]: never}>

export type CreateLegalPageThirdPartyLicencesQuery = {
    allPrismicLegalPageThirdPartyLicences: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type LegalPageThirdPartyLicencesQueryVariables = Exact<{
    locale: Scalars['String']['input']
}>

export type LegalPageThirdPartyLicencesQuery = {
    allPrismicLegalPageThirdPartyLicences: {
        nodes: Array<{
            _previewable: string
            data: {
                meta_title: string
                meta_description: string
                recognition_title: string
                open_graph_image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                sections: Array<{
                    section_title: string
                    inverse: boolean
                    section_image: {
                        alt: string
                        copyright: string
                        url: string
                        dimensions: {height: number; width: number}
                    }
                    section_content: {richText: any}
                }>
                predefined_licences: {
                    document:
                        | {
                              data: {
                                  licences: Array<{
                                      licence_type: string
                                      program_name: string
                                      program_url: string
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }
        }>
    }
    allPrismicLegalDocuments: {
        nodes: Array<{
            _previewable: string
            data: {
                title: string
                historical_documents_title: string
                documents: Array<{
                    title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
                historical_documents: Array<{
                    document_title: string
                    link_text: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }
        }>
    }
}

export type CreateWhyPleoQueryVariables = Exact<{[key: string]: never}>

export type CreateWhyPleoQuery = {
    allPrismicWhyPleoPage: {
        nodes: Array<{
            id: string
            lang: string
            type: string
            last_publication_date: any
            alternate_languages: Array<{uid: string; lang: string; type: string}>
            data: {excludeSitemap: boolean}
        }>
    }
}

export type WhyPleoQueryVariables = Exact<{
    locale: Scalars['String']['input']
    imageBreakpoints: InputMaybe<
        Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>
    >
    twoColumnsAsymmetric: InputMaybe<Scalars['String']['input']>
}>

export type WhyPleoQuery = {
    prismicWhyPleoPage: {
        _previewable: string
        data: {
            meta_title: string
            meta_description: string
            how_to_title: string
            comparison_table_title: string
            body: Array<{
                __typename: 'PrismicWhyPleoPageDataBodyBigList'
                primary: {background_color: string; description: string}
                items: Array<{
                    icon: string
                    label: string
                    secondary_label: string
                    link: {
                        link_type: PrismicLinkTypeEnum
                        uid: string
                        type: string
                        lang: string
                        target: string
                        url: string
                    }
                }>
            }>
            open_graph_image: {
                alt: string
                copyright: string
                url: string
                dimensions: {height: number; width: number}
            }
            hero: Array<{
                title: string
                body: {richText: any}
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                proof_point_badges: {
                    document:
                        | {
                              data: {
                                  proof_point_first: Array<{
                                      title: string
                                      subtitle: string
                                      icon: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                                  proof_point_second: Array<{
                                      title: string
                                      subtitle: string
                                      icon: {
                                          alt: string
                                          copyright: string
                                          url: string
                                          dimensions: {height: number; width: number}
                                      }
                                  }>
                              }
                          }
                        | Record<PropertyKey, never>
                }
            }>
            how_to_subtitle: {richText: any}
            how_to_steps: Array<{title: string}>
            what_is_pleo: Array<{
                title: string
                video_id: string
                video_thumbnail: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
            }>
            feature_blocks: Array<{
                title: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    gatsbyImageData: any
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
            }>
            comparison_table: {
                document:
                    | {
                          type: string
                          id: string
                          data: {
                              title: string
                              category: string
                              pleo_heading: string
                              corporate_cards_heading: string
                              expense_software_heading: string
                              corporate_cards_expense_software_heading: string
                              yes_value: string
                              no_value: string
                              rows: Array<{
                                  feature: string
                                  feature_subtext: string
                                  pleo: boolean
                                  corporate_cards: boolean
                                  expense_software: boolean
                                  corporate_cards_expense_software: boolean
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            customers: Array<{
                title: string
                cta_text: string
                image: {
                    alt: string
                    copyright: string
                    url: string
                    dimensions: {height: number; width: number}
                }
                body: {richText: any}
                cta_link: {
                    link_type: PrismicLinkTypeEnum
                    uid: string
                    type: string
                    lang: string
                    target: string
                    url: string
                }
            }>
            social_proof_logos_extended_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              logos: Array<{
                                  logo: {
                                      alt: string
                                      copyright: string
                                      url: string
                                      dimensions: {height: number; width: number}
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            social_proof_ratings_section: {
                document:
                    | {
                          data: {
                              title: {richText: any}
                              ratings: Array<{
                                  rating: {
                                      document:
                                          | {
                                                data: {
                                                    stars: string
                                                    link: string
                                                    rating_number: number
                                                    logo: {
                                                        alt: string
                                                        copyright: string
                                                        url: string
                                                        dimensions: {height: number; width: number}
                                                    }
                                                }
                                            }
                                          | Record<PropertyKey, never>
                                  }
                              }>
                          }
                      }
                    | Record<PropertyKey, never>
            }
            signup_banner: {
                document:
                    | {
                          _previewable: string
                          type: string
                          data: {
                              title: string
                              subtitle: string
                              email_input_placeholder: string
                              email_input_error_text: string
                              submit_text: string
                              aria_label: string
                              partner_signup_redirect: boolean
                              form_name: string
                              disclaimer_copy: {richText: any}
                              image: {
                                  alt: string
                                  copyright: string
                                  url: string
                                  dimensions: {width: number; height: number}
                              }
                              redirect_link: {
                                  link_type: PrismicLinkTypeEnum
                                  uid: string
                                  type: string
                                  lang: string
                                  target: string
                                  url: string
                              }
                              form_production: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                              form_staging: {
                                  formId: string
                                  consents: {
                                      type: string
                                      communicationConsents: Array<{id: number; required: boolean}>
                                  }
                              }
                          }
                      }
                    | Record<PropertyKey, never>
            }
        }
    }
}

export type LegalDocumentsDirectoryQueryVariables = Exact<{[key: string]: never}>

export type LegalDocumentsDirectoryQuery = {
    allPrismicLegalDocumentsDirectory: {
        nodes: Array<{
            id: string
            last_publication_date: any
            data: {
                legal_document: Array<{
                    filename: string
                    document_friendly_name: string
                    pdf_file: {url: string}
                }>
            }
        }>
    }
}
